
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire77e7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire77e7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("entK4", function(module, exports) {

$parcel$export(module.exports, "icon", function () { return $a77a48d9501f4b81$export$1ca1ec8b29a4ce27; });
$parcel$export(module.exports, "hydrateIcons", function () { return $a77a48d9501f4b81$export$1530406411bfd73f; });
$parcel$export(module.exports, "getFileIconSvg", function () { return $a77a48d9501f4b81$export$9bc9aed9fa20c6d6; });
/**
 * Centrální modul ikon – jediný zdroj pravdy pro SVG ikony v aplikaci.
 *
 * Standard: Heroicons v2 outline, viewBox 0 0 24 24,
 * fill="none" stroke="currentColor" stroke-width="1.75".
 *
 * Použití v JS:   import { icon } from './icons.js';  icon('trash', 'w-4 h-4')
 * Použití v HTML: <svg data-icon="trash" class="w-4 h-4"></svg> + hydrateIcons()
 */ const $a77a48d9501f4b81$var$STROKE_WIDTH = '1.75';
// Kanonické Heroicons v2 outline path data (hodnota = pole <path d="...">).
const $a77a48d9501f4b81$var$ICON_PATHS = {
    // Navigace a sekce
    'calculator': [
        'M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V13.5Zm0 2.25h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V18Zm2.498-6.75h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V13.5Zm0 2.25h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V18Zm2.504-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5Zm0 2.25h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V18Zm2.498-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5ZM8.25 6h7.5v2.25h-7.5V6ZM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 0 0 2.25 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0 0 12 2.25Z'
    ],
    'document-text': [
        'M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z'
    ],
    'clipboard-check': [
        'M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75'
    ],
    'banknotes': [
        'M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z'
    ],
    'user-group': [
        'M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z'
    ],
    'users': [
        'M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z'
    ],
    'user': [
        'M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z'
    ],
    'user-circle': [
        'M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z'
    ],
    'user-plus': [
        'M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z'
    ],
    'folder-open': [
        'M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 0 0-1.883 2.542l.857 6a2.25 2.25 0 0 0 2.227 1.932H19.05a2.25 2.25 0 0 0 2.227-1.932l.857-6a2.25 2.25 0 0 0-1.883-2.542m-16.5 0V6A2.25 2.25 0 0 1 6 3.75h3.879a1.5 1.5 0 0 1 1.06.44l2.122 2.12a1.5 1.5 0 0 0 1.06.44H18A2.25 2.25 0 0 1 20.25 9v.776'
    ],
    'folder': [
        'M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z'
    ],
    'swatch': [
        'M4.098 19.902a3.75 3.75 0 0 0 5.304 0l6.401-6.402M6.75 21A3.75 3.75 0 0 1 3 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 0 0 3.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008Z'
    ],
    'cog': [
        'M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z',
        'M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z'
    ],
    'bars-3': [
        'M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5'
    ],
    // Akce
    'plus': [
        'M12 4.5v15m7.5-7.5h-15'
    ],
    'arrow-up': [
        'M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18'
    ],
    'paperclip': [
        'm18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l7.693-7.693a3 3 0 0 1 4.243 4.243L9.786 17.99a1.5 1.5 0 0 1-2.121-2.122l7.693-7.692'
    ],
    'pencil-square': [
        'm16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10'
    ],
    'trash': [
        'm14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0'
    ],
    'x-mark': [
        'M6 18 18 6M6 6l12 12'
    ],
    'document-duplicate': [
        'M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75'
    ],
    // Duplikovat (vytvořit kopii položky) – dva překrývající se čtverce.
    // Odlišné od `document-duplicate`, které používáme pro "kopírovat" (schránka).
    'squares-2-stack': [
        'M16.5 8.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v8.25A2.25 2.25 0 0 0 6 16.5h2.25m8.25-8.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-7.5A2.25 2.25 0 0 1 8.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 0 0-2.25 2.25v6'
    ],
    'view-columns': [
        'M9 4.5v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.5 3 5.004 3 5.625v12.75c0 .621.504 1.125 1.125 1.125Z'
    ],
    'list-bullet': [
        'M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z'
    ],
    'funnel': [
        'M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z'
    ],
    'link': [
        'M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244'
    ],
    'printer': [
        'M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Z'
    ],
    'document-arrow-down': [
        'M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z'
    ],
    'eye': [
        'M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z',
        'M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z'
    ],
    'magnifying-glass': [
        'm21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z'
    ],
    'arrow-path': [
        'M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99'
    ],
    'ellipsis-vertical': [
        'M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z'
    ],
    'arrows-right-left': [
        'M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5'
    ],
    'arrow-down-tray': [
        'M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3'
    ],
    'arrow-up-tray': [
        'M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5'
    ],
    // Vertikální oboustranná šipka – affordance pro "přetáhni / přesuň nahoru-dolů".
    'arrows-up-down': [
        'M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5'
    ],
    'cloud-arrow-up': [
        'M12 16.5V9.75m0 0 3 3m-3-3-3 3M6.75 19.5a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z'
    ],
    'arrow-right-on-rectangle': [
        'M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9'
    ],
    'key': [
        'M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z'
    ],
    // Záložka – "uložit předvolbu".
    'bookmark': [
        'M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z'
    ],
    // Šipky a chevrony
    'chevron-down': [
        'm19.5 8.25-7.5 7.5-7.5-7.5'
    ],
    'chevron-up': [
        'm4.5 15.75 7.5-7.5 7.5 7.5'
    ],
    'chevron-left': [
        'M15.75 19.5 8.25 12l7.5-7.5'
    ],
    'chevron-right': [
        'm8.25 4.5 7.5 7.5-7.5 7.5'
    ],
    'arrow-right': [
        'M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3'
    ],
    'arrow-down': [
        'M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3'
    ],
    'arrow-down-on-square': [
        'M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15M9 12l3 3m0 0 3-3m-3 3V2.25'
    ],
    // Datum a čas
    'calendar': [
        'M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5'
    ],
    // Stav a feedback
    'exclamation-triangle': [
        'M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z'
    ],
    'exclamation-circle': [
        'M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z'
    ],
    'information-circle': [
        'm11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z'
    ],
    'check': [
        'm4.5 12.75 6 6 9-13.5'
    ],
    'check-circle': [
        'M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z'
    ],
    'clock': [
        'M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z'
    ],
    'lock-closed': [
        'M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z'
    ],
    // Soubory a data
    'photo': [
        'm2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z'
    ],
    'document': [
        'M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z'
    ],
    // Dokument s plus – "přidat novou položku".
    'document-plus': [
        'M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z'
    ],
    'archive-box': [
        'm20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z'
    ],
    'receipt': [
        'm9 14.25 6-6m4.5-3.493V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0c1.1.128 1.907 1.077 1.907 2.185ZM9.75 9h.008v.008H9.75V9Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm4.125 4.5h.008v.008h-.008V13.5Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z'
    ],
    'chart-bar': [
        'M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z'
    ],
    'sparkles': [
        'M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z'
    ],
    'paper-airplane': [
        'M6 12 3.269 5.125a59.769 59.769 0 0 1 22.382 0L22.8 12l2.851 6.875a59.769 59.769 0 0 1-22.382 0L6 12Zm6 2.25 4.5 0M6 12l3-3m0 6-3-3'
    ],
    'chat-bubble-left-right': [
        'M20.599 17.839a3.993 3.993 0 0 0-1.556-1.018 41.875 41.875 0 0 0-7.485-2.067 39.6 39.6 0 0 0-7.485 2.067 3.993 3.993 0 0 0-1.556 1.018A2.25 2.25 0 0 0 2.25 18v.75a2.25 2.25 0 0 0 2.25 2.25h15a2.25 2.25 0 0 0 2.25-2.25V18a2.25 2.25 0 0 0-.951-1.161ZM12 9.75a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Zm5.1-5.25a3 3 0 0 1 0 6 3 3 0 0 1 0-6Zm-10.2 0a3 3 0 0 1 0 6 3 3 0 0 1 0-6Z'
    ],
    'inbox': [
        'M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H6.911a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661Z'
    ]
};
// Výjimky – ikony, které nejsou standardní outline (vlastní markup uvnitř <svg>).
const $a77a48d9501f4b81$var$SPECIAL_ICONS = {
    // Drag handle (9 teček) – Heroicons ekvivalent neexistuje, solid varianta.
    'grip': {
        attrs: 'viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"',
        body: '<path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path><path d="M6 6a2 2 0 110-4 2 2 0 010 4zM6 12a2 2 0 110-4 2 2 0 010 4zM6 18a2 2 0 110-4 2 2 0 010 4z"></path><path d="M14 6a2 2 0 110-4 2 2 0 010 4zM14 12a2 2 0 110-4 2 2 0 010 4zM14 18a2 2 0 110-4 2 2 0 010 4z"></path>'
    },
    // Vertikální drag handle (6 teček, 2 sloupce × 3 řádky) – standard pro
    // reorder ve vertikálním seznamu (Notion/Linear/Todoist). Odlišné od grid menu.
    'grip-vertical': {
        attrs: 'viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"',
        body: '<path d="M7 6a2 2 0 110-4 2 2 0 010 4zM7 12a2 2 0 110-4 2 2 0 010 4zM7 18a2 2 0 110-4 2 2 0 010 4z"></path><path d="M13 6a2 2 0 110-4 2 2 0 010 4zM13 12a2 2 0 110-4 2 2 0 010 4zM13 18a2 2 0 110-4 2 2 0 010 4z"></path>'
    },
    // Jednotný SVG spinner (přidej třídu animate-spin přes className).
    'spinner': {
        attrs: 'viewBox="0 0 24 24" fill="none" aria-hidden="true"',
        body: '<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>'
    }
};
function $a77a48d9501f4b81$export$1ca1ec8b29a4ce27(name, className = 'w-5 h-5', attrs = {}) {
    const extra = Object.entries(attrs).map(([k, v])=>` ${k}="${String(v).replace(/"/g, '&quot;')}"`).join('');
    const special = $a77a48d9501f4b81$var$SPECIAL_ICONS[name];
    if (special) return `<svg class="${className}" ${special.attrs}${extra}>${special.body}</svg>`;
    const paths = $a77a48d9501f4b81$var$ICON_PATHS[name];
    if (!paths) {
        console.warn(`[icons] Nezn\xe1m\xe1 ikona: ${name}`);
        return '';
    }
    const body = paths.map((d)=>`<path stroke-linecap="round" stroke-linejoin="round" d="${d}"></path>`).join('');
    return `<svg class="${className}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${$a77a48d9501f4b81$var$STROKE_WIDTH}" aria-hidden="true"${extra}>${body}</svg>`;
}
function $a77a48d9501f4b81$export$1530406411bfd73f(root = document) {
    root.querySelectorAll('svg[data-icon]').forEach((el)=>{
        const name = el.getAttribute('data-icon');
        const special = $a77a48d9501f4b81$var$SPECIAL_ICONS[name];
        if (special) {
            // attrs string -> nastavit na element
            special.attrs.match(/([a-zA-Z-]+)="([^"]*)"/g).forEach((pair)=>{
                const [, k, v] = pair.match(/([a-zA-Z-]+)="([^"]*)"/);
                el.setAttribute(k, v);
            });
            el.innerHTML = special.body;
            return;
        }
        const paths = $a77a48d9501f4b81$var$ICON_PATHS[name];
        if (!paths) {
            console.warn(`[icons] Nezn\xe1m\xe1 ikona v HTML: ${name}`);
            return;
        }
        el.setAttribute('viewBox', '0 0 24 24');
        el.setAttribute('fill', 'none');
        el.setAttribute('stroke', 'currentColor');
        el.setAttribute('stroke-width', $a77a48d9501f4b81$var$STROKE_WIDTH);
        el.setAttribute('aria-hidden', 'true');
        el.innerHTML = paths.map((d)=>`<path stroke-linecap="round" stroke-linejoin="round" d="${d}"></path>`).join('');
    });
}
function $a77a48d9501f4b81$export$9bc9aed9fa20c6d6(mimeType, filename, className = 'w-5 h-5') {
    const mt = String(mimeType || '').toLowerCase();
    const ext = String(filename || '').split('.').pop().toLowerCase();
    if (mt.startsWith('image/')) return $a77a48d9501f4b81$export$1ca1ec8b29a4ce27('photo', className);
    if (mt === 'application/pdf' || ext === 'pdf') return $a77a48d9501f4b81$export$1ca1ec8b29a4ce27('document-text', className);
    if ([
        'zip',
        'rar',
        '7z',
        'tar',
        'gz',
        'bz2'
    ].includes(ext)) return $a77a48d9501f4b81$export$1ca1ec8b29a4ce27('archive-box', className);
    if ([
        'doc',
        'docx',
        'odt',
        'rtf'
    ].includes(ext)) return $a77a48d9501f4b81$export$1ca1ec8b29a4ce27('document-text', className);
    return $a77a48d9501f4b81$export$1ca1ec8b29a4ce27('document', className);
}

});

parcelRegister("6NozV", function(module, exports) {

$parcel$export(module.exports, "API_BASE_URL", function () { return $4f2a626f4d7d3c8a$export$c3ee1e672e1e24e7; });
$parcel$export(module.exports, "escapeHtml", function () { return $4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8; });
$parcel$export(module.exports, "customerDataText", function () { return $4f2a626f4d7d3c8a$export$c01dda7d7200ff25; });
$parcel$export(module.exports, "customerNameOf", function () { return $4f2a626f4d7d3c8a$export$89fa9b825f0417ab; });
$parcel$export(module.exports, "formatDateTime", function () { return $4f2a626f4d7d3c8a$export$8b492ed8828f789c; });
$parcel$export(module.exports, "formatDate", function () { return $4f2a626f4d7d3c8a$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatMoney", function () { return $4f2a626f4d7d3c8a$export$a17b3c2052469c69; });
$parcel$export(module.exports, "STATUS_META", function () { return $4f2a626f4d7d3c8a$export$8f9292f3e50b1f73; });
$parcel$export(module.exports, "statusBadge", function () { return $4f2a626f4d7d3c8a$export$a7d7073b5bbba013; });
$parcel$export(module.exports, "statusLabel", function () { return $4f2a626f4d7d3c8a$export$a954299e2515e375; });
$parcel$export(module.exports, "renderListCard", function () { return $4f2a626f4d7d3c8a$export$bd925ac6e624bab3; });
$parcel$export(module.exports, "renderLoading", function () { return $4f2a626f4d7d3c8a$export$429ee859e6a27934; });
$parcel$export(module.exports, "renderErrorState", function () { return $4f2a626f4d7d3c8a$export$fbc2bfe7dd7fe0cd; });
$parcel$export(module.exports, "ListView", function () { return $4f2a626f4d7d3c8a$export$84d0dd190d551cd1; });
/**
 * Sdílené UI pro seznamové sekce (Nabídky / Objednávky / Faktury / Výroba).
 *
 * Jednotný toolbar (hledání, autor, stav, období, reset), jednotné karty
 * řádků s akcemi, stránkování, kompaktní režim a přepínač seznam/kanban.
 * Každá sekce si nechává vlastní načítání dat a detailové pohledy; tento
 * modul drží stav filtrů, kreslí skořápku sekce a společné prvky.
 */ 
var $entK4 = parcelRequire("entK4");
const $4f2a626f4d7d3c8a$export$c3ee1e672e1e24e7 = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
function $4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(str) {
    if (str == null) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
function $4f2a626f4d7d3c8a$export$c01dda7d7200ff25(data) {
    if (!data) return '';
    if (typeof data === 'string') return data;
    if (typeof data === 'object') {
        const c = data;
        const lines = [];
        if (c.name) lines.push(c.name);
        if (c.contactPerson && c.contactPerson !== c.name) lines.push(c.contactPerson);
        if (c.address) lines.push(c.address);
        const cityLine = [
            c.zip,
            c.city
        ].filter(Boolean).join(' ');
        if (cityLine) lines.push(cityLine);
        if (c.country && c.country !== "\u010Cesk\xe1 republika") lines.push(c.country);
        const contact = [
            c.phone,
            c.email
        ].filter(Boolean).join(', ');
        if (contact) lines.push(contact);
        const taxLine = [
            c.ico ? `I\u{10C}: ${c.ico}` : '',
            c.dic ? `DI\u{10C}: ${c.dic}` : ''
        ].filter(Boolean).join(', ');
        if (taxLine) {
            lines.push('');
            lines.push(taxLine);
        }
        return lines.join('\n');
    }
    return String(data);
}
function $4f2a626f4d7d3c8a$export$89fa9b825f0417ab(entity) {
    if (!entity) return '';
    if (entity.customerName) return String(entity.customerName).trim();
    return ($4f2a626f4d7d3c8a$export$c01dda7d7200ff25(entity.customerData).split('\n')[0] || '').trim();
}
function $4f2a626f4d7d3c8a$export$8b492ed8828f789c(iso) {
    if (!iso) return '';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('cs-CZ', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
}
function $4f2a626f4d7d3c8a$export$3ae94a2503e890a1(iso) {
    if (!iso) return '';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('cs-CZ', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
}
function $4f2a626f4d7d3c8a$export$a17b3c2052469c69(value, currency = "K\u010D") {
    const n = typeof value === 'number' ? value : 0;
    return `${n.toLocaleString('cs-CZ', {
        maximumFractionDigits: 0
    })} ${currency}`;
}
const $4f2a626f4d7d3c8a$export$8f9292f3e50b1f73 = {
    offer: {
        draft: {
            label: "Rozpracovan\xe1",
            badge: 'bg-gray-100 text-gray-800',
            dot: 'bg-gray-500'
        },
        sent: {
            label: "Odesl\xe1na",
            badge: 'bg-blue-100 text-blue-800',
            dot: 'bg-blue-500'
        },
        negotiation: {
            label: "Vyjedn\xe1v\xe1n\xed",
            badge: 'bg-amber-100 text-amber-800',
            dot: 'bg-amber-500'
        },
        approved: {
            label: "Schv\xe1lena",
            badge: 'bg-emerald-100 text-emerald-800',
            dot: 'bg-emerald-500'
        },
        rejected: {
            label: "Odm\xedtnuta",
            badge: 'bg-red-100 text-red-800',
            dot: 'bg-red-500'
        },
        converted: {
            label: "P\u0159evedena",
            badge: 'bg-purple-100 text-purple-800',
            dot: 'bg-purple-500'
        }
    },
    order: {
        received: {
            label: "P\u0159ijato",
            badge: 'bg-blue-100 text-blue-800',
            dot: 'bg-blue-500'
        },
        in_progress: {
            label: "Zpracov\xe1v\xe1 se",
            badge: 'bg-amber-100 text-amber-800',
            dot: 'bg-amber-500'
        },
        done: {
            label: 'Hotovo',
            badge: 'bg-emerald-100 text-emerald-800',
            dot: 'bg-emerald-500'
        },
        to_invoice: {
            label: 'Fakturovat',
            badge: 'bg-purple-100 text-purple-800',
            dot: 'bg-purple-500'
        },
        invoiced: {
            label: "Fakturov\xe1no",
            badge: 'bg-indigo-100 text-indigo-800',
            dot: 'bg-indigo-500'
        },
        delivered: {
            label: "P\u0159ed\xe1no",
            badge: 'bg-gray-100 text-gray-700',
            dot: 'bg-gray-500'
        },
        cancelled: {
            label: "Zru\u0161eno",
            badge: 'bg-red-100 text-red-800',
            dot: 'bg-red-500'
        }
    },
    invoice: {
        draft: {
            label: "Rozpracovan\xe1",
            badge: 'bg-gray-100 text-gray-800',
            dot: 'bg-gray-500'
        },
        issued: {
            label: 'Vystavena',
            badge: 'bg-blue-100 text-blue-800',
            dot: 'bg-blue-500'
        },
        partially_paid: {
            label: "\u010C\xe1ste\u010Dn\u011B uhrazena",
            badge: 'bg-amber-100 text-amber-800',
            dot: 'bg-amber-500'
        },
        paid: {
            label: 'Uhrazena',
            badge: 'bg-emerald-100 text-emerald-800',
            dot: 'bg-emerald-500'
        },
        overdue: {
            label: 'Po splatnosti',
            badge: 'bg-red-100 text-red-800',
            dot: 'bg-red-500'
        },
        cancelled: {
            label: "Stornov\xe1na",
            badge: 'bg-gray-100 text-gray-500',
            dot: 'bg-gray-400'
        }
    },
    // Výrobní pohled na objednávky – stejné klíče, terminologie dílny.
    vyroba: {
        received: {
            label: "P\u0159ijato / P\u0159\xedprava",
            badge: 'bg-blue-100 text-blue-800 border border-blue-200',
            dot: 'bg-blue-500'
        },
        in_progress: {
            label: "Ve v\xfdrob\u011B",
            badge: 'bg-amber-100 text-amber-800 border border-amber-200',
            dot: 'bg-amber-500'
        },
        done: {
            label: 'Hotovo (Expedice)',
            badge: 'bg-emerald-100 text-emerald-800 border border-emerald-200',
            dot: 'bg-emerald-500'
        },
        to_invoice: {
            label: 'K fakturaci',
            badge: 'bg-purple-100 text-purple-800 border border-purple-200',
            dot: 'bg-purple-500'
        },
        invoiced: {
            label: "Vyfakturov\xe1no",
            badge: 'bg-indigo-100 text-indigo-800 border border-indigo-200',
            dot: 'bg-indigo-500'
        },
        delivered: {
            label: "Odesl\xe1no / P\u0159ed\xe1no",
            badge: 'bg-gray-100 text-gray-700 border border-gray-200',
            dot: 'bg-gray-500'
        },
        cancelled: {
            label: "Zru\u0161eno",
            badge: 'bg-red-100 text-red-800 border border-red-200',
            dot: 'bg-red-500'
        }
    }
};
function $4f2a626f4d7d3c8a$export$a7d7073b5bbba013(kind, status, extraClass = '') {
    const meta = $4f2a626f4d7d3c8a$export$8f9292f3e50b1f73[kind] && $4f2a626f4d7d3c8a$export$8f9292f3e50b1f73[kind][status] || {
        label: status || "\u2014",
        badge: 'bg-gray-100 text-gray-800',
        dot: 'bg-gray-400'
    };
    return `
    <span class="inline-flex items-center text-xs px-2 py-0.5 rounded-full whitespace-nowrap ${meta.badge} ${extraClass}">
      <span class="w-1.5 h-1.5 rounded-full mr-1.5 ${meta.dot}"></span>${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(meta.label)}
    </span>
  `;
}
function $4f2a626f4d7d3c8a$export$a954299e2515e375(kind, status) {
    const meta = $4f2a626f4d7d3c8a$export$8f9292f3e50b1f73[kind] && $4f2a626f4d7d3c8a$export$8f9292f3e50b1f73[kind][status];
    return meta ? meta.label : status || '';
}
/** Kruhové ghost tlačítko akce v řádku (ikona + tooltip + aria-label). */ function $4f2a626f4d7d3c8a$var$rowActionButton(a, id) {
    const tone = a.tone === 'danger' ? 'text-gray-400 hover:text-red-600 hover:bg-red-50' : a.tone === 'primary' ? 'text-blue-600 hover:text-blue-800 hover:bg-blue-50' : 'text-gray-400 hover:text-gray-700 hover:bg-gray-100';
    return `
    <button type="button" data-action="${a.action}" data-id="${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(id)}"
      class="inline-flex items-center justify-center w-8 h-8 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 ${tone}"
      title="${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(a.label)}" aria-label="${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(a.label)}">
      ${(0, $entK4.icon)(a.icon, 'w-4.5 h-4.5 w-[18px] h-[18px]')}
    </button>
  `;
}
function $4f2a626f4d7d3c8a$export$bd925ac6e624bab3(cfg) {
    const badgeHtml = $4f2a626f4d7d3c8a$export$a7d7073b5bbba013(cfg.status.kind, cfg.status.value);
    const extraBadges = (cfg.badges || []).join('');
    const actionsHtml = (cfg.actions || []).map((a)=>$4f2a626f4d7d3c8a$var$rowActionButton(a, cfg.id)).join('');
    if (cfg.compact) return `
      <li class="hover:bg-gray-50 transition-colors cursor-pointer" data-row-id="${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(cfg.id)}" ${cfg.rowAttr || ''}>
        <div class="px-4 py-2 flex items-center gap-3">
          <span class="text-sm font-medium text-gray-900 whitespace-nowrap">${cfg.title}</span>
          ${badgeHtml}
          <span class="text-sm font-medium text-gray-700 truncate min-w-0 flex-shrink" title="${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(cfg.customerName || '')}">${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(cfg.customerName || "\u2014")}</span>
          <span class="text-xs text-gray-400 truncate min-w-0 flex-1 hidden md:inline">${cfg.description || ''}</span>
          ${extraBadges}
          <span class="text-sm font-semibold text-gray-900 whitespace-nowrap ml-auto">${cfg.price || ''}</span>
          <span class="flex items-center gap-0.5 flex-shrink-0">${actionsHtml}</span>
        </div>
      </li>
    `;
    return `
    <li class="hover:bg-gray-50 transition-colors cursor-pointer" data-row-id="${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(cfg.id)}" ${cfg.rowAttr || ''}>
      <div class="px-4 py-4 sm:px-6">
        <div class="flex items-start justify-between gap-4">
          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-2 flex-wrap">
              <p class="text-sm font-medium text-gray-900">${cfg.title}</p>
              ${badgeHtml}
              ${extraBadges}
            </div>
            <p class="mt-1 text-sm font-medium text-gray-800 truncate">${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(cfg.customerName || "\u2014")}</p>
            <div class="mt-1 flex items-center text-xs text-gray-500 flex-wrap gap-x-2">${cfg.metaLine || ''}</div>
            ${cfg.description ? `<p class="mt-1 text-sm text-gray-500 truncate">${cfg.description}</p>` : ''}
          </div>
          <div class="flex flex-col items-end gap-2 flex-shrink-0">
            <div class="text-right">
              <p class="text-base sm:text-lg font-semibold text-gray-900 whitespace-nowrap">${cfg.price || ''}</p>
              ${cfg.priceNote ? `<p class="text-xs text-gray-500">${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(cfg.priceNote)}</p>` : ''}
            </div>
            <div class="flex items-center gap-0.5" onclick="event.stopPropagation()">${actionsHtml}</div>
          </div>
        </div>
      </div>
    </li>
  `;
}
function $4f2a626f4d7d3c8a$export$75003f4882a3396d({ title: title, hint: hint, iconName: iconName = 'inbox' }) {
    return `
    <div class="bg-white rounded-lg shadow-md p-8 text-center mt-4">
      ${(0, $entK4.icon)(iconName, 'mx-auto h-12 w-12 text-gray-400 mb-4')}
      <h3 class="text-lg font-medium text-gray-900 mb-2">${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(title)}</h3>
      ${hint ? `<p class="text-gray-500">${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(hint)}</p>` : ''}
    </div>
  `;
}
function $4f2a626f4d7d3c8a$export$429ee859e6a27934() {
    return `
    <div class="flex items-center justify-center py-16 text-gray-400">
      ${(0, $entK4.icon)('spinner', 'w-8 h-8 animate-spin')}
    </div>
  `;
}
function $4f2a626f4d7d3c8a$export$fbc2bfe7dd7fe0cd(message, retryJs) {
    return `
    <div class="bg-red-50 border border-red-200 rounded-md p-4 mt-4">
      <div class="flex">
        ${(0, $entK4.icon)('exclamation-circle', 'h-5 w-5 text-red-400 flex-shrink-0')}
        <div class="ml-3">
          <h3 class="text-sm font-medium text-red-800">${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(message)}</h3>
          ${retryJs ? `<button onclick="${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(retryJs)}" class="mt-2 text-sm text-red-600 hover:text-red-500 underline">Zkusit znovu</button>` : ''}
        </div>
      </div>
    </div>
  `;
}
const $4f2a626f4d7d3c8a$var$PAGE_SIZES = [
    25,
    50,
    100
];
const $4f2a626f4d7d3c8a$var$DEFAULT_PAGE_SIZE = 25;
class $4f2a626f4d7d3c8a$export$84d0dd190d551cd1 {
    constructor(cfg){
        this.cfg = cfg;
        this.key = cfg.key;
        // Filtry
        this.search = '';
        this.status = 'all';
        this.author = 'me';
        this.timeRange = 'all';
        this.dateFrom = '';
        this.dateTo = '';
        this.customerId = '';
        this.customerName = '';
        this.showAdvanced = false;
        // Stránkování + zobrazení (perzistentní preference)
        const prefs = this._loadPrefs();
        this.pageSize = $4f2a626f4d7d3c8a$var$PAGE_SIZES.includes(prefs.pageSize) ? prefs.pageSize : $4f2a626f4d7d3c8a$var$DEFAULT_PAGE_SIZE;
        this.compact = Boolean(prefs.compact);
        this.viewMode = cfg.enableKanban && prefs.viewMode === 'kanban' ? 'kanban' : 'list';
        this.page = 0;
        this.total = 0;
        // Data pro selecty (aktualizuje manager z API odpovědi)
        this.statuses = cfg.statuses || [];
        this.authors = [];
        this._shellRendered = false;
    }
    _prefsKey() {
        return `tria-list-prefs-${this.key}`;
    }
    _loadPrefs() {
        try {
            return JSON.parse(localStorage.getItem(this._prefsKey()) || '{}');
        } catch  {
            return {};
        }
    }
    _savePrefs() {
        try {
            localStorage.setItem(this._prefsKey(), JSON.stringify({
                pageSize: this.pageSize,
                compact: this.compact,
                viewMode: this.viewMode
            }));
        } catch  {}
    }
    getCurrentUser() {
        try {
            const fromApp = window.app && window.app.currentUser;
            if (fromApp) return fromApp;
            return JSON.parse(localStorage.getItem('currentUser') || 'null');
        } catch  {
            return null;
        }
    }
    /** Query parametry pro list endpoint (vč. stránkování). */ buildParams({ paginate: paginate = true } = {}) {
        const params = new URLSearchParams();
        if (this.status && this.status !== 'all') params.set('status', this.status);
        if (this.search) params.set('search', this.search);
        if (this.customerId) params.set('customerId', this.customerId);
        if (this.dateFrom) params.set('dateFrom', this.dateFrom);
        if (this.dateTo) params.set('dateTo', this.dateTo);
        this._applyAuthorParam(params);
        if (paginate) {
            params.set('limit', String(this.pageSize));
            params.set('offset', String(this.page * this.pageSize));
        }
        return params;
    }
    _applyAuthorParam(params) {
        if (!this.author || this.author === 'all') return;
        if (this.author === 'me') {
            params.set('userId', 'me');
            return;
        }
        if (this.author.startsWith('name:')) {
            params.set('userName', this.author.slice(5));
            return;
        }
        if (this.author.startsWith('id:')) {
            params.set('userId', this.author.slice(3));
            return;
        }
        params.set('userId', this.author);
    }
    hasActiveFilters() {
        return Boolean(this.status && this.status !== 'all' || this.search || this.customerId || this.timeRange && this.timeRange !== 'all' || this.author && this.author !== 'me');
    }
    _activeAdvancedCount() {
        let n = 0;
        if (this.status && this.status !== 'all') n++;
        if (this.customerId) n++;
        if (this.timeRange && this.timeRange !== 'all') n++;
        if (this.author && this.author !== 'me') n++;
        return n;
    }
    resetFilters() {
        this.search = '';
        this.status = 'all';
        this.author = 'me';
        this.timeRange = 'all';
        this.dateFrom = '';
        this.dateTo = '';
        this.customerId = '';
        this.customerName = '';
        this.page = 0;
    }
    updateDatesByTimeRange() {
        if (this.timeRange === 'all') {
            this.dateFrom = '';
            this.dateTo = '';
        } else if (this.timeRange === 'today') {
            const now = new Date().toISOString().split('T')[0];
            this.dateFrom = now;
            this.dateTo = now;
        } else if (this.timeRange === '7days') {
            const to = new Date();
            const from = new Date();
            from.setDate(to.getDate() - 7);
            this.dateFrom = from.toISOString().split('T')[0];
            this.dateTo = to.toISOString().split('T')[0];
        } else if (this.timeRange === 'month') {
            const to = new Date();
            const from = new Date();
            from.setMonth(to.getMonth() - 1);
            this.dateFrom = from.toISOString().split('T')[0];
            this.dateTo = to.toISOString().split('T')[0];
        }
    // 'custom' – data nastavuje uživatel ručně
    }
    _timeRangeDisplay() {
        if (this.timeRange === 'all') return "V\u0161echna data";
        if (!this.dateFrom && !this.dateTo) return "V\u0161echna data";
        const fmt = (isoStr)=>{
            if (!isoStr) return '';
            const [y, m, d] = isoStr.split('-');
            return `${parseInt(d, 10)}. ${parseInt(m, 10)}.`;
        };
        return `${fmt(this.dateFrom)} \u{2013} ${fmt(this.dateTo)}`;
    }
    _buildAuthorOptions() {
        const currentUser = this.getCurrentUser();
        const currentUserId = currentUser ? String(currentUser.id) : null;
        const meLabel = this.cfg.authorLabels && this.cfg.authorLabels.me || 'Moje';
        const options = [
            {
                value: 'me',
                label: meLabel
            },
            {
                value: 'all',
                label: "Cel\xe1 firma"
            }
        ];
        for (const author of this.authors){
            let value;
            if (author.userId != null) {
                if (currentUserId && String(author.userId) === currentUserId) continue;
                value = `id:${author.userId}`;
            } else {
                if (currentUser && author.name === (currentUser.name || currentUser.username)) continue;
                value = `name:${author.name}`;
            }
            options.push({
                value: value,
                label: author.name
            });
        }
        const known = new Set(options.map((o)=>o.value));
        if (!known.has(this.author)) this.author = 'me';
        return options.map((o)=>({
                ...o,
                selected: o.value === this.author
            }));
    }
    _id(suffix) {
        return `${this.key}-${suffix}`;
    }
    /**
   * Vykreslí skořápku sekce (hlavička + toolbar + panel filtrů + kontejnery
   * seznamu a stránkování) a naváže eventy. Volat jednou; při změně dat
   * pak jen renderResults().
   */ renderShell(container) {
        const cfg = this.cfg;
        const statusOptions = [
            {
                value: 'all',
                label: "V\u0161echny stavy"
            },
            ...this.statuses.map((s)=>({
                    value: s,
                    label: $4f2a626f4d7d3c8a$export$a954299e2515e375(cfg.statusKind, s) || s
                }))
        ];
        const authorOptions = this._buildAuthorOptions();
        const advCount = this._activeAdvancedCount();
        container.innerHTML = `
      <div class="w-full">
        <div class="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-3 mb-4">
          <div class="flex-shrink-0">
            <h2 class="text-2xl font-semibold text-gray-900 mb-1">${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(cfg.title)}</h2>
            <p class="text-gray-600 text-sm mb-0">${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(cfg.subtitle || '')}</p>
          </div>

          <!-- JEDNOTN\xdd TOOLBAR -->
          <div class="flex flex-wrap gap-2 items-center flex-1 lg:justify-end w-full">
            <div class="relative flex-1 min-w-[180px] max-w-md">
              <input type="text" id="${this._id('search')}"
                placeholder="${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(cfg.searchPlaceholder || "Hledat\u2026")}"
                value="${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(this.search)}"
                class="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              <span class="absolute left-2.5 top-2.5 text-gray-400">${(0, $entK4.icon)('magnifying-glass', 'w-4 h-4')}</span>
            </div>

            <select id="${this._id('author')}" title="\u{10C}\xed z\xe1znamy zobrazit"
              class="border border-gray-300 rounded-md py-2 px-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500">
              ${authorOptions.map((o)=>`<option value="${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(o.value)}" ${o.selected ? 'selected' : ''}>${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(o.label)}</option>`).join('')}
            </select>

            <button id="${this._id('toggle-filters')}" type="button"
              class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500">
              ${(0, $entK4.icon)('funnel', 'w-4 h-4 mr-1.5 text-gray-500')}
              Filtry
              <span id="${this._id('filters-badge')}" class="${advCount > 0 ? '' : 'hidden'} ml-1.5 bg-blue-100 text-blue-800 text-xs font-semibold px-2 py-0.5 rounded-full">${advCount}</span>
            </button>

            <button id="${this._id('reset-filters')}" type="button" title="Zru\u{161}it v\u{161}echny filtry a vr\xe1tit v\xfdchoz\xed zobrazen\xed"
              class="${this.hasActiveFilters() ? '' : 'hidden'} inline-flex items-center px-3 py-2 text-sm font-medium rounded-md text-red-600 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500">
              ${(0, $entK4.icon)('x-mark', 'w-4 h-4 mr-1')}
              Reset
            </button>

            ${cfg.enableKanban ? `
              <span class="inline-flex rounded-md border border-gray-300 shadow-sm overflow-hidden" role="group" aria-label="Re\u{17E}im zobrazen\xed">
                <button id="${this._id('view-list')}" type="button" title="Zobrazit jako seznam"
                  class="px-2.5 py-2 text-sm ${this.viewMode === 'list' ? 'bg-blue-50 text-blue-700' : 'bg-white text-gray-500 hover:bg-gray-50'}">
                  ${(0, $entK4.icon)('list-bullet', 'w-4 h-4')}
                </button>
                <button id="${this._id('view-kanban')}" type="button" title="Zobrazit jako kanban podle stav\u{16F}"
                  class="px-2.5 py-2 text-sm border-l border-gray-300 ${this.viewMode === 'kanban' ? 'bg-blue-50 text-blue-700' : 'bg-white text-gray-500 hover:bg-gray-50'}">
                  ${(0, $entK4.icon)('view-columns', 'w-4 h-4')}
                </button>
              </span>
            ` : ''}

            <button id="${this._id('density')}" type="button" title="${this.compact ? "P\u0159epnout na podrobn\xe9 zobrazen\xed" : "P\u0159epnout na kompaktn\xed zobrazen\xed"}"
              class="inline-flex items-center px-2.5 py-2 border border-gray-300 shadow-sm text-sm rounded-md bg-white ${this.compact ? 'text-blue-700 bg-blue-50' : 'text-gray-500'} hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500">
              ${(0, $entK4.icon)('bars-3', 'w-4 h-4')}
            </button>

            <button id="${this._id('refresh')}" type="button" title="Obnovit data"
              class="inline-flex items-center px-2.5 py-2 border border-gray-300 shadow-sm text-sm rounded-md text-gray-500 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500">
              ${(0, $entK4.icon)('arrow-path', 'w-4 h-4')}
            </button>

            ${typeof cfg.extraToolbar === 'function' ? cfg.extraToolbar() : cfg.extraToolbar || ''}
          </div>
        </div>

        <!-- ROZBALOVAC\xcd PANEL FILTR\u{16E} -->
        <div id="${this._id('advanced-panel')}" class="${this.showAdvanced ? '' : 'hidden'} mb-4 bg-gray-50 rounded-lg border border-gray-200 p-4 shadow-inner">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            ${cfg.enableCustomerFilter !== false ? `
              <div class="relative">
                <label class="block text-xs font-semibold text-gray-600 mb-1">Firma / z\xe1kazn\xedk</label>
                <div class="relative">
                  <input type="text" id="${this._id('customer')}" placeholder="Hledat firmu\u{2026}"
                    value="${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(this.customerName)}"
                    class="w-full bg-white border border-gray-300 rounded-md py-1.5 pl-3 pr-8 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                  <button id="${this._id('customer-clear')}" type="button" class="${this.customerId ? '' : 'hidden'} absolute inset-y-0 right-0 pr-2.5 flex items-center text-gray-400 hover:text-gray-600">
                    ${(0, $entK4.icon)('x-mark', 'w-4 h-4')}
                  </button>
                </div>
                <div id="${this._id('customer-list')}" class="hidden absolute left-0 right-0 mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-20 max-h-40 overflow-y-auto text-sm"></div>
              </div>
            ` : ''}

            <div>
              <label class="block text-xs font-semibold text-gray-600 mb-1">\u{10C}asov\xe9 obdob\xed</label>
              <div class="grid grid-cols-2 gap-2">
                <select id="${this._id('time')}" class="bg-white border border-gray-300 rounded-md py-1.5 px-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                  <option value="all" ${this.timeRange === 'all' ? 'selected' : ''}>V\u{161}echna data</option>
                  <option value="today" ${this.timeRange === 'today' ? 'selected' : ''}>Dnes</option>
                  <option value="7days" ${this.timeRange === '7days' ? 'selected' : ''}>Posledn\xedch 7 dn\xed</option>
                  <option value="month" ${this.timeRange === 'month' ? 'selected' : ''}>Posledn\xed m\u{11B}s\xedc</option>
                  <option value="custom" ${this.timeRange === 'custom' ? 'selected' : ''}>Vlastn\xed rozmez\xed\u{2026}</option>
                </select>
                <div id="${this._id('time-display')}" class="text-xs text-gray-500 flex items-center justify-center bg-white border border-gray-200 rounded px-2 text-center truncate">
                  ${this._timeRangeDisplay()}
                </div>
              </div>
            </div>

            <div>
              <label class="block text-xs font-semibold text-gray-600 mb-1">Stav</label>
              <select id="${this._id('status')}" class="w-full bg-white border border-gray-300 rounded-md py-1.5 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                ${statusOptions.map((o)=>`<option value="${o.value}" ${o.value === this.status ? 'selected' : ''}>${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(o.label)}</option>`).join('')}
              </select>
            </div>

            <div id="${this._id('date-range')}" class="${this.timeRange === 'custom' ? '' : 'hidden'} md:col-span-3 bg-white p-3 rounded-md border border-gray-200 flex flex-wrap gap-4 items-center">
              <div class="flex items-center gap-2">
                <span class="text-xs font-medium text-gray-600">Od:</span>
                <input type="date" id="${this._id('date-from')}" value="${this.dateFrom}" class="bg-white border border-gray-300 rounded-md py-1 px-2 text-xs focus:ring-2 focus:ring-blue-500 focus:outline-none">
              </div>
              <div class="flex items-center gap-2">
                <span class="text-xs font-medium text-gray-600">Do:</span>
                <input type="date" id="${this._id('date-to')}" value="${this.dateTo}" class="bg-white border border-gray-300 rounded-md py-1 px-2 text-xs focus:ring-2 focus:ring-blue-500 focus:outline-none">
              </div>
            </div>
          </div>

          <div class="flex justify-between items-center border-t border-gray-200 pt-3 mt-4">
            <button id="${this._id('clear-all')}" type="button" class="text-xs text-red-600 hover:text-red-800 font-medium">Vy\u{10D}istit v\u{161}echny filtry</button>
            <button id="${this._id('close-panel')}" type="button" class="bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium py-1 px-3 rounded text-xs transition-colors">Zav\u{159}\xedt</button>
          </div>
        </div>

        ${cfg.summarySlot ? `<div id="${this._id('summary')}"></div>` : ''}
        <div id="${this._id('list')}">${$4f2a626f4d7d3c8a$export$429ee859e6a27934()}</div>
        <div id="${this._id('pagination')}"></div>
      </div>
    `;
        this._bindShellEvents(container);
        this._shellRendered = true;
    }
    get listContainer() {
        return document.getElementById(this._id('list'));
    }
    get summaryContainer() {
        return document.getElementById(this._id('summary'));
    }
    _emitChange() {
        this._savePrefs();
        this._refreshToolbarState();
        if (typeof this.cfg.onChange === 'function') this.cfg.onChange();
    }
    /** Aktualizace badge počtu filtrů + viditelnosti resetu bez překreslení shellu. */ _refreshToolbarState() {
        const badge = document.getElementById(this._id('filters-badge'));
        const advCount = this._activeAdvancedCount();
        if (badge) {
            badge.textContent = advCount;
            badge.classList.toggle('hidden', advCount === 0);
        }
        const reset = document.getElementById(this._id('reset-filters'));
        if (reset) reset.classList.toggle('hidden', !this.hasActiveFilters());
        const timeDisplay = document.getElementById(this._id('time-display'));
        if (timeDisplay) timeDisplay.textContent = this._timeRangeDisplay();
    }
    _bindShellEvents(container) {
        // Hledání s debounce
        const searchInput = document.getElementById(this._id('search'));
        if (searchInput) {
            let t;
            searchInput.addEventListener('input', (e)=>{
                clearTimeout(t);
                t = setTimeout(()=>{
                    this.search = e.target.value;
                    this.page = 0;
                    this._emitChange();
                }, 250);
            });
        }
        document.getElementById(this._id('author'))?.addEventListener('change', (e)=>{
            this.author = e.target.value;
            this.page = 0;
            this._emitChange();
        });
        document.getElementById(this._id('toggle-filters'))?.addEventListener('click', ()=>{
            this.showAdvanced = !this.showAdvanced;
            document.getElementById(this._id('advanced-panel'))?.classList.toggle('hidden', !this.showAdvanced);
        });
        document.getElementById(this._id('close-panel'))?.addEventListener('click', ()=>{
            this.showAdvanced = false;
            document.getElementById(this._id('advanced-panel'))?.classList.add('hidden');
        });
        const doReset = ()=>{
            this.resetFilters();
            // Synchronizace ovládacích prvků
            const set = (suffix, value)=>{
                const el = document.getElementById(this._id(suffix));
                if (el) el.value = value;
            };
            set('search', '');
            set('status', 'all');
            set('author', 'me');
            set('time', 'all');
            set('date-from', '');
            set('date-to', '');
            if (this.cfg.enableCustomerFilter !== false) {
                set('customer', '');
                document.getElementById(this._id('customer-clear'))?.classList.add('hidden');
                const dd = document.getElementById(this._id('customer-list'));
                if (dd) {
                    dd.classList.add('hidden');
                    dd.innerHTML = '';
                }
            }
            document.getElementById(this._id('date-range'))?.classList.add('hidden');
            this._emitChange();
        };
        document.getElementById(this._id('reset-filters'))?.addEventListener('click', doReset);
        document.getElementById(this._id('clear-all'))?.addEventListener('click', doReset);
        document.getElementById(this._id('refresh'))?.addEventListener('click', ()=>this._emitChange());
        document.getElementById(this._id('status'))?.addEventListener('change', (e)=>{
            this.status = e.target.value;
            this.page = 0;
            this._emitChange();
        });
        document.getElementById(this._id('time'))?.addEventListener('change', (e)=>{
            this.timeRange = e.target.value;
            this.updateDatesByTimeRange();
            document.getElementById(this._id('date-range'))?.classList.toggle('hidden', this.timeRange !== 'custom');
            const set = (suffix, value)=>{
                const el = document.getElementById(this._id(suffix));
                if (el) el.value = value;
            };
            set('date-from', this.dateFrom);
            set('date-to', this.dateTo);
            this.page = 0;
            this._emitChange();
        });
        document.getElementById(this._id('date-from'))?.addEventListener('change', (e)=>{
            this.dateFrom = e.target.value;
            this.page = 0;
            this._emitChange();
        });
        document.getElementById(this._id('date-to'))?.addEventListener('change', (e)=>{
            this.dateTo = e.target.value;
            this.page = 0;
            this._emitChange();
        });
        // Kompaktní zobrazení
        document.getElementById(this._id('density'))?.addEventListener('click', (e)=>{
            this.compact = !this.compact;
            const btn = e.currentTarget;
            btn.classList.toggle('text-blue-700', this.compact);
            btn.classList.toggle('bg-blue-50', this.compact);
            btn.classList.toggle('text-gray-500', !this.compact);
            btn.title = this.compact ? "P\u0159epnout na podrobn\xe9 zobrazen\xed" : "P\u0159epnout na kompaktn\xed zobrazen\xed";
            this._emitChange();
        });
        // Přepínač seznam/kanban
        if (this.cfg.enableKanban) {
            const setMode = (mode)=>{
                if (this.viewMode === mode) return;
                this.viewMode = mode;
                const listBtn = document.getElementById(this._id('view-list'));
                const kanbanBtn = document.getElementById(this._id('view-kanban'));
                for (const [btn, active] of [
                    [
                        listBtn,
                        mode === 'list'
                    ],
                    [
                        kanbanBtn,
                        mode === 'kanban'
                    ]
                ]){
                    if (!btn) continue;
                    btn.classList.toggle('bg-blue-50', active);
                    btn.classList.toggle('text-blue-700', active);
                    btn.classList.toggle('bg-white', !active);
                    btn.classList.toggle('text-gray-500', !active);
                }
                this.page = 0;
                this._emitChange();
            };
            document.getElementById(this._id('view-list'))?.addEventListener('click', ()=>setMode('list'));
            document.getElementById(this._id('view-kanban'))?.addEventListener('click', ()=>setMode('kanban'));
        }
        // Autocomplete zákazníka
        if (this.cfg.enableCustomerFilter !== false) this._bindCustomerAutocomplete();
        // Stránkování (delegace – tlačítka se překreslují)
        document.getElementById(this._id('pagination'))?.addEventListener('click', (e)=>{
            const btn = e.target.closest('[data-page]');
            if (!btn) return;
            const page = parseInt(btn.dataset.page, 10);
            if (!Number.isFinite(page) || page < 0) return;
            this.page = page;
            this._emitChange();
        });
        document.getElementById(this._id('pagination'))?.addEventListener('change', (e)=>{
            if (e.target.matches('[data-page-size]')) {
                this.pageSize = parseInt(e.target.value, 10) || $4f2a626f4d7d3c8a$var$DEFAULT_PAGE_SIZE;
                this.page = 0;
                this._emitChange();
            }
        });
    }
    _bindCustomerAutocomplete() {
        const input = document.getElementById(this._id('customer'));
        const dropdown = document.getElementById(this._id('customer-list'));
        const clearBtn = document.getElementById(this._id('customer-clear'));
        if (!input || !dropdown) return;
        dropdown.addEventListener('click', (e)=>{
            const item = e.target.closest('[data-id]');
            if (!item) return;
            this.customerId = item.dataset.id;
            this.customerName = item.dataset.name;
            dropdown.classList.add('hidden');
            dropdown.innerHTML = '';
            clearBtn?.classList.remove('hidden');
            input.value = item.dataset.name;
            this.page = 0;
            this._emitChange();
        });
        clearBtn?.addEventListener('click', ()=>{
            this.customerId = '';
            this.customerName = '';
            input.value = '';
            dropdown.classList.add('hidden');
            dropdown.innerHTML = '';
            clearBtn.classList.add('hidden');
            this.page = 0;
            this._emitChange();
        });
        let t;
        input.addEventListener('input', (e)=>{
            const value = e.target.value.trim();
            clearTimeout(t);
            if (this.customerId && value !== this.customerName) {
                this.customerId = '';
                this.customerName = '';
                clearBtn?.classList.add('hidden');
                this._emitChange();
            }
            if (value.length < 2) {
                dropdown.classList.add('hidden');
                dropdown.innerHTML = '';
                return;
            }
            t = setTimeout(async ()=>{
                try {
                    if (!window.customersManager) return;
                    const customers = await window.customersManager.fetchCustomers(value);
                    dropdown.innerHTML = customers.length === 0 ? '<div class="p-2 text-gray-500 italic text-xs">\u017D\xe1dn\xfd z\xe1kazn\xedk nenalezen</div>' : customers.map((c)=>`
                <div class="px-3 py-2 hover:bg-blue-50 cursor-pointer text-gray-800 transition-colors" data-id="${c.id}" data-name="${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(c.name)}">
                  <span class="font-medium">${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(c.name)}</span>
                  ${c.ico ? `<span class="text-xs text-gray-400 ml-1">(I\u{10C}O: ${$4f2a626f4d7d3c8a$export$4cf11838cdc2a8a8(c.ico)})</span>` : ''}
                </div>
              `).join('');
                    dropdown.classList.remove('hidden');
                } catch (err) {
                    console.error('Chyba autocomplete:', err);
                }
            }, 200);
        });
        input.addEventListener('focus', ()=>{
            if (input.value.trim().length >= 2 && dropdown.innerHTML) dropdown.classList.remove('hidden');
        });
        document.addEventListener('click', (e)=>{
            if (!input.contains(e.target) && !dropdown.contains(e.target)) dropdown.classList.add('hidden');
        });
    }
    /**
   * Vykreslí výsledky (list mód): pole hotových <li> html + total z API.
   * @param {object} p { rowsHtml: string[], total: number, emptyState?: {title, hint} }
   */ renderResults({ rowsHtml: rowsHtml, total: total, emptyState: emptyState }) {
        this.total = typeof total === 'number' ? total : rowsHtml.length;
        const list = this.listContainer;
        if (!list) return;
        if (!rowsHtml.length) {
            const empty = emptyState || {};
            list.innerHTML = $4f2a626f4d7d3c8a$export$75003f4882a3396d({
                title: this.hasActiveFilters() ? "Nic neodpov\xedd\xe1 zadan\xfdm filtr\u016Fm" : empty.title || "Zat\xedm tu nic nen\xed",
                hint: this.hasActiveFilters() ? "Zkuste zm\u011Bnit filtry nebo je resetujte tla\u010D\xedtkem Reset." : empty.hint || ''
            });
        } else list.innerHTML = `
        <div class="bg-white shadow overflow-hidden sm:rounded-md">
          <ul class="divide-y divide-gray-200">${rowsHtml.join('')}</ul>
        </div>
      `;
        this._renderPagination();
        this._refreshToolbarState();
    }
    /** Vloží do list kontejneru libovolné HTML (kanban, chyba…). */ renderCustom(html, { showPagination: showPagination = false } = {}) {
        const list = this.listContainer;
        if (!list) return;
        list.innerHTML = html;
        if (showPagination) this._renderPagination();
        else {
            const p = document.getElementById(this._id('pagination'));
            if (p) p.innerHTML = '';
        }
        this._refreshToolbarState();
    }
    renderLoading() {
        const list = this.listContainer;
        if (list) list.innerHTML = $4f2a626f4d7d3c8a$export$429ee859e6a27934();
    }
    _renderPagination() {
        const el = document.getElementById(this._id('pagination'));
        if (!el) return;
        const totalPages = Math.max(Math.ceil(this.total / this.pageSize), 1);
        if (this.page >= totalPages) this.page = totalPages - 1;
        const from = this.total === 0 ? 0 : this.page * this.pageSize + 1;
        const to = Math.min((this.page + 1) * this.pageSize, this.total);
        el.innerHTML = `
      <div class="flex flex-wrap items-center justify-between gap-3 py-3 text-sm text-gray-600">
        <div class="flex items-center gap-2">
          <span>${from}\u{2013}${to} z ${this.total}</span>
          <select data-page-size class="border border-gray-300 rounded-md py-1 px-1.5 text-xs bg-white focus:outline-none focus:ring-2 focus:ring-blue-500" title="Po\u{10D}et z\xe1znam\u{16F} na str\xe1nku">
            ${$4f2a626f4d7d3c8a$var$PAGE_SIZES.map((s)=>`<option value="${s}" ${s === this.pageSize ? 'selected' : ''}>${s} / str\xe1nka</option>`).join('')}
          </select>
        </div>
        ${totalPages > 1 ? `
          <div class="flex items-center gap-1">
            <button type="button" data-page="${this.page - 1}" ${this.page === 0 ? 'disabled' : ''}
              class="inline-flex items-center px-2 py-1.5 border border-gray-300 rounded-md bg-white ${this.page === 0 ? 'text-gray-300 cursor-default' : 'text-gray-600 hover:bg-gray-50'}"
              title="P\u{159}edchoz\xed str\xe1nka">${(0, $entK4.icon)('chevron-left', 'w-4 h-4')}</button>
            ${this._pageButtons(totalPages)}
            <button type="button" data-page="${this.page + 1}" ${this.page >= totalPages - 1 ? 'disabled' : ''}
              class="inline-flex items-center px-2 py-1.5 border border-gray-300 rounded-md bg-white ${this.page >= totalPages - 1 ? 'text-gray-300 cursor-default' : 'text-gray-600 hover:bg-gray-50'}"
              title="Dal\u{161}\xed str\xe1nka">${(0, $entK4.icon)('chevron-right', 'w-4 h-4')}</button>
          </div>
        ` : ''}
      </div>
    `;
    }
    _pageButtons(totalPages) {
        // Zobrazíme max 7 tlačítek: 1 … p-1 p p+1 … N
        const pages = new Set([
            0,
            totalPages - 1,
            this.page - 1,
            this.page,
            this.page + 1
        ]);
        const sorted = [
            ...pages
        ].filter((p)=>p >= 0 && p < totalPages).sort((a, b)=>a - b);
        let html = '';
        let prev = -1;
        for (const p of sorted){
            if (prev >= 0 && p - prev > 1) html += '<span class="px-1 text-gray-400">\u2026</span>';
            html += `
        <button type="button" data-page="${p}"
          class="min-w-[32px] px-2 py-1.5 border rounded-md text-center ${p === this.page ? 'border-blue-500 bg-blue-50 text-blue-700 font-semibold' : 'border-gray-300 bg-white text-gray-600 hover:bg-gray-50'}">${p + 1}</button>
      `;
            prev = p;
        }
        return html;
    }
}

});

parcelRegister("l8N1u", function(module, exports) {
module.exports = $parcel$import("4nsUp").then(()=>parcelRequire('3hxDL'));

});

parcelRegister("5LbsB", function(module, exports) {
module.exports = $parcel$import("5RIj2").then(()=>parcelRequire('1gxgv'));

});

var $0e53608df89ca7f3$exports = {};
$parcel$extendImportMap({
    "4nsUp": "kanban.a666ce01.js",
    "jsksu": "logo-icon.5365db16.svg",
    "5RIj2": "client.910219aa.js"
});


// Tailwind UI Components - Nahrazení Bootstrap JS funkcionaliy

var $entK4 = parcelRequire("entK4");
// Modal funkcionality
class $a548b9f28be92ab1$var$TailwindModal {
    constructor(modalId){
        this.modal = document.getElementById(modalId);
        this.backdrop = this.modal?.querySelector('#modal-backdrop');
        this.closeBtn = this.modal?.querySelector('#modal-close-btn');
        this.cancelBtn = this.modal?.querySelector('#modal-cancel-btn');
        this.init();
    }
    init() {
        if (!this.modal) return;
        // Event listenery pro zavírání modalu
        this.closeBtn?.addEventListener('click', ()=>this.hide());
        this.cancelBtn?.addEventListener('click', ()=>this.hide());
        this.backdrop?.addEventListener('click', ()=>this.hide());
        // Zavřít modal při ESC
        document.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape' && !this.modal.classList.contains('hidden')) this.hide();
        });
    }
    show() {
        if (!this.modal) return;
        this.modal.classList.remove('hidden');
        this.modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        // Focus na první input
        const firstInput = this.modal.querySelector('input, textarea, select');
        if (firstInput) setTimeout(()=>firstInput.focus(), 100);
    }
    hide() {
        if (!this.modal) return;
        this.modal.classList.add('hidden');
        this.modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        // Vyčisti formulář
        const form = this.modal.querySelector('form');
        if (form) form.reset();
        // Skryj error zprávy
        const errorDiv = this.modal.querySelector('[id$="-error"]');
        if (errorDiv) errorDiv.classList.add('hidden');
    }
    static getInstance(modalId) {
        return new $a548b9f28be92ab1$var$TailwindModal(modalId);
    }
}
// Tab funkcionalita
class $a548b9f28be92ab1$var$TailwindTabs {
    constructor(tabContainer){
        this.container = typeof tabContainer === 'string' ? document.querySelector(tabContainer) : tabContainer;
        if (!this.container) return;
        this.tabs = this.container.querySelectorAll('[data-tab]');
        this.tabPanes = document.querySelectorAll('.tab-pane');
        this.init();
    }
    init() {
        this.tabs.forEach((tab)=>{
            tab.addEventListener('click', (e)=>{
                e.preventDefault();
                this.switchTab(tab.getAttribute('data-tab'));
            });
        });
    }
    switchTab(targetTab) {
        // Deaktivuj všechny taby
        this.tabs.forEach((tab)=>{
            tab.classList.remove('border-blue-500', 'text-blue-600');
            tab.classList.add('border-transparent', 'text-gray-500', 'hover:text-gray-700', 'hover:border-gray-300');
        });
        // Aktivuj kliknutý tab
        const activeTab = document.querySelector(`[data-tab="${targetTab}"]`);
        if (activeTab) {
            activeTab.classList.add('border-blue-500', 'text-blue-600');
            activeTab.classList.remove('border-transparent', 'text-gray-500', 'hover:text-gray-700', 'hover:border-gray-300');
        }
        // Skryj všechny tab panes
        this.tabPanes.forEach((pane)=>{
            pane.classList.remove('active');
        });
        // Zobraz aktivní tab pane
        const activePane = document.getElementById(targetTab);
        if (activePane) activePane.classList.add('active');
        // Na mobilu (< sm): po přepnutí tabu odscrolluj na začátek formuláře.
        // Předchozí pane mohl být dlouhý a uživatel odscrolovaný hluboko – nový
        // (často kratší) pane by jinak zůstal mimo dohled.
        if (window.matchMedia('(max-width: 639.98px)').matches) {
            const header = this.container.closest('.border-b');
            if (header) header.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }
}
// Mobile menu funkcionalita – levý drawer s backdropem
class $a548b9f28be92ab1$var$MobileMenu {
    constructor(){
        this.menuBtn = document.getElementById('mobile-menu-btn');
        this.mobileMenu = document.getElementById('mobile-menu');
        this.backdrop = document.getElementById('mobile-menu-backdrop');
        this.init();
    }
    init() {
        if (!this.menuBtn || !this.mobileMenu) return;
        this.menuBtn.addEventListener('click', ()=>{
            this.toggle();
        });
        // Zavři menu při kliknutí na link
        const menuLinks = this.mobileMenu.querySelectorAll('a[data-section]');
        menuLinks.forEach((link)=>{
            link.addEventListener('click', ()=>{
                this.hide();
            });
        });
        // Zavři menu při kliknutí na backdrop
        if (this.backdrop) this.backdrop.addEventListener('click', ()=>this.hide());
        // Zavři menu na Escape
        document.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape' && this.isVisible()) this.hide();
        });
    }
    toggle() {
        if (this.isVisible()) this.hide();
        else this.show();
    }
    isVisible() {
        return this.mobileMenu.classList.contains('opacity-100');
    }
    hide() {
        this.mobileMenu.classList.remove('opacity-100');
        this.mobileMenu.classList.add('opacity-0');
        if (this.backdrop) {
            this.backdrop.classList.remove('is-visible');
            this.backdrop.classList.add('hidden');
        }
        this.menuBtn.setAttribute('aria-expanded', 'false');
    }
    show() {
        this.mobileMenu.classList.remove('opacity-0');
        this.mobileMenu.classList.add('opacity-100');
        if (this.backdrop) {
            this.backdrop.classList.remove('hidden');
            // force reflow pro přechod opacity z 0 → 1
            this.backdrop.offsetWidth;
            this.backdrop.classList.add('is-visible');
        }
        this.menuBtn.setAttribute('aria-expanded', 'true');
    }
}
// Notification systém
function $a548b9f28be92ab1$var$showTailwindNotification(message, type = 'info') {
    // Odstranění starých notifikací
    const existingNotifications = document.querySelectorAll('.notification');
    existingNotifications.forEach((n)=>n.remove());
    const notification = document.createElement('div');
    notification.className = `notification fixed top-4 right-4 z-50 max-w-sm p-4 rounded-md shadow-lg transform transition-all duration-300 translate-x-full`;
    const colors = {
        'success': 'bg-green-50 border border-green-200 text-green-800',
        'error': 'bg-red-50 border border-red-200 text-red-800',
        'warning': 'bg-yellow-50 border border-yellow-200 text-yellow-800',
        'info': 'bg-blue-50 border border-blue-200 text-blue-800'
    };
    notification.className += ` ${colors[type] || colors.info}`;
    notification.innerHTML = `
    <div class="flex">
      <div class="flex-1">
        <p class="text-sm font-medium">${message}</p>
      </div>
      <div class="ml-4 flex-shrink-0 flex">
        <button class="inline-flex text-gray-400 hover:text-gray-600 focus:outline-none">
          ${(0, $entK4.icon)('x-mark', 'h-5 w-5')}
        </button>
      </div>
    </div>
  `;
    document.body.appendChild(notification);
    // Animace příchodu
    setTimeout(()=>{
        notification.classList.remove('translate-x-full');
    }, 10);
    // Auto-hide po 5 sekundách
    setTimeout(()=>{
        notification.classList.add('translate-x-full');
        setTimeout(()=>notification.remove(), 300);
    }, 5000);
    // Zavírací tlačítko
    const closeBtn = notification.querySelector('button');
    closeBtn.addEventListener('click', ()=>{
        notification.classList.add('translate-x-full');
        setTimeout(()=>notification.remove(), 300);
    });
}
// Inicializace po načtení DOM
document.addEventListener('DOMContentLoaded', function() {
    // Inicializuj modal
    const loginModal = new $a548b9f28be92ab1$var$TailwindModal('loginModal');
    window.TailwindModal = $a548b9f28be92ab1$var$TailwindModal; // Global přístup
    // Inicializuj taby
    const tabContainer = document.querySelector('nav[role="tablist"]');
    if (tabContainer) new $a548b9f28be92ab1$var$TailwindTabs(tabContainer);
    // Inicializuj mobile menu
    window.mobileMenu = new $a548b9f28be92ab1$var$MobileMenu();
    // Global funkce pro notifikace
    window.showNotification = $a548b9f28be92ab1$var$showTailwindNotification;
    console.log('Tailwind UI components initialized');
});


// Administrace materiálů

var $entK4 = parcelRequire("entK4");
class $167d902a780ac256$export$bd69549a0ec80b2c {
    constructor(){
        this.baseUrl = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
        this.materials = {};
        this.init();
    }
    // Získat informace o roli uživatele
    getCurrentUserRole() {
        try {
            const userData = localStorage.getItem('currentUser');
            if (userData) {
                const user = JSON.parse(userData);
                return user.role;
            }
        } catch (error) {
            console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed role u\u017Eivatele:", error);
        }
        return null;
    }
    // Kontrola, zda je uživatel admin
    isAdmin() {
        return this.getCurrentUserRole() === 'admin';
    }
    // Skrýt/zobrazit UI prvky podle role uživatele
    handleRoleBasedUI() {
        const isAdmin = this.isAdmin();
        const adminButtons = document.getElementById('materials-admin-buttons');
        if (adminButtons) {
            if (isAdmin) adminButtons.classList.remove('hidden');
            else adminButtons.classList.add('hidden');
        }
    }
    async init() {
        try {
            // Nastavit loading text do info boxu
            const el = document.getElementById('materials-last-saved-info');
            if (el && !el.textContent.trim()) el.textContent = "(na\u010D\xedt\xe1m z API...)";
            // Skrýt/zobrazit admin tlačítka podle role
            this.handleRoleBasedUI();
            await this.loadMaterials();
            this.renderMaterials();
            // Inicializace formuláře s materiály
            this.updateMaterialsForm();
        } catch (error) {
            console.error("Chyba p\u0159i inicializaci:", error);
            this.showError("Chyba p\u0159i na\u010D\xedt\xe1n\xed materi\xe1l\u016F");
            // Zachovat původní text v info boxu pokud existuje
            const el = document.getElementById('materials-last-saved-info');
            if (el) {
                const currentText = el.textContent.trim();
                if (!currentText || currentText === "(na\u010D\xedt\xe1m z API...)" || currentText.includes('chyba')) el.textContent = "(chyba na\u010Dten\xed z API)";
            }
        }
    }
    async loadMaterials() {
        try {
            const response = await fetch(`${this.baseUrl}/materials`);
            const result = await response.json();
            if (result.success) {
                // Nový formát dat s metadata wrapper
                this.materials = result.data.materials;
                // Nastavit informaci o posledním uložení
                const el = document.getElementById('materials-last-saved-info');
                if (el && result.data.lastUpdated) {
                    const lastUpdated = new Date(result.data.lastUpdated);
                    const userName = result.data.lastUpdatedBy || "nezn\xe1m\xfd";
                    const storageType = result.data.storageType || 'file';
                    const storageText = storageType === 'redis' ? "cloud datab\xe1ze" : "lok\xe1ln\xed soubor";
                    el.textContent = `Posledn\xed \xfapravu provedl u\u{17E}ivatel ${userName} ${lastUpdated.toLocaleString('cs-CZ')} (${storageText})`;
                }
            } else throw new Error(result.error);
        } catch (error) {
            console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed materi\xe1l\u016F:", error);
            // Fallback text do info boxu - ale zachováme původní text pokud existuje
            const el = document.getElementById('materials-last-saved-info');
            if (el) {
                // Pokud je element prázdný nebo obsahuje chybovou zprávu, nastavíme fallback
                const currentText = el.textContent.trim();
                if (!currentText || currentText === "(na\u010D\xedt\xe1m z API...)" || currentText.includes('chyba')) el.textContent = "(chyba na\u010Dten\xed z API)";
            // Jinak ponecháme původní text - neztratíme informaci o centrální správě
            }
        // Nevyhazujeme error, aby se aplikace mohla dál spustit
        // throw error;
        }
    }
    renderMaterials() {
        const container = document.getElementById('materials-container');
        if (!container) return;
        const isAdmin = this.isAdmin();
        const totalMaterials = Object.values(this.materials).reduce((sum, materials)=>sum + materials.length, 0);
        if (totalMaterials === 0) {
            container.innerHTML = `
        <div class="text-center py-12">
          ${(0, $entK4.icon)('inbox', 'mx-auto h-12 w-12 text-ink-faint mb-3')}
          <h3 class="text-base font-medium text-ink-muted mb-1">Zat\xedm \u{17E}\xe1dn\xe9 materi\xe1ly</h3>
          <p class="text-sm text-ink-faint">Za\u{10D}n\u{11B}te p\u{159}id\xe1n\xedm prvn\xedho materi\xe1lu tla\u{10D}\xedtkem \u{201E}P\u{159}idat materi\xe1l".</p>
        </div>
      `;
            this.initTooltips();
            return;
        }
        let html = '';
        // Low-stock banner – pouze pokud jsou nějaké nízké zásoby
        const lowStock = this.computeLowStock();
        if (lowStock.length > 0) html += `
        <div class="mb-6 flex items-center justify-between gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3" id="low-stock-banner">
          <div class="flex items-center gap-2 text-sm text-amber-800">
            ${(0, $entK4.icon)('exclamation-triangle', 'w-5 h-5 text-amber-500')}
            <span><strong>N\xedzk\xe9 z\xe1soby:</strong> ${lowStock.length} ${lowStock.length === 1 ? "materi\xe1l" : lowStock.length < 5 ? "materi\xe1ly" : "materi\xe1l\u016F"}</span>
          </div>
          <div class="flex items-center gap-2">
            <button class="text-xs font-medium text-amber-800 hover:text-amber-900 underline" onclick="materialsAdmin.toggleLowStockFilter()">
              <span id="low-stock-filter-label">Zobrazit pouze n\xedzk\xe9</span>
            </button>
          </div>
        </div>
      `;
        for (const [categoryId, categoryMaterials] of Object.entries(this.materials)){
            if (categoryMaterials.length === 0) continue;
            html += `
        <section id="papiry-${categoryId}" class="mb-6 last:mb-0 scroll-mt-24" data-category="${categoryId}">
          <header class="flex items-center gap-2 mb-2 px-1">
            ${(0, $entK4.icon)('folder', 'w-4 h-4 text-brand-500')}
            <h3 class="text-sm font-semibold text-ink">${this.getCategoryName(categoryId)}</h3>
            <span class="inline-flex items-center px-1.5 py-0.5 rounded bg-ink-50 text-ink-muted text-[11px] font-medium">${categoryMaterials.length}</span>
          </header>
          <div class="overflow-x-auto border border-ink-100 rounded-lg">
            <table class="min-w-full text-sm">
              <thead>
                <tr class="bg-surface-1 text-ink-muted">
                  <th class="px-4 py-2 text-left text-[11px] font-semibold uppercase tracking-wider">N\xe1zev</th>
                  <th class="px-4 py-2 text-right text-[11px] font-semibold uppercase tracking-wider">Cena / arch</th>
                  <th class="px-4 py-2 text-right text-[11px] font-semibold uppercase tracking-wider">Skladem</th>
                  <th class="px-4 py-2 text-right text-[11px] font-semibold uppercase tracking-wider">Min</th>
                  <th class="px-4 py-2 text-center text-[11px] font-semibold uppercase tracking-wider">Gram\xe1\u{17E}</th>
                  <th class="px-4 py-2 text-center text-[11px] font-semibold uppercase tracking-wider">Rozm\u{11B}ry</th>
                  <th class="px-4 py-2 text-center text-[11px] font-semibold uppercase tracking-wider">Obr\xe1tka</th>
                  <th class="px-4 py-2 text-right text-[11px] font-semibold uppercase tracking-wider">Akce</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-ink-50">
      `;
            categoryMaterials.forEach((material)=>{
                const isLowStock = this.isMaterialLowStock(material);
                const stockColor = (parseInt(material.skladem) || 0) === 0 ? 'bg-red-100 text-red-700' : isLowStock ? 'bg-amber-100 text-amber-700' : 'bg-green-100 text-green-700';
                const available = (parseInt(material.skladem) || 0) - (parseInt(material.reservedCount) || 0);
                const reservedCount = parseInt(material.reservedCount) || 0;
                const lowStockClass = isLowStock ? 'data-low-stock="true"' : '';
                html += `
          <tr class="hover:bg-surface-1 transition-colors" ${lowStockClass}>
            <td class="px-4 py-2 whitespace-nowrap font-medium text-ink">${material.name}</td>
            <td class="px-4 py-2 text-right">
              ${isAdmin ? `<input type="number" value="${material.price}" step="0.01" min="0" onchange="materialsAdmin.updatePrice('${categoryId}', '${material.id}', this.value)" class="w-24 text-right px-2 py-1 border border-ink-100 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 text-sm tabular-nums" title="Zm\u{11B}nit cenu">` : `<span class="text-ink-muted tabular-nums">${Number(material.price).toFixed(2)} K\u{10D}</span>`}
            </td>
            <td class="px-4 py-2 text-right">
              <div class="flex flex-col items-end">
                ${isAdmin ? `<input type="number" value="${material.skladem || 0}" min="0" onchange="materialsAdmin.updateStock('${categoryId}', '${material.id}', this.value)" class="w-20 text-right px-2 py-1 border border-ink-100 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 text-sm tabular-nums" title="Zm\u{11B}nit skladov\xe9 mno\u{17E}stv\xed">` : `<span class="inline-flex items-center px-2 py-0.5 rounded ${stockColor} text-xs font-medium tabular-nums">${material.skladem || 0}</span>`}
                ${isAdmin ? `<span class="text-[10px] text-ink-faint mt-0.5">Dostupn\xe9: ${available}</span>` : `<span class="text-[10px] text-ink-faint mt-0.5">Dostupn\xe9: ${available}</span>`}
                ${reservedCount > 0 ? `<span class="text-[10px] text-amber-600">Rezervov\xe1no: ${reservedCount}</span>` : ''}
              </div>
            </td>
            <td class="px-4 py-2 text-right">
              ${isAdmin ? `<input type="number" value="${material.minStock || 0}" min="0" onchange="materialsAdmin.updateMinStock('${categoryId}', '${material.id}', this.value)" class="w-16 text-right px-2 py-1 border border-ink-100 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 text-sm tabular-nums" title="Minim\xe1ln\xed skladov\xe9 mno\u{17E}stv\xed">` : `<span class="text-ink-muted tabular-nums">${material.minStock || 0}</span>`}
            </td>
            <td class="px-4 py-2 text-center text-ink-muted tabular-nums">${material.weight} <span class="text-ink-faint text-xs">g/m\xb2</span></td>
            <td class="px-4 py-2 text-center text-ink-faint text-xs tabular-nums">${material.width}\xd7${material.height} mm</td>
            <td class="px-4 py-2 text-center">
              ${material.canFlip ? `<span class="inline-flex items-center gap-1 text-success text-xs font-medium">${(0, $entK4.icon)('check', 'w-3.5 h-3.5')}ano</span>` : `<span class="text-ink-faint text-xs">\u{2014}</span>`}
            </td>
            <td class="px-4 py-2 text-right">
              <div class="flex justify-end gap-1">
                <button class="p-1.5 rounded-md hover:bg-brand-50 text-ink-muted hover:text-brand transition-colors" onclick="materialsAdmin.showMovementsModal('${categoryId}', '${material.id}')" title="Skladov\xe9 pohyby">
                  ${(0, $entK4.icon)('arrow-path', 'w-4 h-4')}
                </button>
                ${isAdmin ? `<button class="p-1.5 rounded-md hover:bg-brand-50 text-ink-muted hover:text-brand transition-colors" onclick="materialsAdmin.editMaterial('${categoryId}', '${material.id}')" title="Upravit">
                      ${(0, $entK4.icon)('pencil-square', 'w-4 h-4')}
                    </button>
                    <button class="p-1.5 rounded-md hover:bg-danger-soft text-ink-muted hover:text-danger transition-colors" onclick="materialsAdmin.deleteMaterial('${categoryId}', '${material.id}')" title="Smazat">
                      ${(0, $entK4.icon)('trash', 'w-4 h-4')}
                    </button>` : `<span class="text-ink-faint text-xs">jen pro \u{10D}ten\xed</span>`}
              </div>
            </td>
          </tr>
        `;
            });
            html += `
              </tbody>
            </table>
          </div>
        </section>
      `;
        }
        container.innerHTML = html;
        this.initTooltips();
        this.renderCategoriesNav();
        this.initCategoriesNav();
    }
    /**
   * Vykreslí boční navigaci kategoriemi papírů (pouze kategorie, které mají alespoň jeden materiál).
   */ renderCategoriesNav() {
        const nav = document.getElementById('papiry-nav');
        if (!nav) return;
        const linksHtml = Object.entries(this.materials).filter(([, items])=>items.length > 0).map(([categoryId, items])=>`
        <a href="#papiry-${categoryId}" class="settings-nav__link" data-category="${categoryId}">
          <span class="flex-1 truncate">${this.getCategoryName(categoryId)}</span>
          <span class="text-[11px] text-ink-faint tabular-nums">${items.length}</span>
        </a>
      `).join('');
        nav.innerHTML = `
      <div class="settings-nav__group">
        <div class="settings-nav__title">Kategorie pap\xedr\u{16F}</div>
        ${linksHtml}
      </div>
    `;
    }
    /**
   * Scroll-spy: plynulý skok na kategorii po kliknutí + zvýraznění aktivní kategorie
   * podle pozice scrollu. Stejný pattern jako initSettingsNav v app.js.
   */ initCategoriesNav() {
        const nav = document.getElementById('papiry-nav');
        if (!nav) return;
        const links = Array.from(nav.querySelectorAll('.settings-nav__link'));
        if (!links.length) return;
        const targets = links.map((link)=>{
            const id = link.getAttribute('href')?.replace('#', '');
            const el = id ? document.getElementById(id) : null;
            return el ? {
                link: link,
                el: el
            } : null;
        }).filter(Boolean);
        if (!targets.length) return;
        const setActive = (activeLink)=>{
            links.forEach((l)=>l.classList.remove('is-active'));
            if (activeLink) activeLink.classList.add('is-active');
        };
        // Výchozí aktivní = první kategorie
        setActive(targets[0].link);
        // Klik na odkaz = plynulé odskrolování na sekci
        links.forEach((link)=>{
            link.addEventListener('click', (e)=>{
                const id = link.getAttribute('href')?.replace('#', '');
                const el = id ? document.getElementById(id) : null;
                if (!el) return;
                e.preventDefault();
                setActive(link);
                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
        });
        // Odpojíme starý observer při opětovném renderu
        if (this._categoriesObserver) this._categoriesObserver.disconnect();
        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries)=>{
                const visible = entries.filter((en)=>en.isIntersecting).sort((a, b)=>a.boundingClientRect.top - b.boundingClientRect.top);
                if (!visible.length) return;
                const topId = visible[0].target.id;
                const match = targets.find((t)=>t.el.id === topId);
                if (match) setActive(match.link);
            }, {
                rootMargin: '-96px 0px -60% 0px',
                threshold: 0
            });
            targets.forEach((t)=>observer.observe(t.el));
            this._categoriesObserver = observer;
        }
    }
    getCategoryName(categoryId) {
        const categoryNames = {
            'ofset': "Ofsetov\xfd pap\xedr",
            'laserova': "Do laserov\xe9 tisk\xe1rny",
            'krida-leskla': "Leskl\xe1 k\u0159\xedda",
            'krida-matna': "Matn\xe1 k\u0159\xedda",
            'recyklovane': "Recyklovan\xe9 a ekologick\xe9 pap\xedry",
            'lepenky': 'Lepenky',
            'samolepici': "Samolep\xedc\xed pap\xedry",
            'kartony': "Kart\xf3ny",
            'specialni': "Speci\xe1ln\xed grafick\xe9 pap\xedry"
        };
        return categoryNames[categoryId] || "Ostatn\xed";
    }
    async updatePrice(categoryId, materialId, newPrice) {
        try {
            const response = await fetch(`${this.baseUrl}/materials/${categoryId}/${materialId}/price`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    price: parseFloat(newPrice)
                })
            });
            if (!response.ok) {
                if (response.status === 401) {
                    this.showError("Nejste p\u0159ihl\xe1\u0161eni. P\u0159ihlaste se pros\xedm jako administr\xe1tor.");
                    return;
                }
                if (response.status === 403) {
                    this.showError("Nem\xe1te opr\xe1vn\u011Bn\xed k \xfaprav\u011B cen. Pouze administr\xe1to\u0159i mohou upravovat ceny materi\xe1l\u016F.");
                    return;
                }
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            const result = await response.json();
            if (result.success) {
                this.showSuccess(`Cena materi\xe1lu byla aktualizov\xe1na na ${newPrice} K\u{10D}`);
                // Aktualizovat lokální data
                const material = this.materials[categoryId].find((m)=>m.id === materialId);
                if (material) material.price = parseFloat(newPrice);
                // Aktualizovat formulář
                this.updateMaterialsForm();
            } else throw new Error(result.error || "Nezn\xe1m\xe1 chyba");
        } catch (error) {
            console.error("Chyba p\u0159i aktualizaci ceny:", error);
            if (error.name === 'SyntaxError') this.showError("Nejste p\u0159ihl\xe1\u0161eni nebo nem\xe1te opr\xe1vn\u011Bn\xed. P\u0159ihlaste se pros\xedm jako administr\xe1tor.");
            else this.showError(`Chyba p\u{159}i aktualizaci ceny: ${error.message}`);
        }
    }
    async updateStock(categoryId, materialId, newStock) {
        try {
            const response = await fetch(`${this.baseUrl}/materials/${categoryId}/${materialId}/stock`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    stock: parseInt(newStock)
                })
            });
            if (!response.ok) {
                if (response.status === 401) {
                    this.showError("Nejste p\u0159ihl\xe1\u0161eni. P\u0159ihlaste se pros\xedm jako administr\xe1tor.");
                    return;
                }
                if (response.status === 403) {
                    this.showError("Nem\xe1te opr\xe1vn\u011Bn\xed k \xfaprav\u011B skladov\xfdch z\xe1sob. Pouze administr\xe1to\u0159i mohou upravovat tyto hodnoty.");
                    return;
                }
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            const result = await response.json();
            if (result.success) {
                this.showSuccess(`Skladov\xe9 mno\u{17E}stv\xed bylo aktualizov\xe1no na ${newStock} ks`);
                // Aktualizovat lokální data
                const material = this.materials[categoryId].find((m)=>m.id === materialId);
                if (material) material.skladem = parseInt(newStock);
                // Aktualizovat formulář
                this.updateMaterialsForm();
            } else throw new Error(result.error || "Nezn\xe1m\xe1 chyba");
        } catch (error) {
            console.error("Chyba p\u0159i aktualizaci skladov\xe9ho mno\u017Estv\xed:", error);
            if (error.name === 'SyntaxError') this.showError("Nejste p\u0159ihl\xe1\u0161eni nebo nem\xe1te opr\xe1vn\u011Bn\xed. P\u0159ihlaste se pros\xedm jako administr\xe1tor.");
            else this.showError(`Chyba p\u{159}i aktualizaci skladov\xe9ho mno\u{17E}stv\xed: ${error.message}`);
        }
    }
    async updateMinStock(categoryId, materialId, newMin) {
        try {
            const response = await fetch(`${this.baseUrl}/materials/${categoryId}/${materialId}/min-stock`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    minStock: parseInt(newMin)
                })
            });
            if (!response.ok) {
                if (response.status === 401) {
                    this.showError("Nejste p\u0159ihl\xe1\u0161eni. P\u0159ihlaste se pros\xedm jako administr\xe1tor.");
                    return;
                }
                if (response.status === 403) {
                    this.showError("Nem\xe1te opr\xe1vn\u011Bn\xed k \xfaprav\u011B min. skladu.");
                    return;
                }
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            const result = await response.json();
            if (result.success) {
                this.showSuccess(`Min. sklad nastaven na ${newMin} ks`);
                const material = this.materials[categoryId].find((m)=>m.id === materialId);
                if (material) material.minStock = parseInt(newMin);
            } else throw new Error(result.error || "Nezn\xe1m\xe1 chyba");
        } catch (error) {
            console.error("Chyba p\u0159i aktualizaci min. skladu:", error);
            this.showError(`Chyba p\u{159}i aktualizaci min. skladu: ${error.message}`);
        }
    }
    // ----- Skladové pohyby (warehouse) -----
    isMaterialLowStock(material) {
        const skladem = parseInt(material.skladem) || 0;
        const minStock = parseInt(material.minStock) || 0;
        return minStock > 0 && skladem <= minStock || skladem === 0;
    }
    computeLowStock() {
        const result = [];
        for (const categoryId of Object.keys(this.materials)){
            const items = this.materials[categoryId];
            if (!Array.isArray(items)) continue;
            for (const material of items)if (this.isMaterialLowStock(material)) result.push({
                categoryId: categoryId,
                material: material
            });
        }
        return result;
    }
    toggleLowStockFilter() {
        this._lowStockOnly = !this._lowStockOnly;
        const label = document.getElementById('low-stock-filter-label');
        if (label) label.textContent = this._lowStockOnly ? "Zobrazit v\u0161echny" : "Zobrazit pouze n\xedzk\xe9";
        const sections = document.querySelectorAll('#materials-container section[data-category]');
        sections.forEach((section)=>{
            const rows = Array.from(section.querySelectorAll('tbody tr'));
            const lowRows = rows.filter((r)=>r.getAttribute('data-low-stock') === 'true');
            const hasLow = lowRows.length > 0;
            if (!this._lowStockOnly) {
                section.style.display = '';
                rows.forEach((r)=>{
                    r.style.display = '';
                });
            } else if (!hasLow) section.style.display = 'none';
            else {
                section.style.display = '';
                rows.forEach((r)=>{
                    r.style.display = r.getAttribute('data-low-stock') === 'true' ? '' : 'none';
                });
            }
        });
    }
    showMovementsModal(categoryId, materialId) {
        const material = this.materials[categoryId]?.find((m)=>m.id === materialId);
        if (!material) {
            this.showError("Materi\xe1l nebyl nalezen.");
            return;
        }
        const existing = document.getElementById('movementsModal');
        if (existing) existing.remove();
        this.createMovementsModal(material, categoryId);
        const tailwindModal = new TailwindModal('movementsModal');
        tailwindModal.show();
        this._movementsContext = {
            categoryId: categoryId,
            materialId: materialId
        };
        this.loadMovements(categoryId, materialId);
    }
    createMovementsModal(material, categoryId) {
        const isAdmin = this.isAdmin();
        const available = (parseInt(material.skladem) || 0) - (parseInt(material.reservedCount) || 0);
        const modalHtml = `
      <div class="fixed inset-0 z-50 overflow-y-auto hidden" id="movementsModal" aria-labelledby="movementsModalLabel" aria-hidden="true">
        <div class="flex items-center justify-center min-h-screen px-4">
          <div class="fixed inset-0 bg-black opacity-50" id="modal-backdrop"></div>
          <div class="bg-white rounded-lg shadow-xl max-w-3xl w-full relative">
            <div class="px-6 py-4 border-b border-gray-200">
              <h3 class="text-lg font-medium text-gray-900" id="movementsModalLabel">Skladov\xe9 pohyby \u{2013} ${material.name}</h3>
              <button type="button" class="absolute top-4 right-4 text-gray-400 hover:text-gray-600" id="modal-close-btn">
                ${(0, $entK4.icon)('x-mark', 'h-6 w-6')}
              </button>
              <p class="text-sm text-gray-500 mt-1">
                Skladem: <strong>${material.skladem || 0}</strong> \xb7
                Rezervov\xe1no: <strong>${material.reservedCount || 0}</strong> \xb7
                Dostupn\xe9: <strong>${available}</strong> \xb7
                Min: <strong>${material.minStock || 0}</strong>
              </p>
            </div>
            <div class="px-6 py-4">
              ${isAdmin ? `
              <form id="movementForm" class="grid grid-cols-12 gap-3 items-end mb-4 p-3 bg-gray-50 rounded-md">
                <div class="col-span-3">
                  <label class="block text-xs font-medium text-gray-700 mb-1">Typ pohybu</label>
                  <select id="movementType" class="block w-full px-2 py-1.5 border border-gray-300 rounded-md text-sm">
                    <option value="in">P\u{159}\xedjem</option>
                    <option value="out">V\xfddej</option>
                    <option value="reservation">Rezervace</option>
                  </select>
                </div>
                <div class="col-span-3">
                  <label class="block text-xs font-medium text-gray-700 mb-1">Mno\u{17E}stv\xed</label>
                  <input type="number" id="movementQuantity" min="1" value="1" class="block w-full px-2 py-1.5 border border-gray-300 rounded-md text-sm">
                </div>
                <div class="col-span-3">
                  <label class="block text-xs font-medium text-gray-700 mb-1">Objedn\xe1vka (voliteln\xe9)</label>
                  <input type="text" id="movementOrderId" placeholder="ORD-..." class="block w-full px-2 py-1.5 border border-gray-300 rounded-md text-sm">
                </div>
                <div class="col-span-3">
                  <label class="block text-xs font-medium text-gray-700 mb-1">D\u{16F}vod (voliteln\xe9)</label>
                  <input type="text" id="movementReason" class="block w-full px-2 py-1.5 border border-gray-300 rounded-md text-sm">
                </div>
                <div class="col-span-12">
                  <button type="button" class="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700" onclick="materialsAdmin.addMovement()">
                    ${(0, $entK4.icon)('plus', 'w-4 h-4 mr-1')} P\u{159}idat pohyb
                  </button>
                </div>
              </form>
              ` : ''}
              <div id="movementsTableContainer" class="overflow-x-auto border border-gray-100 rounded-md">
                <div class="p-4 text-sm text-gray-500 text-center">Na\u{10D}\xedt\xe1m pohyby\u{2026}</div>
              </div>
            </div>
            <div class="px-6 py-4 border-t border-gray-200 flex justify-end">
              <button type="button" class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" id="modal-cancel-btn">Zav\u{159}\xedt</button>
            </div>
          </div>
        </div>
      </div>
    `;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
    }
    async loadMovements(categoryId, materialId) {
        const container = document.getElementById('movementsTableContainer');
        if (!container) return;
        try {
            const url = new URL(`${this.baseUrl}/warehouse/movements`);
            url.searchParams.set('categoryId', categoryId);
            url.searchParams.set('materialId', materialId);
            const response = await fetch(url.toString(), {
                credentials: 'include'
            });
            const result = await response.json();
            if (result.success) this.renderMovementsTable(result.data);
            else container.innerHTML = `<div class="p-4 text-sm text-red-600">${result.error || "Chyba p\u0159i na\u010D\xedt\xe1n\xed pohyb\u016F"}</div>`;
        } catch (error) {
            console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed pohyb\u016F:", error);
            container.innerHTML = `<div class="p-4 text-sm text-red-600">Chyba p\u{159}i na\u{10D}\xedt\xe1n\xed pohyb\u{16F}</div>`;
        }
    }
    renderMovementsTable(movements) {
        const container = document.getElementById('movementsTableContainer');
        if (!container) return;
        if (!movements || movements.length === 0) {
            container.innerHTML = `<div class="p-6 text-sm text-gray-500 text-center">Zat\xedm \u{17E}\xe1dn\xe9 skladov\xe9 pohyby.</div>`;
            return;
        }
        const typeLabel = (t)=>({
                'in': '<span class="text-green-700">P\u0159\xedjem</span>',
                'out': '<span class="text-red-700">V\xfddej</span>',
                'reservation': '<span class="text-amber-700">Rezervace</span>',
                'reservation-release': '<span class="text-ink-muted">Uvoln\u011Bn\xed rez.</span>'
            })[t] || t;
        const isAdmin = this.isAdmin();
        const rows = movements.map((m)=>{
            const date = new Date(m.createdAt).toLocaleString('cs-CZ');
            const sign = m.type === 'in' ? '+' : m.type === 'out' ? "\u2212" : m.type === 'reservation' ? "\u22CA" : "\u21BA";
            const released = m.type === 'reservation' && m.released ? ' <span class="text-[10px] text-ink-faint">(uvoln\u011Bna)</span>' : '';
            return `
        <tr class="border-b border-gray-50">
          <td class="px-3 py-2 text-xs text-gray-500 whitespace-nowrap">${date}</td>
          <td class="px-3 py-2 text-xs">${typeLabel(m.type)}${released}</td>
          <td class="px-3 py-2 text-xs tabular-nums font-medium">${sign} ${m.quantity}</td>
          <td class="px-3 py-2 text-xs text-gray-500">${m.orderId || "\u2014"}</td>
          <td class="px-3 py-2 text-xs text-gray-500">${m.reason || "\u2014"}</td>
          <td class="px-3 py-2 text-xs text-gray-500">${m.user || "\u2014"}</td>
          <td class="px-3 py-2 text-xs text-right">
            ${isAdmin && m.type !== 'reservation-release' && !m.released ? `<button class="text-red-500 hover:text-red-700" onclick="materialsAdmin.deleteMovement('${m.id}')" title="Smazat pohyb">${(0, $entK4.icon)('trash', 'w-3.5 h-3.5')}</button>` : ''}
          </td>
        </tr>
      `;
        }).join('');
        container.innerHTML = `
      <table class="min-w-full text-sm">
        <thead class="bg-gray-50 text-gray-500">
          <tr>
            <th class="px-3 py-2 text-left text-[11px] font-semibold uppercase">Datum</th>
            <th class="px-3 py-2 text-left text-[11px] font-semibold uppercase">Typ</th>
            <th class="px-3 py-2 text-left text-[11px] font-semibold uppercase">Mno\u{17E}stv\xed</th>
            <th class="px-3 py-2 text-left text-[11px] font-semibold uppercase">Objedn\xe1vka</th>
            <th class="px-3 py-2 text-left text-[11px] font-semibold uppercase">D\u{16F}vod</th>
            <th class="px-3 py-2 text-left text-[11px] font-semibold uppercase">U\u{17E}ivatel</th>
            <th class="px-3 py-2 text-right text-[11px] font-semibold uppercase">Akce</th>
          </tr>
        </thead>
        <tbody>${rows}</tbody>
      </table>
    `;
    }
    async addMovement() {
        const ctx = this._movementsContext;
        if (!ctx) return;
        const type = document.getElementById('movementType').value;
        const quantity = parseInt(document.getElementById('movementQuantity').value);
        const orderId = document.getElementById('movementOrderId').value.trim();
        const reason = document.getElementById('movementReason').value.trim();
        if (!quantity || quantity <= 0) {
            this.showError("Mno\u017Estv\xed mus\xed b\xfdt kladn\xe9 cel\xe9 \u010D\xedslo");
            return;
        }
        try {
            const response = await fetch(`${this.baseUrl}/warehouse/movements`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    categoryId: ctx.categoryId,
                    materialId: ctx.materialId,
                    type: type,
                    quantity: quantity,
                    orderId: orderId || null,
                    reason: reason || null
                })
            });
            const result = await response.json();
            if (result.success) {
                this.showSuccess("Skladov\xfd pohyb byl zaznamen\xe1n");
                document.getElementById('movementQuantity').value = '1';
                document.getElementById('movementOrderId').value = '';
                document.getElementById('movementReason').value = '';
                await this.loadMovements(ctx.categoryId, ctx.materialId);
                await this.loadMaterials();
                this.renderMaterials();
            } else throw new Error(result.error || "Nezn\xe1m\xe1 chyba");
        } catch (error) {
            console.error("Chyba p\u0159i p\u0159id\xe1v\xe1n\xed pohybu:", error);
            this.showError(`Chyba: ${error.message}`);
        }
    }
    async deleteMovement(movementId) {
        if (!confirm("Opravdu smazat tento skladov\xfd pohyb? Skladov\xe9 stavy budou reverzn\u011B upraveny.")) return;
        const ctx = this._movementsContext;
        try {
            const response = await fetch(`${this.baseUrl}/warehouse/movements/${movementId}`, {
                method: 'DELETE',
                credentials: 'include'
            });
            const result = await response.json();
            if (result.success) {
                this.showSuccess("Pohyb byl smaz\xe1n");
                if (ctx) await this.loadMovements(ctx.categoryId, ctx.materialId);
                await this.loadMaterials();
                this.renderMaterials();
            } else throw new Error(result.error || "Nezn\xe1m\xe1 chyba");
        } catch (error) {
            console.error("Chyba p\u0159i maz\xe1n\xed pohybu:", error);
            this.showError(`Chyba: ${error.message}`);
        }
    }
    showAddMaterialModal() {
        try {
            const modal = document.getElementById('addMaterialModal');
            if (!modal) this.createAddMaterialModal();
            const tailwindModal = new TailwindModal('addMaterialModal');
            tailwindModal.show();
        } catch (error) {
            console.error("Chyba p\u0159i otev\xedr\xe1n\xed modalu:", error);
            this.showError("Chyba p\u0159i otev\xedr\xe1n\xed formul\xe1\u0159e pro p\u0159id\xe1n\xed materi\xe1lu.");
        }
    }
    createAddMaterialModal() {
        const modalHtml = `
      <div class="fixed inset-0 z-50 overflow-y-auto hidden" id="addMaterialModal" aria-labelledby="addMaterialModalLabel" aria-hidden="true">
        <div class="flex items-center justify-center min-h-screen px-4">
          <div class="fixed inset-0 bg-black opacity-50" id="modal-backdrop"></div>
          <div class="bg-white rounded-lg shadow-xl max-w-lg w-full relative">
            <div class="px-6 py-4 border-b border-gray-200">
              <h3 class="text-lg font-medium text-gray-900" id="addMaterialModalLabel">P\u{159}idat nov\xfd materi\xe1l</h3>
              <button type="button" class="absolute top-4 right-4 text-gray-400 hover:text-gray-600" id="modal-close-btn">
                ${(0, $entK4.icon)('x-mark', 'h-6 w-6')}
              </button>
            </div>
            <div class="px-6 py-4">
              <form id="addMaterialForm">
                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-2">Kategorie</label>
                  <select class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-white" id="materialCategory" required>
                    <option value="">Vyberte kategorii</option>
                    <option value="ofset">Ofsetov\xfd pap\xedr</option>
                    <option value="laserova">Do laserov\xe9 tisk\xe1rny</option>
                    <option value="krida-leskla">Leskl\xe1 k\u{159}\xedda</option>
                    <option value="krida-matna">Matn\xe1 k\u{159}\xedda</option>
                    <option value="recyklovane">Recyklovan\xe9 a ekologick\xe9 pap\xedry</option>
                    <option value="lepenky">Lepenky</option>
                    <option value="samolepici">Samolep\xedc\xed pap\xedry</option>
                    <option value="kartony">Kart\xf3ny</option>
                    <option value="specialni">Speci\xe1ln\xed grafick\xe9 pap\xedry</option>
                  </select>
                </div>
                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-2">N\xe1zev</label>
                  <input type="text" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" id="materialName" required minlength="2" maxlength="100" placeholder="Zadejte n\xe1zev materi\xe1lu">
                  <div class="text-red-500 text-sm mt-1 hidden" id="materialNameError">N\xe1zev mus\xed m\xedt alespo\u{148} 2 znaky</div>
                </div>
                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-2">Cena (K\u{10D})</label>
                  <input type="number" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" id="materialPrice" step="0.01" min="0.01" max="99999" required placeholder="0.00">
                  <div class="text-red-500 text-sm mt-1 hidden" id="materialPriceError">Cena mus\xed b\xfdt v\u{11B}t\u{161}\xed ne\u{17E} 0 K\u{10D}</div>
                </div>
                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-2">Skladem (ks)</label>
                  <input type="number" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" id="materialStock" min="0" value="0" placeholder="0">
                  <div class="text-red-500 text-sm mt-1 hidden" id="materialStockError">Skladov\xe9 mno\u{17E}stv\xed mus\xed b\xfdt 0 nebo v\xedce</div>
                </div>
                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-2">Gram\xe1\u{17E} (g/m\xb2)</label>
                  <input type="number" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" id="materialWeight" min="10" max="1000" required placeholder="80">
                  <div class="text-red-500 text-sm mt-1 hidden" id="materialWeightError">Gram\xe1\u{17E} mus\xed b\xfdt mezi 10-1000 g/m\xb2</div>
                </div>
                <div class="grid grid-cols-2 gap-3">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">\u{160}\xed\u{159}ka (mm)</label>
                    <input type="number" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" id="materialWidth" value="650" min="100" max="5000" required>
                    <div class="text-red-500 text-sm mt-1 hidden" id="materialWidthError">\u{160}\xed\u{159}ka mus\xed b\xfdt 100-5000 mm</div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">V\xfd\u{161}ka (mm)</label>
                    <input type="number" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" id="materialHeight" value="480" min="100" max="5000" required>
                    <div class="text-red-500 text-sm mt-1 hidden" id="materialHeightError">V\xfd\u{161}ka mus\xed b\xfdt 100-5000 mm</div>
                  </div>
                </div>
                <div class="mb-4">
                  <div class="flex items-center">
                    <input type="checkbox" id="materialCanFlip" checked class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded">
                    <label class="ml-2 text-sm text-gray-700" for="materialCanFlip">
                      Umo\u{17E}nit obr\xe1tku
                    </label>
                  </div>
                </div>
              </form>
            </div>
            <div class="px-6 py-4 border-t border-gray-200 flex justify-end space-x-3">
              <button type="button" class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" id="modal-cancel-btn">Zru\u{161}it</button>
              <button type="button" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" onclick="materialsAdmin.addMaterial()">P\u{159}idat</button>
            </div>
          </div>
        </div>
      </div>
    `;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
        // Nastavit validaci pro formulář
        this.setupFormValidation();
    }
    setupFormValidation() {
        const fields = [
            {
                id: 'materialName',
                errorId: 'materialNameError',
                validation: (value)=>value.length >= 2
            },
            {
                id: 'materialPrice',
                errorId: 'materialPriceError',
                validation: (value)=>parseFloat(value) > 0
            },
            {
                id: 'materialStock',
                errorId: 'materialStockError',
                validation: (value)=>parseInt(value) >= 0
            },
            {
                id: 'materialWeight',
                errorId: 'materialWeightError',
                validation: (value)=>parseInt(value) >= 10 && parseInt(value) <= 1000
            },
            {
                id: 'materialWidth',
                errorId: 'materialWidthError',
                validation: (value)=>parseInt(value) >= 100 && parseInt(value) <= 5000
            },
            {
                id: 'materialHeight',
                errorId: 'materialHeightError',
                validation: (value)=>parseInt(value) >= 100 && parseInt(value) <= 5000
            }
        ];
        fields.forEach((field)=>{
            const input = document.getElementById(field.id);
            const errorDiv = document.getElementById(field.errorId);
            if (input && errorDiv) {
                // Validace při blur (opuštění pole)
                input.addEventListener('blur', ()=>{
                    const isValid = field.validation(input.value);
                    if (!isValid && input.value !== '') {
                        errorDiv.classList.remove('hidden');
                        input.classList.add('border-red-500');
                        input.classList.remove('border-gray-300');
                    } else {
                        errorDiv.classList.add('hidden');
                        input.classList.remove('border-red-500');
                        input.classList.add('border-gray-300');
                    }
                });
                // Skrýt chybu při začátku psaní
                input.addEventListener('input', ()=>{
                    if (!errorDiv.classList.contains('hidden')) {
                        const isValid = field.validation(input.value);
                        if (isValid) {
                            errorDiv.classList.add('hidden');
                            input.classList.remove('border-red-500');
                            input.classList.add('border-gray-300');
                        }
                    }
                });
            }
        });
    }
    async addMaterial() {
        const form = document.getElementById('addMaterialForm');
        // Kontrola HTML5 validace
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }
        const materialData = {
            name: document.getElementById('materialName').value.trim(),
            price: parseFloat(document.getElementById('materialPrice').value),
            skladem: parseInt(document.getElementById('materialStock').value),
            weight: parseInt(document.getElementById('materialWeight').value),
            width: parseInt(document.getElementById('materialWidth').value),
            height: parseInt(document.getElementById('materialHeight').value),
            canFlip: document.getElementById('materialCanFlip').checked
        };
        const categoryId = document.getElementById('materialCategory').value;
        // Detailní validace
        const validationErrors = [];
        if (!categoryId) validationErrors.push("Vyberte kategorii materi\xe1lu");
        if (!materialData.name || materialData.name.length < 2) validationErrors.push("N\xe1zev mus\xed m\xedt alespo\u0148 2 znaky");
        if (!materialData.price || materialData.price <= 0) validationErrors.push("Cena mus\xed b\xfdt v\u011Bt\u0161\xed ne\u017E 0 K\u010D");
        if (materialData.skladem < 0) validationErrors.push("Skladov\xe9 mno\u017Estv\xed mus\xed b\xfdt 0 nebo v\xedce");
        if (!materialData.weight || materialData.weight < 10 || materialData.weight > 1000) validationErrors.push("Gram\xe1\u017E mus\xed b\xfdt mezi 10-1000 g/m\xb2");
        if (!materialData.width || materialData.width < 100 || materialData.width > 5000) validationErrors.push("\u0160\xed\u0159ka mus\xed b\xfdt mezi 100-5000 mm");
        if (!materialData.height || materialData.height < 100 || materialData.height > 5000) validationErrors.push("V\xfd\u0161ka mus\xed b\xfdt mezi 100-5000 mm");
        if (validationErrors.length > 0) {
            this.showError("Opravte n\xe1sleduj\xedc\xed chyby:\n\u2022 " + validationErrors.join("\n\u2022 "));
            return;
        }
        try {
            const response = await fetch(`${this.baseUrl}/materials/${categoryId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify(materialData)
            });
            const result = await response.json();
            if (result.success) {
                this.showSuccess("Materi\xe1l byl \xfasp\u011B\u0161n\u011B p\u0159id\xe1n");
                const tailwindModal = new TailwindModal('addMaterialModal');
                tailwindModal.hide();
                form.reset();
                await this.loadMaterials();
                this.renderMaterials();
                // Aktualizovat formulář
                this.updateMaterialsForm();
            } else throw new Error(result.error);
        } catch (error) {
            console.error("Chyba p\u0159i p\u0159id\xe1v\xe1n\xed materi\xe1lu:", error);
            this.showError("Chyba p\u0159i p\u0159id\xe1v\xe1n\xed materi\xe1lu");
        }
    }
    async deleteMaterial(categoryId, materialId) {
        if (!confirm("Opravdu chcete smazat tento materi\xe1l?")) return;
        try {
            const response = await fetch(`${this.baseUrl}/materials/${categoryId}/${materialId}`, {
                method: 'DELETE',
                credentials: 'include'
            });
            const result = await response.json();
            if (result.success) {
                this.showSuccess("Materi\xe1l byl \xfasp\u011B\u0161n\u011B smaz\xe1n");
                await this.loadMaterials();
                this.renderMaterials();
                // Aktualizovat formulář
                this.updateMaterialsForm();
            } else throw new Error(result.error);
        } catch (error) {
            console.error("Chyba p\u0159i maz\xe1n\xed materi\xe1lu:", error);
            this.showError("Chyba p\u0159i maz\xe1n\xed materi\xe1lu");
        }
    }
    async exportMaterials(format = 'csv') {
        try {
            const response = await fetch(`${this.baseUrl}/materials/export?format=${format}`);
            if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            // Nastavení názvu souboru podle formátu
            const fileExtension = format === 'csv' ? 'csv' : 'json';
            const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
            a.download = `materials-export-${timestamp}.${fileExtension}`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            const formatName = format === 'csv' ? 'CSV' : 'JSON';
            this.showSuccess(`Data byla exportov\xe1na do ${formatName} souboru`);
        } catch (error) {
            console.error("Chyba p\u0159i exportu:", error);
            this.showError("Chyba p\u0159i exportu dat: " + error.message);
        }
    }
    // Nová funkce pro zobrazení modalu s výběrem formátu exportu
    showExportModal() {
        const modalHtml = `
      <div class="fixed inset-0 z-50 overflow-y-auto hidden" id="exportModal" aria-labelledby="exportModalLabel" aria-hidden="true">
        <div class="flex items-center justify-center min-h-screen px-4">
          <div class="fixed inset-0 bg-black opacity-50" id="modal-backdrop"></div>
          <div class="bg-white rounded-lg shadow-xl max-w-md w-full relative">
            <div class="px-6 py-4 border-b border-gray-200">
              <h3 class="text-lg font-medium text-gray-900" id="exportModalLabel">Export materi\xe1l\u{16F}</h3>
              <button type="button" class="absolute top-4 right-4 text-gray-400 hover:text-gray-600" id="modal-close-btn">
                ${(0, $entK4.icon)('x-mark', 'h-6 w-6')}
              </button>
            </div>
            <div class="px-6 py-4">
              <p class="text-sm text-gray-600 mb-4">Vyberte form\xe1t pro export materi\xe1l\u{16F}:</p>
              
              <div class="space-y-3">
                <label class="flex items-center p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer">
                  <input type="radio" name="exportFormat" value="csv" checked class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300">
                  <div class="ml-3">
                    <div class="font-medium text-gray-900">CSV soubor</div>
                    <div class="text-sm text-gray-500">Vhodn\xe9 pro Excel a tabulkov\xe9 procesory</div>
                  </div>
                </label>
                
                <label class="flex items-center p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer">
                  <input type="radio" name="exportFormat" value="json" class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300">
                  <div class="ml-3">
                    <div class="font-medium text-gray-900">JSON soubor</div>
                    <div class="text-sm text-gray-500">Zachov\xe1v\xe1 kompletn\xed strukturu dat</div>
                  </div>
                </label>
              </div>
            </div>
            <div class="px-6 py-4 border-t border-gray-200 flex justify-end space-x-3">
              <button type="button" class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" id="modal-cancel-btn">Zru\u{161}it</button>
              <button type="button" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" onclick="materialsAdmin.executeExport()">Exportovat</button>
            </div>
          </div>
        </div>
      </div>
    `;
        // Odebrání existujícího modalu
        const existingModal = document.getElementById('exportModal');
        if (existingModal) existingModal.remove();
        document.body.insertAdjacentHTML('beforeend', modalHtml);
        const tailwindModal = new TailwindModal('exportModal');
        tailwindModal.show();
    }
    executeExport() {
        const selectedFormat = document.querySelector('input[name="exportFormat"]:checked').value;
        const tailwindModal = new TailwindModal('exportModal');
        tailwindModal.hide();
        this.exportMaterials(selectedFormat);
    }
    showImportModal() {
        // Implementace import modalu
        const modalHtml = `
      <div class="fixed inset-0 z-50 overflow-y-auto hidden" id="importModal" aria-labelledby="importModalLabel" aria-hidden="true">
        <div class="flex items-center justify-center min-h-screen px-4">
          <div class="fixed inset-0 bg-black opacity-50" id="modal-backdrop"></div>
          <div class="bg-white rounded-lg shadow-xl max-w-lg w-full relative">
            <div class="px-6 py-4 border-b border-gray-200">
              <h3 class="text-lg font-medium text-gray-900" id="importModalLabel">Import materi\xe1l\u{16F}</h3>
              <button type="button" class="absolute top-4 right-4 text-gray-400 hover:text-gray-600" id="modal-close-btn">
                ${(0, $entK4.icon)('x-mark', 'h-6 w-6')}
              </button>
            </div>
            <div class="px-6 py-4">
              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">Vyberte soubor</label>
                <input type="file" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" id="importFile" accept=".csv,.json">
                <p class="mt-2 text-sm text-gray-500">Podporovan\xe9 form\xe1ty: CSV a JSON</p>
              </div>
              
              <div class="bg-blue-50 border border-blue-200 rounded-md p-3 mb-4">
                <h4 class="text-sm font-medium text-blue-800 mb-2">Form\xe1t CSV souboru:</h4>
                <p class="text-xs text-blue-700">
                  Soubor mus\xed obsahovat sloupce: Kategorie, N\xe1zev, Cena (K\u{10D}), Skladem, Gram\xe1\u{17E} (g/m\xb2), \u{160}\xed\u{159}ka (mm), V\xfd\u{161}ka (mm), Obr\xe1tka<br>
                  Odd\u{11B}lova\u{10D}: st\u{159}edn\xedk (;)<br>
                  K\xf3dov\xe1n\xed: UTF-8
                </p>
              </div>
              
              <div class="bg-yellow-50 border border-yellow-200 rounded-md p-3">
                <div class="flex">
                  ${(0, $entK4.icon)('exclamation-triangle', 'flex-shrink-0 h-5 w-5 text-yellow-400')}
                  <div class="ml-3">
                    <h3 class="text-sm font-medium text-yellow-800">Upozorn\u{11B}n\xed</h3>
                    <div class="mt-2 text-sm text-yellow-700">
                      Import nahrad\xed v\u{161}echny st\xe1vaj\xedc\xed materi\xe1ly. Doporu\u{10D}ujeme nejprve vyexportovat z\xe1lohu.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="px-6 py-4 border-t border-gray-200 flex justify-end space-x-3">
              <button type="button" class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" id="modal-cancel-btn">Zru\u{161}it</button>
              <button type="button" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" onclick="materialsAdmin.importMaterials()">Importovat</button>
            </div>
          </div>
        </div>
      </div>
    `;
        // Odebrání existujícího modalu
        const existingModal = document.getElementById('importModal');
        if (existingModal) existingModal.remove();
        document.body.insertAdjacentHTML('beforeend', modalHtml);
        const tailwindModal = new TailwindModal('importModal');
        tailwindModal.show();
    }
    async importMaterials() {
        const fileInput = document.getElementById('importFile');
        const file = fileInput.files[0];
        if (!file) {
            this.showError('Vyberte soubor');
            return;
        }
        try {
            const text = await file.text();
            const fileExtension = file.name.split('.').pop().toLowerCase();
            let requestHeaders = {};
            let requestBody;
            let endpoint;
            if (fileExtension === 'csv') {
                // CSV import - specializovaný endpoint
                requestHeaders['Content-Type'] = 'text/csv; charset=utf-8';
                requestBody = text;
                endpoint = `${this.baseUrl}/materials/import-csv`;
            } else // JSON import (zpětná kompatibilita)
            try {
                const data = JSON.parse(text);
                requestHeaders['Content-Type'] = 'application/json';
                requestBody = JSON.stringify(data);
                endpoint = `${this.baseUrl}/materials/import`;
            } catch (parseError) {
                this.showError("Neplatn\xfd JSON form\xe1t souboru");
                return;
            }
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: requestHeaders,
                credentials: 'include',
                body: requestBody
            });
            const result = await response.json();
            if (result.success) {
                const formatName = fileExtension === 'csv' ? 'CSV' : 'JSON';
                this.showSuccess(`Data byla \xfasp\u{11B}\u{161}n\u{11B} importov\xe1na z ${formatName} souboru`);
                const tailwindModal = new TailwindModal('importModal');
                tailwindModal.hide();
                await this.loadMaterials();
                this.renderMaterials();
                // Aktualizovat formulář
                this.updateMaterialsForm();
            } else throw new Error(result.error);
        } catch (error) {
            console.error("Chyba p\u0159i importu:", error);
            this.showError("Chyba p\u0159i importu dat: " + error.message);
        }
    }
    showSuccess(message) {
        this.showToast(message, 'success');
    }
    showError(message) {
        this.showToast(message, 'error');
    }
    showToast(message, type) {
        // Jednoduchý toast systém
        const toastContainer = document.getElementById('toast-container') || this.createToastContainer();
        const toast = document.createElement('div');
        const bgColor = type === 'success' ? 'bg-green-50 border-green-200 text-green-800' : 'bg-red-50 border-red-200 text-red-800';
        toast.className = `border rounded-md p-4 mb-2 ${bgColor} flex items-center justify-between`;
        toast.innerHTML = `
      <span>${message}</span>
      <button type="button" class="text-gray-400 hover:text-gray-600" onclick="this.parentElement.remove()">
        ${(0, $entK4.icon)('x-mark', 'h-4 w-4')}
      </button>
    `;
        toastContainer.appendChild(toast);
        // Automatické odstranění po 5 sekundách
        setTimeout(()=>{
            if (toast.parentNode) toast.parentNode.removeChild(toast);
        }, 5000);
    }
    createToastContainer() {
        const container = document.createElement('div');
        container.id = 'toast-container';
        container.style.position = 'fixed';
        container.style.top = '20px';
        container.style.right = '20px';
        container.style.zIndex = '9999';
        document.body.appendChild(container);
        return container;
    }
    // Upravit materiál
    editMaterial(categoryId, materialId) {
        try {
            // Najdeme materiál podle categoryId a materialId
            const material = this.materials[categoryId]?.find((m)=>m.id === materialId);
            if (!material) {
                this.showError("Materi\xe1l nebyl nalezen.");
                return;
            }
            // Vytvoříme/otevřeme edit modal
            const modal = document.getElementById('editMaterialModal');
            if (!modal) this.createEditMaterialModal();
            // Předvyplníme formulář
            this.populateEditForm(material, categoryId);
            const tailwindModal = new TailwindModal('editMaterialModal');
            tailwindModal.show();
        } catch (error) {
            console.error("Chyba p\u0159i otev\xedr\xe1n\xed edita\u010Dn\xedho modalu:", error);
            this.showError("Chyba p\u0159i otev\xedr\xe1n\xed formul\xe1\u0159e pro \xfapravu materi\xe1lu.");
        }
    }
    // Smazat materiál
    async deleteMaterial(categoryId, materialId) {
        try {
            const material = this.materials[categoryId]?.find((m)=>m.id === materialId);
            if (!material) {
                this.showError("Materi\xe1l nebyl nalezen.");
                return;
            }
            if (!confirm(`Opravdu chcete smazat materi\xe1l "${material.name}"?`)) return;
            const response = await fetch(`${this.baseUrl}/materials/${categoryId}/${materialId}`, {
                method: 'DELETE',
                credentials: 'include'
            });
            const result = await response.json();
            if (result.success) {
                this.showSuccess("Materi\xe1l byl \xfasp\u011B\u0161n\u011B smaz\xe1n.");
                await this.loadMaterials();
                this.renderMaterials();
            } else throw new Error(result.error);
        } catch (error) {
            console.error("Chyba p\u0159i maz\xe1n\xed materi\xe1lu:", error);
            this.showError("Chyba p\u0159i maz\xe1n\xed materi\xe1lu: " + error.message);
        }
    }
    // Vytvořit edit modal
    createEditMaterialModal() {
        const modalHtml = `
      <div class="fixed inset-0 z-50 overflow-y-auto hidden" id="editMaterialModal" aria-labelledby="editMaterialModalLabel" aria-hidden="true">
        <div class="flex items-center justify-center min-h-screen px-4">
          <div class="fixed inset-0 bg-black opacity-50" id="modal-backdrop"></div>
          <div class="bg-white rounded-lg shadow-xl max-w-lg w-full relative">
            <div class="px-6 py-4 border-b border-gray-200">
              <h3 class="text-lg font-medium text-gray-900" id="editMaterialModalLabel">Upravit materi\xe1l</h3>
              <button type="button" class="absolute top-4 right-4 text-gray-400 hover:text-gray-600" id="modal-close-btn">
                ${(0, $entK4.icon)('x-mark', 'h-6 w-6')}
              </button>
            </div>
            <div class="px-6 py-4">
              <form id="editMaterialForm">
                <input type="hidden" id="editMaterialId" name="materialId">
                <input type="hidden" id="editCategoryId" name="categoryId">
                
                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-2">Kategorie</label>
                  <select class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-white" id="editMaterialCategory" required>
                    <option value="">Vyberte kategorii</option>
                    <option value="ofset">Ofsetov\xfd pap\xedr</option>
                    <option value="laserova">Do laserov\xe9 tisk\xe1rny</option>
                    <option value="krida-leskla">Leskl\xe1 k\u{159}\xedda</option>
                    <option value="krida-matna">Matn\xe1 k\u{159}\xedda</option>
                    <option value="recyklovane">Recyklovan\xe9 a ekologick\xe9 pap\xedry</option>
                    <option value="lepenky">Lepenky</option>
                    <option value="samolepici">Samolep\xedc\xed pap\xedry</option>
                    <option value="kartony">Kart\xf3ny</option>
                    <option value="specialni">Speci\xe1ln\xed grafick\xe9 pap\xedry</option>
                  </select>
                </div>
                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-2">N\xe1zev</label>
                  <input type="text" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" id="editMaterialName" required>
                </div>
                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-2">Cena (K\u{10D})</label>
                  <input type="number" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" id="editMaterialPrice" step="0.01" min="0" required>
                </div>
                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-2">Skladem (ks)</label>
                  <input type="number" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" id="editMaterialStock" min="0" value="0">
                </div>
                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-2">Gram\xe1\u{17E} (g/m\xb2)</label>
                  <input type="number" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" id="editMaterialWeight" min="1" required>
                </div>
                <div class="grid grid-cols-2 gap-3">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">\u{160}\xed\u{159}ka (mm)</label>
                    <input type="number" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" id="editMaterialWidth" min="1" required>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">V\xfd\u{161}ka (mm)</label>
                    <input type="number" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" id="editMaterialHeight" min="1" required>
                  </div>
                </div>
                <div class="mb-4">
                  <div class="flex items-center">
                    <input type="checkbox" id="editMaterialCanFlip" class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded">
                    <label class="ml-2 text-sm text-gray-700" for="editMaterialCanFlip">
                      Umo\u{17E}nit obr\xe1tku
                    </label>
                  </div>
                </div>
              </form>
            </div>
            <div class="px-6 py-4 border-t border-gray-200 flex justify-end space-x-3">
              <button type="button" class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" id="modal-cancel-btn">Zru\u{161}it</button>
              <button type="button" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" onclick="materialsAdmin.updateMaterial()">Ulo\u{17E}it zm\u{11B}ny</button>
            </div>
          </div>
        </div>
      </div>
    `;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
    }
    // Předvyplnit edit formulář
    populateEditForm(material, categoryId) {
        document.getElementById('editMaterialId').value = material.id;
        document.getElementById('editCategoryId').value = categoryId;
        document.getElementById('editMaterialCategory').value = categoryId;
        document.getElementById('editMaterialName').value = material.name;
        document.getElementById('editMaterialPrice').value = material.price;
        document.getElementById('editMaterialStock').value = material.skladem || 0;
        document.getElementById('editMaterialWeight').value = material.weight;
        document.getElementById('editMaterialWidth').value = material.width;
        document.getElementById('editMaterialHeight').value = material.height;
        document.getElementById('editMaterialCanFlip').checked = material.canFlip;
    }
    // Aktualizovat materiál
    async updateMaterial() {
        try {
            const materialId = document.getElementById('editMaterialId').value;
            const oldCategoryId = document.getElementById('editCategoryId').value;
            const newCategoryId = document.getElementById('editMaterialCategory').value;
            const materialData = {
                id: materialId,
                name: document.getElementById('editMaterialName').value,
                price: parseFloat(document.getElementById('editMaterialPrice').value),
                skladem: parseInt(document.getElementById('editMaterialStock').value),
                weight: parseInt(document.getElementById('editMaterialWeight').value),
                width: parseInt(document.getElementById('editMaterialWidth').value),
                height: parseInt(document.getElementById('editMaterialHeight').value),
                canFlip: document.getElementById('editMaterialCanFlip').checked
            };
            // Validace
            if (!materialData.name || materialData.price < 0 || materialData.weight < 1 || materialData.width < 1 || materialData.height < 1) {
                this.showError("Pros\xedm vypl\u0148te v\u0161echna povinn\xe1 pole spr\xe1vn\u011B.");
                return;
            }
            // Pokud se změnila kategorie, potřebujeme smazat z původní a přidat do nové
            if (oldCategoryId !== newCategoryId) {
                // Smazat z původní kategorie
                await fetch(`${this.baseUrl}/materials/${oldCategoryId}/${materialId}`, {
                    method: 'DELETE',
                    credentials: 'include'
                });
                // Přidat do nové kategorie
                const response = await fetch(`${this.baseUrl}/materials/${newCategoryId}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include',
                    body: JSON.stringify(materialData)
                });
                const result = await response.json();
                if (result.success) this.showSuccess("Materi\xe1l byl \xfasp\u011B\u0161n\u011B p\u0159esunut do nov\xe9 kategorie a aktualizov\xe1n.");
                else throw new Error(result.error);
            } else {
                // Aktualizovat ve stejné kategorii
                const response = await fetch(`${this.baseUrl}/materials/${oldCategoryId}/${materialId}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include',
                    body: JSON.stringify(materialData)
                });
                const result = await response.json();
                if (result.success) this.showSuccess("Materi\xe1l byl \xfasp\u011B\u0161n\u011B aktualizov\xe1n.");
                else throw new Error(result.error);
            }
            // Zavřít modal
            const tailwindModal = new TailwindModal('editMaterialModal');
            tailwindModal.hide();
            // Znovu načíst a zobrazit materiály
            await this.loadMaterials();
            this.renderMaterials();
            // Aktualizovat formulář
            this.updateMaterialsForm();
        } catch (error) {
            console.error("Chyba p\u0159i aktualizaci materi\xe1lu:", error);
            this.showError("Chyba p\u0159i aktualizaci materi\xe1lu: " + error.message);
        }
    }
    // Inicializace tooltipů
    initTooltips() {
    // Tooltip funkcionalita bude implementována později s Tailwind
    // Prozatím ponecháme prázdné
    }
    // Funkce pro aktualizaci formuláře materiálů
    updateMaterialsForm() {
        if (typeof window.loadMaterialsToForm === 'function') window.loadMaterialsToForm();
        else // Fallback - pokud funkce není dostupná, aktualizujeme přímo
        this.renderMaterialsToSelect();
    }
    // Funkce pro renderování materiálů do select elementu (fallback)
    renderMaterialsToSelect() {
        const select = document.getElementById('material');
        if (!select) return;
        // Zjistím aktuálně vybranou hodnotu
        const selectedValue = select.value;
        // Vyčistím select
        select.innerHTML = '';
        // Kategorie a jejich názvy
        const categoryNames = {
            'ofset': "Ofsetov\xfd pap\xedr",
            'laserova': "Do laserov\xe9 tisk\xe1rny",
            'krida-leskla': "Leskl\xe1 k\u0159\xedda",
            'krida-matna': "Matn\xe1 k\u0159\xedda",
            'recyklovane': "Recyklovan\xe9 a ekologick\xe9 pap\xedry",
            'lepenky': 'Lepenky',
            'samolepici': "Samolep\xedc\xed pap\xedry",
            'kartony': "Kart\xf3ny",
            'specialni': "Speci\xe1ln\xed grafick\xe9 pap\xedry"
        };
        // Pořadí kategorií
        const categoryOrder = [
            'ofset',
            'laserova',
            'krida-leskla',
            'krida-matna',
            'recyklovane',
            'lepenky',
            'samolepici',
            'kartony',
            'specialni'
        ];
        // Vytvořím optgroup pro každou kategorii
        categoryOrder.forEach((categoryId)=>{
            const categoryMaterials = this.materials[categoryId];
            if (!categoryMaterials || categoryMaterials.length === 0) return;
            const optgroup = document.createElement('optgroup');
            optgroup.label = categoryNames[categoryId];
            categoryMaterials.forEach((material)=>{
                const option = document.createElement('option');
                option.value = material.price;
                option.textContent = material.name;
                option.setAttribute('data-obratka', material.canFlip ? '1' : '0');
                option.setAttribute('data-gramaz', material.weight);
                option.setAttribute('data-vyska', material.width); // Pozor: width je výška archu
                option.setAttribute('data-sirka', material.height); // Pozor: height je šířka archu
                // Pokud je to stejná hodnota jako předchozí selected, označím jako selected
                if (selectedValue && selectedValue === material.price.toString()) option.selected = true;
                optgroup.appendChild(option);
            });
            select.appendChild(optgroup);
        });
        // Přidám možnost "Vlastní materiál" na konec
        const customOption = document.createElement('option');
        customOption.value = 'vlastni';
        customOption.textContent = "Vlastn\xed materi\xe1l";
        customOption.setAttribute('data-obratka', '1');
        customOption.setAttribute('data-gramaz', '200');
        customOption.setAttribute('data-vyska', '650');
        customOption.setAttribute('data-sirka', '480');
        select.appendChild(customOption);
        // Pokud nebyla žádná hodnota vybrána, vyberu výchozí (Ofset 80 g/m²)
        if (!selectedValue) {
            const defaultOption = select.querySelector('option[value="1.43"]');
            if (defaultOption) defaultOption.selected = true;
        }
    }
}


// Modul pro správu položek nabídky (složené kalkulace)
/**!
 * Sortable 1.15.6
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $dbec57966acc54fe$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dbec57966acc54fe$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dbec57966acc54fe$var$ownKeys(Object(source), true).forEach(function(key) {
            $dbec57966acc54fe$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dbec57966acc54fe$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dbec57966acc54fe$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $dbec57966acc54fe$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $dbec57966acc54fe$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $dbec57966acc54fe$var$_typeof(obj);
}
function $dbec57966acc54fe$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dbec57966acc54fe$var$_extends() {
    $dbec57966acc54fe$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dbec57966acc54fe$var$_extends.apply(this, arguments);
}
function $dbec57966acc54fe$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $dbec57966acc54fe$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $dbec57966acc54fe$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $dbec57966acc54fe$var$_toConsumableArray(arr) {
    return $dbec57966acc54fe$var$_arrayWithoutHoles(arr) || $dbec57966acc54fe$var$_iterableToArray(arr) || $dbec57966acc54fe$var$_unsupportedIterableToArray(arr) || $dbec57966acc54fe$var$_nonIterableSpread();
}
function $dbec57966acc54fe$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $dbec57966acc54fe$var$_arrayLikeToArray(arr);
}
function $dbec57966acc54fe$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $dbec57966acc54fe$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dbec57966acc54fe$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dbec57966acc54fe$var$_arrayLikeToArray(o, minLen);
}
function $dbec57966acc54fe$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dbec57966acc54fe$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $dbec57966acc54fe$var$version = "1.15.6";
function $dbec57966acc54fe$var$userAgent(pattern) {
    if (typeof window !== 'undefined' && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $dbec57966acc54fe$var$IE11OrLess = $dbec57966acc54fe$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $dbec57966acc54fe$var$Edge = $dbec57966acc54fe$var$userAgent(/Edge/i);
var $dbec57966acc54fe$var$FireFox = $dbec57966acc54fe$var$userAgent(/firefox/i);
var $dbec57966acc54fe$var$Safari = $dbec57966acc54fe$var$userAgent(/safari/i) && !$dbec57966acc54fe$var$userAgent(/chrome/i) && !$dbec57966acc54fe$var$userAgent(/android/i);
var $dbec57966acc54fe$var$IOS = $dbec57966acc54fe$var$userAgent(/iP(ad|od|hone)/i);
var $dbec57966acc54fe$var$ChromeForAndroid = $dbec57966acc54fe$var$userAgent(/chrome/i) && $dbec57966acc54fe$var$userAgent(/android/i);
var $dbec57966acc54fe$var$captureMode = {
    capture: false,
    passive: false
};
function $dbec57966acc54fe$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$dbec57966acc54fe$var$IE11OrLess && $dbec57966acc54fe$var$captureMode);
}
function $dbec57966acc54fe$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$dbec57966acc54fe$var$IE11OrLess && $dbec57966acc54fe$var$captureMode);
}
function $dbec57966acc54fe$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === '>' && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $dbec57966acc54fe$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $dbec57966acc54fe$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && $dbec57966acc54fe$var$matches(el, selector) : $dbec57966acc54fe$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $dbec57966acc54fe$var$getParentOrHost(el));
    }
    return null;
}
var $dbec57966acc54fe$var$R_SPACE = /\s+/g;
function $dbec57966acc54fe$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? 'add' : 'remove'](name);
        else {
            var className = (' ' + el.className + ' ').replace($dbec57966acc54fe$var$R_SPACE, ' ').replace(' ' + name + ' ', ' ');
            el.className = (className + (state ? ' ' + name : '')).replace($dbec57966acc54fe$var$R_SPACE, ' ');
        }
    }
}
function $dbec57966acc54fe$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, '');
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf('webkit') === -1) prop = '-webkit-' + prop;
            style[prop] = val + (typeof val === 'string' ? '' : 'px');
        }
    }
}
function $dbec57966acc54fe$var$matrix(el, selfOnly) {
    var appliedTransforms = '';
    if (typeof el === 'string') appliedTransforms = el;
    else do {
        var transform = $dbec57966acc54fe$var$css(el, 'transform');
        if (transform && transform !== 'none') appliedTransforms = transform + ' ' + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $dbec57966acc54fe$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $dbec57966acc54fe$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $dbec57966acc54fe$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $dbec57966acc54fe$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode;
        // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$dbec57966acc54fe$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($dbec57966acc54fe$var$css(container, 'transform') !== 'none' || relativeToNonStaticParent && $dbec57966acc54fe$var$css(container, 'position') !== 'static')) {
                var containerRect = container.getBoundingClientRect();
                // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($dbec57966acc54fe$var$css(container, 'border-top-width'));
                left -= containerRect.left + parseInt($dbec57966acc54fe$var$css(container, 'border-left-width'));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $dbec57966acc54fe$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $dbec57966acc54fe$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $dbec57966acc54fe$var$getParentAutoScrollElement(el, true), elSideVal = $dbec57966acc54fe$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $dbec57966acc54fe$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === 'top' || parentSide === 'left') visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $dbec57966acc54fe$var$getWindowScrollingElement()) break;
        parent = $dbec57966acc54fe$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $dbec57966acc54fe$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== 'none' && children[i] !== $dbec57966acc54fe$export$31b3ca70d8f57423.ghost && (includeDragEl || children[i] !== $dbec57966acc54fe$export$31b3ca70d8f57423.dragged) && $dbec57966acc54fe$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $dbec57966acc54fe$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $dbec57966acc54fe$export$31b3ca70d8f57423.ghost || $dbec57966acc54fe$var$css(last, 'display') === 'none' || selector && !$dbec57966acc54fe$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $dbec57966acc54fe$var$index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== $dbec57966acc54fe$export$31b3ca70d8f57423.clone && (!selector || $dbec57966acc54fe$var$matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $dbec57966acc54fe$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $dbec57966acc54fe$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $dbec57966acc54fe$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $dbec57966acc54fe$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $dbec57966acc54fe$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $dbec57966acc54fe$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $dbec57966acc54fe$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
            if (!elem.getBoundingClientRect || elem === document.body) return $dbec57966acc54fe$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $dbec57966acc54fe$var$getWindowScrollingElement();
}
function $dbec57966acc54fe$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $dbec57966acc54fe$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $dbec57966acc54fe$var$_throttleTimeout;
function $dbec57966acc54fe$var$throttle(callback, ms) {
    return function() {
        if (!$dbec57966acc54fe$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $dbec57966acc54fe$var$_throttleTimeout = setTimeout(function() {
                $dbec57966acc54fe$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $dbec57966acc54fe$var$cancelThrottle() {
    clearTimeout($dbec57966acc54fe$var$_throttleTimeout);
    $dbec57966acc54fe$var$_throttleTimeout = void 0;
}
function $dbec57966acc54fe$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $dbec57966acc54fe$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $dbec57966acc54fe$var$setRect(el, rect) {
    $dbec57966acc54fe$var$css(el, 'position', 'absolute');
    $dbec57966acc54fe$var$css(el, 'top', rect.top);
    $dbec57966acc54fe$var$css(el, 'left', rect.left);
    $dbec57966acc54fe$var$css(el, 'width', rect.width);
    $dbec57966acc54fe$var$css(el, 'height', rect.height);
}
function $dbec57966acc54fe$var$unsetRect(el) {
    $dbec57966acc54fe$var$css(el, 'position', '');
    $dbec57966acc54fe$var$css(el, 'top', '');
    $dbec57966acc54fe$var$css(el, 'left', '');
    $dbec57966acc54fe$var$css(el, 'width', '');
    $dbec57966acc54fe$var$css(el, 'height', '');
}
function $dbec57966acc54fe$var$getChildContainingRectFromElement(container, options, ghostEl) {
    var rect = {};
    Array.from(container.children).forEach(function(child) {
        var _rect$left, _rect$top, _rect$right, _rect$bottom;
        if (!$dbec57966acc54fe$var$closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
        var childRect = $dbec57966acc54fe$var$getRect(child);
        rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
        rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
        rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
        rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
    });
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
var $dbec57966acc54fe$var$expando = 'Sortable' + new Date().getTime();
function $dbec57966acc54fe$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($dbec57966acc54fe$var$css(child, 'display') === 'none' || child === $dbec57966acc54fe$export$31b3ca70d8f57423.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $dbec57966acc54fe$var$getRect(child)
                });
                var fromRect = $dbec57966acc54fe$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect);
                // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $dbec57966acc54fe$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($dbec57966acc54fe$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === 'function') callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $dbec57966acc54fe$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $dbec57966acc54fe$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($dbec57966acc54fe$var$isRectEqual(prevFromRect, toRect) && !$dbec57966acc54fe$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $dbec57966acc54fe$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                }
                // if fromRect != toRect: animate
                if (!$dbec57966acc54fe$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === 'function') callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === 'function') callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $dbec57966acc54fe$var$css(target, 'transition', '');
                $dbec57966acc54fe$var$css(target, 'transform', '');
                var elMatrix = $dbec57966acc54fe$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $dbec57966acc54fe$var$css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
                this.forRepaintDummy = $dbec57966acc54fe$var$repaint(target); // repaint
                $dbec57966acc54fe$var$css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
                $dbec57966acc54fe$var$css(target, 'transform', 'translate3d(0,0,0)');
                typeof target.animated === 'number' && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $dbec57966acc54fe$var$css(target, 'transition', '');
                    $dbec57966acc54fe$var$css(target, 'transform', '');
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $dbec57966acc54fe$var$repaint(target) {
    return target.offsetWidth;
}
function $dbec57966acc54fe$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $dbec57966acc54fe$var$plugins = [];
var $dbec57966acc54fe$var$defaults = {
    initializeByDefault: true
};
var $dbec57966acc54fe$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $dbec57966acc54fe$var$defaults)if ($dbec57966acc54fe$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $dbec57966acc54fe$var$defaults[option];
        $dbec57966acc54fe$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $dbec57966acc54fe$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + 'Global';
        $dbec57966acc54fe$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return;
            // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($dbec57966acc54fe$var$_objectSpread2({
                sortable: sortable
            }, evt));
            // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($dbec57966acc54fe$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $dbec57966acc54fe$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized;
            // Add default options from plugin
            $dbec57966acc54fe$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== 'undefined') sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $dbec57966acc54fe$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== 'function') return;
            $dbec57966acc54fe$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $dbec57966acc54fe$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return;
            // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $dbec57966acc54fe$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$dbec57966acc54fe$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$dbec57966acc54fe$var$IE11OrLess && !$dbec57966acc54fe$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent('Event');
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $dbec57966acc54fe$var$_objectSpread2($dbec57966acc54fe$var$_objectSpread2({}, extraEventProperties), $dbec57966acc54fe$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $dbec57966acc54fe$var$_excluded = [
    "evt"
];
var $dbec57966acc54fe$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $dbec57966acc54fe$var$_objectWithoutProperties(_ref, $dbec57966acc54fe$var$_excluded);
    $dbec57966acc54fe$var$PluginManager.pluginEvent.bind($dbec57966acc54fe$export$31b3ca70d8f57423)(eventName, sortable, $dbec57966acc54fe$var$_objectSpread2({
        dragEl: $dbec57966acc54fe$var$dragEl,
        parentEl: $dbec57966acc54fe$var$parentEl,
        ghostEl: $dbec57966acc54fe$var$ghostEl,
        rootEl: $dbec57966acc54fe$var$rootEl,
        nextEl: $dbec57966acc54fe$var$nextEl,
        lastDownEl: $dbec57966acc54fe$var$lastDownEl,
        cloneEl: $dbec57966acc54fe$var$cloneEl,
        cloneHidden: $dbec57966acc54fe$var$cloneHidden,
        dragStarted: $dbec57966acc54fe$var$moved,
        putSortable: $dbec57966acc54fe$var$putSortable,
        activeSortable: $dbec57966acc54fe$export$31b3ca70d8f57423.active,
        originalEvent: originalEvent,
        oldIndex: $dbec57966acc54fe$var$oldIndex,
        oldDraggableIndex: $dbec57966acc54fe$var$oldDraggableIndex,
        newIndex: $dbec57966acc54fe$var$newIndex,
        newDraggableIndex: $dbec57966acc54fe$var$newDraggableIndex,
        hideGhostForTarget: $dbec57966acc54fe$var$_hideGhostForTarget,
        unhideGhostForTarget: $dbec57966acc54fe$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $dbec57966acc54fe$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $dbec57966acc54fe$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $dbec57966acc54fe$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $dbec57966acc54fe$var$_dispatchEvent(info) {
    $dbec57966acc54fe$var$dispatchEvent($dbec57966acc54fe$var$_objectSpread2({
        putSortable: $dbec57966acc54fe$var$putSortable,
        cloneEl: $dbec57966acc54fe$var$cloneEl,
        targetEl: $dbec57966acc54fe$var$dragEl,
        rootEl: $dbec57966acc54fe$var$rootEl,
        oldIndex: $dbec57966acc54fe$var$oldIndex,
        oldDraggableIndex: $dbec57966acc54fe$var$oldDraggableIndex,
        newIndex: $dbec57966acc54fe$var$newIndex,
        newDraggableIndex: $dbec57966acc54fe$var$newDraggableIndex
    }, info));
}
var $dbec57966acc54fe$var$dragEl, $dbec57966acc54fe$var$parentEl, $dbec57966acc54fe$var$ghostEl, $dbec57966acc54fe$var$rootEl, $dbec57966acc54fe$var$nextEl, $dbec57966acc54fe$var$lastDownEl, $dbec57966acc54fe$var$cloneEl, $dbec57966acc54fe$var$cloneHidden, $dbec57966acc54fe$var$oldIndex, $dbec57966acc54fe$var$newIndex, $dbec57966acc54fe$var$oldDraggableIndex, $dbec57966acc54fe$var$newDraggableIndex, $dbec57966acc54fe$var$activeGroup, $dbec57966acc54fe$var$putSortable, $dbec57966acc54fe$var$awaitingDragStarted = false, $dbec57966acc54fe$var$ignoreNextClick = false, $dbec57966acc54fe$var$sortables = [], $dbec57966acc54fe$var$tapEvt, $dbec57966acc54fe$var$touchEvt, $dbec57966acc54fe$var$lastDx, $dbec57966acc54fe$var$lastDy, $dbec57966acc54fe$var$tapDistanceLeft, $dbec57966acc54fe$var$tapDistanceTop, $dbec57966acc54fe$var$moved, $dbec57966acc54fe$var$lastTarget, $dbec57966acc54fe$var$lastDirection, $dbec57966acc54fe$var$pastFirstInvertThresh = false, $dbec57966acc54fe$var$isCircumstantialInvert = false, $dbec57966acc54fe$var$targetMoveDistance, // For positioning ghost absolutely
$dbec57966acc54fe$var$ghostRelativeParent, $dbec57966acc54fe$var$ghostRelativeParentInitialScroll = [], // (left, top)
$dbec57966acc54fe$var$_silent = false, $dbec57966acc54fe$var$savedInputChecked = [];
/** @const */ var $dbec57966acc54fe$var$documentExists = typeof document !== 'undefined', $dbec57966acc54fe$var$PositionGhostAbsolutely = $dbec57966acc54fe$var$IOS, $dbec57966acc54fe$var$CSSFloatProperty = $dbec57966acc54fe$var$Edge || $dbec57966acc54fe$var$IE11OrLess ? 'cssFloat' : 'float', // This will not pass for IE9, because IE9 DnD only works on anchors
$dbec57966acc54fe$var$supportDraggable = $dbec57966acc54fe$var$documentExists && !$dbec57966acc54fe$var$ChromeForAndroid && !$dbec57966acc54fe$var$IOS && 'draggable' in document.createElement('div'), $dbec57966acc54fe$var$supportCssPointerEvents = function() {
    if (!$dbec57966acc54fe$var$documentExists) return;
    // false when <= IE11
    if ($dbec57966acc54fe$var$IE11OrLess) return false;
    var el = document.createElement('x');
    el.style.cssText = 'pointer-events:auto';
    return el.style.pointerEvents === 'auto';
}(), $dbec57966acc54fe$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $dbec57966acc54fe$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $dbec57966acc54fe$var$getChild(el, 0, options), child2 = $dbec57966acc54fe$var$getChild(el, 1, options), firstChildCSS = child1 && $dbec57966acc54fe$var$css(child1), secondChildCSS = child2 && $dbec57966acc54fe$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $dbec57966acc54fe$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $dbec57966acc54fe$var$getRect(child2).width;
    if (elCSS.display === 'flex') return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
    if (elCSS.display === 'grid') return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
        var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
        return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
    }
    return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[$dbec57966acc54fe$var$CSSFloatProperty] === 'none' || child2 && elCSS[$dbec57966acc54fe$var$CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
}, $dbec57966acc54fe$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */ $dbec57966acc54fe$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $dbec57966acc54fe$var$sortables.some(function(sortable) {
        var threshold = sortable[$dbec57966acc54fe$var$expando].options.emptyInsertThreshold;
        if (!threshold || $dbec57966acc54fe$var$lastChild(sortable)) return;
        var rect = $dbec57966acc54fe$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $dbec57966acc54fe$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === 'clone') return value;
            else if (typeof value === 'function') return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $dbec57966acc54fe$var$_typeof(originalGroup) != 'object') originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $dbec57966acc54fe$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$dbec57966acc54fe$var$supportCssPointerEvents && $dbec57966acc54fe$var$ghostEl) $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'display', 'none');
}, $dbec57966acc54fe$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$dbec57966acc54fe$var$supportCssPointerEvents && $dbec57966acc54fe$var$ghostEl) $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'display', '');
};
// #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($dbec57966acc54fe$var$documentExists && !$dbec57966acc54fe$var$ChromeForAndroid) document.addEventListener('click', function(evt) {
    if ($dbec57966acc54fe$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $dbec57966acc54fe$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $dbec57966acc54fe$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($dbec57966acc54fe$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $dbec57966acc54fe$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$dbec57966acc54fe$var$expando]._onDragOver(event);
        }
    }
};
var $dbec57966acc54fe$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($dbec57966acc54fe$var$dragEl) $dbec57966acc54fe$var$dragEl.parentNode[$dbec57966acc54fe$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $dbec57966acc54fe$export$31b3ca70d8f57423(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $dbec57966acc54fe$var$_extends({}, options);
    // Export instance
    el[$dbec57966acc54fe$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $dbec57966acc54fe$var$_detectDirection(el, this.options);
        },
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        dragClass: 'sortable-drag',
        ignore: 'a, img',
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData('Text', dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: 'data-id',
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: 'sortable-fallback',
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        // Disabled on Safari: #1571; Enabled on Safari IOS: #2244
        supportPointer: $dbec57966acc54fe$export$31b3ca70d8f57423.supportPointer !== false && 'PointerEvent' in window && (!$dbec57966acc54fe$var$Safari || $dbec57966acc54fe$var$IOS),
        emptyInsertThreshold: 5
    };
    $dbec57966acc54fe$var$PluginManager.initializePlugins(this, el, defaults);
    // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $dbec57966acc54fe$var$_prepareGroup(options);
    // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
    // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $dbec57966acc54fe$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
    // Bind events
    if (options.supportPointer) $dbec57966acc54fe$var$on(el, 'pointerdown', this._onTapStart);
    else {
        $dbec57966acc54fe$var$on(el, 'mousedown', this._onTapStart);
        $dbec57966acc54fe$var$on(el, 'touchstart', this._onTapStart);
    }
    if (this.nativeDraggable) {
        $dbec57966acc54fe$var$on(el, 'dragover', this);
        $dbec57966acc54fe$var$on(el, 'dragenter', this);
    }
    $dbec57966acc54fe$var$sortables.push(this.el);
    // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []);
    // Add animation state manager
    $dbec57966acc54fe$var$_extends(this, $dbec57966acc54fe$var$AnimationStateManager());
}
$dbec57966acc54fe$export$31b3ca70d8f57423.prototype = /** @lends Sortable.prototype */ {
    constructor: $dbec57966acc54fe$export$31b3ca70d8f57423,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $dbec57966acc54fe$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, $dbec57966acc54fe$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $dbec57966acc54fe$var$_saveInputCheckedState(el);
        // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($dbec57966acc54fe$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
        // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
        // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $dbec57966acc54fe$var$Safari && target && target.tagName.toUpperCase() === 'SELECT') return;
        target = $dbec57966acc54fe$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($dbec57966acc54fe$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
        // Get the index of the dragged element within its parent
        $dbec57966acc54fe$var$oldIndex = $dbec57966acc54fe$var$index(target);
        $dbec57966acc54fe$var$oldDraggableIndex = $dbec57966acc54fe$var$index(target, options.draggable);
        // Check filter
        if (typeof filter === 'function') {
            if (filter.call(this, evt, target, this)) {
                $dbec57966acc54fe$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: 'filter',
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $dbec57966acc54fe$var$pluginEvent('filter', _this, {
                    evt: evt
                });
                preventOnFilter && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(',').some(function(criteria) {
                criteria = $dbec57966acc54fe$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $dbec57966acc54fe$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: 'filter',
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $dbec57966acc54fe$var$pluginEvent('filter', _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$dbec57966acc54fe$var$closest(originalTarget, options.handle, el, false)) return;
        // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$dbec57966acc54fe$var$dragEl && target.parentNode === el) {
            var dragRect = $dbec57966acc54fe$var$getRect(target);
            $dbec57966acc54fe$var$rootEl = el;
            $dbec57966acc54fe$var$dragEl = target;
            $dbec57966acc54fe$var$parentEl = $dbec57966acc54fe$var$dragEl.parentNode;
            $dbec57966acc54fe$var$nextEl = $dbec57966acc54fe$var$dragEl.nextSibling;
            $dbec57966acc54fe$var$lastDownEl = target;
            $dbec57966acc54fe$var$activeGroup = options.group;
            $dbec57966acc54fe$export$31b3ca70d8f57423.dragged = $dbec57966acc54fe$var$dragEl;
            $dbec57966acc54fe$var$tapEvt = {
                target: $dbec57966acc54fe$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $dbec57966acc54fe$var$tapDistanceLeft = $dbec57966acc54fe$var$tapEvt.clientX - dragRect.left;
            $dbec57966acc54fe$var$tapDistanceTop = $dbec57966acc54fe$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $dbec57966acc54fe$var$dragEl.style['will-change'] = 'all';
            dragStartFn = function dragStartFn() {
                $dbec57966acc54fe$var$pluginEvent('delayEnded', _this, {
                    evt: evt
                });
                if ($dbec57966acc54fe$export$31b3ca70d8f57423.eventCanceled) {
                    _this._onDrop();
                    return;
                }
                // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$dbec57966acc54fe$var$FireFox && _this.nativeDraggable) $dbec57966acc54fe$var$dragEl.draggable = true;
                // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch);
                // Drag start event
                $dbec57966acc54fe$var$_dispatchEvent({
                    sortable: _this,
                    name: 'choose',
                    originalEvent: evt
                });
                // Chosen item
                $dbec57966acc54fe$var$toggleClass($dbec57966acc54fe$var$dragEl, options.chosenClass, true);
            };
            // Disable "draggable"
            options.ignore.split(',').forEach(function(criteria) {
                $dbec57966acc54fe$var$find($dbec57966acc54fe$var$dragEl, criteria.trim(), $dbec57966acc54fe$var$_disableDraggable);
            });
            $dbec57966acc54fe$var$on(ownerDocument, 'dragover', $dbec57966acc54fe$var$nearestEmptyInsertDetectEvent);
            $dbec57966acc54fe$var$on(ownerDocument, 'mousemove', $dbec57966acc54fe$var$nearestEmptyInsertDetectEvent);
            $dbec57966acc54fe$var$on(ownerDocument, 'touchmove', $dbec57966acc54fe$var$nearestEmptyInsertDetectEvent);
            if (options.supportPointer) {
                $dbec57966acc54fe$var$on(ownerDocument, 'pointerup', _this._onDrop);
                // Native D&D triggers pointercancel
                !this.nativeDraggable && $dbec57966acc54fe$var$on(ownerDocument, 'pointercancel', _this._onDrop);
            } else {
                $dbec57966acc54fe$var$on(ownerDocument, 'mouseup', _this._onDrop);
                $dbec57966acc54fe$var$on(ownerDocument, 'touchend', _this._onDrop);
                $dbec57966acc54fe$var$on(ownerDocument, 'touchcancel', _this._onDrop);
            }
            // Make dragEl draggable (must be before delay for FireFox)
            if ($dbec57966acc54fe$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $dbec57966acc54fe$var$dragEl.draggable = true;
            }
            $dbec57966acc54fe$var$pluginEvent('delayStart', this, {
                evt: evt
            });
            // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($dbec57966acc54fe$var$Edge || $dbec57966acc54fe$var$IE11OrLess))) {
                if ($dbec57966acc54fe$export$31b3ca70d8f57423.eventCanceled) {
                    this._onDrop();
                    return;
                }
                // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                if (options.supportPointer) {
                    $dbec57966acc54fe$var$on(ownerDocument, 'pointerup', _this._disableDelayedDrag);
                    $dbec57966acc54fe$var$on(ownerDocument, 'pointercancel', _this._disableDelayedDrag);
                } else {
                    $dbec57966acc54fe$var$on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
                    $dbec57966acc54fe$var$on(ownerDocument, 'touchend', _this._disableDelayedDrag);
                    $dbec57966acc54fe$var$on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
                }
                $dbec57966acc54fe$var$on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
                $dbec57966acc54fe$var$on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
                options.supportPointer && $dbec57966acc54fe$var$on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $dbec57966acc54fe$var$dragEl && $dbec57966acc54fe$var$_disableDraggable($dbec57966acc54fe$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $dbec57966acc54fe$var$off(ownerDocument, 'mouseup', this._disableDelayedDrag);
        $dbec57966acc54fe$var$off(ownerDocument, 'touchend', this._disableDelayedDrag);
        $dbec57966acc54fe$var$off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
        $dbec57966acc54fe$var$off(ownerDocument, 'pointerup', this._disableDelayedDrag);
        $dbec57966acc54fe$var$off(ownerDocument, 'pointercancel', this._disableDelayedDrag);
        $dbec57966acc54fe$var$off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
        $dbec57966acc54fe$var$off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
        $dbec57966acc54fe$var$off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == 'touch' && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $dbec57966acc54fe$var$on(document, 'pointermove', this._onTouchMove);
            else if (touch) $dbec57966acc54fe$var$on(document, 'touchmove', this._onTouchMove);
            else $dbec57966acc54fe$var$on(document, 'mousemove', this._onTouchMove);
        } else {
            $dbec57966acc54fe$var$on($dbec57966acc54fe$var$dragEl, 'dragend', this);
            $dbec57966acc54fe$var$on($dbec57966acc54fe$var$rootEl, 'dragstart', this._onDragStart);
        }
        try {
            if (document.selection) $dbec57966acc54fe$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $dbec57966acc54fe$var$awaitingDragStarted = false;
        if ($dbec57966acc54fe$var$rootEl && $dbec57966acc54fe$var$dragEl) {
            $dbec57966acc54fe$var$pluginEvent('dragStarted', this, {
                evt: evt
            });
            if (this.nativeDraggable) $dbec57966acc54fe$var$on(document, 'dragover', $dbec57966acc54fe$var$_checkOutsideTargetEl);
            var options = this.options;
            // Apply effect
            !fallback && $dbec57966acc54fe$var$toggleClass($dbec57966acc54fe$var$dragEl, options.dragClass, false);
            $dbec57966acc54fe$var$toggleClass($dbec57966acc54fe$var$dragEl, options.ghostClass, true);
            $dbec57966acc54fe$export$31b3ca70d8f57423.active = this;
            fallback && this._appendGhost();
            // Drag start event
            $dbec57966acc54fe$var$_dispatchEvent({
                sortable: this,
                name: 'start',
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($dbec57966acc54fe$var$touchEvt) {
            this._lastX = $dbec57966acc54fe$var$touchEvt.clientX;
            this._lastY = $dbec57966acc54fe$var$touchEvt.clientY;
            $dbec57966acc54fe$var$_hideGhostForTarget();
            var target = document.elementFromPoint($dbec57966acc54fe$var$touchEvt.clientX, $dbec57966acc54fe$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($dbec57966acc54fe$var$touchEvt.clientX, $dbec57966acc54fe$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $dbec57966acc54fe$var$dragEl.parentNode[$dbec57966acc54fe$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$dbec57966acc54fe$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$dbec57966acc54fe$var$expando]._onDragOver({
                        clientX: $dbec57966acc54fe$var$touchEvt.clientX,
                        clientY: $dbec57966acc54fe$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = $dbec57966acc54fe$var$getParentOrHost(parent));
            $dbec57966acc54fe$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($dbec57966acc54fe$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $dbec57966acc54fe$var$ghostEl && $dbec57966acc54fe$var$matrix($dbec57966acc54fe$var$ghostEl, true), scaleX = $dbec57966acc54fe$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $dbec57966acc54fe$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $dbec57966acc54fe$var$PositionGhostAbsolutely && $dbec57966acc54fe$var$ghostRelativeParent && $dbec57966acc54fe$var$getRelativeScrollOffset($dbec57966acc54fe$var$ghostRelativeParent), dx = (touch.clientX - $dbec57966acc54fe$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $dbec57966acc54fe$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $dbec57966acc54fe$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $dbec57966acc54fe$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
            // only set the status to dragging, when we are actually dragging
            if (!$dbec57966acc54fe$export$31b3ca70d8f57423.active && !$dbec57966acc54fe$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($dbec57966acc54fe$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($dbec57966acc54fe$var$lastDx || 0);
                    ghostMatrix.f += dy - ($dbec57966acc54fe$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'webkitTransform', cssMatrix);
                $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'mozTransform', cssMatrix);
                $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'msTransform', cssMatrix);
                $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'transform', cssMatrix);
                $dbec57966acc54fe$var$lastDx = dx;
                $dbec57966acc54fe$var$lastDy = dy;
                $dbec57966acc54fe$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$dbec57966acc54fe$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $dbec57966acc54fe$var$rootEl, rect = $dbec57966acc54fe$var$getRect($dbec57966acc54fe$var$dragEl, true, $dbec57966acc54fe$var$PositionGhostAbsolutely, true, container), options = this.options;
            // Position absolutely
            if ($dbec57966acc54fe$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $dbec57966acc54fe$var$ghostRelativeParent = container;
                while($dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostRelativeParent, 'position') === 'static' && $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostRelativeParent, 'transform') === 'none' && $dbec57966acc54fe$var$ghostRelativeParent !== document)$dbec57966acc54fe$var$ghostRelativeParent = $dbec57966acc54fe$var$ghostRelativeParent.parentNode;
                if ($dbec57966acc54fe$var$ghostRelativeParent !== document.body && $dbec57966acc54fe$var$ghostRelativeParent !== document.documentElement) {
                    if ($dbec57966acc54fe$var$ghostRelativeParent === document) $dbec57966acc54fe$var$ghostRelativeParent = $dbec57966acc54fe$var$getWindowScrollingElement();
                    rect.top += $dbec57966acc54fe$var$ghostRelativeParent.scrollTop;
                    rect.left += $dbec57966acc54fe$var$ghostRelativeParent.scrollLeft;
                } else $dbec57966acc54fe$var$ghostRelativeParent = $dbec57966acc54fe$var$getWindowScrollingElement();
                $dbec57966acc54fe$var$ghostRelativeParentInitialScroll = $dbec57966acc54fe$var$getRelativeScrollOffset($dbec57966acc54fe$var$ghostRelativeParent);
            }
            $dbec57966acc54fe$var$ghostEl = $dbec57966acc54fe$var$dragEl.cloneNode(true);
            $dbec57966acc54fe$var$toggleClass($dbec57966acc54fe$var$ghostEl, options.ghostClass, false);
            $dbec57966acc54fe$var$toggleClass($dbec57966acc54fe$var$ghostEl, options.fallbackClass, true);
            $dbec57966acc54fe$var$toggleClass($dbec57966acc54fe$var$ghostEl, options.dragClass, true);
            $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'transition', '');
            $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'transform', '');
            $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'box-sizing', 'border-box');
            $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'margin', 0);
            $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'top', rect.top);
            $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'left', rect.left);
            $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'width', rect.width);
            $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'height', rect.height);
            $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'opacity', '0.8');
            $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'position', $dbec57966acc54fe$var$PositionGhostAbsolutely ? 'absolute' : 'fixed');
            $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'zIndex', '100000');
            $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'pointerEvents', 'none');
            $dbec57966acc54fe$export$31b3ca70d8f57423.ghost = $dbec57966acc54fe$var$ghostEl;
            container.appendChild($dbec57966acc54fe$var$ghostEl);
            // Set transform-origin
            $dbec57966acc54fe$var$css($dbec57966acc54fe$var$ghostEl, 'transform-origin', $dbec57966acc54fe$var$tapDistanceLeft / parseInt($dbec57966acc54fe$var$ghostEl.style.width) * 100 + '% ' + $dbec57966acc54fe$var$tapDistanceTop / parseInt($dbec57966acc54fe$var$ghostEl.style.height) * 100 + '%');
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $dbec57966acc54fe$var$pluginEvent('dragStart', this, {
            evt: evt
        });
        if ($dbec57966acc54fe$export$31b3ca70d8f57423.eventCanceled) {
            this._onDrop();
            return;
        }
        $dbec57966acc54fe$var$pluginEvent('setupClone', this);
        if (!$dbec57966acc54fe$export$31b3ca70d8f57423.eventCanceled) {
            $dbec57966acc54fe$var$cloneEl = $dbec57966acc54fe$var$clone($dbec57966acc54fe$var$dragEl);
            $dbec57966acc54fe$var$cloneEl.removeAttribute("id");
            $dbec57966acc54fe$var$cloneEl.draggable = false;
            $dbec57966acc54fe$var$cloneEl.style['will-change'] = '';
            this._hideClone();
            $dbec57966acc54fe$var$toggleClass($dbec57966acc54fe$var$cloneEl, this.options.chosenClass, false);
            $dbec57966acc54fe$export$31b3ca70d8f57423.clone = $dbec57966acc54fe$var$cloneEl;
        }
        // #1143: IFrame support workaround
        _this.cloneId = $dbec57966acc54fe$var$_nextTick(function() {
            $dbec57966acc54fe$var$pluginEvent('clone', _this);
            if ($dbec57966acc54fe$export$31b3ca70d8f57423.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $dbec57966acc54fe$var$rootEl.insertBefore($dbec57966acc54fe$var$cloneEl, $dbec57966acc54fe$var$dragEl);
            _this._hideClone();
            $dbec57966acc54fe$var$_dispatchEvent({
                sortable: _this,
                name: 'clone'
            });
        });
        !fallback && $dbec57966acc54fe$var$toggleClass($dbec57966acc54fe$var$dragEl, options.dragClass, true);
        // Set proper drop events
        if (fallback) {
            $dbec57966acc54fe$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $dbec57966acc54fe$var$off(document, 'mouseup', _this._onDrop);
            $dbec57966acc54fe$var$off(document, 'touchend', _this._onDrop);
            $dbec57966acc54fe$var$off(document, 'touchcancel', _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = 'move';
                options.setData && options.setData.call(_this, dataTransfer, $dbec57966acc54fe$var$dragEl);
            }
            $dbec57966acc54fe$var$on(document, 'drop', _this);
            // #1276 fix:
            $dbec57966acc54fe$var$css($dbec57966acc54fe$var$dragEl, 'transform', 'translateZ(0)');
        }
        $dbec57966acc54fe$var$awaitingDragStarted = true;
        _this._dragStartId = $dbec57966acc54fe$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $dbec57966acc54fe$var$on(document, 'selectstart', _this);
        $dbec57966acc54fe$var$moved = true;
        window.getSelection().removeAllRanges();
        if ($dbec57966acc54fe$var$Safari) $dbec57966acc54fe$var$css(document.body, 'user-select', 'none');
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $dbec57966acc54fe$export$31b3ca70d8f57423.active, isOwner = $dbec57966acc54fe$var$activeGroup === group, canSort = options.sort, fromSortable = $dbec57966acc54fe$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($dbec57966acc54fe$var$_silent) return;
        function dragOverEvent(name, extra) {
            $dbec57966acc54fe$var$pluginEvent(name, _this, $dbec57966acc54fe$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? 'vertical' : 'horizontal',
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $dbec57966acc54fe$var$_onMove($dbec57966acc54fe$var$rootEl, el, $dbec57966acc54fe$var$dragEl, dragRect, target, $dbec57966acc54fe$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        }
        // Capture animation state
        function capture() {
            dragOverEvent('dragOverAnimationCapture');
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        }
        // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent('dragOverCompleted', {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $dbec57966acc54fe$var$toggleClass($dbec57966acc54fe$var$dragEl, $dbec57966acc54fe$var$putSortable ? $dbec57966acc54fe$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $dbec57966acc54fe$var$toggleClass($dbec57966acc54fe$var$dragEl, options.ghostClass, true);
                }
                if ($dbec57966acc54fe$var$putSortable !== _this && _this !== $dbec57966acc54fe$export$31b3ca70d8f57423.active) $dbec57966acc54fe$var$putSortable = _this;
                else if (_this === $dbec57966acc54fe$export$31b3ca70d8f57423.active && $dbec57966acc54fe$var$putSortable) $dbec57966acc54fe$var$putSortable = null;
                // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent('dragOverAnimationComplete');
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            }
            // Null lastTarget if it is not inside a previously swapped element
            if (target === $dbec57966acc54fe$var$dragEl && !$dbec57966acc54fe$var$dragEl.animated || target === el && !target.animated) $dbec57966acc54fe$var$lastTarget = null;
            // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $dbec57966acc54fe$var$dragEl.parentNode[$dbec57966acc54fe$var$expando]._isOutsideThisEl(evt.target);
                // Do not detect for empty insert if already inserted
                !insertion && $dbec57966acc54fe$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        }
        // Call when dragEl has been inserted
        function changed() {
            $dbec57966acc54fe$var$newIndex = $dbec57966acc54fe$var$index($dbec57966acc54fe$var$dragEl);
            $dbec57966acc54fe$var$newDraggableIndex = $dbec57966acc54fe$var$index($dbec57966acc54fe$var$dragEl, options.draggable);
            $dbec57966acc54fe$var$_dispatchEvent({
                sortable: _this,
                name: 'change',
                toEl: el,
                newIndex: $dbec57966acc54fe$var$newIndex,
                newDraggableIndex: $dbec57966acc54fe$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $dbec57966acc54fe$var$closest(target, options.draggable, el, true);
        dragOverEvent('dragOver');
        if ($dbec57966acc54fe$export$31b3ca70d8f57423.eventCanceled) return completedFired;
        if ($dbec57966acc54fe$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $dbec57966acc54fe$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $dbec57966acc54fe$var$parentEl !== $dbec57966acc54fe$var$rootEl // Reverting item into the original list
        ) : $dbec57966acc54fe$var$putSortable === this || (this.lastPutMode = $dbec57966acc54fe$var$activeGroup.checkPull(this, activeSortable, $dbec57966acc54fe$var$dragEl, evt)) && group.checkPut(this, activeSortable, $dbec57966acc54fe$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === 'vertical';
            dragRect = $dbec57966acc54fe$var$getRect($dbec57966acc54fe$var$dragEl);
            dragOverEvent('dragOverValid');
            if ($dbec57966acc54fe$export$31b3ca70d8f57423.eventCanceled) return completedFired;
            if (revert) {
                $dbec57966acc54fe$var$parentEl = $dbec57966acc54fe$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent('revert');
                if (!$dbec57966acc54fe$export$31b3ca70d8f57423.eventCanceled) {
                    if ($dbec57966acc54fe$var$nextEl) $dbec57966acc54fe$var$rootEl.insertBefore($dbec57966acc54fe$var$dragEl, $dbec57966acc54fe$var$nextEl);
                    else $dbec57966acc54fe$var$rootEl.appendChild($dbec57966acc54fe$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $dbec57966acc54fe$var$lastChild(el, options.draggable);
            if (!elLastChild || $dbec57966acc54fe$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $dbec57966acc54fe$var$dragEl) return completed(false);
                // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $dbec57966acc54fe$var$getRect(target);
                if ($dbec57966acc54fe$var$_onMove($dbec57966acc54fe$var$rootEl, el, $dbec57966acc54fe$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore($dbec57966acc54fe$var$dragEl, elLastChild.nextSibling);
                    else el.appendChild($dbec57966acc54fe$var$dragEl);
                    $dbec57966acc54fe$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $dbec57966acc54fe$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $dbec57966acc54fe$var$getChild(el, 0, options, true);
                if (firstChild === $dbec57966acc54fe$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $dbec57966acc54fe$var$getRect(target);
                if ($dbec57966acc54fe$var$_onMove($dbec57966acc54fe$var$rootEl, el, $dbec57966acc54fe$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($dbec57966acc54fe$var$dragEl, firstChild);
                    $dbec57966acc54fe$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $dbec57966acc54fe$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $dbec57966acc54fe$var$dragEl.parentNode !== el, differentRowCol = !$dbec57966acc54fe$var$_dragElInRowColumn($dbec57966acc54fe$var$dragEl.animated && $dbec57966acc54fe$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? 'top' : 'left', scrolledPastTop = $dbec57966acc54fe$var$isScrolledPast(target, 'top', 'top') || $dbec57966acc54fe$var$isScrolledPast($dbec57966acc54fe$var$dragEl, 'top', 'top'), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($dbec57966acc54fe$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $dbec57966acc54fe$var$pastFirstInvertThresh = false;
                    $dbec57966acc54fe$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $dbec57966acc54fe$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $dbec57966acc54fe$var$isCircumstantialInvert, $dbec57966acc54fe$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $dbec57966acc54fe$var$index($dbec57966acc54fe$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $dbec57966acc54fe$var$parentEl.children[dragIndex];
                    }while (sibling && ($dbec57966acc54fe$var$css(sibling, 'display') === 'none' || sibling === $dbec57966acc54fe$var$ghostEl));
                }
                // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $dbec57966acc54fe$var$lastTarget = target;
                $dbec57966acc54fe$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $dbec57966acc54fe$var$_onMove($dbec57966acc54fe$var$rootEl, el, $dbec57966acc54fe$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $dbec57966acc54fe$var$_silent = true;
                    setTimeout($dbec57966acc54fe$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($dbec57966acc54fe$var$dragEl);
                    else target.parentNode.insertBefore($dbec57966acc54fe$var$dragEl, after ? nextSibling : target);
                    // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $dbec57966acc54fe$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $dbec57966acc54fe$var$parentEl = $dbec57966acc54fe$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$dbec57966acc54fe$var$isCircumstantialInvert) $dbec57966acc54fe$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $dbec57966acc54fe$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($dbec57966acc54fe$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $dbec57966acc54fe$var$off(document, 'mousemove', this._onTouchMove);
        $dbec57966acc54fe$var$off(document, 'touchmove', this._onTouchMove);
        $dbec57966acc54fe$var$off(document, 'pointermove', this._onTouchMove);
        $dbec57966acc54fe$var$off(document, 'dragover', $dbec57966acc54fe$var$nearestEmptyInsertDetectEvent);
        $dbec57966acc54fe$var$off(document, 'mousemove', $dbec57966acc54fe$var$nearestEmptyInsertDetectEvent);
        $dbec57966acc54fe$var$off(document, 'touchmove', $dbec57966acc54fe$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $dbec57966acc54fe$var$off(ownerDocument, 'mouseup', this._onDrop);
        $dbec57966acc54fe$var$off(ownerDocument, 'touchend', this._onDrop);
        $dbec57966acc54fe$var$off(ownerDocument, 'pointerup', this._onDrop);
        $dbec57966acc54fe$var$off(ownerDocument, 'pointercancel', this._onDrop);
        $dbec57966acc54fe$var$off(ownerDocument, 'touchcancel', this._onDrop);
        $dbec57966acc54fe$var$off(document, 'selectstart', this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options;
        // Get the index of the dragged element within its parent
        $dbec57966acc54fe$var$newIndex = $dbec57966acc54fe$var$index($dbec57966acc54fe$var$dragEl);
        $dbec57966acc54fe$var$newDraggableIndex = $dbec57966acc54fe$var$index($dbec57966acc54fe$var$dragEl, options.draggable);
        $dbec57966acc54fe$var$pluginEvent('drop', this, {
            evt: evt
        });
        $dbec57966acc54fe$var$parentEl = $dbec57966acc54fe$var$dragEl && $dbec57966acc54fe$var$dragEl.parentNode;
        // Get again after plugin event
        $dbec57966acc54fe$var$newIndex = $dbec57966acc54fe$var$index($dbec57966acc54fe$var$dragEl);
        $dbec57966acc54fe$var$newDraggableIndex = $dbec57966acc54fe$var$index($dbec57966acc54fe$var$dragEl, options.draggable);
        if ($dbec57966acc54fe$export$31b3ca70d8f57423.eventCanceled) {
            this._nulling();
            return;
        }
        $dbec57966acc54fe$var$awaitingDragStarted = false;
        $dbec57966acc54fe$var$isCircumstantialInvert = false;
        $dbec57966acc54fe$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $dbec57966acc54fe$var$_cancelNextTick(this.cloneId);
        $dbec57966acc54fe$var$_cancelNextTick(this._dragStartId);
        // Unbind events
        if (this.nativeDraggable) {
            $dbec57966acc54fe$var$off(document, 'drop', this);
            $dbec57966acc54fe$var$off(el, 'dragstart', this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($dbec57966acc54fe$var$Safari) $dbec57966acc54fe$var$css(document.body, 'user-select', '');
        $dbec57966acc54fe$var$css($dbec57966acc54fe$var$dragEl, 'transform', '');
        if (evt) {
            if ($dbec57966acc54fe$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $dbec57966acc54fe$var$ghostEl && $dbec57966acc54fe$var$ghostEl.parentNode && $dbec57966acc54fe$var$ghostEl.parentNode.removeChild($dbec57966acc54fe$var$ghostEl);
            if ($dbec57966acc54fe$var$rootEl === $dbec57966acc54fe$var$parentEl || $dbec57966acc54fe$var$putSortable && $dbec57966acc54fe$var$putSortable.lastPutMode !== 'clone') // Remove clone(s)
            $dbec57966acc54fe$var$cloneEl && $dbec57966acc54fe$var$cloneEl.parentNode && $dbec57966acc54fe$var$cloneEl.parentNode.removeChild($dbec57966acc54fe$var$cloneEl);
            if ($dbec57966acc54fe$var$dragEl) {
                if (this.nativeDraggable) $dbec57966acc54fe$var$off($dbec57966acc54fe$var$dragEl, 'dragend', this);
                $dbec57966acc54fe$var$_disableDraggable($dbec57966acc54fe$var$dragEl);
                $dbec57966acc54fe$var$dragEl.style['will-change'] = '';
                // Remove classes
                // ghostClass is added in dragStarted
                if ($dbec57966acc54fe$var$moved && !$dbec57966acc54fe$var$awaitingDragStarted) $dbec57966acc54fe$var$toggleClass($dbec57966acc54fe$var$dragEl, $dbec57966acc54fe$var$putSortable ? $dbec57966acc54fe$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $dbec57966acc54fe$var$toggleClass($dbec57966acc54fe$var$dragEl, this.options.chosenClass, false);
                // Drag stop event
                $dbec57966acc54fe$var$_dispatchEvent({
                    sortable: this,
                    name: 'unchoose',
                    toEl: $dbec57966acc54fe$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($dbec57966acc54fe$var$rootEl !== $dbec57966acc54fe$var$parentEl) {
                    if ($dbec57966acc54fe$var$newIndex >= 0) {
                        // Add event
                        $dbec57966acc54fe$var$_dispatchEvent({
                            rootEl: $dbec57966acc54fe$var$parentEl,
                            name: 'add',
                            toEl: $dbec57966acc54fe$var$parentEl,
                            fromEl: $dbec57966acc54fe$var$rootEl,
                            originalEvent: evt
                        });
                        // Remove event
                        $dbec57966acc54fe$var$_dispatchEvent({
                            sortable: this,
                            name: 'remove',
                            toEl: $dbec57966acc54fe$var$parentEl,
                            originalEvent: evt
                        });
                        // drag from one list and drop into another
                        $dbec57966acc54fe$var$_dispatchEvent({
                            rootEl: $dbec57966acc54fe$var$parentEl,
                            name: 'sort',
                            toEl: $dbec57966acc54fe$var$parentEl,
                            fromEl: $dbec57966acc54fe$var$rootEl,
                            originalEvent: evt
                        });
                        $dbec57966acc54fe$var$_dispatchEvent({
                            sortable: this,
                            name: 'sort',
                            toEl: $dbec57966acc54fe$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $dbec57966acc54fe$var$putSortable && $dbec57966acc54fe$var$putSortable.save();
                } else {
                    if ($dbec57966acc54fe$var$newIndex !== $dbec57966acc54fe$var$oldIndex) {
                        if ($dbec57966acc54fe$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $dbec57966acc54fe$var$_dispatchEvent({
                                sortable: this,
                                name: 'update',
                                toEl: $dbec57966acc54fe$var$parentEl,
                                originalEvent: evt
                            });
                            $dbec57966acc54fe$var$_dispatchEvent({
                                sortable: this,
                                name: 'sort',
                                toEl: $dbec57966acc54fe$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($dbec57966acc54fe$export$31b3ca70d8f57423.active) {
                    /* jshint eqnull:true */ if ($dbec57966acc54fe$var$newIndex == null || $dbec57966acc54fe$var$newIndex === -1) {
                        $dbec57966acc54fe$var$newIndex = $dbec57966acc54fe$var$oldIndex;
                        $dbec57966acc54fe$var$newDraggableIndex = $dbec57966acc54fe$var$oldDraggableIndex;
                    }
                    $dbec57966acc54fe$var$_dispatchEvent({
                        sortable: this,
                        name: 'end',
                        toEl: $dbec57966acc54fe$var$parentEl,
                        originalEvent: evt
                    });
                    // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $dbec57966acc54fe$var$pluginEvent('nulling', this);
        $dbec57966acc54fe$var$rootEl = $dbec57966acc54fe$var$dragEl = $dbec57966acc54fe$var$parentEl = $dbec57966acc54fe$var$ghostEl = $dbec57966acc54fe$var$nextEl = $dbec57966acc54fe$var$cloneEl = $dbec57966acc54fe$var$lastDownEl = $dbec57966acc54fe$var$cloneHidden = $dbec57966acc54fe$var$tapEvt = $dbec57966acc54fe$var$touchEvt = $dbec57966acc54fe$var$moved = $dbec57966acc54fe$var$newIndex = $dbec57966acc54fe$var$newDraggableIndex = $dbec57966acc54fe$var$oldIndex = $dbec57966acc54fe$var$oldDraggableIndex = $dbec57966acc54fe$var$lastTarget = $dbec57966acc54fe$var$lastDirection = $dbec57966acc54fe$var$putSortable = $dbec57966acc54fe$var$activeGroup = $dbec57966acc54fe$export$31b3ca70d8f57423.dragged = $dbec57966acc54fe$export$31b3ca70d8f57423.ghost = $dbec57966acc54fe$export$31b3ca70d8f57423.clone = $dbec57966acc54fe$export$31b3ca70d8f57423.active = null;
        $dbec57966acc54fe$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $dbec57966acc54fe$var$savedInputChecked.length = $dbec57966acc54fe$var$lastDx = $dbec57966acc54fe$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case 'drop':
            case 'dragend':
                this._onDrop(evt);
                break;
            case 'dragenter':
            case 'dragover':
                if ($dbec57966acc54fe$var$dragEl) {
                    this._onDragOver(evt);
                    $dbec57966acc54fe$var$_globalDragOver(evt);
                }
                break;
            case 'selectstart':
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($dbec57966acc54fe$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $dbec57966acc54fe$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($dbec57966acc54fe$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $dbec57966acc54fe$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $dbec57966acc54fe$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== 'undefined') options[name] = modifiedValue;
            else options[name] = value;
            if (name === 'group') $dbec57966acc54fe$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $dbec57966acc54fe$var$pluginEvent('destroy', this);
        var el = this.el;
        el[$dbec57966acc54fe$var$expando] = null;
        $dbec57966acc54fe$var$off(el, 'mousedown', this._onTapStart);
        $dbec57966acc54fe$var$off(el, 'touchstart', this._onTapStart);
        $dbec57966acc54fe$var$off(el, 'pointerdown', this._onTapStart);
        if (this.nativeDraggable) {
            $dbec57966acc54fe$var$off(el, 'dragover', this);
            $dbec57966acc54fe$var$off(el, 'dragenter', this);
        }
        // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function(el) {
            el.removeAttribute('draggable');
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $dbec57966acc54fe$var$sortables.splice($dbec57966acc54fe$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$dbec57966acc54fe$var$cloneHidden) {
            $dbec57966acc54fe$var$pluginEvent('hideClone', this);
            if ($dbec57966acc54fe$export$31b3ca70d8f57423.eventCanceled) return;
            $dbec57966acc54fe$var$css($dbec57966acc54fe$var$cloneEl, 'display', 'none');
            if (this.options.removeCloneOnHide && $dbec57966acc54fe$var$cloneEl.parentNode) $dbec57966acc54fe$var$cloneEl.parentNode.removeChild($dbec57966acc54fe$var$cloneEl);
            $dbec57966acc54fe$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== 'clone') {
            this._hideClone();
            return;
        }
        if ($dbec57966acc54fe$var$cloneHidden) {
            $dbec57966acc54fe$var$pluginEvent('showClone', this);
            if ($dbec57966acc54fe$export$31b3ca70d8f57423.eventCanceled) return;
            // show clone at dragEl or original position
            if ($dbec57966acc54fe$var$dragEl.parentNode == $dbec57966acc54fe$var$rootEl && !this.options.group.revertClone) $dbec57966acc54fe$var$rootEl.insertBefore($dbec57966acc54fe$var$cloneEl, $dbec57966acc54fe$var$dragEl);
            else if ($dbec57966acc54fe$var$nextEl) $dbec57966acc54fe$var$rootEl.insertBefore($dbec57966acc54fe$var$cloneEl, $dbec57966acc54fe$var$nextEl);
            else $dbec57966acc54fe$var$rootEl.appendChild($dbec57966acc54fe$var$cloneEl);
            if (this.options.group.revertClone) this.animate($dbec57966acc54fe$var$dragEl, $dbec57966acc54fe$var$cloneEl);
            $dbec57966acc54fe$var$css($dbec57966acc54fe$var$cloneEl, 'display', '');
            $dbec57966acc54fe$var$cloneHidden = false;
        }
    }
};
function $dbec57966acc54fe$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = 'move';
    evt.cancelable && evt.preventDefault();
}
function $dbec57966acc54fe$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$dbec57966acc54fe$var$expando], onMoveFn = sortable.options.onMove, retVal;
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$dbec57966acc54fe$var$IE11OrLess && !$dbec57966acc54fe$var$Edge) evt = new CustomEvent('move', {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent('Event');
        evt.initEvent('move', true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $dbec57966acc54fe$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $dbec57966acc54fe$var$_disableDraggable(el) {
    el.draggable = false;
}
function $dbec57966acc54fe$var$_unsilent() {
    $dbec57966acc54fe$var$_silent = false;
}
function $dbec57966acc54fe$var$_ghostIsFirst(evt, vertical, sortable) {
    var firstElRect = $dbec57966acc54fe$var$getRect($dbec57966acc54fe$var$getChild(sortable.el, 0, sortable.options, true));
    var childContainingRect = $dbec57966acc54fe$var$getChildContainingRectFromElement(sortable.el, sortable.options, $dbec57966acc54fe$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function $dbec57966acc54fe$var$_ghostIsLast(evt, vertical, sortable) {
    var lastElRect = $dbec57966acc54fe$var$getRect($dbec57966acc54fe$var$lastChild(sortable.el, sortable.options.draggable));
    var childContainingRect = $dbec57966acc54fe$var$getChildContainingRectFromElement(sortable.el, sortable.options, $dbec57966acc54fe$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function $dbec57966acc54fe$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $dbec57966acc54fe$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$dbec57966acc54fe$var$pastFirstInvertThresh && ($dbec57966acc54fe$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $dbec57966acc54fe$var$pastFirstInvertThresh = true;
            if (!$dbec57966acc54fe$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($dbec57966acc54fe$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $dbec57966acc54fe$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $dbec57966acc54fe$var$targetMoveDistance) return -$dbec57966acc54fe$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $dbec57966acc54fe$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $dbec57966acc54fe$var$_getInsertDirection(target) {
    if ($dbec57966acc54fe$var$index($dbec57966acc54fe$var$dragEl) < $dbec57966acc54fe$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $dbec57966acc54fe$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $dbec57966acc54fe$var$_saveInputCheckedState(root) {
    $dbec57966acc54fe$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName('input');
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $dbec57966acc54fe$var$savedInputChecked.push(el);
    }
}
function $dbec57966acc54fe$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $dbec57966acc54fe$var$_cancelNextTick(id) {
    return clearTimeout(id);
}
// Fixed #973:
if ($dbec57966acc54fe$var$documentExists) $dbec57966acc54fe$var$on(document, 'touchmove', function(evt) {
    if (($dbec57966acc54fe$export$31b3ca70d8f57423.active || $dbec57966acc54fe$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
// Export utils
$dbec57966acc54fe$export$31b3ca70d8f57423.utils = {
    on: $dbec57966acc54fe$var$on,
    off: $dbec57966acc54fe$var$off,
    css: $dbec57966acc54fe$var$css,
    find: $dbec57966acc54fe$var$find,
    is: function is(el, selector) {
        return !!$dbec57966acc54fe$var$closest(el, selector, el, false);
    },
    extend: $dbec57966acc54fe$var$extend,
    throttle: $dbec57966acc54fe$var$throttle,
    closest: $dbec57966acc54fe$var$closest,
    toggleClass: $dbec57966acc54fe$var$toggleClass,
    clone: $dbec57966acc54fe$var$clone,
    index: $dbec57966acc54fe$var$index,
    nextTick: $dbec57966acc54fe$var$_nextTick,
    cancelNextTick: $dbec57966acc54fe$var$_cancelNextTick,
    detectDirection: $dbec57966acc54fe$var$_detectDirection,
    getChild: $dbec57966acc54fe$var$getChild,
    expando: $dbec57966acc54fe$var$expando
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $dbec57966acc54fe$export$31b3ca70d8f57423.get = function(element) {
    return element[$dbec57966acc54fe$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $dbec57966acc54fe$export$31b3ca70d8f57423.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $dbec57966acc54fe$export$31b3ca70d8f57423.utils = $dbec57966acc54fe$var$_objectSpread2($dbec57966acc54fe$var$_objectSpread2({}, $dbec57966acc54fe$export$31b3ca70d8f57423.utils), plugin.utils);
        $dbec57966acc54fe$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $dbec57966acc54fe$export$31b3ca70d8f57423.create = function(el, options) {
    return new $dbec57966acc54fe$export$31b3ca70d8f57423(el, options);
};
// Export
$dbec57966acc54fe$export$31b3ca70d8f57423.version = $dbec57966acc54fe$var$version;
var $dbec57966acc54fe$var$autoScrolls = [], $dbec57966acc54fe$var$scrollEl, $dbec57966acc54fe$var$scrollRootEl, $dbec57966acc54fe$var$scrolling = false, $dbec57966acc54fe$var$lastAutoScrollX, $dbec57966acc54fe$var$lastAutoScrollY, $dbec57966acc54fe$var$touchEvt$1, $dbec57966acc54fe$var$pointerElemChangedInterval;
function $dbec57966acc54fe$var$AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        };
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $dbec57966acc54fe$var$on(document, 'dragover', this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $dbec57966acc54fe$var$on(document, 'pointermove', this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $dbec57966acc54fe$var$on(document, 'touchmove', this._handleFallbackAutoScroll);
                else $dbec57966acc54fe$var$on(document, 'mousemove', this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $dbec57966acc54fe$var$off(document, 'dragover', this._handleAutoScroll);
            else {
                $dbec57966acc54fe$var$off(document, 'pointermove', this._handleFallbackAutoScroll);
                $dbec57966acc54fe$var$off(document, 'touchmove', this._handleFallbackAutoScroll);
                $dbec57966acc54fe$var$off(document, 'mousemove', this._handleFallbackAutoScroll);
            }
            $dbec57966acc54fe$var$clearPointerElemChangedInterval();
            $dbec57966acc54fe$var$clearAutoScrolls();
            $dbec57966acc54fe$var$cancelThrottle();
        },
        nulling: function nulling() {
            $dbec57966acc54fe$var$touchEvt$1 = $dbec57966acc54fe$var$scrollRootEl = $dbec57966acc54fe$var$scrollEl = $dbec57966acc54fe$var$scrolling = $dbec57966acc54fe$var$pointerElemChangedInterval = $dbec57966acc54fe$var$lastAutoScrollX = $dbec57966acc54fe$var$lastAutoScrollY = null;
            $dbec57966acc54fe$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $dbec57966acc54fe$var$touchEvt$1 = evt;
            // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $dbec57966acc54fe$var$Edge || $dbec57966acc54fe$var$IE11OrLess || $dbec57966acc54fe$var$Safari) {
                $dbec57966acc54fe$var$autoScroll(evt, this.options, elem, fallback);
                // Listener for pointer element change
                var ogElemScroller = $dbec57966acc54fe$var$getParentAutoScrollElement(elem, true);
                if ($dbec57966acc54fe$var$scrolling && (!$dbec57966acc54fe$var$pointerElemChangedInterval || x !== $dbec57966acc54fe$var$lastAutoScrollX || y !== $dbec57966acc54fe$var$lastAutoScrollY)) {
                    $dbec57966acc54fe$var$pointerElemChangedInterval && $dbec57966acc54fe$var$clearPointerElemChangedInterval();
                    // Detect for pointer elem change, emulating native DnD behaviour
                    $dbec57966acc54fe$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $dbec57966acc54fe$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $dbec57966acc54fe$var$clearAutoScrolls();
                        }
                        $dbec57966acc54fe$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $dbec57966acc54fe$var$lastAutoScrollX = x;
                    $dbec57966acc54fe$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $dbec57966acc54fe$var$getParentAutoScrollElement(elem, true) === $dbec57966acc54fe$var$getWindowScrollingElement()) {
                    $dbec57966acc54fe$var$clearAutoScrolls();
                    return;
                }
                $dbec57966acc54fe$var$autoScroll(evt, this.options, $dbec57966acc54fe$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $dbec57966acc54fe$var$_extends(AutoScroll, {
        pluginName: 'scroll',
        initializeByDefault: true
    });
}
function $dbec57966acc54fe$var$clearAutoScrolls() {
    $dbec57966acc54fe$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $dbec57966acc54fe$var$autoScrolls = [];
}
function $dbec57966acc54fe$var$clearPointerElemChangedInterval() {
    clearInterval($dbec57966acc54fe$var$pointerElemChangedInterval);
}
var $dbec57966acc54fe$var$autoScroll = $dbec57966acc54fe$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $dbec57966acc54fe$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn;
    // New scroll root, set scrollEl
    if ($dbec57966acc54fe$var$scrollRootEl !== rootEl) {
        $dbec57966acc54fe$var$scrollRootEl = rootEl;
        $dbec57966acc54fe$var$clearAutoScrolls();
        $dbec57966acc54fe$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($dbec57966acc54fe$var$scrollEl === true) $dbec57966acc54fe$var$scrollEl = $dbec57966acc54fe$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $dbec57966acc54fe$var$scrollEl;
    do {
        var el = currentParent, rect = $dbec57966acc54fe$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $dbec57966acc54fe$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
            canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
            canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$dbec57966acc54fe$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$dbec57966acc54fe$var$autoScrolls[i]) $dbec57966acc54fe$var$autoScrolls[i] = {};
        }
        if ($dbec57966acc54fe$var$autoScrolls[layersOut].vx != vx || $dbec57966acc54fe$var$autoScrolls[layersOut].vy != vy || $dbec57966acc54fe$var$autoScrolls[layersOut].el !== el) {
            $dbec57966acc54fe$var$autoScrolls[layersOut].el = el;
            $dbec57966acc54fe$var$autoScrolls[layersOut].vx = vx;
            $dbec57966acc54fe$var$autoScrolls[layersOut].vy = vy;
            clearInterval($dbec57966acc54fe$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $dbec57966acc54fe$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $dbec57966acc54fe$export$31b3ca70d8f57423.active._onTouchMove($dbec57966acc54fe$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $dbec57966acc54fe$var$autoScrolls[this.layer].vy ? $dbec57966acc54fe$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $dbec57966acc54fe$var$autoScrolls[this.layer].vx ? $dbec57966acc54fe$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === 'function') {
                        if (scrollCustomFn.call($dbec57966acc54fe$export$31b3ca70d8f57423.dragged.parentNode[$dbec57966acc54fe$var$expando], scrollOffsetX, scrollOffsetY, evt, $dbec57966acc54fe$var$touchEvt$1, $dbec57966acc54fe$var$autoScrolls[this.layer].el) !== 'continue') return;
                    }
                    $dbec57966acc54fe$var$scrollBy($dbec57966acc54fe$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $dbec57966acc54fe$var$getParentAutoScrollElement(currentParent, false)));
    $dbec57966acc54fe$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $dbec57966acc54fe$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent('spill');
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $dbec57966acc54fe$var$Revert() {}
$dbec57966acc54fe$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $dbec57966acc54fe$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $dbec57966acc54fe$var$drop
};
$dbec57966acc54fe$var$_extends($dbec57966acc54fe$var$Revert, {
    pluginName: 'revertOnSpill'
});
function $dbec57966acc54fe$var$Remove() {}
$dbec57966acc54fe$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $dbec57966acc54fe$var$drop
};
$dbec57966acc54fe$var$_extends($dbec57966acc54fe$var$Remove, {
    pluginName: 'removeOnSpill'
});
var $dbec57966acc54fe$var$lastSwapEl;
function $dbec57966acc54fe$export$bdb5f0a1b77546f4() {
    function Swap() {
        this.defaults = {
            swapClass: 'sortable-swap-highlight'
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $dbec57966acc54fe$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $dbec57966acc54fe$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $dbec57966acc54fe$var$toggleClass(target, options.swapClass, true);
                    $dbec57966acc54fe$var$lastSwapEl = target;
                } else $dbec57966acc54fe$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $dbec57966acc54fe$var$lastSwapEl) $dbec57966acc54fe$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $dbec57966acc54fe$var$lastSwapEl && $dbec57966acc54fe$var$toggleClass($dbec57966acc54fe$var$lastSwapEl, options.swapClass, false);
            if ($dbec57966acc54fe$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $dbec57966acc54fe$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $dbec57966acc54fe$var$swapNodes(dragEl, $dbec57966acc54fe$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $dbec57966acc54fe$var$lastSwapEl = null;
        }
    };
    return $dbec57966acc54fe$var$_extends(Swap, {
        pluginName: 'swap',
        eventProperties: function eventProperties() {
            return {
                swapItem: $dbec57966acc54fe$var$lastSwapEl
            };
        }
    });
}
function $dbec57966acc54fe$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $dbec57966acc54fe$var$index(n1);
    i2 = $dbec57966acc54fe$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $dbec57966acc54fe$var$multiDragElements = [], $dbec57966acc54fe$var$multiDragClones = [], $dbec57966acc54fe$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$dbec57966acc54fe$var$multiDragSortable, $dbec57966acc54fe$var$initialFolding = false, // Initial multi-drag fold when drag started
$dbec57966acc54fe$var$folding = false, // Folding any other time
$dbec57966acc54fe$var$dragStarted = false, $dbec57966acc54fe$var$dragEl$1, $dbec57966acc54fe$var$clonesFromRect, $dbec57966acc54fe$var$clonesHidden;
function $dbec57966acc54fe$export$18e5d2a5d1df842d() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) $dbec57966acc54fe$var$on(document, 'pointerup', this._deselectMultiDrag);
            else {
                $dbec57966acc54fe$var$on(document, 'mouseup', this._deselectMultiDrag);
                $dbec57966acc54fe$var$on(document, 'touchend', this._deselectMultiDrag);
            }
        }
        $dbec57966acc54fe$var$on(document, 'keydown', this._checkKeyDown);
        $dbec57966acc54fe$var$on(document, 'keyup', this._checkKeyUp);
        this.defaults = {
            selectedClass: 'sortable-selected',
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = '';
                if ($dbec57966acc54fe$var$multiDragElements.length && $dbec57966acc54fe$var$multiDragSortable === sortable) $dbec57966acc54fe$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? '' : ', ') + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData('Text', data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $dbec57966acc54fe$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$dbec57966acc54fe$var$multiDragElements.indexOf($dbec57966acc54fe$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $dbec57966acc54fe$var$multiDragElements.length; i++){
                $dbec57966acc54fe$var$multiDragClones.push($dbec57966acc54fe$var$clone($dbec57966acc54fe$var$multiDragElements[i]));
                $dbec57966acc54fe$var$multiDragClones[i].sortableIndex = $dbec57966acc54fe$var$multiDragElements[i].sortableIndex;
                $dbec57966acc54fe$var$multiDragClones[i].draggable = false;
                $dbec57966acc54fe$var$multiDragClones[i].style['will-change'] = '';
                $dbec57966acc54fe$var$toggleClass($dbec57966acc54fe$var$multiDragClones[i], this.options.selectedClass, false);
                $dbec57966acc54fe$var$multiDragElements[i] === $dbec57966acc54fe$var$dragEl$1 && $dbec57966acc54fe$var$toggleClass($dbec57966acc54fe$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($dbec57966acc54fe$var$multiDragElements.length && $dbec57966acc54fe$var$multiDragSortable === sortable) {
                    $dbec57966acc54fe$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent('clone');
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $dbec57966acc54fe$var$insertMultiDragClones(false, rootEl);
            $dbec57966acc54fe$var$multiDragClones.forEach(function(clone) {
                $dbec57966acc54fe$var$css(clone, 'display', '');
            });
            cloneNowShown();
            $dbec57966acc54fe$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $dbec57966acc54fe$var$multiDragClones.forEach(function(clone) {
                $dbec57966acc54fe$var$css(clone, 'display', 'none');
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $dbec57966acc54fe$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $dbec57966acc54fe$var$multiDragSortable) $dbec57966acc54fe$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $dbec57966acc54fe$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $dbec57966acc54fe$var$index(multiDragElement);
            });
            // Sort multi-drag elements
            $dbec57966acc54fe$var$multiDragElements = $dbec57966acc54fe$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $dbec57966acc54fe$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $dbec57966acc54fe$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $dbec57966acc54fe$var$dragEl$1) return;
                        $dbec57966acc54fe$var$css(multiDragElement, 'position', 'absolute');
                    });
                    var dragRect = $dbec57966acc54fe$var$getRect($dbec57966acc54fe$var$dragEl$1, false, true, true);
                    $dbec57966acc54fe$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $dbec57966acc54fe$var$dragEl$1) return;
                        $dbec57966acc54fe$var$setRect(multiDragElement, dragRect);
                    });
                    $dbec57966acc54fe$var$folding = true;
                    $dbec57966acc54fe$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $dbec57966acc54fe$var$folding = false;
                $dbec57966acc54fe$var$initialFolding = false;
                if (_this2.options.animation) $dbec57966acc54fe$var$multiDragElements.forEach(function(multiDragElement) {
                    $dbec57966acc54fe$var$unsetRect(multiDragElement);
                });
                // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $dbec57966acc54fe$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($dbec57966acc54fe$var$folding && ~$dbec57966acc54fe$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($dbec57966acc54fe$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $dbec57966acc54fe$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $dbec57966acc54fe$var$folding ? $dbec57966acc54fe$var$getRect(multiDragElement) : dragRect
                    });
                    $dbec57966acc54fe$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $dbec57966acc54fe$var$folding = false;
                $dbec57966acc54fe$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $dbec57966acc54fe$var$initialFolding = false;
                // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $dbec57966acc54fe$var$multiDragElements.length > 1 && ($dbec57966acc54fe$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $dbec57966acc54fe$var$getRect($dbec57966acc54fe$var$dragEl$1, false, true, true);
                    $dbec57966acc54fe$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $dbec57966acc54fe$var$dragEl$1) return;
                        $dbec57966acc54fe$var$setRect(multiDragElement, dragRectAbsolute);
                        // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $dbec57966acc54fe$var$folding = true;
                }
                // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$dbec57966acc54fe$var$folding) $dbec57966acc54fe$var$removeMultiDragElements();
                    if ($dbec57966acc54fe$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $dbec57966acc54fe$var$clonesHidden;
                        activeSortable._showClone(sortable);
                        // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$dbec57966acc54fe$var$clonesHidden && clonesHiddenBefore) $dbec57966acc54fe$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $dbec57966acc54fe$var$clonesFromRect
                            });
                            clone.fromRect = $dbec57966acc54fe$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $dbec57966acc54fe$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $dbec57966acc54fe$var$clonesFromRect = $dbec57966acc54fe$var$_extends({}, dragRect);
                var dragMatrix = $dbec57966acc54fe$var$matrix($dbec57966acc54fe$var$dragEl$1, true);
                $dbec57966acc54fe$var$clonesFromRect.top -= dragMatrix.f;
                $dbec57966acc54fe$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($dbec57966acc54fe$var$folding) {
                $dbec57966acc54fe$var$folding = false;
                $dbec57966acc54fe$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children;
            // Multi-drag selection
            if (!$dbec57966acc54fe$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $dbec57966acc54fe$var$toggleClass($dbec57966acc54fe$var$dragEl$1, options.selectedClass, !~$dbec57966acc54fe$var$multiDragElements.indexOf($dbec57966acc54fe$var$dragEl$1));
                if (!~$dbec57966acc54fe$var$multiDragElements.indexOf($dbec57966acc54fe$var$dragEl$1)) {
                    $dbec57966acc54fe$var$multiDragElements.push($dbec57966acc54fe$var$dragEl$1);
                    $dbec57966acc54fe$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: 'select',
                        targetEl: $dbec57966acc54fe$var$dragEl$1,
                        originalEvent: evt
                    });
                    // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $dbec57966acc54fe$var$lastMultiDragSelect && sortable.el.contains($dbec57966acc54fe$var$lastMultiDragSelect)) {
                        var lastIndex = $dbec57966acc54fe$var$index($dbec57966acc54fe$var$lastMultiDragSelect), currentIndex = $dbec57966acc54fe$var$index($dbec57966acc54fe$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) (function() {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            var filter = options.filter;
                            for(; i < n; i++){
                                if (~$dbec57966acc54fe$var$multiDragElements.indexOf(children[i])) continue;
                                // Check if element is draggable
                                if (!$dbec57966acc54fe$var$closest(children[i], options.draggable, parentEl, false)) continue;
                                // Check if element is filtered
                                var filtered = filter && (typeof filter === 'function' ? filter.call(sortable, evt, children[i], sortable) : filter.split(',').some(function(criteria) {
                                    return $dbec57966acc54fe$var$closest(children[i], criteria.trim(), parentEl, false);
                                }));
                                if (filtered) continue;
                                $dbec57966acc54fe$var$toggleClass(children[i], options.selectedClass, true);
                                $dbec57966acc54fe$var$multiDragElements.push(children[i]);
                                $dbec57966acc54fe$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: 'select',
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        })();
                    } else $dbec57966acc54fe$var$lastMultiDragSelect = $dbec57966acc54fe$var$dragEl$1;
                    $dbec57966acc54fe$var$multiDragSortable = toSortable;
                } else {
                    $dbec57966acc54fe$var$multiDragElements.splice($dbec57966acc54fe$var$multiDragElements.indexOf($dbec57966acc54fe$var$dragEl$1), 1);
                    $dbec57966acc54fe$var$lastMultiDragSelect = null;
                    $dbec57966acc54fe$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: 'deselect',
                        targetEl: $dbec57966acc54fe$var$dragEl$1,
                        originalEvent: evt
                    });
                }
            }
            // Multi-drag drop
            if ($dbec57966acc54fe$var$dragStarted && this.isMultiDrag) {
                $dbec57966acc54fe$var$folding = false;
                // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$dbec57966acc54fe$var$expando].options.sort || parentEl !== rootEl) && $dbec57966acc54fe$var$multiDragElements.length > 1) {
                    var dragRect = $dbec57966acc54fe$var$getRect($dbec57966acc54fe$var$dragEl$1), multiDragIndex = $dbec57966acc54fe$var$index($dbec57966acc54fe$var$dragEl$1, ':not(.' + this.options.selectedClass + ')');
                    if (!$dbec57966acc54fe$var$initialFolding && options.animation) $dbec57966acc54fe$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$dbec57966acc54fe$var$initialFolding) {
                        if (options.animation) {
                            $dbec57966acc54fe$var$dragEl$1.fromRect = dragRect;
                            $dbec57966acc54fe$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $dbec57966acc54fe$var$dragEl$1) {
                                    var rect = $dbec57966acc54fe$var$folding ? $dbec57966acc54fe$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect;
                                    // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        }
                        // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $dbec57966acc54fe$var$removeMultiDragElements();
                        $dbec57966acc54fe$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        });
                        // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $dbec57966acc54fe$var$index($dbec57966acc54fe$var$dragEl$1)) {
                            var update = false;
                            $dbec57966acc54fe$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $dbec57966acc54fe$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) {
                                dispatchSortableEvent('update');
                                dispatchSortableEvent('sort');
                            }
                        }
                    }
                    // Must be done after capturing individual rects (scroll bar)
                    $dbec57966acc54fe$var$multiDragElements.forEach(function(multiDragElement) {
                        $dbec57966acc54fe$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $dbec57966acc54fe$var$multiDragSortable = toSortable;
            }
            // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') $dbec57966acc54fe$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $dbec57966acc54fe$var$dragStarted = false;
            $dbec57966acc54fe$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $dbec57966acc54fe$var$off(document, 'pointerup', this._deselectMultiDrag);
            $dbec57966acc54fe$var$off(document, 'mouseup', this._deselectMultiDrag);
            $dbec57966acc54fe$var$off(document, 'touchend', this._deselectMultiDrag);
            $dbec57966acc54fe$var$off(document, 'keydown', this._checkKeyDown);
            $dbec57966acc54fe$var$off(document, 'keyup', this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $dbec57966acc54fe$var$dragStarted !== "undefined" && $dbec57966acc54fe$var$dragStarted) return;
            // Only deselect if selection is in this sortable
            if ($dbec57966acc54fe$var$multiDragSortable !== this.sortable) return;
            // Only deselect if target is not item in this sortable
            if (evt && $dbec57966acc54fe$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return;
            // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($dbec57966acc54fe$var$multiDragElements.length){
                var el = $dbec57966acc54fe$var$multiDragElements[0];
                $dbec57966acc54fe$var$toggleClass(el, this.options.selectedClass, false);
                $dbec57966acc54fe$var$multiDragElements.shift();
                $dbec57966acc54fe$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: 'deselect',
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $dbec57966acc54fe$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: 'multiDrag',
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$dbec57966acc54fe$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$dbec57966acc54fe$var$multiDragElements.indexOf(el)) return;
                if ($dbec57966acc54fe$var$multiDragSortable && $dbec57966acc54fe$var$multiDragSortable !== sortable) {
                    $dbec57966acc54fe$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $dbec57966acc54fe$var$multiDragSortable = sortable;
                }
                $dbec57966acc54fe$var$toggleClass(el, sortable.options.selectedClass, true);
                $dbec57966acc54fe$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$dbec57966acc54fe$var$expando], index = $dbec57966acc54fe$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                $dbec57966acc54fe$var$toggleClass(el, sortable.options.selectedClass, false);
                $dbec57966acc54fe$var$multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $dbec57966acc54fe$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                });
                // multiDragElements will already be sorted if folding
                var newIndex;
                if ($dbec57966acc54fe$var$folding && multiDragElement !== $dbec57966acc54fe$var$dragEl$1) newIndex = -1;
                else if ($dbec57966acc54fe$var$folding) newIndex = $dbec57966acc54fe$var$index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
                else newIndex = $dbec57966acc54fe$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $dbec57966acc54fe$var$_toConsumableArray($dbec57966acc54fe$var$multiDragElements),
                clones: [].concat($dbec57966acc54fe$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === 'ctrl') key = 'Control';
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $dbec57966acc54fe$var$insertMultiDragElements(clonesInserted, rootEl) {
    $dbec57966acc54fe$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $dbec57966acc54fe$var$insertMultiDragClones(elementsInserted, rootEl) {
    $dbec57966acc54fe$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $dbec57966acc54fe$var$removeMultiDragElements() {
    $dbec57966acc54fe$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $dbec57966acc54fe$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
$dbec57966acc54fe$export$31b3ca70d8f57423.mount(new $dbec57966acc54fe$var$AutoScrollPlugin());
$dbec57966acc54fe$export$31b3ca70d8f57423.mount($dbec57966acc54fe$var$Remove, $dbec57966acc54fe$var$Revert);
var $dbec57966acc54fe$export$2e2bcd8739ae039 = $dbec57966acc54fe$export$31b3ca70d8f57423;



var $entK4 = parcelRequire("entK4");
class $978543261cadeb8d$export$e516135c113cb170 {
    constructor(){
        this.items = [];
        this.activeItemId = null;
        this.itemIdCounter = 0;
        this.sortable = null;
        this.selectedCustomer = null;
        this._bulkRecalculating = false;
        // Původ typu ceny: 'customer' = odvozeno od vybraného odběratele,
        // 'manual' = uživatel přepnul ručně (override).
        this.typCenySource = 'manual';
        this.init();
    }
    init() {
        // Vytvoření první položky s aktuálním stavem formuláře
        const currentFormState = this.saveCurrentFormState();
        const firstItem = {
            id: ++this.itemIdCounter,
            name: this.generateItemName(),
            formData: currentFormState,
            price: 0,
            pricePerPiece: 0
        };
        this.items.push(firstItem);
        this.activeItemId = firstItem.id;
        // Event listenery
        this.setupEventListeners();
        // Vykreslit položky
        this.renderItems();
        // Aktualizovat celkovou cenu
        this.updateTotalPrice();
    }
    setupEventListeners() {
        // Tlačítko pro přidání položky
        const addButton = document.getElementById('pridatPolozku');
        if (addButton) addButton.addEventListener('click', ()=>this.addItem());
        // Tlačítko pro vytvoření nabídky
        const createOfferButton = document.getElementById('vytvorNabidku');
        if (createOfferButton) createOfferButton.addEventListener('click', ()=>this.createOffer());
        // Změna typu ceny (maloobchodní/velkoobchodní) – globální pro celou nabídku:
        // přepočítáme všechny položky a sečteme je. stopPropagation zabrání tomu,
        // aby se spustil i běžný change-listener na formuláři #ceny (ten by přepočítal
        // jen aktivní položku). Pozor: restoreFormState nastavuje typCeny programově
        // (při _applyingPreset) – tehdy listener ignorujeme, jinak by došlo k rekurzi.
        // Vizuální stav segmentovaného toggle se ale synchronizuje vždy.
        const typCenySelect = document.getElementById('typCeny');
        if (typCenySelect) typCenySelect.addEventListener('change', (e)=>{
            this.syncTypCenyToggle();
            if (window._applyingPreset || this._bulkRecalculating) return;
            e.stopPropagation();
            this.recalculateAllItems(e.target.value);
        });
        // Segmentovaný toggle – vizuální řadič nad skrytým selectem #typCeny.
        const typCenyToggle = document.getElementById('typCenyToggle');
        if (typCenyToggle) typCenyToggle.querySelectorAll('.typ-ceny-btn').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                if (window._applyingPreset || this._bulkRecalculating) return;
                const value = btn.dataset.typCeny;
                if (!value) return;
                if (typCenySelect && typCenySelect.value !== value) {
                    this.typCenySource = 'manual';
                    typCenySelect.value = value;
                    typCenySelect.dispatchEvent(new Event('change', {
                        bubbles: true
                    }));
                } else this.syncTypCenyToggle();
            });
        });
        // Iniciální vizuální stav toggle
        this.syncTypCenyToggle();
        // Vyhledávání odběratele v tabu "Dodání a fakturace"
        this.setupCustomerSearch();
    }
    // ----- Vyhledávač odběratele -----
    setupCustomerSearch() {
        const input = document.getElementById('vyhledatOdberatele');
        const resultsBox = document.getElementById('vyhledatOdberateleResults');
        if (!input || !resultsBox) return;
        let debounceTimer = null;
        let lastQuery = '';
        let activeRequestToken = 0;
        const hideResults = ()=>{
            resultsBox.classList.add('hidden');
            resultsBox.innerHTML = '';
        };
        const showResults = (html)=>{
            resultsBox.innerHTML = html;
            resultsBox.classList.remove('hidden');
        };
        const runSearch = async (query)=>{
            const trimmed = query.trim();
            if (trimmed.length < 2) {
                hideResults();
                return;
            }
            if (trimmed === lastQuery) return;
            lastQuery = trimmed;
            if (!window.customersManager) {
                showResults(`<div class="px-4 py-3 text-sm text-gray-500">Spr\xe1va z\xe1kazn\xedk\u{16F} nen\xed dostupn\xe1.</div>`);
                return;
            }
            const token = ++activeRequestToken;
            try {
                const customers = await window.customersManager.fetchCustomers(trimmed);
                if (token !== activeRequestToken) return;
                if (!customers.length) {
                    showResults(`<div class="px-4 py-3 text-sm text-gray-500">\u{17D}\xe1dn\xfd odb\u{11B}ratel neodpov\xedd\xe1 \u{201E}${this.escapeHtml(trimmed)}".</div>`);
                    return;
                }
                const html = customers.slice(0, 10).map((c, i)=>`
          <button type="button" data-customer-idx="${i}"
            class="w-full text-left px-4 py-2.5 hover:bg-blue-50 focus:bg-blue-50 focus:outline-none border-b border-gray-100 last:border-b-0 transition-colors">
            <div class="flex items-center justify-between gap-3">
              <div class="min-w-0 flex-1">
                <div class="text-sm font-medium text-gray-900 truncate">${this.escapeHtml(c.name || "(bez n\xe1zvu)")}</div>
                <div class="mt-0.5 text-xs text-gray-500 truncate">
                  ${[
                        c.ico ? `I\u{10C}O ${this.escapeHtml(c.ico)}` : '',
                        c.city ? this.escapeHtml(c.city) : '',
                        c.email ? this.escapeHtml(c.email) : ''
                    ].filter(Boolean).join(" \xb7 ")}
                </div>
              </div>
              <span class="shrink-0 text-[11px] px-2 py-0.5 rounded-full ${c.type === 'person' ? 'bg-purple-100 text-purple-700' : 'bg-blue-100 text-blue-700'}">
                ${c.type === 'person' ? 'Osoba' : 'Firma'}
              </span>
            </div>
          </button>
        `).join('');
                showResults(html);
                resultsBox.querySelectorAll('[data-customer-idx]').forEach((btn)=>{
                    btn.addEventListener('click', ()=>{
                        const idx = Number(btn.dataset.customerIdx);
                        const customer = customers[idx];
                        if (customer) this.selectCustomer(customer);
                        hideResults();
                    });
                });
            } catch (err) {
                if (token !== activeRequestToken) return;
                const msg = err?.message || "Chyba p\u0159i vyhled\xe1v\xe1n\xed z\xe1kazn\xedka";
                showResults(`<div class="px-4 py-3 text-sm text-red-600">${this.escapeHtml(msg)}</div>`);
            }
        };
        input.addEventListener('input', ()=>{
            const value = input.value;
            if (debounceTimer) clearTimeout(debounceTimer);
            debounceTimer = setTimeout(()=>runSearch(value), 250);
        });
        input.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape') hideResults();
        });
        // Klik mimo dropdown ho zavře
        document.addEventListener('click', (e)=>{
            if (!resultsBox.contains(e.target) && e.target !== input) hideResults();
        });
    }
    // Synchronizace vizuálního stavu segmentovaného toggle Typ ceny se skrytým
    // selectem #typCeny. Zároveň zobrazí hint, pokud je typ ceny odvozen od
    // vybraného zákazníka.
    syncTypCenyToggle() {
        const select = document.getElementById('typCeny');
        const toggle = document.getElementById('typCenyToggle');
        const hint = document.getElementById('typCenyHint');
        if (!select || !toggle) return;
        const value = select.value || 'velko';
        toggle.querySelectorAll('.typ-ceny-btn').forEach((btn)=>{
            const active = btn.dataset.typCeny === value;
            btn.classList.toggle('bg-green-600', active);
            btn.classList.toggle('text-white', active);
            btn.classList.toggle('text-gray-600', !active);
            btn.classList.toggle('hover:text-gray-900', !active);
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (hint) hint.textContent = this.typCenySource === 'customer' ? "odvozeno od z\xe1kazn\xedka" : '';
    }
    selectCustomer(customer) {
        if (!customer) return;
        this.selectedCustomer = customer;
        // Vyplnit fakturační pole v aktivní položce
        const fakturaceEl = document.getElementById('fakturace');
        if (fakturaceEl && window.CustomersManager) fakturaceEl.value = window.CustomersManager.formatCustomerToText(customer);
        const fakturaMailEl = document.getElementById('fakturaMail');
        if (fakturaMailEl) fakturaMailEl.value = customer.email || '';
        const telefonEl = document.getElementById('telefonDoprava');
        if (telefonEl) telefonEl.value = customer.phone || '';
        // Odvodit typ ceny z cenové úrovně zákazníka (velko/malo) a přepočítat
        // celou nabídku. Source of truth je skrytý select #typCeny.
        const tier = customer.pricingTier === 'malo' ? 'malo' : 'velko';
        const typCenySelect = document.getElementById('typCeny');
        if (typCenySelect) {
            this.typCenySource = 'customer';
            if (typCenySelect.value !== tier) {
                typCenySelect.value = tier;
                typCenySelect.dispatchEvent(new Event('change', {
                    bubbles: true
                }));
            } else this.syncTypCenyToggle();
        }
        // Reset vyhledávacího inputu a zobrazit chip
        const input = document.getElementById('vyhledatOdberatele');
        if (input) input.value = '';
        this.renderSelectedCustomer();
        // Uložit do aktivní položky, aby se při přepnutí/uložení zachovalo
        if (this.activeItemId) {
            const current = this.items.find((i)=>i.id === this.activeItemId);
            if (current) current.formData = this.saveCurrentFormState();
        }
    }
    clearSelectedCustomer() {
        this.selectedCustomer = null;
        // Bez zákazníka už typ ceny není odvozen – přepnutí zpět na manuální.
        this.typCenySource = 'manual';
        this.syncTypCenyToggle();
        this.renderSelectedCustomer();
    }
    renderSelectedCustomer() {
        const box = document.getElementById('vybranyOdberatel');
        if (!box) return;
        if (!this.selectedCustomer) {
            box.classList.add('hidden');
            box.innerHTML = '';
            return;
        }
        const c = this.selectedCustomer;
        const meta = [
            c.ico ? `I\u{10C}O ${this.escapeHtml(c.ico)}` : '',
            c.dic ? `DI\u{10C} ${this.escapeHtml(c.dic)}` : '',
            c.city ? this.escapeHtml(c.city) : ''
        ].filter(Boolean).join(" \xb7 ");
        box.classList.remove('hidden');
        box.innerHTML = `
      <div class="flex items-start justify-between gap-3">
        <div class="min-w-0 flex-1">
          <div class="flex items-center gap-2 flex-wrap">
            <span class="text-sm font-semibold text-gray-900 truncate">${this.escapeHtml(c.name || '')}</span>
            <span class="text-[11px] px-2 py-0.5 rounded-full ${c.type === 'person' ? 'bg-purple-100 text-purple-700' : 'bg-blue-100 text-blue-700'}">
              ${c.type === 'person' ? 'Osoba' : 'Firma'}
            </span>
            <span class="text-[11px] px-2 py-0.5 rounded-full ${c.pricingTier === 'malo' ? 'bg-amber-100 text-amber-700' : 'bg-emerald-100 text-emerald-700'}" title="Cenov\xe1 \xfarove\u{148} z\xe1kazn\xedka">
              ${c.pricingTier === 'malo' ? 'Maloobchod' : 'Velkoobchod'}
            </span>
          </div>
          ${meta ? `<div class="mt-0.5 text-xs text-gray-600">${meta}</div>` : ''}
          ${c.email || c.phone ? `<div class="mt-0.5 text-xs text-gray-500">${[
            c.email ? this.escapeHtml(c.email) : '',
            c.phone ? this.escapeHtml(c.phone) : ''
        ].filter(Boolean).join(" \xb7 ")}</div>` : ''}
        </div>
        <button type="button" id="odebratOdberatele"
          class="shrink-0 p-1 text-gray-400 hover:text-red-600 focus:outline-none"
          title="Odebrat vybran\xe9ho odb\u{11B}ratele">
          ${(0, $entK4.icon)('x-mark', 'w-4 h-4')}
        </button>
      </div>
    `;
        document.getElementById('odebratOdberatele')?.addEventListener('click', ()=>this.clearSelectedCustomer());
    }
    // Přidání nové položky s výchozími hodnotami
    addItem() {
        const itemId = ++this.itemIdCounter;
        const currentFormState = this.saveCurrentFormState();
        // Uložit stav aktuální položky
        if (this.activeItemId) {
            const currentItem = this.items.find((item)=>item.id === this.activeItemId);
            if (currentItem) currentItem.formData = currentFormState;
        }
        // Vytvořit novou položku s výchozími hodnotami
        const defaultFormData = this.getDefaultFormData();
        const newItem = {
            id: itemId,
            name: this.generateDefaultItemName(),
            formData: defaultFormData,
            price: 0,
            pricePerPiece: 0
        };
        this.items.push(newItem);
        this.activeItemId = itemId;
        // Načíst výchozí hodnoty do formuláře
        this.restoreFormState(defaultFormData);
        this.renderItems();
    }
    // Duplikování aktuální položky
    duplicateItem(itemId) {
        const sourcItem = this.items.find((item)=>item.id === itemId);
        if (!sourcItem) return;
        const newItemId = ++this.itemIdCounter;
        const currentFormState = this.saveCurrentFormState();
        // Uložit aktuální stav do zdrojové položky pokud je aktivní
        if (this.activeItemId === itemId) sourcItem.formData = currentFormState;
        // Vytvořit duplikát s kopií dat ze zdrojové položky
        const newItem = {
            id: newItemId,
            name: sourcItem.name,
            formData: {
                ...sourcItem.formData
            },
            price: 0,
            pricePerPiece: 0
        };
        this.items.push(newItem);
        this.activeItemId = newItemId;
        // Načíst data duplikátu do formuláře
        this.restoreFormState(newItem.formData);
        this.renderItems();
    }
    // Odstranění položky
    removeItem(itemId) {
        if (this.items.length <= 1) return; // Nelze odstranit poslední položku
        const index = this.items.findIndex((item)=>item.id === itemId);
        if (index > -1) {
            this.items.splice(index, 1);
            // Pokud byla odstraněna aktivní položka, aktivovat jinou
            if (this.activeItemId === itemId) {
                this.activeItemId = this.items[0].id;
                this.switchToItem(this.activeItemId);
            }
            this.renderItems();
            this.updateTotalPrice();
        }
    }
    // Přepnutí na jinou položku
    switchToItem(itemId) {
        if (this.activeItemId === itemId) return;
        // Uložit aktuální stav formuláře
        if (this.activeItemId) {
            const currentItem = this.items.find((item)=>item.id === this.activeItemId);
            if (currentItem) currentItem.formData = this.saveCurrentFormState();
        }
        // Přepnout na novou položku
        const newItem = this.items.find((item)=>item.id === itemId);
        if (newItem) {
            this.activeItemId = itemId;
            this.restoreFormState(newItem.formData);
            this.renderItems();
        }
    }
    // Aktualizace ceny položky
    updateItemPrice(price, pricePerPiece, debugInfo, calculationResult = null) {
        const currentItem = this.items.find((item)=>item.id === this.activeItemId);
        if (currentItem) {
            currentItem.price = price;
            currentItem.pricePerPiece = pricePerPiece;
            currentItem.debugInfo = debugInfo;
            if (calculationResult) currentItem.calculationResult = calculationResult;
            // Aktualizovat název položky podle nového formátu
            currentItem.name = this.generateItemName();
            // Během hromadného přepočtu (změna typu ceny pro celou nabídku)
            // vykreslování a aktualizaci celkové ceny potlačíme – provede se
            // najednou až na konci v recalculateAllItems().
            if (this._bulkRecalculating) return;
            this.renderItems();
            this.updateTotalPrice();
        }
    }
    // Generování výchozího názvu položky
    generateDefaultItemName() {
        const defaultData = this.getDefaultFormData();
        // Základní název s výchozími hodnotami
        let nameParts = [];
        // Počet kusů
        nameParts.push(`${defaultData.pocetKusu}ks`);
        // Formát A4
        nameParts.push("A4 (210\xd7297 mm)");
        // Barevnost 4/4
        nameParts.push('4/4');
        // Materiál (najdeme v selectu)
        const materialSelect = document.getElementById('material');
        if (materialSelect) {
            const defaultOption = materialSelect.querySelector(`option[value="${defaultData.material}"]`);
            if (defaultOption) nameParts.push(defaultOption.text);
            else nameParts.push("V\xfdchoz\xed materi\xe1l");
        }
        return nameParts.join(', ');
    }
    // Generování názvu položky ve formátu stejném jako "Výsledek kalkulace"
    generateItemName() {
        const nazev = document.getElementById('nazev')?.value?.trim();
        const pocet = document.getElementById('pocetKusu')?.value || '0';
        const format = document.getElementById('produktRozmerFormat');
        const pocetBarev = document.getElementById('pocetBarev');
        const material = document.getElementById('material');
        // Sestavit základní část názvu
        let nameParts = [];
        // Počet kusů
        nameParts.push(`${pocet}ks`);
        // Formát s rozměry
        if (format) {
            const selectedOption = format.options[format.selectedIndex];
            if (selectedOption) {
                const formatText = selectedOption.text;
                if (format.value === 'vlastni') {
                    const vlastniSirka = document.getElementById('produktRozmerSirka')?.value || '0';
                    const vlastniVyska = document.getElementById('produktRozmerVyska')?.value || '0';
                    nameParts.push(`Vlastn\xed (${vlastniSirka}\xd7${vlastniVyska} mm)`);
                } else // formatText už obsahuje rozměry z HTML (např. "A3 (297×420 mm)")
                nameParts.push(formatText);
            }
        }
        // Barevnost s PANTONE barvami (připojené bez čárky)
        if (pocetBarev) {
            const selectedOption = pocetBarev.options[pocetBarev.selectedIndex];
            if (selectedOption) {
                let barevnostText = selectedOption.text;
                // Přidat PANTONE barvy pokud jsou vyplněné (připojené k barevnosti)
                const primeBarvy = document.getElementById('primeBarvy')?.value;
                if (primeBarvy && primeBarvy !== '0') {
                    const pocetPrimeBarev = parseInt(primeBarvy);
                    if (pocetPrimeBarev === 1) barevnostText += ' + 1 PANTONE';
                    else if (pocetPrimeBarev > 1) barevnostText += ` + ${pocetPrimeBarev} PANTONE`;
                }
                nameParts.push(barevnostText);
            }
        }
        // Materiál na konec. Dokončovací operace (lakování, laminace, bigování, …)
        // se do jména NEDOSTÁVAJÍ – zobrazují se samostatně pod názvem jako menší
        // šedý výpis (viz OfferEditorManager.formatItemSpecification).
        if (material) {
            const selectedOption = material.options[material.selectedIndex];
            if (selectedOption) {
                const materialText = selectedOption.text;
                // materialText už obsahuje gramáž z databáze (např. "Ofset 80 g/m²")
                nameParts.push(materialText);
            }
        }
        const baseName = nameParts.join(', ');
        // Pokud je vyplněný název zakázky, přidat ho na začátek
        if (nazev) return `${nazev}: ${baseName}`;
        else return baseName;
    }
    // Hromadný přepočet všech položek nabídky při změně typu ceny
    // (maloobchodní/velkoobchodní). typCeny je globální pro celou nabídku:
    // přepíná se jedním selectem, ale přepočítají se všechny položky a z nich
    // se teprve sčítá celková cena nabídky.
    async recalculateAllItems(newTypCeny) {
        if (this._bulkRecalculating) return;
        const originalActiveId = this.activeItemId;
        // Uložit aktuální živý stav formuláře do aktivní položky. Je to nutné,
        // protože formulář se do formData aktivní položky běžně ukládá až při
        // přepnutí/přidání položky – aktivní položka by tak měla zastaralá data
        // (např. materiál změněný uživatelem) a obnova by ho přepsala výchozím.
        if (this.activeItemId) {
            const current = this.items.find((i)=>i.id === this.activeItemId);
            if (current) current.formData = this.saveCurrentFormState();
        }
        // Synchronizovat typ ceny ve všech položkách (aby při pozdějším přepnutí
        // aktivní položky select ukazoval stejnou hodnotu).
        this.items.forEach((item)=>{
            if (item.formData) item.formData.typCeny = newTypCeny;
        });
        this._bulkRecalculating = true;
        try {
            // Postupně načíst formulář pro každou položku, přepočítat a uložit její cenu.
            for (const item of this.items){
                this.activeItemId = item.id;
                const promise = this.restoreFormState(item.formData);
                if (promise) await promise;
            }
        } finally{
            this._bulkRecalculating = false;
        }
        // Obnovit původně aktivní položku do formuláře a překreslit seznam.
        this.activeItemId = originalActiveId;
        const original = this.items.find((i)=>i.id === originalActiveId);
        if (original) this.restoreFormState(original.formData);
        this.renderItems();
        this.updateTotalPrice();
    }
    // Pomocná funkce pro získání textů dodatečných služeb
    getAdditionalServicesText() {
        const dodatecneUpravy = [];
        // Digitální speciální barvy
        const barvyDigital = document.getElementById('barvyDigital')?.value;
        if (barvyDigital && barvyDigital !== '0') {
            const digitalText = this.getDigitalColorName(barvyDigital);
            if (digitalText) dodatecneUpravy.push(`Digit\xe1ln\xed speci\xe1ln\xed barva: ${digitalText}`);
        }
        // Lakování
        const lak = document.getElementById('lakovani')?.value;
        if (lak && lak !== '0') {
            const lakText = this.getLakText(lak);
            if (lakText) dodatecneUpravy.push(`Lakov\xe1n\xed: ${lakText}`);
        }
        // Laminace
        const lamino = document.getElementById('laminace')?.value;
        if (lamino && lamino !== '0') {
            const laminaceText = this.getLaminaceText(lamino);
            if (laminaceText) dodatecneUpravy.push(`Laminace: ${laminaceText}`);
        }
        // Falcování
        const falcovani = document.getElementById('falcovani')?.value;
        if (falcovani && falcovani !== '0') {
            const falcovaniText = this.getFalcovaniText(falcovani);
            if (falcovaniText) dodatecneUpravy.push(`Falcov\xe1n\xed: ${falcovaniText}`);
        }
        // Bigování
        const bigovani = document.getElementById('bigovani')?.value;
        if (bigovani && bigovani !== '0') {
            const bigovaniText = this.getBigovaniText(bigovani);
            if (bigovaniText) dodatecneUpravy.push(`Bigov\xe1n\xed: ${bigovaniText}`);
        }
        // Výsek
        const vysek = document.getElementById('vysek')?.value;
        if (vysek && vysek !== '0') {
            const vysekText = this.getVysekText(vysek);
            const pozicNaVysek = document.getElementById('pozicNaVysek')?.value || '1';
            if (vysekText) dodatecneUpravy.push(`V\xfdsek: ${vysekText} (${pozicNaVysek} pozic)`);
        }
        // Předsek
        const predsek = document.getElementById('predsek')?.value;
        if (predsek && predsek !== '0') {
            const predsekText = this.getPredsekText(predsek);
            const pozicNaPredsek = document.getElementById('pozicNaPredsek')?.value || '1';
            if (predsekText) dodatecneUpravy.push(`P\u{159}edsek: ${predsekText} (${pozicNaPredsek} pozic)`);
        }
        // Ražba
        const razba = document.getElementById('razba')?.value;
        if (razba && razba !== '0') {
            const razbaText = this.getRazbaText(razba);
            const pozicNaRazbu = document.getElementById('pozicNaRazbu')?.value || '1';
            if (razbaText) dodatecneUpravy.push(`Ra\u{17E}ba: ${razbaText} (${pozicNaRazbu} pozic)`);
        }
        // Vrtání
        const vrtani = document.getElementById('vrtani')?.value;
        if (vrtani && vrtani !== '0') {
            const vrtaniText = this.getVrtaniText(vrtani);
            if (vrtaniText) dodatecneUpravy.push(`Vrt\xe1n\xed: ${vrtaniText}`);
        }
        // Perforace
        const perforace = document.getElementById('perforace')?.value;
        if (perforace && perforace !== '0') {
            const pocetPerforaci = parseInt(perforace);
            if (pocetPerforaci > 0) dodatecneUpravy.push(`Perforace ${pocetPerforaci}x`);
        }
        // Lepení
        const lepeni = document.getElementById('lepeni')?.value;
        if (lepeni && lepeni !== '0') {
            const lepeniText = this.getLepeniText(lepeni);
            if (lepeniText) dodatecneUpravy.push(lepeniText);
        }
        // Vazba
        const vazba = document.getElementById('vazba')?.value;
        if (vazba && vazba !== '0') {
            const vazbaText = this.getVazbaText(vazba);
            if (vazbaText) dodatecneUpravy.push(vazbaText);
        }
        return dodatecneUpravy;
    }
    // Pomocné funkce pro převod hodnot na texty (duplikáty z backend kódu)
    getDigitalColorName(typ) {
        const nazvy = {
            'lak_10_50': "1/0 lak (parci\xe1ln\xed)",
            'lak_11_50': "1/1 lak (parci\xe1ln\xed)",
            'lak_10_100': "1/0 lak (cel\xe1 plocha)",
            'lak_11_100': "1/1 lak (cel\xe1 plocha)",
            'bila_10_50': "1/0 b\xedl\xe1 (parci\xe1ln\xed)",
            'bila_11_50': "1/1 b\xedl\xe1 (parci\xe1ln\xed)",
            'bila_10_100': "1/0 b\xedl\xe1 (cel\xe1 plocha)",
            'bila_11_100': "1/1 b\xedl\xe1 (cel\xe1 plocha)",
            'zlata_10_50': "1/0 zlat\xe1 (parci\xe1ln\xed)",
            'zlata_11_50': "1/1 zlat\xe1 (parci\xe1ln\xed)",
            'zlata_10_100': "1/0 zlat\xe1 (cel\xe1 plocha)",
            'zlata_11_100': "1/1 zlat\xe1 (cel\xe1 plocha)"
        };
        return nazvy[typ] || '';
    }
    getLakText(typ) {
        const nazvy = {
            'parcial10': "1/0 UV lak parci\xe1ln\xed",
            'parcial11': "1/1 UV lak parci\xe1ln\xed",
            'plocha10': "1/0 UV lak cel\xe1 plocha",
            'plocha11': "1/1 UV lak cel\xe1 plocha",
            'stroj10': '1/0 Stroj lak',
            'stroj11': '1/1 Stroj lak'
        };
        return nazvy[typ] || '';
    }
    getLaminaceText(typ) {
        const nazvy = {
            'lesk10': "1/0 Lamino leskl\xe9",
            'lesk11': "1/1 Lamino leskl\xe9",
            'mat10': "1/0 Lamino matn\xe9",
            'mat11': "1/1 Lamino matn\xe9",
            'struktura10': "1/0 Lamino nepo\u0161krabateln\xe9",
            'struktura11': "1/1 Lamino nepo\u0161krabateln\xe9",
            'samet10': "1/0 Lamino sametov\xe9",
            'samet11': "1/1 Lamino sametov\xe9",
            'kapsaA5': "1/1 Laminace kapsov\xe1 (A5)",
            'kapsaA4': "1/1 Laminace kapsov\xe1 (A4)",
            'kapsaA3': "1/1 Laminace kapsov\xe1 (A3)"
        };
        return nazvy[typ] || '';
    }
    getFalcovaniText(typ) {
        const nazvy = {
            'half-fold': 'Na polovinu (1 lom)',
            'cross-fold': "K\u0159\xed\u017Eov\xfd lom (2 lomy)",
            'u-fold': 'Do U (2 lomy)',
            'z-fold': 'Do Z (2 lomy)',
            'double-half-fold': 'Na polovinu (2 lomy)',
            'roll-fold': "Harmonikov\xe9 s p\u0159ebalem (3 lomy)",
            'harmonium-fold-3': "Harmonikov\xe9 skl\xe1d\xe1n\xed (3 lomy)",
            'harmonium-fold-4': "Harmonikov\xe9 skl\xe1d\xe1n\xed (4 lomy)",
            'harmonium-fold-5': "Harmonikov\xe9 skl\xe1d\xe1n\xed (5 lom\u016F)",
            'gate-fold': "Skl\xe1d\xe1n\xed do psan\xed\u010Dka (3 lomy)",
            'double-gate-fold': "Zav\u0159en\xe9 psan\xed\u010Dko (3 lomy)"
        };
        return nazvy[typ] || '';
    }
    getBigovaniText(typ) {
        const nazvy = {
            'half-fold': 'Na polovinu (1 big)',
            'cross-fold': "Do k\u0159\xed\u017Ee (2 bigy)",
            'u-fold': 'Do U (2 bigy)',
            'z-fold': 'Do Z (2 bigy)',
            'double-half-fold': 'Na polovinu (2 bigy)',
            'roll-fold': "Harmonikov\xe9 (3 bigy)",
            'harmonium-fold-3': "Harmonikov\xe9 (3 bigy)",
            'harmonium-fold-4': "Harmonikov\xe9 (4 bigy)",
            'harmonium-fold-5': "Harmonikov\xe9 (5 bigy)",
            'gate-fold': "Skl\xe1d\xe1n\xed do psan\xed\u010Dka (3 bigy)",
            'double-gate-fold': "Zav\u0159en\xe9 psan\xed\u010Dko (3 bigy)"
        };
        return nazvy[typ] || '';
    }
    getVysekText(option) {
        const nazvy = {
            'vlastni': "Vlastn\xed/p\u016Fj\u010Den\xe9 v\xfdsekov\xe9 \u017Eelezo",
            'nove': "Nov\xe9 v\xfdsekov\xe9 \u017Eelezo"
        };
        return nazvy[option] || '';
    }
    getPredsekText(option) {
        const nazvy = {
            '1': "Vlastn\xed/p\u016Fj\u010Den\xe9 p\u0159edsekov\xe9 \u017Eelezo",
            '2': "Nov\xe9 p\u0159edsekov\xe9 \u017Eelezo"
        };
        return nazvy[option] || '';
    }
    getRazbaText(option) {
        const nazvy = {
            '1': "Vlastn\xed/p\u016Fj\u010Den\xfd \u0161to\u010Dek",
            '2': "Nov\xfd \u0161to\u010Dek"
        };
        return nazvy[option] || '';
    }
    getVrtaniText(typ) {
        const nazvy = {
            '1dira2mm': "1 d\xedra (2 mm)",
            '1dira4mm': "1 d\xedra (4 mm)",
            '1dira5mm': "1 d\xedra (5,5 mm)",
            '2diry2mm': "2 d\xedry (2 mm)",
            '2diry4mm': "2 d\xedry (4 mm)",
            '2diry5mm': "2 d\xedry (5,5 mm)",
            'euro2diry2mm': "Euro blok, 2 d\xedry (2 mm)",
            'euro2diry4mm': "Euro blok, 2 d\xedry (4 mm)",
            'euro2diry5mm': "Euro blok, 2 d\xedry (5,5 mm)",
            '3diry2mm': "3 d\xedry (2 mm)",
            '3diry4mm': "3 d\xedry (4 mm)",
            '3diry5mm': "3 d\xedry (5,5 mm)",
            'euro4diry2mm': "Euro blok, 4 d\xedry (2 mm)",
            'euro4diry4mm': "Euro blok, 4 d\xedry (4 mm)",
            'euro4diry5mm': "Euro blok, 4 d\xedry (5,5 mm)"
        };
        return nazvy[typ] || '';
    }
    getLepeniText(typ) {
        const nazvy = {
            '1': "Lepen\xed krabi\u010Dek"
        };
        return nazvy[typ] || '';
    }
    getVazbaText(typ) {
        const nazvy = {
            'V1-strojni': "V1 (2 skoby) strojn\xed",
            'V1-rucni': "V1 (2 skoby) ru\u010Dn\u011B",
            'blok': "Lepen\xfd blok",
            'blokPrebal': "Lepen\xfd blok s p\u0159ebalem",
            'V2-PUR': "V2 lepen\xe1 (PUR)",
            'V3': "V3 lepen\xe1 a \u0161it\xe1",
            'V6': 'V6 leporelo',
            'krouzek-blok': "Krou\u017Ekov\xe1 twin wire",
            'krouzek-kalendar': "Krou\u017Ekov\xe1 s h\xe1\u010Dkem na pov\u011B\u0161en\xed",
            'V4': "V4 \u0161it\xe1, m\u011Bkk\xe1 ob\xe1lka",
            'V5': "V5 \u0161it\xe1, tvrd\xe1 ob\xe1lka",
            'V2V8': "V2V8 \u2013 fale\u0161n\xe1 V8",
            'V8': "V8 \u0161it\xe1, tvrd\xe1 ob\xe1lka"
        };
        return nazvy[typ] || "Nezn\xe1m\xe1 vazba";
    }
    // Vykreslení seznamu položek
    renderItems() {
        const container = document.getElementById('seznamPolozek');
        if (!container) return;
        container.innerHTML = this.items.map((item)=>`
      <div class="flex items-center justify-between p-3 border rounded-md cursor-pointer transition-colors ${item.id === this.activeItemId ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:bg-gray-50'}" data-item-id="${item.id}">
        <div class="flex-1 min-w-0" onclick="window.offerItemsManager.switchToItem(${item.id})">
          <div class="font-medium text-sm text-gray-900">${this.escapeHtml(item.name)}</div>
          <div class="text-sm text-gray-500">
            ${item.price.toLocaleString('cs-CZ')} K\u{10D}
            ${item.pricePerPiece > 0 ? `(${item.pricePerPiece.toFixed(2)} K\u{10D}/ks)` : ''}
          </div>
        </div>
        <div class="flex flex-col items-center justify-center gap-0.5">
          <!-- P\u{159}et\xe1hnout (drag handle) -->
          <div class="drag-handle p-1 text-gray-400 hover:text-gray-600 cursor-grab active:cursor-grabbing focus:outline-none" title="P\u{159}et\xe1hnout pro zm\u{11B}nu po\u{159}ad\xed" aria-label="P\u{159}et\xe1hnout pro zm\u{11B}nu po\u{159}ad\xed">
            ${(0, $entK4.icon)('arrows-up-down', 'w-4 h-4')}
          </div>
          <!-- Duplikovat -->
          <button type="button" onclick="window.offerItemsManager.duplicateItem(${item.id})"
            class="p-1 text-gray-400 hover:text-gray-600 focus:outline-none" title="Duplikovat polo\u{17E}ku">
            ${(0, $entK4.icon)('squares-2-stack', 'w-4 h-4')}
          </button>
          <!-- Smazat -->
          ${this.items.length > 1 ? `
            <button type="button" onclick="window.offerItemsManager.removeItem(${item.id})"
              class="p-1 text-gray-400 hover:text-red-600 focus:outline-none" title="Smazat polo\u{17E}ku">
              ${(0, $entK4.icon)('trash', 'w-4 h-4')}
            </button>
          ` : ''}
        </div>
      </div>
    `).join('');
        // Inicializovat nebo znovu inicializovat Sortable
        this.initializeSortable();
        // Vždy zobrazit možnost vytvořit nabídku
        const wrapper = document.getElementById('celkovaCenaWrapper');
        if (wrapper) wrapper.classList.remove('hidden');
    }
    // Inicializace Sortable drag & drop
    initializeSortable() {
        const container = document.getElementById('seznamPolozek');
        if (!container) return;
        // Zničit existující Sortable instanci
        if (this.sortable) this.sortable.destroy();
        // Vytvořit novou Sortable instanci
        this.sortable = (0, $dbec57966acc54fe$export$2e2bcd8739ae039).create(container, {
            animation: 150,
            ghostClass: 'sortable-ghost',
            chosenClass: 'sortable-chosen',
            dragClass: 'sortable-drag',
            handle: '.drag-handle',
            onEnd: (evt)=>{
                // Přeuspořádat položky
                this.reorderItems(evt.oldIndex, evt.newIndex);
            }
        });
    }
    // Přeuspořádání položek po drag & drop
    reorderItems(oldIndex, newIndex) {
        if (oldIndex === newIndex) return;
        // Uložit aktuální stav formuláře
        if (this.activeItemId) {
            const currentItem = this.items.find((item)=>item.id === this.activeItemId);
            if (currentItem) currentItem.formData = this.saveCurrentFormState();
        }
        // Přesunout položku v poli
        const movedItem = this.items.splice(oldIndex, 1)[0];
        this.items.splice(newIndex, 0, movedItem);
        // Překreslit seznam (bez reinicializace Sortable)
        this.renderItemsContent();
        // Aktualizovat celkovou cenu
        this.updateTotalPrice();
    }
    // Vykreslení obsahu položek bez reinicializace Sortable
    renderItemsContent() {
        const container = document.getElementById('seznamPolozek');
        if (!container) return;
        container.innerHTML = this.items.map((item)=>`
      <div class="flex items-center justify-between p-3 border rounded-md cursor-pointer transition-colors ${item.id === this.activeItemId ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:bg-gray-50'}" data-item-id="${item.id}">
        <div class="flex-1 min-w-0" onclick="window.offerItemsManager.switchToItem(${item.id})">
          <div class="font-medium text-sm text-gray-900">${this.escapeHtml(item.name)}</div>
          <div class="text-sm text-gray-500">
            ${item.price.toLocaleString('cs-CZ')} K\u{10D}
            ${item.pricePerPiece > 0 ? `(${item.pricePerPiece.toFixed(2)} K\u{10D}/ks)` : ''}
          </div>
        </div>
        <div class="flex flex-col items-center justify-center gap-0.5">
          <!-- P\u{159}et\xe1hnout (drag handle) -->
          <div class="drag-handle p-1 text-gray-400 hover:text-gray-600 cursor-grab active:cursor-grabbing focus:outline-none" title="P\u{159}et\xe1hnout pro zm\u{11B}nu po\u{159}ad\xed" aria-label="P\u{159}et\xe1hnout pro zm\u{11B}nu po\u{159}ad\xed">
            ${(0, $entK4.icon)('arrows-up-down', 'w-4 h-4')}
          </div>
          <!-- Duplikovat -->
          <button type="button" onclick="window.offerItemsManager.duplicateItem(${item.id})"
            class="p-1 text-gray-400 hover:text-gray-600 focus:outline-none" title="Duplikovat polo\u{17E}ku">
            ${(0, $entK4.icon)('squares-2-stack', 'w-4 h-4')}
          </button>
          <!-- Smazat -->
          ${this.items.length > 1 ? `
            <button type="button" onclick="window.offerItemsManager.removeItem(${item.id})"
              class="p-1 text-gray-400 hover:text-red-600 focus:outline-none" title="Smazat polo\u{17E}ku">
              ${(0, $entK4.icon)('trash', 'w-4 h-4')}
            </button>
          ` : ''}
        </div>
      </div>
    `).join('');
    }
    // Aktualizace celkové ceny
    updateTotalPrice() {
        const total = this.items.reduce((sum, item)=>sum + item.price, 0);
        const totalElement = document.getElementById('celkovaCenaNabidky');
        if (totalElement) totalElement.textContent = `${total.toLocaleString('cs-CZ')} K\u{10D}`;
    }
    // Uložení aktuálního stavu formuláře
    saveCurrentFormState() {
        const formData = {};
        const form = document.getElementById('vypocet');
        if (!form) return formData;
        // Uložit všechny inputy, selecty a textarey
        const inputs = form.querySelectorAll('input, select, textarea');
        inputs.forEach((input)=>{
            if (!input.id) return;
            if (input.type === 'checkbox') formData[input.id] = input.checked;
            else if (input.type === 'radio') {
                if (input.checked) formData[input.name] = input.value;
            } else formData[input.id] = input.value;
        });
        // Materiály uložit podle názvu option (ne podle value=cena) – ceny se mohou
        // duplikovat, takže obnova podle value by vybrala špatný papír.
        const matSelect = document.getElementById('material');
        if (matSelect && matSelect.selectedIndex >= 0) {
            const opt = matSelect.options[matSelect.selectedIndex];
            if (opt && opt.value) formData.materialName = opt.textContent.trim();
        }
        const vnitrniSelect = document.getElementById('vnitrniMaterial');
        if (vnitrniSelect && vnitrniSelect.selectedIndex >= 0) {
            const opt = vnitrniSelect.options[vnitrniSelect.selectedIndex];
            if (opt && opt.value) formData.vnitrniMaterialName = opt.textContent.trim();
        }
        // Uložit i typ ceny
        const typCeny = document.getElementById('typCeny');
        const nazev = document.getElementById('nazev');
        if (typCeny) formData.typCeny = typCeny.value;
        if (nazev) formData.nazev = nazev.value;
        // Motivy – dynamické řádky nemají id ve formuláři
        if (+(formData.pocetDruhu || 1) > 1 && typeof window.getMotivyRows === 'function') {
            const rows = window.getMotivyRows().filter((m)=>m.pocetKusu > 0);
            if (rows.length > 1) formData.motivy = rows;
        }
        return formData;
    }
    // Obnovení stavu formuláře
    restoreFormState(formData) {
        if (!formData) return;
        const form = document.getElementById('vypocet');
        if (!form) return;
        // Potlačit "reset-na-vlastní" listenery (Formát/Materiál) během obnovy,
        // jinak by nastavení šířky/výšky/ceny přepsalo select na "vlastní".
        const prevApplying = window._applyingPreset;
        window._applyingPreset = true;
        try {
            Object.keys(formData).forEach((key)=>{
                // Materiály obnovíme podle názvu až po ostatních polích.
                if (key === 'materialName' || key === 'vnitrniMaterialName') return;
                const element = document.getElementById(key);
                if (!element) return;
                if (element.type === 'checkbox') element.checked = formData[key];
                else element.value = formData[key];
                // Trigger change aby se aktualizovala podmíněná pole (vazba, obálka,
                // vnitřní blok, sync materiálu …) a spustil se přepočet.
                element.dispatchEvent(new Event('change', {
                    bubbles: true
                }));
            });
            // Obnova materiálů podle názvu (až po ostatních polích).
            if (formData.materialName && window.selectMaterialByName) window.selectMaterialByName('material', formData.materialName);
            if (formData.vnitrniMaterialName && window.selectMaterialByName) window.selectMaterialByName('vnitrniMaterial', formData.vnitrniMaterialName);
            // Obnova motivů (dynamické řádky)
            if (Array.isArray(formData.motivy) && formData.motivy.length > 1 && typeof window.renderMotivyPanel === 'function') {
                const druhuInput = document.getElementById('pocetDruhu');
                if (druhuInput) druhuInput.value = formData.motivy.length;
                window.renderMotivyPanel(formData.motivy);
            }
        } finally{
            window._applyingPreset = prevApplying;
        }
        // Spustit přepočet (vyplní Kč/arch, g/m², výsledek).
        // Vracíme promise z pocitej(), aby volající mohl přepočet počkat
        // (např. hromadný přepočet všech položek při změně typu ceny).
        if (window.pocitej) return window.pocitej();
    }
    // Výchozí data formuláře
    getDefaultFormData() {
        return {
            pocetKusu: '1000',
            produktRozmerFormat: 'A4',
            produktRozmerSirka: '210',
            produktRozmerVyska: '297',
            pocetBarev: '4/4',
            primeBarvy: '0',
            barvyDigital: '0',
            material: 'Krida_lesk_115',
            materialGramaz: '115',
            materialCena: '',
            materialRozmerSirka: '',
            materialRozmerVyska: '',
            lamino: '0',
            laminoOboustranne: false,
            plocha: '0',
            soutisk: false,
            bigovani: '0',
            vysek: '0',
            pozicNaVysek: '1',
            cenaRazniceVyseku: '0',
            predsek: '0',
            pozicNaPredsek: '1',
            cenaRaznicePredseku: '0',
            razba: '0',
            pozicNaRazbu: '1',
            cenaStocku: '0',
            doprava: '0',
            nazev: '',
            typCeny: 'velko'
        };
    }
    // Vytvoření nabídky
    async createOffer() {
        try {
            // Uložit aktuální stav formuláře
            if (this.activeItemId) {
                const currentItem = this.items.find((item)=>item.id === this.activeItemId);
                if (currentItem) currentItem.formData = this.saveCurrentFormState();
            }
            // Připravit data pro odeslání
            const offerData = {
                items: this.items.map((item)=>({
                        name: item.name,
                        formData: item.formData,
                        price: item.price,
                        pricePerPiece: item.pricePerPiece,
                        debugInfo: item.debugInfo,
                        // Strukturovaný výsledek kalkulace pro technický list (výroba):
                        // bez objemných textových polí, ta jsou už v debugInfo.
                        calculationResult: this.stripCalculationResult(item.calculationResult)
                    })),
                totalPrice: this.items.reduce((sum, item)=>sum + item.price, 0),
                createdAt: new Date().toISOString(),
                customerId: this.selectedCustomer?.id || null,
                customerData: this.selectedCustomer || null
            };
            // Odeslat na backend
            const API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
            const response = await fetch(`${API_BASE_URL}/offers`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify(offerData)
            });
            if (!response.ok) throw new Error("Chyba p\u0159i vytv\xe1\u0159en\xed nab\xeddky");
            const result = await response.json();
            // Zobrazit notifikaci
            if (window.showNotification) window.showNotification("Nab\xeddka byla \xfasp\u011B\u0161n\u011B vytvo\u0159ena", 'success');
            // Přejít na sekci nabídek
            if (window.sectionManager) window.sectionManager.showSection('nabidky');
        } catch (error) {
            console.error("Chyba p\u0159i vytv\xe1\u0159en\xed nab\xeddky:", error);
            if (window.showNotification) window.showNotification("Chyba p\u0159i vytv\xe1\u0159en\xed nab\xeddky", 'error');
        }
    }
    /**
   * Ořeže výsledek kalkulace pro uložení do nabídky: vynechá objemné
   * textové výstupy (debugInfo, textOutput) – strukturovaná data
   * (comp, vazba, motivy, počty archů, technologie…) zůstávají pro
   * technický list ve výrobě.
   */ stripCalculationResult(result) {
        if (!result || typeof result !== 'object') return null;
        const { debugInfo: debugInfo, textOutput: textOutput, ...rest } = result;
        try {
            return JSON.parse(JSON.stringify(rest));
        } catch  {
            return null;
        }
    }
    // Pomocná funkce pro escapování HTML
    escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }
}
// Export pro použití v app.js
window.OfferItemsManager = $978543261cadeb8d$export$e516135c113cb170;


// Sekce Nabídky – seznam se sdíleným toolbar/kartami z shared/list-ui.js.
// Stránkovaný list endpoint (limit/offset) vrací ořezané záznamy vč. customerName.

var $entK4 = parcelRequire("entK4");

var $6NozV = parcelRequire("6NozV");
const $7c4048e26ce185a4$var$OFFER_STATUS_ORDER = [
    'draft',
    'sent',
    'negotiation',
    'approved',
    'rejected',
    'converted'
];

class $7c4048e26ce185a4$export$66ddce14385f3c96 {
    constructor(){
        this.offers = [];
        this.view = new (0, $6NozV.ListView)({
            key: 'offers',
            title: "Nab\xeddky",
            subtitle: "Stav nab\xeddek a jejich p\u0159evod na objedn\xe1vky.",
            searchPlaceholder: "Hledat (\u010D\xedslo, firma, polo\u017Eka)\u2026",
            statusKind: 'offer',
            statuses: $7c4048e26ce185a4$var$OFFER_STATUS_ORDER,
            authorLabels: {
                me: "Moje nab\xeddky"
            },
            enableCustomerFilter: true,
            enableKanban: true,
            onChange: ()=>this.loadOffers()
        });
        this.init();
    }
    init() {
        this.loadOffers();
    }
    async loadOffers() {
        const container = document.getElementById('nabidky-section');
        if (!container) return;
        if (!document.getElementById('offers-list')) {
            this.view.renderShell(container);
            this._bindListEvents();
        } else this.view.renderLoading();
        try {
            if (this.view.viewMode === 'kanban') {
                await this.loadKanban();
                return;
            }
            const params = this.view.buildParams();
            const response = await fetch(`${(0, $6NozV.API_BASE_URL)}/offers?${params}`, {
                credentials: 'include'
            });
            if (!response.ok) throw new Error("Chyba p\u0159i na\u010D\xedt\xe1n\xed nab\xeddek");
            const result = await response.json();
            this.offers = result.data || [];
            if (Array.isArray(result.statuses) && result.statuses.length) this.view.statuses = result.statuses;
            if (Array.isArray(result.authors)) this.view.authors = result.authors;
            this.view.renderResults({
                rowsHtml: this.offers.map((o)=>this.renderOfferRow(o)),
                total: result.total,
                emptyState: {
                    title: "Zat\xedm nem\xe1te \u017E\xe1dn\xe9 nab\xeddky",
                    hint: "Vytvo\u0159te prvn\xed nab\xeddku v sekci Kalkul\xe1tor p\u0159id\xe1n\xedm polo\u017Eek a kliknut\xedm na \u201EVytvo\u0159it nab\xeddku\u201C."
                }
            });
        } catch (error) {
            console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed nab\xeddek:", error);
            this.view.renderCustom((0, $6NozV.renderErrorState)("Nepoda\u0159ilo se na\u010D\xedst nab\xeddky", 'window.offersListManager.loadOffers()'));
        }
    }
    async loadKanban() {
        const { renderKanbanBoard: renderKanbanBoard } = await (parcelRequire("l8N1u"));
        await renderKanbanBoard({
            view: this.view,
            statusKind: 'offer',
            fetchColumn: async (status)=>{
                const params = this.view.buildParams({
                    paginate: false
                });
                params.set('status', status);
                params.set('limit', '30');
                params.set('sort', 'kanban');
                const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/offers?${params}`, {
                    credentials: 'include'
                });
                if (!res.ok) throw new Error("Chyba p\u0159i na\u010D\xedt\xe1n\xed nab\xeddek");
                const result = await res.json();
                return {
                    items: result.data || [],
                    total: result.total || 0
                };
            },
            cardData: (o)=>({
                    id: o.id,
                    title: `#${o.id}`,
                    customerName: (0, $6NozV.customerNameOf)(o),
                    meta: (0, $6NozV.formatDateTime)(o.createdAt),
                    price: (0, $6NozV.formatMoney)(o.totalPrice),
                    draggable: o.status !== 'converted',
                    orderKey: typeof o.kanbanOrder === 'number' ? o.kanbanOrder : Date.parse(o.createdAt)
                }),
            onOpen: (id)=>this.openOfferEditor(id),
            onDrop: async (id, { status: status, statusChanged: statusChanged, orderKey: orderKey })=>{
                if (statusChanged) {
                    const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/offers/${id}/status`, {
                        method: 'PATCH',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        credentials: 'include',
                        body: JSON.stringify({
                            status: status,
                            note: "Zm\u011Bna stavu p\u0159eta\u017Een\xedm v kanbanu"
                        })
                    });
                    const result = await res.json().catch(()=>({}));
                    if (!res.ok) throw new Error(result.error || "Zm\u011Bna stavu se nezda\u0159ila");
                }
                // Ruční pořadí ve sloupci (kanbanOrder ukládá updateOffer přes PUT)
                const res2 = await fetch(`${(0, $6NozV.API_BASE_URL)}/offers/${id}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include',
                    body: JSON.stringify({
                        kanbanOrder: orderKey
                    })
                });
                if (!res2.ok) {
                    const result = await res2.json().catch(()=>({}));
                    throw new Error(result.error || "Ulo\u017Een\xed po\u0159ad\xed se nezda\u0159ilo");
                }
            }
        });
    }
    renderOfferRow(offer) {
        const itemsCount = offer.itemsCount != null ? offer.itemsCount : (offer.items || []).length;
        const itemsText = itemsCount === 1 ? "1 polo\u017Eka" : `${itemsCount} polo\u{17E}ek`;
        const itemNames = (offer.items || []).map((i)=>(0, $6NozV.escapeHtml)(i.name)).join(', ');
        const badges = [];
        if (offer.convertedToOrderId) badges.push(`
        <span class="inline-flex items-center gap-0.5 text-xs text-purple-700">
          ${(0, $entK4.icon)('arrow-right', 'w-3 h-3')}
          <button type="button" class="underline hover:no-underline" data-action="open-order" data-id="${(0, $6NozV.escapeHtml)(offer.convertedToOrderId)}" title="Otev\u{159}\xedt objedn\xe1vku ${(0, $6NozV.escapeHtml)(offer.convertedToOrderId)}">${(0, $6NozV.escapeHtml)(offer.convertedToOrderId)}</button>
        </span>
      `);
        return (0, $6NozV.renderListCard)({
            id: offer.id,
            title: `Nab\xeddka <span class="font-semibold">#${(0, $6NozV.escapeHtml)(offer.id)}</span>`,
            status: {
                kind: 'offer',
                value: offer.status || 'draft'
            },
            customerName: (0, $6NozV.customerNameOf)(offer),
            metaLine: `
        <span class="inline-flex items-center">${(0, $entK4.icon)('calendar', 'w-3.5 h-3.5 mr-1 text-gray-400')}${(0, $6NozV.formatDateTime)(offer.createdAt)}</span>
        <span>\xb7</span><span>${itemsText}</span>
        ${offer.createdByName ? `<span>\xb7</span><span>${(0, $6NozV.escapeHtml)(offer.createdByName)}</span>` : ''}
      `,
            description: itemNames,
            price: (0, $6NozV.formatMoney)(offer.totalPrice),
            priceNote: 'bez DPH',
            badges: badges,
            compact: this.view.compact,
            actions: [
                {
                    action: 'open',
                    icon: 'eye',
                    label: "Otev\u0159\xedt nab\xeddku",
                    tone: 'primary'
                },
                {
                    action: 'load',
                    icon: 'calculator',
                    label: "Na\u010D\xedst do kalkul\xe1toru a upravit"
                },
                {
                    action: 'delete',
                    icon: 'trash',
                    label: "Smazat nab\xeddku",
                    tone: 'danger'
                }
            ]
        });
    }
    _bindListEvents() {
        const list = this.view.listContainer;
        if (!list) return;
        list.addEventListener('click', (e)=>{
            const actionBtn = e.target.closest('[data-action]');
            if (actionBtn) {
                e.stopPropagation();
                const { action: action, id: id } = actionBtn.dataset;
                if (action === 'open') this.openOfferEditor(id);
                else if (action === 'load') this.editOffer(id);
                else if (action === 'delete') this.deleteOffer(id);
                else if (action === 'open-order') window.ordersListManager?.openDetail(id);
                return;
            }
            const row = e.target.closest('[data-row-id]');
            if (row && !e.target.closest('button, a')) this.openOfferEditor(row.dataset.rowId);
        });
    }
    async editOffer(offerId) {
        try {
            const response = await fetch(`${(0, $6NozV.API_BASE_URL)}/offers/${offerId}`, {
                credentials: 'include'
            });
            if (!response.ok) throw new Error("Chyba p\u0159i na\u010D\xedt\xe1n\xed nab\xeddky");
            const result = await response.json();
            const offer = result.data;
            if (window.sectionManager) window.sectionManager.showSection('kalkulator');
            if (window.offerItemsManager) {
                window.offerItemsManager.items = [];
                window.offerItemsManager.itemIdCounter = 0;
                window.offerItemsManager.activeItemId = null;
                offer.items.forEach((item, index)=>{
                    if (index === 0) {
                        window.offerItemsManager.addItem();
                        const firstItem = window.offerItemsManager.items[0];
                        firstItem.name = item.name;
                        firstItem.formData = item.formData;
                        firstItem.price = item.price;
                        firstItem.pricePerPiece = item.pricePerPiece;
                    } else {
                        const itemId = ++window.offerItemsManager.itemIdCounter;
                        window.offerItemsManager.items.push({
                            id: itemId,
                            name: item.name,
                            formData: item.formData,
                            price: item.price,
                            pricePerPiece: item.pricePerPiece
                        });
                    }
                });
                if (window.offerItemsManager.items.length > 0) {
                    window.offerItemsManager.activeItemId = window.offerItemsManager.items[0].id;
                    window.offerItemsManager.restoreFormState(window.offerItemsManager.items[0].formData);
                    window.offerItemsManager.renderItems();
                    window.offerItemsManager.updateTotalPrice();
                }
            }
            if (window.showNotification) window.showNotification("Nab\xeddka na\u010Dtena do kalkul\xe1toru", 'success');
        } catch (error) {
            console.error("Chyba p\u0159i editaci nab\xeddky:", error);
            if (window.showNotification) window.showNotification("Chyba p\u0159i na\u010D\xedt\xe1n\xed nab\xeddky", 'error');
        }
    }
    async deleteOffer(offerId) {
        if (!confirm("Opravdu chcete smazat tuto nab\xeddku?")) return;
        try {
            const response = await fetch(`${(0, $6NozV.API_BASE_URL)}/offers/${offerId}`, {
                method: 'DELETE',
                credentials: 'include'
            });
            if (!response.ok) throw new Error("Chyba p\u0159i maz\xe1n\xed nab\xeddky");
            if (window.showNotification) window.showNotification("Nab\xeddka byla \xfasp\u011B\u0161n\u011B smaz\xe1na", 'success');
            this.loadOffers();
        } catch (error) {
            console.error("Chyba p\u0159i maz\xe1n\xed nab\xeddky:", error);
            if (window.showNotification) window.showNotification("Chyba p\u0159i maz\xe1n\xed nab\xeddky", 'error');
        }
    }
    async openOfferEditor(offerId) {
        try {
            const response = await fetch(`${(0, $6NozV.API_BASE_URL)}/offers/${offerId}`, {
                credentials: 'include'
            });
            if (!response.ok) throw new Error("Chyba p\u0159i na\u010D\xedt\xe1n\xed nab\xeddky");
            const result = await response.json();
            const offer = result.data;
            if (window.sectionManager) window.sectionManager.showSection('nabidka-editor');
            if (window.offerEditorManager) window.offerEditorManager.loadOffer(offer);
        } catch (error) {
            console.error("Chyba p\u0159i otev\xedr\xe1n\xed editoru nab\xeddky:", error);
            if (window.showNotification) window.showNotification("Chyba p\u0159i otev\xedr\xe1n\xed editoru nab\xeddky", 'error');
        }
    }
    refresh() {
        this.loadOffers();
    }
    escape(str) {
        return (0, $6NozV.escapeHtml)(str);
    }
}
$7c4048e26ce185a4$export$66ddce14385f3c96.STATUS_META = (0, $6NozV.STATUS_META).offer;
$7c4048e26ce185a4$export$66ddce14385f3c96.STATUS_ORDER = $7c4048e26ce185a4$var$OFFER_STATUS_ORDER;
window.OffersListManager = $7c4048e26ce185a4$export$66ddce14385f3c96;


// Modul pro správu editoru nabídky
// Logo tiskárny – stejný asset, jaký se používá v hlavičce aplikace.
// `url:` prefix říká Parcelu 2, aby import vrátil URL k souboru (nikoli inline obsah).
var $cdb5ad58694a976a$exports = {};
$cdb5ad58694a976a$exports = $parcel$resolve("jsksu");


var $39500ec295adf68d$exports = {};
// Sdílené utility pro formátování položek nabídky.
// Modul je napsán v CommonJS, aby mohl být použit:
//   - v Node.js (backend/pdf/index.js – generování PDF)
//   - ve frontendu přes Parcel (offer-editor.js, offer-items.js, public-offer.js)
// Parcel CommonJS importy podporuje out-of-the-box.
//
// Proč existuje: jediné místo, kde se popisuje mapování kódů (formData) na
// lidský text ("Lakování: 1/0 UV lak parciální", …). Dříve byla stejná mapa
// kopírovaná ve 3 souborech, což způsobovalo rozchod editoru, veřejné nabídky
// a PDF.
const $39500ec295adf68d$var$OFFER_FOOTER_DISCLAIMER = "Platnost nab\xeddky je 60 dn\xed od data vystaven\xed. Tento dokument p\u0159edstavuje nez\xe1vaznou cenovou nab\xeddku a nen\xed n\xe1vrhem na uzav\u0159en\xed smlouvy dle \xa7 1731 ob\u010Dansk\xe9ho z\xe1kon\xedku. K uzav\u0159en\xed smlouvy doch\xe1z\xed a\u017E potvrzen\xedm objedn\xe1vky dodavatelem. Nab\xeddka je ur\u010Dena v\xfdhradn\u011B uveden\xe9mu p\u0159\xedjemci.";
const $39500ec295adf68d$var$DIGITAL_COLOR = {
    lak_10_50: "1/0 lak (parci\xe1ln\xed)",
    lak_11_50: "1/1 lak (parci\xe1ln\xed)",
    lak_10_100: "1/0 lak (cel\xe1 plocha)",
    lak_11_100: "1/1 lak (cel\xe1 plocha)",
    bila_10_50: "1/0 b\xedl\xe1 (parci\xe1ln\xed)",
    bila_11_50: "1/1 b\xedl\xe1 (parci\xe1ln\xed)",
    bila_10_100: "1/0 b\xedl\xe1 (cel\xe1 plocha)",
    bila_11_100: "1/1 b\xedl\xe1 (cel\xe1 plocha)",
    zlata_10_50: "1/0 zlat\xe1 (parci\xe1ln\xed)",
    zlata_11_50: "1/1 zlat\xe1 (parci\xe1ln\xed)",
    zlata_10_100: "1/0 zlat\xe1 (cel\xe1 plocha)",
    zlata_11_100: "1/1 zlat\xe1 (cel\xe1 plocha)"
};
const $39500ec295adf68d$var$LAK = {
    parcial10: "1/0 UV lak parci\xe1ln\xed",
    parcial11: "1/1 UV lak parci\xe1ln\xed",
    plocha10: "1/0 UV lak cel\xe1 plocha",
    plocha11: "1/1 UV lak cel\xe1 plocha",
    stroj10: '1/0 Stroj lak',
    stroj11: '1/1 Stroj lak'
};
const $39500ec295adf68d$var$LAMINACE = {
    lesk10: "1/0 Lamino leskl\xe9",
    lesk11: "1/1 Lamino leskl\xe9",
    mat10: "1/0 Lamino matn\xe9",
    mat11: "1/1 Lamino matn\xe9",
    struktura10: "1/0 Lamino nepo\u0161krabateln\xe9",
    struktura11: "1/1 Lamino nepo\u0161krabateln\xe9",
    samet10: "1/0 Lamino sametov\xe9",
    samet11: "1/1 Lamino sametov\xe9",
    kapsaA5: "1/1 Laminace kapsov\xe1 (A5)",
    kapsaA4: "1/1 Laminace kapsov\xe1 (A4)",
    kapsaA3: "1/1 Laminace kapsov\xe1 (A3)"
};
const $39500ec295adf68d$var$FALCOVANI = {
    'half-fold': 'Na polovinu (1 lom)',
    'cross-fold': "K\u0159\xed\u017Eov\xfd lom (2 lomy)",
    'u-fold': 'Do U (2 lomy)',
    'z-fold': 'Do Z (2 lomy)',
    'double-half-fold': 'Na polovinu (2 lomy)',
    'roll-fold': "Harmonikov\xe9 s p\u0159ebalem (3 lomy)",
    'harmonium-fold-3': "Harmonikov\xe9 skl\xe1d\xe1n\xed (3 lomy)",
    'harmonium-fold-4': "Harmonikov\xe9 skl\xe1d\xe1n\xed (4 lomy)",
    'harmonium-fold-5': "Harmonikov\xe9 skl\xe1d\xe1n\xed (5 lom\u016F)",
    'gate-fold': "Skl\xe1d\xe1n\xed do psan\xed\u010Dka (3 lomy)",
    'double-gate-fold': "Zav\u0159en\xe9 psan\xed\u010Dko (3 lomy)"
};
const $39500ec295adf68d$var$BIGOVANI = {
    'half-fold': 'Na polovinu (1 big)',
    'cross-fold': "Do k\u0159\xed\u017Ee (2 bigy)",
    'u-fold': 'Do U (2 bigy)',
    'z-fold': 'Do Z (2 bigy)',
    'double-half-fold': 'Na polovinu (2 bigy)',
    'roll-fold': "Harmonikov\xe9 (3 bigy)",
    'harmonium-fold-3': "Harmonikov\xe9 (3 bigy)",
    'harmonium-fold-4': "Harmonikov\xe9 (4 bigy)",
    'harmonium-fold-5': "Harmonikov\xe9 (5 bigy)",
    'gate-fold': "Skl\xe1d\xe1n\xed do psan\xed\u010Dka (3 bigy)",
    'double-gate-fold': "Zav\u0159en\xe9 psan\xed\u010Dko (3 bigy)"
};
const $39500ec295adf68d$var$VYSEK = {
    vlastni: "Vlastn\xed/p\u016Fj\u010Den\xe9 v\xfdsekov\xe9 \u017Eelezo",
    nove: "Nov\xe9 v\xfdsekov\xe9 \u017Eelezo"
};
const $39500ec295adf68d$var$PREDSEK = {
    1: "Vlastn\xed/p\u016Fj\u010Den\xe9 p\u0159edsekov\xe9 \u017Eelezo",
    2: "Nov\xe9 p\u0159edsekov\xe9 \u017Eelezo"
};
const $39500ec295adf68d$var$RAZBA = {
    1: "Vlastn\xed/p\u016Fj\u010Den\xfd \u0161to\u010Dek",
    2: "Nov\xfd \u0161to\u010Dek"
};
const $39500ec295adf68d$var$VRTANI = {
    '1dira2mm': "1 d\xedra (2 mm)",
    '1dira4mm': "1 d\xedra (4 mm)",
    '1dira5mm': "1 d\xedra (5,5 mm)",
    '2diry2mm': "2 d\xedry (2 mm)",
    '2diry4mm': "2 d\xedry (4 mm)",
    '2diry5mm': "2 d\xedry (5,5 mm)",
    'euro2diry2mm': "Euro blok, 2 d\xedry (2 mm)",
    'euro2diry4mm': "Euro blok, 2 d\xedry (4 mm)",
    'euro2diry5mm': "Euro blok, 2 d\xedry (5,5 mm)",
    '3diry2mm': "3 d\xedry (2 mm)",
    '3diry4mm': "3 d\xedry (4 mm)",
    '3diry5mm': "3 d\xedry (5,5 mm)",
    'euro4diry2mm': "Euro blok, 4 d\xedry (2 mm)",
    'euro4diry4mm': "Euro blok, 4 d\xedry (4 mm)",
    'euro4diry5mm': "Euro blok, 4 d\xedry (5,5 mm)"
};
const $39500ec295adf68d$var$LEPENI = {
    1: "Lepen\xed krabi\u010Dek"
};
const $39500ec295adf68d$var$VAZBA = {
    'V1-strojni': "V1 (2 skoby) strojn\xed",
    'V1-rucni': "V1 (2 skoby) ru\u010Dn\u011B",
    blok: "Lepen\xfd blok",
    blokPrebal: "Lepen\xfd blok s p\u0159ebalem",
    'V2-PUR': "V2 lepen\xe1 (PUR)",
    V3: "V3 lepen\xe1 a \u0161it\xe1",
    V6: 'V6 leporelo',
    'krouzek-blok': "Krou\u017Ekov\xe1 twin wire",
    'krouzek-kalendar': "Krou\u017Ekov\xe1 s h\xe1\u010Dkem na pov\u011B\u0161en\xed",
    V4: "V4 \u0161it\xe1, m\u011Bkk\xe1 ob\xe1lka",
    V5: "V5 \u0161it\xe1, tvrd\xe1 ob\xe1lka",
    V2V8: "V2V8 \u2013 fale\u0161n\xe1 V8",
    V8: "V8 \u0161it\xe1, tvrd\xe1 ob\xe1lka"
};
const $39500ec295adf68d$var$VAZBA_NA = {
    vysku: "Na del\u0161\xed stran\u011B",
    sirku: "Na krat\u0161\xed stran\u011B"
};
const $39500ec295adf68d$var$BARVA_SPIRALY = {
    bila: "B\xedl\xe1",
    cerna: "\u010Cern\xe1",
    stribrna: "St\u0159\xedbrn\xe1",
    zlata: "Zlat\xe1"
};
function $39500ec295adf68d$var$jeKrouzkova(typ) {
    return typeof typ === 'string' && typ.startsWith('krouzek');
}
function $39500ec295adf68d$var$jeBlokova(typ) {
    return typ === 'blok' || typ === 'blokPrebal';
}
function $39500ec295adf68d$var$jednotkaPocetStran(typ) {
    return $39500ec295adf68d$var$jeBlokova(typ) || $39500ec295adf68d$var$jeKrouzkova(typ) ? "list\u016F" : 'stran';
}
function $39500ec295adf68d$var$vnitrniTiskLabel(typ, value) {
    if ($39500ec295adf68d$var$jeBlokova(typ) || $39500ec295adf68d$var$jeKrouzkova(typ)) return value === 'stejna' ? "Ka\u017Ed\xfd list stejn\xfd (opakuj\xedc\xed se motiv)" : "Ka\u017Ed\xfd list jin\xfd (kalend\xe1\u0159, blok)";
    return value === 'stejna' ? "Ka\u017Ed\xe1 strana stejn\xe1 (blok, se\u0161it)" : "Ka\u017Ed\xe1 strana jin\xe1 (bro\u017Eura, katalog)";
}
function $39500ec295adf68d$var$isTruthy(v) {
    return v === true || v === 'true' || v === 'on';
}
function $39500ec295adf68d$var$buildMotivyLines(fd) {
    const lines = [];
    const motivy = Array.isArray(fd.motivy) ? fd.motivy.filter((m)=>+(m.pocetKusu || 0) > 0) : [];
    if (motivy.length > 1) {
        const celkem = motivy.reduce((a, m)=>a + (+m.pocetKusu || 0), 0);
        lines.push(`Motivy (${motivy.length}, celkem ${celkem} ks):`);
        motivy.forEach((m, i)=>{
            const nazev = (m.nazev || '').trim() || `Motiv ${i + 1}`;
            lines.push(`\xb7 ${nazev}: ${(+m.pocetKusu || 0).toLocaleString('cs-CZ')} ks`);
        });
    } else if (+(fd.pocetDruhu || 1) > 1) lines.push(`${fd.pocetDruhu} druhy (motivy)`);
    return lines;
}
function $39500ec295adf68d$var$buildVazbaLines(fd) {
    const lines = [];
    if (!$39500ec295adf68d$var$nonZero(fd.vazba) || !$39500ec295adf68d$var$VAZBA[fd.vazba]) return lines;
    const typ = fd.vazba;
    lines.push(`Vazba: ${$39500ec295adf68d$var$VAZBA[typ]}`);
    if ($39500ec295adf68d$var$nonZero(fd.vazbaPocetStran)) lines.push(`Rozsah: ${fd.vazbaPocetStran} ${$39500ec295adf68d$var$jednotkaPocetStran(typ)}`);
    if (fd.vazbaNa && $39500ec295adf68d$var$VAZBA_NA[fd.vazbaNa]) lines.push(`Um\xedst\u{11B}n\xed vazby: ${$39500ec295adf68d$var$VAZBA_NA[fd.vazbaNa]}`);
    if ($39500ec295adf68d$var$jeKrouzkova(typ) && fd.vazbaBarvaSpiraly && $39500ec295adf68d$var$BARVA_SPIRALY[fd.vazbaBarvaSpiraly]) lines.push(`Barva spir\xe1ly: ${$39500ec295adf68d$var$BARVA_SPIRALY[fd.vazbaBarvaSpiraly]}`);
    if (fd.vazbaVnitrniTisk) lines.push(`Tisk vnit\u{159}n\xedho bloku: ${$39500ec295adf68d$var$vnitrniTiskLabel(typ, fd.vazbaVnitrniTisk)}`);
    if ($39500ec295adf68d$var$isTruthy(fd.vazbaJinaObalka)) {
        const casti = [
            "Jin\xe1 ob\xe1lka ne\u017E vnit\u0159n\xed blok"
        ];
        if (fd.materialName) casti.push(`ob\xe1lka: ${fd.materialName}`);
        if (fd.vnitrniMaterialName) casti.push(`vnit\u{159}ek: ${fd.vnitrniMaterialName}`);
        lines.push(casti.join(" \xb7 "));
    }
    if ($39500ec295adf68d$var$jeKrouzkova(typ) && fd.vazbaObalkaZada === 'ne') lines.push("Ob\xe1lka: jen p\u0159edn\xed list (z\xe1da \u0161ed\xe1 lepenka)");
    if (+(fd.pocetDruhu || 1) > 1 && fd.vazbaMotivRozsah) lines.push(fd.vazbaMotivRozsah === 'obalka-vnitrek' ? "Motivy se li\u0161\xed: ob\xe1lka i vnit\u0159n\xed blok" : "Motivy se li\u0161\xed: jen ob\xe1lka / p\u0159ebal");
    if ($39500ec295adf68d$var$isTruthy(fd.vazbaPodlozka)) lines.push("\u0160ed\xe1 lepenka (podlo\u017Eka pod blok)");
    return lines;
}
function $39500ec295adf68d$var$nonZero(v) {
    return v !== undefined && v !== null && v !== '' && v !== '0' && v !== 0;
}
/**
 * Sestaví pole textových řádků popisujících dokončovací operace z formData.
 * Každý prvek = jedna operace (např. "Lakování: 1/0 UV lak parciální").
 * Pořadí odpovídá pořadí v editoru a ve zbytku aplikace.
 *
 * @param {object} formData
 * @returns {string[]}
 */ function $39500ec295adf68d$var$buildFinishingLines(formData) {
    const fd = formData || {};
    const lines = [];
    lines.push(...$39500ec295adf68d$var$buildMotivyLines(fd));
    lines.push(...$39500ec295adf68d$var$buildVazbaLines(fd));
    if ($39500ec295adf68d$var$nonZero(fd.barvyDigital) && $39500ec295adf68d$var$DIGITAL_COLOR[fd.barvyDigital]) lines.push(`Digit\xe1ln\xed speci\xe1ln\xed barva: ${$39500ec295adf68d$var$DIGITAL_COLOR[fd.barvyDigital]}`);
    if ($39500ec295adf68d$var$nonZero(fd.lakovani) && $39500ec295adf68d$var$LAK[fd.lakovani]) lines.push(`Lakov\xe1n\xed: ${$39500ec295adf68d$var$LAK[fd.lakovani]}`);
    if ($39500ec295adf68d$var$nonZero(fd.laminace) && $39500ec295adf68d$var$LAMINACE[fd.laminace]) lines.push(`Laminace: ${$39500ec295adf68d$var$LAMINACE[fd.laminace]}`);
    if ($39500ec295adf68d$var$nonZero(fd.falcovani) && $39500ec295adf68d$var$FALCOVANI[fd.falcovani]) lines.push(`Falcov\xe1n\xed: ${$39500ec295adf68d$var$FALCOVANI[fd.falcovani]}`);
    if ($39500ec295adf68d$var$nonZero(fd.bigovani) && $39500ec295adf68d$var$BIGOVANI[fd.bigovani]) lines.push(`Bigov\xe1n\xed: ${$39500ec295adf68d$var$BIGOVANI[fd.bigovani]}`);
    if ($39500ec295adf68d$var$nonZero(fd.vysek) && $39500ec295adf68d$var$VYSEK[fd.vysek]) lines.push(`V\xfdsek: ${$39500ec295adf68d$var$VYSEK[fd.vysek]} (${fd.pozicNaVysek || '1'} pozic)`);
    if ($39500ec295adf68d$var$nonZero(fd.predsek) && $39500ec295adf68d$var$PREDSEK[fd.predsek]) lines.push(`P\u{159}edsek: ${$39500ec295adf68d$var$PREDSEK[fd.predsek]} (${fd.pozicNaPredsek || '1'} pozic)`);
    if ($39500ec295adf68d$var$nonZero(fd.razba) && $39500ec295adf68d$var$RAZBA[fd.razba]) lines.push(`Ra\u{17E}ba: ${$39500ec295adf68d$var$RAZBA[fd.razba]} (${fd.pozicNaRazbu || '1'} pozic)`);
    if ($39500ec295adf68d$var$nonZero(fd.vrtani) && $39500ec295adf68d$var$VRTANI[fd.vrtani]) lines.push(`Vrt\xe1n\xed: ${$39500ec295adf68d$var$VRTANI[fd.vrtani]}`);
    if ($39500ec295adf68d$var$nonZero(fd.perforace)) {
        const pocet = parseInt(fd.perforace, 10);
        if (pocet > 0) lines.push(`Perforace ${pocet}x`);
    }
    if ($39500ec295adf68d$var$nonZero(fd.lepeni) && $39500ec295adf68d$var$LEPENI[fd.lepeni]) lines.push($39500ec295adf68d$var$LEPENI[fd.lepeni]);
    return lines;
}
// Regex prefixy, které detekují "segment dokončovací operace" v dříve uloženém
// dlouhém názvu položky. Když stará nabídka má name = "100ks, A3, 4/0, Lakování:…,
// Laminace:…, Matná křída 200 g/m²", tyto prefixy ze jména vyhodíme, aby zůstala
// pouze kratší varianta dle nové konvence.
const $39500ec295adf68d$var$FINISHING_NAME_PATTERNS = [
    /^Lakování:/i,
    /^Laminace:/i,
    /^Falcování:/i,
    /^Bigování:/i,
    /^Výsek:/i,
    /^Předsek:/i,
    /^Ražba:/i,
    /^Vrtání:/i,
    /^Perforace\s/i,
    /^Lepení krabiček$/i,
    /^Digitální speciální barva:/i,
    /^V\d/,
    /^Lepený blok/i,
    /^Kroužková/i,
    /^V2V8/i
];
/**
 * Odstraní z uloženého názvu položky segmenty, které popisují dokončovací
 * operace. Používá se při vykreslování starších nabídek, kde byl název uložen
 * se všemi operacemi spojený čárkou. Nové nabídky tento problém nemají –
 * `generateItemName()` už operace neskládá.
 *
 * Formát: segmenty oddělené ", ". Případný prefix "název zakázky: " se zachová.
 *
 * @param {string} name
 * @returns {string}
 */ function $39500ec295adf68d$var$stripFinishingFromName(name) {
    if (!name) return '';
    const colonIdx = name.indexOf(': ');
    // Pokud je před dvojtečkou nějaký user-zadaný název zakázky (bez čárky), oddělíme ho.
    let prefix = '';
    let rest = name;
    if (colonIdx !== -1 && !name.slice(0, colonIdx).includes(',')) {
        prefix = name.slice(0, colonIdx + 2);
        rest = name.slice(colonIdx + 2);
    }
    const parts = rest.split(/,\s*/);
    const kept = parts.filter((segment)=>{
        const trimmed = segment.trim();
        if (!trimmed) return false;
        return !$39500ec295adf68d$var$FINISHING_NAME_PATTERNS.some((re)=>re.test(trimmed));
    });
    return prefix + kept.join(', ');
}
$39500ec295adf68d$exports = {
    buildFinishingLines: $39500ec295adf68d$var$buildFinishingLines,
    stripFinishingFromName: $39500ec295adf68d$var$stripFinishingFromName,
    OFFER_FOOTER_DISCLAIMER: $39500ec295adf68d$var$OFFER_FOOTER_DISCLAIMER,
    DIGITAL_COLOR: // exporty map – kdyby je frontend potřeboval přímo
    $39500ec295adf68d$var$DIGITAL_COLOR,
    LAK: $39500ec295adf68d$var$LAK,
    LAMINACE: $39500ec295adf68d$var$LAMINACE,
    FALCOVANI: $39500ec295adf68d$var$FALCOVANI,
    BIGOVANI: $39500ec295adf68d$var$BIGOVANI,
    VYSEK: $39500ec295adf68d$var$VYSEK,
    PREDSEK: $39500ec295adf68d$var$PREDSEK,
    RAZBA: $39500ec295adf68d$var$RAZBA,
    VRTANI: $39500ec295adf68d$var$VRTANI,
    LEPENI: $39500ec295adf68d$var$LEPENI,
    VAZBA: $39500ec295adf68d$var$VAZBA
};



var $entK4 = parcelRequire("entK4");
const $89d32ed16e1177d1$var$OFFER_STATUS_META = {
    draft: {
        label: "Rozpracovan\xe1",
        badge: 'bg-gray-100 text-gray-800',
        dot: 'bg-gray-500'
    },
    sent: {
        label: "Odesl\xe1na",
        badge: 'bg-blue-100 text-blue-800',
        dot: 'bg-blue-500'
    },
    negotiation: {
        label: "Vyjedn\xe1v\xe1n\xed",
        badge: 'bg-amber-100 text-amber-800',
        dot: 'bg-amber-500'
    },
    approved: {
        label: "Schv\xe1lena",
        badge: 'bg-emerald-100 text-emerald-800',
        dot: 'bg-emerald-500'
    },
    rejected: {
        label: "Odm\xedtnuta",
        badge: 'bg-red-100 text-red-800',
        dot: 'bg-red-500'
    },
    converted: {
        label: "P\u0159evedena",
        badge: 'bg-purple-100 text-purple-800',
        dot: 'bg-purple-500'
    }
};
const $89d32ed16e1177d1$var$OFFER_STATUS_ORDER = [
    'draft',
    'sent',
    'negotiation',
    'approved',
    'rejected',
    'converted'
];
class $89d32ed16e1177d1$export$9669364b582e5a9e {
    constructor(){
        this.currentOffer = null;
        this.customerData = '';
        this.customerId = null;
        this.savingCustomer = false;
        this.init();
    }
    init() {
    // Inicializace editoru
    }
    /** Normalizuje customerData (string i objekt z MCP/AI nabídky) na text. */ normalizeCustomerData(data) {
        if (!data) return '';
        if (typeof data === 'string') return data;
        if (typeof data === 'object') {
            if (window.CustomersManager && typeof window.CustomersManager.formatCustomerToText === 'function') return window.CustomersManager.formatCustomerToText(data);
            const d = data;
            const lines = [];
            if (d.name) lines.push(d.name);
            if (d.address) lines.push(d.address);
            const cityLine = [
                d.zip,
                d.city
            ].filter(Boolean).join(' ');
            if (cityLine) lines.push(cityLine);
            const taxLine = [
                d.ico ? `I\u{10C}: ${d.ico}` : '',
                d.dic ? `DI\u{10C}: ${d.dic}` : ''
            ].filter(Boolean).join(', ');
            if (taxLine) {
                lines.push('');
                lines.push(taxLine);
            }
            return lines.join('\n');
        }
        return String(data);
    }
    async loadOffer(offer) {
        this.currentOffer = offer;
        this.customerData = this.normalizeCustomerData(offer.customerData);
        this.customerId = offer.customerId || null;
        const currentOfferIdElement = document.getElementById('current-offer-id');
        if (currentOfferIdElement) currentOfferIdElement.textContent = offer.id;
        this.renderStatusPanel();
        this.renderOfferContent();
    }
    // ----- Status panel -----
    getApiBase() {
        return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
    }
    renderStatusPanel() {
        const host = document.getElementById('nabidka-editor-status-panel');
        if (!host || !this.currentOffer) return;
        const status = this.currentOffer.status || 'draft';
        const meta = $89d32ed16e1177d1$var$OFFER_STATUS_META[status] || $89d32ed16e1177d1$var$OFFER_STATUS_META.draft;
        const isConverted = status === 'converted';
        host.innerHTML = `
      <div class="bg-white border border-gray-200 rounded-lg p-4 mb-4 shadow-sm">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div class="flex items-center gap-3">
            <span class="inline-flex items-center text-sm px-3 py-1 rounded-full ${meta.badge}">
              <span class="w-2 h-2 rounded-full mr-2 ${meta.dot}"></span>${this.escape(meta.label)}
            </span>
            ${this.currentOffer.convertedToOrderId ? `
              <span class="text-sm text-gray-600">
                P\u{159}evedeno na objedn\xe1vku
                <button id="offer-open-order-btn" class="text-purple-700 hover:underline font-medium">
                  ${this.escape(this.currentOffer.convertedToOrderId)}
                </button>
              </span>
            ` : ''}
          </div>
          <div class="flex flex-wrap items-center gap-2">
            <label class="text-sm text-gray-600">Zm\u{11B}nit stav:</label>
            <select id="offer-status-select"
              class="px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              ${isConverted ? 'disabled' : ''}>
              ${$89d32ed16e1177d1$var$OFFER_STATUS_ORDER.map((s)=>`<option value="${s}" ${s === status ? 'selected' : ''}>${this.escape($89d32ed16e1177d1$var$OFFER_STATUS_META[s].label)}</option>`).join('')}
            </select>
            <button id="offer-convert-btn"
              class="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-white ${status === 'approved' ? 'bg-purple-600 hover:bg-purple-700' : 'bg-gray-300 cursor-not-allowed'} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
              ${status === 'approved' ? '' : 'disabled'}
              title="${status === 'approved' ? "Vytvo\u0159\xed objedn\xe1vku jako kopii nab\xeddky" : 'Nejprve nastavte stav \u201ESchv\xe1lena"'}">
              ${(0, $entK4.icon)('arrow-right', 'w-4 h-4 mr-2')}
              P\u{159}ev\xe9st na objedn\xe1vku
            </button>
          </div>
        </div>
        ${this.renderStatusHistory(this.currentOffer.statusHistory)}
      </div>
    `;
        document.getElementById('offer-status-select')?.addEventListener('change', (e)=>this.changeStatus(e.target.value));
        document.getElementById('offer-convert-btn')?.addEventListener('click', ()=>this.convertToOrder());
        document.getElementById('offer-open-order-btn')?.addEventListener('click', ()=>{
            if (window.ordersListManager && this.currentOffer.convertedToOrderId) window.ordersListManager.openDetail(this.currentOffer.convertedToOrderId);
        });
    }
    renderStatusHistory(history) {
        if (!Array.isArray(history) || history.length <= 1) return '';
        const last3 = history.slice(-3).reverse();
        return `
      <details class="mt-3">
        <summary class="text-xs text-gray-500 cursor-pointer hover:text-gray-700">Historie zm\u{11B}n stavu (${history.length})</summary>
        <ol class="relative border-l border-gray-200 ml-3 mt-2">
          ${last3.map((h)=>{
            const m = $89d32ed16e1177d1$var$OFFER_STATUS_META[h.status] || {
                label: h.status,
                dot: 'bg-gray-400'
            };
            const time = new Date(h.changedAt).toLocaleString('cs-CZ');
            return `
              <li class="ml-4 pb-2">
                <span class="absolute -left-1.5 mt-1.5 w-2.5 h-2.5 rounded-full border border-white ${m.dot}"></span>
                <div class="text-xs font-medium text-gray-800">${this.escape(m.label)}</div>
                <div class="text-xs text-gray-500">${time} \xb7 ${this.escape(h.changedBy || "\u2014")}</div>
                ${h.note ? `<div class="text-xs text-gray-600">${this.escape(h.note)}</div>` : ''}
              </li>
            `;
        }).join('')}
        </ol>
      </details>
    `;
    }
    async changeStatus(newStatus) {
        if (!this.currentOffer) return;
        try {
            const res = await fetch(`${this.getApiBase()}/offers/${this.currentOffer.id}/status`, {
                method: 'PATCH',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    status: newStatus
                })
            });
            const json = await res.json();
            if (!res.ok) throw new Error(json.error || "Nepoda\u0159ilo se zm\u011Bnit stav");
            this.currentOffer = json.data;
            this.renderStatusPanel();
            if (window.showNotification) window.showNotification(`Stav zm\u{11B}n\u{11B}n na \u{201E}${$89d32ed16e1177d1$var$OFFER_STATUS_META[newStatus]?.label || newStatus}"`, 'success');
        } catch (err) {
            console.error("Chyba p\u0159i zm\u011Bn\u011B stavu:", err);
            if (window.showNotification) window.showNotification(err.message, 'error');
            this.renderStatusPanel();
        }
    }
    async convertToOrder() {
        if (!this.currentOffer) return;
        if (this.currentOffer.status !== 'approved') {
            if (window.showNotification) window.showNotification("Pouze schv\xe1len\xe9 nab\xeddky lze p\u0159ev\xe9st na objedn\xe1vku", 'warning');
            return;
        }
        if (!confirm(`P\u{159}ev\xe9st nab\xeddku #${this.currentOffer.id} na objedn\xe1vku?
Nab\xeddka se uzamkne pro dal\u{161}\xed \xfapravy.`)) return;
        try {
            const res = await fetch(`${this.getApiBase()}/orders/from-offer/${this.currentOffer.id}`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const json = await res.json();
            if (!res.ok) throw new Error(json.error || "Nepoda\u0159ilo se p\u0159ev\xe9st nab\xeddku");
            const order = json.data;
            if (window.showNotification) window.showNotification(`Vytvo\u{159}ena objedn\xe1vka #${order.id}`, 'success');
            // Refresh nabídky (status converted, convertedToOrderId)
            try {
                const r = await fetch(`${this.getApiBase()}/offers/${this.currentOffer.id}`, {
                    credentials: 'include'
                });
                if (r.ok) {
                    const data = await r.json();
                    this.currentOffer = data.data;
                    this.renderStatusPanel();
                }
            } catch (e) {
                console.warn("Nepoda\u0159ilo se obnovit data nab\xeddky po p\u0159evodu:", e);
            }
            // Otevři detail nově vytvořené objednávky
            if (window.ordersListManager) window.ordersListManager.openDetail(order.id);
            else if (window.sectionManager) window.sectionManager.showSection('objednavky');
        } catch (err) {
            console.error("Chyba p\u0159i p\u0159evodu:", err);
            if (window.showNotification) window.showNotification(err.message, 'error');
        }
    }
    renderOfferContent() {
        if (!this.currentOffer) return;
        const container = document.getElementById('nabidka-editor-content');
        if (!container) return;
        const date = new Date(this.currentOffer.createdAt);
        const formattedDate = date.toLocaleDateString('cs-CZ', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
        // Vypočítat celkovou cenu a cenu s DPH
        const totalPrice = this.currentOffer.totalPrice || 0;
        const vatRate = 0.21; // 21% DPH
        const totalPriceWithVat = totalPrice * (1 + vatRate);
        container.innerHTML = `
      <div class="container a4-wrapper" style="max-width: 800px; margin: 0 auto; font-family: 'Plus Jakarta Sans Variable', 'Inter Tight', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
        <header style="display: flex; flex-direction: row; align-items: flex-start; padding-bottom: 22px; border-bottom: 1px solid black; margin-bottom: 20px;">
          <div style="width: 50%;">
            <img src="${0, (/*@__PURE__*/$parcel$interopDefault($cdb5ad58694a976a$exports))}" alt="Tisk\xe1rna Tria, s.r.o." width="140" height="45">
          </div>
          <div style="width: 50%; text-align: right;">
            <h1 style="font-size: 1.3em; margin: 0 0 10px 0; font-weight: 600;">Cenov\xe1 nab\xeddka \u{10D}. ${this.currentOffer.id}</h1>
            <div style="font-size: 0.9em; color: #5A6079;">Ze dne: ${formattedDate}</div>
            <div style="font-size: 0.9em; color: #5A6079;">Vystavil: ${this.currentOffer.createdBy || "Syst\xe9m"}</div>
          </div>
        </header>

        <section style="display: flex; padding-top: 10px; flex-direction: row; align-items: flex-start; justify-content: flex-start; margin-bottom: 20px;">
          <div style="width: 50%;">
            <div class="flex items-center justify-between mb-2">
              <p class="offer-party-label">Odb\u{11B}ratel</p>
              <div class="flex items-center gap-2">
                ${this.customerId ? `
                  <span class="inline-flex items-center text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-700" title="Propojeno se z\xe1kazn\xedkem">
                    ${(0, $entK4.icon)('check', 'w-3 h-3 mr-1')}
                    Z datab\xe1ze
                  </span>
                  <button type="button" onclick="window.offerEditorManager.clearCustomer()"
                    class="text-xs text-gray-500 hover:text-red-600 underline">Odpojit</button>
                ` : ''}
                <button type="button" onclick="window.offerEditorManager.openCustomerSelector()"
                  class="inline-flex items-center px-2.5 py-1 border border-blue-300 text-xs font-medium rounded-md text-blue-700 bg-white hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500">
                  ${(0, $entK4.icon)('magnifying-glass', 'w-3.5 h-3.5 mr-1')}
                  ${this.customerId ? "Zm\u011Bnit z\xe1kazn\xedka" : "Vybrat z\xe1kazn\xedka"}
                </button>
              </div>
            </div>
            <div class="customer-data-container">
              <textarea id="customer-data-input" 
                class="w-full p-3 border border-gray-300 rounded-md resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" 
                rows="8" 
                placeholder="Zadejte \xfadaje odb\u{11B}ratele:&#10;N\xe1zev spole\u{10D}nosti&#10;Adresa&#10;PS\u{10C} M\u{11B}sto&#10;Zem\u{11B}&#10;&#10;I\u{10C}: xxxxxxxxx&#10;DI\u{10C}: xxxxxxxxx"
                onchange="window.offerEditorManager.updateCustomerData(this.value)"
              >${this.customerData}</textarea>
            </div>
          </div>

          <div style="width: 50%; padding-left: 20px;">
            <p class="offer-party-label">Dodavatel</p>
            <div>
              <p>Tisk\xe1rna Tria s.r.o.<br>
              Olbramovice Ves 31,<br>
              259 01 Olbramovice</p>
              <p>I\u{10C}O: 49546112<br>
              DI\u{10C}: CZ49546112</p>
              <p>Email: tiskarna@tria.cz<br>
              Web: www.tria.cz</p>
            </div>
          </div>
        </section>

        <table style="width: 100%; border-collapse: collapse; margin-top: 10px; margin-bottom: 20px;">
          <thead>
            <tr style="border-bottom: 1px solid black;">
              <th style="padding: 8px 4px; text-align: left; font-size: 0.85em; letter-spacing: 0.04em; text-transform: uppercase; color: #5A6079;">Ozna\u{10D}en\xed polo\u{17E}ky</th>
              <th style="padding: 8px 4px; text-align: right; font-size: 0.85em; letter-spacing: 0.04em; text-transform: uppercase; color: #5A6079; white-space: nowrap;">Po\u{10D}et kus\u{16F}</th>
              <th style="padding: 8px 4px; text-align: right; font-size: 0.85em; letter-spacing: 0.04em; text-transform: uppercase; color: #5A6079; white-space: nowrap;">Cena za kus</th>
              <th style="padding: 8px 4px; text-align: right; font-size: 0.85em; letter-spacing: 0.04em; text-transform: uppercase; color: #5A6079;">Cena</th>
              <th style="padding: 8px 4px; text-align: right; font-size: 0.85em; letter-spacing: 0.04em; text-transform: uppercase; color: #5A6079;">% DPH</th>
              <th style="padding: 8px 4px; text-align: right; font-size: 0.85em; letter-spacing: 0.04em; text-transform: uppercase; color: #5A6079; white-space: nowrap;">Cena s DPH</th>
            </tr>
          </thead>
          <tbody>
            ${this.currentOffer.items.map((item)=>this.renderOfferItemRow(item)).join('')}
          </tbody>
        </table>

        <section style="display: flex; justify-content: flex-end; margin-bottom: 16px;">
          <div style="min-width: 280px; font-size: 1em;">
            <div style="display: flex; justify-content: space-between; padding: 4px 0;">
              <span style="color: #5A6079;">Cena celkem (bez DPH)</span>
              <span>${totalPrice.toLocaleString('cs-CZ')} K\u{10D}</span>
            </div>
            <div style="display: flex; justify-content: space-between; padding: 4px 0;">
              <span style="color: #5A6079;">DPH ${(vatRate * 100).toFixed(0)} %</span>
              <span>${(totalPrice * vatRate).toLocaleString('cs-CZ', {
            maximumFractionDigits: 2
        })} K\u{10D}</span>
            </div>
            <div style="display: flex; justify-content: space-between; padding: 8px 0 4px; margin-top: 4px; border-top: 1px solid black; font-weight: 700; font-size: 1.15em;">
              <span>Celkem s DPH</span>
              <span>${totalPriceWithVat.toLocaleString('cs-CZ', {
            maximumFractionDigits: 2
        })} K\u{10D}</span>
            </div>
          </div>
        </section>

        <footer style="margin-top: 24px; padding-top: 16px; border-top: 1px solid #EDEEF3; font-size: 0.75rem; color: #5A6079; line-height: 1.5; text-align: center;">
          ${0, $39500ec295adf68d$exports.OFFER_FOOTER_DISCLAIMER}
        </footer>
      </div>
    `;
    }
    renderOfferItemRow(item) {
        const vatRate = 0.21; // 21% DPH
        const priceWithVat = item.price * (1 + vatRate);
        const quantity = Number(item.formData?.pocetKusu) || 1;
        // Cena za kus – preferujeme uložený pricePerPiece (kalkulačka ho spočítá
        // včetně všech příplatků), jinak fallback na item.price / počet kusů.
        const unitPrice = item.pricePerPiece || (quantity > 0 ? item.price / quantity : 0);
        const displayName = (0, $39500ec295adf68d$exports.stripFinishingFromName)(item.name || '');
        const finishingLines = item.formData ? (0, $39500ec295adf68d$exports.buildFinishingLines)(item.formData) : [];
        const hasSpec = finishingLines.length > 0;
        const nameId = (item.name || '').replace(/[^a-zA-Z0-9]/g, '');
        return `
      <tr class="${hasSpec ? 'item-row' : ''}" style="${hasSpec ? '' : 'border-bottom: 1px solid #EDEEF3;'}">
        <td style="padding: 8px 4px; vertical-align: top; ${hasSpec ? '' : ''}">
          <div style="font-weight: 500;">${this.escape(displayName)}</div>
          ${item.notes && item.notes.trim() ? `<div style="font-size: 0.85em; color: #5A6079; margin-top: 2px;">${this.escape(item.notes)}</div>` : ''}
        </td>
        <td style="padding: 8px 4px; text-align: right; white-space: nowrap; vertical-align: top; font-variant-numeric: tabular-nums;">${quantity.toLocaleString('cs-CZ')} ks</td>
        <td style="padding: 8px 4px; text-align: right; white-space: nowrap; vertical-align: top; font-variant-numeric: tabular-nums;">${unitPrice.toLocaleString('cs-CZ', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        })} K\u{10D}</td>
        <td style="padding: 8px 4px; text-align: right; white-space: nowrap; vertical-align: top; font-variant-numeric: tabular-nums;">${item.price.toLocaleString('cs-CZ', {
            maximumFractionDigits: 2
        })} K\u{10D}</td>
        <td style="padding: 8px 4px; text-align: right; white-space: nowrap; vertical-align: top; font-variant-numeric: tabular-nums;">${(vatRate * 100).toFixed(0)} %</td>
        <td style="padding: 8px 4px; text-align: right; white-space: nowrap; vertical-align: top; font-variant-numeric: tabular-nums;">${priceWithVat.toLocaleString('cs-CZ', {
            maximumFractionDigits: 2
        })} K\u{10D}</td>
      </tr>
      ${hasSpec ? `
        <tr style="border-bottom: 1px solid #EDEEF3;">
          <td colspan="6" style="padding: 0 4px 10px 4px; font-size: 0.85em; color: #5A6079; line-height: 1.5;">
            ${finishingLines.map((l)=>this.escape(l)).join('<br>')}
          </td>
        </tr>
      ` : ''}
      <tr style="border-bottom: 1px solid #EDEEF3;">
        <td colspan="6" style="padding: 0 4px 12px 4px;">
          <textarea id="notes-${nameId}"
            style="width: 100%; min-height: 52px; padding: 6px 8px; border: 1px solid #D6D9E3; border-radius: 4px; resize: vertical; font-size: 0.9em; color: #0B0E2D;"
            placeholder="Zadejte dodate\u{10D}n\xe9 informace nebo pozn\xe1mky k t\xe9to polo\u{17E}ce..."
            onchange="window.offerEditorManager.updateItemNotes('${this.escape(item.name)}', this.value)"
          >${this.escape(item.notes || '')}</textarea>
        </td>
      </tr>
    `;
    }
    // Zpětně-kompatibilní wrapper: vrací HTML s <br>. Nová logika je v
    // shared/offer-item-format.js. Dodatečné mapování níže zůstává pro případ,
    // že by někdo volal getLakText apod. z externího kódu.
    formatItemSpecification(formData) {
        return (0, $39500ec295adf68d$exports.buildFinishingLines)(formData || {}).join('<br>');
    }
    _legacyFormatItemSpecification(formData) {
        let spec = [];
        // Digitální speciální barvy
        if (formData.barvyDigital && formData.barvyDigital !== '0') {
            const digitalText = this.getDigitalColorName(formData.barvyDigital);
            if (digitalText) spec.push(`Digit\xe1ln\xed speci\xe1ln\xed barva: ${digitalText}`);
        }
        // Lakování
        if (formData.lakovani && formData.lakovani !== '0') {
            const lakText = this.getLakText(formData.lakovani);
            if (lakText) spec.push(`Lakov\xe1n\xed: ${lakText}`);
        }
        // Laminace
        if (formData.laminace && formData.laminace !== '0') {
            const laminaceText = this.getLaminaceText(formData.laminace);
            if (laminaceText) spec.push(`Laminace: ${laminaceText}`);
        }
        // Falcování
        if (formData.falcovani && formData.falcovani !== '0') {
            const falcovaniText = this.getFalcovaniText(formData.falcovani);
            if (falcovaniText) spec.push(`Falcov\xe1n\xed: ${falcovaniText}`);
        }
        // Bigování
        if (formData.bigovani && formData.bigovani !== '0') {
            const bigovaniText = this.getBigovaniText(formData.bigovani);
            if (bigovaniText) spec.push(`Bigov\xe1n\xed: ${bigovaniText}`);
        }
        // Výsek
        if (formData.vysek && formData.vysek !== '0') {
            const vysekText = this.getVysekText(formData.vysek);
            const pozicNaVysek = formData.pozicNaVysek || '1';
            if (vysekText) spec.push(`V\xfdsek: ${vysekText} (${pozicNaVysek} pozic)`);
        }
        // Předsek
        if (formData.predsek && formData.predsek !== '0') {
            const predsekText = this.getPredsekText(formData.predsek);
            const pozicNaPredsek = formData.pozicNaPredsek || '1';
            if (predsekText) spec.push(`P\u{159}edsek: ${predsekText} (${pozicNaPredsek} pozic)`);
        }
        // Ražba
        if (formData.razba && formData.razba !== '0') {
            const razbaText = this.getRazbaText(formData.razba);
            const pozicNaRazbu = formData.pozicNaRazbu || '1';
            if (razbaText) spec.push(`Ra\u{17E}ba: ${razbaText} (${pozicNaRazbu} pozic)`);
        }
        // Vrtání
        if (formData.vrtani && formData.vrtani !== '0') {
            const vrtaniText = this.getVrtaniText(formData.vrtani);
            if (vrtaniText) spec.push(`Vrt\xe1n\xed: ${vrtaniText}`);
        }
        // Perforace
        if (formData.perforace && formData.perforace !== '0') {
            const pocetPerforaci = parseInt(formData.perforace);
            if (pocetPerforaci > 0) spec.push(`Perforace ${pocetPerforaci}x`);
        }
        // Lepení
        if (formData.lepeni && formData.lepeni !== '0') {
            const lepeniText = this.getLepeniText(formData.lepeni);
            if (lepeniText) spec.push(lepeniText);
        }
        // Vazba
        if (formData.vazba && formData.vazba !== '0') {
            const vazbaText = this.getVazbaText(formData.vazba);
            if (vazbaText) spec.push(vazbaText);
        }
        return spec.join('<br>');
    }
    // Pomocné funkce pro převod hodnot na texty (shodné s offer-items.js)
    getDigitalColorName(typ) {
        const nazvy = {
            'lak_10_50': "1/0 lak (parci\xe1ln\xed)",
            'lak_11_50': "1/1 lak (parci\xe1ln\xed)",
            'lak_10_100': "1/0 lak (cel\xe1 plocha)",
            'lak_11_100': "1/1 lak (cel\xe1 plocha)",
            'bila_10_50': "1/0 b\xedl\xe1 (parci\xe1ln\xed)",
            'bila_11_50': "1/1 b\xedl\xe1 (parci\xe1ln\xed)",
            'bila_10_100': "1/0 b\xedl\xe1 (cel\xe1 plocha)",
            'bila_11_100': "1/1 b\xedl\xe1 (cel\xe1 plocha)",
            'zlata_10_50': "1/0 zlat\xe1 (parci\xe1ln\xed)",
            'zlata_11_50': "1/1 zlat\xe1 (parci\xe1ln\xed)",
            'zlata_10_100': "1/0 zlat\xe1 (cel\xe1 plocha)",
            'zlata_11_100': "1/1 zlat\xe1 (cel\xe1 plocha)"
        };
        return nazvy[typ] || '';
    }
    getLakText(typ) {
        const nazvy = {
            'parcial10': "1/0 UV lak parci\xe1ln\xed",
            'parcial11': "1/1 UV lak parci\xe1ln\xed",
            'plocha10': "1/0 UV lak cel\xe1 plocha",
            'plocha11': "1/1 UV lak cel\xe1 plocha",
            'stroj10': '1/0 Stroj lak',
            'stroj11': '1/1 Stroj lak'
        };
        return nazvy[typ] || '';
    }
    getLaminaceText(typ) {
        const nazvy = {
            'lesk10': "1/0 Lamino leskl\xe9",
            'lesk11': "1/1 Lamino leskl\xe9",
            'mat10': "1/0 Lamino matn\xe9",
            'mat11': "1/1 Lamino matn\xe9",
            'struktura10': "1/0 Lamino nepo\u0161krabateln\xe9",
            'struktura11': "1/1 Lamino nepo\u0161krabateln\xe9",
            'samet10': "1/0 Lamino sametov\xe9",
            'samet11': "1/1 Lamino sametov\xe9",
            'kapsaA5': "1/1 Laminace kapsov\xe1 (A5)",
            'kapsaA4': "1/1 Laminace kapsov\xe1 (A4)",
            'kapsaA3': "1/1 Laminace kapsov\xe1 (A3)"
        };
        return nazvy[typ] || '';
    }
    getFalcovaniText(typ) {
        const nazvy = {
            'half-fold': 'Na polovinu (1 lom)',
            'cross-fold': "K\u0159\xed\u017Eov\xfd lom (2 lomy)",
            'u-fold': 'Do U (2 lomy)',
            'z-fold': 'Do Z (2 lomy)',
            'double-half-fold': 'Na polovinu (2 lomy)',
            'roll-fold': "Harmonikov\xe9 s p\u0159ebalem (3 lomy)",
            'harmonium-fold-3': "Harmonikov\xe9 skl\xe1d\xe1n\xed (3 lomy)",
            'harmonium-fold-4': "Harmonikov\xe9 skl\xe1d\xe1n\xed (4 lomy)",
            'harmonium-fold-5': "Harmonikov\xe9 skl\xe1d\xe1n\xed (5 lom\u016F)",
            'gate-fold': "Skl\xe1d\xe1n\xed do psan\xed\u010Dka (3 lomy)",
            'double-gate-fold': "Zav\u0159en\xe9 psan\xed\u010Dko (3 lomy)"
        };
        return nazvy[typ] || '';
    }
    getBigovaniText(typ) {
        const nazvy = {
            'half-fold': 'Na polovinu (1 big)',
            'cross-fold': "Do k\u0159\xed\u017Ee (2 bigy)",
            'u-fold': 'Do U (2 bigy)',
            'z-fold': 'Do Z (2 bigy)',
            'double-half-fold': 'Na polovinu (2 bigy)',
            'roll-fold': "Harmonikov\xe9 (3 bigy)",
            'harmonium-fold-3': "Harmonikov\xe9 (3 bigy)",
            'harmonium-fold-4': "Harmonikov\xe9 (4 bigy)",
            'harmonium-fold-5': "Harmonikov\xe9 (5 bigy)",
            'gate-fold': "Skl\xe1d\xe1n\xed do psan\xed\u010Dka (3 bigy)",
            'double-gate-fold': "Zav\u0159en\xe9 psan\xed\u010Dko (3 bigy)"
        };
        return nazvy[typ] || '';
    }
    getVysekText(option) {
        const nazvy = {
            'vlastni': "Vlastn\xed/p\u016Fj\u010Den\xe9 v\xfdsekov\xe9 \u017Eelezo",
            'nove': "Nov\xe9 v\xfdsekov\xe9 \u017Eelezo"
        };
        return nazvy[option] || '';
    }
    getPredsekText(option) {
        const nazvy = {
            '1': "Vlastn\xed/p\u016Fj\u010Den\xe9 p\u0159edsekov\xe9 \u017Eelezo",
            '2': "Nov\xe9 p\u0159edsekov\xe9 \u017Eelezo"
        };
        return nazvy[option] || '';
    }
    getRazbaText(option) {
        const nazvy = {
            '1': "Vlastn\xed/p\u016Fj\u010Den\xfd \u0161to\u010Dek",
            '2': "Nov\xfd \u0161to\u010Dek"
        };
        return nazvy[option] || '';
    }
    getVrtaniText(typ) {
        const nazvy = {
            '1dira2mm': "1 d\xedra (2 mm)",
            '1dira4mm': "1 d\xedra (4 mm)",
            '1dira5mm': "1 d\xedra (5,5 mm)",
            '2diry2mm': "2 d\xedry (2 mm)",
            '2diry4mm': "2 d\xedry (4 mm)",
            '2diry5mm': "2 d\xedry (5,5 mm)",
            'euro2diry2mm': "Euro blok, 2 d\xedry (2 mm)",
            'euro2diry4mm': "Euro blok, 2 d\xedry (4 mm)",
            'euro2diry5mm': "Euro blok, 2 d\xedry (5,5 mm)",
            '3diry2mm': "3 d\xedry (2 mm)",
            '3diry4mm': "3 d\xedry (4 mm)",
            '3diry5mm': "3 d\xedry (5,5 mm)",
            'euro4diry2mm': "Euro blok, 4 d\xedry (2 mm)",
            'euro4diry4mm': "Euro blok, 4 d\xedry (4 mm)",
            'euro4diry5mm': "Euro blok, 4 d\xedry (5,5 mm)"
        };
        return nazvy[typ] || '';
    }
    getLepeniText(typ) {
        const nazvy = {
            '1': "Lepen\xed krabi\u010Dek"
        };
        return nazvy[typ] || '';
    }
    getVazbaText(typ) {
        const nazvy = {
            'V1-strojni': "V1 (2 skoby) strojn\xed",
            'V1-rucni': "V1 (2 skoby) ru\u010Dn\u011B",
            'blok': "Lepen\xfd blok",
            'blokPrebal': "Lepen\xfd blok s p\u0159ebalem",
            'V2-PUR': "V2 lepen\xe1 (PUR)",
            'V3': "V3 lepen\xe1 a \u0161it\xe1",
            'V6': 'V6 leporelo',
            'krouzek-blok': "Krou\u017Ekov\xe1 twin wire",
            'krouzek-kalendar': "Krou\u017Ekov\xe1 s h\xe1\u010Dkem na pov\u011B\u0161en\xed",
            'V4': "V4 \u0161it\xe1, m\u011Bkk\xe1 ob\xe1lka",
            'V5': "V5 \u0161it\xe1, tvrd\xe1 ob\xe1lka",
            'V2V8': "V2V8 \u2013 fale\u0161n\xe1 V8",
            'V8': "V8 \u0161it\xe1, tvrd\xe1 ob\xe1lka"
        };
        return nazvy[typ] || "Nezn\xe1m\xe1 vazba";
    }
    updateCustomerData(value) {
        this.customerData = value;
        // Pokud uživatel ručně upraví text, propojení se zákazníkem už nereflektuje databázi - rozpojit
        if (this.customerId) this.customerId = null;
        this.persistCustomerOnOffer();
    }
    async openCustomerSelector() {
        if (!window.customersManager) {
            if (window.showNotification) window.showNotification("Modul z\xe1kazn\xedk\u016F nen\xed dostupn\xfd", 'error');
            return;
        }
        try {
            const customer = await window.customersManager.openSelector();
            if (!customer) return;
            this.applySelectedCustomer(customer);
        } catch (err) {
            console.error("Chyba p\u0159i v\xfdb\u011Bru z\xe1kazn\xedka:", err);
            if (window.showNotification) window.showNotification(err.message || "Chyba p\u0159i v\xfdb\u011Bru z\xe1kazn\xedka", 'error');
        }
    }
    applySelectedCustomer(customer) {
        this.customerId = customer.id;
        this.customerData = window.CustomersManager ? window.CustomersManager.formatCustomerToText(customer) : [
            customer.name,
            customer.address,
            [
                customer.zip,
                customer.city
            ].filter(Boolean).join(' ')
        ].filter(Boolean).join('\n');
        const textarea = document.getElementById('customer-data-input');
        if (textarea) textarea.value = this.customerData;
        this.renderOfferContent();
        this.persistCustomerOnOffer();
        if (window.showNotification) window.showNotification(`Vybr\xe1n z\xe1kazn\xedk: ${customer.name}`, 'success');
    }
    clearCustomer() {
        this.customerId = null;
        this.customerData = '';
        const textarea = document.getElementById('customer-data-input');
        if (textarea) textarea.value = '';
        this.renderOfferContent();
        this.persistCustomerOnOffer();
    }
    /**
   * Uloží customerData a customerId do nabídky na backendu (pokud je nabídka načtená).
   */ async persistCustomerOnOffer() {
        if (!this.currentOffer || this.savingCustomer) return;
        this.savingCustomer = true;
        try {
            const API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
            const res = await fetch(`${API_BASE_URL}/offers/${this.currentOffer.id}`, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    customerData: this.customerData,
                    customerId: this.customerId
                })
            });
            if (!res.ok) throw new Error("Chyba p\u0159i ukl\xe1d\xe1n\xed odb\u011Bratele");
            const json = await res.json();
            if (json && json.data) {
                this.currentOffer.customerData = json.data.customerData;
                this.currentOffer.customerId = json.data.customerId;
            }
        } catch (err) {
            console.error("Chyba p\u0159i ukl\xe1d\xe1n\xed odb\u011Bratele:", err);
            if (window.showNotification) window.showNotification(err.message || "Chyba p\u0159i ukl\xe1d\xe1n\xed odb\u011Bratele", 'error');
        } finally{
            this.savingCustomer = false;
        }
    }
    updateItemNotes(itemName, notes) {
        if (!this.currentOffer) return;
        // Najít položku a aktualizovat poznámky
        const item = this.currentOffer.items.find((item)=>item.name === itemName);
        if (item) item.notes = notes;
    }
    async editCurrentOffer() {
        if (!this.currentOffer) return;
        try {
            // Přepnout na kalkulátor s načtenými daty
            if (window.sectionManager) window.sectionManager.showSection('kalkulator');
            // Načíst položky do kalkulátoru
            if (window.offerItemsManager) {
                // Vymazat stávající položky
                window.offerItemsManager.items = [];
                window.offerItemsManager.itemIdCounter = 0;
                window.offerItemsManager.activeItemId = null;
                // Načíst položky z nabídky
                this.currentOffer.items.forEach((item, index)=>{
                    if (index === 0) {
                        // První položku vytvoříme pomocí addItem
                        window.offerItemsManager.addItem();
                        const firstItem = window.offerItemsManager.items[0];
                        firstItem.name = item.name;
                        firstItem.formData = item.formData;
                        firstItem.price = item.price;
                        firstItem.pricePerPiece = item.pricePerPiece;
                    } else {
                        // Další položky přidáme
                        const itemId = ++window.offerItemsManager.itemIdCounter;
                        window.offerItemsManager.items.push({
                            id: itemId,
                            name: item.name,
                            formData: item.formData,
                            price: item.price,
                            pricePerPiece: item.pricePerPiece
                        });
                    }
                });
                // Aktivovat první položku
                if (window.offerItemsManager.items.length > 0) {
                    window.offerItemsManager.activeItemId = window.offerItemsManager.items[0].id;
                    window.offerItemsManager.restoreFormState(window.offerItemsManager.items[0].formData);
                    window.offerItemsManager.renderItems();
                    window.offerItemsManager.updateTotalPrice();
                }
            }
            if (window.showNotification) window.showNotification("Nab\xeddka na\u010Dtena do kalkul\xe1toru pro editaci", 'success');
        } catch (error) {
            console.error("Chyba p\u0159i editaci nab\xeddky:", error);
            if (window.showNotification) window.showNotification("Chyba p\u0159i editaci nab\xeddky", 'error');
        }
    }
    async deleteCurrentOffer() {
        if (!this.currentOffer) return;
        if (!confirm("Opravdu chcete smazat tuto nab\xeddku?")) return;
        try {
            const API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
            const response = await fetch(`${API_BASE_URL}/offers/${this.currentOffer.id}`, {
                method: 'DELETE',
                credentials: 'include'
            });
            if (!response.ok) throw new Error("Chyba p\u0159i maz\xe1n\xed nab\xeddky");
            if (window.showNotification) window.showNotification("Nab\xeddka byla \xfasp\u011B\u0161n\u011B smaz\xe1na", 'success');
            // Přepnout zpět na seznam nabídek
            if (window.sectionManager) window.sectionManager.showSection('nabidky');
            // Znovu načíst seznam nabídek
            if (window.offersListManager) window.offersListManager.loadOffers();
        } catch (error) {
            console.error("Chyba p\u0159i maz\xe1n\xed nab\xeddky:", error);
            if (window.showNotification) window.showNotification("Chyba p\u0159i maz\xe1n\xed nab\xeddky", 'error');
        }
    }
    async createPublicLink() {
        if (!this.currentOffer) return;
        try {
            const API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
            const response = await fetch(`${API_BASE_URL}/offers/${this.currentOffer.id}/public-link`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) throw new Error("Chyba p\u0159i vytv\xe1\u0159en\xed ve\u0159ejn\xe9ho odkazu");
            const result = await response.json();
            if (result.success && result.data) // Zobrazit modal s veřejným odkazem
            this.showPublicLinkModal(result.data);
            else throw new Error("Neplatn\xe1 odpov\u011B\u010F od serveru");
        } catch (error) {
            console.error("Chyba p\u0159i vytv\xe1\u0159en\xed ve\u0159ejn\xe9ho odkazu:", error);
            if (window.showNotification) window.showNotification("Chyba p\u0159i vytv\xe1\u0159en\xed ve\u0159ejn\xe9ho odkazu", 'error');
        }
    }
    showPublicLinkModal(linkData) {
        // Vytvořit modal pro zobrazení veřejného odkazu
        const modalHtml = `
      <div id="public-link-modal" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="public-link-modal-title" role="dialog" aria-modal="true">
        <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
          <!-- Background overlay -->
          <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

          <!-- Modal panel -->
          <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
            <div>
              <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                ${(0, $entK4.icon)('link', 'h-6 w-6 text-green-600')}
              </div>
              <div class="mt-3 text-center sm:mt-5">
                <h3 class="text-lg leading-6 font-medium text-gray-900" id="public-link-modal-title">
                  Ve\u{159}ejn\xfd odkaz na nab\xeddku
                </h3>
                <div class="mt-2">
                  <p class="text-sm text-gray-500">
                    Tento odkaz m\u{16F}\u{17E}ete poslat klientovi. Nab\xeddka bude zobrazena bez mo\u{17E}nosti editace.
                  </p>
                </div>
                <div class="mt-4">
                  <div class="flex rounded-md shadow-sm">
                    <input 
                      type="text" 
                      id="public-link-url" 
                      readonly 
                      value="${linkData.url}" 
                      class="flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-l-md border border-gray-300 bg-gray-50 text-sm"
                    >
                    <button 
                      onclick="window.offerEditorManager.copyToClipboard('${linkData.url}')"
                      type="button" 
                      class="inline-flex items-center px-4 py-2 border border-l-0 border-gray-300 rounded-r-md bg-blue-600 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                      ${(0, $entK4.icon)('document-duplicate', 'h-5 w-5')}
                      <span class="ml-2">Kop\xedrovat</span>
                    </button>
                  </div>
                </div>
                <div class="mt-3 text-xs text-gray-400">
                  <p>Vytvo\u{159}eno: ${new Date(linkData.createdAt).toLocaleString('cs-CZ')}</p>
                  ${linkData.viewCount > 0 ? `<p>Zobrazen\xed: ${linkData.viewCount}\xd7</p>` : ''}
                </div>
              </div>
            </div>
            <div class="mt-5 sm:mt-6">
              <button 
                onclick="window.offerEditorManager.closePublicLinkModal()" 
                type="button" 
                class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-gray-600 text-base font-medium text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:text-sm"
              >
                Zav\u{159}\xedt
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
        // Přidat modal do stránky
        const modalContainer = document.createElement('div');
        modalContainer.innerHTML = modalHtml;
        document.body.appendChild(modalContainer);
    }
    async copyToClipboard(text) {
        try {
            await navigator.clipboard.writeText(text);
            if (window.showNotification) window.showNotification("Odkaz byl zkop\xedrov\xe1n do schr\xe1nky", 'success');
        } catch (error) {
            console.error("Chyba p\u0159i kop\xedrov\xe1n\xed:", error);
            if (window.showNotification) window.showNotification("Chyba p\u0159i kop\xedrov\xe1n\xed do schr\xe1nky", 'error');
        }
    }
    closePublicLinkModal() {
        const modal = document.getElementById('public-link-modal');
        if (modal && modal.parentElement) modal.parentElement.remove();
    }
    async generatePDF() {
        if (!this.currentOffer) return;
        const btn = document.getElementById('nabidka-editor-pdf-btn');
        const originalHtml = btn ? btn.innerHTML : null;
        if (btn) {
            btn.disabled = true;
            btn.innerHTML = `
        ${(0, $entK4.icon)('spinner', 'animate-spin w-4 h-4 mr-2')}
        Generuji PDF\u{2026}
      `;
        }
        const filename = `nabidka-${this.currentOffer.id}.pdf`;
        try {
            const API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
            const response = await fetch(`${API_BASE_URL}/offers/${encodeURIComponent(this.currentOffer.id)}/pdf`, {
                credentials: 'include'
            });
            if (!response.ok) {
                let message = "Chyba p\u0159i generov\xe1n\xed PDF na serveru";
                try {
                    const body = await response.json();
                    if (body?.error) message = body.error;
                } catch (_) {}
                throw new Error(message);
            }
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            // Necháme URL chvíli živou, aby browser stihl zahájit download, pak ji uvolníme
            setTimeout(()=>URL.revokeObjectURL(url), 1000);
            if (window.showNotification) window.showNotification(`PDF \u{201E}${filename}" bylo sta\u{17E}eno`, 'success');
        } catch (error) {
            console.error("Chyba p\u0159i generov\xe1n\xed PDF:", error);
            if (window.showNotification) window.showNotification(error.message || "Chyba p\u0159i generov\xe1n\xed PDF", 'error');
        } finally{
            if (btn && originalHtml !== null) {
                btn.disabled = false;
                btn.innerHTML = originalHtml;
            }
        }
    }
    printOffer() {
        if (!this.currentOffer) return;
        try {
            // Vytvořit nové okno s obsahem pro tisk
            const printWindow = window.open('', '_blank');
            const printContent = this.generatePDFContent();
            printWindow.document.write(printContent);
            // Stejné @font-face jako v aplikaci (stylesheet bundlu z app.js) – tisková okna nemají import z node_modules
            window.document.querySelectorAll('link[rel="stylesheet"][href]').forEach((link)=>{
                const l = printWindow.document.createElement('link');
                l.rel = 'stylesheet';
                l.href = link.href;
                printWindow.document.head.appendChild(l);
            });
            printWindow.document.close();
            // Automaticky spustit tisk
            printWindow.focus();
            setTimeout(()=>{
                printWindow.print();
            }, 250);
            if (window.showNotification) window.showNotification("Nab\xeddka se odes\xedl\xe1 na tisk", 'success');
        } catch (error) {
            console.error("Chyba p\u0159i tisku nab\xeddky:", error);
            if (window.showNotification) window.showNotification("Chyba p\u0159i tisku nab\xeddky", 'error');
        }
    }
    escape(str) {
        if (str == null) return '';
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    generatePDFContent() {
        if (!this.currentOffer) return '';
        const date = new Date(this.currentOffer.createdAt);
        const formattedDate = date.toLocaleDateString('cs-CZ', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
        // Vypočítat celkovou cenu a cenu s DPH
        const totalPrice = this.currentOffer.totalPrice || 0;
        const vatRate = 0.21; // 21% DPH
        const totalPriceWithVat = totalPrice * (1 + vatRate);
        // Pro tiskové okno (window.open) potřebujeme absolutní URL k logu,
        // protože nové okno má about:blank jako base a relativní cesty by se nevyřešily.
        const absoluteLogoUrl = new URL((0, (/*@__PURE__*/$parcel$interopDefault($cdb5ad58694a976a$exports))), window.location.href).href;
        return `
<!doctype html>
<html>
<head>
    <meta charset='utf-8'>
    <title>Nab\xeddka \u{10D}. ${this.currentOffer.id}</title>
    <style>
        body {
            font-family: 'Plus Jakarta Sans Variable', 'Inter Tight', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            margin: 40px;
        }
        header {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            padding-bottom: 22px;
            border-bottom: 1px solid black;
        }
        .section {
            margin-bottom: 20px;
        }
        section.od {
            display: flex;
            padding-top: 10px;
            flex-direction: row;
            align-items: flex-start;
            justify-content: flex-start;
        }
        table {
            width: 100%;
            border-collapse: collapse;
        }
        tbody {
            border-top: 1px solid black;
        }
        .tabulka {
            margin-top: 10px;
            margin-bottom: 0;
        }
        tr {
            border-bottom: 1px solid black;
        }
        th, td {
            padding: 8px;
            padding-left: 0;
            text-align: left;
        }
        .width50 {
            width: 50%;
        }
        h1 {
            font-size: 1.3em;
        }
        h2 {
            font-size: 0.625rem;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.04em;
            color: #5A6079;
        }
        .offer-party-label {
            font-size: 1rem !important;
            line-height: 1rem !important;
            font-weight: 600 !important;
            text-transform: uppercase;
            letter-spacing: 0.025em;
            color: #5A6079 !important;
            margin: 0 0 0.5rem 0 !important;
        }
        .offer-footer {
            margin-top: 24px;
            padding-top: 16px;
            border-top: 1px solid #ccc;
            font-size: 0.75rem;
            color: #868686;
            line-height: 1.5;
            text-align: center;
        }
        .logo {
            padding-top: 11px;
        }
        @media print {
            .a4-wrapper {
                width: 190mm;
                margin: 10mm auto;
                page-break-after: always;
            }
        }
        @media screen {
            .a4-wrapper {
                width: 190mm;
                margin: 20px auto;
            }
        }
        section.price {
            padding-top: 8px;
            padding-bottom: 24px;
            padding-left: 50%;
            margin-bottom: 16px;
            display: flex;
            align-items: flex-start;
        }
        td.offer-note {
            padding-bottom: 17px;
            font-size: 90%;
            color: #868686;
        }
    </style>
</head>
<body>
    <div class="container a4-wrapper">
        <header>
            <div class="logo width50">
                <img src="${absoluteLogoUrl}" alt="Tisk\xe1rna Tria, s.r.o." width="140" height="45">
            </div>
            <section class="width50" style="text-align: right;">
                <h1>Cenov\xe1 nab\xeddka \u{10D}. ${this.currentOffer.id}</h1>
                Ze dne: ${formattedDate}<br>
                Vystavil: ${this.currentOffer.createdBy || "Syst\xe9m"}<br>
            </section>
        </header>

        <section class="od">
            <div class="o width50">
                <p class="offer-party-label">Odb\u{11B}ratel</p>
                <p>${this.customerData.replace(/\n/g, '<br>')}</p>
            </div>

            <div class="d width50">
                <p class="offer-party-label">Dodavatel</p>
                <p>Tisk\xe1rna Tria s.r.o.<br>
                Olbramovice Ves 31,<br>
                259 01 Olbramovice</p>
                <p>I\u{10C}O: 49546112<br>
                DI\u{10C}: CZ49546112</p>
                <p>Email: tiskarna@tria.cz<br>
                Web: www.tria.cz</p>
            </div>
        </section>

        <table class="tabulka">
            <tr>
                <th>Ozna\u{10D}en\xed polo\u{17E}ky</th>
                <th>Po\u{10D}et kus\u{16F}</th>
                <th>Cena za kus</th>
                <th>Cena</th>
                <th>% DPH</th>
                <th>Cena s DPH</th>
            </tr>
            ${this.currentOffer.items.map((item)=>{
            const vatRate = 0.21;
            const priceWithVat = item.price * (1 + vatRate);
            const quantity = Number(item.formData?.pocetKusu) || 1;
            const unitPrice = item.pricePerPiece || (quantity > 0 ? item.price / quantity : 0);
            const shortName = (0, $39500ec295adf68d$exports.stripFinishingFromName)(item.name || '');
            const lines = item.formData ? (0, $39500ec295adf68d$exports.buildFinishingLines)(item.formData) : [];
            return `
                <tr>
                    <td>${shortName}${item.notes && item.notes.trim() ? `<br><span style="font-size: 90%; color: #868686;">${item.notes}</span>` : ''}</td>
                    <td>${quantity} ks</td>
                    <td>${unitPrice.toLocaleString('cs-CZ', {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
            })} K\u{10D}</td>
                    <td>${item.price.toLocaleString('cs-CZ')} K\u{10D}</td>
                    <td>21 %</td>
                    <td>${priceWithVat.toLocaleString('cs-CZ')} K\u{10D}</td>
                </tr>
                ${lines.length ? `
                <tr>
                    <td colspan="6" class="offer-note">
                        ${lines.join('<br>')}
                    </td>
                </tr>
                ` : ''}
              `;
        }).join('')}
        </table>

        <section class="price">
            <div class="width50">
                <h2>Celkov\xe1 cena:</h2>
                ${totalPrice.toLocaleString('cs-CZ')} K\u{10D}
            </div>

            <div class="width50">
                <h2>Celkov\xe1 cena s DPH:</h2>
                ${totalPriceWithVat.toLocaleString('cs-CZ')} K\u{10D}
            </div>
        </section>

        <footer class="offer-footer">
            ${0, $39500ec295adf68d$exports.OFFER_FOOTER_DISCLAIMER}
        </footer>
    </div>
</body>
</html>
    `;
    }
}
// Export pro použití v app.js
window.OfferEditorManager = $89d32ed16e1177d1$export$9669364b582e5a9e;


// Modul pro zobrazení veřejné nabídky (read-only)
// Logo tiskárny – stejný asset, jaký se používá v hlavičce aplikace.
// `url:` prefix říká Parcelu 2, aby import vrátil URL k souboru (nikoli inline obsah).



var $entK4 = parcelRequire("entK4");
class $48e6b8dca9234cdb$export$75c187d5a2c30495 {
    constructor(){
        this.currentOffer = null;
        this.token = null;
    }
    /** Normalizuje customerData (string i objekt z MCP/AI) na text. */ formatCustomerData(data) {
        if (!data) return '';
        if (typeof data === 'string') return data;
        if (typeof data === 'object') {
            const d = data;
            const lines = [];
            if (d.name) lines.push(d.name);
            if (d.contactPerson && d.contactPerson !== d.name) lines.push(d.contactPerson);
            if (d.address) lines.push(d.address);
            const cityLine = [
                d.zip,
                d.city
            ].filter(Boolean).join(' ');
            if (cityLine) lines.push(cityLine);
            if (d.country && d.country !== "\u010Cesk\xe1 republika") lines.push(d.country);
            const contact = [
                d.phone,
                d.email
            ].filter(Boolean).join(', ');
            if (contact) lines.push(contact);
            const taxLine = [
                d.ico ? `I\u{10C}: ${d.ico}` : '',
                d.dic ? `DI\u{10C}: ${d.dic}` : ''
            ].filter(Boolean).join(', ');
            if (taxLine) {
                lines.push('');
                lines.push(taxLine);
            }
            return lines.join('\n');
        }
        return String(data);
    }
    async loadOfferByToken(token) {
        this.token = token;
        try {
            const API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
            const response = await fetch(`${API_BASE_URL}/public/offer/${token}`);
            if (!response.ok) {
                if (response.status === 404) this.showError("Nab\xeddka nebyla nalezena nebo odkaz nen\xed platn\xfd");
                else this.showError("Chyba p\u0159i na\u010D\xedt\xe1n\xed nab\xeddky");
                return;
            }
            const result = await response.json();
            if (result.success && result.data && result.data.offer) {
                this.currentOffer = result.data.offer;
                this.renderPublicOffer();
            } else this.showError("Neplatn\xe1 odpov\u011B\u010F od serveru");
        } catch (error) {
            console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed ve\u0159ejn\xe9 nab\xeddky:", error);
            this.showError("Chyba p\u0159i na\u010D\xedt\xe1n\xed nab\xeddky");
        }
    }
    showError(message) {
        const container = document.getElementById('public-offer-content');
        if (!container) return;
        container.innerHTML = `
      <div class="text-center p-8">
        ${(0, $entK4.icon)('exclamation-triangle', 'mx-auto h-12 w-12 text-red-400')}
        <h3 class="mt-2 text-sm font-medium text-gray-900">${message}</h3>
      </div>
    `;
    }
    renderPublicOffer() {
        if (!this.currentOffer) return;
        const container = document.getElementById('public-offer-content');
        if (!container) return;
        const date = new Date(this.currentOffer.createdAt);
        const formattedDate = date.toLocaleDateString('cs-CZ', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
        // Vypočítat celkovou cenu a cenu s DPH
        const totalPrice = this.currentOffer.totalPrice || 0;
        const vatRate = 0.21; // 21% DPH
        const totalPriceWithVat = totalPrice * (1 + vatRate);
        // Získat data odběratele (může být string i objekt z MCP/AI nabídky)
        const customerData = this.formatCustomerData(this.currentOffer.customerData);
        const html = `
      <div class="max-w-4xl mx-auto">
        <!-- Header s logem a \u{10D}\xedslem nab\xeddky -->
        <header class="flex flex-col sm:flex-row sm:items-start pb-6 border-b border-black mb-6">
          <div class="w-full sm:w-1/2 mb-4 sm:mb-0">
            <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($cdb5ad58694a976a$exports)))}" alt="Tisk\xe1rna Tria, s.r.o." class="h-12 w-auto">
          </div>
          <div class="w-full sm:w-1/2 sm:text-right">
            <h1 class="text-xl sm:text-2xl font-semibold mb-2">Cenov\xe1 nab\xeddka \u{10D}. ${this.currentOffer.id}</h1>
            <div class="text-sm text-gray-500">Ze dne: ${formattedDate}</div>
            <div class="text-sm text-gray-500">Vystavil: ${this.currentOffer.createdBy || "Syst\xe9m"}</div>
          </div>
        </header>

        <!-- Odb\u{11B}ratel a Dodavatel -->
        <section class="flex flex-col sm:flex-row gap-6 mb-6 pt-2">
          <div class="w-full sm:w-1/2">
            <p class="offer-party-label">Odb\u{11B}ratel</p>
            <div class="text-sm whitespace-pre-line">${customerData || 'Neuvedeno'}</div>
          </div>

          <div class="w-full sm:w-1/2">
            <p class="offer-party-label">Dodavatel</p>
            <div class="text-sm">
              <p>Tisk\xe1rna Tria s.r.o.<br>
              Olbramovice Ves 31,<br>
              259 01 Olbramovice</p>
              <p class="mt-2">I\u{10C}O: 49546112<br>
              DI\u{10C}: CZ49546112</p>
              <p class="mt-2">Email: tiskarna@tria.cz<br>
              Web: www.tria.cz</p>
            </div>
          </div>
        </section>

        <!-- Tabulka polo\u{17E}ek - responzivn\xed s horizont\xe1ln\xedm scrollem na mobilu -->
        <div class="overflow-x-auto mb-6">
          <table class="w-full border-collapse min-w-full">
            <thead>
              <tr class="border-b border-black">
                <th class="py-2 px-1 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">Ozna\u{10D}en\xed polo\u{17E}ky</th>
                <th class="py-2 px-1 text-right text-xs font-semibold uppercase tracking-wide text-gray-500 whitespace-nowrap">Po\u{10D}et kus\u{16F}</th>
                <th class="py-2 px-1 text-right text-xs font-semibold uppercase tracking-wide text-gray-500 whitespace-nowrap">Cena za kus</th>
                <th class="py-2 px-1 text-right text-xs font-semibold uppercase tracking-wide text-gray-500">Cena</th>
                <th class="py-2 px-1 text-right text-xs font-semibold uppercase tracking-wide text-gray-500">% DPH</th>
                <th class="py-2 px-1 text-right text-xs font-semibold uppercase tracking-wide text-gray-500 whitespace-nowrap">Cena s DPH</th>
              </tr>
            </thead>
            <tbody>
              ${this.currentOffer.items.map((item)=>this.renderOfferItemRow(item)).join('')}
            </tbody>
          </table>
        </div>

        <!-- Celkem s DPH \u{2013} box s rozpisem (stejn\u{11B} jako PDF) -->
        <section class="flex justify-end mb-6">
          <div class="min-w-[260px] text-sm">
            <div class="flex justify-between py-1">
              <span class="text-gray-500">Cena celkem (bez DPH)</span>
              <span class="tabular-nums">${totalPrice.toLocaleString('cs-CZ')} K\u{10D}</span>
            </div>
            <div class="flex justify-between py-1">
              <span class="text-gray-500">DPH ${(vatRate * 100).toFixed(0)} %</span>
              <span class="tabular-nums">${(totalPrice * vatRate).toLocaleString('cs-CZ', {
            maximumFractionDigits: 2
        })} K\u{10D}</span>
            </div>
            <div class="flex justify-between pt-2 mt-1 border-t border-black text-base font-bold">
              <span>Celkem s DPH</span>
              <span class="tabular-nums">${totalPriceWithVat.toLocaleString('cs-CZ', {
            maximumFractionDigits: 2
        })} K\u{10D}</span>
            </div>
          </div>
        </section>

        <div class="public-offer-disclaimer mt-10 pt-6 border-t border-gray-300 text-xs text-gray-500 leading-relaxed text-center px-2">
          ${(0, $39500ec295adf68d$exports.OFFER_FOOTER_DISCLAIMER)}
        </div>
      </div>
    `;
        container.innerHTML = html;
    }
    renderOfferItemRow(item) {
        const vatRate = 0.21; // 21% DPH
        const priceWithVat = item.price * (1 + vatRate);
        const quantity = Number(item.formData?.pocetKusu) || 1;
        const unitPrice = item.pricePerPiece || (quantity > 0 ? item.price / quantity : 0);
        const displayName = (0, $39500ec295adf68d$exports.stripFinishingFromName)(item.name || '');
        const lines = item.formData ? (0, $39500ec295adf68d$exports.buildFinishingLines)(item.formData) : [];
        return `
      <tr class="${lines.length ? '' : 'border-b border-gray-200'}">
        <td class="py-2 px-1 text-sm align-top">
          <div class="font-medium">${displayName}</div>
          ${item.notes && item.notes.trim() ? `<div class="text-xs text-gray-500 mt-0.5">${item.notes}</div>` : ''}
        </td>
        <td class="py-2 px-1 text-sm text-right whitespace-nowrap align-top tabular-nums">${quantity.toLocaleString('cs-CZ')} ks</td>
        <td class="py-2 px-1 text-sm text-right whitespace-nowrap align-top tabular-nums">${unitPrice.toLocaleString('cs-CZ', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        })} K\u{10D}</td>
        <td class="py-2 px-1 text-sm text-right whitespace-nowrap align-top tabular-nums">${item.price.toLocaleString('cs-CZ', {
            maximumFractionDigits: 2
        })} K\u{10D}</td>
        <td class="py-2 px-1 text-sm text-right whitespace-nowrap align-top tabular-nums">${(vatRate * 100).toFixed(0)} %</td>
        <td class="py-2 px-1 text-sm text-right whitespace-nowrap align-top tabular-nums">${priceWithVat.toLocaleString('cs-CZ', {
            maximumFractionDigits: 2
        })} K\u{10D}</td>
      </tr>
      ${lines.length ? `
        <tr class="border-b border-gray-200">
          <td colspan="6" class="pt-0 pb-3 px-1 text-xs text-gray-500 leading-relaxed">
            ${lines.join('<br>')}
          </td>
        </tr>
      ` : ''}
    `;
    }
    // Zpětně-kompatibilní wrapper: vrací HTML se <br>. Skutečná logika je v
    // shared/offer-item-format.js, níže uvedené helpery jsou už jen dead code.
    formatItemSpecification(formData) {
        return (0, $39500ec295adf68d$exports.buildFinishingLines)(formData || {}).join('<br>');
    }
    _legacyFormatItemSpecification(formData) {
        let spec = [];
        // Digitální speciální barvy
        if (formData.barvyDigital && formData.barvyDigital !== '0') {
            const digitalText = this.getDigitalColorName(formData.barvyDigital);
            if (digitalText) spec.push(`Digit\xe1ln\xed speci\xe1ln\xed barva: ${digitalText}`);
        }
        // Lakování
        if (formData.lakovani && formData.lakovani !== '0') {
            const lakText = this.getLakText(formData.lakovani);
            if (lakText) spec.push(`Lakov\xe1n\xed: ${lakText}`);
        }
        // Laminace
        if (formData.laminace && formData.laminace !== '0') {
            const laminaceText = this.getLaminaceText(formData.laminace);
            if (laminaceText) spec.push(`Laminace: ${laminaceText}`);
        }
        // Falcování
        if (formData.falcovani && formData.falcovani !== '0') {
            const falcovaniText = this.getFalcovaniText(formData.falcovani);
            if (falcovaniText) spec.push(`Falcov\xe1n\xed: ${falcovaniText}`);
        }
        // Bigování
        if (formData.bigovani && formData.bigovani !== '0') {
            const bigovaniText = this.getBigovaniText(formData.bigovani);
            if (bigovaniText) spec.push(`Bigov\xe1n\xed: ${bigovaniText}`);
        }
        // Výsek
        if (formData.vysek && formData.vysek !== '0') {
            const vysekText = this.getVysekText(formData.vysek);
            const pozicNaVysek = formData.pozicNaVysek || '1';
            if (vysekText) spec.push(`V\xfdsek: ${vysekText} (${pozicNaVysek} pozic)`);
        }
        // Předsek
        if (formData.predsek && formData.predsek !== '0') {
            const predsekText = this.getPredsekText(formData.predsek);
            const pozicNaPredsek = formData.pozicNaPredsek || '1';
            if (predsekText) spec.push(`P\u{159}edsek: ${predsekText} (${pozicNaPredsek} pozic)`);
        }
        // Ražba
        if (formData.razba && formData.razba !== '0') {
            const razbaText = this.getRazbaText(formData.razba);
            const pozicNaRazbu = formData.pozicNaRazbu || '1';
            if (razbaText) spec.push(`Ra\u{17E}ba: ${razbaText} (${pozicNaRazbu} pozic)`);
        }
        // Vrtání
        if (formData.vrtani && formData.vrtani !== '0') {
            const vrtaniText = this.getVrtaniText(formData.vrtani);
            if (vrtaniText) spec.push(`Vrt\xe1n\xed: ${vrtaniText}`);
        }
        // Perforace
        if (formData.perforace && formData.perforace !== '0') {
            const pocetPerforaci = parseInt(formData.perforace);
            if (pocetPerforaci > 0) spec.push(`Perforace ${pocetPerforaci}x`);
        }
        // Lepení
        if (formData.lepeni && formData.lepeni !== '0') {
            const lepeniText = this.getLepeniText(formData.lepeni);
            if (lepeniText) spec.push(lepeniText);
        }
        // Vazba
        if (formData.vazba && formData.vazba !== '0') {
            const vazbaText = this.getVazbaText(formData.vazba);
            if (vazbaText) spec.push(vazbaText);
        }
        return spec.join('<br>');
    }
    // Pomocné funkce pro převod hodnot na texty (shodné s offer-editor.js)
    getDigitalColorName(typ) {
        const nazvy = {
            'lak_10_50': "1/0 lak (parci\xe1ln\xed)",
            'lak_11_50': "1/1 lak (parci\xe1ln\xed)",
            'lak_10_100': "1/0 lak (cel\xe1 plocha)",
            'lak_11_100': "1/1 lak (cel\xe1 plocha)",
            'bila_10_50': "1/0 b\xedl\xe1 (parci\xe1ln\xed)",
            'bila_11_50': "1/1 b\xedl\xe1 (parci\xe1ln\xed)",
            'bila_10_100': "1/0 b\xedl\xe1 (cel\xe1 plocha)",
            'bila_11_100': "1/1 b\xedl\xe1 (cel\xe1 plocha)",
            'zlata_10_50': "1/0 zlat\xe1 (parci\xe1ln\xed)",
            'zlata_11_50': "1/1 zlat\xe1 (parci\xe1ln\xed)",
            'zlata_10_100': "1/0 zlat\xe1 (cel\xe1 plocha)",
            'zlata_11_100': "1/1 zlat\xe1 (cel\xe1 plocha)"
        };
        return nazvy[typ] || '';
    }
    getLakText(typ) {
        const nazvy = {
            'parcial10': "1/0 UV lak parci\xe1ln\xed",
            'parcial11': "1/1 UV lak parci\xe1ln\xed",
            'plocha10': "1/0 UV lak cel\xe1 plocha",
            'plocha11': "1/1 UV lak cel\xe1 plocha",
            'stroj10': '1/0 Stroj lak',
            'stroj11': '1/1 Stroj lak'
        };
        return nazvy[typ] || '';
    }
    getLaminaceText(typ) {
        const nazvy = {
            'lesk10': "1/0 Lamino leskl\xe9",
            'lesk11': "1/1 Lamino leskl\xe9",
            'mat10': "1/0 Lamino matn\xe9",
            'mat11': "1/1 Lamino matn\xe9",
            'struktura10': "1/0 Lamino nepo\u0161krabateln\xe9",
            'struktura11': "1/1 Lamino nepo\u0161krabateln\xe9",
            'samet10': "1/0 Lamino sametov\xe9",
            'samet11': "1/1 Lamino sametov\xe9",
            'kapsaA5': "1/1 Laminace kapsov\xe1 (A5)",
            'kapsaA4': "1/1 Laminace kapsov\xe1 (A4)",
            'kapsaA3': "1/1 Laminace kapsov\xe1 (A3)"
        };
        return nazvy[typ] || '';
    }
    getFalcovaniText(typ) {
        const nazvy = {
            'half-fold': 'Na polovinu (1 lom)',
            'cross-fold': "K\u0159\xed\u017Eov\xfd lom (2 lomy)",
            'u-fold': 'Do U (2 lomy)',
            'z-fold': 'Do Z (2 lomy)',
            'double-half-fold': 'Na polovinu (2 lomy)',
            'roll-fold': "Harmonikov\xe9 s p\u0159ebalem (3 lomy)",
            'harmonium-fold-3': "Harmonikov\xe9 skl\xe1d\xe1n\xed (3 lomy)",
            'harmonium-fold-4': "Harmonikov\xe9 skl\xe1d\xe1n\xed (4 lomy)",
            'harmonium-fold-5': "Harmonikov\xe9 skl\xe1d\xe1n\xed (5 lom\u016F)",
            'gate-fold': "Skl\xe1d\xe1n\xed do psan\xed\u010Dka (3 lomy)",
            'double-gate-fold': "Zav\u0159en\xe9 psan\xed\u010Dko (3 lomy)"
        };
        return nazvy[typ] || '';
    }
    getBigovaniText(typ) {
        const nazvy = {
            'half-fold': 'Na polovinu (1 big)',
            'cross-fold': "Do k\u0159\xed\u017Ee (2 bigy)",
            'u-fold': 'Do U (2 bigy)',
            'z-fold': 'Do Z (2 bigy)',
            'double-half-fold': 'Na polovinu (2 bigy)',
            'roll-fold': "Harmonikov\xe9 (3 bigy)",
            'harmonium-fold-3': "Harmonikov\xe9 (3 bigy)",
            'harmonium-fold-4': "Harmonikov\xe9 (4 bigy)",
            'harmonium-fold-5': "Harmonikov\xe9 (5 bigy)",
            'gate-fold': "Skl\xe1d\xe1n\xed do psan\xed\u010Dka (3 bigy)",
            'double-gate-fold': "Zav\u0159en\xe9 psan\xed\u010Dko (3 bigy)"
        };
        return nazvy[typ] || '';
    }
    getVysekText(option) {
        const nazvy = {
            'vlastni': "Vlastn\xed/p\u016Fj\u010Den\xe9 v\xfdsekov\xe9 \u017Eelezo",
            'nove': "Nov\xe9 v\xfdsekov\xe9 \u017Eelezo"
        };
        return nazvy[option] || '';
    }
    getPredsekText(option) {
        const nazvy = {
            '1': "Vlastn\xed/p\u016Fj\u010Den\xe9 p\u0159edsekov\xe9 \u017Eelezo",
            '2': "Nov\xe9 p\u0159edsekov\xe9 \u017Eelezo"
        };
        return nazvy[option] || '';
    }
    getRazbaText(option) {
        const nazvy = {
            '1': "Vlastn\xed/p\u016Fj\u010Den\xfd \u0161to\u010Dek",
            '2': "Nov\xfd \u0161to\u010Dek"
        };
        return nazvy[option] || '';
    }
    getVrtaniText(typ) {
        const nazvy = {
            '1dira2mm': "1 d\xedra (2 mm)",
            '1dira4mm': "1 d\xedra (4 mm)",
            '1dira5mm': "1 d\xedra (5,5 mm)",
            '2diry2mm': "2 d\xedry (2 mm)",
            '2diry4mm': "2 d\xedry (4 mm)",
            '2diry5mm': "2 d\xedry (5,5 mm)",
            'euro2diry2mm': "Euro blok, 2 d\xedry (2 mm)",
            'euro2diry4mm': "Euro blok, 2 d\xedry (4 mm)",
            'euro2diry5mm': "Euro blok, 2 d\xedry (5,5 mm)",
            '3diry2mm': "3 d\xedry (2 mm)",
            '3diry4mm': "3 d\xedry (4 mm)",
            '3diry5mm': "3 d\xedry (5,5 mm)",
            'euro4diry2mm': "Euro blok, 4 d\xedry (2 mm)",
            'euro4diry4mm': "Euro blok, 4 d\xedry (4 mm)",
            'euro4diry5mm': "Euro blok, 4 d\xedry (5,5 mm)"
        };
        return nazvy[typ] || '';
    }
    getLepeniText(typ) {
        const nazvy = {
            '1': "Lepen\xed krabi\u010Dek"
        };
        return nazvy[typ] || '';
    }
    getVazbaText(typ) {
        const nazvy = {
            'V1-strojni': "V1 (2 skoby) strojn\xed",
            'V1-rucni': "V1 (2 skoby) ru\u010Dn\u011B",
            'blok': "Lepen\xfd blok",
            'blokPrebal': "Lepen\xfd blok s p\u0159ebalem",
            'V2-PUR': "V2 lepen\xe1 (PUR)",
            'V3': "V3 lepen\xe1 a \u0161it\xe1",
            'V6': 'V6 leporelo',
            'krouzek-blok': "Krou\u017Ekov\xe1 twin wire",
            'krouzek-kalendar': "Krou\u017Ekov\xe1 s h\xe1\u010Dkem na pov\u011B\u0161en\xed",
            'V4': "V4 \u0161it\xe1, m\u011Bkk\xe1 ob\xe1lka",
            'V5': "V5 \u0161it\xe1, tvrd\xe1 ob\xe1lka",
            'V2V8': "V2V8 \u2013 fale\u0161n\xe1 V8",
            'V8': "V8 \u0161it\xe1, tvrd\xe1 ob\xe1lka"
        };
        return nazvy[typ] || "Nezn\xe1m\xe1 vazba";
    }
}
// Export pro použití v app.js
window.PublicOfferManager = $48e6b8dca9234cdb$export$75c187d5a2c30495;


// Veřejná stránka pro zobrazení souborů zákazníka (read-only, bez auth).
// Aktivuje se přes URL `/public-files/{token}` – routing zajišťuje app.js.
//
// Z backendu si vytahuje data přes GET /api/public/files/:token a podle
// MIME typu poskládá seznam souborů s akcemi (Náhled, Stáhnout). Stránka
// nemá menu ani footer a layoutem se drží stejné estetiky jako public-offer.js.


var $entK4 = parcelRequire("entK4");
// 7 dní v ms – po této době badge "Nové" mizí
const $8f203edbe7e377df$var$NEW_BADGE_MS = 604800000;
// Přípony obrázků pro lightbox náhled
const $8f203edbe7e377df$var$IMAGE_EXT = [
    'png',
    'jpg',
    'jpeg',
    'webp',
    'gif',
    'bmp',
    'svg'
];
// Přípony archivů (zobrazujeme ikonu, náhled nedělá smysl)
const $8f203edbe7e377df$var$ARCHIVE_EXT = [
    'zip',
    'rar',
    '7z',
    'tar',
    'gz',
    'bz2'
];
function $8f203edbe7e377df$var$getExt(name) {
    if (!name) return '';
    const idx = name.lastIndexOf('.');
    return idx >= 0 ? name.slice(idx + 1).toLowerCase() : '';
}
function $8f203edbe7e377df$var$isImage(file) {
    if (!file) return false;
    if (file.mimeType && file.mimeType.startsWith('image/')) return true;
    return $8f203edbe7e377df$var$IMAGE_EXT.includes($8f203edbe7e377df$var$getExt(file.originalName));
}
function $8f203edbe7e377df$var$isPdf(file) {
    if (!file) return false;
    if (file.mimeType === 'application/pdf') return true;
    return $8f203edbe7e377df$var$getExt(file.originalName) === 'pdf';
}
function $8f203edbe7e377df$var$isArchive(file) {
    return $8f203edbe7e377df$var$ARCHIVE_EXT.includes($8f203edbe7e377df$var$getExt(file.originalName));
}
class $8f203edbe7e377df$export$6bdc5e81a59d859 {
    constructor(){
        this.token = null;
        this.data = null;
    }
    async loadFilesByToken(token) {
        this.token = token;
        const API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
        try {
            const response = await fetch(`${API_BASE_URL}/public/files/${token}`);
            if (!response.ok) {
                if (response.status === 404) return this.showError("Odkaz nebyl nalezen nebo ji\u017E nen\xed platn\xfd.");
                return this.showError("P\u0159i na\u010D\xedt\xe1n\xed soubor\u016F do\u0161lo k chyb\u011B. Zkuste to pros\xedm za chv\xedli znovu.");
            }
            const json = await response.json();
            if (!json.success || !json.data) return this.showError("Neplatn\xe1 odpov\u011B\u010F serveru.");
            this.data = json.data;
            this.renderPage();
        } catch (err) {
            console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed public files:", err);
            this.showError("Str\xe1nka se nepoda\u0159ilo na\u010D\xedst. Zkontrolujte p\u0159ipojen\xed k internetu.");
        }
    }
    // ===== Rendering =====
    showError(message) {
        const container = document.getElementById('public-files-content');
        if (!container) return;
        container.innerHTML = `
      <div class="max-w-xl mx-auto px-4 py-16">
        <div class="bg-white rounded-2xl border border-gray-200 shadow-sm p-8 text-center">
          <div class="mx-auto w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mb-4">
            ${(0, $entK4.icon)('exclamation-triangle', 'w-6 h-6 text-red-500')}
          </div>
          <h1 class="text-lg font-semibold text-gray-900 mb-1">Odkaz nen\xed dostupn\xfd</h1>
          <p class="text-sm text-gray-600">${this.escape(message)}</p>
        </div>
      </div>
    `;
    }
    renderPage() {
        const container = document.getElementById('public-files-content');
        if (!container) return;
        const { customer: customer, files: files } = this.data;
        // Zabraň crawlerům indexovat tuto osobní stránku a sledovat download/preview
        // linky (každý crawl / unfurl = 1 operace na Vercel Blob).
        this.applyRobotsMeta();
        const filesSorted = (files || []).slice().sort((a, b)=>new Date(b.uploadedAt).getTime() - new Date(a.uploadedAt).getTime());
        const totalSize = filesSorted.reduce((sum, f)=>sum + (f.size || 0), 0);
        const empty = filesSorted.length === 0;
        container.innerHTML = `
      <div class="min-h-screen bg-gray-50">
        <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">

          <header class="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 pb-6 border-b border-gray-200 mb-8">
            <div class="flex items-center gap-3">
              <img src="${0, (/*@__PURE__*/$parcel$interopDefault($cdb5ad58694a976a$exports))}" alt="Tisk\xe1rna Tria, s.r.o." class="h-10 w-auto">
              <div class="hidden sm:block leading-tight">
                <div class="text-sm font-semibold text-gray-900">Tisk\xe1rna Tria, s.r.o.</div>
                <div class="text-xs text-gray-500">Sd\xedlen\xe9 soubory</div>
              </div>
            </div>
            <div class="text-left sm:text-right">
              <div class="text-xs uppercase tracking-wide text-gray-500">Soubory pro</div>
              <div class="text-lg sm:text-xl font-semibold text-gray-900 break-words">${this.escape(customer?.name || '')}</div>
            </div>
          </header>

          ${empty ? this.renderEmpty() : this.renderFilesList(filesSorted, totalSize)}

          <div class="public-files-disclaimer mt-12 pt-6 border-t border-gray-100 text-center text-xs text-gray-400">
            Str\xe1nka je generov\xe1na pro v\xe1s osobn\u{11B}.
            Pro ot\xe1zky n\xe1s kontaktujte na <a href="mailto:info@tria.cz" class="text-blue-600 hover:underline">info@tria.cz</a>.
          </div>
        </div>
      </div>
    `;
        this.bindEvents();
    }
    renderEmpty() {
        return `
      <div class="bg-white rounded-2xl border border-gray-200 shadow-sm p-10 sm:p-14 text-center">
        <div class="mx-auto w-14 h-14 rounded-full bg-gray-50 flex items-center justify-center mb-4">
          ${(0, $entK4.icon)('folder', 'w-7 h-7 text-gray-400')}
        </div>
        <h2 class="text-base font-semibold text-gray-900 mb-1">\u{17D}\xe1dn\xe9 soubory</h2>
        <p class="text-sm text-gray-500">Zat\xedm v\xe1m nebyly \u{17E}\xe1dn\xe9 soubory p\u{159}i\u{159}azeny. A\u{17E} p\u{159}ibydou, najdete je tady.</p>
      </div>
    `;
    }
    renderFilesList(files, totalSize) {
        const rows = files.map((f)=>this.renderFileRow(f)).join('');
        return `
      <div class="mb-3 flex items-center justify-between text-xs text-gray-500">
        <span><span class="font-semibold text-gray-900">${files.length}</span> ${this.plural(files.length, 'soubor', 'soubory', "soubor\u016F")} \xb7 ${this.formatSize(totalSize)} celkem</span>
        <span class="hidden sm:inline">Nejnov\u{11B}j\u{161}\xed naho\u{159}e</span>
      </div>
      <ul class="space-y-3">
        ${rows}
      </ul>
    `;
    }
    renderFileRow(file) {
        const ext = $8f203edbe7e377df$var$getExt(file.originalName);
        const iconSvg = this.getFileIconSvg(file.mimeType, file.originalName);
        const isNew = this.isNew(file.uploadedAt);
        const canPreview = $8f203edbe7e377df$var$isImage(file) || $8f203edbe7e377df$var$isPdf(file);
        return `
      <li class="group bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md hover:border-gray-300 transition-all">
        <div class="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 p-4">
          <div class="flex-shrink-0 w-12 h-12 rounded-lg bg-gradient-to-br from-blue-50 to-indigo-50 ring-1 ring-blue-100/60 flex items-center justify-center text-blue-600">
            ${iconSvg}
          </div>

          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-2 flex-wrap">
              <h3 class="text-sm sm:text-base font-semibold text-gray-900 break-all" title="${this.escape(file.originalName)}">
                ${this.escape(file.originalName)}
              </h3>
              ${isNew ? `
                <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wide bg-emerald-100 text-emerald-700 ring-1 ring-emerald-200/60">
                  Nov\xe9
                </span>` : ''}
              ${ext ? `
                <span class="hidden sm:inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium uppercase tracking-wide bg-gray-100 text-gray-600">
                  ${this.escape(ext)}
                </span>` : ''}
            </div>
            ${file.description ? `
              <p class="text-sm text-gray-600 mt-0.5 break-words">${this.escape(file.description)}</p>` : ''}
            <div class="mt-1 text-xs text-gray-500 flex items-center gap-3 flex-wrap">
              <span>${this.formatDateTime(file.uploadedAt)}</span>
              <span class="text-gray-300">\xb7</span>
              <span class="tabular-nums">${this.formatSize(file.size)}</span>
            </div>
          </div>

          <div class="flex items-center gap-2 sm:flex-shrink-0">
            ${canPreview ? `
              <button type="button" data-action="preview" data-id="${this.escape(file.id)}"
                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs sm:text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-700 hover:bg-gray-50 hover:border-gray-300 transition-colors">
                ${(0, $entK4.icon)('eye', 'w-4 h-4')}
                N\xe1hled
              </button>` : ''}
            <a href="${this.escape(file.downloadUrl)}"
              rel="nofollow noopener"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs sm:text-sm font-medium rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors shadow-sm"
              data-action="download"
              data-id="${this.escape(file.id)}">
              ${(0, $entK4.icon)('arrow-down-tray', 'w-4 h-4')}
              St\xe1hnout
            </a>
          </div>
        </div>
      </li>
    `;
    }
    bindEvents() {
        const container = document.getElementById('public-files-content');
        if (!container) return;
        container.querySelectorAll('[data-action="preview"]').forEach((btn)=>{
            btn.addEventListener('click', ()=>this.openPreview(btn.dataset.id));
        });
    }
    // ===== Preview (lightbox / iframe modal) =====
    openPreview(fileId) {
        const file = (this.data?.files || []).find((f)=>f.id === fileId);
        if (!file) return;
        if ($8f203edbe7e377df$var$isImage(file)) this.openImageLightbox(file);
        else if ($8f203edbe7e377df$var$isPdf(file)) this.openPdfModal(file);
    }
    openImageLightbox(file) {
        this.closePreview();
        const overlay = document.createElement('div');
        overlay.id = 'public-files-preview';
        overlay.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/85 p-4 sm:p-8';
        overlay.innerHTML = `
      <button type="button" data-close="1" aria-label="Zav\u{159}\xedt"
        class="absolute top-4 right-4 inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors">
        ${(0, $entK4.icon)('x-mark', 'w-5 h-5')}
      </button>
      <div class="max-w-full max-h-full flex flex-col items-center gap-4">
        <img src="${this.escape(file.previewUrl)}" alt="${this.escape(file.originalName)}"
          class="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl"
          loading="eager">
        <div class="flex items-center gap-3 text-white">
          <span class="text-sm font-medium truncate max-w-xs sm:max-w-md" title="${this.escape(file.originalName)}">${this.escape(file.originalName)}</span>
          <a href="${this.escape(file.downloadUrl)}"
            rel="nofollow noopener"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg bg-white/15 hover:bg-white/25 text-white transition-colors">
            ${(0, $entK4.icon)('arrow-down-tray', 'w-4 h-4')}
            St\xe1hnout
          </a>
        </div>
      </div>
    `;
        document.body.appendChild(overlay);
        this.attachPreviewClose(overlay);
    }
    openPdfModal(file) {
        this.closePreview();
        const overlay = document.createElement('div');
        overlay.id = 'public-files-preview';
        overlay.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-2 sm:p-6';
        overlay.innerHTML = `
      <div class="bg-white w-full max-w-5xl h-[92vh] sm:h-[88vh] rounded-lg shadow-2xl flex flex-col overflow-hidden">
        <div class="flex items-center justify-between gap-3 px-4 py-3 border-b border-gray-200 bg-gray-50">
          <div class="min-w-0 flex items-center gap-2">
            ${(0, $entK4.icon)('document-text', 'w-5 h-5 text-red-500 flex-shrink-0')}
            <span class="text-sm font-medium text-gray-900 truncate" title="${this.escape(file.originalName)}">${this.escape(file.originalName)}</span>
          </div>
          <div class="flex items-center gap-2">
            <a href="${this.escape(file.downloadUrl)}"
              rel="nofollow noopener"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-md border border-gray-200 text-gray-700 hover:bg-gray-100 transition-colors">
              ${(0, $entK4.icon)('arrow-down-tray', 'w-4 h-4')}
              St\xe1hnout
            </a>
            <button type="button" data-close="1" aria-label="Zav\u{159}\xedt"
              class="inline-flex items-center justify-center w-8 h-8 rounded-md text-gray-500 hover:bg-gray-200 transition-colors">
              ${(0, $entK4.icon)('x-mark', 'w-5 h-5')}
            </button>
          </div>
        </div>
        <iframe src="${this.escape(file.previewUrl)}#zoom=page-fit"
          title="${this.escape(file.originalName)}"
          class="flex-1 w-full border-0 bg-gray-100">
        </iframe>
      </div>
    `;
        document.body.appendChild(overlay);
        this.attachPreviewClose(overlay);
    }
    attachPreviewClose(overlay) {
        const close = ()=>this.closePreview();
        overlay.querySelectorAll('[data-close="1"]').forEach((el)=>el.addEventListener('click', close));
        overlay.addEventListener('click', (e)=>{
            // Klik mimo "kartu" (přímo na overlay)
            if (e.target === overlay) close();
        });
        const onKey = (e)=>{
            if (e.key === 'Escape') close();
        };
        document.addEventListener('keydown', onKey);
        overlay._cleanup = ()=>document.removeEventListener('keydown', onKey);
    }
    closePreview() {
        const overlay = document.getElementById('public-files-preview');
        if (!overlay) return;
        if (typeof overlay._cleanup === 'function') overlay._cleanup();
        overlay.remove();
    }
    // ===== Utility =====
    applyRobotsMeta() {
        let meta = document.querySelector('meta[name="robots"]');
        if (!meta) {
            meta = document.createElement('meta');
            meta.setAttribute('name', 'robots');
            document.head.appendChild(meta);
        }
        meta.setAttribute('content', 'noindex, nofollow');
    }
    isNew(uploadedAt) {
        if (!uploadedAt) return false;
        const ts = new Date(uploadedAt).getTime();
        if (Number.isNaN(ts)) return false;
        return Date.now() - ts < $8f203edbe7e377df$var$NEW_BADGE_MS;
    }
    formatSize(bytes) {
        const b = Number(bytes) || 0;
        if (b === 0) return '0 B';
        const units = [
            'B',
            'kB',
            'MB',
            'GB',
            'TB'
        ];
        const i = Math.min(units.length - 1, Math.floor(Math.log(b) / Math.log(1024)));
        const value = b / Math.pow(1024, i);
        const formatted = value >= 100 ? value.toFixed(0) : value.toFixed(1);
        return `${formatted.replace('.', ',')} ${units[i]}`;
    }
    formatDateTime(iso) {
        if (!iso) return '';
        try {
            const d = new Date(iso);
            return d.toLocaleString('cs-CZ', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (_) {
            return iso;
        }
    }
    plural(count, one, few, many) {
        const n = Math.abs(count);
        if (n === 1) return one;
        if (n >= 2 && n <= 4) return few;
        return many;
    }
    getFileIconSvg(mimeType, filename) {
        return (0, $entK4.getFileIconSvg)(mimeType, filename, 'w-6 h-6');
    }
    escape(str) {
        if (str === null || str === undefined) return '';
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
}


// Modul pro správu odběratelů/zákazníků
// - Seznam, vyhledávání, vytvoření, editace, mazání
// - Vyhledávač pro použití v editoru nabídek (selectorModal)

var $entK4 = parcelRequire("entK4");
const $b9955ebca66af344$var$API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
class $b9955ebca66af344$export$2bd0f762d756ec28 {
    constructor(){
        this.customers = [];
        this.searchQuery = '';
        this.loading = false;
        this.error = null;
        this._loaded = false;
    }
    // ----- API -----
    async fetchCustomers(search = '') {
        this.loading = true;
        this.error = null;
        try {
            const url = new URL(`${$b9955ebca66af344$var$API_BASE_URL}/customers`, window.location.origin);
            if (search) url.searchParams.set('search', search);
            // Při použití absolutní URL ignorujeme window.location.origin u prefixu localhost:1234
            const fetchUrl = search ? `${$b9955ebca66af344$var$API_BASE_URL}/customers?search=${encodeURIComponent(search)}` : `${$b9955ebca66af344$var$API_BASE_URL}/customers`;
            const res = await fetch(fetchUrl, {
                credentials: 'include'
            });
            if (!res.ok) {
                if (res.status === 401) throw new Error("Pro p\u0159\xedstup k z\xe1kazn\xedk\u016Fm je t\u0159eba b\xfdt p\u0159ihl\xe1\u0161en");
                throw new Error("Nepoda\u0159ilo se na\u010D\xedst z\xe1kazn\xedky");
            }
            const json = await res.json();
            this.customers = json.data || [];
            this._loaded = true;
            return this.customers;
        } catch (err) {
            this.error = err.message;
            this.customers = [];
            throw err;
        } finally{
            this.loading = false;
        }
    }
    async getCustomer(id) {
        const res = await fetch(`${$b9955ebca66af344$var$API_BASE_URL}/customers/${id}`, {
            credentials: 'include'
        });
        if (!res.ok) throw new Error("Nepoda\u0159ilo se na\u010D\xedst z\xe1kazn\xedka");
        const json = await res.json();
        return json.data;
    }
    async fetchCustomerStats(id) {
        const res = await fetch(`${$b9955ebca66af344$var$API_BASE_URL}/customers/${id}/stats`, {
            credentials: 'include'
        });
        if (!res.ok) throw new Error("Nepoda\u0159ilo se na\u010D\xedst detail z\xe1kazn\xedka");
        const json = await res.json();
        return json.data;
    }
    async createCustomer(data) {
        const res = await fetch(`${$b9955ebca66af344$var$API_BASE_URL}/customers`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json.error || "Nepoda\u0159ilo se vytvo\u0159it z\xe1kazn\xedka");
        return json.data;
    }
    async updateCustomer(id, data) {
        const res = await fetch(`${$b9955ebca66af344$var$API_BASE_URL}/customers/${id}`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json.error || "Nepoda\u0159ilo se aktualizovat z\xe1kazn\xedka");
        return json.data;
    }
    async deleteCustomer(id) {
        const res = await fetch(`${$b9955ebca66af344$var$API_BASE_URL}/customers/${id}`, {
            method: 'DELETE',
            credentials: 'include'
        });
        if (!res.ok) {
            const json = await res.json().catch(()=>({}));
            throw new Error(json.error || "Nepoda\u0159ilo se smazat z\xe1kazn\xedka");
        }
        return true;
    }
    async searchAres(query, limit = 10) {
        const url = `${$b9955ebca66af344$var$API_BASE_URL}/ares/search?q=${encodeURIComponent(query)}&limit=${limit}`;
        const res = await fetch(url, {
            credentials: 'include'
        });
        const json = await res.json().catch(()=>({}));
        if (!res.ok || json.success === false) throw new Error(json.message || "Vyhled\xe1v\xe1n\xed v ARESu selhalo");
        return json.data || [];
    }
    // ----- Render seznamu -----
    async showSection() {
        await this.loadAndRender();
    }
    async loadAndRender() {
        const container = document.getElementById('zakaznici-section-content');
        if (!container) return;
        container.innerHTML = this.renderHeader() + `<div id="customers-list-container">${this.renderLoading()}</div>`;
        this.bindHeaderEvents();
        try {
            await this.fetchCustomers(this.searchQuery);
            this.renderList();
        } catch (err) {
            this.renderError(err.message);
        }
    }
    renderHeader() {
        return `
      <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-6">
        <div>
          <h2 class="text-2xl font-semibold text-gray-900 mb-1">Z\xe1kazn\xedci / odb\u{11B}ratel\xe9</h2>
          <p class="text-gray-600 mb-0 text-sm">Spr\xe1va kontakt\u{16F} a faktura\u{10D}n\xedch \xfadaj\u{16F}.</p>
        </div>
        <div class="flex w-full sm:w-auto gap-2">
          <div class="relative flex-1 sm:flex-none">
            <input
              type="text"
              id="customers-search-input"
              placeholder="Hledat (n\xe1zev, I\u{10C}O, m\u{11B}sto, email)\u{2026}"
              value="${this.escape(this.searchQuery)}"
              class="pl-9 pr-3 py-2 w-full sm:w-72 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
            ${(0, $entK4.icon)('magnifying-glass', 'absolute left-2.5 top-2.5 w-4 h-4 text-gray-400')}
          </div>
          <button id="customers-add-btn"
            class="inline-flex items-center justify-center px-3 sm:px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 whitespace-nowrap">
            ${(0, $entK4.icon)('plus', 'w-4 h-4 sm:mr-2')}
            <span class="hidden sm:inline">P\u{159}idat z\xe1kazn\xedka</span>
            <span class="sm:hidden">P\u{159}idat</span>
          </button>
        </div>
      </div>
    `;
    }
    bindHeaderEvents() {
        const input = document.getElementById('customers-search-input');
        if (input) {
            let debounce;
            input.addEventListener('input', (e)=>{
                clearTimeout(debounce);
                const value = e.target.value;
                debounce = setTimeout(async ()=>{
                    this.searchQuery = value;
                    try {
                        await this.fetchCustomers(this.searchQuery);
                        this.renderList();
                    } catch (err) {
                        this.renderError(err.message);
                    }
                }, 200);
            });
        }
        const addBtn = document.getElementById('customers-add-btn');
        if (addBtn) addBtn.addEventListener('click', ()=>this.openEditor());
    }
    renderLoading() {
        return `
      <div class="flex justify-center p-12">
        ${(0, $entK4.icon)('spinner', 'animate-spin h-8 w-8 text-blue-500')}
      </div>
    `;
    }
    renderError(message) {
        const container = document.getElementById('customers-list-container');
        if (!container) return;
        container.innerHTML = `
      <div class="bg-red-50 border border-red-200 rounded-md p-4 text-sm text-red-700">
        ${this.escape(message)}
      </div>
    `;
    }
    renderList() {
        const container = document.getElementById('customers-list-container');
        if (!container) return;
        if (this.customers.length === 0) {
            container.innerHTML = `
        <div class="bg-white rounded-lg shadow-md p-8 text-center">
          ${(0, $entK4.icon)('user-group', 'mx-auto h-12 w-12 text-gray-400 mb-4')}
          <h3 class="text-lg font-medium text-gray-900 mb-2">
            ${this.searchQuery ? "\u017D\xe1dn\xfd z\xe1kazn\xedk neodpov\xedd\xe1 hled\xe1n\xed" : "Zat\xedm nem\xe1te \u017E\xe1dn\xe9 z\xe1kazn\xedky"}
          </h3>
          <p class="text-gray-500 text-sm">
            ${this.searchQuery ? "Zkuste jin\xfd hledan\xfd v\xfdraz nebo p\u0159idejte nov\xe9ho z\xe1kazn\xedka." : "P\u0159idejte prvn\xedho z\xe1kazn\xedka kliknut\xedm na tla\u010D\xedtko vpravo naho\u0159e."}
          </p>
        </div>
      `;
            return;
        }
        container.innerHTML = `
      <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <ul class="divide-y divide-gray-200">
          ${this.customers.map((c)=>this.renderCustomerRow(c)).join('')}
        </ul>
      </div>
    `;
        // Bind action handlers
        container.querySelectorAll('[data-action="detail"]').forEach((btn)=>{
            btn.addEventListener('click', ()=>this.openCustomerDetail(btn.dataset.id));
        });
        container.querySelectorAll('[data-action="edit"]').forEach((btn)=>{
            btn.addEventListener('click', ()=>this.openEditor(btn.dataset.id));
        });
        container.querySelectorAll('[data-action="delete"]').forEach((btn)=>{
            btn.addEventListener('click', ()=>this.confirmDelete(btn.dataset.id));
        });
        // Klik na řádek (kromě tlačítek) = detail
        container.querySelectorAll('li > div').forEach((row)=>{
            row.addEventListener('click', (e)=>{
                if (e.target.closest('[data-action]')) return;
                const li = row.closest('li');
                const detailBtn = li?.querySelector('[data-action="detail"]');
                if (detailBtn) this.openCustomerDetail(detailBtn.dataset.id);
            });
        });
    }
    // ----- Detail zákazníka + analytika -----
    async openCustomerDetail(id) {
        if (window.sectionManager) window.sectionManager.showSection('zakaznik-detail');
        const container = document.getElementById('zakaznik-detail-content');
        if (!container) return;
        container.innerHTML = this.renderLoading();
        try {
            const data = await this.fetchCustomerStats(id);
            this.renderCustomerDetail(container, data);
        } catch (err) {
            container.innerHTML = `<div class="bg-red-50 border border-red-200 rounded-md p-4 text-sm text-red-700">${this.escape(err.message)}</div>`;
        }
    }
    renderCustomerDetail(container, data) {
        const { customer: customer, stats: stats, offers: offers, orders: orders, invoices: invoices = [] } = data;
        const offerStatusMeta = window.OffersListManager?.STATUS_META || {};
        const orderStatusMeta = window.OrdersListManager?.STATUS_META || {};
        const invoiceStatusMeta = window.InvoicesListManager?.STATUS_META || {};
        const addressLine = [
            customer.address,
            customer.zip,
            customer.city
        ].filter(Boolean).join(', ');
        const fmt = (n)=>Number(n || 0).toLocaleString('cs-CZ', {
                maximumFractionDigits: 0
            });
        container.innerHTML = `
      <div class="space-y-4">
        <button id="customer-detail-back"
          class="inline-flex items-center px-3 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
          ${(0, $entK4.icon)('chevron-left', 'w-4 h-4 mr-2')}
          Zp\u{11B}t na z\xe1kazn\xedky
        </button>

        <div class="bg-white rounded-lg shadow border border-gray-200 p-6">
          <div class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
            <div class="min-w-0">
              <div class="flex items-center gap-2 flex-wrap">
                <h2 class="text-2xl font-semibold text-gray-900">${this.escape(customer.name)}</h2>
                <span class="text-xs px-2 py-0.5 rounded-full ${customer.type === 'person' ? 'bg-purple-100 text-purple-700' : 'bg-blue-100 text-blue-700'}">
                  ${customer.type === 'person' ? 'Osoba' : 'Firma'}
                </span>
                <span class="text-xs px-2 py-0.5 rounded-full ${customer.pricingTier === 'malo' ? 'bg-amber-100 text-amber-700' : 'bg-emerald-100 text-emerald-700'}" title="Cenov\xe1 \xfarove\u{148} z\xe1kazn\xedka">
                  ${customer.pricingTier === 'malo' ? "Maloobchodn\xed" : "Velkoobchodn\xed"}
                </span>
              </div>
              ${addressLine ? `<p class="mt-1 text-sm text-gray-600">${this.escape(addressLine)}</p>` : ''}
              ${customer.ico || customer.dic ? `<p class="mt-1 text-xs text-gray-500">${customer.ico ? `I\u{10C}O: ${this.escape(customer.ico)}` : ''}${customer.ico && customer.dic ? " \xb7 " : ''}${customer.dic ? `DI\u{10C}: ${this.escape(customer.dic)}` : ''}</p>` : ''}
              ${customer.email || customer.phone ? `<p class="mt-1 text-xs text-gray-500">${customer.email ? this.escape(customer.email) : ''}${customer.email && customer.phone ? " \xb7 " : ''}${customer.phone ? this.escape(customer.phone) : ''}</p>` : ''}
              ${customer.note ? `<p class="mt-2 text-sm text-gray-700 italic">"${this.escape(customer.note)}"</p>` : ''}
            </div>
            <div class="flex gap-2 shrink-0">
              <button id="customer-detail-edit"
                class="inline-flex items-center px-3 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                ${(0, $entK4.icon)('pencil-square', 'w-4 h-4 mr-2')}
                Upravit
              </button>
            </div>
          </div>
        </div>

        <!-- Analytika -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          ${this.renderStatCard({
            title: "Nab\xeddky",
            count: stats.offers.count,
            sum: stats.offers.totalPrice,
            avg: stats.offers.averagePrice,
            color: 'blue',
            icon: 'document-text'
        })}
          ${this.renderStatCard({
            title: "Objedn\xe1vky",
            count: stats.orders.count,
            sum: stats.orders.totalPrice,
            avg: stats.orders.averagePrice,
            color: 'emerald',
            icon: 'clipboard-check'
        })}
          ${this.renderInvoiceStatCard(stats.invoices)}
        </div>

        <!-- Distribuce stav\u{16F} -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div class="bg-white rounded-lg shadow border border-gray-200 p-4">
            <h3 class="text-sm font-semibold text-gray-700 mb-3">Stavy nab\xeddek</h3>
            ${this.renderStatusDistribution(stats.offers.byStatus, offerStatusMeta)}
          </div>
          <div class="bg-white rounded-lg shadow border border-gray-200 p-4">
            <h3 class="text-sm font-semibold text-gray-700 mb-3">Stavy objedn\xe1vek</h3>
            ${this.renderStatusDistribution(stats.orders.byStatus, orderStatusMeta)}
          </div>
          <div class="bg-white rounded-lg shadow border border-gray-200 p-4">
            <h3 class="text-sm font-semibold text-gray-700 mb-3">Stavy faktur</h3>
            ${this.renderStatusDistribution(stats.invoices.byStatus, invoiceStatusMeta)}
          </div>
        </div>

        <!-- Soubory z\xe1kazn\xedka (mini panel \u{2013} posledn\xedch 5) -->
        <div id="customer-files-panel" data-customer-id="${this.escape(customer.id)}" data-customer-name="${this.escape(customer.name)}">
          ${this.renderCustomerFilesSkeleton()}
        </div>

        <!-- Historie nab\xeddek -->
        <div class="bg-white rounded-lg shadow border border-gray-200">
          <div class="px-4 py-3 border-b border-gray-200">
            <h3 class="text-sm font-semibold text-gray-700">Historie nab\xeddek (${offers.length})</h3>
          </div>
          ${offers.length === 0 ? `<p class="p-4 text-sm text-gray-500">\u{17D}\xe1dn\xe9 nab\xeddky pro tohoto z\xe1kazn\xedka.</p>` : `<ul class="divide-y divide-gray-200">${offers.slice(0, 50).map((o)=>this.renderOfferHistoryRow(o, offerStatusMeta)).join('')}</ul>`}
        </div>

        <!-- Historie objedn\xe1vek -->
        <div class="bg-white rounded-lg shadow border border-gray-200">
          <div class="px-4 py-3 border-b border-gray-200">
            <h3 class="text-sm font-semibold text-gray-700">Historie objedn\xe1vek (${orders.length})</h3>
          </div>
          ${orders.length === 0 ? `<p class="p-4 text-sm text-gray-500">\u{17D}\xe1dn\xe9 objedn\xe1vky pro tohoto z\xe1kazn\xedka.</p>` : `<ul class="divide-y divide-gray-200">${orders.slice(0, 50).map((o)=>this.renderOrderHistoryRow(o, orderStatusMeta)).join('')}</ul>`}
        </div>

        <!-- Historie faktur -->
        <div class="bg-white rounded-lg shadow border border-gray-200">
          <div class="px-4 py-3 border-b border-gray-200">
            <h3 class="text-sm font-semibold text-gray-700">Historie faktur (${invoices.length})</h3>
          </div>
          ${invoices.length === 0 ? `<p class="p-4 text-sm text-gray-500">\u{17D}\xe1dn\xe9 faktury pro tohoto z\xe1kazn\xedka.</p>` : `<ul class="divide-y divide-gray-200">${invoices.slice(0, 50).map((inv)=>this.renderInvoiceHistoryRow(inv, invoiceStatusMeta)).join('')}</ul>`}
        </div>
      </div>
    `;
        document.getElementById('customer-detail-back')?.addEventListener('click', ()=>{
            if (window.sectionManager) window.sectionManager.showSection('zakaznici');
        });
        document.getElementById('customer-detail-edit')?.addEventListener('click', ()=>this.openEditor(customer.id));
        // Načti soubory zákazníka asynchronně (panel se rerenderuje, jakmile dorazí data)
        this.loadCustomerFiles(customer.id, customer.name).catch((err)=>{
            console.warn("Nepoda\u0159ilo se na\u010D\xedst soubory z\xe1kazn\xedka:", err);
        });
    }
    // ----- Detail zákazníka: panel "Soubory" -----
    renderCustomerFilesSkeleton() {
        return `
      <div class="bg-white rounded-lg shadow border border-gray-200">
        <div class="px-4 py-3 border-b border-gray-200 flex items-center justify-between gap-3">
          <h3 class="text-sm font-semibold text-gray-700 flex items-center gap-2">
            ${(0, $entK4.icon)('folder', 'w-4 h-4 text-gray-400')}
            Soubory
          </h3>
          <div class="flex items-center gap-2 text-xs text-gray-400">Na\u{10D}\xedt\xe1m\u{2026}</div>
        </div>
        <div class="p-4">
          <div class="space-y-2">
            ${[
            1,
            2,
            3
        ].map(()=>`<div class="h-12 bg-gray-100 rounded animate-pulse"></div>`).join('')}
          </div>
        </div>
      </div>
    `;
    }
    async loadCustomerFiles(customerId, customerName) {
        const API = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
        const panel = document.getElementById('customer-files-panel');
        if (!panel) return;
        try {
            const res = await fetch(`${API}/files?customerId=${encodeURIComponent(customerId)}`, {
                credentials: 'include'
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const json = await res.json();
            const files = Array.isArray(json.data) ? json.data : [];
            this.renderCustomerFilesPanel(panel, customerId, customerName, files);
        } catch (err) {
            console.warn("Soubory z\xe1kazn\xedka:", err);
            panel.innerHTML = `
        <div class="bg-white rounded-lg shadow border border-gray-200 p-4 text-sm text-gray-500">
          Soubory se nepoda\u{159}ilo na\u{10D}\xedst.
        </div>
      `;
        }
    }
    renderCustomerFilesPanel(panel, customerId, customerName, files) {
        const totalCount = files.length;
        const totalSize = files.reduce((sum, f)=>sum + (Number(f.size) || 0), 0);
        const recent = files.slice(0, 5); // listFiles na backendu už řadí newest-first
        const rows = recent.length > 0 ? recent.map((f)=>this.renderCustomerFilesRow(f)).join('') : `<li class="px-4 py-6 text-sm text-gray-500 text-center">Tento z\xe1kazn\xedk zat\xedm nem\xe1 nahran\xe9 \u{17E}\xe1dn\xe9 soubory.</li>`;
        panel.innerHTML = `
      <div class="bg-white rounded-lg shadow border border-gray-200">
        <div class="px-4 py-3 border-b border-gray-200 flex items-center justify-between gap-3 flex-wrap">
          <h3 class="text-sm font-semibold text-gray-700 flex items-center gap-2">
            ${(0, $entK4.icon)('folder', 'w-4 h-4 text-gray-400')}
            Soubory
            <span class="text-xs font-normal text-gray-400">
              ${totalCount > 0 ? `(${totalCount} \xb7 ${this.formatFileSize(totalSize)})` : ''}
            </span>
          </h3>
          <div class="flex items-center gap-2 flex-wrap">
            <button type="button" id="customer-files-upload-btn"
              class="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 shadow-sm">
              ${(0, $entK4.icon)('cloud-arrow-up', 'w-3.5 h-3.5 mr-1.5')}
              Nahr\xe1t
            </button>
            ${totalCount > 0 ? `
              <button type="button" id="customer-files-share-btn"
                class="inline-flex items-center px-2.5 py-1.5 border border-emerald-300 text-xs font-medium rounded-md text-emerald-700 bg-white hover:bg-emerald-50">
                ${(0, $entK4.icon)('link', 'w-3.5 h-3.5 mr-1.5')}
                Sd\xedlet odkaz
              </button>` : ''}
            <button type="button" id="customer-files-all-btn"
              class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 text-xs font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
              V\u{161}echny soubory
              ${(0, $entK4.icon)('chevron-right', 'w-3.5 h-3.5 ml-1.5')}
            </button>
          </div>
        </div>
        <ul class="divide-y divide-gray-100">${rows}</ul>
        ${totalCount > recent.length ? `
          <div class="px-4 py-2 border-t border-gray-100 text-xs text-gray-500 text-center bg-gray-50">
            Zobrazeno posledn\xedch ${recent.length} z ${totalCount} soubor\u{16F}.
            <button id="customer-files-all-link" class="inline-flex items-center gap-0.5 text-blue-600 hover:underline ml-1">Zobrazit v\u{161}echny ${(0, $entK4.icon)('chevron-right', 'w-3 h-3')}</button>
          </div>` : ''}
      </div>
    `;
        this.bindCustomerFilesEvents(panel, customerId, customerName);
    }
    renderCustomerFilesRow(file) {
        const ext = (()=>{
            const name = file.originalName || '';
            const idx = name.lastIndexOf('.');
            return idx >= 0 ? name.slice(idx + 1).toUpperCase() : '';
        })();
        return `
      <li class="px-4 py-3 flex items-center gap-3 hover:bg-gray-50 transition-colors">
        <div class="flex-shrink-0 w-9 h-9 rounded-md bg-blue-50 text-blue-600 flex items-center justify-center text-[10px] font-semibold uppercase tracking-wide">
          ${ext ? this.escape(ext.slice(0, 4)) : (0, $entK4.icon)('document', 'w-4 h-4')}
        </div>
        <div class="flex-1 min-w-0">
          <div class="text-sm font-medium text-gray-900 truncate" title="${this.escape(file.originalName || '')}">
            ${this.escape(file.originalName || '')}
          </div>
          <div class="text-xs text-gray-500 truncate">
            ${this.escape(this.formatFileSize(file.size))} \xb7 ${this.escape(this.formatDateTime(file.uploadedAt))}
            ${file.description ? ` \xb7 ${this.escape(file.description)}` : ''}
          </div>
        </div>
      </li>
    `;
    }
    bindCustomerFilesEvents(panel, customerId, customerName) {
        const goToFiles = ()=>{
            // Předem nastav filtr na zákazníka, pak přepni
            if (window.filesManager) {
                window.filesManager.selectedCustomer = {
                    id: customerId,
                    name: customerName
                };
                window.filesManager.updateCustomerLabel?.();
            }
            if (window.sectionManager) window.sectionManager.showSection('soubory');
        };
        panel.querySelector('#customer-files-all-btn')?.addEventListener('click', goToFiles);
        panel.querySelector('#customer-files-all-link')?.addEventListener('click', goToFiles);
        panel.querySelector('#customer-files-upload-btn')?.addEventListener('click', ()=>{
            // Otevři přímo upload modal s předvyplněným zákazníkem
            if (!window.filesManager) {
                this.notify?.("Sekce soubor\u016F je\u0161t\u011B nen\xed inicializovan\xe1", 'warning');
                return;
            }
            window.filesManager.openUploadModal({
                customer: {
                    id: customerId,
                    name: customerName
                }
            });
            // Po zavření modálu obnov i tento panel
            const refresh = ()=>this.loadCustomerFiles(customerId, customerName);
            // Polling – zjisti, kdy modal zmizí, a refreshni panel
            const interval = setInterval(()=>{
                if (!document.getElementById('files-upload-modal')) {
                    clearInterval(interval);
                    refresh();
                }
            }, 300);
        });
        panel.querySelector('#customer-files-share-btn')?.addEventListener('click', async ()=>{
            try {
                const API = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
                const res = await fetch(`${API}/files/share/${encodeURIComponent(customerId)}`, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        customerName: customerName
                    })
                });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const json = await res.json();
                const url = json.data?.url;
                if (!url) throw new Error("Server nevr\xe1til URL");
                try {
                    await navigator.clipboard.writeText(url);
                    this.notify?.(`Odkaz pro ${customerName} byl zkop\xedrov\xe1n do schr\xe1nky`, 'success');
                } catch (_) {
                    window.prompt("Ve\u0159ejn\xfd odkaz (zkop\xedrujte ru\u010Dn\u011B):", url);
                }
            } catch (err) {
                console.error("Sd\xedlen\xed selhalo:", err);
                this.notify?.("Nepoda\u0159ilo se vytvo\u0159it ve\u0159ejn\xfd odkaz", 'error');
            }
        });
    }
    formatFileSize(bytes) {
        const n = Number(bytes) || 0;
        if (n < 1024) return `${n} B`;
        if (n < 1048576) return `${(n / 1024).toFixed(1)} KB`;
        if (n < 1073741824) return `${(n / 1048576).toFixed(1)} MB`;
        return `${(n / 1073741824).toFixed(2)} GB`;
    }
    formatDateTime(iso) {
        if (!iso) return '';
        try {
            return new Date(iso).toLocaleString('cs-CZ', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (_) {
            return String(iso);
        }
    }
    renderStatCard({ title: title, count: count, sum: sum, avg: avg, color: color, icon: iconName, placeholder: placeholder = false }) {
        const colors = {
            blue: {
                bg: 'bg-blue-50',
                text: 'text-blue-700',
                icon: 'text-blue-500'
            },
            emerald: {
                bg: 'bg-emerald-50',
                text: 'text-emerald-700',
                icon: 'text-emerald-500'
            },
            gray: {
                bg: 'bg-gray-50',
                text: 'text-gray-500',
                icon: 'text-gray-400'
            }
        };
        const c = colors[color] || colors.gray;
        const fmt = (n)=>Number(n || 0).toLocaleString('cs-CZ', {
                maximumFractionDigits: 0
            });
        return `
      <div class="bg-white rounded-lg shadow border border-gray-200 p-5 ${placeholder ? 'opacity-60' : ''}">
        <div class="flex items-start justify-between">
          <div>
            <div class="text-xs uppercase font-semibold tracking-wider ${c.text}">${this.escape(title)}</div>
            <div class="mt-2 text-3xl font-bold text-gray-900">${count.toLocaleString('cs-CZ')}</div>
            <div class="mt-3 text-sm text-gray-700"><strong>${fmt(sum)} K\u{10D}</strong> celkem</div>
            ${count > 0 && avg > 0 ? `<div class="text-xs text-gray-500">pr\u{16F}m\u{11B}r ${fmt(avg)} K\u{10D} / ks</div>` : ''}
            ${placeholder ? `<div class="text-xs text-gray-400 mt-1">Sekce v p\u{159}\xedprav\u{11B} (F\xe1ze 3)</div>` : ''}
          </div>
          <div class="${c.bg} ${c.icon} rounded-lg p-2">
            ${(0, $entK4.icon)(iconName, 'w-5 h-5')}
          </div>
        </div>
      </div>
    `;
    }
    renderStatusDistribution(byStatus, meta) {
        const entries = Object.entries(byStatus || {});
        if (entries.length === 0) return `<p class="text-sm text-gray-400">\u{17D}\xe1dn\xe1 data</p>`;
        const total = entries.reduce((s, [, c])=>s + c, 0);
        return `
      <div class="space-y-2">
        ${entries.map(([key, count])=>{
            const m = meta[key] || {
                label: key,
                dot: 'bg-gray-400'
            };
            const pct = total > 0 ? Math.round(count / total * 100) : 0;
            return `
            <div>
              <div class="flex items-center justify-between text-xs mb-1">
                <span class="flex items-center text-gray-700">
                  <span class="w-2 h-2 rounded-full mr-2 ${m.dot}"></span>${this.escape(m.label)}
                </span>
                <span class="text-gray-500">${count} (${pct} %)</span>
              </div>
              <div class="w-full bg-gray-100 rounded-full h-1.5">
                <div class="${m.dot} h-1.5 rounded-full" style="width: ${pct}%"></div>
              </div>
            </div>
          `;
        }).join('')}
      </div>
    `;
    }
    renderOfferHistoryRow(o, statusMeta) {
        const m = statusMeta[o.status] || {
            label: o.status || 'draft',
            badge: 'bg-gray-100 text-gray-800',
            dot: 'bg-gray-500'
        };
        const date = new Date(o.createdAt).toLocaleDateString('cs-CZ');
        return `
      <li class="px-4 py-3 hover:bg-gray-50">
        <button class="w-full text-left flex items-center justify-between gap-3" onclick="window.offersListManager?.openOfferEditor('${o.id}')">
          <div class="min-w-0">
            <div class="flex items-center gap-2">
              <span class="text-sm font-medium text-gray-900">#${this.escape(o.id)}</span>
              <span class="inline-flex items-center text-xs px-2 py-0.5 rounded-full ${m.badge}">
                <span class="w-1.5 h-1.5 rounded-full mr-1.5 ${m.dot}"></span>${this.escape(m.label)}
              </span>
            </div>
            <div class="text-xs text-gray-500">${date} \xb7 ${(o.items || []).length} polo\u{17E}ek</div>
          </div>
          <div class="text-sm font-semibold text-gray-900 shrink-0">${(o.totalPrice || 0).toLocaleString('cs-CZ')} K\u{10D}</div>
        </button>
      </li>
    `;
    }
    renderOrderHistoryRow(o, statusMeta) {
        const m = statusMeta[o.status] || {
            label: o.status || 'received',
            badge: 'bg-gray-100 text-gray-800',
            dot: 'bg-gray-500'
        };
        const date = new Date(o.createdAt).toLocaleDateString('cs-CZ');
        return `
      <li class="px-4 py-3 hover:bg-gray-50">
        <button class="w-full text-left flex items-center justify-between gap-3" onclick="window.ordersListManager?.openDetail('${o.id}')">
          <div class="min-w-0">
            <div class="flex items-center gap-2">
              <span class="text-sm font-medium text-gray-900">#${this.escape(o.id)}</span>
              <span class="inline-flex items-center text-xs px-2 py-0.5 rounded-full ${m.badge}">
                <span class="w-1.5 h-1.5 rounded-full mr-1.5 ${m.dot}"></span>${this.escape(m.label)}
              </span>
              ${o.invoicedAsId ? `<span class="inline-flex items-center gap-0.5 text-xs text-indigo-600">${(0, $entK4.icon)('arrow-right', 'w-3 h-3')} ${this.escape(o.invoicedAsId)}</span>` : ''}
            </div>
            <div class="text-xs text-gray-500">${date} \xb7 ${(o.items || []).length} polo\u{17E}ek${o.offerId ? ` \xb7 z nab\xeddky #${this.escape(o.offerId)}` : ''}</div>
          </div>
          <div class="text-sm font-semibold text-gray-900 shrink-0">${(o.totalPrice || 0).toLocaleString('cs-CZ')} K\u{10D}</div>
        </button>
      </li>
    `;
    }
    renderInvoiceStatCard(invStats) {
        const fmt = (n)=>Number(n || 0).toLocaleString('cs-CZ', {
                maximumFractionDigits: 0
            });
        const count = invStats?.count || 0;
        const total = invStats?.totalPrice || 0;
        const paid = invStats?.paid || 0;
        const unpaid = invStats?.unpaid || 0;
        const overdue = invStats?.overdueCount || 0;
        const overdueAmount = invStats?.overdueAmount || 0;
        return `
      <div class="bg-white rounded-lg shadow border border-gray-200 p-5">
        <div class="flex items-start justify-between">
          <div class="min-w-0">
            <div class="text-xs uppercase font-semibold tracking-wider text-indigo-700">Faktury</div>
            <div class="mt-2 text-3xl font-bold text-gray-900">${count.toLocaleString('cs-CZ')}</div>
            <div class="mt-3 text-sm text-gray-700"><strong>${fmt(total)} K\u{10D}</strong> celkem (s DPH)</div>
            <div class="mt-2 grid grid-cols-2 gap-2 text-xs">
              <div class="text-emerald-700">Uhrazeno: <strong>${fmt(paid)} K\u{10D}</strong></div>
              <div class="${unpaid > 0 ? 'text-amber-700' : 'text-gray-500'}">Zb\xfdv\xe1: <strong>${fmt(unpaid)} K\u{10D}</strong></div>
            </div>
            ${overdue > 0 ? `
              <div class="mt-2 text-xs text-red-700 bg-red-50 rounded px-2 py-1 inline-block">
                ${overdue}\xd7 po splatnosti \xb7 ${fmt(overdueAmount)} K\u{10D}
              </div>
            ` : ''}
          </div>
          <div class="bg-indigo-50 text-indigo-500 rounded-lg p-2">
            ${(0, $entK4.icon)('receipt', 'w-5 h-5')}
          </div>
        </div>
      </div>
    `;
    }
    renderInvoiceHistoryRow(inv, statusMeta) {
        const m = statusMeta[inv.status] || {
            label: inv.status || 'draft',
            badge: 'bg-gray-100 text-gray-800',
            dot: 'bg-gray-500'
        };
        const issueDate = inv.issueDate ? new Date(inv.issueDate).toLocaleDateString('cs-CZ') : "\u2014";
        const dueDate = inv.dueDate ? new Date(inv.dueDate).toLocaleDateString('cs-CZ') : "\u2014";
        const total = inv.totalPriceWithVat || 0;
        const paid = inv.paidAmount || 0;
        const remaining = Math.max(total - paid, 0);
        return `
      <li class="px-4 py-3 hover:bg-gray-50">
        <button class="w-full text-left flex items-center justify-between gap-3" onclick="(window.sectionManager?.showSection('faktury'),window.invoicesListManager?.openDetail('${inv.id}'))">
          <div class="min-w-0">
            <div class="flex items-center gap-2 flex-wrap">
              <span class="text-sm font-medium text-gray-900">${this.escape(inv.id)}</span>
              <span class="inline-flex items-center text-xs px-2 py-0.5 rounded-full ${m.badge}">
                <span class="w-1.5 h-1.5 rounded-full mr-1.5 ${m.dot}"></span>${this.escape(m.label)}
              </span>
              ${inv.isOverdue ? `<span class="inline-flex items-center text-xs px-2 py-0.5 rounded-full bg-red-100 text-red-800">Po splatnosti</span>` : ''}
            </div>
            <div class="text-xs text-gray-500">Vystaveno ${issueDate} \xb7 Splatnost ${dueDate}${inv.orderId ? ` \xb7 z objedn\xe1vky ${this.escape(inv.orderId)}` : ''}</div>
          </div>
          <div class="text-right shrink-0">
            <div class="text-sm font-semibold text-gray-900">${total.toLocaleString('cs-CZ', {
            maximumFractionDigits: 2
        })} ${this.escape(inv.currency || 'CZK')}</div>
            ${remaining > 0 ? `<div class="text-xs text-amber-700">Zb\xfdv\xe1 ${remaining.toLocaleString('cs-CZ', {
            maximumFractionDigits: 2
        })} ${this.escape(inv.currency || 'CZK')}</div>` : `<div class="text-xs text-emerald-700">Uhrazeno</div>`}
          </div>
        </button>
      </li>
    `;
    }
    renderCustomerRow(c) {
        const addressLine = [
            c.address,
            c.zip,
            c.city
        ].filter(Boolean).join(', ');
        const ico = c.ico ? `I\u{10C}O: ${this.escape(c.ico)}` : '';
        const dic = c.dic ? `DI\u{10C}: ${this.escape(c.dic)}` : '';
        const taxLine = [
            ico,
            dic
        ].filter(Boolean).join(" \xb7 ");
        return `
      <li class="hover:bg-gray-50 transition-colors">
        <div class="px-4 py-4 sm:px-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div class="min-w-0 flex-1">
            <p class="text-base sm:text-sm font-semibold text-gray-900 leading-snug break-words sm:truncate">
              ${this.escape(c.name)}
            </p>
            <div class="mt-1 flex flex-wrap items-center gap-2">
              <span class="text-xs px-2 py-0.5 rounded-full ${c.type === 'person' ? 'bg-purple-100 text-purple-700' : 'bg-blue-100 text-blue-700'}">
                ${c.type === 'person' ? 'Osoba' : 'Firma'}
              </span>
              <span class="text-xs px-2 py-0.5 rounded-full ${c.pricingTier === 'malo' ? 'bg-amber-100 text-amber-700' : 'bg-emerald-100 text-emerald-700'}" title="Cenov\xe1 \xfarove\u{148}">
                ${c.pricingTier === 'malo' ? 'Maloobchod' : 'Velkoobchod'}
              </span>
            </div>
            ${addressLine ? `<p class="mt-1 text-sm text-gray-600 truncate">${this.escape(addressLine)}</p>` : ''}
            ${taxLine ? `<p class="mt-1 text-xs text-gray-500">${taxLine}</p>` : ''}
            ${c.email || c.phone ? `
              <p class="mt-1 text-xs text-gray-500">
                ${c.email ? `<span>${this.escape(c.email)}</span>` : ''}
                ${c.email && c.phone ? " \xb7 " : ''}
                ${c.phone ? `<span>${this.escape(c.phone)}</span>` : ''}
              </p>` : ''}
          </div>
          <div class="flex space-x-2 shrink-0 self-end sm:self-auto">
            <button data-action="detail" data-id="${c.id}"
              class="inline-flex items-center p-2 border border-blue-300 rounded-md shadow-sm text-sm font-medium text-blue-700 bg-white hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              title="Detail a historie zak\xe1zek">
              ${(0, $entK4.icon)('chart-bar', 'h-4 w-4')}
            </button>
            <button data-action="edit" data-id="${c.id}"
              class="inline-flex items-center p-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              title="Upravit">
              ${(0, $entK4.icon)('pencil-square', 'h-4 w-4')}
            </button>
            <button data-action="delete" data-id="${c.id}"
              class="inline-flex items-center p-2 border border-red-300 rounded-md shadow-sm text-sm font-medium text-red-700 bg-white hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              title="Smazat">
              ${(0, $entK4.icon)('trash', 'h-4 w-4')}
            </button>
          </div>
        </div>
      </li>
    `;
    }
    // ----- Editor (modal) -----
    openEditor(id = null) {
        const customer = id ? this.customers.find((c)=>c.id === id) : null;
        const isEdit = !!customer;
        const data = customer || {
            name: '',
            type: 'company',
            ico: '',
            dic: '',
            address: '',
            city: '',
            zip: '',
            country: "\u010Cesk\xe1 republika",
            contactPerson: '',
            email: '',
            phone: '',
            web: '',
            note: '',
            pricingTier: 'velko'
        };
        const modalId = 'customer-editor-modal';
        this.removeModal(modalId);
        const html = `
      <div id="${modalId}" class="fixed inset-0 z-50 overflow-y-auto" role="dialog" aria-modal="true">
        <div class="flex items-end sm:items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:p-0">
          <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" data-close="1"></div>
          <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full">
            <form id="customer-form" class="p-6">
              <div class="flex items-start justify-between mb-4">
                <h3 class="text-lg font-semibold text-gray-900">
                  ${isEdit ? "Upravit z\xe1kazn\xedka" : "Nov\xfd z\xe1kazn\xedk"}
                </h3>
                <button type="button" data-close="1" class="text-gray-400 hover:text-gray-600">
                  ${(0, $entK4.icon)('x-mark', 'w-5 h-5')}
                </button>
              </div>

              ${isEdit ? '' : `
              <div class="mb-5 rounded-lg border border-blue-100 bg-gradient-to-br from-blue-50/60 to-indigo-50/40 p-4">
                <label class="flex items-center gap-2 text-xs font-semibold text-blue-700 uppercase tracking-wide mb-2">
                  ${(0, $entK4.icon)('magnifying-glass', 'w-4 h-4')}
                  Vyhledat z ARESu
                </label>
                <div class="relative">
                  <input type="text" id="ares-search-input" autocomplete="off"
                    placeholder="Zadejte I\u{10C}O (8 \u{10D}\xedslic) nebo n\xe1zev firmy\u{2026}"
                    class="w-full pl-3 pr-10 py-2 border border-blue-200 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white" />
                  <span id="ares-search-spinner" class="hidden absolute right-3 top-1/2 -translate-y-1/2">
                    ${(0, $entK4.icon)('spinner', 'animate-spin h-4 w-4 text-blue-500')}
                  </span>
                  <div id="ares-search-results" class="hidden absolute z-50 left-0 right-0 mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-72 overflow-y-auto"></div>
                </div>
                <p class="mt-2 text-xs text-gray-500">
                  Nalezen\xfd subjekt klikem vybere\u{161} a \xfadaje se p\u{159}edvypln\xed. M\u{16F}\u{17E}e\u{161} je pak p\u{159}ed ulo\u{17E}en\xedm upravit.
                </p>
              </div>
              `}

              <div class="grid grid-cols-1 sm:grid-cols-6 gap-4">
                <div class="sm:col-span-4">
                  <label class="block text-sm font-medium text-gray-700 mb-1">N\xe1zev firmy / jm\xe9no *</label>
                  <input type="text" name="name" required value="${this.escape(data.name)}"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                </div>
                <div class="sm:col-span-2">
                  <label class="block text-sm font-medium text-gray-700 mb-1">Typ</label>
                  <select name="type" class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                    <option value="company" ${data.type === 'company' ? 'selected' : ''}>Firma</option>
                    <option value="person" ${data.type === 'person' ? 'selected' : ''}>Fyzick\xe1 osoba</option>
                  </select>
                </div>
                <div class="sm:col-span-2">
                  <label class="block text-sm font-medium text-gray-700 mb-1">Cenov\xe1 \xfarove\u{148}</label>
                  <select name="pricingTier" class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                    <option value="velko" ${data.pricingTier === 'velko' ? 'selected' : ''}>Velkoobchodn\xed</option>
                    <option value="malo" ${data.pricingTier === 'malo' ? 'selected' : ''}>Maloobchodn\xed</option>
                  </select>
                </div>

                <div class="sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700 mb-1">I\u{10C}O</label>
                  <input type="text" name="ico" value="${this.escape(data.ico)}"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                </div>
                <div class="sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700 mb-1">DI\u{10C}</label>
                  <input type="text" name="dic" value="${this.escape(data.dic)}"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                </div>

                <div class="sm:col-span-6">
                  <label class="block text-sm font-medium text-gray-700 mb-1">Ulice a \u{10D}\xedslo popisn\xe9</label>
                  <input type="text" name="address" value="${this.escape(data.address)}"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                </div>
                <div class="sm:col-span-2">
                  <label class="block text-sm font-medium text-gray-700 mb-1">PS\u{10C}</label>
                  <input type="text" name="zip" value="${this.escape(data.zip)}"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                </div>
                <div class="sm:col-span-2">
                  <label class="block text-sm font-medium text-gray-700 mb-1">M\u{11B}sto</label>
                  <input type="text" name="city" value="${this.escape(data.city)}"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                </div>
                <div class="sm:col-span-2">
                  <label class="block text-sm font-medium text-gray-700 mb-1">Zem\u{11B}</label>
                  <input type="text" name="country" value="${this.escape(data.country)}"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                </div>

                <div class="sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700 mb-1">Kontaktn\xed osoba</label>
                  <input type="text" name="contactPerson" value="${this.escape(data.contactPerson)}"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                </div>
                <div class="sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700 mb-1">Telefon</label>
                  <input type="text" name="phone" value="${this.escape(data.phone)}"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                </div>
                <div class="sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <input type="email" name="email" value="${this.escape(data.email)}"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                </div>
                <div class="sm:col-span-3">
                  <label class="block text-sm font-medium text-gray-700 mb-1">Web</label>
                  <input type="text" name="web" value="${this.escape(data.web)}"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                </div>
                <div class="sm:col-span-6">
                  <label class="block text-sm font-medium text-gray-700 mb-1">Pozn\xe1mka</label>
                  <textarea name="note" rows="2"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500">${this.escape(data.note)}</textarea>
                </div>
              </div>

              <div id="customer-form-error" class="mt-3 text-sm text-red-600 hidden"></div>

              <div class="mt-6 flex justify-end gap-2">
                <button type="button" data-close="1"
                  class="inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50">
                  Zru\u{161}it
                </button>
                <button type="submit"
                  class="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-sm font-medium text-white hover:bg-blue-700">
                  ${isEdit ? "Ulo\u017Eit zm\u011Bny" : "Vytvo\u0159it z\xe1kazn\xedka"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    `;
        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        document.body.appendChild(wrapper);
        const modal = document.getElementById(modalId);
        modal.querySelectorAll('[data-close="1"]').forEach((el)=>{
            el.addEventListener('click', ()=>this.removeModal(modalId));
        });
        const form = document.getElementById('customer-form');
        form.addEventListener('submit', async (e)=>{
            e.preventDefault();
            const fd = new FormData(form);
            const payload = Object.fromEntries(fd.entries());
            try {
                if (isEdit) {
                    await this.updateCustomer(customer.id, payload);
                    this.notify("Z\xe1kazn\xedk byl aktualizov\xe1n", 'success');
                } else {
                    await this.createCustomer(payload);
                    this.notify("Z\xe1kazn\xedk byl vytvo\u0159en", 'success');
                }
                this.removeModal(modalId);
                await this.fetchCustomers(this.searchQuery);
                this.renderList();
            } catch (err) {
                const errBox = document.getElementById('customer-form-error');
                if (errBox) {
                    errBox.textContent = err.message;
                    errBox.classList.remove('hidden');
                }
            }
        });
        if (!isEdit) this.bindAresSearch(form);
    }
    // ----- ARES vyhledávání v editoru -----
    bindAresSearch(form) {
        const input = document.getElementById('ares-search-input');
        const resultsBox = document.getElementById('ares-search-results');
        const spinner = document.getElementById('ares-search-spinner');
        if (!input || !resultsBox) return;
        let debounceTimer = null;
        let lastQuery = '';
        let activeRequestToken = 0;
        const showResults = (html)=>{
            resultsBox.innerHTML = html;
            resultsBox.classList.remove('hidden');
        };
        const hideResults = ()=>{
            resultsBox.classList.add('hidden');
            resultsBox.innerHTML = '';
        };
        const runSearch = async (query)=>{
            const trimmed = query.trim();
            if (trimmed.length < 2) {
                hideResults();
                return;
            }
            if (trimmed === lastQuery) return;
            lastQuery = trimmed;
            const requestToken = ++activeRequestToken;
            spinner?.classList.remove('hidden');
            try {
                const results = await this.searchAres(trimmed, 10);
                if (requestToken !== activeRequestToken) return; // odpověď zastaralá
                if (!results.length) {
                    showResults(`
            <div class="px-4 py-3 text-sm text-gray-500">
              \u{17D}\xe1dn\xfd subjekt nenalezen pro \u{201E}${this.escape(trimmed)}".
            </div>
          `);
                    return;
                }
                const html = results.map((r, i)=>`
          <button type="button" data-ares-idx="${i}"
            class="w-full text-left px-4 py-3 hover:bg-blue-50 focus:bg-blue-50 focus:outline-none border-b border-gray-100 last:border-b-0 transition-colors">
            <div class="flex items-start justify-between gap-3">
              <div class="min-w-0 flex-1">
                <div class="font-medium text-sm text-gray-900 truncate">
                  ${this.escape(r.name || "(bez n\xe1zvu)")}
                </div>
                <div class="mt-0.5 text-xs text-gray-500 truncate">
                  ${this.escape(r.fullAddress || [
                        r.address,
                        r.city
                    ].filter(Boolean).join(', '))}
                </div>
              </div>
              <div class="text-right shrink-0">
                <div class="text-xs font-mono text-gray-700">I\u{10C}O ${this.escape(r.ico)}</div>
                ${r.dic ? `<div class="text-[11px] text-gray-400">${this.escape(r.dic)}</div>` : ''}
                ${r.active === false ? '<div class="text-[11px] text-red-500">Zanikl\xfd subjekt</div>' : ''}
              </div>
            </div>
          </button>
        `).join('');
                showResults(html);
                resultsBox.querySelectorAll('[data-ares-idx]').forEach((btn)=>{
                    btn.addEventListener('click', ()=>{
                        const idx = Number(btn.dataset.aresIdx);
                        const subject = results[idx];
                        if (subject) this.applyAresSubject(form, subject);
                        hideResults();
                    });
                });
            } catch (err) {
                if (requestToken !== activeRequestToken) return;
                showResults(`
          <div class="px-4 py-3 text-sm text-red-600">
            ${this.escape(err.message || "Chyba p\u0159i vyhled\xe1v\xe1n\xed v ARESu")}
          </div>
        `);
            } finally{
                if (requestToken === activeRequestToken) spinner?.classList.add('hidden');
            }
        };
        input.addEventListener('input', ()=>{
            const value = input.value;
            if (debounceTimer) clearTimeout(debounceTimer);
            // U IČO (8 číslic) reagujeme okamžitě, jinak debounce 350 ms
            const delay = /^\d{8}$/.test(value.trim()) ? 0 : 350;
            debounceTimer = setTimeout(()=>runSearch(value), delay);
        });
        input.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                if (debounceTimer) clearTimeout(debounceTimer);
                runSearch(input.value);
            } else if (e.key === 'Escape') hideResults();
        });
        // Klik mimo dropdown ho zavře
        document.addEventListener('click', (e)=>{
            if (!resultsBox.contains(e.target) && e.target !== input) hideResults();
        });
    }
    applyAresSubject(form, subject) {
        if (!form || !subject) return;
        const setValue = (name, value)=>{
            const el = form.querySelector(`[name="${name}"]`);
            if (el && value !== undefined && value !== null && value !== '') {
                el.value = value;
                // Vizuální flash že se hodnota doplnila
                el.classList.add('ring-2', 'ring-green-300');
                setTimeout(()=>el.classList.remove('ring-2', 'ring-green-300'), 1200);
            }
        };
        setValue('name', subject.name);
        setValue('ico', subject.ico);
        setValue('dic', subject.dic);
        setValue('address', subject.address);
        setValue('city', subject.city);
        setValue('zip', subject.zip);
        setValue('country', subject.country);
        const typeEl = form.querySelector('[name="type"]');
        if (typeEl) typeEl.value = 'company';
        this.notify(`\xdadaje na\u{10D}teny z ARESu (${subject.name})`, 'success');
    }
    async confirmDelete(id) {
        const customer = this.customers.find((c)=>c.id === id);
        if (!customer) return;
        if (!confirm(`Opravdu smazat z\xe1kazn\xedka \u{201E}${customer.name}"?`)) return;
        try {
            await this.deleteCustomer(id);
            this.notify("Z\xe1kazn\xedk byl smaz\xe1n", 'success');
            await this.fetchCustomers(this.searchQuery);
            this.renderList();
        } catch (err) {
            this.notify(err.message, 'error');
        }
    }
    // ----- Selektor pro editor nabídek -----
    /**
   * Otevře modální vyhledávač zákazníků.
   * Vrací Promise<customer|null>.
   */ openSelector() {
        return new Promise(async (resolve)=>{
            const modalId = 'customer-selector-modal';
            this.removeModal(modalId);
            const html = `
        <div id="${modalId}" class="fixed inset-0 z-50 overflow-y-auto" role="dialog" aria-modal="true">
          <div class="flex items-end sm:items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:p-0">
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" data-close="1"></div>
            <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl sm:w-full">
              <div class="p-6">
                <div class="flex items-start justify-between mb-4">
                  <h3 class="text-lg font-semibold text-gray-900">Vybrat z\xe1kazn\xedka</h3>
                  <button type="button" data-close="1" class="text-gray-400 hover:text-gray-600">
                    ${(0, $entK4.icon)('x-mark', 'w-5 h-5')}
                  </button>
                </div>

                <div class="relative mb-3">
                  <input type="text" id="customer-selector-search"
                    placeholder="Hledat (n\xe1zev, I\u{10C}O, m\u{11B}sto, email)\u{2026}"
                    class="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                  ${(0, $entK4.icon)('magnifying-glass', 'absolute left-2.5 top-2.5 w-4 h-4 text-gray-400')}
                </div>

                <div id="customer-selector-results" class="max-h-96 overflow-y-auto border border-gray-200 rounded-md divide-y divide-gray-200">
                  ${this.renderLoading()}
                </div>

                <div class="mt-4 flex justify-between items-center text-sm">
                  <button type="button" id="customer-selector-add-new"
                    class="inline-flex items-center text-blue-600 hover:text-blue-800">
                    ${(0, $entK4.icon)('plus', 'w-4 h-4 mr-1')}
                    P\u{159}idat nov\xe9ho z\xe1kazn\xedka
                  </button>
                  <button type="button" data-close="1"
                    class="inline-flex justify-center rounded-md border border-gray-300 px-3 py-1.5 bg-white text-gray-700 hover:bg-gray-50">
                    Zru\u{161}it
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
            const wrapper = document.createElement('div');
            wrapper.innerHTML = html;
            document.body.appendChild(wrapper);
            const modal = document.getElementById(modalId);
            const close = (value)=>{
                this.removeModal(modalId);
                resolve(value);
            };
            modal.querySelectorAll('[data-close="1"]').forEach((el)=>{
                el.addEventListener('click', ()=>close(null));
            });
            const renderResults = (items)=>{
                const results = document.getElementById('customer-selector-results');
                if (!results) return;
                if (!items || items.length === 0) {
                    results.innerHTML = `<div class="p-4 text-sm text-gray-500 text-center">Nic nenalezeno</div>`;
                    return;
                }
                results.innerHTML = items.map((c)=>`
            <button type="button" data-id="${c.id}"
              class="customer-selector-item w-full text-left px-4 py-3 hover:bg-blue-50 focus:bg-blue-50 focus:outline-none">
              <div class="flex items-center justify-between gap-2">
                <div class="min-w-0">
                  <div class="text-sm font-semibold text-gray-900 truncate">${this.escape(c.name)}</div>
                  <div class="text-xs text-gray-500 truncate">
                    ${[
                        c.ico ? `I\u{10C}O ${this.escape(c.ico)}` : '',
                        c.city ? this.escape(c.city) : '',
                        c.email ? this.escape(c.email) : ''
                    ].filter(Boolean).join(" \xb7 ")}
                  </div>
                </div>
                <span class="text-xs px-2 py-0.5 rounded-full ${c.type === 'person' ? 'bg-purple-100 text-purple-700' : 'bg-blue-100 text-blue-700'}">
                  ${c.type === 'person' ? 'Osoba' : 'Firma'}
                </span>
              </div>
            </button>
          `).join('');
                results.querySelectorAll('.customer-selector-item').forEach((btn)=>{
                    btn.addEventListener('click', ()=>{
                        const id = btn.dataset.id;
                        const found = items.find((x)=>x.id === id);
                        close(found || null);
                    });
                });
            };
            try {
                await this.fetchCustomers('');
                renderResults(this.customers);
            } catch (err) {
                const results = document.getElementById('customer-selector-results');
                if (results) results.innerHTML = `<div class="p-4 text-sm text-red-600 text-center">${this.escape(err.message)}</div>`;
            }
            const searchInput = document.getElementById('customer-selector-search');
            if (searchInput) {
                let debounce;
                searchInput.focus();
                searchInput.addEventListener('input', (e)=>{
                    clearTimeout(debounce);
                    const value = e.target.value;
                    debounce = setTimeout(async ()=>{
                        try {
                            const items = await this.fetchCustomers(value);
                            renderResults(items);
                        } catch (err) {
                            const results = document.getElementById('customer-selector-results');
                            if (results) results.innerHTML = `<div class="p-4 text-sm text-red-600 text-center">${this.escape(err.message)}</div>`;
                        }
                    }, 200);
                });
            }
            const addNewBtn = document.getElementById('customer-selector-add-new');
            if (addNewBtn) addNewBtn.addEventListener('click', ()=>{
                close(null);
                // Po zavření selektoru otevři editor
                this.openEditor();
            });
        });
    }
    // ----- Helpers -----
    /**
   * Z dat zákazníka vyrobí víceřádkový text pro vyplnění do textarea Odběratel.
   */ static formatCustomerToText(c) {
        if (!c) return '';
        const lines = [];
        if (c.name) lines.push(c.name);
        if (c.address) lines.push(c.address);
        const cityLine = [
            c.zip,
            c.city
        ].filter(Boolean).join(' ');
        if (cityLine) lines.push(cityLine);
        if (c.country && c.country !== "\u010Cesk\xe1 republika") lines.push(c.country);
        const taxLine = [
            c.ico ? `I\u{10C}: ${c.ico}` : '',
            c.dic ? `DI\u{10C}: ${c.dic}` : ''
        ].filter(Boolean).join(', ');
        if (taxLine) {
            lines.push('');
            lines.push(taxLine);
        }
        return lines.join('\n');
    }
    removeModal(id) {
        const el = document.getElementById(id);
        if (el && el.parentElement) el.parentElement.remove();
    }
    notify(message, type = 'success') {
        if (typeof window.showNotification === 'function') window.showNotification(message, type);
    }
    escape(str) {
        if (str == null) return '';
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
}
window.CustomersManager = $b9955ebca66af344$export$2bd0f762d756ec28;


// Sekce Objednávky – seznam se sdíleným toolbar/kartami z shared/list-ui.js.
// Stránkovaný list endpoint (limit/offset) vrací ořezané záznamy vč. customerName.
// Detail objednávky = editor po vzoru nabídek: A4 náhled, poznámka, PDF, tisk.


var $entK4 = parcelRequire("entK4");


var $6NozV = parcelRequire("6NozV");
const $c2f7131301a6236c$var$ORDER_STATUS_ORDER = [
    'received',
    'in_progress',
    'done',
    'to_invoice',
    'invoiced',
    'delivered',
    'cancelled'
];

class $c2f7131301a6236c$export$972696b81c05d4f3 {
    constructor(){
        this.orders = [];
        this.view = new (0, $6NozV.ListView)({
            key: 'orders',
            title: "Objedn\xe1vky",
            subtitle: "P\u0159ehled zak\xe1zek a jejich stav.",
            searchPlaceholder: "Hledat (\u010D\xedslo, firma, polo\u017Eka)\u2026",
            statusKind: 'order',
            statuses: $c2f7131301a6236c$var$ORDER_STATUS_ORDER,
            authorLabels: {
                me: "Moje objedn\xe1vky"
            },
            enableCustomerFilter: true,
            enableKanban: true,
            extraToolbar: ()=>this.renderExportDropdown(),
            onChange: ()=>this.load()
        });
    }
    // ---------- Seznam ----------
    async showSection() {
        await this.load();
    }
    isDetailView() {
        return Boolean(document.getElementById('orders-back-btn'));
    }
    /** Tichý reload (auto-refresh) – nesahá na otevřený detail, neukazuje spinner. */ refresh() {
        if (this.isDetailView()) return;
        this.load({
            silent: true
        });
    }
    async load({ silent: silent = false } = {}) {
        const container = document.getElementById('objednavky-section-content');
        if (!container) return;
        if (!document.getElementById('orders-list')) {
            this.view.renderShell(container);
            this._bindListEvents();
            this._bindExportEvents();
        } else if (!silent) this.view.renderLoading();
        try {
            if (this.view.viewMode === 'kanban') {
                await this.loadKanban();
                return;
            }
            const params = this.view.buildParams();
            const response = await fetch(`${(0, $6NozV.API_BASE_URL)}/orders?${params}`, {
                credentials: 'include'
            });
            if (!response.ok) throw new Error("Chyba p\u0159i na\u010D\xedt\xe1n\xed objedn\xe1vek");
            const result = await response.json();
            this.orders = result.data || [];
            if (Array.isArray(result.statuses) && result.statuses.length) this.view.statuses = result.statuses;
            if (Array.isArray(result.authors)) this.view.authors = result.authors;
            this.view.renderResults({
                rowsHtml: this.orders.map((o)=>this.renderOrderRow(o)),
                total: result.total,
                emptyState: {
                    title: "Zat\xedm nem\xe1te \u017E\xe1dn\xe9 objedn\xe1vky",
                    hint: "Objedn\xe1vka vznikne p\u0159eveden\xedm schv\xe1len\xe9 nab\xeddky tla\u010D\xedtkem \u201EP\u0159ev\xe9st na objedn\xe1vku\u201C v editoru nab\xeddky."
                }
            });
        } catch (error) {
            console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed objedn\xe1vek:", error);
            this.view.renderCustom((0, $6NozV.renderErrorState)("Nepoda\u0159ilo se na\u010D\xedst objedn\xe1vky", 'window.ordersListManager.load()'));
        }
    }
    async loadKanban() {
        const { renderKanbanBoard: renderKanbanBoard } = await (parcelRequire("l8N1u"));
        await renderKanbanBoard({
            view: this.view,
            statusKind: 'order',
            fetchColumn: async (status)=>{
                const params = this.view.buildParams({
                    paginate: false
                });
                params.set('status', status);
                params.set('limit', '30');
                params.set('sort', 'kanban');
                const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/orders?${params}`, {
                    credentials: 'include'
                });
                if (!res.ok) throw new Error("Chyba p\u0159i na\u010D\xedt\xe1n\xed objedn\xe1vek");
                const result = await res.json();
                return {
                    items: result.data || [],
                    total: result.total || 0
                };
            },
            cardData: (o)=>({
                    id: o.id,
                    title: `#${o.id}`,
                    customerName: (0, $6NozV.customerNameOf)(o),
                    meta: (0, $6NozV.formatDateTime)(o.createdAt),
                    price: (0, $6NozV.formatMoney)(o.totalPrice),
                    orderKey: typeof o.kanbanOrder === 'number' ? o.kanbanOrder : Date.parse(o.createdAt)
                }),
            onOpen: (id)=>this.openDetail(id),
            onDrop: async (id, { status: status, statusChanged: statusChanged, orderKey: orderKey })=>{
                if (statusChanged) await this.setStatus(id, status, "Zm\u011Bna stavu p\u0159eta\u017Een\xedm v kanbanu");
                await this.saveKanbanOrder(id, orderKey);
            }
        });
    }
    renderOrderRow(o) {
        const itemsCount = o.itemsCount != null ? o.itemsCount : (o.items || []).length;
        const itemsText = itemsCount === 1 ? "1 polo\u017Eka" : `${itemsCount} polo\u{17E}ek`;
        const itemNames = (o.items || []).map((i)=>(0, $6NozV.escapeHtml)(i.name)).join(', ');
        const badges = [];
        if (o.invoicedAsId) badges.push(`
        <span class="inline-flex items-center gap-0.5 text-xs text-indigo-700">
          ${(0, $entK4.icon)('receipt', 'w-3 h-3')}
          <button type="button" class="underline hover:no-underline" data-action="open-invoice" data-id="${(0, $6NozV.escapeHtml)(o.invoicedAsId)}" title="Otev\u{159}\xedt fakturu ${(0, $6NozV.escapeHtml)(o.invoicedAsId)}">${(0, $6NozV.escapeHtml)(o.invoicedAsId)}</button>
        </span>
      `);
        return (0, $6NozV.renderListCard)({
            id: o.id,
            title: `Objedn\xe1vka <span class="font-semibold">#${(0, $6NozV.escapeHtml)(o.id)}</span>`,
            status: {
                kind: 'order',
                value: o.status || 'received'
            },
            customerName: (0, $6NozV.customerNameOf)(o),
            metaLine: `
        <span class="inline-flex items-center">${(0, $entK4.icon)('calendar', 'w-3.5 h-3.5 mr-1 text-gray-400')}${(0, $6NozV.formatDateTime)(o.createdAt)}</span>
        <span>\xb7</span><span>${itemsText}</span>
        ${o.createdByName ? `<span>\xb7</span><span>${(0, $6NozV.escapeHtml)(o.createdByName)}</span>` : ''}
        ${o.offerId ? `<span>\xb7</span><span>z nab\xeddky #${(0, $6NozV.escapeHtml)(o.offerId)}</span>` : ''}
      `,
            description: itemNames,
            price: (0, $6NozV.formatMoney)(o.totalPrice),
            priceNote: 'bez DPH',
            badges: badges,
            compact: this.view.compact,
            actions: [
                {
                    action: 'open',
                    icon: 'eye',
                    label: "Detail objedn\xe1vky",
                    tone: 'primary'
                },
                {
                    action: 'pdf',
                    icon: 'document-arrow-down',
                    label: "St\xe1hnout PDF objedn\xe1vky"
                },
                {
                    action: 'delete',
                    icon: 'trash',
                    label: "Smazat objedn\xe1vku",
                    tone: 'danger'
                }
            ]
        });
    }
    _bindListEvents() {
        const list = this.view.listContainer;
        if (!list) return;
        list.addEventListener('click', (e)=>{
            const actionBtn = e.target.closest('[data-action]');
            if (actionBtn) {
                e.stopPropagation();
                const { action: action, id: id } = actionBtn.dataset;
                if (action === 'open') this.openDetail(id);
                else if (action === 'pdf') this.downloadPdf(id);
                else if (action === 'delete') this.confirmDelete(id);
                else if (action === 'open-invoice') {
                    if (window.sectionManager) window.sectionManager.showSection('faktury');
                    window.invoicesListManager?.openDetail(id);
                }
                return;
            }
            const row = e.target.closest('[data-row-id]');
            if (row && !e.target.closest('button, a, select')) this.openDetail(row.dataset.rowId);
        });
    }
    // ---------- Export ----------
    renderExportDropdown() {
        return `
      <div class="relative" id="orders-export-wrap">
        <button id="orders-export-btn" type="button" title="Exportovat aktu\xe1ln\xed v\xfdb\u{11B}r objedn\xe1vek"
          class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500">
          ${(0, $entK4.icon)('arrow-down-tray', 'w-4 h-4 mr-2')}
          Export
          ${(0, $entK4.icon)('chevron-down', 'w-4 h-4 ml-2')}
        </button>
        <div id="orders-export-menu"
          class="hidden absolute right-0 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-20 py-1">
          <button type="button" data-export="csv"
            class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
            CSV (Excel)
          </button>
          <button type="button" data-export="xlsx"
            class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
            Excel (.xlsx)
          </button>
        </div>
      </div>
    `;
    }
    _bindExportEvents() {
        const exportBtn = document.getElementById('orders-export-btn');
        const exportMenu = document.getElementById('orders-export-menu');
        if (!exportBtn || !exportMenu) return;
        exportBtn.addEventListener('click', (e)=>{
            e.stopPropagation();
            exportMenu.classList.toggle('hidden');
        });
        exportMenu.querySelectorAll('[data-export]').forEach((item)=>{
            item.addEventListener('click', ()=>{
                exportMenu.classList.add('hidden');
                this.triggerExport(item.dataset.export);
            });
        });
        // Zavření menu při kliku mimo (jen jednou)
        if (!this._exportOutsideClickBound) {
            this._exportOutsideClickBound = true;
            document.addEventListener('click', (e)=>{
                const wrap = document.getElementById('orders-export-wrap');
                const menu = document.getElementById('orders-export-menu');
                if (!wrap || !menu) return;
                if (!wrap.contains(e.target)) menu.classList.add('hidden');
            });
        }
    }
    triggerExport(format) {
        // Export respektuje aktuální filtry seznamu (bez stránkování);
        // dateFrom/dateTo se u export endpointu jmenují from/to.
        const params = this.view.buildParams({
            paginate: false
        });
        if (params.get('dateFrom')) {
            params.set('from', params.get('dateFrom'));
            params.delete('dateFrom');
        }
        if (params.get('dateTo')) {
            params.set('to', params.get('dateTo'));
            params.delete('dateTo');
        }
        params.set('format', format);
        const url = `${(0, $6NozV.API_BASE_URL)}/orders/export?${params.toString()}`;
        this.downloadExport(url, format);
        this.notify("Export spu\u0161t\u011Bn", 'info');
    }
    async downloadExport(url, format) {
        try {
            const res = await fetch(url, {
                credentials: 'include'
            });
            if (!res.ok) {
                let msg = `HTTP ${res.status}`;
                try {
                    const body = await res.json();
                    if (body?.error) msg = body.error;
                } catch (_) {}
                throw new Error(msg);
            }
            const blob = await res.blob();
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = `objednavky-${new Date().toISOString().slice(0, 10)}.${format}`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(()=>URL.revokeObjectURL(blobUrl), 1000);
        } catch (err) {
            console.error("Chyba p\u0159i exportu objedn\xe1vek:", err);
            this.notify(err.message || "Export se nezda\u0159il", 'error');
        }
    }
    async downloadPdf(id) {
        try {
            const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/orders/${id}/pdf`, {
                credentials: 'include'
            });
            if (!res.ok) {
                let msg = `HTTP ${res.status}`;
                try {
                    const body = await res.json();
                    if (body?.error) msg = body.error;
                } catch (_) {}
                throw new Error(msg);
            }
            const blob = await res.blob();
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = `objednavka-${id}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(()=>URL.revokeObjectURL(blobUrl), 1000);
            this.notify("PDF objedn\xe1vky sta\u017Eeno", 'success');
        } catch (err) {
            console.error("Chyba p\u0159i stahov\xe1n\xed PDF objedn\xe1vky:", err);
            this.notify(err.message || "PDF se nepoda\u0159ilo st\xe1hnout", 'error');
        }
    }
    // ---------- API ----------
    /** Kompatibilita: vyroba.js volá fetchOrders() pro synchronizaci seznamu. */ async fetchOrders() {
        return this.refresh();
    }
    async getOrder(id) {
        const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/orders/${id}`, {
            credentials: 'include'
        });
        if (!res.ok) throw new Error("Nepoda\u0159ilo se na\u010D\xedst objedn\xe1vku");
        const json = await res.json();
        return json.data;
    }
    async setStatus(id, status, note = '') {
        const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/orders/${id}/status`, {
            method: 'PATCH',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                status: status,
                note: note
            })
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json.error || "Nepoda\u0159ilo se zm\u011Bnit stav objedn\xe1vky");
        return json.data;
    }
    /** Uloží ruční pořadí karty v kanbanu (updateOrder propouští kanbanOrder přes PUT). */ async saveKanbanOrder(id, orderKey) {
        const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/orders/${id}`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                kanbanOrder: orderKey
            })
        });
        if (!res.ok) {
            const json = await res.json().catch(()=>({}));
            throw new Error(json.error || "Ulo\u017Een\xed po\u0159ad\xed se nezda\u0159ilo");
        }
    }
    async deleteOrder(id) {
        const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/orders/${id}`, {
            method: 'DELETE',
            credentials: 'include'
        });
        if (!res.ok) {
            const json = await res.json().catch(()=>({}));
            throw new Error(json.error || "Nepoda\u0159ilo se smazat objedn\xe1vku");
        }
        return true;
    }
    // ---------- Detail ----------
    async openDetail(id) {
        const sm = window.sectionManager;
        if (sm && sm.currentSection !== 'objednavky') sm.switchToSection('objednavky', {
            skipLoad: true
        });
        const container = document.getElementById('objednavky-section-content');
        if (!container) return;
        container.innerHTML = `
      <div class="flex items-center justify-center py-16 text-gray-400">
        ${(0, $entK4.icon)('spinner', 'w-8 h-8 animate-spin')}
      </div>
    `;
        try {
            const order = await this.getOrder(id);
            this.renderDetail(order);
        } catch (err) {
            this.renderDetailError(err.message);
        }
    }
    renderDetailError(message) {
        const container = document.getElementById('objednavky-section-content');
        if (!container) return;
        container.innerHTML = `
      <div class="space-y-4">
        <button id="orders-back-btn"
          class="inline-flex items-center px-3 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
          ${(0, $entK4.icon)('chevron-left', 'w-4 h-4 mr-2')}
          Zp\u{11B}t na seznam
        </button>
        <div class="bg-red-50 border border-red-200 rounded-md p-4 text-sm text-red-700">${(0, $6NozV.escapeHtml)(message)}</div>
      </div>
    `;
        document.getElementById('orders-back-btn')?.addEventListener('click', ()=>this.load());
    }
    renderDetail(o) {
        const container = document.getElementById('objednavky-section-content');
        if (!container) return;
        const created = new Date(o.createdAt).toLocaleString('cs-CZ');
        const updated = new Date(o.updatedAt).toLocaleString('cs-CZ');
        const totalPrice = o.totalPrice || 0;
        const totalWithVat = totalPrice * 1.21;
        container.innerHTML = `
      <div class="space-y-4">
        <button id="orders-back-btn"
          class="inline-flex items-center px-3 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
          ${(0, $entK4.icon)('chevron-left', 'w-4 h-4 mr-2')}
          Zp\u{11B}t na seznam
        </button>

        <div class="bg-white rounded-lg shadow border border-gray-200 p-6">
          <div class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-4">
            <div>
              <h3 class="text-xl font-semibold text-gray-900">Objedn\xe1vka #${(0, $6NozV.escapeHtml)(o.id)}</h3>
              <p class="text-sm text-gray-500 mt-1">
                Vytvo\u{159}eno ${created} \xb7 vystavil ${(0, $6NozV.escapeHtml)(o.createdBy || "\u2014")}
                ${o.offerId ? ` \xb7 z nab\xeddky <button class="text-blue-600 hover:underline" id="orders-open-offer">#${(0, $6NozV.escapeHtml)(o.offerId)}</button>` : ''}
              </p>
            </div>
            <div class="flex items-center gap-3 flex-wrap">
              ${(0, $6NozV.statusBadge)('order', o.status, 'text-sm px-3 py-1')}
              <select id="orders-detail-status"
                class="px-3 py-2 border border-gray-300 rounded-md text-sm">
                ${this.view.statuses.map((s)=>`<option value="${s}" ${s === o.status ? 'selected' : ''}>${(0, $6NozV.escapeHtml)((0, $6NozV.statusLabel)('order', s) || s)}</option>`).join('')}
              </select>
              <button id="orders-detail-pdf" type="button"
                class="inline-flex items-center px-3 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                ${(0, $entK4.icon)('document-arrow-down', 'w-4 h-4 mr-1.5 text-gray-500')}
                PDF
              </button>
              <button id="orders-detail-print" type="button"
                class="inline-flex items-center px-3 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                ${(0, $entK4.icon)('printer', 'w-4 h-4 mr-1.5 text-gray-500')}
                Tisk
              </button>
              ${this.renderInvoiceAction(o)}
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-2">
            <div>
              <h4 class="text-sm font-semibold text-gray-700 mb-2">Pozn\xe1mka k objedn\xe1vce</h4>
              <textarea id="orders-detail-note" rows="4"
                class="w-full p-3 border border-gray-300 rounded-md text-sm resize-vertical focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Intern\xed pozn\xe1mka k zak\xe1zce (term\xedn, doprava, speci\xe1ln\xed po\u{17E}adavky\u{2026}). Ulo\u{17E}\xed se automaticky a vytiskne se na objedn\xe1vce.">${(0, $6NozV.escapeHtml)(o.note || '')}</textarea>
              <p id="orders-note-hint" class="text-xs text-gray-400 mt-1">Zm\u{11B}ny se ukl\xe1daj\xed automaticky po opu\u{161}t\u{11B}n\xed pole.</p>
            </div>
            <div>
              <h4 class="text-sm font-semibold text-gray-700 mb-2">Celkov\xe1 cena</h4>
              <div class="bg-gray-50 rounded-md p-3 border border-gray-100">
                <div class="flex justify-between text-sm"><span>Bez DPH</span><strong>${totalPrice.toLocaleString('cs-CZ')} K\u{10D}</strong></div>
                <div class="flex justify-between text-sm mt-1"><span>S DPH 21 %</span><strong>${totalWithVat.toLocaleString('cs-CZ', {
            maximumFractionDigits: 2
        })} K\u{10D}</strong></div>
                <div class="flex justify-between text-xs text-gray-500 mt-2"><span>Polo\u{17E}ek</span><span>${(o.items || []).length}</span></div>
                <div class="flex justify-between text-xs text-gray-500"><span>Posledn\xed zm\u{11B}na</span><span>${updated}</span></div>
              </div>
            </div>
          </div>
        </div>

        <!-- A4 n\xe1hled objedn\xe1vky (stejn\xfd vzor jako editor nab\xeddky) -->
        <div class="bg-white rounded-lg shadow border border-gray-200 p-6 overflow-x-auto" id="orders-a4-preview">
          ${this.renderOrderPreview(o)}
        </div>

        <div class="bg-white rounded-lg shadow border border-gray-200 p-6">
          <h4 class="text-sm font-semibold text-gray-700 mb-3">Historie stav\u{16F}</h4>
          ${this.renderStatusHistory(o.statusHistory)}
        </div>
      </div>
    `;
        document.getElementById('orders-back-btn')?.addEventListener('click', ()=>this.load());
        document.getElementById('orders-detail-pdf')?.addEventListener('click', ()=>this.downloadPdf(o.id));
        document.getElementById('orders-detail-print')?.addEventListener('click', ()=>this.printOrder(o));
        document.getElementById('orders-detail-note')?.addEventListener('change', async (e)=>{
            try {
                const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/orders/${o.id}`, {
                    method: 'PUT',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        note: e.target.value
                    })
                });
                const json = await res.json();
                if (!res.ok) throw new Error(json.error || "Pozn\xe1mku se nepoda\u0159ilo ulo\u017Eit");
                o.note = json.data.note;
                const hint = document.getElementById('orders-note-hint');
                if (hint) hint.textContent = `Ulo\u{17E}eno ${new Date().toLocaleTimeString('cs-CZ')}`;
            } catch (err) {
                this.notify(err.message, 'error');
            }
        });
        document.getElementById('orders-detail-status')?.addEventListener('change', async (e)=>{
            try {
                const updated = await this.setStatus(o.id, e.target.value);
                this.notify(`Stav zm\u{11B}n\u{11B}n na \u{201E}${(0, $6NozV.statusLabel)('order', updated.status) || updated.status}"`, 'success');
                this.renderDetail(updated);
            } catch (err) {
                this.notify(err.message, 'error');
            }
        });
        document.getElementById('orders-open-offer')?.addEventListener('click', async ()=>{
            if (!window.offersListManager || !o.offerId) return;
            window.offersListManager.openOfferEditor(o.offerId);
        });
        document.getElementById('orders-issue-invoice-btn')?.addEventListener('click', ()=>this.handleIssueInvoice(o));
        document.getElementById('orders-open-invoice-btn')?.addEventListener('click', ()=>{
            if (!window.invoicesListManager || !o.invoicedAsId) return;
            if (window.sectionManager) window.sectionManager.showSection('faktury');
            window.invoicesListManager.openDetail(o.invoicedAsId);
        });
    }
    renderInvoiceAction(o) {
        if (o.invoicedAsId) return `
        <button id="orders-open-invoice-btn"
          class="inline-flex items-center px-3 py-2 border border-indigo-300 text-sm font-medium rounded-md text-indigo-700 bg-white hover:bg-indigo-50">
          ${(0, $entK4.icon)('receipt', 'w-4 h-4 mr-1.5')}
          Faktura ${(0, $6NozV.escapeHtml)(o.invoicedAsId)}
        </button>
      `;
        if (o.status === 'cancelled') return '';
        const isReady = [
            'to_invoice',
            'done',
            'delivered',
            'in_progress'
        ].includes(o.status);
        if (!isReady) return '';
        return `
      <button id="orders-issue-invoice-btn"
        class="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-emerald-600 hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500">
        ${(0, $entK4.icon)('receipt', 'w-4 h-4 mr-1.5')}
        Vystavit fakturu
      </button>
    `;
    }
    async handleIssueInvoice(order) {
        if (!confirm(`Vystavit fakturu z objedn\xe1vky #${order.id}?
Objedn\xe1vka p\u{159}ejde do stavu \u{201E}Fakturov\xe1no".`)) return;
        try {
            const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/invoices/from-order/${order.id}`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({})
            });
            const json = await res.json();
            if (!res.ok) throw new Error(json.error || "Nepoda\u0159ilo se vystavit fakturu");
            this.notify(`Vystavena faktura ${json.data.id}`, 'success');
            // Otevřít detail nově vystavené faktury v sekci Faktury
            if (window.sectionManager) window.sectionManager.showSection('faktury');
            if (window.invoicesListManager) await window.invoicesListManager.openDetail(json.data.id);
        } catch (err) {
            this.notify(err.message, 'error');
        }
    }
    renderStatusHistory(history) {
        if (!Array.isArray(history) || history.length === 0) return `<p class="text-sm text-gray-500">Zat\xedm bez zm\u{11B}n stavu.</p>`;
        return `
      <ol class="relative border-l border-gray-200 ml-3">
        ${history.slice().reverse().map((h)=>{
            const m = (0, $6NozV.STATUS_META).order[h.status] || {
                label: h.status,
                dot: 'bg-gray-400'
            };
            const time = new Date(h.changedAt).toLocaleString('cs-CZ');
            return `
            <li class="ml-4 pb-3">
              <span class="absolute -left-1.5 mt-1.5 w-3 h-3 rounded-full border border-white ${m.dot}"></span>
              <div class="text-sm font-medium text-gray-900">${(0, $6NozV.escapeHtml)(m.label)}</div>
              <div class="text-xs text-gray-500">${time} \xb7 ${(0, $6NozV.escapeHtml)(h.changedBy || "\u2014")}</div>
              ${h.note ? `<div class="text-xs text-gray-600 mt-0.5">${(0, $6NozV.escapeHtml)(h.note)}</div>` : ''}
            </li>
          `;
        }).join('')}
      </ol>
    `;
    }
    // ---------- A4 náhled a tisk (vzor: offer-editor.js) ----------
    /** A4 náhled objednávky – hlavička s logem, odběratel/dodavatel, položky se specifikací, součty. */ renderOrderPreview(o) {
        const date = new Date(o.createdAt);
        const formattedDate = date.toLocaleDateString('cs-CZ', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
        const totalPrice = o.totalPrice || 0;
        const vatRate = 0.21;
        const totalPriceWithVat = totalPrice * (1 + vatRate);
        return `
      <div class="container a4-wrapper" style="max-width: 800px; margin: 0 auto; font-family: 'Plus Jakarta Sans Variable', 'Inter Tight', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
        <header style="display: flex; flex-direction: row; align-items: flex-start; padding-bottom: 22px; border-bottom: 1px solid black; margin-bottom: 20px;">
          <div style="width: 50%;">
            <img src="${0, (/*@__PURE__*/$parcel$interopDefault($cdb5ad58694a976a$exports))}" alt="Tisk\xe1rna Tria, s.r.o." width="140" height="45">
          </div>
          <div style="width: 50%; text-align: right;">
            <h1 style="font-size: 1.3em; margin: 0 0 10px 0; font-weight: 600;">Objedn\xe1vka \u{10D}. ${(0, $6NozV.escapeHtml)(o.id)}</h1>
            <div style="font-size: 0.9em; color: #5A6079;">Ze dne: ${formattedDate}</div>
            <div style="font-size: 0.9em; color: #5A6079;">Vystavil: ${(0, $6NozV.escapeHtml)(o.createdByName || o.createdBy || "Syst\xe9m")}</div>
            ${o.offerId ? `<div style="font-size: 0.9em; color: #5A6079;">Na z\xe1klad\u{11B} nab\xeddky \u{10D}. ${(0, $6NozV.escapeHtml)(o.offerId)}</div>` : ''}
          </div>
        </header>

        <section style="display: flex; padding-top: 10px; flex-direction: row; align-items: flex-start; margin-bottom: 20px;">
          <div style="width: 50%;">
            <p style="font-size: 0.85em; letter-spacing: 0.04em; text-transform: uppercase; color: #5A6079; margin: 0 0 8px 0;">Odb\u{11B}ratel</p>
            <pre style="font-family: inherit; font-size: 0.95em; margin: 0; white-space: pre-wrap; line-height: 1.5;">${(0, $6NozV.escapeHtml)((0, $6NozV.customerDataText)(o.customerData) || "\u2014 bez z\xe1kazn\xedka \u2014")}</pre>
          </div>
          <div style="width: 50%; padding-left: 20px;">
            <p style="font-size: 0.85em; letter-spacing: 0.04em; text-transform: uppercase; color: #5A6079; margin: 0 0 8px 0;">Dodavatel</p>
            <div style="font-size: 0.95em; line-height: 1.5;">
              <p style="margin: 0 0 8px 0;">Tisk\xe1rna Tria s.r.o.<br>Olbramovice Ves 31,<br>259 01 Olbramovice</p>
              <p style="margin: 0 0 8px 0;">I\u{10C}O: 49546112<br>DI\u{10C}: CZ49546112</p>
              <p style="margin: 0;">Email: tiskarna@tria.cz<br>Web: www.tria.cz</p>
            </div>
          </div>
        </section>

        <table style="width: 100%; border-collapse: collapse; margin: 10px 0 20px 0;">
          <thead>
            <tr style="border-bottom: 1px solid black;">
              <th style="padding: 8px 4px; text-align: left; font-size: 0.85em; letter-spacing: 0.04em; text-transform: uppercase; color: #5A6079;">Ozna\u{10D}en\xed polo\u{17E}ky</th>
              <th style="padding: 8px 4px; text-align: right; font-size: 0.85em; letter-spacing: 0.04em; text-transform: uppercase; color: #5A6079; white-space: nowrap;">Po\u{10D}et kus\u{16F}</th>
              <th style="padding: 8px 4px; text-align: right; font-size: 0.85em; letter-spacing: 0.04em; text-transform: uppercase; color: #5A6079; white-space: nowrap;">Cena za kus</th>
              <th style="padding: 8px 4px; text-align: right; font-size: 0.85em; letter-spacing: 0.04em; text-transform: uppercase; color: #5A6079;">Cena</th>
              <th style="padding: 8px 4px; text-align: right; font-size: 0.85em; letter-spacing: 0.04em; text-transform: uppercase; color: #5A6079; white-space: nowrap;">Cena s DPH</th>
            </tr>
          </thead>
          <tbody>
            ${(o.items || []).map((item)=>this.renderOrderPreviewItemRow(item)).join('')}
          </tbody>
        </table>

        <section style="display: flex; justify-content: flex-end; margin-bottom: 16px;">
          <div style="min-width: 280px; font-size: 1em;">
            <div style="display: flex; justify-content: space-between; padding: 4px 0;">
              <span style="color: #5A6079;">Cena celkem (bez DPH)</span>
              <span>${totalPrice.toLocaleString('cs-CZ')} K\u{10D}</span>
            </div>
            <div style="display: flex; justify-content: space-between; padding: 4px 0;">
              <span style="color: #5A6079;">DPH 21 %</span>
              <span>${(totalPrice * vatRate).toLocaleString('cs-CZ', {
            maximumFractionDigits: 2
        })} K\u{10D}</span>
            </div>
            <div style="display: flex; justify-content: space-between; padding: 8px 0 4px; margin-top: 4px; border-top: 1px solid black; font-weight: 700; font-size: 1.15em;">
              <span>Celkem s DPH</span>
              <span>${totalPriceWithVat.toLocaleString('cs-CZ', {
            maximumFractionDigits: 2
        })} K\u{10D}</span>
            </div>
          </div>
        </section>

        ${o.note ? `
          <section style="margin-bottom: 16px; border: 1px solid #EDEEF3; border-radius: 6px; padding: 12px 14px; background: #FAFAFC;">
            <p style="font-size: 0.85em; letter-spacing: 0.04em; text-transform: uppercase; color: #5A6079; margin: 0 0 6px 0;">Pozn\xe1mka</p>
            <p style="margin: 0; font-size: 0.95em; white-space: pre-wrap;">${(0, $6NozV.escapeHtml)(o.note)}</p>
          </section>
        ` : ''}
      </div>
    `;
    }
    renderOrderPreviewItemRow(item) {
        const vatRate = 0.21;
        const price = item.price || 0;
        const priceWithVat = price * (1 + vatRate);
        const quantity = Number(item.formData?.pocetKusu) || 1;
        const unitPrice = item.pricePerPiece || (quantity > 0 ? price / quantity : 0);
        const displayName = (0, $39500ec295adf68d$exports.stripFinishingFromName)(item.name || '');
        const finishingLines = item.formData ? (0, $39500ec295adf68d$exports.buildFinishingLines)(item.formData) : [];
        return `
      <tr style="${finishingLines.length ? '' : 'border-bottom: 1px solid #EDEEF3;'}">
        <td style="padding: 8px 4px; vertical-align: top;">
          <div style="font-weight: 500;">${(0, $6NozV.escapeHtml)(displayName)}</div>
          ${item.notes && item.notes.trim() ? `<div style="font-size: 0.85em; color: #5A6079; margin-top: 2px;">${(0, $6NozV.escapeHtml)(item.notes)}</div>` : ''}
        </td>
        <td style="padding: 8px 4px; text-align: right; white-space: nowrap; vertical-align: top;">${quantity.toLocaleString('cs-CZ')} ks</td>
        <td style="padding: 8px 4px; text-align: right; white-space: nowrap; vertical-align: top;">${unitPrice.toLocaleString('cs-CZ', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        })} K\u{10D}</td>
        <td style="padding: 8px 4px; text-align: right; white-space: nowrap; vertical-align: top;">${price.toLocaleString('cs-CZ', {
            maximumFractionDigits: 2
        })} K\u{10D}</td>
        <td style="padding: 8px 4px; text-align: right; white-space: nowrap; vertical-align: top;">${priceWithVat.toLocaleString('cs-CZ', {
            maximumFractionDigits: 2
        })} K\u{10D}</td>
      </tr>
      ${finishingLines.length ? `
        <tr style="border-bottom: 1px solid #EDEEF3;">
          <td colspan="5" style="padding: 0 4px 10px 4px; font-size: 0.85em; color: #5A6079; line-height: 1.5;">
            ${finishingLines.map((l)=>(0, $6NozV.escapeHtml)(l)).join('<br>')}
          </td>
        </tr>
      ` : ''}
    `;
    }
    /** Tisk objednávky – otevře nové okno s A4 náhledem a spustí tisk. */ printOrder(o) {
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            this.notify("Prohl\xed\u017Ee\u010D zablokoval otev\u0159en\xed tiskov\xe9ho okna", 'error');
            return;
        }
        const absoluteLogoUrl = new URL((0, (/*@__PURE__*/$parcel$interopDefault($cdb5ad58694a976a$exports))), window.location.href).href;
        const content = this.renderOrderPreview(o).replace((0, (/*@__PURE__*/$parcel$interopDefault($cdb5ad58694a976a$exports))), absoluteLogoUrl);
        printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Objedn\xe1vka ${(0, $6NozV.escapeHtml)(o.id)}</title>
        <meta charset="utf-8" />
        <style>
          body { margin: 0; padding: 20px; color: #0B0E2D; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; }
          .a4-wrapper { width: 190mm; }
          @media print {
            body { padding: 0; }
            .a4-wrapper { width: auto; }
          }
        </style>
      </head>
      <body>
        ${content}
        <script>
          window.onload = function() { setTimeout(function() { window.print(); }, 300); }
        <\/script>
      </body>
      </html>
    `);
        printWindow.document.close();
    }
    // ---------- Akce ----------
    async confirmDelete(id) {
        if (!confirm(`Opravdu smazat objedn\xe1vku #${id}?`)) return;
        try {
            await this.deleteOrder(id);
            this.notify("Objedn\xe1vka byla smaz\xe1na", 'success');
            this.load();
        } catch (err) {
            this.notify(err.message, 'error');
        }
    }
    // ---------- Helpers ----------
    notify(msg, type = 'success') {
        if (typeof window.showNotification === 'function') window.showNotification(msg, type);
    }
    escape(str) {
        return (0, $6NozV.escapeHtml)(str);
    }
}
$c2f7131301a6236c$export$972696b81c05d4f3.STATUS_META = (0, $6NozV.STATUS_META).order;
$c2f7131301a6236c$export$972696b81c05d4f3.STATUS_ORDER = $c2f7131301a6236c$var$ORDER_STATUS_ORDER;
window.OrdersListManager = $c2f7131301a6236c$export$972696b81c05d4f3;


// Sekce Faktury – seznam se sdíleným toolbar/kartami z shared/list-ui.js.
// Stránkovaný list endpoint (limit/offset) vrací ořezané záznamy vč. customerName
// a serverové summary (KPI přes celý filtrovaný výsledek).
// Detail faktury (úprava draftu, změna stavu, úhrady, e-fakturace) zůstává vlastní.

var $entK4 = parcelRequire("entK4");

var $6NozV = parcelRequire("6NozV");
const $948c3369c316bbed$var$INVOICE_STATUS_ORDER = [
    'draft',
    'issued',
    'partially_paid',
    'paid',
    'overdue',
    'cancelled'
];
const $948c3369c316bbed$var$PAYMENT_METHODS = {
    bank: "Bankovn\xed p\u0159evod",
    cash: "Hotov\u011B",
    card: "Platebn\xed kartou"
};
// Detailové formátování částek (s desetinami) – seznam používá sdílené formatMoney.
const $948c3369c316bbed$var$fmtMoney = (n, currency = 'CZK')=>{
    const num = Number(n) || 0;
    return `${num.toLocaleString('cs-CZ', {
        minimumFractionDigits: num % 1 ? 2 : 0,
        maximumFractionDigits: 2
    })} ${currency}`;
};
const $948c3369c316bbed$var$fmtDate = (iso)=>{
    if (!iso) return "\u2014";
    return new Date(iso).toLocaleDateString('cs-CZ');
};
class $948c3369c316bbed$export$3c55d5630281258f {
    constructor(){
        this.invoices = [];
        this.summary = null;
        this.view = new (0, $6NozV.ListView)({
            key: 'invoices',
            title: 'Faktury',
            subtitle: "Vystaven\xe9 faktury a jejich \xfahrady.",
            searchPlaceholder: "Hledat (\u010D\xedslo, firma, VS, polo\u017Eka)\u2026",
            statusKind: 'invoice',
            statuses: $948c3369c316bbed$var$INVOICE_STATUS_ORDER,
            authorLabels: {
                me: 'Moje faktury'
            },
            enableCustomerFilter: true,
            enableKanban: false,
            summarySlot: true,
            onChange: ()=>this.load()
        });
    }
    // ---------- API (detail) ----------
    async getInvoice(id) {
        const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/invoices/${id}`, {
            credentials: 'include'
        });
        if (!res.ok) throw new Error("Nepoda\u0159ilo se na\u010D\xedst fakturu");
        const json = await res.json();
        return json.data;
    }
    async createFromOrder(orderId, options = {}) {
        const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/invoices/from-order/${orderId}`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(options)
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json.error || "Nepoda\u0159ilo se vystavit fakturu");
        return json.data;
    }
    async updateInvoice(id, data) {
        const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/invoices/${id}`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json.error || "Nepoda\u0159ilo se ulo\u017Eit fakturu");
        return json.data;
    }
    async setStatus(id, status, note = '') {
        const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/invoices/${id}/status`, {
            method: 'PATCH',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                status: status,
                note: note
            })
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json.error || "Nepoda\u0159ilo se zm\u011Bnit stav faktury");
        return json.data;
    }
    async markPaid(id, paidAmount, paidAt = null) {
        const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/invoices/${id}/mark-paid`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                paidAmount: paidAmount,
                paidAt: paidAt
            })
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json.error || "Nepoda\u0159ilo se ozna\u010Dit fakturu jako uhrazenou");
        return json.data;
    }
    async deleteInvoice(id) {
        const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/invoices/${id}`, {
            method: 'DELETE',
            credentials: 'include'
        });
        if (!res.ok) {
            const json = await res.json().catch(()=>({}));
            throw new Error(json.error || "Nepoda\u0159ilo se smazat fakturu");
        }
        return true;
    }
    async getAccountingConfig() {
        const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/invoices/accounting-config`, {
            credentials: 'include'
        });
        if (!res.ok) throw new Error("Nepoda\u0159ilo se na\u010D\xedst konfiguraci \xfa\u010Detnictv\xed");
        const json = await res.json();
        return json.data;
    }
    _downloadBlob(blob, filename) {
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(()=>URL.revokeObjectURL(blobUrl), 1000);
    }
    async downloadIsdocx(id) {
        const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/invoices/${id}/isdocx`, {
            credentials: 'include'
        });
        if (!res.ok) {
            const json = await res.json().catch(()=>({}));
            throw new Error(json.error || `HTTP ${res.status}`);
        }
        this._downloadBlob(await res.blob(), `${id}.isdocx`);
    }
    async downloadPdf(id) {
        const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/invoices/${id}/pdf`, {
            credentials: 'include'
        });
        if (!res.ok) {
            const json = await res.json().catch(()=>({}));
            throw new Error(json.error || `HTTP ${res.status}`);
        }
        this._downloadBlob(await res.blob(), `${id}.pdf`);
    }
    async submitToAccounting(id) {
        const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/invoices/${id}/submit-accounting`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        });
        const json = await res.json().catch(()=>({}));
        if (!res.ok) {
            const err = new Error(json.error || `HTTP ${res.status}`);
            err.status = res.status;
            err.data = json.data;
            throw err;
        }
        return {
            data: json.data,
            externalId: json.externalId
        };
    }
    // ---------- Seznam ----------
    async showSection() {
        await this.load();
    }
    isDetailView() {
        return Boolean(document.getElementById('invoice-back-btn'));
    }
    async refresh() {
        const container = document.getElementById('faktury-section-content');
        if (!container || this.isDetailView()) return;
        await this.load();
    }
    async load() {
        const container = document.getElementById('faktury-section-content');
        if (!container) return;
        if (!document.getElementById('invoices-list')) {
            this.view.renderShell(container);
            this._bindListEvents();
        } else this.view.renderLoading();
        try {
            const params = this.view.buildParams();
            const response = await fetch(`${(0, $6NozV.API_BASE_URL)}/invoices?${params}`, {
                credentials: 'include'
            });
            if (!response.ok) throw new Error("Nepoda\u0159ilo se na\u010D\xedst faktury");
            const result = await response.json();
            this.invoices = result.data || [];
            if (Array.isArray(result.statuses) && result.statuses.length) this.view.statuses = result.statuses;
            if (Array.isArray(result.authors)) this.view.authors = result.authors;
            this.summary = result.summary || null;
            this.renderSummary();
            this.view.renderResults({
                rowsHtml: this.invoices.map((inv)=>this.renderInvoiceRow(inv)),
                total: result.total,
                emptyState: {
                    title: "Zat\xedm nem\xe1te \u017E\xe1dn\xe9 faktury",
                    hint: "Faktura vznikne tla\u010D\xedtkem \u201EVystavit fakturu\u201C v detailu objedn\xe1vky se stavem \u201EFakturovat\u201C."
                }
            });
        } catch (error) {
            console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed faktur:", error);
            const summaryEl = this.view.summaryContainer;
            if (summaryEl) summaryEl.innerHTML = '';
            this.view.renderCustom((0, $6NozV.renderErrorState)("Nepoda\u0159ilo se na\u010D\xedst faktury", 'window.invoicesListManager.load()'));
        }
    }
    /** KPI dlaždice ze serverového summary (počítá se přes celý filtrovaný výsledek). */ renderSummary() {
        const el = this.view.summaryContainer;
        if (!el) return;
        const s = this.summary;
        if (!s || !s.count) {
            el.innerHTML = '';
            return;
        }
        const overdue = Number(s.overdueCount) || 0;
        el.innerHTML = `
      <div class="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        <div class="bg-white border border-gray-200 rounded-lg p-4">
          <div class="text-xs uppercase tracking-wide text-gray-500">Celkem fakturov\xe1no</div>
          <div class="mt-1 text-xl font-semibold text-gray-900">${$948c3369c316bbed$var$fmtMoney(s.totalInvoiced)}</div>
          <div class="text-xs text-gray-400">${s.count} faktur</div>
        </div>
        <div class="bg-white border border-emerald-200 rounded-lg p-4">
          <div class="text-xs uppercase tracking-wide text-emerald-700">Uhrazeno</div>
          <div class="mt-1 text-xl font-semibold text-emerald-700">${$948c3369c316bbed$var$fmtMoney(s.totalPaid)}</div>
        </div>
        <div class="bg-white border border-amber-200 rounded-lg p-4">
          <div class="text-xs uppercase tracking-wide text-amber-700">Neuhrazeno</div>
          <div class="mt-1 text-xl font-semibold text-amber-700">${$948c3369c316bbed$var$fmtMoney(s.totalUnpaid)}</div>
        </div>
        <div class="bg-white border ${overdue ? 'border-red-200' : 'border-gray-200'} rounded-lg p-4">
          <div class="text-xs uppercase tracking-wide ${overdue ? 'text-red-700' : 'text-gray-500'}">Po splatnosti</div>
          <div class="mt-1 text-xl font-semibold ${overdue ? 'text-red-700' : 'text-gray-900'}">${overdue}</div>
          ${overdue ? `<div class="text-xs text-red-600">${$948c3369c316bbed$var$fmtMoney(s.totalOverdue)}</div>` : ''}
        </div>
      </div>
    `;
    }
    renderInvoiceRow(inv) {
        const total = Number(inv.totalPriceWithVat) || 0;
        const paid = Number(inv.paidAmount) || 0;
        const remaining = Math.max(total - paid, 0);
        const currency = inv.currency === 'CZK' ? "K\u010D" : inv.currency || "K\u010D";
        const itemNames = (inv.items || []).map((i)=>(0, $6NozV.escapeHtml)(i.name)).join(', ');
        const badges = [];
        if (inv.isOverdue && inv.status !== 'overdue') badges.push((0, $6NozV.statusBadge)('invoice', 'overdue', 'font-medium'));
        const actions = [
            {
                action: 'open',
                icon: 'eye',
                label: 'Detail faktury',
                tone: 'primary'
            },
            {
                action: 'pdf',
                icon: 'document-arrow-down',
                label: "St\xe1hnout PDF faktury"
            }
        ];
        if (inv.status === 'draft') actions.push({
            action: 'delete',
            icon: 'trash',
            label: 'Smazat rozpracovanou fakturu',
            tone: 'danger'
        });
        return (0, $6NozV.renderListCard)({
            id: inv.id,
            title: `Faktura <span class="font-semibold">${(0, $6NozV.escapeHtml)(inv.id)}</span>`,
            status: {
                kind: 'invoice',
                value: inv.status || 'draft'
            },
            customerName: (0, $6NozV.customerNameOf)(inv),
            metaLine: `
        <span class="inline-flex items-center">${(0, $entK4.icon)('calendar', 'w-3.5 h-3.5 mr-1 text-gray-400')}vystaveno ${(0, $6NozV.formatDate)(inv.issueDate)}</span>
        <span>\xb7</span><span>splatnost ${(0, $6NozV.formatDate)(inv.dueDate)}</span>
        ${inv.variableSymbol ? `<span>\xb7</span><span>VS ${(0, $6NozV.escapeHtml)(inv.variableSymbol)}</span>` : ''}
        ${inv.orderId ? `<span>\xb7</span><span>z objedn\xe1vky #${(0, $6NozV.escapeHtml)(inv.orderId)}</span>` : ''}
      `,
            description: itemNames,
            price: (0, $6NozV.formatMoney)(total, currency),
            priceNote: remaining > 0 ? `zb\xfdv\xe1 ${(0, $6NozV.formatMoney)(remaining, currency)}` : 'uhrazena',
            badges: badges,
            compact: this.view.compact,
            actions: actions
        });
    }
    _bindListEvents() {
        const list = this.view.listContainer;
        if (!list) return;
        list.addEventListener('click', (e)=>{
            const actionBtn = e.target.closest('[data-action]');
            if (actionBtn) {
                e.stopPropagation();
                const { action: action, id: id } = actionBtn.dataset;
                if (action === 'open') this.openDetail(id);
                else if (action === 'pdf') this.handleDownloadPdf(id);
                else if (action === 'delete') this.confirmDelete(id);
                return;
            }
            const row = e.target.closest('[data-row-id]');
            if (row && !e.target.closest('button, a')) this.openDetail(row.dataset.rowId);
        });
    }
    async handleDownloadPdf(id) {
        try {
            await this.downloadPdf(id);
            this.notify("PDF faktury sta\u017Eeno", 'success');
        } catch (err) {
            this.notify("Sta\u017Een\xed PDF selhalo: " + err.message, 'error');
        }
    }
    // ---------- Detail ----------
    async openDetail(id) {
        const container = document.getElementById('faktury-section-content');
        if (!container) return;
        container.innerHTML = (0, $6NozV.renderLoading)();
        try {
            const invoice = await this.getInvoice(id);
            if (!invoice) throw new Error('Faktura nenalezena');
            this.renderDetail(invoice);
        } catch (err) {
            container.innerHTML = `<div class="bg-red-50 border border-red-200 rounded-md p-4 text-sm text-red-700">${this.escape(err.message)}</div>`;
        }
    }
    renderDetail(inv) {
        const container = document.getElementById('faktury-section-content');
        if (!container) return;
        const total = inv.totalPriceWithVat || 0;
        const remaining = Math.max(total - (inv.paidAmount || 0), 0);
        const isEditable = inv.status === 'draft';
        container.innerHTML = `
      <div class="mb-4">
        <button id="invoice-back-btn" class="inline-flex items-center text-sm text-gray-600 hover:text-blue-600">
          ${(0, $entK4.icon)('chevron-left', 'w-4 h-4 mr-1')}
          Zp\u{11B}t na faktury
        </button>
      </div>

      <div class="bg-white rounded-lg shadow-md overflow-hidden">
        <div class="px-6 py-4 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div>
            <h2 class="text-xl font-semibold text-gray-900">Faktura ${this.escape(inv.id)}</h2>
            <div class="mt-1 flex items-center gap-2 flex-wrap">
              ${(0, $6NozV.statusBadge)('invoice', inv.status)}
              ${inv.isOverdue && inv.status !== 'overdue' ? (0, $6NozV.statusBadge)('invoice', 'overdue', 'font-medium') : ''}
              ${inv.orderId ? `<span class="text-xs text-gray-500">z objedn\xe1vky ${this.escape(inv.orderId)}</span>` : ''}
              ${inv.offerId ? `<span class="text-xs text-gray-400">\xb7 nab\xeddka ${this.escape(inv.offerId)}</span>` : ''}
            </div>
          </div>
          <div class="flex flex-wrap gap-2">
            ${this.renderStatusActions(inv)}
          </div>
        </div>

        <form id="invoice-detail-form" class="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          <fieldset class="space-y-3" ${isEditable ? '' : 'disabled'}>
            <legend class="text-xs uppercase tracking-wide text-gray-500 mb-1">Term\xedny a platba</legend>
            <div class="grid grid-cols-2 gap-3">
              <label class="block">
                <span class="block text-xs text-gray-600 mb-1">Datum vystaven\xed</span>
                <input type="date" name="issueDate" value="${this.escape(inv.issueDate || '')}"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
              </label>
              <label class="block">
                <span class="block text-xs text-gray-600 mb-1">DUZP</span>
                <input type="date" name="taxableSupplyDate" value="${this.escape(inv.taxableSupplyDate || '')}"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
              </label>
              <label class="block">
                <span class="block text-xs text-gray-600 mb-1">Splatnost</span>
                <input type="date" name="dueDate" value="${this.escape(inv.dueDate || '')}"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
              </label>
              <label class="block">
                <span class="block text-xs text-gray-600 mb-1">Zp\u{16F}sob platby</span>
                <select name="paymentMethod" class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                  ${Object.entries($948c3369c316bbed$var$PAYMENT_METHODS).map(([k, v])=>`<option value="${k}" ${k === inv.paymentMethod ? 'selected' : ''}>${v}</option>`).join('')}
                </select>
              </label>
            </div>
            <div class="grid grid-cols-2 gap-3">
              <label class="block">
                <span class="block text-xs text-gray-600 mb-1">Variabiln\xed symbol</span>
                <input type="text" name="variableSymbol" value="${this.escape(inv.variableSymbol || '')}"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm font-mono" />
              </label>
              <label class="block">
                <span class="block text-xs text-gray-600 mb-1">Konstantn\xed symbol</span>
                <input type="text" name="constantSymbol" value="${this.escape(inv.constantSymbol || '')}"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm font-mono" />
              </label>
              <label class="block">
                <span class="block text-xs text-gray-600 mb-1">Bankovn\xed \xfa\u{10D}et</span>
                <input type="text" name="bankAccount" value="${this.escape(inv.bankAccount || '')}"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm font-mono" />
              </label>
              <label class="block">
                <span class="block text-xs text-gray-600 mb-1">IBAN</span>
                <input type="text" name="iban" value="${this.escape(inv.iban || '')}"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm font-mono" />
              </label>
            </div>
          </fieldset>

          <fieldset class="space-y-3">
            <legend class="text-xs uppercase tracking-wide text-gray-500 mb-1">Odb\u{11B}ratel</legend>
            <pre class="bg-gray-50 border border-gray-200 rounded-md p-3 text-sm text-gray-800 whitespace-pre-wrap font-sans">${this.escape(this.formatCustomer(inv.customerData) || "\u2014 bez z\xe1kazn\xedka \u2014")}</pre>

            <div class="bg-blue-50 border border-blue-200 rounded-md p-3">
              <div class="text-xs uppercase tracking-wide text-blue-700 mb-1">Celkov\xe1 \u{10D}\xe1stka</div>
              <div class="flex items-baseline justify-between">
                <div>
                  <div class="text-lg font-semibold text-blue-900">${$948c3369c316bbed$var$fmtMoney(total, inv.currency)}</div>
                  <div class="text-xs text-blue-700">bez DPH ${$948c3369c316bbed$var$fmtMoney(inv.totalPrice, inv.currency)} \xb7 DPH ${inv.vatRate}%</div>
                </div>
                <div class="text-right">
                  <div class="text-xs text-gray-600">Uhrazeno</div>
                  <div class="text-base font-semibold ${remaining > 0 ? 'text-amber-700' : 'text-emerald-700'}">${$948c3369c316bbed$var$fmtMoney(inv.paidAmount, inv.currency)}</div>
                  ${remaining > 0 ? `<div class="text-xs text-amber-700">Zb\xfdv\xe1 ${$948c3369c316bbed$var$fmtMoney(remaining, inv.currency)}</div>` : ''}
                </div>
              </div>
            </div>
          </fieldset>

          <div class="md:col-span-2 space-y-3">
            <label class="block">
              <span class="block text-xs text-gray-600 mb-1">Pozn\xe1mka</span>
              <textarea name="note" rows="2"
                class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500">${this.escape(inv.note || '')}</textarea>
            </label>
          </div>

          ${isEditable ? `
            <div class="md:col-span-2 flex justify-end gap-2">
              <button type="submit" class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700">
                Ulo\u{17E}it zm\u{11B}ny
              </button>
            </div>
          ` : ''}
        </form>

        ${this.renderItemsTable(inv)}
        ${this.renderEinvStatusBlock(inv, this._accountingConfigured)}
        ${this.renderStatusHistory(inv)}
      </div>
    `;
        document.getElementById('invoice-back-btn')?.addEventListener('click', ()=>this.load());
        // Načti konfiguraci účetnictví (jednou) a případně deaktuj submit tlačítko.
        this._accountingConfigured = null;
        this.getAccountingConfig().then((cfg)=>{
            this._accountingConfigured = Boolean(cfg && cfg.configured);
            const btn = document.getElementById('invoice-submit-accounting-btn');
            if (btn && !this._accountingConfigured) {
                btn.disabled = true;
                btn.classList.add('opacity-50', 'cursor-not-allowed');
                btn.title = "\xda\u010Detnictv\xed nen\xed nakonfigurov\xe1no (ACCOUNTING_* env)";
                if (!container.querySelector('[data-einv-warn]')) {
                    const warn = document.createElement('div');
                    warn.setAttribute('data-einv-warn', '1');
                    warn.className = 'text-xs text-amber-700 px-6 pb-2';
                    warn.textContent = "\xda\u010Detnictv\xed nen\xed nakonfigurov\xe1no (ACCOUNTING_* env) \u2013 odesl\xe1n\xed nen\xed dostupn\xe9.";
                    btn.closest('.bg-white.rounded-lg.shadow-md')?.appendChild(warn);
                }
            }
        }).catch(()=>{});
        if (isEditable) {
            const form = document.getElementById('invoice-detail-form');
            form?.addEventListener('submit', async (e)=>{
                e.preventDefault();
                const fd = new FormData(form);
                const payload = Object.fromEntries(fd.entries());
                try {
                    const updated = await this.updateInvoice(inv.id, payload);
                    this.notify("Faktura ulo\u017Eena", 'success');
                    this.renderDetail(updated);
                } catch (err) {
                    this.notify(err.message, 'error');
                }
            });
        }
        container.querySelectorAll('[data-status-action]').forEach((btn)=>btn.addEventListener('click', ()=>this.handleStatusAction(inv.id, btn.dataset.statusAction)));
        container.querySelectorAll('[data-einv-action]').forEach((btn)=>btn.addEventListener('click', ()=>this.handleEinvAction(inv.id, btn.dataset.einvAction)));
        document.getElementById('mark-paid-btn')?.addEventListener('click', ()=>this.openMarkPaidPrompt(inv));
    }
    async handleEinvAction(id, action) {
        if (action === 'isdocx') {
            try {
                await this.downloadIsdocx(id);
                this.notify("ISDOCx sta\u017Een", 'success');
            } catch (err) {
                this.notify("Sta\u017Een\xed ISDOCx selhalo: " + err.message, 'error');
            }
            return;
        }
        if (action === 'pdf') {
            await this.handleDownloadPdf(id);
            return;
        }
        if (action === 'submit-accounting') {
            try {
                const { externalId: externalId } = await this.submitToAccounting(id);
                this.notify(`Odesl\xe1no do \xfa\u{10D}etnictv\xed (ID: ${externalId || "\u2014"})`, 'success');
                const updated = await this.getInvoice(id);
                this.renderDetail(updated);
            } catch (err) {
                if (err.status === 501) this.notify("\xda\u010Detnictv\xed nen\xed nakonfigurov\xe1no", 'warning');
                else if (err.status === 502) this.notify("Chyba odesl\xe1n\xed: " + err.message, 'error');
                else this.notify("Chyba odesl\xe1n\xed: " + err.message, 'error');
                // Obnov detail, aby se zobrazila zaznamenaná chyba.
                try {
                    const updated = await this.getInvoice(id);
                    this.renderDetail(updated);
                } catch (_) {}
            }
            return;
        }
    }
    renderStatusActions(inv) {
        const buttons = [];
        buttons.push(`<button data-einv-action="pdf"
      class="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md text-gray-700 border border-gray-300 bg-white hover:bg-gray-50" title="St\xe1hnout PDF faktury">
      ${(0, $entK4.icon)('document-arrow-down', 'w-4 h-4 mr-1.5')}
      PDF
    </button>`);
        buttons.push(`<button data-einv-action="isdocx"
      class="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md text-gray-700 border border-gray-300 bg-white hover:bg-gray-50" title="St\xe1hnout e-fakturu ISDOCx">
      ${(0, $entK4.icon)('arrow-down-tray', 'w-4 h-4 mr-1.5')}
      ISDOCx
    </button>`);
        buttons.push(`<button data-einv-action="submit-accounting" id="invoice-submit-accounting-btn"
      class="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700">
      ${(0, $entK4.icon)('cloud-arrow-up', 'w-4 h-4 mr-1.5')}
      Odeslat do \xfa\u{10D}etnictv\xed
    </button>`);
        if (inv.status === 'draft') buttons.push(`<button data-status-action="issued"
        class="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700">
        Vystavit
      </button>`);
        if ([
            'issued',
            'partially_paid',
            'overdue'
        ].includes(inv.status) || inv.isOverdue) buttons.push(`<button id="mark-paid-btn"
        class="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md text-white bg-emerald-600 hover:bg-emerald-700">
        Ozna\u{10D}it jako uhrazeno
      </button>`);
        if (inv.status !== 'cancelled' && inv.status !== 'paid') buttons.push(`<button data-status-action="cancelled"
        class="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md text-red-700 border border-red-300 bg-white hover:bg-red-50">
        Stornovat
      </button>`);
        return buttons.join('');
    }
    renderEinvStatusBlock(inv, accountingConfigured) {
        const parts = [];
        if (inv.accountingExternalId) parts.push(`<div class="text-xs text-emerald-700"><strong>Odesl\xe1no do \xfa\u{10D}etnictv\xed:</strong> ${this.escape(inv.accountingExternalId)}${inv.accountingSystem ? ' (' + this.escape(inv.accountingSystem) + ')' : ''}${inv.accountingSubmittedAt ? " \xb7 " + $948c3369c316bbed$var$fmtDate(inv.accountingSubmittedAt) : ''}</div>`);
        if (inv.accountingSubmitError) parts.push(`<div class="text-xs text-red-700"><strong>Chyba odesl\xe1n\xed:</strong> ${this.escape(inv.accountingSubmitError)}</div>`);
        if (inv.isdocGeneratedAt) parts.push(`<div class="text-xs text-gray-500">ISDOCx generov\xe1n: ${$948c3369c316bbed$var$fmtDate(inv.isdocGeneratedAt)}</div>`);
        if (!accountingConfigured && !inv.accountingExternalId) parts.push(`<div class="text-xs text-amber-700">\xda\u{10D}etnictv\xed nen\xed nakonfigurov\xe1no (ACCOUNTING_* env) \u{2013} odesl\xe1n\xed nen\xed dostupn\xe9.</div>`);
        if (!parts.length) return '';
        return `
      <div class="border-t border-gray-200 px-6 py-4">
        <h3 class="text-sm font-semibold text-gray-700 mb-2">E-fakturace</h3>
        <div class="space-y-1">${parts.join('')}</div>
      </div>
    `;
    }
    async handleStatusAction(id, status) {
        let note = '';
        if (status === 'cancelled') note = prompt("D\u016Fvod storna (voliteln\xe9):") || '';
        try {
            const updated = await this.setStatus(id, status, note);
            this.notify(`Stav zm\u{11B}n\u{11B}n: ${(0, $6NozV.STATUS_META).invoice[status]?.label || status}`, 'success');
            this.renderDetail(updated);
        } catch (err) {
            this.notify(err.message, 'error');
        }
    }
    openMarkPaidPrompt(inv) {
        const total = inv.totalPriceWithVat || 0;
        const remaining = Math.max(total - (inv.paidAmount || 0), 0);
        const inputStr = prompt(`\u{10C}\xe1stka \xfahrady (K\u{10D}). Zb\xfdv\xe1 uhradit: ${remaining.toFixed(2)}
Pro plnou \xfahradu zadejte ${total.toFixed(2)}:`, String(total.toFixed(2)));
        if (inputStr === null) return;
        const amount = Number(inputStr.replace(',', '.'));
        if (!Number.isFinite(amount) || amount < 0) {
            this.notify("Neplatn\xe1 \u010D\xe1stka", 'error');
            return;
        }
        this.markPaid(inv.id, amount, null).then((updated)=>{
            this.notify("\xdahrada zaznamen\xe1na", 'success');
            this.renderDetail(updated);
        }).catch((err)=>this.notify(err.message, 'error'));
    }
    renderItemsTable(inv) {
        const items = inv.items || [];
        if (!items.length) return '';
        return `
      <div class="border-t border-gray-200 px-6 py-4">
        <h3 class="text-sm font-semibold text-gray-700 mb-3">Polo\u{17E}ky faktury</h3>
        <div class="overflow-x-auto">
          <table class="min-w-full text-sm">
            <thead class="text-xs uppercase text-gray-500 border-b border-gray-200">
              <tr>
                <th class="text-left py-2">Popis</th>
                <th class="text-right py-2">Cena</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
              ${items.map((item)=>`
                <tr>
                  <td class="py-2 text-gray-800">${this.escape(item.name || "\u2014")}</td>
                  <td class="py-2 text-right text-gray-900">${$948c3369c316bbed$var$fmtMoney(item.price || 0, inv.currency)}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
      </div>
    `;
    }
    renderStatusHistory(inv) {
        const history = inv.statusHistory || [];
        if (!history.length) return '';
        return `
      <div class="border-t border-gray-200 px-6 py-4">
        <h3 class="text-sm font-semibold text-gray-700 mb-3">Historie stav\u{16F}</h3>
        <ol class="space-y-2">
          ${history.map((h)=>{
            const meta = (0, $6NozV.STATUS_META).invoice[h.status] || {
                label: h.status,
                badge: 'bg-gray-100 text-gray-800',
                dot: 'bg-gray-400'
            };
            return `
              <li class="flex items-start gap-2 text-sm">
                <span class="mt-1 inline-block w-1.5 h-1.5 rounded-full ${meta.dot}"></span>
                <div>
                  <span class="inline-flex items-center text-xs px-2 py-0.5 rounded-full ${meta.badge}">${this.escape(meta.label)}</span>
                  <span class="ml-2 text-xs text-gray-500">${new Date(h.changedAt).toLocaleString('cs-CZ')} \xb7 ${this.escape(h.changedBy || "\u2014")}</span>
                  ${h.note ? `<div class="text-xs text-gray-600 mt-0.5">${this.escape(h.note)}</div>` : ''}
                </div>
              </li>
            `;
        }).join('')}
        </ol>
      </div>
    `;
    }
    async confirmDelete(id) {
        const inv = this.invoices.find((i)=>i.id === id);
        if (!inv) return;
        if (!confirm(`Opravdu smazat fakturu ${inv.id}? Tuto akci nelze vr\xe1tit.`)) return;
        try {
            await this.deleteInvoice(id);
            this.notify("Faktura smaz\xe1na", 'success');
            this.load();
        } catch (err) {
            this.notify(err.message, 'error');
        }
    }
    // ---------- Utils ----------
    notify(message, type = 'info') {
        if (typeof window.showNotification === 'function') window.showNotification(message, type);
        else console.log(`[${type}] ${message}`);
    }
    escape(str) {
        return (0, $6NozV.escapeHtml)(str);
    }
    /** Normalizuje customerData (string i objekt z MCP/AI nabídky) na text. */ formatCustomer(data) {
        return (0, $6NozV.customerDataText)(data);
    }
}
$948c3369c316bbed$export$3c55d5630281258f.STATUS_META = (0, $6NozV.STATUS_META).invoice;
$948c3369c316bbed$export$3c55d5630281258f.STATUS_ORDER = $948c3369c316bbed$var$INVOICE_STATUS_ORDER;
if (typeof window !== 'undefined') window.InvoicesListManager = $948c3369c316bbed$export$3c55d5630281258f;


// Modul pro správu výroby (Technologické a průvodní listy)
// - Seznam aktivních zakázek ve výrobním procesu
// - Generování a tisk Technologických listů (A4 Job Tickets)
// - Generování a tisk Průvodních listů (A4 Accompanying Sheets pro dílnu)
// - Generování a tisk DPD přepravních štítků (mockup)
// Jednotky rozsahu produktu podle typu vazby – jediný zdroj pravdy.
//
// Oborový standard:
// - Stránkované publikace (V1, V2–V8) se specifikují v POČTU STRAN (vč. obálky).
//   U V1 je násobek 4 (1 přeložený list / složka = 4 strany), u lepených násobek 2.
// - Bloky, zápisníky a kroužkové bloky/kalendáře se specifikují v POČTU LISTŮ
//   (1 list = 2 strany, líc a rub).
// - Složka (přeložený list) je výrobní pojem – zákazníkovi se nenabízí jako
//   jednotka, ale výroba ji potřebuje vidět v technických listech.
/** České skloňování podle počtu: sklon(3, ['strana', 'strany', 'stran']) → 'strany'. */ function $464a82d0a054b7a0$var$sklon(n, tvary) {
    if (n === 1) return tvary[0];
    if (n >= 2 && n <= 4) return tvary[1];
    return tvary[2];
}
function $464a82d0a054b7a0$export$2b135dbaa7f01c1a(typ) {
    return typeof typ === 'string' && typ.startsWith('krouzek');
}
function $464a82d0a054b7a0$export$f57709b683aa589(typ) {
    return typ === 'blok' || typ === 'blokPrebal';
}
function $464a82d0a054b7a0$export$98cb836883cfa442(typ) {
    return typ === 'V1-strojni' || typ === 'V1-rucni';
}
function $464a82d0a054b7a0$export$4b295968f122e918(typ) {
    if (!typ || typ === '0') return {
        unit: null,
        slovo: 'stran',
        label: "Po\u010Det stran",
        min: 4,
        step: 4,
        nasobek: null
    };
    if ($464a82d0a054b7a0$export$f57709b683aa589(typ)) return {
        unit: 'listy',
        slovo: "list\u016F",
        label: "Po\u010Det list\u016F vnit\u0159n\xedho bloku",
        min: 1,
        step: 1,
        nasobek: null
    };
    if ($464a82d0a054b7a0$export$2b135dbaa7f01c1a(typ)) return {
        unit: 'listy',
        slovo: "list\u016F",
        label: "Po\u010Det list\u016F (v\u010D. ob\xe1lkov\xfdch)",
        min: 1,
        step: 1,
        nasobek: null
    };
    if ($464a82d0a054b7a0$export$98cb836883cfa442(typ)) return {
        unit: 'strany',
        slovo: 'stran',
        label: "Po\u010Det stran (v\u010D. ob\xe1lky)",
        min: 4,
        step: 4,
        nasobek: 4
    };
    // Ostatní stránkové vazby (V2-PUR, V3, V4, V5, V6, V8, V2V8…)
    return {
        unit: 'strany',
        slovo: 'stran',
        label: "Po\u010Det stran (v\u010D. ob\xe1lky)",
        min: 4,
        step: 2,
        nasobek: 2
    };
}
function $464a82d0a054b7a0$export$b435a2b6fffcb71b(typ, hodnota, volby = {}) {
    const n = Math.max(0, Math.round(+hodnota || 0));
    if (!typ || typ === '0' || !n) return '';
    if ($464a82d0a054b7a0$export$f57709b683aa589(typ)) {
        const prebal = typ === 'blokPrebal' ? " \xb7 p\u0159ebal se po\u010D\xedt\xe1 zvl\xe1\u0161\u0165" : '';
        return `${n} identick\xfdch list\u{16F} vnit\u{159}n\xedho bloku (1 list = 2 strany)${prebal}`;
    }
    if ($464a82d0a054b7a0$export$2b135dbaa7f01c1a(typ)) {
        const strany = n * 2;
        const listuSlovo = $464a82d0a054b7a0$var$sklon(n, [
            'list',
            'listy',
            "list\u016F"
        ]);
        if (volby.jinaObalka) {
            const obalkaListu = volby.obalkaZada === false ? 1 : 2;
            const vnitrnich = Math.max(0, n - obalkaListu);
            const obalkaText = obalkaListu === 2 ? "ob\xe1lka (p\u0159edn\xed + zadn\xed list)" : "ob\xe1lka (jen p\u0159edn\xed list)";
            return `${n} ${listuSlovo} = ${obalkaText} + ${vnitrnich} vnit\u{159}n\xedch \xb7 1 list = 2 strany (a\u{17E} ${strany} stran potisku)`;
        }
        return `${n} ${listuSlovo} \xb7 1 list = 2 strany, l\xedc a rub (a\u{17E} ${strany} stran potisku)`;
    }
    if ($464a82d0a054b7a0$export$98cb836883cfa442(typ)) {
        if (n % 4 !== 0) return '';
        const slozky = n / 4;
        const stranSlovo = $464a82d0a054b7a0$var$sklon(n, [
            'strana',
            'strany',
            'stran'
        ]);
        const slozkyText = (k)=>`${k} p\u{159}elo\u{17E}en${k === 1 ? "\xfd list (slo\u017Eka)" : k < 5 ? "\xe9 listy (slo\u017Eky)" : "\xfdch list\u016F (slo\u017Eek)"}`;
        if (volby.jinaObalka && slozky >= 2) return `${n} ${stranSlovo} = ob\xe1lka (4 str.) + ${slozkyText(slozky - 1)} vnit\u{159}ku \xb7 1 p\u{159}elo\u{17E}en\xfd list (slo\u{17E}ka) = 4 strany`;
        return `${n} ${stranSlovo} = ${slozkyText(slozky)} \xb7 1 p\u{159}elo\u{17E}en\xfd list = 4 strany`;
    }
    // Stránkové vazby: obálka = 4 strany (1 přeložený list), vnitřek 1 list = 2 strany
    if (n % 2 !== 0) return '';
    const stranSlovo2 = $464a82d0a054b7a0$var$sklon(n, [
        'strana',
        'strany',
        'stran'
    ]);
    if (volby.jinaObalka && n > 4) {
        const listuVnitrku = (n - 4) / 2;
        return `${n} ${stranSlovo2} = ob\xe1lka (4 str.) + ${listuVnitrku} ${$464a82d0a054b7a0$var$sklon(listuVnitrku, [
            'list',
            'listy',
            "list\u016F"
        ])} vnit\u{159}ku \xb7 1 list = 2 strany`;
    }
    const listu2 = Math.ceil(n / 2);
    return `${n} ${stranSlovo2} = ${listu2} ${$464a82d0a054b7a0$var$sklon(listu2, [
        'list',
        'listy',
        "list\u016F"
    ])} \xb7 1 list = 2 strany`;
}
function $464a82d0a054b7a0$export$9993a9b4228961d8(typ, hodnota) {
    const meta = $464a82d0a054b7a0$export$4b295968f122e918(typ);
    const n = Math.round(+hodnota || 0);
    if (!meta.nasobek || !n || n % meta.nasobek === 0) return '';
    const dolu = Math.max(meta.min, Math.floor(n / meta.nasobek) * meta.nasobek);
    const nahoru = Math.ceil(n / meta.nasobek) * meta.nasobek;
    const duvod = meta.nasobek === 4 ? "1 p\u0159elo\u017Een\xfd list (slo\u017Eka) = 4 strany" : '1 list = 2 strany';
    return `Po\u{10D}et stran mus\xed b\xfdt n\xe1sobek ${meta.nasobek} (${duvod}). Nejbli\u{17E}\u{161}\xed platn\xe9 hodnoty: ${dolu === nahoru ? dolu : dolu + ' nebo ' + nahoru}.`;
}
function $464a82d0a054b7a0$export$35a4665e1e1472ea(vazba) {
    if (!vazba || !vazba.typ || vazba.typ === '0' || !vazba.pocetStran) return '';
    const n = vazba.pocetStran;
    if ($464a82d0a054b7a0$export$f57709b683aa589(vazba.typ)) return `${n} ${$464a82d0a054b7a0$var$sklon(n, [
        'list',
        'listy',
        "list\u016F"
    ])} vnit\u{159}n\xedho bloku`;
    if ($464a82d0a054b7a0$export$2b135dbaa7f01c1a(vazba.typ)) return `${n} ${$464a82d0a054b7a0$var$sklon(n, [
        'list',
        'listy',
        "list\u016F"
    ])} = a\u{17E} ${n * 2} stran potisku`;
    if ($464a82d0a054b7a0$export$98cb836883cfa442(vazba.typ)) {
        const slozek = Math.ceil(n / 4);
        return `${n} ${$464a82d0a054b7a0$var$sklon(n, [
            'strana',
            'strany',
            'stran'
        ])} = ${slozek} ${$464a82d0a054b7a0$var$sklon(slozek, [
            "slo\u017Eka",
            "slo\u017Eky",
            "slo\u017Eek"
        ])} (p\u{159}elo\u{17E}en\xe9 listy)`;
    }
    const listuR = Math.ceil(n / 2);
    return `${n} ${$464a82d0a054b7a0$var$sklon(n, [
        'strana',
        'strany',
        'stran'
    ])} = ${listuR} ${$464a82d0a054b7a0$var$sklon(listuR, [
        'list',
        'listy',
        "list\u016F"
    ])}`;
}



var $entK4 = parcelRequire("entK4");

var $6NozV = parcelRequire("6NozV");
// Výrobní pohled sdílí stavový model objednávek, jen s terminologií dílny.
const $48533a8b43f55ecf$var$STATUS_META = (0, $6NozV.STATUS_META).vyroba;
const $48533a8b43f55ecf$var$VYROBA_STATUS_ORDER = [
    'received',
    'in_progress',
    'done',
    'to_invoice',
    'invoiced',
    'delivered',
    'cancelled'
];

class $48533a8b43f55ecf$export$ddd6263a5ec85a3d {
    constructor(){
        this.orders = [];
        this.loading = false;
        this.view = new (0, $6NozV.ListView)({
            key: 'vyroba',
            title: "\u0158\xedzen\xed v\xfdroby",
            subtitle: "Technologick\xe9 a pr\u016Fvodn\xed listy zak\xe1zek pro ofsetov\xfd a digit\xe1ln\xed tisk.",
            searchPlaceholder: "Hledat (\u010D\xedslo, firma, polo\u017Eka)\u2026",
            statusKind: 'vyroba',
            statuses: $48533a8b43f55ecf$var$VYROBA_STATUS_ORDER,
            authorLabels: {
                me: "Moje zak\xe1zky"
            },
            enableCustomerFilter: true,
            enableKanban: true,
            onChange: ()=>this.load()
        });
    }
    // ---------- API ----------
    async fetchOrders(params) {
        this.loading = true;
        const qs = params && params.toString() ? `?${params}` : '';
        const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/orders${qs}`, {
            credentials: 'include'
        });
        if (!res.ok) {
            this.loading = false;
            throw new Error("Nepoda\u0159ilo se na\u010D\xedst zak\xe1zky pro v\xfdrobu");
        }
        const json = await res.json();
        this.loading = false;
        return json;
    }
    async getOrder(id) {
        const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/orders/${id}`, {
            credentials: 'include'
        });
        if (!res.ok) throw new Error("Nepoda\u0159ilo se na\u010D\xedst detaily zak\xe1zky");
        const json = await res.json();
        return json.data;
    }
    async setOrderStatus(id, status, note = '') {
        const res = await fetch(`${(0, $6NozV.API_BASE_URL)}/orders/${id}/status`, {
            method: 'PATCH',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                status: status,
                note: note
            })
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json.error || "Nepoda\u0159ilo se zm\u011Bnit stav zak\xe1zky");
        return json.data;
    }
    // ---------- Renderování sekce ----------
    async showSection() {
        await this.load();
    }
    async load() {
        const container = document.getElementById('vyroba-section-content');
        if (!container) return;
        if (!document.getElementById('vyroba-list')) {
            this.view.renderShell(container);
            this._bindListEvents();
        } else this.view.renderLoading();
        try {
            if (this.view.viewMode === 'kanban') {
                await this.loadKanban();
                return;
            }
            const result = await this.fetchOrders(this.view.buildParams());
            this.orders = result.data || [];
            if (Array.isArray(result.statuses) && result.statuses.length) this.view.statuses = result.statuses;
            if (Array.isArray(result.authors)) this.view.authors = result.authors;
            this.view.renderResults({
                rowsHtml: this.orders.map((o)=>this.renderOrderCard(o)),
                total: result.total,
                emptyState: {
                    title: "\u017D\xe1dn\xe9 zak\xe1zky ve v\xfdrob\u011B",
                    hint: "Zak\xe1zky vznikaj\xed p\u0159evodem schv\xe1len\xe9 nab\xeddky na objedn\xe1vku."
                }
            });
        } catch (err) {
            console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed v\xfdroby:", err);
            this.view.renderCustom((0, $6NozV.renderErrorState)(err.message || "Nepoda\u0159ilo se na\u010D\xedst zak\xe1zky", 'window.vyrobaManager.load()'));
        }
    }
    async loadKanban() {
        const { renderKanbanBoard: renderKanbanBoard } = await (parcelRequire("l8N1u"));
        await renderKanbanBoard({
            view: this.view,
            statusKind: 'vyroba',
            fetchColumn: async (status)=>{
                const params = this.view.buildParams({
                    paginate: false
                });
                params.set('status', status);
                params.set('limit', '30');
                params.set('sort', 'kanban');
                const result = await this.fetchOrders(params);
                return {
                    items: result.data || [],
                    total: result.total || 0
                };
            },
            cardData: (o)=>({
                    id: o.id,
                    title: `#${o.id}`,
                    customerName: (0, $6NozV.customerNameOf)(o),
                    meta: (0, $6NozV.formatDateTime)(o.createdAt),
                    price: this.renderTechBadges(o.items),
                    badges: [],
                    orderKey: typeof o.kanbanOrder === 'number' ? o.kanbanOrder : Date.parse(o.createdAt)
                }),
            onOpen: (id)=>this.openDetail(id),
            onDrop: async (id, { status: status, statusChanged: statusChanged, orderKey: orderKey })=>{
                if (statusChanged) await this.setOrderStatus(id, status, "Zm\u011Bna stavu p\u0159eta\u017Een\xedm v kanbanu v\xfdroby");
                // Pořadí sdílí s objednávkami (stejná entita) – uloží ordersListManager helper
                if (window.ordersListManager) await window.ordersListManager.saveKanbanOrder(id, orderKey);
            }
        });
    }
    // Tichý refresh (auto-refresh / realtime push): obnoví jen seznam zakázek.
    // Pokud je otevřený detail zakázky, nic nedělá, aby uživateli nezmizel kontext.
    async refresh() {
        const container = document.getElementById('vyroba-section-content');
        if (!container || !document.getElementById('vyroba-list')) return;
        try {
            await this.load();
        } catch (_) {
        // tichý refresh – chybu neukazujeme, další pokus proběhne v dalším intervalu
        }
    }
    renderError(message) {
        const container = document.getElementById('vyroba-section-content');
        if (!container) return;
        container.innerHTML = (0, $6NozV.renderErrorState)(message, 'window.vyrobaManager.load()');
    }
    /** Badge technologií položek (OFSET/DIGI) – z list projekce (item.technologie). */ renderTechBadges(items) {
        const badge = (tech)=>tech === 'ofset' ? '<span class="px-1.5 py-0.5 rounded text-[10px] font-bold bg-amber-50 text-amber-700 border border-amber-200/50">OFSET</span>' : tech === 'digital' ? '<span class="px-1.5 py-0.5 rounded text-[10px] font-bold bg-blue-50 text-blue-700 border border-blue-200/50">DIGI</span>' : '<span class="px-1.5 py-0.5 rounded text-[10px] font-bold bg-gray-50 text-gray-700 border border-gray-200/50">AUTO</span>';
        const techs = (items || []).map((it)=>it.technologie || it.calculationResult && it.calculationResult.tiskTechnologie || 'auto');
        return techs.map(badge).join(' ');
    }
    renderOrderCard(o) {
        const items = o.items || [];
        const itemsDesc = items.map((it)=>`
      <span class="inline-flex items-center gap-1 mr-2">
        <span class="font-medium text-gray-700">${(0, $6NozV.escapeHtml)(it.name)}</span>
        ${this.renderTechBadges([
                it
            ])}
      </span>
    `).join('');
        return (0, $6NozV.renderListCard)({
            id: o.id,
            title: `Zak\xe1zka <span class="font-semibold">#${(0, $6NozV.escapeHtml)(o.id)}</span>`,
            status: {
                kind: 'vyroba',
                value: o.status || 'received'
            },
            customerName: (0, $6NozV.customerNameOf)(o),
            metaLine: `
        <span class="inline-flex items-center">${(0, $entK4.icon)('calendar', 'w-3.5 h-3.5 mr-1 text-gray-400')}${(0, $6NozV.formatDateTime)(o.createdAt)}</span>
        <span>\xb7</span><span>${o.offerId ? `z nab\xeddky #${(0, $6NozV.escapeHtml)(o.offerId)}` : "p\u0159\xedm\xe1 zak\xe1zka"}</span>
        ${o.createdByName ? `<span>\xb7</span><span>${(0, $6NozV.escapeHtml)(o.createdByName)}</span>` : ''}
      `,
            description: itemsDesc,
            price: '',
            compact: this.view.compact,
            actions: [
                {
                    action: 'open',
                    icon: 'clipboard-check',
                    label: "Otev\u0159\xedt technologick\xfd list",
                    tone: 'primary'
                }
            ]
        });
    }
    _bindListEvents() {
        const list = this.view.listContainer;
        if (!list) return;
        list.addEventListener('click', (e)=>{
            const actionBtn = e.target.closest('[data-action]');
            if (actionBtn) {
                e.stopPropagation();
                if (actionBtn.dataset.action === 'open') this.openDetail(actionBtn.dataset.id);
                return;
            }
            const row = e.target.closest('[data-row-id]');
            if (row && !e.target.closest('button, a')) this.openDetail(row.dataset.rowId);
        });
    }
    // ---------- Detail zakázky (Technologická karta) ----------
    async openDetail(id) {
        const container = document.getElementById('vyroba-section-content');
        if (!container) return;
        // Detail se kreslí přes celou sekci – skořápka seznamu se obnoví při návratu.
        container.innerHTML = `
      <div class="flex justify-center p-8 text-gray-400">
        ${(0, $entK4.icon)('spinner', 'w-8 h-8 animate-spin')}
      </div>
    `;
        try {
            const order = await this.getOrder(id);
            this.currentOrder = order;
            this.renderDetail(order);
        } catch (err) {
            this.renderError(err.message);
        }
    }
    /**
   * Vytáhne HTML schéma vyřazení (rozkres tiskových desek) z debugInfo položky.
   * debugInfo je uložené přímo na položce; rozkres je obalen <div data-rozkres-desek>
   * a sahá až na konec řetězce (generuje backend/calc/calc-output.js).
   */ layoutHtmlFor(it) {
        const src = it && it.debugInfo || it && it.calculationResult && it.calculationResult.debugInfo || '';
        const idx = src.indexOf('<div data-rozkres-desek');
        return idx >= 0 ? src.slice(idx) : '';
    }
    /** Bezpečné řádky adresy (customerData může být string i objekt). */ customerLines(o) {
        return (0, $6NozV.customerDataText)(o.customerData).split('\n');
    }
    renderDetail(o) {
        const container = document.getElementById('vyroba-section-content');
        if (!container) return;
        const meta = $48533a8b43f55ecf$var$STATUS_META[o.status] || {
            label: o.status,
            badge: 'bg-gray-100 text-gray-800',
            dot: 'bg-gray-400'
        };
        const created = new Date(o.createdAt).toLocaleString('cs-CZ');
        const customerText = (0, $6NozV.customerDataText)(o.customerData);
        const customerLines = this.customerLines(o);
        // Logistika z formData první položky (doprava/zabalení jsou per zakázka)
        const fd0 = o.items && o.items[0] && o.items[0].formData || {};
        container.innerHTML = `
      <div class="space-y-6">
        <!-- Ovl\xe1dac\xed li\u{161}ta -->
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 border-b border-gray-200 pb-4">
          <div class="flex items-center gap-3">
            <button id="vyroba-back-btn" class="btn btn-secondary btn-sm inline-flex items-center">
              <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
              </svg>
              Zp\u{11B}t na zak\xe1zky
            </button>
            <h3 class="text-xl font-bold text-gray-900">Zak\xe1zka #${this.escape(o.id)}</h3>
          </div>
          <div class="flex items-center gap-2.5 flex-wrap">
            <span class="inline-flex items-center text-sm font-semibold px-3 py-1 rounded-full ${meta.badge}">
              <span class="w-1.5 h-1.5 rounded-full mr-2 ${meta.dot}"></span>${meta.label}
            </span>
            <select id="vyroba-detail-status" class="px-3 py-1.5 border border-gray-300 rounded-md text-sm bg-white focus:ring-blue-500 focus:border-blue-500">
              <option value="received" ${o.status === 'received' ? 'selected' : ''}>P\u{159}ijato / P\u{159}\xedprava</option>
              <option value="in_progress" ${o.status === 'in_progress' ? 'selected' : ''}>Ve v\xfdrob\u{11B}</option>
              <option value="done" ${o.status === 'done' ? 'selected' : ''}>Hotovo (k expedici)</option>
              <option value="delivered" ${o.status === 'delivered' ? 'selected' : ''}>Odesl\xe1no / P\u{159}ed\xe1no</option>
              <option value="cancelled" ${o.status === 'cancelled' ? 'selected' : ''}>Zru\u{161}eno</option>
            </select>
            <button id="vyroba-print-tech-list" class="btn btn-primary btn-sm inline-flex items-center gap-1.5">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"></path>
              </svg>
              Tisk tech. listu (A4)
            </button>
          </div>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <!-- Lev\xfd sloupec: Informace o zak\xe1zce, adresy, DPD -->
          <div class="space-y-6 lg:col-span-1">
            <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-5 space-y-4">
              <h4 class="text-sm font-semibold text-gray-800 uppercase tracking-wider border-b border-gray-100 pb-2">P\u{159}ehled zak\xe1zky</h4>
              <div class="text-sm space-y-2">
                <div class="flex justify-between"><span class="text-gray-500">Z\xe1kazn\xedk:</span><span class="font-medium text-gray-900">${this.escape(customerLines[0] || "\u2014")}</span></div>
                <div class="flex justify-between"><span class="text-gray-500">Vytvo\u{159}eno:</span><span class="text-gray-900">${created}</span></div>
                <div class="flex justify-between"><span class="text-gray-500">Vystavil:</span><span class="text-gray-900">${this.escape(o.createdByName || o.createdBy || 'system')}</span></div>
                <div class="flex justify-between"><span class="text-gray-500">Z nab\xeddky:</span><span class="text-gray-900">${o.offerId ? `#${this.escape(o.offerId)}` : "p\u0159\xedm\xe1 zak\xe1zka"}</span></div>
                ${o.reprintOfId ? `<div class="flex justify-between"><span class="text-gray-500">Reprint zak\xe1zky:</span><span class="text-gray-900">#${this.escape(o.reprintOfId)}</span></div>` : ''}
                <div class="flex justify-between"><span class="text-gray-500">Po\u{10D}et polo\u{17E}ek:</span><span class="font-bold text-gray-900">${(o.items || []).length}</span></div>
                ${o.invoicedAsId ? `<div class="flex justify-between"><span class="text-gray-500">Faktura:</span><span class="text-gray-900">${this.escape(o.invoicedAsId)}</span></div>` : ''}
              </div>
              ${o.note ? `
                <div class="border-t border-amber-100 pt-3">
                  <div class="text-xs font-bold text-amber-700 uppercase tracking-wide mb-1">\u{1F4DD} Pozn\xe1mka k zak\xe1zce</div>
                  <p class="text-sm text-gray-800 bg-amber-50 border border-amber-100 rounded-md p-2.5 whitespace-pre-wrap">${this.escape(o.note)}</p>
                </div>
              ` : ''}
            </div>

            <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-5 space-y-4">
              <h4 class="text-sm font-semibold text-gray-800 uppercase tracking-wider border-b border-gray-100 pb-2">Dod\xe1n\xed a logistika</h4>
              <div class="text-sm space-y-2">
                <div class="flex justify-between"><span class="text-gray-500">Doprava:</span><span class="text-gray-900">${fd0.doprava && fd0.doprava !== '0' ? "Kur\xfdrn\xed slu\u017Eba" : "Osobn\xed odb\u011Br / neur\u010Deno"}</span></div>
                <div class="flex justify-between"><span class="text-gray-500">Zabalen\xed:</span><span class="text-gray-900">${fd0.zabaleni && fd0.zabaleni !== '0' ? 'Ano' : "Standardn\xed"}</span></div>
                ${fd0.dodat ? `<div class="flex justify-between"><span class="text-gray-500">Dodat:</span><span class="text-gray-900">${this.escape(fd0.dodat)}</span></div>` : ''}
              </div>
              <pre class="text-sm text-gray-700 font-sans whitespace-pre-wrap leading-relaxed bg-gray-50/50 p-3 rounded-md border border-gray-100">${this.escape(fd0.adresa || customerText || "\u017D\xe1dn\xe9 dopl\u0148uj\xedc\xed adresn\xed \xfadaje")}</pre>
            </div>

            <!-- DPD Expedi\u{10D}n\xed l\xedstek -->
            <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-5 space-y-4">
              <div class="flex justify-between items-center border-b border-gray-100 pb-2">
                <h4 class="text-sm font-semibold text-gray-800 uppercase tracking-wider">DPD P\u{159}epravn\xed \u{161}t\xedtek</h4>
                <span class="px-2 py-0.5 text-[9px] bg-red-100 text-red-700 font-bold rounded border border-red-200">EXPRES</span>
              </div>
              <p class="text-xs text-gray-500">Vygenerovan\xfd p\u{159}epravn\xed \u{161}t\xedtek pro kur\xfdra DPD k nalepen\xed na krabici.</p>
              
              <div class="border border-gray-300 rounded p-4 bg-gray-50 flex flex-col items-center">
                <!-- DPD logo -->
                <div class="flex justify-between items-center w-full mb-3">
                  <span class="font-extrabold text-lg text-red-600 leading-none">dpd</span>
                  <span class="text-[9px] font-bold text-gray-500 uppercase tracking-wide">Classic Service</span>
                </div>
                
                <!-- Adresa v labelu -->
                <div class="w-full text-[10px] text-gray-700 font-medium space-y-1 mb-3">
                  <div class="border-b border-gray-200 pb-1 font-bold">P\u{159}\xedjemce:</div>
                  <div class="truncate font-bold">${this.escape(customerLines[0] || "Nezn\xe1m\xfd")}</div>
                  <div class="truncate">${this.escape(customerLines[1] || '')}</div>
                  <div class="truncate">${this.escape(customerLines[2] || '')}</div>
                </div>

                <!-- Fake \u{10D}\xe1rov\xfd k\xf3d pomoc\xed div\u{16F} -->
                <div class="flex items-end justify-center h-12 w-full bg-white border border-gray-200 p-1 mb-1">
                  <!-- Generujeme n\xe1hodn\xe9 \u{161}\xed\u{159}ky \u{10D}\xe1rek -->
                  <div class="w-0.5 h-full bg-black mx-[1px]"></div>
                  <div class="w-1.5 h-full bg-black mx-[1px]"></div>
                  <div class="w-0.5 h-full bg-black mx-[1px]"></div>
                  <div class="w-1 h-full bg-black mx-[1px]"></div>
                  <div class="w-0.5 h-full bg-black mx-[1px]"></div>
                  <div class="w-2 h-full bg-black mx-[1px]"></div>
                  <div class="w-0.5 h-full bg-black mx-[1px]"></div>
                  <div class="w-1 h-full bg-black mx-[1px]"></div>
                  <div class="w-1.5 h-full bg-black mx-[1px]"></div>
                  <div class="w-0.5 h-full bg-black mx-[1px]"></div>
                  <div class="w-1.5 h-full bg-black mx-[1px]"></div>
                  <div class="w-1 h-full bg-black mx-[1px]"></div>
                  <div class="w-0.5 h-full bg-black mx-[1px]"></div>
                  <div class="w-2 h-full bg-black mx-[1px]"></div>
                  <div class="w-1 h-full bg-black mx-[1px]"></div>
                  <div class="w-0.5 h-full bg-black mx-[1px]"></div>
                </div>
                <div class="text-[9px] font-mono tracking-widest text-gray-600 mb-4">DPD-9471-${o.id}</div>

                <button id="vyroba-print-dpd" class="btn btn-secondary btn-sm w-full inline-flex items-center justify-center gap-1.5 bg-white">
                  <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"></path>
                  </svg>
                  Vytisknout \u{161}t\xedtek (10x15)
                </button>
              </div>
            </div>
          </div>

          <!-- Prav\xfd sloupec: Seznam polo\u{17E}ek a jejich technologick\xe9 karty s rozkresy vy\u{159}azen\xed -->
          <div class="lg:col-span-2 space-y-6">
            <h4 class="text-lg font-bold text-gray-800 tracking-tight flex items-center justify-between">
              <span>Technologick\xe9 karty polo\u{17E}ek</span>
              <span class="text-xs font-normal text-gray-500">Celkem ${(o.items || []).length} polo\u{17E}ek</span>
            </h4>

            ${(o.items || []).map((it, idx)=>this.renderItemTechCard(it, idx, o)).join('')}
          </div>
        </div>
      </div>
    `;
        // Eventy
        document.getElementById('vyroba-back-btn')?.addEventListener('click', ()=>this.load());
        document.getElementById('vyroba-print-tech-list')?.addEventListener('click', ()=>this.printTechnicalList(o));
        document.getElementById('vyroba-print-dpd')?.addEventListener('click', ()=>this.printDpdLabel(o));
        // Změna stavu zakázky
        document.getElementById('vyroba-detail-status')?.addEventListener('change', async (e)=>{
            const newStatus = e.target.value;
            try {
                const updated = await this.setOrderStatus(o.id, newStatus, "Zm\u011Bna stavu v modulu V\xfdroba");
                showNotification(`Stav zak\xe1zky byl \xfasp\u{11B}\u{161}n\u{11B} zm\u{11B}n\u{11B}n na "${$48533a8b43f55ecf$var$STATUS_META[newStatus]?.label || newStatus}"`, 'success');
                this.renderDetail(updated);
                // Synchronizovat s orders listem pokud existuje
                if (window.ordersListManager) window.ordersListManager.fetchOrders();
            } catch (err) {
                showNotification(err.message, 'error');
                e.target.value = o.status; // vrátit zpět
            }
        });
    }
    // HTML rozpis motivů (jména + počty kusů) pro tech kartu a tiskové listy.
    renderMotivyTable(motivy, compact = false) {
        if (!Array.isArray(motivy) || motivy.length < 2) return '';
        const celkem = motivy.reduce((a, m)=>a + (+m.pocetKusu || 0), 0);
        const rows = motivy.map((m, i)=>`
      <tr>
        <td style="padding:3px 10px 3px 0; color:#64748b;">${i + 1}.</td>
        <td style="padding:3px 10px 3px 0; font-weight:600;">${this.escape(m.nazev || 'Motiv ' + (i + 1))}</td>
        <td style="padding:3px 0; text-align:right; font-weight:700;">${m.pocetKusu} ks</td>
      </tr>`).join('');
        return `
      <div style="${compact ? 'margin-top:8px;' : 'margin-top:12px;'}">
        <div style="font-weight:800; font-size:${compact ? '11px' : '12px'}; text-transform:uppercase; color:#334155; margin-bottom:4px;">Motivy (${motivy.length})</div>
        <table style="font-size:${compact ? '12px' : '13px'}; border-collapse:collapse;">
          ${rows}
          <tr><td></td><td style="padding:4px 10px 0 0; border-top:1px solid #cbd5e1; color:#64748b;">celkem</td><td style="padding:4px 0 0; border-top:1px solid #cbd5e1; text-align:right; font-weight:800;">${celkem} ks</td></tr>
        </table>
      </div>`;
    }
    renderItemTechCard(it, idx, order) {
        const r = it.calculationResult || {};
        const tech = r.tiskTechnologie || 'auto';
        const hasVazba = r.vazba && r.vazba.typ !== '0' && r.vazba.nazev;
        const hasJinaObalka = hasVazba && r.vazba.jinaObalka && r.vazba.vnitrniBlok && !r.vazba.obalkaSloucena;
        let techDetailsHtml = '';
        if (hasJinaObalka && r.vazba.obalka && r.vazba.blok) techDetailsHtml = `
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mt-4">
          <!-- Ob\xe1lka -->
          <div class="bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-3">
            <div class="flex justify-between items-center border-b border-gray-200 pb-1.5">
              <span class="font-bold text-xs text-gray-800 uppercase tracking-wide">\u{1F4D8} Ob\xe1lka</span>
              <span class="px-2 py-0.5 text-[9px] font-bold bg-blue-50 text-blue-700 rounded border border-blue-200/50">${r.vazba.obalka.tiskTechnologie.toUpperCase()}</span>
            </div>
            <div class="text-xs text-gray-600 space-y-1.5">
              <div><span class="text-gray-400">Gram\xe1\u{17E} a pap\xedr:</span> <strong class="text-gray-800">${this.escape(r.vazba.obalka.material?.nazev || "\u2014")} (${r.vazba.obalka.material?.gramaz || "\u2014"}g)</strong></div>
              <div><span class="text-gray-400">Barevnost:</span> <strong class="text-gray-800">${this.escape(r.vazba.obalka.barevnost || "\u2014")}</strong></div>
              <div><span class="text-gray-400">Laminace:</span> <strong class="text-gray-800">${r.vazba.obalka.laminace && r.vazba.obalka.laminace !== '0' ? 'ANO' : 'NE'}</strong></div>
              <div><span class="text-gray-400">Po\u{10D}et arch\u{16F} k potisku:</span> <strong class="text-gray-800">${r.vazba.obalka.pocetArchu || 0} ks</strong></div>
              <div><span class="text-gray-400">Vy\u{159}azen\xed na archu:</span> <strong class="text-indigo-700">${r.vazba.obalka.comp?.count || 0}x na arch</strong></div>
              <div><span class="text-gray-400">Tiskov\xe9 desky (ofset):</span> <strong class="text-amber-700">${r.vazba.obalka.comp ? r.vazba.obalka.comp.plates ? r.vazba.obalka.comp.plates.length : r.vazba.obalka.comp.numberOfDifferentSheets + (r.vazba.obalka.comp.rewind ? 1 : 0) : 0} sad</strong></div>
            </div>
          </div>

          <!-- Vnit\u{159}n\xed blok -->
          <div class="bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-3">
            <div class="flex justify-between items-center border-b border-gray-200 pb-1.5">
              <span class="font-bold text-xs text-gray-800 uppercase tracking-wide">\u{1F4D6} Vnit\u{159}n\xed blok</span>
              <span class="px-2 py-0.5 text-[9px] font-bold bg-amber-50 text-amber-700 rounded border border-amber-200/50">${r.vazba.blok.tiskTechnologie.toUpperCase()}</span>
            </div>
            <div class="text-xs text-gray-600 space-y-1.5">
              <div><span class="text-gray-400">Gram\xe1\u{17E} a pap\xedr:</span> <strong class="text-gray-800">${this.escape(r.vazba.blok.material?.nazev || "\u2014")} (${r.vazba.blok.material?.gramaz || "\u2014"}g)</strong></div>
              <div><span class="text-gray-400">Barevnost:</span> <strong class="text-gray-800">${this.escape(r.vazba.blok.barevnost || "\u2014")}</strong></div>
              <div><span class="text-gray-400">Laminace:</span> <strong class="text-gray-800">${r.vazba.blok.laminace && r.vazba.blok.laminace !== '0' ? 'ANO' : 'NE'}</strong></div>
              <div><span class="text-gray-400">Po\u{10D}et arch\u{16F} k potisku:</span> <strong class="text-gray-800">${r.vazba.blok.pocetArchu || 0} ks</strong></div>
              <div><span class="text-gray-400">Vy\u{159}azen\xed na archu:</span> <strong class="text-indigo-700">${r.vazba.blok.comp?.count || 0}x na arch</strong></div>
              <div><span class="text-gray-400">Tiskov\xe9 desky (ofset):</span> <strong class="text-amber-700">${r.vazba.blok.comp ? r.vazba.blok.comp.plates ? r.vazba.blok.comp.plates.length : r.vazba.blok.comp.numberOfDifferentSheets + (r.vazba.blok.comp.rewind ? 1 : 0) : 0} sad</strong></div>
            </div>
          </div>
        </div>
      `;
        else {
            // Jednodílná zakázka (volné listy nebo sloučená obálka).
            // Primárně strukturovaný výsledek kalkulace (r), fallback formData –
            // starší zakázky calculationResult uložený nemají.
            const fd = it.formData || {};
            const deskyPocet = r.comp ? r.comp.plates ? r.comp.plates.length : r.comp.numberOfDifferentSheets + (r.comp.rewind ? 1 : 0) + (r.comp.restSheets > 0 ? 1 : 0) : null;
            const naklad = r.pocetKusu || Number(fd.pocetKusu) || 0;
            const rozmer = `${fd.produktRozmerSirka || fd.rozmerSirka || "\u2014"}\xd7${fd.produktRozmerVyska || fd.rozmerVyska || "\u2014"} mm`;
            const format = fd.produktRozmerFormat && fd.produktRozmerFormat !== 'vlastni' ? ` (${this.escape(fd.produktRozmerFormat)})` : '';
            const barevnost = fd.pocetBarev || fd.barevnost || "\u2014";
            const papir = fd.materialName || fd.material || "\u2014";
            techDetailsHtml = `
        <div class="bg-gray-50 border border-gray-200 rounded-lg p-4 mt-4 space-y-2.5 text-xs text-gray-600 max-w-full">
          <div class="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-2">
            <div><span class="text-gray-400">Pap\xedr:</span> <strong class="text-gray-800">${this.escape(papir)}</strong></div>
            <div><span class="text-gray-400">Form\xe1t produktu:</span> <strong class="text-gray-800">${rozmer}${format}</strong></div>
            <div><span class="text-gray-400">Barevnost:</span> <strong class="text-gray-800">${this.escape(barevnost)}</strong></div>
            <div><span class="text-gray-400">Vy\u{159}azen\xed na archu:</span> <strong class="text-indigo-700">${r.comp?.count ? `${r.comp.count}x ${r.orientace || "na v\xfd\u0161ku"}` : "\u2014"}</strong></div>
            <div><span class="text-gray-400">Spot\u{159}eba arch\u{16F}:</span> <strong class="text-gray-800">${r.pocetArchu ? `${r.pocetArchu} ks ${r.tiskFormat || 'SRA3'}` : "\u2014"}</strong></div>
            <div><span class="text-gray-400">Technologie:</span> <strong class="text-gray-800 uppercase">${tech === 'digital' ? "Digit\xe1ln\xed tisk" : tech === 'ofset' ? "Ofsetov\xfd tisk" : 'Auto (dle kalkulace)'}</strong></div>
            ${tech === 'ofset' && deskyPocet != null ? `<div><span class="text-gray-400">Tiskov\xe9 desky:</span> <strong class="text-amber-700">${deskyPocet} sad desek</strong></div>` : ''}
            <div><span class="text-gray-400">Po\u{10D}et druh\u{16F}:</span> <strong class="text-gray-800">${r.pocetDruhu || fd.pocetDruhu || 1} druh(\u{16F})</strong></div>
            <div><span class="text-gray-400">Celkov\xfd n\xe1klad:</span> <strong class="text-gray-800 font-bold">${naklad.toLocaleString('cs-CZ')} ks</strong></div>
            ${fd.primeBarvy && fd.primeBarvy !== '0' ? `<div><span class="text-gray-400">P\u{159}\xedm\xe9 barvy:</span> <strong class="text-gray-800">${this.escape(fd.primeBarvy)}</strong></div>` : ''}
            ${fd.dtp && fd.dtp !== '0' ? `<div><span class="text-gray-400">DTP / grafika:</span> <strong class="text-gray-800">Ano</strong></div>` : ''}
            ${fd.typCeny ? `<div><span class="text-gray-400">Cenov\xe1 \xfarove\u{148}:</span> <strong class="text-gray-800">${fd.typCeny === 'malo' ? 'maloobchod' : 'velkoobchod'}</strong></div>` : ''}
          </div>
          ${r.vazba?.obalkaSloucena ? `
            <div class="border-t border-emerald-100 pt-2 text-[10px] text-emerald-700 font-semibold flex items-center gap-1">
              <span>\u{2139}\u{FE0F} Ob\xe1lka i vnit\u{159}ek jsou identick\xe9 a byly slou\u{10D}eny do jednoho vy\u{159}azen\xed (tisk z jedn\xe9 formy).</span>
            </div>
          ` : ''}
        </div>
      `;
        }
        // Knihařská dokončení
        const finishingOperations = [];
        if (it.formData?.laminace && it.formData.laminace !== '0') finishingOperations.push(`Laminace (k\xf3d: ${it.formData.laminace})`);
        if (it.formData?.lakovani && it.formData.lakovani !== '0') finishingOperations.push(`Lakov\xe1n\xed (k\xf3d: ${it.formData.lakovani})`);
        if (it.formData?.falcovani && it.formData.falcovani !== '0') finishingOperations.push(`Falcov\xe1n\xed (lomy: ${it.formData.falcovani})`);
        if (it.formData?.bigovani && it.formData.bigovani !== '0') finishingOperations.push(`Bigov\xe1n\xed (b\xedg\u{16F}: ${it.formData.bigovani})`);
        if (it.formData?.vysek && it.formData.vysek !== '0') finishingOperations.push(`V\xfdsek (raznice${it.formData.pozicNaVysek ? `, pozic: ${it.formData.pozicNaVysek}` : ''})`);
        if (it.formData?.predsek && it.formData.predsek !== '0') finishingOperations.push(`P\u{159}edsek${it.formData.pozicNaPredsek ? ` (pozic: ${it.formData.pozicNaPredsek})` : ''}`);
        if (it.formData?.razba && it.formData.razba !== '0') finishingOperations.push(`Ra\u{17E}ba${it.formData.pozicNaRazbu ? ` (pozic: ${it.formData.pozicNaRazbu})` : ''}`);
        if (it.formData?.vrtani && it.formData.vrtani !== '0') finishingOperations.push(`Vrt\xe1n\xed (otvor\u{16F}: ${it.formData.vrtani})`);
        if (it.formData?.perforace && it.formData.perforace !== '0') finishingOperations.push(`Perforace`);
        if (it.formData?.lepeni && it.formData.lepeni !== '0') finishingOperations.push(`Lepen\xed${it.formData.lepeniPocet ? ` (${it.formData.lepeniPocet}\xd7)` : ''}`);
        if (it.formData?.personalizace && it.formData.personalizace !== '0') finishingOperations.push(`Personalizace${it.formData.personalizacePocet ? ` (${it.formData.personalizacePocet} z\xe1znam\u{16F})` : ''}`);
        if (it.formData?.vazba && it.formData.vazba !== '0') finishingOperations.push(`Vazba: ${r.vazba?.nazev || 'ANO'}${r.vazba?.barvaSpiralyText ? ` \u{2013} spir\xe1la ${r.vazba.barvaSpiralyText}` : ''}`);
        if (r.vazba?.cenaPodlozka > 0) finishingOperations.push(`Podlo\u{17E}ka: ${r.vazba.materialPodlozka || "\u0161ed\xe1 lepenka"}`);
        const finishingHtml = finishingOperations.length > 0 ? `
        <div class="mt-4">
          <div class="text-xs font-bold text-gray-700 mb-1.5 uppercase tracking-wide">\u{1F527} Kniha\u{159}sk\xe9 dokon\u{10D}ovac\xed operace:</div>
          <div class="flex flex-wrap gap-2">
            ${finishingOperations.map((op)=>`<span class="px-2.5 py-1 text-xs bg-indigo-50 border border-indigo-100 text-indigo-700 rounded-md font-semibold">${op}</span>`).join('')}
          </div>
        </div>
      ` : '';
        // Schéma vyřazení tiskových desek – HTML render z kalkulačního debugInfo
        // (uloženo přímo na položce, wrapper <div data-rozkres-desek>).
        const layoutVisualHtml = this.layoutHtmlFor(it);
        return `
      <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 space-y-4">
        <div class="flex justify-between items-start border-b border-gray-100 pb-3 flex-wrap gap-2">
          <div>
            <h5 class="text-md font-bold text-gray-900">${idx + 1}. ${this.escape(it.name)}</h5>
            <p class="text-xs text-gray-500 mt-1">Polo\u{17E}ka zak\xe1zky #${this.escape(order.id)}</p>
          </div>
          <div class="flex items-center gap-2">
            <button onclick="window.vyrobaManager.printAccompanyingSheet('${order.id}', ${idx})" class="btn btn-secondary btn-xs py-1 px-2.5 text-xs text-indigo-700 bg-indigo-50 border-indigo-100 hover:bg-indigo-100 inline-flex items-center gap-1">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"></path>
              </svg>
              Tisk pr\u{16F}vodky (A4)
            </button>
          </div>
        </div>

        ${techDetailsHtml}
        ${(0, $464a82d0a054b7a0$export$35a4665e1e1472ea)(r.vazba) ? `
          <div class="text-xs text-gray-600 mt-3"><span class="font-bold text-gray-700 uppercase tracking-wide">\u{1F4D0} Rozsah:</span> <strong class="text-gray-800">${(0, $464a82d0a054b7a0$export$35a4665e1e1472ea)(r.vazba)}</strong></div>
        ` : ''}
        ${this.renderMotivyTable(r.motivy)}
        ${finishingHtml}

        <!-- Vizualizace vy\u{159}azen\xed -->
        ${layoutVisualHtml ? `
          <div class="border-t border-gray-100 pt-4 max-w-full overflow-hidden">
            <div class="text-xs font-bold text-gray-700 mb-2 uppercase tracking-wide">\u{1F4CD} Sch\xe9ma vy\u{159}azen\xed na tiskovou desku:</div>
            <div class="bg-gray-50/50 rounded-lg p-3 border border-gray-100 flex justify-center">
              ${layoutVisualHtml}
            </div>
          </div>
        ` : ''}
      </div>
    `;
    }
    // ---------- Tiskové šablony (Technologický list, Průvodní list, DPD) ----------
    printTechnicalList(order) {
        const printWindow = window.open('', '_blank');
        const created = new Date(order.createdAt).toLocaleString('cs-CZ');
        let itemsHtml = '';
        (order.items || []).forEach((it, idx)=>{
            const r = it.calculationResult || {};
            const tech = r.tiskTechnologie || 'auto';
            const isOffset = tech === 'ofset';
            const hasVazba = r.vazba && r.vazba.typ !== '0' && r.vazba.nazev;
            const hasJinaObalka = hasVazba && r.vazba.jinaObalka && r.vazba.vnitrniBlok && !r.vazba.obalkaSloucena;
            const layoutVisualHtml = this.layoutHtmlFor(it);
            let specHtml = '';
            if (hasJinaObalka && r.vazba.obalka && r.vazba.blok) specHtml = `
          <div class="tech-grid">
            <div class="tech-box">
              <div class="tech-box-title">\u{1F4D8} Ob\xe1lka - ${r.vazba.obalka.tiskTechnologie.toUpperCase()}</div>
              <table>
                <tr><td>Pap\xedr:</td><td><strong>${r.vazba.obalka.material?.nazev} (${r.vazba.obalka.material?.gramaz}g)</strong></td></tr>
                <tr><td>Barevnost:</td><td><strong>${r.vazba.obalka.barevnost}</strong></td></tr>
                <tr><td>Po\u{10D}et arch\u{16F}:</td><td><strong>${r.vazba.obalka.pocetArchu} ks</strong></td></tr>
                <tr><td>Vy\u{159}azen\xed:</td><td><strong>${r.vazba.obalka.comp?.count}x na arch</strong></td></tr>
              </table>
            </div>
            <div class="tech-box">
              <div class="tech-box-title">\u{1F4D6} Vnit\u{159}n\xed blok - ${r.vazba.blok.tiskTechnologie.toUpperCase()}</div>
              <table>
                <tr><td>Pap\xedr:</td><td><strong>${r.vazba.blok.material?.nazev} (${r.vazba.blok.material?.gramaz}g)</strong></td></tr>
                <tr><td>Barevnost:</td><td><strong>${r.vazba.blok.barevnost}</strong></td></tr>
                <tr><td>Po\u{10D}et arch\u{16F}:</td><td><strong>${r.vazba.blok.pocetArchu} ks</strong></td></tr>
                <tr><td>Vy\u{159}azen\xed:</td><td><strong>${r.vazba.blok.comp?.count}x na arch</strong></td></tr>
              </table>
            </div>
          </div>
        `;
            else {
                const fd = it.formData || {};
                const deskyPocet = r.comp ? r.comp.plates ? r.comp.plates.length : r.comp.numberOfDifferentSheets + (r.comp.rewind ? 1 : 0) + (r.comp.restSheets > 0 ? 1 : 0) : null;
                const naklad = r.pocetKusu || Number(fd.pocetKusu) || 0;
                specHtml = `
          <table class="simple-spec-table">
            <tr>
              <td><strong>N\xe1klad:</strong> ${naklad.toLocaleString('cs-CZ')} ks</td>
              <td><strong>Rozm\u{11B}r:</strong> ${fd.produktRozmerSirka || fd.rozmerSirka || "\u2014"}x${fd.produktRozmerVyska || fd.rozmerVyska || "\u2014"} mm</td>
              <td><strong>Pap\xedr:</strong> ${fd.materialName || fd.material || "\u2014"}</td>
            </tr>
            <tr>
              <td><strong>Barevnost:</strong> ${fd.pocetBarev || fd.barevnost || "\u2014"}</td>
              <td><strong>Technologie:</strong> ${tech.toUpperCase()}</td>
              <td><strong>Archy:</strong> ${r.pocetArchu ? `${r.pocetArchu} ks (${r.tiskFormat || 'SRA3'})` : "\u2014"}</td>
            </tr>
            <tr>
              <td><strong>Vy\u{159}azen\xed:</strong> ${r.comp?.count ? `${r.comp.count}x na archu` : "\u2014"}</td>
              <td><strong>Po\u{10D}et druh\u{16F}:</strong> ${r.pocetDruhu || fd.pocetDruhu || 1} motiv(\u{16F})</td>
              <td><strong>Tiskov\xe9 desky:</strong> ${isOffset ? deskyPocet != null ? `${deskyPocet} sad` : "\u2014" : "nevy\u017Eaduje"}</td>
            </tr>
          </table>
        `;
            }
            // Knihařská dokončení
            const finishingList = [];
            if (it.formData?.laminace && it.formData.laminace !== '0') finishingList.push(`Laminace (${it.formData.laminace})`);
            if (it.formData?.lakovani && it.formData.lakovani !== '0') finishingList.push(`Lakov\xe1n\xed (${it.formData.lakovani})`);
            if (it.formData?.falcovani && it.formData.falcovani !== '0') finishingList.push(`Falcov\xe1n\xed (${it.formData.falcovani} lomy)`);
            if (it.formData?.bigovani && it.formData.bigovani !== '0') finishingList.push(`Bigov\xe1n\xed (${it.formData.bigovani} r\xfdhy)`);
            if (it.formData?.vysek && it.formData.vysek !== '0') finishingList.push(`V\xfdsek`);
            if (it.formData?.predsek && it.formData.predsek !== '0') finishingList.push(`P\u{159}edsek`);
            if (it.formData?.razba && it.formData.razba !== '0') finishingList.push(`Ra\u{17E}ba`);
            if (it.formData?.vrtani && it.formData.vrtani !== '0') finishingList.push(`Vrt\xe1n\xed (${it.formData.vrtani} otvory)`);
            if (it.formData?.perforace && it.formData.perforace !== '0') finishingList.push(`Perforace`);
            if (it.formData?.lepeni && it.formData.lepeni !== '0') finishingList.push(`Lepen\xed`);
            if (it.formData?.personalizace && it.formData.personalizace !== '0') finishingList.push(`Personalizace`);
            if (it.formData?.vazba && it.formData.vazba !== '0') finishingList.push(`Vazba: ${r.vazba?.nazev || 'ANO'}${r.vazba?.barvaSpiralyText ? ` \u{2013} spir\xe1la ${r.vazba.barvaSpiralyText}` : ''}`);
            if (r.vazba?.cenaPodlozka > 0) finishingList.push(`Podlo\u{17E}ka: ${r.vazba.materialPodlozka || "\u0161ed\xe1 lepenka"}`);
            const finishingHtml = finishingList.length > 0 ? `<div class="finishing-section"><strong>Kniha\u{159}sk\xe9 dokon\u{10D}en\xed:</strong> ${finishingList.join(" \u2014 ")}</div>` : '';
            const rozsahHtml = (0, $464a82d0a054b7a0$export$35a4665e1e1472ea)(r.vazba) ? `<div style="font-size:12px; margin-top:6px;"><strong>Rozsah:</strong> ${(0, $464a82d0a054b7a0$export$35a4665e1e1472ea)(r.vazba)}</div>` : '';
            itemsHtml += `
        <div class="item-card">
          <div class="item-card-header">${idx + 1}. ${it.name}</div>
          ${specHtml}
          ${rozsahHtml}
          ${this.renderMotivyTable(r.motivy, true)}
          ${finishingHtml}
          ${layoutVisualHtml ? `<div class="layout-visual-container">${layoutVisualHtml}</div>` : ''}
        </div>
      `;
        });
        const content = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Technologick\xfd list #${order.id}</title>
        <meta charset="utf-8" />
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;800&display=swap" rel="stylesheet">
        <style>
          body { font-family: 'Inter', sans-serif; color: #1e293b; line-height: 1.5; margin: 0; padding: 25px; font-size: 13px; }
          .header { display: flex; justify-content: space-between; align-items: start; border-b: 2px solid #e2e8f0; padding-bottom: 15px; margin-bottom: 20px; }
          .logo { font-size: 24px; font-weight: 800; color: #1d4ed8; text-transform: uppercase; letter-spacing: 1px; }
          .order-title { font-size: 20px; font-weight: 700; text-align: right; margin: 0; color: #0f172a; }
          .meta-grid { display: grid; grid-template-cols: 1fr 1fr; gap: 20px; margin-bottom: 20px; }
          .meta-box { border: 1px solid #e2e8f0; border-radius: 6px; padding: 12px; background-color: #f8fafc; }
          .meta-box h4 { margin: 0 0 8px 0; font-size: 11px; font-weight: 700; text-transform: uppercase; color: #64748b; letter-spacing: 0.5px; }
          .meta-box pre { font-family: inherit; font-size: 12px; margin: 0; white-space: pre-wrap; }
          .item-card { border: 1px solid #cbd5e1; border-radius: 8px; padding: 15px; margin-bottom: 20px; page-break-inside: avoid; }
          .item-card-header { font-size: 14px; font-weight: 700; color: #1e3a8a; border-bottom: 1px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px; }
          .tech-grid { display: grid; grid-template-cols: 1fr 1fr; gap: 15px; margin-bottom: 12px; }
          .tech-box { border: 1px solid #e2e8f0; border-radius: 6px; padding: 10px; background-color: #f8fafc; }
          .tech-box-title { font-size: 11px; font-weight: 700; color: #334155; border-bottom: 1px solid #e2e8f0; padding-bottom: 5px; margin-bottom: 8px; }
          .tech-box table, .simple-spec-table { width: 100%; border-collapse: collapse; font-size: 12px; }
          .tech-box td { padding: 3px 0; vertical-align: top; }
          .simple-spec-table td { padding: 6px 0; border-bottom: 1px solid #f1f5f9; width: 33.33%; }
          .finishing-section { margin-top: 10px; background-color: #eff6ff; border: 1px solid #bfdbfe; padding: 8px 12px; border-radius: 6px; font-size: 11.5px; color: #1e40af; }
          .layout-visual-container { margin-top: 15px; border-top: 1px dashed #e2e8f0; padding-top: 12px; display: flex; justify-content: center; }
          .signature-section { display: flex; justify-content: space-between; margin-top: 40px; page-break-inside: avoid; }
          .sig-box { width: 200px; border-top: 1px solid #94a3b8; text-align: center; padding-top: 6px; font-size: 11px; color: #64748b; }
          @media print {
            body { padding: 0; }
            .no-print { display: none; }
          }
          /* Styly pro vizualizaci z calc-output.js */
          .bg-gray-50 { background-color: #f9fafb !important; }
          .border { border: 1px solid #e5e7eb !important; }
          .rounded-lg { border-radius: 0.5rem !important; }
          .p-3 { padding: 0.75rem !important; }
          .mb-3 { margin-bottom: 0.75rem !important; }
          .text-xs { font-size: 0.75rem !important; }
          .font-bold { font-weight: 700 !important; }
          .text-gray-700 { color: #374151 !important; }
          .text-[10px] { font-size: 10px !important; }
          .text-gray-400 { color: #9ca3af !important; }
          .mb-2 { margin-bottom: 0.5rem !important; }
          .relative { position: relative !important; }
          .bg-white { background-color: #ffffff !important; }
          .border-gray-400 { border-color: #9ca3af !important; }
          .shadow-sm { box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important; }
          .mx-auto { margin-left: auto !important; margin-right: auto !important; }
          .absolute { position: absolute !important; }
          .border-white/60 { border-color: rgba(255, 255, 255, 0.6) !important; }
          .text-[9px] { font-size: 9px !important; }
          .text-[11px] { font-size: 11px !important; }
          .text-white { color: #ffffff !important; }
          .flex { display: flex !important; }
          .flex-col { flex-direction: column !important; }
          .items-center { align-items: center !important; }
          .justify-center { justify-content: center !important; }
          .justify-between { justify-content: space-between !important; }
          .gap-1 { gap: 0.25rem !important; }
          .mt-2 { margin-top: 0.5rem !important; }
          .mb-3 { margin-bottom: 0.75rem !important; }
          .px-2 { padding-left: 0.5rem !important; padding-right: 0.5rem !important; }
          .py-0.5 { padding-top: 0.125rem !important; padding-bottom: 0.125rem !important; }
          .rounded-full { border-radius: 9999px !important; }
          .font-semibold { font-weight: 600 !important; }
          .uppercase { text-transform: uppercase !important; }
          .tracking-wider { letter-spacing: 0.05em !important; }
          .bg-indigo-100 { background-color: #e0e7ff !important; }
          .text-indigo-700 { color: #4338ca !important; }
          .text-indigo-800 { color: #3730a3 !important; }
          .border-gray-200 { border-color: #e5e7eb !important; }
        </style>
      </head>
      <body>
        <div class="header">
          <div>
            <div class="logo">TRIA tisk\xe1rna</div>
            <div style="font-size: 11px; color: #64748b; margin-top: 4px;">V\xfdrobn\xed a tiskov\xe9 odd\u{11B}len\xed</div>
          </div>
          <div>
            <h1 class="order-title">TECHNOLOGICK\xdd LIST</h1>
            <div style="font-size: 14px; font-weight: 700; text-align: right; color: #1d4ed8; margin-top: 3px;">Zak\xe1zka #${order.id}</div>
          </div>
        </div>

        <div class="meta-grid">
          <div class="meta-box">
            <h4>Odb\u{11B}ratel a doru\u{10D}en\xed</h4>
            <pre>${this.escape((0, $6NozV.customerDataText)(order.customerData))}</pre>
          </div>
          <div class="meta-box">
            <h4>Informace o v\xfdrob\u{11B}</h4>
            <table style="width:100%; border-collapse:collapse; font-size:12px;">
              <tr><td style="padding:4px 0; color:#64748b;">Datum vystaven\xed:</td><td><strong>${created}</strong></td></tr>
              <tr><td style="padding:4px 0; color:#64748b;">Vystavil:</td><td><strong>${this.escape(order.createdByName || order.createdBy || 'system')}</strong></td></tr>
              <tr><td style="padding:4px 0; color:#64748b;">Zdroj:</td><td><strong>${order.offerId ? `nab\xeddka #${this.escape(order.offerId)}` : "p\u0159\xedm\xe1 zak\xe1zka"}</strong></td></tr>
              <tr><td style="padding:4px 0; color:#64748b;">Stav v\xfdroby:</td><td><strong style="color:#d97706; text-transform:uppercase;">${$48533a8b43f55ecf$var$STATUS_META[order.status]?.label || order.status}</strong></td></tr>
              <tr><td style="padding:4px 0; color:#64748b;">Zp\u{16F}sob dod\xe1n\xed:</td><td><strong>Kur\xfdrn\xed slu\u{17E}ba (DPD Classic)</strong></td></tr>
            </table>
            ${order.note ? `<div style="margin-top:8px; border:1px solid #fcd34d; background:#fffbeb; border-radius:6px; padding:8px 10px; font-size:12px;"><strong>Pozn\xe1mka:</strong> ${this.escape(order.note)}</div>` : ''}
          </div>
        </div>

        ${itemsHtml}

        <div class="signature-section">
          <div class="sig-box">Vydal (oper\xe1tor v\xfdroby)</div>
          <div class="sig-box">P\u{159}evzal (tiska\u{159} / CTP)</div>
          <div class="sig-box">Zkontroloval (dokon\u{10D}ovac\xed zpracov\xe1n\xed)</div>
        </div>

        <script>
          window.onload = function() {
            setTimeout(function() { window.print(); }, 300);
          }
        </script>
      </body>
      </html>
    `;
        printWindow.document.write(content);
        printWindow.document.close();
    }
    async printAccompanyingSheet(orderId, itemIndex) {
        // Plný objekt zakázky drží currentOrder (detail); jinak dotáhneme z API –
        // seznam má jen ořezanou projekci bez formData/calculationResult.
        let order = this.currentOrder && this.currentOrder.id === orderId ? this.currentOrder : null;
        if (!order) try {
            order = await this.getOrder(orderId);
        } catch  {
            return;
        }
        const it = order.items[itemIndex];
        if (!it) return;
        const printWindow = window.open('', '_blank');
        const r = it.calculationResult || {};
        const finishingList = [];
        if (it.formData?.laminace && it.formData.laminace !== '0') finishingList.push(`LAMINACE: ${it.formData.laminace}`);
        if (it.formData?.lakovani && it.formData.lakovani !== '0') finishingList.push(`LAKOV\xc1N\xcd: ${it.formData.lakovani}`);
        if (it.formData?.falcovani && it.formData.falcovani !== '0') finishingList.push(`FALCOV\xc1N\xcd (${it.formData.falcovani}x lom)`);
        if (it.formData?.bigovani && it.formData.bigovani !== '0') finishingList.push(`B\xcdGOV\xc1N\xcd (${it.formData.bigovani}x r\xfdha)`);
        if (it.formData?.vysek && it.formData.vysek !== '0') finishingList.push(`V\xddSEK (RAZNICE)`);
        if (it.formData?.vrtani && it.formData.vrtani !== '0') finishingList.push(`VRT\xc1N\xcd (${it.formData.vrtani}x otvor)`);
        if (it.formData?.perforace && it.formData.perforace !== '0') finishingList.push(`PERFORACE`);
        if (it.formData?.vazba && it.formData.vazba !== '0') finishingList.push(`VAZBA: ${r.vazba?.nazev || 'ANO'}${r.vazba?.barvaSpiralyText ? ` \u{2013} SPIR\xc1LA ${r.vazba.barvaSpiralyText.toUpperCase()}` : ''}`);
        if (r.vazba?.cenaPodlozka > 0) finishingList.push(`PODLO\u{17D}KA: ${(r.vazba.materialPodlozka || "\u0161ed\xe1 lepenka").toUpperCase()}`);
        const content = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Pr\u{16F}vodn\xed list zak\xe1zky #${order.id}</title>
        <meta charset="utf-8" />
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;700;800;900&display=swap" rel="stylesheet">
        <style>
          body { font-family: 'Inter', sans-serif; color: #000; margin: 0; padding: 40px; }
          .border-wrapper { border: 15px solid #1e3a8a; border-radius: 12px; padding: 40px; height: calc(100vh - 110px); display: flex; flex-direction: column; justify-content: space-between; box-sizing: border-box; }
          .header { display: flex; justify-content: space-between; align-items: start; border-bottom: 5px solid #000; padding-bottom: 20px; }
          .logo { font-size: 28px; font-weight: 900; letter-spacing: 0.5px; text-transform: uppercase; color: #1e3a8a; }
          .sheet-type { font-size: 16px; font-weight: 700; color: #ef4444; border: 2px solid #ef4444; padding: 4px 10px; border-radius: 4px; text-transform: uppercase; }
          .order-id { font-size: 72px; font-weight: 900; text-align: center; margin: 40px 0 20px 0; color: #1e3a8a; }
          .product-name { font-size: 32px; font-weight: 800; text-align: center; margin: 0 0 40px 0; text-transform: uppercase; border-bottom: 3px solid #e2e8f0; padding-bottom: 15px; }
          .specs-grid { display: grid; grid-template-cols: 1fr 1fr; gap: 30px; font-size: 18px; margin-bottom: 30px; }
          .spec-item { border-bottom: 1px solid #cbd5e1; padding-bottom: 8px; }
          .spec-label { color: #64748b; font-size: 14px; font-weight: 700; text-transform: uppercase; margin-bottom: 4px; }
          .spec-value { font-weight: 700; font-size: 22px; }
          .finishing-checklist { border: 4px solid #1e3a8a; border-radius: 8px; padding: 20px; background-color: #f0f4f8; margin-top: 20px; }
          .checklist-title { font-size: 16px; font-weight: 800; text-transform: uppercase; color: #1e3a8a; border-bottom: 2px solid #1e3a8a; padding-bottom: 8px; margin-bottom: 15px; }
          .checklist-grid { display: grid; grid-template-cols: 1fr 1fr; gap: 15px; }
          .checklist-item { display: flex; align-items: center; font-size: 16px; font-weight: 700; }
          .checkbox { width: 22px; height: 22px; border: 2px solid #000; margin-right: 12px; flex-shrink: 0; background-color: #fff; }
          .footer-info { display: flex; justify-content: space-between; font-size: 14px; color: #475569; font-weight: 700; border-top: 2px solid #000; padding-top: 15px; }
        </style>
      </head>
      <body>
        <div class="border-wrapper">
          <div>
            <div class="header">
              <div>
                <div class="logo">TRIA tisk\xe1rna</div>
              </div>
              <div class="sheet-type">Pr\u{16F}vodn\xed list zak\xe1zky</div>
            </div>

            <div class="order-id">#${order.id}</div>
            <div class="product-name">${it.name}</div>

            <div class="specs-grid">
              <div class="spec-item">
                <div class="spec-label">N\xe1klad k tisku:</div>
                <div class="spec-value" style="color: #ef4444; font-size: 36px;">${(r.pocetKusu || Number(it.formData?.pocetKusu) || 0).toLocaleString('cs-CZ')} ks</div>
              </div>
              <div class="spec-item">
                <div class="spec-label">Pap\xedr:</div>
                <div class="spec-value">${it.formData?.materialName || it.formData?.material || "\u2014"}</div>
              </div>
              <div class="spec-item">
                <div class="spec-label">Technologie tisku:</div>
                <div class="spec-value" style="text-transform: uppercase; color: #1d4ed8;">${(r.tiskTechnologie || 'AUTO').toUpperCase()} (${r.tiskFormat || 'SRA3'})</div>
              </div>
              <div class="spec-item">
                <div class="spec-label">Barevnost:</div>
                <div class="spec-value">${it.formData?.pocetBarev || it.formData?.barevnost || "\u2014"}</div>
              </div>
              <div class="spec-item">
                <div class="spec-label">Rozm\u{11B}r produktu:</div>
                <div class="spec-value">${it.formData?.produktRozmerSirka || "\u2014"}\xd7${it.formData?.produktRozmerVyska || "\u2014"} mm</div>
              </div>
              ${(0, $464a82d0a054b7a0$export$35a4665e1e1472ea)(r.vazba) ? `
              <div class="spec-item" style="grid-column: 1 / -1;">
                <div class="spec-label">Rozsah:</div>
                <div class="spec-value" style="font-size: 18px;">${(0, $464a82d0a054b7a0$export$35a4665e1e1472ea)(r.vazba)}</div>
              </div>
              ` : ''}
            </div>

            ${Array.isArray(r.motivy) && r.motivy.length > 1 ? `
              <div style="border: 3px solid #7c3aed; border-radius: 8px; padding: 14px 18px; background-color: #f5f3ff; margin-bottom: 24px;">
                <div style="font-size: 14px; font-weight: 800; text-transform: uppercase; color: #5b21b6; margin-bottom: 8px;">\u{1F3A8} Motivy \u{2013} rozd\u{11B}len\xed n\xe1kladu (${r.motivy.length}):</div>
                ${r.motivy.map((m, i)=>`
                  <div style="display:flex; justify-content:space-between; font-size:18px; font-weight:700; border-bottom:1px solid #ddd6fe; padding:4px 0;">
                    <span>${i + 1}. ${this.escape(m.nazev || 'Motiv ' + (i + 1))}</span>
                    <span>${m.pocetKusu} ks</span>
                  </div>`).join('')}
              </div>
            ` : ''}

            ${finishingList.length > 0 ? `
              <div class="finishing-checklist">
                <div class="checklist-title">\u{1F527} KNIHA\u{158}SK\xc9 ZPRACOV\xc1N\xcd (Za\u{161}krtn\u{11B}te po dokon\u{10D}en\xed):</div>
                <div class="checklist-grid">
                  ${finishingList.map((op)=>`
                    <div class="checklist-item">
                      <div class="checkbox"></div>
                      <div>${op}</div>
                    </div>
                  `).join('')}
                </div>
              </div>
            ` : `
              <div class="finishing-checklist" style="border-color: #22c55e; background-color: #f0fdf4;">
                <div class="checklist-title" style="color: #15803d; border-color: #15803d;">\u{1F527} DOKON\u{10C}OVAC\xcd PR\xc1CE:</div>
                <div style="font-size: 16px; font-weight: 700; color: #166534;">\u{10C}IST\xdd O\u{158}EZ: Pouze na\u{159}ezat na \u{10D}ist\xfd form\xe1t rozm\u{11B}ru! \u{17D}\xe1dn\xe9 dal\u{161}\xed kniha\u{159}sk\xe9 \xfapravy nejsou vy\u{17E}adov\xe1ny.</div>
              </div>
            `}
          </div>

          <div class="footer-info">
            <div>VYSTAVIL: ${order.createdBy || 'system'}</div>
            <div>DATUM V\xddROBY: ${new Date(order.createdAt).toLocaleDateString('cs-CZ')}</div>
            <div>\u{10C}\xc1ST: ${itemIndex + 1} / ${(order.items || []).length}</div>
          </div>
        </div>

        <script>
          window.onload = function() {
            setTimeout(function() { window.print(); }, 300);
          }
        </script>
      </body>
      </html>
    `;
        printWindow.document.write(content);
        printWindow.document.close();
    }
    printDpdLabel(order) {
        const printWindow = window.open('', '_blank', 'width=600,height=800');
        const recipient = this.customerLines(order);
        const content = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>DPD \u{160}t\xedtek #${order.id}</title>
        <meta charset="utf-8" />
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;700;800;900&display=swap" rel="stylesheet">
        <style>
          body { font-family: 'Inter', sans-serif; color: #000; margin: 0; padding: 15px; background: #fff; width: 375px; height: 560px; box-sizing: border-box; }
          .ticket-border { border: 2px solid #000; width: 100%; height: 100%; padding: 15px; box-sizing: border-box; display: flex; flex-direction: column; justify-content: space-between; }
          .logo-row { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #000; padding-bottom: 10px; }
          .dpd-logo { font-size: 32px; font-weight: 900; color: #e11d48; margin: 0; line-height: 1; }
          .service-type { font-size: 12px; font-weight: 800; text-transform: uppercase; background: #000; color: #fff; padding: 3px 6px; border-radius: 3px; }
          .address-section { display: grid; grid-template-cols: 1fr; gap: 10px; margin-top: 15px; font-size: 11px; }
          .addr-box { border-bottom: 1px dashed #cbd5e1; padding-bottom: 8px; }
          .addr-title { font-size: 9px; font-weight: 700; color: #64748b; text-transform: uppercase; margin-bottom: 3px; }
          .addr-body { font-weight: 700; font-size: 12px; line-height: 1.4; }
          .bar-code-mockup { margin-top: 15px; border: 1px solid #94a3b8; background: #fff; padding: 6px; display: flex; flex-direction: column; items: center; }
          .barcode-bars { display: flex; items: end; justify-content: center; h-16 w-full; height: 60px; width: 100%; }
          .barcode-num { font-size: 10px; font-weight: 700; letter-spacing: 3px; margin-top: 4px; font-family: monospace; }
          .routing-info { display: flex; justify-content: space-between; border-top: 2px solid #000; padding-top: 10px; font-size: 10px; font-weight: 700; }
        </style>
      </head>
      <body>
        <div class="ticket-border">
          <div>
            <div class="logo-row">
              <span class="dpd-logo">dpd</span>
              <span class="service-type">DPD Classic</span>
            </div>

            <div class="address-section">
              <div class="addr-box">
                <div class="addr-title">Odes\xedlatel:</div>
                <div class="addr-body" style="font-size: 11px; font-weight: 500;">
                  TRIA tisk\xe1rna s.r.o.<br>
                  Pr\u{16F}myslov\xe1 1052, 390 01 T\xe1bor
                </div>
              </div>
              <div class="addr-box" style="border: none;">
                <div class="addr-title">P\u{159}\xedjemce:</div>
                <div class="addr-body">
                  ${this.escape(recipient[0] || "Nezn\xe1m\xfd p\u0159\xedjemce")}<br>
                  ${this.escape(recipient[1] || '')}<br>
                  ${this.escape(recipient[2] || '')}<br>
                  ${this.escape(recipient[3] || '')}
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="bar-code-mockup">
              <div class="barcode-bars">
                <div class="w-0.5 h-full bg-black mx-[1px]" style="width:2px; height:100%; background:#000; margin:0 1px;"></div>
                <div class="w-1.5 h-full bg-black mx-[1px]" style="width:4px; height:100%; background:#000; margin:0 1px;"></div>
                <div class="w-0.5 h-full bg-black mx-[1px]" style="width:2px; height:100%; background:#000; margin:0 1px;"></div>
                <div class="w-1 h-full bg-black mx-[1px]" style="width:3px; height:100%; background:#000; margin:0 1px;"></div>
                <div class="w-0.5 h-full bg-black mx-[1px]" style="width:1px; height:100%; background:#000; margin:0 1px;"></div>
                <div class="w-2.5 h-full bg-black mx-[1px]" style="width:6px; height:100%; background:#000; margin:0 1px;"></div>
                <div class="w-1 h-full bg-black mx-[1px]" style="width:3px; height:100%; background:#000; margin:0 1px;"></div>
                <div class="w-0.5 h-full bg-black mx-[1px]" style="width:2px; height:100%; background:#000; margin:0 1px;"></div>
                <div class="w-1.5 h-full bg-black mx-[1px]" style="width:4px; height:100%; background:#000; margin:0 1px;"></div>
                <div class="w-0.5 h-full bg-black mx-[1px]" style="width:1px; height:100%; background:#000; margin:0 1px;"></div>
                <div class="w-2 h-full bg-black mx-[1px]" style="width:5px; height:100%; background:#000; margin:0 1px;"></div>
                <div class="w-1 h-full bg-black mx-[1px]" style="width:3px; height:100%; background:#000; margin:0 1px;"></div>
                <div class="w-0.5 h-full bg-black mx-[1px]" style="width:1px; height:100%; background:#000; margin:0 1px;"></div>
                <div class="w-1.5 h-full bg-black mx-[1px]" style="width:4px; height:100%; background:#000; margin:0 1px;"></div>
                <div class="w-1.5 h-full bg-black mx-[1px]" style="width:4px; height:100%; background:#000; margin:0 1px;"></div>
                <div class="w-0.5 h-full bg-black mx-[1px]" style="width:2px; height:100%; background:#000; margin:0 1px;"></div>
              </div>
              <div class="barcode-num">DPD-(020)9471${order.id}</div>
            </div>

            <div class="routing-info">
              <div>DEPOT: CZ-390</div>
              <div>V\xc1HA: 1.5 kg</div>
              <div>ID: #${order.id}</div>
            </div>
          </div>
        </div>

        <script>
          window.onload = function() {
            setTimeout(function() { window.print(); }, 300);
          }
        </script>
      </body>
      </html>
    `;
        printWindow.document.write(content);
        printWindow.document.close();
    }
    // ---------- Pomocné funkce ----------
    escape(str) {
        if (!str) return '';
        return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    }
}


// Dashboard – agregace KPI napříč nabídkami, objednávkami, fakturami, skladem
// a výrobními lístky. Jediný round-trip na /api/dashboard/summary.

var $entK4 = parcelRequire("entK4");
const $d61c106ff4296524$var$API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
const $d61c106ff4296524$var$OFFER_STATUS_META = {
    draft: {
        label: "Rozpracovan\xe1",
        badge: 'bg-gray-100 text-gray-700'
    },
    sent: {
        label: "Odeslan\xe1",
        badge: 'bg-blue-100 text-blue-800'
    },
    negotiation: {
        label: "Vyjedn\xe1v\xe1n\xed",
        badge: 'bg-amber-100 text-amber-800'
    },
    approved: {
        label: "Schv\xe1len\xe1",
        badge: 'bg-emerald-100 text-emerald-800'
    },
    rejected: {
        label: "Odm\xedtnut\xe1",
        badge: 'bg-red-100 text-red-800'
    },
    converted: {
        label: "P\u0159eveden\xe1",
        badge: 'bg-indigo-100 text-indigo-800'
    }
};
const $d61c106ff4296524$var$ORDER_STATUS_META = {
    received: {
        label: "P\u0159ijato",
        badge: 'bg-blue-100 text-blue-800'
    },
    in_progress: {
        label: "Ve v\xfdrob\u011B",
        badge: 'bg-amber-100 text-amber-800'
    },
    done: {
        label: 'Hotovo',
        badge: 'bg-emerald-100 text-emerald-800'
    },
    to_invoice: {
        label: 'K fakturaci',
        badge: 'bg-purple-100 text-purple-800'
    },
    invoiced: {
        label: "Fakturov\xe1no",
        badge: 'bg-indigo-100 text-indigo-800'
    },
    delivered: {
        label: "Dod\xe1no",
        badge: 'bg-gray-100 text-gray-800'
    },
    cancelled: {
        label: 'Storno',
        badge: 'bg-red-100 text-red-800'
    }
};
const $d61c106ff4296524$var$INVOICE_STATUS_META = {
    draft: {
        label: "Rozpracovan\xe1",
        badge: 'bg-gray-100 text-gray-700'
    },
    issued: {
        label: 'Vystavena',
        badge: 'bg-blue-100 text-blue-800'
    },
    partially_paid: {
        label: "\u010C\xe1ste\u010Dn\u011B uhrazena",
        badge: 'bg-amber-100 text-amber-800'
    },
    paid: {
        label: 'Uhrazena',
        badge: 'bg-emerald-100 text-emerald-800'
    },
    cancelled: {
        label: "Stornov\xe1na",
        badge: 'bg-gray-100 text-gray-500'
    }
};
// Stavy zakázek relevantní pro výrobu (technické listy) – viz vyroba.js.
const $d61c106ff4296524$var$VYROBA_STATUS_META = {
    received: {
        label: "P\u0159\xedprava",
        badge: 'bg-blue-100 text-blue-800'
    },
    in_progress: {
        label: "Ve v\xfdrob\u011B",
        badge: 'bg-amber-100 text-amber-800'
    },
    done: {
        label: 'Hotovo',
        badge: 'bg-emerald-100 text-emerald-800'
    },
    cancelled: {
        label: "Zru\u0161eno",
        badge: 'bg-red-100 text-red-800'
    }
};
class $d61c106ff4296524$export$25a4e4714246e488 {
    constructor(){
        this.data = null;
        this.loading = false;
        this.collapsed = {
            overdue: true,
            lowStock: true,
            inProgress: true
        };
    }
    // ---------- API ----------
    async showSection() {
        await this.loadAndRender();
    }
    async refresh() {
        if (this.loading) return;
        await this.loadAndRender({
            background: true
        });
    }
    async loadAndRender({ background: background = false } = {}) {
        const container = document.getElementById('dashboard-section-content');
        if (!container) return;
        this.loading = true;
        const hasData = Boolean(this.data);
        if (!background || !hasData) container.innerHTML = this.renderHeader() + this.renderLoading();
        try {
            const res = await fetch(`${$d61c106ff4296524$var$API_BASE_URL}/dashboard/summary`, {
                credentials: 'include'
            });
            const json = await res.json();
            if (!res.ok || !json.success) throw new Error(json.error || "Nepoda\u0159ilo se na\u010D\xedst dashboard");
            this.data = json.data;
            this.loading = false;
            this.render();
        } catch (err) {
            this.loading = false;
            if (background && hasData) {
                console.warn('Dashboard auto-refresh selhal:', err);
                return;
            }
            this.renderError(err.message);
        }
    }
    // ---------- Render ----------
    renderHeader() {
        return `
      <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-6">
        <div>
          <h2 class="text-2xl font-semibold text-gray-900 mb-1">P\u{159}ehled</h2>
          <p class="text-gray-600 mb-0 text-sm">Kl\xed\u{10D}ov\xe9 ukazatele nap\u{159}\xed\u{10D} obchodem, v\xfdrobou, fakturac\xed a skladem.</p>
        </div>
      </div>
    `;
    }
    render() {
        const container = document.getElementById('dashboard-section-content');
        if (!container || !this.data) return;
        const d = this.data;
        container.innerHTML = `
      ${this.renderHeader()}
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-6">
        ${this.renderKpiCard({
            icon: 'document-text',
            title: "Nab\xeddky tento m\u011Bs\xedc",
            value: String(d.offers.thisMonth),
            subtitle: `${d.offers.total} celkem \xb7 konverze ${this.formatPct(d.offers.conversionRate)}`,
            accent: 'blue'
        })}
        ${this.renderKpiCard({
            icon: 'clipboard-check',
            title: "Aktivn\xed objedn\xe1vky",
            value: String(d.orders.active),
            subtitle: this.renderOrderBadges(d.orders.byStatus),
            accent: 'amber'
        })}
        ${this.renderKpiCard({
            icon: 'banknotes',
            title: "Obrat tento m\u011Bs\xedc",
            value: this.formatCZK(d.invoices.revenueThisMonth),
            subtitle: `${d.invoices.issuedThisMonth} vystaven\xfdch`,
            accent: 'emerald'
        })}
        ${this.renderKpiCard({
            icon: 'receipt',
            title: 'Nezaplaceno',
            value: this.formatCZK(d.invoices.unpaidAmount),
            subtitle: this.renderOverdueBadge(d.invoices.overdueCount),
            accent: d.invoices.overdueCount > 0 ? 'red' : 'gray'
        })}
        ${this.renderKpiCard({
            icon: 'printer',
            title: "Ve v\xfdrob\u011B",
            value: String(d.vyroba.inProgress),
            subtitle: `${d.vyroba.queued} v p\u{159}\xedprav\u{11B}, ${d.vyroba.readyToShip} k expedici`,
            accent: 'indigo'
        })}
        ${this.renderKpiCard({
            icon: 'swatch',
            title: "N\xedzk\xe9 z\xe1soby",
            value: String(d.stock.lowStockCount),
            subtitle: d.stock.lowStockCount > 0 ? `<span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-red-100 text-red-800">pod minimem</span>` : `<span class="text-xs text-gray-500">v\u{161}e v norm\u{11B}</span>`,
            accent: d.stock.lowStockCount > 0 ? 'red' : 'gray'
        })}
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        ${this.renderOverdueSection(d.invoices)}
        ${this.renderLowStockSection(d.stock)}
      </div>

      <div class="mt-6">
        ${this.renderInProgressSection(d.vyroba)}
      </div>
    `;
        container.querySelectorAll('[data-toggle]').forEach((btn)=>{
            btn.addEventListener('click', ()=>this.toggleSection(btn.dataset.toggle));
        });
        container.querySelectorAll('[data-cta]').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                if (window.sectionManager) window.sectionManager.showSection(btn.dataset.cta);
            });
        });
    }
    toggleSection(id) {
        if (!id || !(id in this.collapsed)) return;
        this.collapsed[id] = !this.collapsed[id];
        const body = document.querySelector(`[data-body="${id}"]`);
        const toggle = document.querySelector(`[data-toggle="${id}"]`);
        if (!body || !toggle) return;
        body.classList.toggle('hidden', this.collapsed[id]);
        const chevron = toggle.querySelector(`svg[data-chevron="${id}"]`);
        if (chevron) chevron.classList.toggle('rotate-180', !this.collapsed[id]);
    }
    renderKpiCard({ icon: iconName, title: title, value: value, subtitle: subtitle, accent: accent }) {
        const colors = {
            blue: {
                bg: 'bg-blue-50',
                text: 'text-blue-600',
                accent: 'text-blue-900'
            },
            amber: {
                bg: 'bg-amber-50',
                text: 'text-amber-600',
                accent: 'text-amber-900'
            },
            emerald: {
                bg: 'bg-emerald-50',
                text: 'text-emerald-600',
                accent: 'text-emerald-900'
            },
            red: {
                bg: 'bg-red-50',
                text: 'text-red-600',
                accent: 'text-red-900'
            },
            indigo: {
                bg: 'bg-indigo-50',
                text: 'text-indigo-600',
                accent: 'text-indigo-900'
            },
            gray: {
                bg: 'bg-gray-50',
                text: 'text-gray-500',
                accent: 'text-gray-900'
            }
        };
        const c = colors[accent] || colors.gray;
        return `
      <div class="bg-white rounded-lg border border-gray-200 p-3 flex items-start gap-3 shadow-sm">
        <div class="flex-shrink-0 w-9 h-9 rounded-md ${c.bg} ${c.text} flex items-center justify-center">
          ${(0, $entK4.icon)(iconName, 'w-5 h-5')}
        </div>
        <div class="min-w-0">
          <div class="text-[11px] uppercase tracking-wide text-gray-500 font-medium">${this.escape(title)}</div>
          <div class="text-base sm:text-lg font-semibold ${c.accent} truncate tabular-nums" title="${this.escape(String(value))}">${this.escape(String(value))}</div>
          <div class="text-xs text-gray-500">${subtitle || ''}</div>
        </div>
      </div>
    `;
    }
    renderOrderBadges(byStatus) {
        const order = [
            'received',
            'in_progress',
            'to_invoice'
        ];
        const parts = [];
        for (const s of order){
            const n = byStatus[s] || 0;
            if (n <= 0) continue;
            const m = $d61c106ff4296524$var$ORDER_STATUS_META[s];
            parts.push(`<span class="inline-flex items-center px-1.5 py-0.5 rounded text-[11px] ${m.badge}">${m.label}: ${n}</span>`);
        }
        return parts.length ? parts.join(' ') : '<span class="text-xs text-gray-500">\u017E\xe1dn\xe9 aktivn\xed</span>';
    }
    renderOverdueBadge(count) {
        if (count > 0) return `<span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-red-100 text-red-800">${count} po splatnosti</span>`;
        return '<span class="text-xs text-gray-500">v\u0161e po splatnosti</span>';
    }
    renderOverdueSection(invoices) {
        const items = invoices.overdueInvoices || [];
        const emptyBody = `
      <div class="p-8 text-center">
        ${(0, $entK4.icon)('check-circle', 'mx-auto h-10 w-10 text-emerald-400 mb-2')}
        <p class="text-sm text-gray-500">\u{17D}\xe1dn\xe9 faktury po splatnosti.</p>
      </div>
    `;
        const tableBody = `
      <div class="overflow-x-auto">
        <table class="min-w-full text-sm">
          <thead>
            <tr class="text-left border-b border-gray-200 bg-gray-50/60">
              <th class="px-4 py-2.5 font-medium text-gray-600">Faktura</th>
              <th class="px-4 py-2.5 font-medium text-gray-600">Z\xe1kazn\xedk</th>
              <th class="px-4 py-2.5 font-medium text-gray-600 text-right">\u{10C}\xe1stka</th>
              <th class="px-4 py-2.5 font-medium text-gray-600">Splatnost</th>
              <th class="px-4 py-2.5 font-medium text-gray-600">Stav</th>
            </tr>
          </thead>
          <tbody>
            ${items.map((inv)=>{
            const m = $d61c106ff4296524$var$INVOICE_STATUS_META[inv.status] || {
                label: inv.status,
                badge: 'bg-gray-100 text-gray-800'
            };
            return `
                <tr class="border-b border-gray-100 hover:bg-gray-50">
                  <td class="px-4 py-2.5 font-medium text-gray-900">${this.escape(inv.id)}</td>
                  <td class="px-4 py-2.5 text-gray-700">${this.escape(inv.customerName || "\u2014")}</td>
                  <td class="px-4 py-2.5 text-right text-gray-900">${this.formatCZK(inv.totalPriceWithVat)}</td>
                  <td class="px-4 py-2.5 text-gray-600">${this.formatDate(inv.dueDate)}</td>
                  <td class="px-4 py-2.5"><span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs ${m.badge}">${this.escape(m.label)}</span></td>
                </tr>
              `;
        }).join('')}
          </tbody>
        </table>
      </div>
    `;
        return this.renderCollapsibleCard({
            id: 'overdue',
            icon: 'exclamation-triangle',
            iconColor: 'text-red-500',
            title: 'Po splatnosti',
            items: items,
            countBadgeClass: 'bg-red-100 text-red-800',
            body: items.length ? tableBody : emptyBody,
            ctaLabel: "P\u0159ej\xedt na faktury",
            ctaSection: 'faktury'
        });
    }
    renderLowStockSection(stock) {
        const items = stock.lowStock || [];
        const emptyBody = `
      <div class="p-8 text-center">
        ${(0, $entK4.icon)('check-circle', 'mx-auto h-10 w-10 text-emerald-400 mb-2')}
        <p class="text-sm text-gray-500">V\u{161}echny materi\xe1ly nad minimem.</p>
      </div>
    `;
        const tableBody = `
      <div class="overflow-x-auto">
        <table class="min-w-full text-sm">
          <thead>
            <tr class="text-left border-b border-gray-200 bg-gray-50/60">
              <th class="px-4 py-2.5 font-medium text-gray-600">Materi\xe1l</th>
              <th class="px-4 py-2.5 font-medium text-gray-600">Kategorie</th>
              <th class="px-4 py-2.5 font-medium text-gray-600 text-right">Skladem</th>
              <th class="px-4 py-2.5 font-medium text-gray-600 text-right">Min</th>
              <th class="px-4 py-2.5 font-medium text-gray-600 text-right">Dostupn\xe9</th>
            </tr>
          </thead>
          <tbody>
            ${items.map((m)=>{
            const low = m.skladem <= m.minStock;
            return `
                <tr class="border-b border-gray-100 hover:bg-gray-50">
                  <td class="px-4 py-2.5 text-gray-900">${this.escape(m.name)}</td>
                  <td class="px-4 py-2.5 text-gray-600">${this.escape(m.categoryId)}</td>
                  <td class="px-4 py-2.5 text-right ${low ? 'text-red-700 font-medium' : 'text-gray-700'}">${m.skladem}</td>
                  <td class="px-4 py-2.5 text-right text-gray-500">${m.minStock}</td>
                  <td class="px-4 py-2.5 text-right text-gray-700">${m.available}</td>
                </tr>
              `;
        }).join('')}
          </tbody>
        </table>
      </div>
    `;
        return this.renderCollapsibleCard({
            id: 'lowStock',
            icon: 'swatch',
            iconColor: 'text-amber-500',
            title: "N\xedzk\xe9 z\xe1soby",
            items: items,
            countBadgeClass: 'bg-amber-100 text-amber-800',
            body: items.length ? tableBody : emptyBody,
            ctaLabel: "P\u0159ej\xedt na pap\xedry",
            ctaSection: 'papiry'
        });
    }
    /**
   * Skládací karta dashboardu. Defaultně sbalená – ukazuje titulek, počet a CTA.
   * Rozbalením se ukáže tělo (tabulka). Prázdný stav (items.length === 0)
   * se ukazuje rozevřený bez CTA a bez šipky.
   */ renderCollapsibleCard({ id: id, icon: iconName, iconColor: iconColor, title: title, items: items, countBadgeClass: countBadgeClass, body: body, ctaLabel: ctaLabel, ctaSection: ctaSection }) {
        const hasItems = Array.isArray(items) && items.length > 0;
        const isCollapsed = this.collapsed[id];
        const chevronClass = isCollapsed ? '' : 'rotate-180';
        const bodyHiddenClass = isCollapsed ? 'hidden' : '';
        return `
      <div class="bg-white rounded-lg shadow-sm border border-gray-200">
        <div class="px-5 py-4 border-b border-gray-100 flex items-center gap-2">
          <button type="button" data-toggle="${id}"
            class="flex items-center gap-2 text-left flex-1 min-w-0 cursor-pointer hover:text-blue-600">
            ${(0, $entK4.icon)('chevron-down', `w-4 h-4 text-gray-400 transition-transform duration-200 ${chevronClass}`, {
            'data-chevron': id
        })}
            ${(0, $entK4.icon)(iconName, `h-5 w-5 ${iconColor} flex-shrink-0`)}
            <h3 class="text-base font-semibold text-gray-900 truncate">${this.escape(title)}</h3>
            ${hasItems ? `<span class="text-xs px-2 py-0.5 rounded-full ${countBadgeClass}">${items.length}</span>` : ''}
          </button>
          <button type="button" data-cta="${ctaSection}"
            class="inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-700 flex-shrink-0">
            <span class="hidden sm:inline">${this.escape(ctaLabel)}</span>
            ${(0, $entK4.icon)('arrow-right', 'w-4 h-4 sm:ml-1')}
          </button>
        </div>
        <div data-body="${id}" class="${bodyHiddenClass}">
          ${body}
        </div>
      </div>
    `;
    }
    renderInProgressSection(vyroba) {
        const items = vyroba.inProgressOrders || [];
        const emptyBody = `
      <div class="p-8 text-center">
        ${(0, $entK4.icon)('check-circle', 'mx-auto h-10 w-10 text-emerald-400 mb-2')}
        <p class="text-sm text-gray-500">\u{17D}\xe1dn\xe9 zak\xe1zky aktu\xe1ln\u{11B} ve v\xfdrob\u{11B}.</p>
      </div>
    `;
        const tableBody = `
      <div class="overflow-x-auto">
        <table class="min-w-full text-sm">
          <thead>
            <tr class="text-left border-b border-gray-200 bg-gray-50/60">
              <th class="px-4 py-2.5 font-medium text-gray-600">Zak\xe1zka</th>
              <th class="px-4 py-2.5 font-medium text-gray-600">Z\xe1kazn\xedk</th>
              <th class="px-4 py-2.5 font-medium text-gray-600">Posledn\xed zm\u{11B}na</th>
              <th class="px-4 py-2.5 font-medium text-gray-600">Stav</th>
              <th class="px-4 py-2.5 font-medium text-gray-600 text-right">Cena</th>
            </tr>
          </thead>
          <tbody>
            ${items.map((t)=>{
            const m = $d61c106ff4296524$var$VYROBA_STATUS_META[t.status] || {
                label: t.status,
                badge: 'bg-gray-100 text-gray-800'
            };
            return `
                <tr class="border-b border-gray-100 hover:bg-gray-50">
                  <td class="px-4 py-2.5 font-medium text-gray-900">${this.escape(t.id)}</td>
                  <td class="px-4 py-2.5 text-gray-700">${this.escape(t.customerName || "\u2014")}</td>
                  <td class="px-4 py-2.5 text-gray-600">${this.formatDate(t.updatedAt)}</td>
                  <td class="px-4 py-2.5"><span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs ${m.badge}">${this.escape(m.label)}</span></td>
                  <td class="px-4 py-2.5 text-right text-gray-700">${(t.totalPrice || 0).toLocaleString('cs-CZ')} K\u{10D}</td>
                </tr>
              `;
        }).join('')}
          </tbody>
        </table>
      </div>
    `;
        return this.renderCollapsibleCard({
            id: 'inProgress',
            icon: 'printer',
            iconColor: 'text-indigo-500',
            title: "Ve v\xfdrob\u011B",
            items: items,
            countBadgeClass: 'bg-indigo-100 text-indigo-800',
            body: items.length ? tableBody : emptyBody,
            ctaLabel: "P\u0159ej\xedt na technick\xe9 listy",
            ctaSection: 'vyroba'
        });
    }
    renderLoading() {
        return `
      <div class="flex justify-center p-12">
        ${(0, $entK4.icon)('spinner', 'animate-spin h-8 w-8 text-blue-500')}
      </div>
    `;
    }
    renderError(message) {
        const container = document.getElementById('dashboard-section-content');
        if (!container) return;
        container.innerHTML = `
      ${this.renderHeader()}
      <div class="bg-red-50 border border-red-200 rounded-md p-4 text-sm text-red-700">${this.escape(message)}</div>
    `;
    }
    // ---------- Helpers ----------
    formatCZK(n) {
        const num = Number(n) || 0;
        return num.toLocaleString('cs-CZ', {
            maximumFractionDigits: 0
        }) + " K\u010D";
    }
    formatPct(n) {
        const num = Number(n) || 0;
        return num.toLocaleString('cs-CZ', {
            maximumFractionDigits: 1
        }) + ' %';
    }
    formatDate(value) {
        if (!value) return "\u2014";
        const d = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(value.slice(0, 4), parseInt(value.slice(5, 7), 10) - 1, value.slice(8, 10)) : new Date(value);
        if (Number.isNaN(d.getTime())) return this.escape(String(value));
        return d.toLocaleDateString('cs-CZ', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    }
    notify(msg, type = 'success') {
        if (typeof window.showNotification === 'function') window.showNotification(msg, type);
    }
    escape(str) {
        if (str == null) return '';
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
}
window.DashboardManager = $d61c106ff4296524$export$25a4e4714246e488;


// Modul pro správu sekce Soubory (admin)
// - Tabulka souborů s filtrem podle zákazníka
// - Akce: stáhnout, sdílet odkaz, smazat
// - Upload je implementován ve Fázi 3 (zatím placeholder)

var $entK4 = parcelRequire("entK4");
const $02538f383e87444e$var$API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
const $02538f383e87444e$var$FILE_STATUS_META = {
    active: {
        label: "Aktivn\xed",
        badge: 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200/60'
    },
    archived: {
        label: "Archivovan\xfd",
        badge: 'bg-gray-100 text-gray-600 ring-1 ring-gray-200'
    }
};
// Zakázané přípony (FE pre-validace; backend validuje znovu)
const $02538f383e87444e$var$BLOCKED_EXTENSIONS = [
    'exe',
    'sh',
    'bat',
    'ps1',
    'cmd',
    'com',
    'app',
    'msi',
    'scr',
    'vbs',
    'js'
];
function $02538f383e87444e$var$getFileExtension(name) {
    if (!name) return '';
    const idx = name.lastIndexOf('.');
    return idx >= 0 ? name.slice(idx + 1).toLowerCase() : '';
}

class $02538f383e87444e$export$7d691179cffa4ac0 {
    constructor(){
        this.files = [];
        this.selectedCustomer = null; // { id, name } | null
        this.includeArchived = false;
        this.loading = false;
        this.error = null;
        this._inited = false;
        this.stats = null; // { totals, perCustomer } | null
    }
    /**
   * Voláno při aktivaci sekce. Idempotentní – načte data při prvním zobrazení,
   * při dalších přechodech volá pouze refresh().
   */ async showSection() {
        if (!this._inited) {
            this._inited = true;
            this.renderShell();
        }
        // Pokud byl filtr nastaven externě (např. z customers.js před přechodem),
        // refresh label + checkbox po každém vstupu do sekce.
        this.updateCustomerLabel();
        const archivedToggle = document.getElementById('files-archived-toggle');
        if (archivedToggle) archivedToggle.checked = this.includeArchived;
        await this.loadFiles();
    }
    /**
   * Veřejné refresh API (např. po uploadu / smazání externě).
   */ refresh() {
        return this.loadFiles();
    }
    // ===== API =====
    async loadFiles() {
        this.loading = true;
        this.error = null;
        this.renderBody();
        try {
            const params = new URLSearchParams();
            if (this.selectedCustomer?.id) params.set('customerId', this.selectedCustomer.id);
            if (this.includeArchived) params.set('includeArchived', 'true');
            const url = `${$02538f383e87444e$var$API_BASE_URL}/files${params.toString() ? `?${params}` : ''}`;
            const res = await fetch(url, {
                credentials: 'include'
            });
            if (!res.ok) {
                const text = await res.text().catch(()=>'');
                throw new Error(text || `HTTP ${res.status}`);
            }
            const json = await res.json();
            this.files = Array.isArray(json.data) ? json.data : [];
        } catch (err) {
            console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed soubor\u016F:", err);
            this.error = err.message || "Nepoda\u0159ilo se na\u010D\xedst soubory";
            this.files = [];
        } finally{
            this.loading = false;
            this.renderBody();
        }
        // Stats refresh (fire-and-forget, neblokuje hlavní seznam)
        this.loadStats();
    }
    async loadStats() {
        try {
            const res = await fetch(`${$02538f383e87444e$var$API_BASE_URL}/files/stats`, {
                credentials: 'include'
            });
            if (!res.ok) return;
            const json = await res.json();
            this.stats = json.data || null;
            this.renderStats();
        } catch (err) {
            console.warn("Statistiky se nepoda\u0159ilo na\u010D\xedst:", err);
        }
    }
    async deleteFile(fileId, label) {
        if (!confirm(`Opravdu chcete smazat soubor \u{201E}${label}"?

Tato akce je nevratn\xe1.`)) return;
        try {
            const res = await fetch(`${$02538f383e87444e$var$API_BASE_URL}/files/${encodeURIComponent(fileId)}`, {
                method: 'DELETE',
                credentials: 'include'
            });
            if (!res.ok) throw new Error("Smaz\xe1n\xed selhalo");
            this.notify("Soubor byl smaz\xe1n", 'success');
            this.loadFiles();
        } catch (err) {
            console.error("Chyba p\u0159i maz\xe1n\xed souboru:", err);
            this.notify("Chybu p\u0159i maz\xe1n\xed souboru", 'error');
        }
    }
    async createShareLink(customerId, customerName) {
        try {
            const res = await fetch(`${$02538f383e87444e$var$API_BASE_URL}/files/share/${encodeURIComponent(customerId)}`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    customerName: customerName
                })
            });
            if (!res.ok) throw new Error("Vytvo\u0159en\xed odkazu selhalo");
            const json = await res.json();
            return json.data; // { token, url, ... }
        } catch (err) {
            console.error("Chyba p\u0159i vytv\xe1\u0159en\xed odkazu:", err);
            this.notify("Nepoda\u0159ilo se vytvo\u0159it ve\u0159ejn\xfd odkaz", 'error');
            return null;
        }
    }
    async shareCustomerFiles(customerId, customerName) {
        const linkData = await this.createShareLink(customerId, customerName);
        if (!linkData) return;
        const url = linkData.url;
        try {
            await this.copyToClipboard(url);
            this.notify(`Odkaz pro ${customerName} byl zkop\xedrov\xe1n do schr\xe1nky`, 'success');
        } catch (_) {
            // Fallback – zobrazí prompt
            window.prompt("Ve\u0159ejn\xfd odkaz pro z\xe1kazn\xedka (zkop\xedrujte ru\u010Dn\u011B):", url);
        }
    }
    // ===== Render: shell (top bar + container, jen jednou) =====
    renderShell() {
        const root = document.getElementById('soubory-section-content');
        if (!root) return;
        root.innerHTML = `
      <div class="w-full">
        <div class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-6">
          <div>
            <h2 class="text-2xl font-semibold text-gray-900 mb-1">Soubory</h2>
            <p class="text-gray-600 text-sm mb-0">Sd\xedlen\xed soubor\u{16F} s klienty p\u{159}es ve\u{159}ejn\xfd odkaz.</p>
          </div>
          <div class="flex flex-wrap items-center gap-2">
            <button id="files-upload-btn"
              class="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
              ${(0, $entK4.icon)('cloud-arrow-up', 'w-4 h-4 mr-2')}
              Nahr\xe1t soubor
            </button>
            <button id="files-maintenance-btn"
              class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              title="Hromadn\u{11B} smazat star\xe9 soubory">
              ${(0, $entK4.icon)('archive-box', 'w-4 h-4 mr-2 text-gray-500')}
              \xdadr\u{17E}ba
            </button>
          </div>
        </div>

        <div id="files-stats" class="mb-4"></div>

        <div class="bg-white shadow-sm rounded-lg border border-gray-200 p-4 mb-4">
          <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
            <div class="flex flex-col sm:flex-row sm:items-center gap-3 flex-1 min-w-0">
              <div class="flex items-center gap-2 min-w-0">
                <span class="text-sm text-gray-500 whitespace-nowrap">Z\xe1kazn\xedk:</span>
                <div class="flex items-center gap-2 min-w-0">
                  <button id="files-pick-customer-btn"
                    class="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-md text-sm text-gray-700 bg-white hover:bg-gray-50 min-w-0">
                    ${(0, $entK4.icon)('magnifying-glass', 'w-4 h-4 mr-1.5 text-gray-400 flex-shrink-0')}
                    <span id="files-customer-label" class="truncate max-w-[18rem]">V\u{161}ichni z\xe1kazn\xedci</span>
                  </button>
                  <button id="files-clear-customer-btn"
                    class="hidden inline-flex items-center justify-center w-8 h-8 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100"
                    title="Zru\u{161}it filtr">
                    ${(0, $entK4.icon)('x-mark', 'w-4 h-4')}
                  </button>
                </div>
              </div>

              <label class="inline-flex items-center text-sm text-gray-700 select-none">
                <input id="files-archived-toggle" type="checkbox"
                  class="rounded border-gray-300 text-blue-600 focus:ring-blue-500 mr-2">
                Zobrazit i archivovan\xe9
              </label>
            </div>

            <div id="files-customer-actions" class="hidden flex items-center gap-2">
              <button id="files-share-btn"
                class="inline-flex items-center px-3 py-1.5 border border-emerald-300 rounded-md text-sm font-medium text-emerald-700 bg-white hover:bg-emerald-50">
                ${(0, $entK4.icon)('link', 'w-4 h-4 mr-1.5')}
                Zkop\xedrovat odkaz pro klienta
              </button>
            </div>
          </div>
        </div>

        <div id="files-summary" class="mb-3 text-xs text-gray-500"></div>
        <div id="files-body"></div>
      </div>
    `;
        this.bindShellEvents();
    }
    bindShellEvents() {
        document.getElementById('files-upload-btn')?.addEventListener('click', ()=>this.openUploadModal());
        document.getElementById('files-maintenance-btn')?.addEventListener('click', ()=>this.openMaintenanceModal());
        document.getElementById('files-pick-customer-btn')?.addEventListener('click', ()=>this.pickCustomer());
        document.getElementById('files-clear-customer-btn')?.addEventListener('click', ()=>this.clearCustomerFilter());
        document.getElementById('files-archived-toggle')?.addEventListener('change', (e)=>{
            this.includeArchived = !!e.target.checked;
            this.loadFiles();
        });
        document.getElementById('files-share-btn')?.addEventListener('click', ()=>{
            if (!this.selectedCustomer) return;
            this.shareCustomerFiles(this.selectedCustomer.id, this.selectedCustomer.name);
        });
    }
    async pickCustomer() {
        if (!window.customersManager) {
            this.notify("Z\xe1kazn\xedci nejsou je\u0161t\u011B na\u010Dteni", 'warning');
            return;
        }
        const customer = await window.customersManager.openSelector();
        if (!customer) return;
        this.selectedCustomer = {
            id: customer.id,
            name: customer.name
        };
        this.updateCustomerLabel();
        this.loadFiles();
    }
    clearCustomerFilter() {
        this.selectedCustomer = null;
        this.updateCustomerLabel();
        this.loadFiles();
    }
    updateCustomerLabel() {
        const label = document.getElementById('files-customer-label');
        const clearBtn = document.getElementById('files-clear-customer-btn');
        const actions = document.getElementById('files-customer-actions');
        if (this.selectedCustomer) {
            if (label) label.textContent = this.selectedCustomer.name;
            clearBtn?.classList.remove('hidden');
            actions?.classList.remove('hidden');
            actions?.classList.add('flex');
        } else {
            if (label) label.textContent = "V\u0161ichni z\xe1kazn\xedci";
            clearBtn?.classList.add('hidden');
            actions?.classList.add('hidden');
            actions?.classList.remove('flex');
        }
    }
    // ===== Render: body (table / empty / error / loading) =====
    renderBody() {
        const container = document.getElementById('files-body');
        const summary = document.getElementById('files-summary');
        if (!container) return;
        if (this.loading) {
            container.innerHTML = `
        <div class="flex justify-center p-8">
          ${(0, $entK4.icon)('spinner', 'animate-spin h-8 w-8 text-blue-500', {
                role: 'status'
            })}
          <span class="sr-only">Na\u{10D}\xedt\xe1m\u{2026}</span>
        </div>
      `;
            if (summary) summary.textContent = '';
            return;
        }
        if (this.error) {
            container.innerHTML = `
        <div class="bg-red-50 border border-red-200 rounded-md p-4">
          <div class="flex items-start">
            ${(0, $entK4.icon)('exclamation-circle', 'h-5 w-5 text-red-400 mt-0.5')}
            <div class="ml-3 flex-1">
              <h3 class="text-sm font-medium text-red-800">${this.escape(this.error)}</h3>
              <button id="files-retry-btn" class="mt-2 text-sm text-red-600 hover:text-red-500 underline">Zkusit znovu</button>
            </div>
          </div>
        </div>
      `;
            document.getElementById('files-retry-btn')?.addEventListener('click', ()=>this.loadFiles());
            if (summary) summary.textContent = '';
            return;
        }
        if (this.files.length === 0) {
            const inFilter = !!this.selectedCustomer;
            container.innerHTML = `
        <div class="bg-white rounded-lg border border-gray-200 p-10 text-center">
          ${(0, $entK4.icon)('folder-open', 'mx-auto h-12 w-12 text-gray-300 mb-3')}
          <h3 class="text-base font-medium text-gray-900 mb-1">
            ${inFilter ? "Tento z\xe1kazn\xedk zat\xedm nem\xe1 \u017E\xe1dn\xe9 soubory" : "Zat\xedm nejsou nahran\xe9 \u017E\xe1dn\xe9 soubory"}
          </h3>
          <p class="text-sm text-gray-500">
            ${inFilter ? "Nahrajte prvn\xed soubor pro tohoto z\xe1kazn\xedka." : "Za\u010Dn\u011Bte nahr\xe1n\xedm souboru a p\u0159i\u0159azen\xedm k z\xe1kazn\xedkovi."}
          </p>
        </div>
      `;
            if (summary) summary.textContent = '';
            return;
        }
        // Souhrn nahoře
        if (summary) {
            const activeCount = this.files.filter((f)=>f.status !== 'archived').length;
            const archivedCount = this.files.length - activeCount;
            const totalSize = this.files.reduce((sum, f)=>sum + (Number(f.size) || 0), 0);
            const parts = [
                `${this.files.length} ${this.plural(this.files.length, 'soubor', 'soubory', "soubor\u016F")}`,
                `${this.formatSize(totalSize)} celkem`
            ];
            if (archivedCount > 0) parts.push(`${archivedCount} archivovan\xfdch`);
            summary.textContent = parts.join(" \xb7 ");
        }
        // Tabulka
        container.innerHTML = `
      <div class="bg-white shadow-sm rounded-lg border border-gray-200 overflow-hidden">
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-12"></th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Soubor</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden md:table-cell">Z\xe1kazn\xedk</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden lg:table-cell">Nahr\xe1no</th>
                <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider hidden sm:table-cell">Velikost</th>
                <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden md:table-cell">Stav</th>
                <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Akce</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-100">
              ${this.files.map((f)=>this.renderRow(f)).join('')}
            </tbody>
          </table>
        </div>
      </div>
    `;
        this.bindRowEvents(container);
    }
    renderRow(file) {
        const iconSvg = this.getFileIconSvg(file.mimeType, file.originalName);
        const meta = $02538f383e87444e$var$FILE_STATUS_META[file.status] || $02538f383e87444e$var$FILE_STATUS_META.active;
        const uploadDate = this.formatDateTime(file.uploadedAt);
        const sizeStr = this.formatSize(file.size);
        const customerName = file.customerName || file.customerId || '-';
        const isArchived = file.status === 'archived';
        return `
      <tr class="hover:bg-gray-50 ${isArchived ? 'opacity-70' : ''}">
        <td class="px-4 py-3 align-middle">
          <div class="w-9 h-9 rounded-md bg-gray-50 ring-1 ring-gray-200 flex items-center justify-center text-gray-500">
            ${iconSvg}
          </div>
        </td>
        <td class="px-4 py-3 align-middle min-w-0">
          <div class="text-sm font-medium text-gray-900 truncate max-w-[28rem]" title="${this.escape(file.originalName)}">${this.escape(file.originalName)}</div>
          ${file.description ? `<div class="text-xs text-gray-500 truncate max-w-[28rem] mt-0.5" title="${this.escape(file.description)}">${this.escape(file.description)}</div>` : ''}
          <div class="text-xs text-gray-500 md:hidden mt-1">${this.escape(customerName)} \xb7 ${this.escape(uploadDate)} \xb7 ${sizeStr}</div>
        </td>
        <td class="px-4 py-3 align-middle hidden md:table-cell">
          <button class="text-sm text-blue-600 hover:text-blue-800 hover:underline" data-action="filter-customer" data-id="${this.escape(file.customerId)}" data-name="${this.escape(customerName)}">
            ${this.escape(customerName)}
          </button>
        </td>
        <td class="px-4 py-3 align-middle hidden lg:table-cell">
          <span class="text-sm text-gray-700">${this.escape(uploadDate)}</span>
          ${file.uploadedBy ? `<div class="text-xs text-gray-400">${this.escape(file.uploadedBy)}</div>` : ''}
        </td>
        <td class="px-4 py-3 align-middle text-right hidden sm:table-cell">
          <span class="text-sm text-gray-700 tabular-nums">${sizeStr}</span>
        </td>
        <td class="px-4 py-3 align-middle hidden md:table-cell">
          <span class="inline-flex items-center text-xs px-2 py-0.5 rounded-full ${meta.badge}">${this.escape(meta.label)}</span>
          ${file.downloadCount > 0 ? `<div class="inline-flex items-center gap-0.5 text-xs text-gray-400 mt-0.5">${(0, $entK4.icon)('arrow-down-tray', 'w-3 h-3')} ${file.downloadCount}\xd7</div>` : ''}
        </td>
        <td class="px-4 py-3 align-middle text-right whitespace-nowrap">
          <div class="inline-flex items-center gap-1">
            <button data-action="download" data-id="${this.escape(file.id)}" data-url="${this.escape(file.storageUrl || '')}" data-name="${this.escape(file.originalName)}"
              class="inline-flex items-center p-1.5 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100" title="St\xe1hnout">
              ${(0, $entK4.icon)('arrow-down-tray', 'w-4 h-4')}
            </button>
            <button data-action="share" data-customer-id="${this.escape(file.customerId)}" data-customer-name="${this.escape(customerName)}"
              class="inline-flex items-center p-1.5 rounded-md text-emerald-600 hover:text-emerald-700 hover:bg-emerald-50" title="Sd\xedlet z\xe1kazn\xedkovi (vytvo\u{159}\xed/zkop\xedruje odkaz)">
              ${(0, $entK4.icon)('link', 'w-4 h-4')}
            </button>
            ${!isArchived ? `
            <button data-action="replace" data-id="${this.escape(file.id)}"
              class="inline-flex items-center p-1.5 rounded-md text-amber-600 hover:text-amber-700 hover:bg-amber-50" title="Nahradit novou verz\xed">
              ${(0, $entK4.icon)('arrows-right-left', 'w-4 h-4')}
            </button>` : ''}
            <button data-action="delete" data-id="${this.escape(file.id)}" data-name="${this.escape(file.originalName)}"
              class="inline-flex items-center p-1.5 rounded-md text-red-500 hover:text-red-600 hover:bg-red-50" title="Smazat">
              ${(0, $entK4.icon)('trash', 'w-4 h-4')}
            </button>
          </div>
        </td>
      </tr>
    `;
    }
    bindRowEvents(container) {
        container.querySelectorAll('[data-action="filter-customer"]').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                e.preventDefault();
                const id = btn.dataset.id;
                const name = btn.dataset.name;
                if (!id) return;
                this.selectedCustomer = {
                    id: id,
                    name: name
                };
                this.updateCustomerLabel();
                this.loadFiles();
            });
        });
        container.querySelectorAll('[data-action="download"]').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                e.preventDefault();
                const id = btn.dataset.id;
                const url = btn.dataset.url;
                const name = btn.dataset.name;
                this.downloadFile(id, url, name);
            });
        });
        container.querySelectorAll('[data-action="share"]').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                e.preventDefault();
                const customerId = btn.dataset.customerId;
                const customerName = btn.dataset.customerName;
                if (customerId) this.shareCustomerFiles(customerId, customerName);
            });
        });
        container.querySelectorAll('[data-action="replace"]').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                e.preventDefault();
                this.openReplaceModal(btn.dataset.id);
            });
        });
        container.querySelectorAll('[data-action="delete"]').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                e.preventDefault();
                this.deleteFile(btn.dataset.id, btn.dataset.name);
            });
        });
    }
    // ===== Akce: download =====
    downloadFile(fileId, storageUrl, filename) {
        if (!storageUrl) {
            this.notify("Soubor nem\xe1 ulo\u017Eenou adresu", 'error');
            return;
        }
        // Pro lokální dev URL doplníme absolutní origin backend serveru
        let absoluteUrl = storageUrl;
        if (storageUrl.startsWith('/api/')) absoluteUrl = `${$02538f383e87444e$var$API_BASE_URL.replace(/\/api$/, '')}${storageUrl}`;
        // Pro stažení vytvoříme dočasný link
        const a = document.createElement('a');
        a.href = absoluteUrl;
        a.download = filename || '';
        a.target = '_blank';
        a.rel = 'noopener';
        document.body.appendChild(a);
        a.click();
        a.remove();
    }
    // ===== Upload modal =====
    /**
   * Otevře upload modal. Pokud je nastaven `replaceOf`, modal poběží v replace-režimu –
   * zákazník je předvyplněný + uzamčený, po úspěšném uploadu se starý soubor archivuje.
   *
   * @param {object} [opts]
   * @param {string} [opts.replaceOf] - ID souboru, který se má nahradit
   * @param {{id:string,name:string}} [opts.customer] - Předvyplněný zákazník (např. z aktivního filtru)
   */ openUploadModal(opts = {}) {
        const replaceOf = opts.replaceOf || null;
        const oldFile = replaceOf ? this.files.find((f)=>f.id === replaceOf) : null;
        // Předvyplnění zákazníka:
        // 1) replace mode – ze starého souboru (uzamčeno)
        // 2) jinak z aktivního filtru
        let customer = null;
        if (oldFile) customer = {
            id: oldFile.customerId,
            name: oldFile.customerName || ''
        };
        else if (opts.customer) customer = opts.customer;
        else if (this.selectedCustomer) customer = {
            ...this.selectedCustomer
        };
        this.renderUploadModal({
            replaceOf: replaceOf,
            oldFile: oldFile,
            customer: customer
        });
    }
    openReplaceModal(fileId) {
        this.openUploadModal({
            replaceOf: fileId
        });
    }
    renderUploadModal({ replaceOf: replaceOf, oldFile: oldFile, customer: customer }) {
        const modalId = 'files-upload-modal';
        this.removeModal(modalId);
        const isReplace = !!replaceOf;
        const title = isReplace ? "Nahradit soubor novou verz\xed" : "Nahr\xe1t soubory";
        const subtitle = isReplace && oldFile ? `P\u{16F}vodn\xed soubor: <span class="font-medium text-gray-700">${this.escape(oldFile.originalName)}</span> bude p\u{159}esunut do archivu.` : "Soubory budou p\u0159i\u0159azeny vybran\xe9mu z\xe1kazn\xedkovi. M\u016F\u017Eete p\u0159idat v\xedce soubor\u016F nar\xe1z.";
        const customerLocked = !!isReplace;
        const customerLabel = customer?.name || "Vyberte z\xe1kazn\xedka";
        const html = `
      <div id="${modalId}" class="fixed inset-0 z-50 overflow-y-auto" role="dialog" aria-modal="true">
        <div class="flex items-end sm:items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:p-0">
          <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" data-close="1"></div>
          <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl sm:w-full">
            <div class="p-6">
              <div class="flex items-start justify-between mb-4">
                <div class="min-w-0">
                  <h3 class="text-lg font-semibold text-gray-900">${title}</h3>
                  <p class="text-sm text-gray-500 mt-1">${subtitle}</p>
                </div>
                <button type="button" data-close="1" class="text-gray-400 hover:text-gray-600 -mt-1 -mr-1 p-1">
                  ${(0, $entK4.icon)('x-mark', 'w-5 h-5')}
                </button>
              </div>

              <div class="space-y-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">
                    Z\xe1kazn\xedk <span class="text-red-500">*</span>
                  </label>
                  <button type="button" id="files-upload-customer-btn"
                    class="w-full inline-flex items-center justify-between px-3 py-2 border border-gray-300 rounded-md text-sm bg-white hover:bg-gray-50 ${customerLocked ? 'opacity-60 cursor-not-allowed' : ''}"
                    ${customerLocked ? 'disabled' : ''}>
                    <span id="files-upload-customer-label" class="truncate ${customer ? 'text-gray-900' : 'text-gray-400'}">${this.escape(customerLabel)}</span>
                    ${customerLocked ? (0, $entK4.icon)('lock-closed', 'w-4 h-4 text-gray-400 flex-shrink-0 ml-2') : (0, $entK4.icon)('magnifying-glass', 'w-4 h-4 text-gray-400 flex-shrink-0 ml-2')}
                  </button>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Popis (voliteln\xfd)</label>
                  <input type="text" id="files-upload-description"
                    placeholder="Kr\xe1tk\xfd popis souboru, nap\u{159}. \u{201E}Vizitky \u{2013} druh\xe1 korektura"
                    value="${this.escape(oldFile?.description || '')}"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">${isReplace ? 'Soubor' : 'Soubory'}</label>
                  <div id="files-upload-dropzone"
                    class="relative border-2 border-dashed border-gray-300 rounded-lg p-6 transition-colors hover:border-blue-400 hover:bg-blue-50/30 cursor-pointer focus-within:ring-2 focus-within:ring-blue-500">
                    <input type="file" id="files-upload-input"
                      ${isReplace ? '' : 'multiple'}
                      class="absolute inset-0 w-full h-full opacity-0 cursor-pointer">
                    <div id="files-upload-dropzone-content" class="text-center pointer-events-none">
                      ${(0, $entK4.icon)('cloud-arrow-up', 'mx-auto h-10 w-10 text-gray-400 mb-2')}
                      <p class="text-sm text-gray-700">
                        ${isReplace ? "P\u0159et\xe1hn\u011Bte soubor sem nebo" : "P\u0159et\xe1hn\u011Bte soubory sem nebo"}
                        <span class="text-blue-600 font-medium">klikn\u{11B}te pro v\xfdb\u{11B}r</span>
                      </p>
                      <p id="files-upload-size-hint" class="text-xs text-gray-500 mt-1">Maxim\xe1ln\xed velikost se na\u{10D}\xedt\xe1\u{2026}</p>
                    </div>
                  </div>
                  <div id="files-upload-file-preview" class="hidden mt-3"></div>
                  <div id="files-upload-progress" class="hidden mt-3">
                    <div class="flex items-center justify-between text-xs text-gray-600 mb-1">
                      <span id="files-upload-progress-label">P\u{159}ipravuji\u{2026}</span>
                      <span id="files-upload-progress-pct" class="tabular-nums">0 %</span>
                    </div>
                    <div class="w-full h-2 bg-gray-100 rounded-full overflow-hidden">
                      <div id="files-upload-progress-bar" class="h-full bg-blue-500 transition-all duration-150" style="width: 0%"></div>
                    </div>
                  </div>
                </div>

                <div id="files-upload-error" class="hidden bg-red-50 border border-red-200 rounded-md p-3 text-sm text-red-800"></div>
              </div>

              <div class="mt-6 flex justify-end gap-2">
                <button type="button" data-close="1"
                  class="inline-flex justify-center px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
                  Zru\u{161}it
                </button>
                <button type="button" id="files-upload-submit"
                  class="inline-flex justify-center px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-blue-300 disabled:cursor-not-allowed"
                  disabled>
                  ${isReplace ? 'Nahradit soubor' : "Nahr\xe1t soubory"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        document.body.appendChild(wrapper);
        // Interní stav uploadu (uvnitř instance, ne globální)
        this._uploadState = {
            replaceOf: replaceOf,
            isReplace: isReplace,
            customer: customer ? {
                ...customer
            } : null,
            customerLocked: customerLocked,
            files: [],
            uploading: false,
            maxFileSizeMb: null,
            storageMode: null // 'blob' | 'local'
        };
        this.bindUploadModalEvents(modalId);
        // Naplň informaci o limitu z /upload-url (a uložíme storage mode pro odeslání)
        this.fetchUploadConfig().catch((err)=>console.warn("Nepoda\u0159ilo se na\u010D\xedst upload-url:", err));
    }
    bindUploadModalEvents(modalId) {
        const modal = document.getElementById(modalId);
        if (!modal) return;
        modal.querySelectorAll('[data-close="1"]').forEach((el)=>{
            el.addEventListener('click', ()=>this.closeUploadModal());
        });
        document.getElementById('files-upload-customer-btn')?.addEventListener('click', async ()=>{
            if (this._uploadState.customerLocked) return;
            if (!window.customersManager) {
                this.notify("Z\xe1kazn\xedci nejsou je\u0161t\u011B na\u010Dteni", 'warning');
                return;
            }
            const c = await window.customersManager.openSelector();
            if (!c) return;
            this._uploadState.customer = {
                id: c.id,
                name: c.name
            };
            const lbl = document.getElementById('files-upload-customer-label');
            if (lbl) {
                lbl.textContent = c.name;
                lbl.classList.remove('text-gray-400');
                lbl.classList.add('text-gray-900');
            }
            this.refreshUploadSubmitState();
        });
        const input = document.getElementById('files-upload-input');
        input?.addEventListener('change', (e)=>{
            const list = e.target.files;
            if (list && list.length) this.addUploadFiles(list);
            // Reset inputu, aby šel vybrat znovu stejné soubory
            if (input) input.value = '';
        });
        const dropzone = document.getElementById('files-upload-dropzone');
        if (dropzone) {
            [
                'dragover',
                'dragenter'
            ].forEach((evt)=>{
                dropzone.addEventListener(evt, (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    dropzone.classList.add('border-blue-500', 'bg-blue-50');
                });
            });
            [
                'dragleave',
                'dragend',
                'drop'
            ].forEach((evt)=>{
                dropzone.addEventListener(evt, (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    dropzone.classList.remove('border-blue-500', 'bg-blue-50');
                });
            });
            dropzone.addEventListener('drop', (e)=>{
                const dt = e.dataTransfer;
                if (dt && dt.files && dt.files.length) this.addUploadFiles(dt.files);
            });
        }
        document.getElementById('files-upload-submit')?.addEventListener('click', ()=>{
            this.submitUpload();
        });
    }
    async fetchUploadConfig() {
        try {
            const res = await fetch(`${$02538f383e87444e$var$API_BASE_URL}/files/upload-url`, {
                credentials: 'include'
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const json = await res.json();
            const data = json.data || {};
            this._uploadState.maxFileSizeMb = Number(data.maxFileSizeMb) || 200;
            this._uploadState.storageMode = data.type === 'blob' ? 'blob' : 'local';
            const hint = document.getElementById('files-upload-size-hint');
            if (hint) hint.textContent = `Max. ${this._uploadState.maxFileSizeMb} MB \xb7 PDF, obr\xe1zky, ZIP a dal\u{161}\xed (krom\u{11B} spustiteln\xfdch soubor\u{16F}).`;
        } catch (err) {
            console.warn('Upload config fetch failed:', err);
            // Fallback hodnoty
            this._uploadState.maxFileSizeMb = 200;
            this._uploadState.storageMode = 'local';
            const hint = document.getElementById('files-upload-size-hint');
            if (hint) hint.textContent = "Max. 200 MB \xb7 PDF, obr\xe1zky, ZIP a dal\u0161\xed.";
        }
    }
    addUploadFiles(fileList) {
        this.clearUploadError();
        const maxMb = this._uploadState.maxFileSizeMb || 200;
        const incoming = Array.from(fileList || []);
        const rejected = [];
        const accepted = [];
        for (const file of incoming){
            const ext = $02538f383e87444e$var$getFileExtension(file.name);
            if ($02538f383e87444e$var$BLOCKED_EXTENSIONS.includes(ext)) {
                rejected.push(`${file.name} (zak\xe1zan\xe1 p\u{159}\xedpona .${ext})`);
                continue;
            }
            if (file.size > maxMb * 1048576) {
                rejected.push(`${file.name} (v\u{11B}t\u{161}\xed ne\u{17E} ${maxMb} MB)`);
                continue;
            }
            accepted.push(file);
        }
        // V replace režimu akceptuj jen jeden soubor (nahraď případný předchozí výběr)
        if (this._uploadState.isReplace && accepted.length > 0) {
            this._uploadState.files = [
                accepted[0]
            ];
            if (accepted.length > 1) rejected.push(`V re\u{17E}imu nahrazen\xed lze vybrat jen jeden soubor \u{2013} pou\u{17E}it ${accepted[0].name}, zbytek p\u{159}esko\u{10D}en.`);
        } else {
            // Deduplikace podle name+size+lastModified, abychom nepřidali stejný soubor 2×
            const existing = this._uploadState.files;
            for (const file of accepted){
                const dup = existing.some((f)=>f.name === file.name && f.size === file.size && f.lastModified === file.lastModified);
                if (!dup) existing.push(file);
            }
        }
        if (rejected.length) this.showUploadError(`N\u{11B}kter\xe9 soubory byly p\u{159}esko\u{10D}eny: ${rejected.join('; ')}.`);
        this.renderUploadPreview();
        this.refreshUploadSubmitState();
    }
    renderUploadPreview() {
        const preview = document.getElementById('files-upload-file-preview');
        if (!preview) return;
        const files = this._uploadState.files || [];
        if (files.length === 0) {
            preview.classList.add('hidden');
            preview.innerHTML = '';
            const dz = document.getElementById('files-upload-dropzone-content');
            dz?.classList.remove('hidden');
            return;
        }
        const totalSize = files.reduce((s, f)=>s + (Number(f.size) || 0), 0);
        const items = files.map((file, idx)=>{
            const iconSvg = this.getFileIconSvg(file.type, file.name);
            return `
        <div class="flex items-center gap-3 p-2.5 bg-gray-50 border border-gray-200 rounded-md">
          <div class="w-9 h-9 rounded-md bg-white ring-1 ring-gray-200 flex items-center justify-center text-gray-500 flex-shrink-0">
            ${iconSvg}
          </div>
          <div class="flex-1 min-w-0">
            <div class="text-sm font-medium text-gray-900 truncate" title="${this.escape(file.name)}">${this.escape(file.name)}</div>
            <div class="text-xs text-gray-500">${this.formatSize(file.size)}${file.type ? " \xb7 " + this.escape(file.type) : ''}</div>
          </div>
          <button type="button" data-file-remove="${idx}" class="text-gray-400 hover:text-red-500 p-1" title="Odebrat soubor">
            ${(0, $entK4.icon)('x-mark', 'w-4 h-4')}
          </button>
        </div>
      `;
        }).join('');
        preview.innerHTML = `
      <div class="space-y-2">
        ${items}
        <div class="flex items-center justify-between text-xs text-gray-500 px-1">
          <span>${files.length} ${this.plural(files.length, 'soubor', 'soubory', "soubor\u016F")} \xb7 ${this.formatSize(totalSize)}</span>
          <button type="button" id="files-upload-files-clear" class="text-gray-500 hover:text-red-500 underline">Odebrat v\u{161}e</button>
        </div>
      </div>
    `;
        preview.classList.remove('hidden');
        // Skrij dropzone content, když máme soubory (uživatel je může dál přidávat,
        // ale dropzone zůstává funkční – jen skryjeme ikonu)
        const dz = document.getElementById('files-upload-dropzone-content');
        if (dz && !this._uploadState.isReplace) dz.classList.add('hidden');
        preview.querySelectorAll('[data-file-remove]').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                const idx = Number(btn.dataset.fileRemove);
                if (Number.isInteger(idx)) {
                    this._uploadState.files.splice(idx, 1);
                    this.renderUploadPreview();
                    this.refreshUploadSubmitState();
                }
            });
        });
        document.getElementById('files-upload-files-clear')?.addEventListener('click', ()=>{
            this._uploadState.files = [];
            const input = document.getElementById('files-upload-input');
            if (input) input.value = '';
            this.renderUploadPreview();
            this.refreshUploadSubmitState();
        });
    }
    refreshUploadSubmitState() {
        const btn = document.getElementById('files-upload-submit');
        if (!btn) return;
        const state = this._uploadState;
        const ready = !state.uploading && state.files.length > 0 && !!state.customer?.id;
        btn.disabled = !ready;
    }
    showUploadError(message) {
        const errEl = document.getElementById('files-upload-error');
        if (!errEl) return;
        errEl.textContent = message;
        errEl.classList.remove('hidden');
    }
    clearUploadError() {
        const errEl = document.getElementById('files-upload-error');
        if (!errEl) return;
        errEl.classList.add('hidden');
        errEl.textContent = '';
    }
    setUploadProgress(percent, label) {
        const wrap = document.getElementById('files-upload-progress');
        const bar = document.getElementById('files-upload-progress-bar');
        const pct = document.getElementById('files-upload-progress-pct');
        const lbl = document.getElementById('files-upload-progress-label');
        if (!wrap || !bar || !pct) return;
        wrap.classList.remove('hidden');
        const p = Math.max(0, Math.min(100, Math.round(percent)));
        bar.style.width = `${p}%`;
        pct.textContent = `${p} %`;
        if (label && lbl) lbl.textContent = label;
    }
    hideUploadProgress() {
        document.getElementById('files-upload-progress')?.classList.add('hidden');
    }
    async submitUpload() {
        const state = this._uploadState;
        if (!state || state.uploading || state.files.length === 0 || !state.customer?.id) return;
        const descriptionEl = document.getElementById('files-upload-description');
        const description = descriptionEl ? descriptionEl.value.trim() : '';
        state.uploading = true;
        this.refreshUploadSubmitState();
        document.getElementById('files-upload-submit')?.classList.add('opacity-75');
        this.clearUploadError();
        this.setUploadProgress(0, "P\u0159ipravuji\u2026");
        const files = state.isReplace ? state.files.slice(0, 1) : state.files.slice();
        let okCount = 0;
        const errors = [];
        try {
            for(let i = 0; i < files.length; i++){
                const file = files[i];
                const baseLabel = files.length > 1 ? `Soubor ${i + 1}/${files.length}: ${file.name}` : file.name;
                try {
                    // eslint-disable-next-line no-await-in-loop
                    if (state.storageMode === 'blob') await this.uploadViaBlob(state, file, description);
                    else await this.uploadViaLocal(state, file, description);
                    okCount += 1;
                } catch (err) {
                    console.error(`Chyba p\u{159}i uploadu souboru ${file.name}:`, err);
                    errors.push(`${file.name}: ${err.message || "Upload se nezda\u0159il"}`);
                }
            }
            if (errors.length) {
                if (okCount > 0) {
                    this.showUploadError(`N\u{11B}kter\xe9 soubory se nepoda\u{159}ilo nahr\xe1t (${errors.length} z ${files.length}):\n${errors.join('\n')}`);
                    this.notify(`${okCount} z ${files.length} soubor\u{16F} nahr\xe1no`, 'warning');
                } else this.showUploadError(errors.join('\n'));
                this.hideUploadProgress();
            } else {
                this.setUploadProgress(100, 'Hotovo');
                const msg = state.replaceOf ? 'Soubor byl nahrazen' : okCount > 1 ? `${okCount} soubor\u{16F} bylo nahr\xe1no` : "Soubor byl nahr\xe1n";
                this.notify(msg, 'success');
                this.closeUploadModal();
            }
            if (okCount > 0) await this.loadFiles();
        } finally{
            state.uploading = false;
            document.getElementById('files-upload-submit')?.classList.remove('opacity-75');
            this.refreshUploadSubmitState();
        }
    }
    /**
   * Dev / fallback flow: XHR multipart POST na /api/files/upload (s progress events).
   */ uploadViaLocal(state, file, description) {
        return new Promise((resolve, reject)=>{
            const fd = new FormData();
            fd.append('file', file);
            fd.append('customerId', state.customer.id);
            if (state.customer.name) fd.append('customerName', state.customer.name);
            if (description) fd.append('description', description);
            if (state.replaceOf) fd.append('replaceOf', state.replaceOf);
            const xhr = new XMLHttpRequest();
            xhr.open('POST', `${$02538f383e87444e$var$API_BASE_URL}/files/upload`);
            xhr.withCredentials = true;
            xhr.upload.onprogress = (e)=>{
                if (e.lengthComputable) {
                    const pct = e.loaded / e.total * 100;
                    // Necháme posledních ~5 % pro server-side zpracování (rename, metadata zápis)
                    this.setUploadProgress(Math.min(95, pct), `Nahr\xe1v\xe1m: ${file.name}`);
                }
            };
            xhr.upload.onloadend = ()=>{
                this.setUploadProgress(95, `Zpracov\xe1v\xe1m: ${file.name}`);
            };
            xhr.onload = ()=>{
                if (xhr.status >= 200 && xhr.status < 300) try {
                    const json = JSON.parse(xhr.responseText);
                    if (json.success) return resolve(json.data);
                    return reject(new Error(json.error || 'Upload selhal'));
                } catch (e) {
                    return reject(new Error("Neplatn\xe1 odpov\u011B\u010F serveru"));
                }
                let message = `Upload selhal (HTTP ${xhr.status})`;
                try {
                    const j = JSON.parse(xhr.responseText);
                    if (j && j.error) message = j.error;
                } catch (_) {}
                reject(new Error(message));
            };
            xhr.onerror = ()=>reject(new Error("Chyba s\xedt\u011B"));
            xhr.onabort = ()=>reject(new Error("Upload zru\u0161en"));
            xhr.send(fd);
        });
    }
    /**
   * Production flow: client-upload přímo na Vercel Blob přes @vercel/blob/client.
   * Po úspěchu zapíše metadata přes POST /api/files (s případným replaceOf).
   */ async uploadViaBlob(state, file, description) {
        // Dynamický import – parcel vytvoří separátní chunk a stáhne ho jen v blob režimu
        const { upload: upload } = await (parcelRequire("5LbsB"));
        const clientPayload = JSON.stringify({
            customerId: state.customer.id,
            description: description || '',
            replaceOf: state.replaceOf || null
        });
        const result = await upload(file.name, file, {
            access: 'public',
            handleUploadUrl: `${$02538f383e87444e$var$API_BASE_URL}/files/upload-token`,
            clientPayload: clientPayload,
            onUploadProgress: ({ percentage: percentage })=>{
                this.setUploadProgress(Math.min(95, percentage), `Nahr\xe1v\xe1m: ${file.name}`);
            }
        });
        this.setUploadProgress(96, `Ukl\xe1d\xe1m metadata: ${file.name}`);
        // Zapiš metadata na backend
        const metaRes = await fetch(`${$02538f383e87444e$var$API_BASE_URL}/files`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                originalName: file.name,
                size: file.size,
                mimeType: file.type,
                storageUrl: result.url,
                customerId: state.customer.id,
                customerName: state.customer.name || '',
                description: description || '',
                replaceOf: state.replaceOf || null
            })
        });
        if (!metaRes.ok) {
            const text = await metaRes.text().catch(()=>'');
            throw new Error(text || `Ulo\u{17E}en\xed metadat selhalo (HTTP ${metaRes.status})`);
        }
        const json = await metaRes.json();
        if (!json.success) throw new Error(json.error || "Ulo\u017Een\xed metadat selhalo");
        return json.data;
    }
    closeUploadModal() {
        this.removeModal('files-upload-modal');
        this._uploadState = null;
    }
    removeModal(id) {
        const el = document.getElementById(id);
        if (el && el.parentNode) el.parentNode.remove();
    }
    // ===== Stats panel =====
    renderStats() {
        const el = document.getElementById('files-stats');
        if (!el) return;
        if (!this.stats) {
            el.innerHTML = '';
            return;
        }
        const t = this.stats.totals || {};
        const perCustomer = this.stats.perCustomer || [];
        // Pokud je vybrán filtr, najdi statistiky daného zákazníka
        const selectedStat = this.selectedCustomer ? perCustomer.find((p)=>p.customerId === this.selectedCustomer.id) : null;
        const topThree = perCustomer.slice(0, 3);
        el.innerHTML = `
      <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
        ${this.renderStatCard({
            label: "Celkov\xe9 m\xedsto",
            value: this.formatSize(t.size || 0),
            sub: `${(t.count || 0).toLocaleString('cs-CZ')} ${this.plural(t.count || 0, 'soubor', 'soubory', "soubor\u016F")}`,
            color: 'blue',
            icon: 'folder'
        })}
        ${this.renderStatCard({
            label: "Aktivn\xed",
            value: this.formatSize(t.activeSize || 0),
            sub: `${(t.activeCount || 0).toLocaleString('cs-CZ')} ${this.plural(t.activeCount || 0, 'soubor', 'soubory', "soubor\u016F")}`,
            color: 'emerald',
            icon: 'check'
        })}
        ${this.renderStatCard({
            label: "Archivov\xe1no",
            value: this.formatSize(t.archivedSize || 0),
            sub: `${(t.archivedCount || 0).toLocaleString('cs-CZ')} ${this.plural(t.archivedCount || 0, 'soubor', 'soubory', "soubor\u016F")}`,
            color: 'gray',
            icon: 'archive-box'
        })}
        ${this.renderStatCard({
            label: selectedStat ? "Vybran\xfd z\xe1kazn\xedk" : "Z\xe1kazn\xedci se soubory",
            value: selectedStat ? this.formatSize(selectedStat.size || 0) : perCustomer.length.toLocaleString('cs-CZ'),
            sub: selectedStat ? `${(selectedStat.count || 0).toLocaleString('cs-CZ')} ${this.plural(selectedStat.count || 0, 'soubor', 'soubory', "soubor\u016F")}` : perCustomer.length === 1 ? "1 z\xe1kazn\xedk" : `${perCustomer.length} z\xe1kazn\xedk\u{16F}`,
            color: 'indigo',
            icon: 'user-group'
        })}
      </div>

      ${!this.selectedCustomer && topThree.length > 0 ? `
        <div class="mt-3 bg-white rounded-lg border border-gray-200 p-3">
          <div class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Nejv\u{11B}t\u{161}\xed z\xe1kazn\xedci podle velikosti soubor\u{16F}</div>
          <div class="flex flex-wrap gap-2">
            ${topThree.map((c)=>`
              <button type="button" data-customer-id="${this.escape(c.customerId || '')}" data-customer-name="${this.escape(c.customerName || '')}"
                class="files-stats-customer inline-flex items-center gap-2 px-2.5 py-1 rounded-full text-xs bg-gray-50 hover:bg-blue-50 hover:text-blue-700 ring-1 ring-gray-200 hover:ring-blue-200 transition-colors">
                <span class="font-medium truncate max-w-[12rem]">${this.escape(c.customerName || "(bez jm\xe9na)")}</span>
                <span class="text-gray-500">${this.formatSize(c.size || 0)}</span>
                <span class="text-gray-400">\xb7</span>
                <span class="text-gray-500">${c.count}\xd7</span>
              </button>`).join('')}
          </div>
        </div>` : ''}
    `;
        // Klik na kartičku zákazníka v Top 3 → nastavit filtr
        el.querySelectorAll('.files-stats-customer').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                const id = btn.dataset.customerId;
                const name = btn.dataset.customerName;
                if (!id) return;
                this.selectedCustomer = {
                    id: id,
                    name: name
                };
                this.updateCustomerLabel();
                this.loadFiles();
            });
        });
    }
    renderStatCard({ label: label, value: value, sub: sub, color: color, icon: iconName }) {
        const colors = {
            blue: {
                bg: 'bg-blue-50',
                text: 'text-blue-600',
                accent: 'text-blue-900'
            },
            emerald: {
                bg: 'bg-emerald-50',
                text: 'text-emerald-600',
                accent: 'text-emerald-900'
            },
            gray: {
                bg: 'bg-gray-50',
                text: 'text-gray-500',
                accent: 'text-gray-900'
            },
            indigo: {
                bg: 'bg-indigo-50',
                text: 'text-indigo-600',
                accent: 'text-indigo-900'
            }
        };
        const c = colors[color] || colors.gray;
        return `
      <div class="bg-white rounded-lg border border-gray-200 p-3 flex items-start gap-3 shadow-sm">
        <div class="flex-shrink-0 w-9 h-9 rounded-md ${c.bg} ${c.text} flex items-center justify-center">
          ${(0, $entK4.icon)(iconName, 'w-5 h-5')}
        </div>
        <div class="min-w-0">
          <div class="text-[11px] uppercase tracking-wide text-gray-500 font-medium">${this.escape(label)}</div>
          <div class="text-base sm:text-lg font-semibold ${c.accent} truncate tabular-nums" title="${this.escape(String(value))}">${this.escape(String(value))}</div>
          <div class="text-xs text-gray-500">${this.escape(sub || '')}</div>
        </div>
      </div>
    `;
    }
    // ===== Maintenance modal =====
    openMaintenanceModal() {
        const modalId = 'files-maintenance-modal';
        this.removeModal(modalId);
        const totals = this.stats?.totals || {};
        const totalSizeStr = this.formatSize(totals.size || 0);
        const totalCount = totals.count || 0;
        // Předvyplnit filtr aktuálně vybraného zákazníka, pokud existuje
        const scopedCustomer = this.selectedCustomer ? {
            ...this.selectedCustomer
        } : null;
        const html = `
      <div id="${modalId}" class="fixed inset-0 z-50 overflow-y-auto" role="dialog" aria-modal="true">
        <div class="flex items-end sm:items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:p-0">
          <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" data-close="1"></div>
          <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
            <div class="p-6">
              <div class="flex items-start justify-between mb-4">
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">\xdadr\u{17E}ba \xfalo\u{17E}i\u{161}t\u{11B}</h3>
                  <p class="text-sm text-gray-500 mt-1">Hromadn\u{11B} sma\u{17E}e star\xe9 soubory podle vybran\xfdch krit\xe9ri\xed.</p>
                </div>
                <button type="button" data-close="1" class="text-gray-400 hover:text-gray-600 -mt-1 -mr-1 p-1">
                  ${(0, $entK4.icon)('x-mark', 'w-5 h-5')}
                </button>
              </div>

              <div class="bg-gray-50 border border-gray-200 rounded-md p-3 mb-4 text-xs text-gray-600">
                Aktu\xe1ln\u{11B} ulo\u{17E}en\xe9: <strong class="text-gray-900">${this.escape(totalSizeStr)}</strong> v ${totalCount.toLocaleString('cs-CZ')} ${this.plural(totalCount, 'souboru', 'souborech', 'souborech')}.
              </div>

              <div class="space-y-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Smazat soubory star\u{161}\xed ne\u{17E}</label>
                  <div class="flex items-center gap-2">
                    <input type="number" id="files-maint-days" min="1" step="1" value="90"
                      class="w-24 px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 tabular-nums">
                    <span class="text-sm text-gray-600">dn\xed</span>
                  </div>
                  <div class="mt-2 flex flex-wrap gap-1.5">
                    ${[
            30,
            90,
            180,
            365
        ].map((d)=>`
                      <button type="button" data-preset="${d}"
                        class="files-maint-preset inline-flex items-center px-2 py-0.5 rounded-md text-xs border border-gray-200 text-gray-600 hover:bg-gray-50">
                        ${d} dn\xed
                      </button>`).join('')}
                  </div>
                </div>

                <div>
                  <label class="flex items-center gap-2 mb-1">
                    <input type="checkbox" id="files-maint-scope-customer" ${scopedCustomer ? 'checked' : ''}
                      class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                    <span class="text-sm font-medium text-gray-700">Omezit na jednoho z\xe1kazn\xedka</span>
                  </label>
                  <div id="files-maint-customer-row" class="${scopedCustomer ? '' : 'hidden'} pl-6">
                    <button type="button" id="files-maint-customer-btn"
                      class="w-full inline-flex items-center justify-between px-3 py-2 border border-gray-300 rounded-md text-sm bg-white hover:bg-gray-50">
                      <span id="files-maint-customer-label" class="truncate ${scopedCustomer ? 'text-gray-900' : 'text-gray-400'}">
                        ${this.escape(scopedCustomer?.name || "Vybrat z\xe1kazn\xedka")}
                      </span>
                      ${(0, $entK4.icon)('magnifying-glass', 'w-4 h-4 text-gray-400 flex-shrink-0 ml-2')}
                    </button>
                  </div>
                </div>

                <label class="flex items-center gap-2">
                  <input type="checkbox" id="files-maint-include-archived" checked
                    class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                  <span class="text-sm text-gray-700">Smazat i archivovan\xe9 verze</span>
                </label>
              </div>

              <div id="files-maint-preview" class="mt-4 hidden">
                <div class="bg-amber-50 border border-amber-200 rounded-md p-3 text-sm text-amber-900">
                  <div class="font-semibold mb-1">K odstran\u{11B}n\xed p\u{159}ipraveno:</div>
                  <div id="files-maint-preview-text" class="text-amber-800"></div>
                </div>
              </div>

              <div id="files-maint-error" class="hidden mt-3 bg-red-50 border border-red-200 rounded-md p-3 text-sm text-red-800"></div>

              <div class="mt-6 flex justify-end gap-2 flex-wrap">
                <button type="button" data-close="1"
                  class="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
                  Zru\u{161}it
                </button>
                <button type="button" id="files-maint-preview-btn"
                  class="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
                  N\xe1hled (po\u{10D}et soubor\u{16F})
                </button>
                <button type="button" id="files-maint-purge-btn"
                  class="inline-flex items-center px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-red-600 hover:bg-red-700 disabled:bg-red-300 disabled:cursor-not-allowed">
                  ${(0, $entK4.icon)('trash', 'w-4 h-4 mr-2')}
                  Smazat
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
        const wrap = document.createElement('div');
        wrap.innerHTML = html;
        document.body.appendChild(wrap);
        this._maintState = {
            customer: scopedCustomer
        };
        this.bindMaintenanceModalEvents(modalId);
    }
    bindMaintenanceModalEvents(modalId) {
        const modal = document.getElementById(modalId);
        if (!modal) return;
        const close = ()=>this.removeModal(modalId);
        modal.querySelectorAll('[data-close="1"]').forEach((el)=>el.addEventListener('click', close));
        // Presety dní
        modal.querySelectorAll('.files-maint-preset').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                const input = document.getElementById('files-maint-days');
                if (input) input.value = btn.dataset.preset;
                document.getElementById('files-maint-preview')?.classList.add('hidden');
            });
        });
        // Zobrazení / skrytí řádku s customerem
        const scopeChk = document.getElementById('files-maint-scope-customer');
        const customerRow = document.getElementById('files-maint-customer-row');
        scopeChk?.addEventListener('change', ()=>{
            if (scopeChk.checked) customerRow?.classList.remove('hidden');
            else {
                customerRow?.classList.add('hidden');
                this._maintState.customer = null;
                this.updateMaintenanceCustomerLabel();
            }
            document.getElementById('files-maint-preview')?.classList.add('hidden');
        });
        document.getElementById('files-maint-customer-btn')?.addEventListener('click', async ()=>{
            if (!window.customersManager) {
                this.notify("Z\xe1kazn\xedci nejsou je\u0161t\u011B na\u010Dteni", 'warning');
                return;
            }
            const c = await window.customersManager.openSelector();
            if (!c) return;
            this._maintState.customer = {
                id: c.id,
                name: c.name
            };
            this.updateMaintenanceCustomerLabel();
            document.getElementById('files-maint-preview')?.classList.add('hidden');
        });
        document.getElementById('files-maint-preview-btn')?.addEventListener('click', ()=>this.runMaintenance({
                dryRun: true
            }));
        document.getElementById('files-maint-purge-btn')?.addEventListener('click', ()=>this.runMaintenance({
                dryRun: false
            }));
    }
    updateMaintenanceCustomerLabel() {
        const lbl = document.getElementById('files-maint-customer-label');
        if (!lbl) return;
        const c = this._maintState?.customer;
        if (c) {
            lbl.textContent = c.name;
            lbl.classList.remove('text-gray-400');
            lbl.classList.add('text-gray-900');
        } else {
            lbl.textContent = "Vybrat z\xe1kazn\xedka";
            lbl.classList.add('text-gray-400');
            lbl.classList.remove('text-gray-900');
        }
    }
    async runMaintenance({ dryRun: dryRun }) {
        const errEl = document.getElementById('files-maint-error');
        const previewEl = document.getElementById('files-maint-preview');
        const previewText = document.getElementById('files-maint-preview-text');
        errEl?.classList.add('hidden');
        const days = Number(document.getElementById('files-maint-days')?.value);
        if (!Number.isFinite(days) || days <= 0) {
            if (errEl) {
                errEl.textContent = "Zadejte kladn\xfd po\u010Det dn\xed.";
                errEl.classList.remove('hidden');
            }
            return;
        }
        const scopeChecked = document.getElementById('files-maint-scope-customer')?.checked;
        const customer = scopeChecked ? this._maintState?.customer : null;
        if (scopeChecked && !customer) {
            if (errEl) {
                errEl.textContent = "Vyberte z\xe1kazn\xedka, na kter\xe9ho se m\xe1 \xfadr\u017Eba omezit.";
                errEl.classList.remove('hidden');
            }
            return;
        }
        const includeArchived = !!document.getElementById('files-maint-include-archived')?.checked;
        // Pro skutečné mazání ještě confirm
        if (!dryRun) {
            const previewVisible = previewEl && !previewEl.classList.contains('hidden');
            const scopeText = customer ? ` z\xe1kazn\xedka \u{201E}${customer.name}"` : '';
            const message = previewVisible ? `Opravdu nevratn\u{11B} smazat soubory${scopeText} star\u{161}\xed ne\u{17E} ${days} dn\xed?` : `Opravdu nevratn\u{11B} smazat v\u{161}echny soubory${scopeText} star\u{161}\xed ne\u{17E} ${days} dn\xed?

Doporu\u{10D}ujeme nejd\u{159}\xedv zobrazit n\xe1hled.`;
            if (!confirm(message)) return;
        }
        const purgeBtn = document.getElementById('files-maint-purge-btn');
        const previewBtn = document.getElementById('files-maint-preview-btn');
        if (purgeBtn) purgeBtn.disabled = true;
        if (previewBtn) previewBtn.disabled = true;
        try {
            const res = await fetch(`${$02538f383e87444e$var$API_BASE_URL}/files/maintenance/purge`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    days: days,
                    customerId: customer?.id || null,
                    includeArchived: includeArchived,
                    dryRun: dryRun
                })
            });
            if (!res.ok) {
                const text = await res.text().catch(()=>'');
                throw new Error(text || `HTTP ${res.status}`);
            }
            const json = await res.json();
            const data = json.data || {};
            if (dryRun) {
                const count = data.matchedCount || 0;
                const size = this.formatSize(data.matchedSize || 0);
                if (previewText) previewText.innerHTML = count === 0 ? `\u{17D}\xe1dn\xfd soubor neodpov\xedd\xe1 krit\xe9ri\xedm \u{2013} nen\xed co mazat.` : `<strong>${count}</strong> ${this.plural(count, 'soubor', 'soubory', "soubor\u016F")} \xb7 ${this.escape(size)}`;
                previewEl?.classList.remove('hidden');
            } else {
                const count = data.deletedCount || 0;
                const size = this.formatSize(data.deletedSize || 0);
                if (count === 0) this.notify("\u017D\xe1dn\xfd soubor nespl\u0148oval krit\xe9ria \u2013 nic nebylo smaz\xe1no.", 'info');
                else {
                    let msg = `Smaz\xe1no ${count} ${this.plural(count, 'soubor', 'soubory', "soubor\u016F")} (${size}).`;
                    if (data.binaryErrors > 0) msg += ` Pozn.: ${data.binaryErrors} bin\xe1rn\xedch soubor\u{16F} se nepoda\u{159}ilo smazat z disku.`;
                    this.notify(msg, count > 0 ? 'success' : 'info');
                }
                this.removeModal('files-maintenance-modal');
                this.loadFiles();
            }
        } catch (err) {
            console.error("\xdadr\u017Eba selhala:", err);
            if (errEl) {
                errEl.textContent = err.message || "\xdadr\u017Eba se nezda\u0159ila";
                errEl.classList.remove('hidden');
            }
        } finally{
            if (purgeBtn) purgeBtn.disabled = false;
            if (previewBtn) previewBtn.disabled = false;
        }
    }
    // ===== Utility =====
    formatSize(bytes) {
        const n = Number(bytes) || 0;
        if (n < 1024) return `${n} B`;
        if (n < 1048576) return `${(n / 1024).toFixed(1)} KB`;
        if (n < 1073741824) return `${(n / 1048576).toFixed(1)} MB`;
        return `${(n / 1073741824).toFixed(2)} GB`;
    }
    formatDateTime(iso) {
        if (!iso) return '-';
        try {
            const d = new Date(iso);
            return d.toLocaleString('cs-CZ', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (_) {
            return '-';
        }
    }
    plural(n, one, few, many) {
        const abs = Math.abs(n);
        if (abs === 1) return one;
        if (abs >= 2 && abs <= 4) return few;
        return many;
    }
    /**
   * Vrací inline SVG ikonu podle typu souboru (sdílená implementace v icons.js).
   */ getFileIconSvg(mimeType, filename) {
        return (0, $entK4.getFileIconSvg)(mimeType, filename);
    }
    async copyToClipboard(text) {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return;
        }
        // Fallback (insecure context / staré prohlížeče)
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try {
            document.execCommand('copy');
        } finally{
            ta.remove();
        }
    }
    notify(msg, type = 'info') {
        if (typeof window.showNotification === 'function') window.showNotification(msg, type);
        else console.log(`[${type}] ${msg}`);
    }
    escape(str) {
        if (str == null) return '';
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
}
window.FilesManager = $02538f383e87444e$export$7d691179cffa4ac0;


// Administrace uživatelů (pouze pro roli admin)
// Vzorováno na materials-admin.js – seznam + modály pro create/edit/reset/delete.

var $entK4 = parcelRequire("entK4");
class $6d164d6d27cb07b0$export$d6f738b7ad05096e {
    constructor(){
        this.baseUrl = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
        this.users = [];
        this._loaded = false;
    }
    // Získat informace o roli aktuálního uživatele
    getCurrentUserRole() {
        try {
            const userData = localStorage.getItem('currentUser');
            if (userData) return JSON.parse(userData).role;
        } catch (error) {
            console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed role u\u017Eivatele:", error);
        }
        return null;
    }
    isAdmin() {
        return this.getCurrentUserRole() === 'admin';
    }
    getAuthHeaders() {
        // SEC-7: autentizaci nese httpOnly cookie (credentials: 'include').
        // Legacy Bearer token z localStorage už nepoužíváme.
        return {};
    }
    // Voláno při přepnutí na sekci "Uživatelé"
    async showSection() {
        if (!this.isAdmin()) {
            this.showError("Nem\xe1te opr\xe1vn\u011Bn\xed zobrazit spr\xe1vu u\u017Eivatel\u016F.");
            return;
        }
        await this.loadUsers();
        this.renderUsers();
    }
    async loadUsers() {
        const container = document.getElementById('users-container');
        if (container) container.innerHTML = `
        <div class="flex justify-center p-8">
          ${(0, $entK4.icon)('spinner', 'animate-spin h-8 w-8 text-blue-500', {
            role: 'status'
        })}
          <span class="sr-only">Na\u{10D}\xedt\xe1m...</span>
        </div>`;
        try {
            const response = await fetch(`${this.baseUrl}/users`, {
                headers: {
                    ...this.getAuthHeaders()
                },
                credentials: 'include'
            });
            const result = await response.json();
            if (response.ok && result.success) {
                this.users = Array.isArray(result.data) ? result.data : [];
                this._loaded = true;
            } else throw new Error(result.message || "Nepoda\u0159ilo se na\u010D\xedst u\u017Eivatele");
        } catch (error) {
            console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed u\u017Eivatel\u016F:", error);
            this.users = [];
            if (container) container.innerHTML = `
          <div class="bg-red-50 border border-red-200 rounded-md p-4 text-sm text-red-800">
            Chyba p\u{159}i na\u{10D}\xedt\xe1n\xed u\u{17E}ivatel\u{16F}: ${error.message}
          </div>`;
        }
    }
    roleLabel(role) {
        return role === 'admin' ? "Administr\xe1tor" : "Obchodn\xedk";
    }
    escapeHtml(value) {
        return String(value ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    renderUsers() {
        const container = document.getElementById('users-container');
        if (!container) return;
        if (!this.users.length) {
            container.innerHTML = `
        <div class="text-center py-12">
          ${(0, $entK4.icon)('users', 'mx-auto h-12 w-12 text-ink-faint mb-3')}
          <h3 class="text-base font-medium text-ink-muted mb-1">Zat\xedm \u{17E}\xe1dn\xed u\u{17E}ivatel\xe9</h3>
          <p class="text-sm text-ink-faint">Za\u{10D}n\u{11B}te p\u{159}id\xe1n\xedm u\u{17E}ivatele tla\u{10D}\xedtkem \u{201E}P\u{159}idat u\u{17E}ivatele".</p>
        </div>`;
            return;
        }
        let rows = '';
        this.users.forEach((user)=>{
            const name = this.escapeHtml(user.name);
            const username = this.escapeHtml(user.username);
            const email = this.escapeHtml(user.email || '');
            const mustBadge = user.mustChangePassword ? `<span class="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-yellow-50 text-yellow-800 border border-yellow-200 text-[11px] font-medium">mus\xed zm\u{11B}nit heslo</span>` : '';
            const roleBadge = user.role === 'admin' ? `<span class="inline-flex items-center px-2 py-0.5 rounded bg-blue-50 text-blue-700 text-xs font-medium">Administr\xe1tor</span>` : `<span class="inline-flex items-center px-2 py-0.5 rounded bg-ink-50 text-ink-muted text-xs font-medium">Obchodn\xedk</span>`;
            const id = this.escapeHtml(user.id);
            rows += `
        <tr class="hover:bg-surface-1 transition-colors">
          <td class="px-4 py-2 whitespace-nowrap font-medium text-ink">${name} ${mustBadge}</td>
          <td class="px-4 py-2 text-ink-muted">${username}</td>
          <td class="px-4 py-2 text-ink-muted">${email || '<span class="text-ink-faint">\u2014</span>'}</td>
          <td class="px-4 py-2">${roleBadge}</td>
          <td class="px-4 py-2 text-right">
            <div class="flex justify-end gap-1">
              <button class="p-1.5 rounded-md hover:bg-brand-50 text-ink-muted hover:text-brand transition-colors" onclick="usersAdmin.editUser('${id}')" title="Upravit">
                ${(0, $entK4.icon)('pencil-square', 'w-4 h-4')}
              </button>
              <button class="p-1.5 rounded-md hover:bg-yellow-50 text-ink-muted hover:text-yellow-700 transition-colors" onclick="usersAdmin.resetPassword('${id}')" title="Reset hesla">
                ${(0, $entK4.icon)('key', 'w-4 h-4')}
              </button>
              <button class="p-1.5 rounded-md hover:bg-danger-soft text-ink-muted hover:text-danger transition-colors" onclick="usersAdmin.deleteUser('${id}')" title="Smazat">
                ${(0, $entK4.icon)('trash', 'w-4 h-4')}
              </button>
            </div>
          </td>
        </tr>`;
        });
        container.innerHTML = `
      <div class="overflow-x-auto border border-ink-100 rounded-lg">
        <table class="min-w-full text-sm">
          <thead>
            <tr class="bg-surface-1 text-ink-muted">
              <th class="px-4 py-2 text-left text-[11px] font-semibold uppercase tracking-wider">Jm\xe9no</th>
              <th class="px-4 py-2 text-left text-[11px] font-semibold uppercase tracking-wider">U\u{17E}ivatelsk\xe9 jm\xe9no</th>
              <th class="px-4 py-2 text-left text-[11px] font-semibold uppercase tracking-wider">Email</th>
              <th class="px-4 py-2 text-left text-[11px] font-semibold uppercase tracking-wider">Role</th>
              <th class="px-4 py-2 text-right text-[11px] font-semibold uppercase tracking-wider">Akce</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-ink-50">${rows}</tbody>
        </table>
      </div>`;
    }
    // ============================================================
    // Přidání uživatele
    // ============================================================
    showAddUserModal() {
        if (!document.getElementById('addUserModal')) this.createAddUserModal();
        const form = document.getElementById('addUserForm');
        if (form) form.reset();
        new TailwindModal('addUserModal').show();
    }
    createAddUserModal() {
        const modalHtml = `
      <div class="fixed inset-0 z-50 overflow-y-auto hidden" id="addUserModal" aria-labelledby="addUserModalLabel" aria-hidden="true">
        <div class="flex items-center justify-center min-h-screen px-4">
          <div class="fixed inset-0 bg-black opacity-50" id="modal-backdrop"></div>
          <div class="bg-white rounded-lg shadow-xl max-w-lg w-full relative">
            <div class="px-6 py-4 border-b border-gray-200">
              <h3 class="text-lg font-medium text-gray-900" id="addUserModalLabel">P\u{159}idat u\u{17E}ivatele</h3>
              <button type="button" class="absolute top-4 right-4 text-gray-400 hover:text-gray-600" id="modal-close-btn">
                ${(0, $entK4.icon)('x-mark', 'h-6 w-6')}
              </button>
            </div>
            <div class="px-6 py-4">
              <form id="addUserForm">
                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-2">U\u{17E}ivatelsk\xe9 jm\xe9no <span class="text-red-500">*</span></label>
                  <input type="text" id="addUserUsername" required minlength="3" maxlength="50" autocomplete="off" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="napr. jnovak">
                </div>
                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-2">Cel\xe9 jm\xe9no <span class="text-red-500">*</span></label>
                  <input type="text" id="addUserName" required minlength="2" maxlength="100" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="Jan Nov\xe1k">
                </div>
                <div class="grid grid-cols-2 gap-3 mb-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">Email</label>
                    <input type="email" id="addUserEmail" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="jan@firma.cz">
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">Telefon</label>
                    <input type="tel" id="addUserPhone" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="+420 XXX XXX XXX">
                  </div>
                </div>
                <div class="mb-2">
                  <label class="block text-sm font-medium text-gray-700 mb-2">Role <span class="text-red-500">*</span></label>
                  <select id="addUserRole" required class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-white">
                    <option value="sales">Obchodn\xedk</option>
                    <option value="admin">Administr\xe1tor</option>
                  </select>
                </div>
                <p class="text-xs text-gray-500">Po vytvo\u{159}en\xed se zobraz\xed do\u{10D}asn\xe9 heslo, kter\xe9 je nutn\xe9 p\u{159}edat u\u{17E}ivateli. Heslo se zobraz\xed pouze jednou.</p>
              </form>
            </div>
            <div class="px-6 py-4 border-t border-gray-200 flex justify-end space-x-3">
              <button type="button" class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" id="modal-cancel-btn">Zru\u{161}it</button>
              <button type="button" class="btn btn-primary" onclick="usersAdmin.addUser()">Vytvo\u{159}it u\u{17E}ivatele</button>
            </div>
          </div>
        </div>
      </div>`;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
    }
    async addUser() {
        const form = document.getElementById('addUserForm');
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }
        const payload = {
            username: document.getElementById('addUserUsername').value.trim(),
            name: document.getElementById('addUserName').value.trim(),
            email: document.getElementById('addUserEmail').value.trim(),
            phone: document.getElementById('addUserPhone').value.trim(),
            role: document.getElementById('addUserRole').value
        };
        try {
            const response = await fetch(`${this.baseUrl}/users`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...this.getAuthHeaders()
                },
                credentials: 'include',
                body: JSON.stringify(payload)
            });
            const result = await response.json();
            if (response.ok && result.success) {
                new TailwindModal('addUserModal').hide();
                const tempPassword = result.data?.tempPassword;
                await this.loadUsers();
                this.renderUsers();
                this.showTempPasswordDialog(tempPassword, payload.username, "U\u017Eivatel byl vytvo\u0159en");
            } else this.showError(result.message || "Nepoda\u0159ilo se vytvo\u0159it u\u017Eivatele");
        } catch (error) {
            console.error("Chyba p\u0159i vytv\xe1\u0159en\xed u\u017Eivatele:", error);
            this.showError("Chyba spojen\xed se serverem");
        }
    }
    // ============================================================
    // Úprava uživatele
    // ============================================================
    editUser(userId) {
        const user = this.users.find((u)=>String(u.id) === String(userId));
        if (!user) {
            this.showError("U\u017Eivatel nebyl nalezen.");
            return;
        }
        if (!document.getElementById('editUserModal')) this.createEditUserModal();
        document.getElementById('editUserId').value = user.id;
        document.getElementById('editUserName').value = user.name || '';
        document.getElementById('editUserEmail').value = user.email || '';
        document.getElementById('editUserPhone').value = user.phone || '';
        document.getElementById('editUserRole').value = user.role || 'sales';
        new TailwindModal('editUserModal').show();
    }
    createEditUserModal() {
        const modalHtml = `
      <div class="fixed inset-0 z-50 overflow-y-auto hidden" id="editUserModal" aria-labelledby="editUserModalLabel" aria-hidden="true">
        <div class="flex items-center justify-center min-h-screen px-4">
          <div class="fixed inset-0 bg-black opacity-50" id="modal-backdrop"></div>
          <div class="bg-white rounded-lg shadow-xl max-w-lg w-full relative">
            <div class="px-6 py-4 border-b border-gray-200">
              <h3 class="text-lg font-medium text-gray-900" id="editUserModalLabel">Upravit u\u{17E}ivatele</h3>
              <button type="button" class="absolute top-4 right-4 text-gray-400 hover:text-gray-600" id="modal-close-btn">
                ${(0, $entK4.icon)('x-mark', 'h-6 w-6')}
              </button>
            </div>
            <div class="px-6 py-4">
              <form id="editUserForm">
                <input type="hidden" id="editUserId">
                <div class="mb-4">
                  <label class="block text-sm font-medium text-gray-700 mb-2">Cel\xe9 jm\xe9no <span class="text-red-500">*</span></label>
                  <input type="text" id="editUserName" required minlength="2" maxlength="100" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
                </div>
                <div class="grid grid-cols-2 gap-3 mb-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">Email</label>
                    <input type="email" id="editUserEmail" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">Telefon</label>
                    <input type="tel" id="editUserPhone" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
                  </div>
                </div>
                <div class="mb-2">
                  <label class="block text-sm font-medium text-gray-700 mb-2">Role <span class="text-red-500">*</span></label>
                  <select id="editUserRole" required class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-white">
                    <option value="sales">Obchodn\xedk</option>
                    <option value="admin">Administr\xe1tor</option>
                  </select>
                </div>
              </form>
            </div>
            <div class="px-6 py-4 border-t border-gray-200 flex justify-end space-x-3">
              <button type="button" class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" id="modal-cancel-btn">Zru\u{161}it</button>
              <button type="button" class="btn btn-primary" onclick="usersAdmin.updateUser()">Ulo\u{17E}it zm\u{11B}ny</button>
            </div>
          </div>
        </div>
      </div>`;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
    }
    async updateUser() {
        const form = document.getElementById('editUserForm');
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }
        const userId = document.getElementById('editUserId').value;
        const payload = {
            name: document.getElementById('editUserName').value.trim(),
            email: document.getElementById('editUserEmail').value.trim(),
            phone: document.getElementById('editUserPhone').value.trim(),
            role: document.getElementById('editUserRole').value
        };
        try {
            const response = await fetch(`${this.baseUrl}/users/${userId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    ...this.getAuthHeaders()
                },
                credentials: 'include',
                body: JSON.stringify(payload)
            });
            const result = await response.json();
            if (response.ok && result.success) {
                new TailwindModal('editUserModal').hide();
                this.showSuccess("U\u017Eivatel byl aktualizov\xe1n.");
                await this.loadUsers();
                this.renderUsers();
            } else this.showError(result.message || "Nepoda\u0159ilo se aktualizovat u\u017Eivatele");
        } catch (error) {
            console.error("Chyba p\u0159i aktualizaci u\u017Eivatele:", error);
            this.showError("Chyba spojen\xed se serverem");
        }
    }
    // ============================================================
    // Reset hesla
    // ============================================================
    async resetPassword(userId) {
        const user = this.users.find((u)=>String(u.id) === String(userId));
        if (!user) {
            this.showError("U\u017Eivatel nebyl nalezen.");
            return;
        }
        if (!confirm(`Opravdu chcete resetovat heslo u\u{17E}ivateli \u{201E}${user.name}"? Bude vygenerov\xe1no nov\xe9 do\u{10D}asn\xe9 heslo.`)) return;
        try {
            const response = await fetch(`${this.baseUrl}/users/${userId}/reset-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...this.getAuthHeaders()
                },
                credentials: 'include'
            });
            const result = await response.json();
            if (response.ok && result.success) {
                await this.loadUsers();
                this.renderUsers();
                this.showTempPasswordDialog(result.data?.tempPassword, user.username, "Heslo bylo resetov\xe1no");
            } else this.showError(result.message || "Nepoda\u0159ilo se resetovat heslo");
        } catch (error) {
            console.error("Chyba p\u0159i resetov\xe1n\xed hesla:", error);
            this.showError("Chyba spojen\xed se serverem");
        }
    }
    // ============================================================
    // Smazání uživatele
    // ============================================================
    async deleteUser(userId) {
        const user = this.users.find((u)=>String(u.id) === String(userId));
        if (!user) {
            this.showError("U\u017Eivatel nebyl nalezen.");
            return;
        }
        if (!confirm(`Opravdu chcete smazat u\u{17E}ivatele \u{201E}${user.name}" (${user.username})?`)) return;
        try {
            const response = await fetch(`${this.baseUrl}/users/${userId}`, {
                method: 'DELETE',
                headers: {
                    ...this.getAuthHeaders()
                },
                credentials: 'include'
            });
            const result = await response.json();
            if (response.ok && result.success) {
                this.showSuccess("U\u017Eivatel byl smaz\xe1n.");
                await this.loadUsers();
                this.renderUsers();
            } else // Chybové message z API (např. "Nelze smazat posledního administrátora")
            this.showError(result.message || "Nepoda\u0159ilo se smazat u\u017Eivatele");
        } catch (error) {
            console.error("Chyba p\u0159i maz\xe1n\xed u\u017Eivatele:", error);
            this.showError("Chyba spojen\xed se serverem");
        }
    }
    // ============================================================
    // Dialog s vygenerovaným dočasným heslem (jednorázové zobrazení)
    // ============================================================
    showTempPasswordDialog(tempPassword, username, title) {
        if (!tempPassword) {
            this.showSuccess(`${title}.`);
            return;
        }
        const existing = document.getElementById('tempPasswordModal');
        if (existing) existing.remove();
        const safePwd = this.escapeHtml(tempPassword);
        const safeUser = this.escapeHtml(username || '');
        const modalHtml = `
      <div class="fixed inset-0 z-[70] overflow-y-auto hidden" id="tempPasswordModal" aria-hidden="true">
        <div class="flex items-center justify-center min-h-screen px-4">
          <div class="fixed inset-0 bg-black opacity-50" id="modal-backdrop"></div>
          <div class="bg-white rounded-lg shadow-xl max-w-md w-full relative">
            <div class="px-6 py-4 border-b border-gray-200">
              <h3 class="text-lg font-medium text-gray-900">${this.escapeHtml(title)}</h3>
            </div>
            <div class="px-6 py-4">
              <p class="text-sm text-gray-600 mb-3">Do\u{10D}asn\xe9 heslo pro u\u{17E}ivatele <strong>${safeUser}</strong>:</p>
              <div class="flex items-center gap-2 mb-3">
                <input type="text" id="tempPasswordValue" readonly value="${safePwd}" class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm font-mono text-sm bg-gray-50 select-all">
                <button type="button" class="btn btn-secondary shrink-0" onclick="usersAdmin.copyTempPassword()">Kop\xedrovat</button>
              </div>
              <div class="bg-yellow-50 border border-yellow-200 rounded-md p-3 text-sm text-yellow-800">
                Heslo se zobraz\xed jen jednou, p\u{159}edejte ho u\u{17E}ivateli. Po prvn\xedm p\u{159}ihl\xe1\u{161}en\xed si jej bude muset zm\u{11B}nit.
              </div>
            </div>
            <div class="px-6 py-4 border-t border-gray-200 flex justify-end">
              <button type="button" class="btn btn-primary" id="modal-cancel-btn">Hotovo</button>
            </div>
          </div>
        </div>
      </div>`;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
        new TailwindModal('tempPasswordModal').show();
    }
    copyTempPassword() {
        const input = document.getElementById('tempPasswordValue');
        if (!input) return;
        const value = input.value;
        const done = ()=>this.showSuccess("Heslo zkop\xedrov\xe1no do schr\xe1nky.");
        if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(value).then(done).catch(()=>{
            input.select();
            document.execCommand('copy');
            done();
        });
        else {
            input.select();
            document.execCommand('copy');
            done();
        }
    }
    showSuccess(message) {
        if (typeof window.showNotification === 'function') window.showNotification(message, 'success');
    }
    showError(message) {
        if (typeof window.showNotification === 'function') window.showNotification(message, 'error');
        else alert(message);
    }
}


// Správa API klíčů pro MCP integraci.
//
// Komunikuje s `/api/api-keys` (admin-only). UI je v sekci #settings-api-keys
// definované v src/index.html. Veškerá business logika (hash, expirace, audit)
// zůstává na backendu – tady řešíme jen formuláře a notifikace.
const $e2a4d9e9dccae108$var$API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:3001/api' : '/api';
// Fallback labely – preferenčně se použijí ty, které vrátí backend
// (GET /api/api-keys → pricingTierLabels), díky čemuž je frontend
// nezávislý na konkrétních hodnotách tieru.
const $e2a4d9e9dccae108$var$TIER_LABELS_FALLBACK = {
    velko: "Velkoobchodn\xed",
    malo: "Maloobchodn\xed"
};
function $e2a4d9e9dccae108$var$notify(message, type = 'success') {
    if (typeof window.showNotification === 'function') window.showNotification(message, type);
    else console.log(`[${type}] ${message}`);
}
function $e2a4d9e9dccae108$var$formatDate(iso) {
    if (!iso) return "\u2014";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString('cs-CZ') + ' ' + d.toLocaleTimeString('cs-CZ', {
        hour: '2-digit',
        minute: '2-digit'
    });
}
function $e2a4d9e9dccae108$var$statusBadge(key) {
    if (key.revokedAt) return '<span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600">Odvolan\xfd</span>';
    if (key.expiresAt && new Date(key.expiresAt) < new Date()) return '<span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-yellow-100 text-yellow-800">Propadl\xfd</span>';
    return '<span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">Aktivn\xed</span>';
}
class $e2a4d9e9dccae108$export$be712e1a94688726 {
    constructor(){
        this.listEl = document.getElementById('api-keys-list');
        this.emptyEl = document.getElementById('api-keys-empty');
        this.createBtn = document.getElementById('api-key-create-btn');
        this.createModal = document.getElementById('api-key-create-modal');
        this.editModal = document.getElementById('api-key-edit-modal');
        this.showModal = document.getElementById('api-key-show-modal');
        this.plaintextEl = document.getElementById('api-key-plaintext');
        this.tierLabels = {
            ...$e2a4d9e9dccae108$var$TIER_LABELS_FALLBACK
        };
        this.keys = [];
        this.loaded = false;
        if (!this.listEl || !this.createBtn) return;
        this.bindEvents();
    }
    bindEvents() {
        this.createBtn.addEventListener('click', ()=>this.openCreateModal());
        document.getElementById('api-key-create-cancel').addEventListener('click', ()=>this.closeCreateModal());
        document.getElementById('api-key-create-submit').addEventListener('click', ()=>this.submitCreate());
        document.getElementById('api-key-edit-cancel').addEventListener('click', ()=>this.closeEditModal());
        document.getElementById('api-key-edit-submit').addEventListener('click', ()=>this.submitEdit());
        document.getElementById('api-key-show-close').addEventListener('click', ()=>this.closeShowModal());
        document.getElementById('api-key-copy-btn').addEventListener('click', ()=>this.copyPlaintext());
        // Klik mimo modal = zavřít.
        this.createModal.addEventListener('click', (e)=>{
            if (e.target === this.createModal) this.closeCreateModal();
        });
        this.editModal.addEventListener('click', (e)=>{
            if (e.target === this.editModal) this.closeEditModal();
        });
        this.showModal.addEventListener('click', (e)=>{
            if (e.target === this.showModal) this.closeShowModal();
        });
        // Event delegation pro tlačítka edit/revoke/delete v seznamu.
        this.listEl.addEventListener('click', (e)=>{
            const editBtn = e.target.closest('[data-action="edit"]');
            if (editBtn) {
                const id = editBtn.getAttribute('data-id');
                this.openEditModal(id);
                return;
            }
            const revokeBtn = e.target.closest('[data-action="revoke"]');
            if (revokeBtn) {
                const id = revokeBtn.getAttribute('data-id');
                const name = revokeBtn.getAttribute('data-name');
                if (confirm(`Opravdu zneplatnit kl\xed\u{10D} "${name}"? Klient s t\xedmto kl\xed\u{10D}em ztrat\xed p\u{159}\xedstup.`)) this.revoke(id);
                return;
            }
            const deleteBtn = e.target.closest('[data-action="delete"]');
            if (deleteBtn) {
                const id = deleteBtn.getAttribute('data-id');
                const name = deleteBtn.getAttribute('data-name');
                if (confirm(`Trvale smazat kl\xed\u{10D} "${name}" z evidence?`)) this.delete(id);
            }
        });
    }
    async fetchKeys() {
        const res = await fetch(`${$e2a4d9e9dccae108$var$API_BASE_URL}/api-keys`, {
            credentials: 'include'
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (!data.success) throw new Error(data.error || "Nezn\xe1m\xe1 chyba");
        if (data.pricingTierLabels && typeof data.pricingTierLabels === 'object') this.tierLabels = {
            ...$e2a4d9e9dccae108$var$TIER_LABELS_FALLBACK,
            ...data.pricingTierLabels
        };
        return data.data || [];
    }
    async load() {
        try {
            const keys = await this.fetchKeys();
            this.keys = keys;
            this.loaded = true;
            this.render(keys);
        } catch (err) {
            console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed API kl\xed\u010D\u016F:", err);
            this.listEl.innerHTML = `<div class="p-6 text-sm text-red-600 text-center">Chyba: ${err.message}</div>`;
        }
    }
    tierLabel(tier) {
        return this.tierLabels[tier] || tier || "\u2014";
    }
    render(keys) {
        if (!keys.length) {
            this.listEl.innerHTML = `
        <div class="p-6 text-sm text-gray-500 text-center">
          Zat\xedm \u{17E}\xe1dn\xe9 API kl\xed\u{10D}e. Vytvo\u{159} prvn\xed klikem na <strong>Vytvo\u{159}it kl\xed\u{10D}</strong>.
        </div>`;
            return;
        }
        const rows = keys.map((k)=>{
            const tier = this.tierLabel(k.pricingTier);
            const tierBadgeClass = k.pricingTier === 'malo' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800';
            const isActive = !k.revokedAt && (!k.expiresAt || new Date(k.expiresAt) >= new Date());
            return `
        <tr class="border-t border-gray-100">
          <td class="px-4 py-3 text-sm">
            <div class="font-medium text-ink">${$e2a4d9e9dccae108$var$escapeHtml(k.name)}</div>
            <div class="text-xs text-gray-500 font-mono">tria_\u{2026}${$e2a4d9e9dccae108$var$escapeHtml(k.lastFour || '????')}</div>
          </td>
          <td class="px-4 py-3 text-sm">
            <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${tierBadgeClass}">${$e2a4d9e9dccae108$var$escapeHtml(tier)}</span>
          </td>
          <td class="px-4 py-3 text-sm">${$e2a4d9e9dccae108$var$statusBadge(k)}</td>
          <td class="px-4 py-3 text-xs text-gray-600">
            <div>Vytvo\u{159}eno: ${$e2a4d9e9dccae108$var$formatDate(k.createdAt)}</div>
            ${k.expiresAt ? `<div>Platnost: ${$e2a4d9e9dccae108$var$formatDate(k.expiresAt)}</div>` : ''}
            ${k.lastUsedAt ? `<div>Posl. pou\u{17E}it\xed: ${$e2a4d9e9dccae108$var$formatDate(k.lastUsedAt)} (${k.usageCount || 0}\xd7)</div>` : '<div class="text-gray-400">Zat\xedm nepou\u017Eito</div>'}
          </td>
          <td class="px-4 py-3 text-sm text-right whitespace-nowrap">
            ${isActive ? `<button data-action="edit" data-id="${k.id}" class="btn btn-ghost btn-sm text-blue-700 hover:bg-blue-50">Upravit</button>` : ''}
            ${isActive ? `<button data-action="revoke" data-id="${k.id}" data-name="${$e2a4d9e9dccae108$var$escapeHtml(k.name)}" class="btn btn-ghost btn-sm text-yellow-700 hover:bg-yellow-50 ml-1">Zneplatnit</button>` : ''}
            <button data-action="delete" data-id="${k.id}" data-name="${$e2a4d9e9dccae108$var$escapeHtml(k.name)}" class="btn btn-ghost btn-sm text-red-700 hover:bg-red-50 ml-1">Smazat</button>
          </td>
        </tr>`;
        }).join('');
        this.listEl.innerHTML = `
      <table class="w-full">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">N\xe1zev / kl\xed\u{10D}</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tier</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Stav</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Detaily</th>
            <th class="px-4 py-2"></th>
          </tr>
        </thead>
        <tbody>${rows}</tbody>
      </table>`;
    }
    openCreateModal() {
        document.getElementById('api-key-name').value = '';
        document.getElementById('api-key-tier').value = 'velko';
        document.getElementById('api-key-expires').value = '';
        this.createModal.classList.remove('hidden');
        setTimeout(()=>document.getElementById('api-key-name').focus(), 50);
    }
    closeCreateModal() {
        this.createModal.classList.add('hidden');
    }
    openEditModal(id) {
        const key = (this.keys || []).find((k)=>k.id === id);
        if (!key) {
            $e2a4d9e9dccae108$var$notify("Kl\xed\u010D nenalezen, obnov str\xe1nku", 'warning');
            return;
        }
        document.getElementById('api-key-edit-id').value = key.id;
        document.getElementById('api-key-edit-name').value = key.name || '';
        document.getElementById('api-key-edit-tier').value = key.pricingTier || 'velko';
        document.getElementById('api-key-edit-expires').value = key.expiresAt ? new Date(key.expiresAt).toISOString().slice(0, 10) : '';
        this.editModal.classList.remove('hidden');
        setTimeout(()=>document.getElementById('api-key-edit-name').focus(), 50);
    }
    closeEditModal() {
        this.editModal.classList.add('hidden');
    }
    async submitEdit() {
        const id = document.getElementById('api-key-edit-id').value;
        const name = document.getElementById('api-key-edit-name').value.trim();
        const pricingTier = document.getElementById('api-key-edit-tier').value;
        const expiresInput = document.getElementById('api-key-edit-expires').value;
        if (!id) return;
        try {
            const body = {
                name: name,
                pricingTier: pricingTier
            };
            body.expiresAt = expiresInput ? new Date(expiresInput + 'T23:59:59').toISOString() : null;
            const res = await fetch(`${$e2a4d9e9dccae108$var$API_BASE_URL}/api-keys/${id}`, {
                method: 'PATCH',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });
            const data = await res.json();
            if (!res.ok || !data.success) throw new Error(data.error || `HTTP ${res.status}`);
            this.closeEditModal();
            $e2a4d9e9dccae108$var$notify("Kl\xed\u010D upraven", 'success');
            this.load();
        } catch (err) {
            console.error("Chyba p\u0159i \xfaprav\u011B kl\xed\u010De:", err);
            $e2a4d9e9dccae108$var$notify(`Chyba: ${err.message}`, 'error');
        }
    }
    async submitCreate() {
        const name = document.getElementById('api-key-name').value.trim();
        const pricingTier = document.getElementById('api-key-tier').value;
        const expiresInput = document.getElementById('api-key-expires').value;
        if (!name) {
            $e2a4d9e9dccae108$var$notify("Zadej n\xe1zev kl\xed\u010De", 'warning');
            return;
        }
        try {
            const body = {
                name: name,
                pricingTier: pricingTier
            };
            if (expiresInput) body.expiresAt = new Date(expiresInput + 'T23:59:59').toISOString();
            const res = await fetch(`${$e2a4d9e9dccae108$var$API_BASE_URL}/api-keys`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });
            const data = await res.json();
            if (!res.ok || !data.success) throw new Error(data.error || `HTTP ${res.status}`);
            this.closeCreateModal();
            this.showNewKey(data.data.plaintextKey);
            this.load();
            $e2a4d9e9dccae108$var$notify("API kl\xed\u010D vytvo\u0159en", 'success');
        } catch (err) {
            console.error("Chyba p\u0159i vytv\xe1\u0159en\xed kl\xed\u010De:", err);
            $e2a4d9e9dccae108$var$notify(`Chyba: ${err.message}`, 'error');
        }
    }
    showNewKey(plaintext) {
        this.plaintextEl.textContent = plaintext;
        this.showModal.classList.remove('hidden');
    }
    closeShowModal() {
        this.showModal.classList.add('hidden');
        this.plaintextEl.textContent = '';
    }
    async copyPlaintext() {
        try {
            await navigator.clipboard.writeText(this.plaintextEl.textContent);
            $e2a4d9e9dccae108$var$notify("Kl\xed\u010D zkop\xedrov\xe1n do schr\xe1nky", 'success');
        } catch (err) {
            $e2a4d9e9dccae108$var$notify("Nepoda\u0159ilo se zkop\xedrovat \u2013 ozna\u010D a zkop\xedruj ru\u010Dn\u011B.", 'warning');
        }
    }
    async revoke(id) {
        try {
            const res = await fetch(`${$e2a4d9e9dccae108$var$API_BASE_URL}/api-keys/${id}/revoke`, {
                method: 'POST',
                credentials: 'include'
            });
            const data = await res.json();
            if (!res.ok || !data.success) throw new Error(data.error || `HTTP ${res.status}`);
            $e2a4d9e9dccae108$var$notify("Kl\xed\u010D zneplatn\u011Bn", 'success');
            this.load();
        } catch (err) {
            console.error("Chyba p\u0159i zneplatn\u011Bn\xed kl\xed\u010De:", err);
            $e2a4d9e9dccae108$var$notify(`Chyba: ${err.message}`, 'error');
        }
    }
    async delete(id) {
        try {
            const res = await fetch(`${$e2a4d9e9dccae108$var$API_BASE_URL}/api-keys/${id}`, {
                method: 'DELETE',
                credentials: 'include'
            });
            const data = await res.json();
            if (!res.ok || !data.success) throw new Error(data.error || `HTTP ${res.status}`);
            $e2a4d9e9dccae108$var$notify("Kl\xed\u010D smaz\xe1n", 'success');
            this.load();
        } catch (err) {
            console.error("Chyba p\u0159i maz\xe1n\xed kl\xed\u010De:", err);
            $e2a4d9e9dccae108$var$notify(`Chyba: ${err.message}`, 'error');
        }
    }
}
function $e2a4d9e9dccae108$var$escapeHtml(str) {
    return String(str ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}


// Admin UI pro OAuth klienty registrované přes DCR.
//
// Klienti se vytváří automaticky když ChatGPT (a další MCP klienti) projdou
// `/oauth/register` (Dynamic Client Registration, RFC 7591). Tady je můžeme:
//  - vidět v tabulce (kdo se zaregistroval, kdy, jakou cenovou úroveň má)
//  - změnit cenovou úroveň (velko / malo)
//  - zneplatnit (odebere přístup, ale ponechá v evidenci)
//  - smazat (úplně odstraní + invaliduje tokeny)
//
// Vystavené access tokeny si nesou tier z času jejich vystavení – změna tieru
// klienta se projeví až u dalších nově vystavených tokenů (po novém OAuth flow).
const $f4a03d91423655c0$var$API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:3001/api' : '/api';
const $f4a03d91423655c0$var$TIER_LABELS = {
    velko: "Velkoobchodn\xed",
    malo: "Maloobchodn\xed"
};
function $f4a03d91423655c0$var$notify(message, type = 'success') {
    if (typeof window.showNotification === 'function') window.showNotification(message, type);
    else console.log(`[${type}] ${message}`);
}
function $f4a03d91423655c0$var$formatDate(iso) {
    if (!iso) return "\u2014";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString('cs-CZ') + ' ' + d.toLocaleTimeString('cs-CZ', {
        hour: '2-digit',
        minute: '2-digit'
    });
}
function $f4a03d91423655c0$var$escapeHtml(str) {
    return String(str ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
class $f4a03d91423655c0$export$ba48fe53c6dc330 {
    constructor(){
        this.listEl = document.getElementById('oauth-clients-list');
        this.editModal = document.getElementById('oauth-client-edit-modal');
        this.clients = [];
        if (!this.listEl) return;
        this.bindEvents();
    }
    bindEvents() {
        document.getElementById('oauth-client-edit-cancel').addEventListener('click', ()=>this.closeEditModal());
        document.getElementById('oauth-client-edit-submit').addEventListener('click', ()=>this.submitEdit());
        this.editModal.addEventListener('click', (e)=>{
            if (e.target === this.editModal) this.closeEditModal();
        });
        this.listEl.addEventListener('click', (e)=>{
            const editBtn = e.target.closest('[data-action="edit-oauth"]');
            if (editBtn) {
                this.openEditModal(editBtn.getAttribute('data-id'));
                return;
            }
            const revokeBtn = e.target.closest('[data-action="revoke-oauth"]');
            if (revokeBtn) {
                const id = revokeBtn.getAttribute('data-id');
                const name = revokeBtn.getAttribute('data-name');
                if (confirm(`Zneplatnit klienta "${name}"? V\u{161}echny jeho aktivn\xed tokeny budou okam\u{17E}it\u{11B} zru\u{161}eny \u{2013} u\u{17E}ivatel\xe9 se mus\xed v ChatGPT znovu p\u{159}ihl\xe1sit.`)) this.revoke(id);
                return;
            }
            const deleteBtn = e.target.closest('[data-action="delete-oauth"]');
            if (deleteBtn) {
                const id = deleteBtn.getAttribute('data-id');
                const name = deleteBtn.getAttribute('data-name');
                if (confirm(`Trvale smazat klienta "${name}" z evidence? Zru\u{161}\xed se i v\u{161}echny tokeny.`)) this.delete(id);
            }
        });
    }
    async load() {
        try {
            const res = await fetch(`${$f4a03d91423655c0$var$API_BASE_URL}/oauth-admin/clients`, {
                credentials: 'include'
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();
            if (!data.success) throw new Error(data.error || "Nezn\xe1m\xe1 chyba");
            this.clients = data.data || [];
            this.render();
        } catch (err) {
            console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed OAuth klient\u016F:", err);
            this.listEl.innerHTML = `<div class="p-6 text-sm text-red-600 text-center">Chyba: ${$f4a03d91423655c0$var$escapeHtml(err.message)}</div>`;
        }
    }
    render() {
        if (!this.clients.length) {
            this.listEl.innerHTML = `
        <div class="p-6 text-sm text-gray-500 text-center">
          Zat\xedm \u{17E}\xe1dn\xed OAuth klienti.<br>
          <span class="text-xs">Klient se objev\xed, kdy\u{17E} si ho zaregistruje ChatGPT \u{201E}Nov\xe1 aplikace BETA" p\u{159}es DCR endpoint.</span>
        </div>`;
            return;
        }
        const rows = this.clients.map((c)=>{
            const tier = $f4a03d91423655c0$var$TIER_LABELS[c.pricing_tier] || c.pricing_tier;
            const tierBadge = c.pricing_tier === 'malo' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800';
            const statusBadge = c.revoked_at ? '<span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600">Odvolan\xfd</span>' : '<span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">Aktivn\xed</span>';
            const isActive = !c.revoked_at;
            const software = c.software_id ? `<div class="text-xs text-gray-500">Software: <code>${$f4a03d91423655c0$var$escapeHtml(c.software_id)}</code></div>` : '';
            const redirects = (c.redirect_uris || []).map((u)=>`<code class="text-xs">${$f4a03d91423655c0$var$escapeHtml(u)}</code>`).join('<br>');
            return `
        <tr class="border-t border-gray-100">
          <td class="px-4 py-3 text-sm align-top">
            <div class="font-medium text-ink">${$f4a03d91423655c0$var$escapeHtml(c.client_name)}</div>
            <div class="text-xs text-gray-500 font-mono break-all">${$f4a03d91423655c0$var$escapeHtml(c.client_id)}</div>
            ${software}
          </td>
          <td class="px-4 py-3 text-sm align-top">
            <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${tierBadge}">${$f4a03d91423655c0$var$escapeHtml(tier)}</span>
          </td>
          <td class="px-4 py-3 text-sm align-top">${statusBadge}</td>
          <td class="px-4 py-3 text-xs text-gray-600 align-top">
            <div>Registrace: ${$f4a03d91423655c0$var$formatDate(c.created_at)}</div>
            <div class="mt-1">Redirect URI:<br>${redirects || "<em>\u2014</em>"}</div>
          </td>
          <td class="px-4 py-3 text-sm text-right whitespace-nowrap align-top">
            ${isActive ? `<button data-action="edit-oauth" data-id="${$f4a03d91423655c0$var$escapeHtml(c.client_id)}" class="btn btn-ghost btn-sm text-blue-700 hover:bg-blue-50">Upravit</button>` : ''}
            ${isActive ? `<button data-action="revoke-oauth" data-id="${$f4a03d91423655c0$var$escapeHtml(c.client_id)}" data-name="${$f4a03d91423655c0$var$escapeHtml(c.client_name)}" class="btn btn-ghost btn-sm text-yellow-700 hover:bg-yellow-50 ml-1">Zneplatnit</button>` : ''}
            <button data-action="delete-oauth" data-id="${$f4a03d91423655c0$var$escapeHtml(c.client_id)}" data-name="${$f4a03d91423655c0$var$escapeHtml(c.client_name)}" class="btn btn-ghost btn-sm text-red-700 hover:bg-red-50 ml-1">Smazat</button>
          </td>
        </tr>`;
        }).join('');
        this.listEl.innerHTML = `
      <table class="w-full">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Klient</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tier</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Stav</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Detaily</th>
            <th class="px-4 py-2"></th>
          </tr>
        </thead>
        <tbody>${rows}</tbody>
      </table>`;
    }
    openEditModal(clientId) {
        const c = this.clients.find((x)=>x.client_id === clientId);
        if (!c) {
            $f4a03d91423655c0$var$notify("Klient nenalezen, obnov str\xe1nku", 'warning');
            return;
        }
        document.getElementById('oauth-client-edit-id').value = c.client_id;
        document.getElementById('oauth-client-edit-name').value = c.client_name || '';
        document.getElementById('oauth-client-edit-tier').value = c.pricing_tier || 'velko';
        this.editModal.classList.remove('hidden');
        setTimeout(()=>document.getElementById('oauth-client-edit-name').focus(), 50);
    }
    closeEditModal() {
        this.editModal.classList.add('hidden');
    }
    async submitEdit() {
        const id = document.getElementById('oauth-client-edit-id').value;
        const client_name = document.getElementById('oauth-client-edit-name').value.trim();
        const pricing_tier = document.getElementById('oauth-client-edit-tier').value;
        if (!id) return;
        try {
            const res = await fetch(`${$f4a03d91423655c0$var$API_BASE_URL}/oauth-admin/clients/${encodeURIComponent(id)}`, {
                method: 'PATCH',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    client_name: client_name,
                    pricing_tier: pricing_tier
                })
            });
            const data = await res.json();
            if (!res.ok || !data.success) throw new Error(data.error || `HTTP ${res.status}`);
            this.closeEditModal();
            $f4a03d91423655c0$var$notify('OAuth klient upraven', 'success');
            this.load();
        } catch (err) {
            console.error("Chyba p\u0159i \xfaprav\u011B OAuth klienta:", err);
            $f4a03d91423655c0$var$notify(`Chyba: ${err.message}`, 'error');
        }
    }
    async revoke(id) {
        try {
            const res = await fetch(`${$f4a03d91423655c0$var$API_BASE_URL}/oauth-admin/clients/${encodeURIComponent(id)}/revoke`, {
                method: 'POST',
                credentials: 'include'
            });
            const data = await res.json();
            if (!res.ok || !data.success) throw new Error(data.error || `HTTP ${res.status}`);
            $f4a03d91423655c0$var$notify("Klient zneplatn\u011Bn, tokeny zru\u0161eny", 'success');
            this.load();
        } catch (err) {
            console.error("Chyba p\u0159i zneplatn\u011Bn\xed OAuth klienta:", err);
            $f4a03d91423655c0$var$notify(`Chyba: ${err.message}`, 'error');
        }
    }
    async delete(id) {
        try {
            const res = await fetch(`${$f4a03d91423655c0$var$API_BASE_URL}/oauth-admin/clients/${encodeURIComponent(id)}`, {
                method: 'DELETE',
                credentials: 'include'
            });
            const data = await res.json();
            if (!res.ok || !data.success) throw new Error(data.error || `HTTP ${res.status}`);
            $f4a03d91423655c0$var$notify("Klient smaz\xe1n", 'success');
            this.load();
        } catch (err) {
            console.error("Chyba p\u0159i maz\xe1n\xed OAuth klienta:", err);
            $f4a03d91423655c0$var$notify(`Chyba: ${err.message}`, 'error');
        }
    }
}


// AI asistent – vanilla JS chat přes Vercel AI Gateway.
//
// Komunikuje s /api/ai/chat (SSE UI message stream z AI SDK v5) a /api/ai/models.
// Tooly (calculate_price, list_materials, nabídky…) běží na backendu přes
// service vrstvu – frontend jen zobrazuje streamované odpovědi a tool chipy.
// CSRF hlavičku a credentials přidává globální csrfFetch wrapper z app.js.
/**
 * marked v12.0.2 - a markdown parser
 * Copyright (c) 2011-2024, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ /**
 * Gets the original marked default options.
 */ function $c186377a43ac04e5$export$212bb2fc580a90a8() {
    return {
        async: false,
        breaks: false,
        extensions: null,
        gfm: true,
        hooks: null,
        pedantic: false,
        renderer: null,
        silent: false,
        tokenizer: null,
        walkTokens: null
    };
}
let $c186377a43ac04e5$export$ebe90cb607ad99e = $c186377a43ac04e5$export$212bb2fc580a90a8();
function $c186377a43ac04e5$var$changeDefaults(newDefaults) {
    $c186377a43ac04e5$export$ebe90cb607ad99e = newDefaults;
}
/**
 * Helpers
 */ const $c186377a43ac04e5$var$escapeTest = /[&<>"']/;
const $c186377a43ac04e5$var$escapeReplace = new RegExp($c186377a43ac04e5$var$escapeTest.source, 'g');
const $c186377a43ac04e5$var$escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
const $c186377a43ac04e5$var$escapeReplaceNoEncode = new RegExp($c186377a43ac04e5$var$escapeTestNoEncode.source, 'g');
const $c186377a43ac04e5$var$escapeReplacements = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
const $c186377a43ac04e5$var$getEscapeReplacement = (ch)=>$c186377a43ac04e5$var$escapeReplacements[ch];
function $c186377a43ac04e5$var$escape$1(html, encode) {
    if (encode) {
        if ($c186377a43ac04e5$var$escapeTest.test(html)) return html.replace($c186377a43ac04e5$var$escapeReplace, $c186377a43ac04e5$var$getEscapeReplacement);
    } else {
        if ($c186377a43ac04e5$var$escapeTestNoEncode.test(html)) return html.replace($c186377a43ac04e5$var$escapeReplaceNoEncode, $c186377a43ac04e5$var$getEscapeReplacement);
    }
    return html;
}
const $c186377a43ac04e5$var$unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
function $c186377a43ac04e5$var$unescape(html) {
    // explicitly match decimal, hex, and named HTML entities
    return html.replace($c186377a43ac04e5$var$unescapeTest, (_, n)=>{
        n = n.toLowerCase();
        if (n === 'colon') return ':';
        if (n.charAt(0) === '#') return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
        return '';
    });
}
const $c186377a43ac04e5$var$caret = /(^|[^\[])\^/g;
function $c186377a43ac04e5$var$edit(regex, opt) {
    let source = typeof regex === 'string' ? regex : regex.source;
    opt = opt || '';
    const obj = {
        replace: (name, val)=>{
            let valSource = typeof val === 'string' ? val : val.source;
            valSource = valSource.replace($c186377a43ac04e5$var$caret, '$1');
            source = source.replace(name, valSource);
            return obj;
        },
        getRegex: ()=>{
            return new RegExp(source, opt);
        }
    };
    return obj;
}
function $c186377a43ac04e5$var$cleanUrl(href) {
    try {
        href = encodeURI(href).replace(/%25/g, '%');
    } catch (e) {
        return null;
    }
    return href;
}
const $c186377a43ac04e5$var$noopTest = {
    exec: ()=>null
};
function $c186377a43ac04e5$var$splitCells(tableRow, count) {
    // ensure that every cell-delimiting pipe has a space
    // before it to distinguish it from an escaped pipe
    const row = tableRow.replace(/\|/g, (match, offset, str)=>{
        let escaped = false;
        let curr = offset;
        while(--curr >= 0 && str[curr] === '\\')escaped = !escaped;
        if (escaped) // odd number of slashes means | is escaped
        // so we leave it alone
        return '|';
        else // add space before unescaped |
        return ' |';
    }), cells = row.split(/ \|/);
    let i = 0;
    // First/last cell in a row cannot be empty if it has no leading/trailing pipe
    if (!cells[0].trim()) cells.shift();
    if (cells.length > 0 && !cells[cells.length - 1].trim()) cells.pop();
    if (count) {
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push('');
    }
    for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
    cells[i] = cells[i].trim().replace(/\\\|/g, '|');
    return cells;
}
/**
 * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
 * /c*$/ is vulnerable to REDOS.
 *
 * @param str
 * @param c
 * @param invert Remove suffix of non-c chars instead. Default falsey.
 */ function $c186377a43ac04e5$var$rtrim(str, c, invert) {
    const l = str.length;
    if (l === 0) return '';
    // Length of suffix matching the invert condition.
    let suffLen = 0;
    // Step left until we fail to match the invert condition.
    while(suffLen < l){
        const currChar = str.charAt(l - suffLen - 1);
        if (currChar === c && !invert) suffLen++;
        else if (currChar !== c && invert) suffLen++;
        else break;
    }
    return str.slice(0, l - suffLen);
}
function $c186377a43ac04e5$var$findClosingBracket(str, b) {
    if (str.indexOf(b[1]) === -1) return -1;
    let level = 0;
    for(let i = 0; i < str.length; i++){
        if (str[i] === '\\') i++;
        else if (str[i] === b[0]) level++;
        else if (str[i] === b[1]) {
            level--;
            if (level < 0) return i;
        }
    }
    return -1;
}
function $c186377a43ac04e5$var$outputLink(cap, link, raw, lexer) {
    const href = link.href;
    const title = link.title ? $c186377a43ac04e5$var$escape$1(link.title) : null;
    const text = cap[1].replace(/\\([\[\]])/g, '$1');
    if (cap[0].charAt(0) !== '!') {
        lexer.state.inLink = true;
        const token = {
            type: 'link',
            raw: raw,
            href: href,
            title: title,
            text: text,
            tokens: lexer.inlineTokens(text)
        };
        lexer.state.inLink = false;
        return token;
    }
    return {
        type: 'image',
        raw: raw,
        href: href,
        title: title,
        text: $c186377a43ac04e5$var$escape$1(text)
    };
}
function $c186377a43ac04e5$var$indentCodeCompensation(raw, text) {
    const matchIndentToCode = raw.match(/^(\s+)(?:```)/);
    if (matchIndentToCode === null) return text;
    const indentToCode = matchIndentToCode[1];
    return text.split('\n').map((node)=>{
        const matchIndentInNode = node.match(/^\s+/);
        if (matchIndentInNode === null) return node;
        const [indentInNode] = matchIndentInNode;
        if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
        return node;
    }).join('\n');
}
/**
 * Tokenizer
 */ class $c186377a43ac04e5$export$55e8b082af4aa63e {
    options;
    rules;
    lexer;
    constructor(options){
        this.options = options || $c186377a43ac04e5$export$ebe90cb607ad99e;
    }
    space(src) {
        const cap = this.rules.block.newline.exec(src);
        if (cap && cap[0].length > 0) return {
            type: 'space',
            raw: cap[0]
        };
    }
    code(src) {
        const cap = this.rules.block.code.exec(src);
        if (cap) {
            const text = cap[0].replace(/^ {1,4}/gm, '');
            return {
                type: 'code',
                raw: cap[0],
                codeBlockStyle: 'indented',
                text: !this.options.pedantic ? $c186377a43ac04e5$var$rtrim(text, '\n') : text
            };
        }
    }
    fences(src) {
        const cap = this.rules.block.fences.exec(src);
        if (cap) {
            const raw = cap[0];
            const text = $c186377a43ac04e5$var$indentCodeCompensation(raw, cap[3] || '');
            return {
                type: 'code',
                raw: raw,
                lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, '$1') : cap[2],
                text: text
            };
        }
    }
    heading(src) {
        const cap = this.rules.block.heading.exec(src);
        if (cap) {
            let text = cap[2].trim();
            // remove trailing #s
            if (/#$/.test(text)) {
                const trimmed = $c186377a43ac04e5$var$rtrim(text, '#');
                if (this.options.pedantic) text = trimmed.trim();
                else if (!trimmed || / $/.test(trimmed)) // CommonMark requires space before trailing #s
                text = trimmed.trim();
            }
            return {
                type: 'heading',
                raw: cap[0],
                depth: cap[1].length,
                text: text,
                tokens: this.lexer.inline(text)
            };
        }
    }
    hr(src) {
        const cap = this.rules.block.hr.exec(src);
        if (cap) return {
            type: 'hr',
            raw: cap[0]
        };
    }
    blockquote(src) {
        const cap = this.rules.block.blockquote.exec(src);
        if (cap) {
            // precede setext continuation with 4 spaces so it isn't a setext
            let text = cap[0].replace(/\n {0,3}((?:=+|-+) *)(?=\n|$)/g, '\n    $1');
            text = $c186377a43ac04e5$var$rtrim(text.replace(/^ *>[ \t]?/gm, ''), '\n');
            const top = this.lexer.state.top;
            this.lexer.state.top = true;
            const tokens = this.lexer.blockTokens(text);
            this.lexer.state.top = top;
            return {
                type: 'blockquote',
                raw: cap[0],
                tokens: tokens,
                text: text
            };
        }
    }
    list(src) {
        let cap = this.rules.block.list.exec(src);
        if (cap) {
            let bull = cap[1].trim();
            const isordered = bull.length > 1;
            const list = {
                type: 'list',
                raw: '',
                ordered: isordered,
                start: isordered ? +bull.slice(0, -1) : '',
                loose: false,
                items: []
            };
            bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
            if (this.options.pedantic) bull = isordered ? bull : '[*+-]';
            // Get next list item
            const itemRegex = new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`);
            let raw = '';
            let itemContents = '';
            let endsWithBlankLine = false;
            // Check if current bullet point can start a new List Item
            while(src){
                let endEarly = false;
                if (!(cap = itemRegex.exec(src))) break;
                if (this.rules.block.hr.test(src)) break;
                raw = cap[0];
                src = src.substring(raw.length);
                let line = cap[2].split('\n', 1)[0].replace(/^\t+/, (t)=>' '.repeat(3 * t.length));
                let nextLine = src.split('\n', 1)[0];
                let indent = 0;
                if (this.options.pedantic) {
                    indent = 2;
                    itemContents = line.trimStart();
                } else {
                    indent = cap[2].search(/[^ ]/); // Find first non-space char
                    indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                    itemContents = line.slice(indent);
                    indent += cap[1].length;
                }
                let blankLine = false;
                if (!line && /^ *$/.test(nextLine)) {
                    raw += nextLine + '\n';
                    src = src.substring(nextLine.length + 1);
                    endEarly = true;
                }
                if (!endEarly) {
                    const nextBulletRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`);
                    const hrRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`);
                    const fencesBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`);
                    const headingBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`);
                    // Check if following lines should be included in List Item
                    while(src){
                        const rawLine = src.split('\n', 1)[0];
                        nextLine = rawLine;
                        // Re-align to follow commonmark nesting rules
                        if (this.options.pedantic) nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ');
                        // End list item if found code fences
                        if (fencesBeginRegex.test(nextLine)) break;
                        // End list item if found start of new heading
                        if (headingBeginRegex.test(nextLine)) break;
                        // End list item if found start of new bullet
                        if (nextBulletRegex.test(nextLine)) break;
                        // Horizontal rule found
                        if (hrRegex.test(src)) break;
                        if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) itemContents += '\n' + nextLine.slice(indent);
                        else {
                            // not enough indentation
                            if (blankLine) break;
                            // paragraph continuation unless last line was a different block level element
                            if (line.search(/[^ ]/) >= 4) break;
                            if (fencesBeginRegex.test(line)) break;
                            if (headingBeginRegex.test(line)) break;
                            if (hrRegex.test(line)) break;
                            itemContents += '\n' + nextLine;
                        }
                        if (!blankLine && !nextLine.trim()) blankLine = true;
                        raw += rawLine + '\n';
                        src = src.substring(rawLine.length + 1);
                        line = nextLine.slice(indent);
                    }
                }
                if (!list.loose) {
                    // If the previous item ended with a blank line, the list is loose
                    if (endsWithBlankLine) list.loose = true;
                    else if (/\n *\n *$/.test(raw)) endsWithBlankLine = true;
                }
                let istask = null;
                let ischecked;
                // Check for task list items
                if (this.options.gfm) {
                    istask = /^\[[ xX]\] /.exec(itemContents);
                    if (istask) {
                        ischecked = istask[0] !== '[ ] ';
                        itemContents = itemContents.replace(/^\[[ xX]\] +/, '');
                    }
                }
                list.items.push({
                    type: 'list_item',
                    raw: raw,
                    task: !!istask,
                    checked: ischecked,
                    loose: false,
                    text: itemContents,
                    tokens: []
                });
                list.raw += raw;
            }
            // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
            list.items[list.items.length - 1].raw = raw.trimEnd();
            list.items[list.items.length - 1].text = itemContents.trimEnd();
            list.raw = list.raw.trimEnd();
            // Item child tokens handled here at end because we needed to have the final item to trim it first
            for(let i = 0; i < list.items.length; i++){
                this.lexer.state.top = false;
                list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                if (!list.loose) {
                    // Check if list should be loose
                    const spacers = list.items[i].tokens.filter((t)=>t.type === 'space');
                    const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t)=>/\n.*\n/.test(t.raw));
                    list.loose = hasMultipleLineBreaks;
                }
            }
            // Set all items to loose if list is loose
            if (list.loose) for(let i = 0; i < list.items.length; i++)list.items[i].loose = true;
            return list;
        }
    }
    html(src) {
        const cap = this.rules.block.html.exec(src);
        if (cap) {
            const token = {
                type: 'html',
                block: true,
                raw: cap[0],
                pre: cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style',
                text: cap[0]
            };
            return token;
        }
    }
    def(src) {
        const cap = this.rules.block.def.exec(src);
        if (cap) {
            const tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
            const href = cap[2] ? cap[2].replace(/^<(.*)>$/, '$1').replace(this.rules.inline.anyPunctuation, '$1') : '';
            const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, '$1') : cap[3];
            return {
                type: 'def',
                tag: tag,
                raw: cap[0],
                href: href,
                title: title
            };
        }
    }
    table(src) {
        const cap = this.rules.block.table.exec(src);
        if (!cap) return;
        if (!/[:|]/.test(cap[2])) // delimiter row must have a pipe (|) or colon (:) otherwise it is a setext heading
        return;
        const headers = $c186377a43ac04e5$var$splitCells(cap[1]);
        const aligns = cap[2].replace(/^\||\| *$/g, '').split('|');
        const rows = cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, '').split('\n') : [];
        const item = {
            type: 'table',
            raw: cap[0],
            header: [],
            align: [],
            rows: []
        };
        if (headers.length !== aligns.length) // header and align columns must be equal, rows can be different.
        return;
        for (const align of aligns){
            if (/^ *-+: *$/.test(align)) item.align.push('right');
            else if (/^ *:-+: *$/.test(align)) item.align.push('center');
            else if (/^ *:-+ *$/.test(align)) item.align.push('left');
            else item.align.push(null);
        }
        for (const header of headers)item.header.push({
            text: header,
            tokens: this.lexer.inline(header)
        });
        for (const row of rows)item.rows.push($c186377a43ac04e5$var$splitCells(row, item.header.length).map((cell)=>{
            return {
                text: cell,
                tokens: this.lexer.inline(cell)
            };
        }));
        return item;
    }
    lheading(src) {
        const cap = this.rules.block.lheading.exec(src);
        if (cap) return {
            type: 'heading',
            raw: cap[0],
            depth: cap[2].charAt(0) === '=' ? 1 : 2,
            text: cap[1],
            tokens: this.lexer.inline(cap[1])
        };
    }
    paragraph(src) {
        const cap = this.rules.block.paragraph.exec(src);
        if (cap) {
            const text = cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1];
            return {
                type: 'paragraph',
                raw: cap[0],
                text: text,
                tokens: this.lexer.inline(text)
            };
        }
    }
    text(src) {
        const cap = this.rules.block.text.exec(src);
        if (cap) return {
            type: 'text',
            raw: cap[0],
            text: cap[0],
            tokens: this.lexer.inline(cap[0])
        };
    }
    escape(src) {
        const cap = this.rules.inline.escape.exec(src);
        if (cap) return {
            type: 'escape',
            raw: cap[0],
            text: $c186377a43ac04e5$var$escape$1(cap[1])
        };
    }
    tag(src) {
        const cap = this.rules.inline.tag.exec(src);
        if (cap) {
            if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) this.lexer.state.inLink = true;
            else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) this.lexer.state.inLink = false;
            if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = true;
            else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = false;
            return {
                type: 'html',
                raw: cap[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                block: false,
                text: cap[0]
            };
        }
    }
    link(src) {
        const cap = this.rules.inline.link.exec(src);
        if (cap) {
            const trimmedUrl = cap[2].trim();
            if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                // commonmark requires matching angle brackets
                if (!/>$/.test(trimmedUrl)) return;
                // ending angle bracket cannot be escaped
                const rtrimSlash = $c186377a43ac04e5$var$rtrim(trimmedUrl.slice(0, -1), '\\');
                if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
            } else {
                // find closing parenthesis
                const lastParenIndex = $c186377a43ac04e5$var$findClosingBracket(cap[2], '()');
                if (lastParenIndex > -1) {
                    const start = cap[0].indexOf('!') === 0 ? 5 : 4;
                    const linkLen = start + cap[1].length + lastParenIndex;
                    cap[2] = cap[2].substring(0, lastParenIndex);
                    cap[0] = cap[0].substring(0, linkLen).trim();
                    cap[3] = '';
                }
            }
            let href = cap[2];
            let title = '';
            if (this.options.pedantic) {
                // split pedantic href and title
                const link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                if (link) {
                    href = link[1];
                    title = link[3];
                }
            } else title = cap[3] ? cap[3].slice(1, -1) : '';
            href = href.trim();
            if (/^</.test(href)) {
                if (this.options.pedantic && !/>$/.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                href = href.slice(1);
                else href = href.slice(1, -1);
            }
            return $c186377a43ac04e5$var$outputLink(cap, {
                href: href ? href.replace(this.rules.inline.anyPunctuation, '$1') : href,
                title: title ? title.replace(this.rules.inline.anyPunctuation, '$1') : title
            }, cap[0], this.lexer);
        }
    }
    reflink(src, links) {
        let cap;
        if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
            const linkString = (cap[2] || cap[1]).replace(/\s+/g, ' ');
            const link = links[linkString.toLowerCase()];
            if (!link) {
                const text = cap[0].charAt(0);
                return {
                    type: 'text',
                    raw: text,
                    text: text
                };
            }
            return $c186377a43ac04e5$var$outputLink(cap, link, cap[0], this.lexer);
        }
    }
    emStrong(src, maskedSrc, prevChar = '') {
        let match = this.rules.inline.emStrongLDelim.exec(src);
        if (!match) return;
        // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
        if (match[3] && prevChar.match(/[\p{L}\p{N}]/u)) return;
        const nextChar = match[1] || match[2] || '';
        if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
            // unicode Regex counts emoji as 1 char; spread into array for proper count (used multiple times below)
            const lLength = [
                ...match[0]
            ].length - 1;
            let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
            const endReg = match[0][0] === '*' ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
            endReg.lastIndex = 0;
            // Clip maskedSrc to same section of string as src (move to lexer?)
            maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
            while((match = endReg.exec(maskedSrc)) != null){
                rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                if (!rDelim) continue; // skip single * in __abc*abc__
                rLength = [
                    ...rDelim
                ].length;
                if (match[3] || match[4]) {
                    delimTotal += rLength;
                    continue;
                } else if (match[5] || match[6]) {
                    if (lLength % 3 && !((lLength + rLength) % 3)) {
                        midDelimTotal += rLength;
                        continue; // CommonMark Emphasis Rules 9-10
                    }
                }
                delimTotal -= rLength;
                if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                // Remove extra characters. *a*** -> *a*
                rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                // char length can be >1 for unicode characters;
                const lastCharLength = [
                    ...match[0]
                ][0].length;
                const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                // Create `em` if smallest delimiter has odd char count. *a***
                if (Math.min(lLength, rLength) % 2) {
                    const text = raw.slice(1, -1);
                    return {
                        type: 'em',
                        raw: raw,
                        text: text,
                        tokens: this.lexer.inlineTokens(text)
                    };
                }
                // Create 'strong' if smallest delimiter has even char count. **a***
                const text = raw.slice(2, -2);
                return {
                    type: 'strong',
                    raw: raw,
                    text: text,
                    tokens: this.lexer.inlineTokens(text)
                };
            }
        }
    }
    codespan(src) {
        const cap = this.rules.inline.code.exec(src);
        if (cap) {
            let text = cap[2].replace(/\n/g, ' ');
            const hasNonSpaceChars = /[^ ]/.test(text);
            const hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
            if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
            text = $c186377a43ac04e5$var$escape$1(text, true);
            return {
                type: 'codespan',
                raw: cap[0],
                text: text
            };
        }
    }
    br(src) {
        const cap = this.rules.inline.br.exec(src);
        if (cap) return {
            type: 'br',
            raw: cap[0]
        };
    }
    del(src) {
        const cap = this.rules.inline.del.exec(src);
        if (cap) return {
            type: 'del',
            raw: cap[0],
            text: cap[2],
            tokens: this.lexer.inlineTokens(cap[2])
        };
    }
    autolink(src) {
        const cap = this.rules.inline.autolink.exec(src);
        if (cap) {
            let text, href;
            if (cap[2] === '@') {
                text = $c186377a43ac04e5$var$escape$1(cap[1]);
                href = 'mailto:' + text;
            } else {
                text = $c186377a43ac04e5$var$escape$1(cap[1]);
                href = text;
            }
            return {
                type: 'link',
                raw: cap[0],
                text: text,
                href: href,
                tokens: [
                    {
                        type: 'text',
                        raw: text,
                        text: text
                    }
                ]
            };
        }
    }
    url(src) {
        let cap;
        if (cap = this.rules.inline.url.exec(src)) {
            let text, href;
            if (cap[2] === '@') {
                text = $c186377a43ac04e5$var$escape$1(cap[0]);
                href = 'mailto:' + text;
            } else {
                // do extended autolink path validation
                let prevCapZero;
                do {
                    prevCapZero = cap[0];
                    cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? '';
                }while (prevCapZero !== cap[0]);
                text = $c186377a43ac04e5$var$escape$1(cap[0]);
                if (cap[1] === 'www.') href = 'http://' + cap[0];
                else href = cap[0];
            }
            return {
                type: 'link',
                raw: cap[0],
                text: text,
                href: href,
                tokens: [
                    {
                        type: 'text',
                        raw: text,
                        text: text
                    }
                ]
            };
        }
    }
    inlineText(src) {
        const cap = this.rules.inline.text.exec(src);
        if (cap) {
            let text;
            if (this.lexer.state.inRawBlock) text = cap[0];
            else text = $c186377a43ac04e5$var$escape$1(cap[0]);
            return {
                type: 'text',
                raw: cap[0],
                text: text
            };
        }
    }
}
/**
 * Block-Level Grammar
 */ const $c186377a43ac04e5$var$newline = /^(?: *(?:\n|$))+/;
const $c186377a43ac04e5$var$blockCode = /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/;
const $c186377a43ac04e5$var$fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
const $c186377a43ac04e5$var$hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
const $c186377a43ac04e5$var$heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
const $c186377a43ac04e5$var$bullet = /(?:[*+-]|\d{1,9}[.)])/;
const $c186377a43ac04e5$var$lheading = $c186377a43ac04e5$var$edit(/^(?!bull |blockCode|fences|blockquote|heading|html)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html))+?)\n {0,3}(=+|-+) *(?:\n+|$)/).replace(/bull/g, $c186377a43ac04e5$var$bullet) // lists can interrupt
.replace(/blockCode/g, / {4}/) // indented code blocks can interrupt
.replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/) // fenced code blocks can interrupt
.replace(/blockquote/g, / {0,3}>/) // blockquote can interrupt
.replace(/heading/g, / {0,3}#{1,6}/) // ATX heading can interrupt
.replace(/html/g, / {0,3}<[^\n>]+>\n/) // block html can interrupt
.getRegex();
const $c186377a43ac04e5$var$_paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
const $c186377a43ac04e5$var$blockText = /^[^\n]+/;
const $c186377a43ac04e5$var$_blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
const $c186377a43ac04e5$var$def = $c186377a43ac04e5$var$edit(/^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/).replace('label', $c186377a43ac04e5$var$_blockLabel).replace('title', /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
const $c186377a43ac04e5$var$list = $c186377a43ac04e5$var$edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, $c186377a43ac04e5$var$bullet).getRegex();
const $c186377a43ac04e5$var$_tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
const $c186377a43ac04e5$var$_comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
const $c186377a43ac04e5$var$html = $c186377a43ac04e5$var$edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))", 'i').replace('comment', $c186377a43ac04e5$var$_comment).replace('tag', $c186377a43ac04e5$var$_tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
const $c186377a43ac04e5$var$paragraph = $c186377a43ac04e5$var$edit($c186377a43ac04e5$var$_paragraph).replace('hr', $c186377a43ac04e5$var$hr).replace('heading', ' {0,3}#{1,6}(?:\\s|$)').replace('|lheading', '') // setext headings don't interrupt commonmark paragraphs
.replace('|table', '').replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
.replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', $c186377a43ac04e5$var$_tag) // pars can be interrupted by type (6) html blocks
.getRegex();
const $c186377a43ac04e5$var$blockquote = $c186377a43ac04e5$var$edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace('paragraph', $c186377a43ac04e5$var$paragraph).getRegex();
/**
 * Normal Block Grammar
 */ const $c186377a43ac04e5$var$blockNormal = {
    blockquote: $c186377a43ac04e5$var$blockquote,
    code: $c186377a43ac04e5$var$blockCode,
    def: $c186377a43ac04e5$var$def,
    fences: $c186377a43ac04e5$var$fences,
    heading: $c186377a43ac04e5$var$heading,
    hr: $c186377a43ac04e5$var$hr,
    html: $c186377a43ac04e5$var$html,
    lheading: $c186377a43ac04e5$var$lheading,
    list: $c186377a43ac04e5$var$list,
    newline: $c186377a43ac04e5$var$newline,
    paragraph: $c186377a43ac04e5$var$paragraph,
    table: $c186377a43ac04e5$var$noopTest,
    text: $c186377a43ac04e5$var$blockText
};
/**
 * GFM Block Grammar
 */ const $c186377a43ac04e5$var$gfmTable = $c186377a43ac04e5$var$edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)") // Cells
.replace('hr', $c186377a43ac04e5$var$hr).replace('heading', ' {0,3}#{1,6}(?:\\s|$)').replace('blockquote', ' {0,3}>').replace('code', ' {4}[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
.replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', $c186377a43ac04e5$var$_tag) // tables can be interrupted by type (6) html blocks
.getRegex();
const $c186377a43ac04e5$var$blockGfm = {
    ...$c186377a43ac04e5$var$blockNormal,
    table: $c186377a43ac04e5$var$gfmTable,
    paragraph: $c186377a43ac04e5$var$edit($c186377a43ac04e5$var$_paragraph).replace('hr', $c186377a43ac04e5$var$hr).replace('heading', ' {0,3}#{1,6}(?:\\s|$)').replace('|lheading', '') // setext headings don't interrupt commonmark paragraphs
    .replace('table', $c186377a43ac04e5$var$gfmTable) // interrupt paragraphs with table
    .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', $c186377a43ac04e5$var$_tag) // pars can be interrupted by type (6) html blocks
    .getRegex()
};
/**
 * Pedantic grammar (original John Gruber's loose markdown specification)
 */ const $c186377a43ac04e5$var$blockPedantic = {
    ...$c186377a43ac04e5$var$blockNormal,
    html: $c186377a43ac04e5$var$edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace('comment', $c186377a43ac04e5$var$_comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: $c186377a43ac04e5$var$noopTest,
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: $c186377a43ac04e5$var$edit($c186377a43ac04e5$var$_paragraph).replace('hr', $c186377a43ac04e5$var$hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', $c186377a43ac04e5$var$lheading).replace('|table', '').replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').replace('|tag', '').getRegex()
};
/**
 * Inline-Level Grammar
 */ const $c186377a43ac04e5$var$escape = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
const $c186377a43ac04e5$var$inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
const $c186377a43ac04e5$var$br = /^( {2,}|\\)\n(?!\s*$)/;
const $c186377a43ac04e5$var$inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
// list of unicode punctuation marks, plus any missing characters from CommonMark spec
const $c186377a43ac04e5$var$_punctuation = '\\p{P}\\p{S}';
const $c186377a43ac04e5$var$punctuation = $c186377a43ac04e5$var$edit(/^((?![*_])[\spunctuation])/, 'u').replace(/punctuation/g, $c186377a43ac04e5$var$_punctuation).getRegex();
// sequences em should skip over [title](link), `code`, <html>
const $c186377a43ac04e5$var$blockSkip = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g;
const $c186377a43ac04e5$var$emStrongLDelim = $c186377a43ac04e5$var$edit(/^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/, 'u').replace(/punct/g, $c186377a43ac04e5$var$_punctuation).getRegex();
const $c186377a43ac04e5$var$emStrongRDelimAst = $c186377a43ac04e5$var$edit("^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)[punct](\\*+)(?=[\\s]|$)|[^punct\\s](\\*+)(?!\\*)(?=[punct\\s]|$)|(?!\\*)[punct\\s](\\*+)(?=[^punct\\s])|[\\s](\\*+)(?!\\*)(?=[punct])|(?!\\*)[punct](\\*+)(?!\\*)(?=[punct])|[^punct\\s](\\*+)(?=[^punct\\s])", 'gu') // (6) a***a can be either Left or Right Delimiter
.replace(/punct/g, $c186377a43ac04e5$var$_punctuation).getRegex();
// (6) Not allowed for _
const $c186377a43ac04e5$var$emStrongRDelimUnd = $c186377a43ac04e5$var$edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\\s]|$)|[^punct\\s](_+)(?!_)(?=[punct\\s]|$)|(?!_)[punct\\s](_+)(?=[^punct\\s])|[\\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])", 'gu') // (5) #___# can be either Left or Right Delimiter
.replace(/punct/g, $c186377a43ac04e5$var$_punctuation).getRegex();
const $c186377a43ac04e5$var$anyPunctuation = $c186377a43ac04e5$var$edit(/\\([punct])/, 'gu').replace(/punct/g, $c186377a43ac04e5$var$_punctuation).getRegex();
const $c186377a43ac04e5$var$autolink = $c186377a43ac04e5$var$edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace('scheme', /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace('email', /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
const $c186377a43ac04e5$var$_inlineComment = $c186377a43ac04e5$var$edit($c186377a43ac04e5$var$_comment).replace('(?:-->|$)', '-->').getRegex();
const $c186377a43ac04e5$var$tag = $c186377a43ac04e5$var$edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>") // CDATA section
.replace('comment', $c186377a43ac04e5$var$_inlineComment).replace('attribute', /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
const $c186377a43ac04e5$var$_inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
const $c186377a43ac04e5$var$link = $c186377a43ac04e5$var$edit(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace('label', $c186377a43ac04e5$var$_inlineLabel).replace('href', /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace('title', /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
const $c186377a43ac04e5$var$reflink = $c186377a43ac04e5$var$edit(/^!?\[(label)\]\[(ref)\]/).replace('label', $c186377a43ac04e5$var$_inlineLabel).replace('ref', $c186377a43ac04e5$var$_blockLabel).getRegex();
const $c186377a43ac04e5$var$nolink = $c186377a43ac04e5$var$edit(/^!?\[(ref)\](?:\[\])?/).replace('ref', $c186377a43ac04e5$var$_blockLabel).getRegex();
const $c186377a43ac04e5$var$reflinkSearch = $c186377a43ac04e5$var$edit('reflink|nolink(?!\\()', 'g').replace('reflink', $c186377a43ac04e5$var$reflink).replace('nolink', $c186377a43ac04e5$var$nolink).getRegex();
/**
 * Normal Inline Grammar
 */ const $c186377a43ac04e5$var$inlineNormal = {
    _backpedal: $c186377a43ac04e5$var$noopTest,
    anyPunctuation: $c186377a43ac04e5$var$anyPunctuation,
    autolink: $c186377a43ac04e5$var$autolink,
    blockSkip: $c186377a43ac04e5$var$blockSkip,
    br: $c186377a43ac04e5$var$br,
    code: $c186377a43ac04e5$var$inlineCode,
    del: $c186377a43ac04e5$var$noopTest,
    emStrongLDelim: $c186377a43ac04e5$var$emStrongLDelim,
    emStrongRDelimAst: $c186377a43ac04e5$var$emStrongRDelimAst,
    emStrongRDelimUnd: $c186377a43ac04e5$var$emStrongRDelimUnd,
    escape: $c186377a43ac04e5$var$escape,
    link: $c186377a43ac04e5$var$link,
    nolink: $c186377a43ac04e5$var$nolink,
    punctuation: $c186377a43ac04e5$var$punctuation,
    reflink: $c186377a43ac04e5$var$reflink,
    reflinkSearch: $c186377a43ac04e5$var$reflinkSearch,
    tag: $c186377a43ac04e5$var$tag,
    text: $c186377a43ac04e5$var$inlineText,
    url: $c186377a43ac04e5$var$noopTest
};
/**
 * Pedantic Inline Grammar
 */ const $c186377a43ac04e5$var$inlinePedantic = {
    ...$c186377a43ac04e5$var$inlineNormal,
    link: $c186377a43ac04e5$var$edit(/^!?\[(label)\]\((.*?)\)/).replace('label', $c186377a43ac04e5$var$_inlineLabel).getRegex(),
    reflink: $c186377a43ac04e5$var$edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', $c186377a43ac04e5$var$_inlineLabel).getRegex()
};
/**
 * GFM Inline Grammar
 */ const $c186377a43ac04e5$var$inlineGfm = {
    ...$c186377a43ac04e5$var$inlineNormal,
    escape: $c186377a43ac04e5$var$edit($c186377a43ac04e5$var$escape).replace('])', '~|])').getRegex(),
    url: $c186377a43ac04e5$var$edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, 'i').replace('email', /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};
/**
 * GFM + Line Breaks Inline Grammar
 */ const $c186377a43ac04e5$var$inlineBreaks = {
    ...$c186377a43ac04e5$var$inlineGfm,
    br: $c186377a43ac04e5$var$edit($c186377a43ac04e5$var$br).replace('{2,}', '*').getRegex(),
    text: $c186377a43ac04e5$var$edit($c186377a43ac04e5$var$inlineGfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
};
/**
 * exports
 */ const $c186377a43ac04e5$var$block = {
    normal: $c186377a43ac04e5$var$blockNormal,
    gfm: $c186377a43ac04e5$var$blockGfm,
    pedantic: $c186377a43ac04e5$var$blockPedantic
};
const $c186377a43ac04e5$var$inline = {
    normal: $c186377a43ac04e5$var$inlineNormal,
    gfm: $c186377a43ac04e5$var$inlineGfm,
    breaks: $c186377a43ac04e5$var$inlineBreaks,
    pedantic: $c186377a43ac04e5$var$inlinePedantic
};
/**
 * Block Lexer
 */ class $c186377a43ac04e5$export$6168dc8908a6c652 {
    tokens;
    options;
    state;
    tokenizer;
    inlineQueue;
    constructor(options){
        // TokenList cannot be created in one go
        this.tokens = [];
        this.tokens.links = Object.create(null);
        this.options = options || $c186377a43ac04e5$export$ebe90cb607ad99e;
        this.options.tokenizer = this.options.tokenizer || new $c186377a43ac04e5$export$55e8b082af4aa63e();
        this.tokenizer = this.options.tokenizer;
        this.tokenizer.options = this.options;
        this.tokenizer.lexer = this;
        this.inlineQueue = [];
        this.state = {
            inLink: false,
            inRawBlock: false,
            top: true
        };
        const rules = {
            block: $c186377a43ac04e5$var$block.normal,
            inline: $c186377a43ac04e5$var$inline.normal
        };
        if (this.options.pedantic) {
            rules.block = $c186377a43ac04e5$var$block.pedantic;
            rules.inline = $c186377a43ac04e5$var$inline.pedantic;
        } else if (this.options.gfm) {
            rules.block = $c186377a43ac04e5$var$block.gfm;
            if (this.options.breaks) rules.inline = $c186377a43ac04e5$var$inline.breaks;
            else rules.inline = $c186377a43ac04e5$var$inline.gfm;
        }
        this.tokenizer.rules = rules;
    }
    /**
     * Expose Rules
     */ static get rules() {
        return {
            block: $c186377a43ac04e5$var$block,
            inline: $c186377a43ac04e5$var$inline
        };
    }
    /**
     * Static Lex Method
     */ static lex(src, options) {
        const lexer = new $c186377a43ac04e5$export$6168dc8908a6c652(options);
        return lexer.lex(src);
    }
    /**
     * Static Lex Inline Method
     */ static lexInline(src, options) {
        const lexer = new $c186377a43ac04e5$export$6168dc8908a6c652(options);
        return lexer.inlineTokens(src);
    }
    /**
     * Preprocessing
     */ lex(src) {
        src = src.replace(/\r\n|\r/g, '\n');
        this.blockTokens(src, this.tokens);
        for(let i = 0; i < this.inlineQueue.length; i++){
            const next = this.inlineQueue[i];
            this.inlineTokens(next.src, next.tokens);
        }
        this.inlineQueue = [];
        return this.tokens;
    }
    blockTokens(src, tokens = []) {
        if (this.options.pedantic) src = src.replace(/\t/g, '    ').replace(/^ +$/gm, '');
        else src = src.replace(/^( *)(\t+)/gm, (_, leading, tabs)=>{
            return leading + '    '.repeat(tabs.length);
        });
        let token;
        let lastToken;
        let cutSrc;
        let lastParagraphClipped;
        while(src){
            if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((extTokenizer)=>{
                if (token = extTokenizer.call({
                    lexer: this
                }, src, tokens)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    return true;
                }
                return false;
            })) continue;
            // newline
            if (token = this.tokenizer.space(src)) {
                src = src.substring(token.raw.length);
                if (token.raw.length === 1 && tokens.length > 0) // if there's a single \n as a spacer, it's terminating the last line,
                // so move it there so that we don't get unnecessary paragraph tags
                tokens[tokens.length - 1].raw += '\n';
                else tokens.push(token);
                continue;
            }
            // code
            if (token = this.tokenizer.code(src)) {
                src = src.substring(token.raw.length);
                lastToken = tokens[tokens.length - 1];
                // An indented code block cannot interrupt a paragraph.
                if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
                    lastToken.raw += '\n' + token.raw;
                    lastToken.text += '\n' + token.text;
                    this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                } else tokens.push(token);
                continue;
            }
            // fences
            if (token = this.tokenizer.fences(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // heading
            if (token = this.tokenizer.heading(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // hr
            if (token = this.tokenizer.hr(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // blockquote
            if (token = this.tokenizer.blockquote(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // list
            if (token = this.tokenizer.list(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // html
            if (token = this.tokenizer.html(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // def
            if (token = this.tokenizer.def(src)) {
                src = src.substring(token.raw.length);
                lastToken = tokens[tokens.length - 1];
                if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
                    lastToken.raw += '\n' + token.raw;
                    lastToken.text += '\n' + token.raw;
                    this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                    href: token.href,
                    title: token.title
                };
                continue;
            }
            // table (gfm)
            if (token = this.tokenizer.table(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // lheading
            if (token = this.tokenizer.lheading(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // top-level paragraph
            // prevent paragraph consuming extensions by clipping 'src' to extension start
            cutSrc = src;
            if (this.options.extensions && this.options.extensions.startBlock) {
                let startIndex = Infinity;
                const tempSrc = src.slice(1);
                let tempStart;
                this.options.extensions.startBlock.forEach((getStartIndex)=>{
                    tempStart = getStartIndex.call({
                        lexer: this
                    }, tempSrc);
                    if (typeof tempStart === 'number' && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                });
                if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
            }
            if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                lastToken = tokens[tokens.length - 1];
                if (lastParagraphClipped && lastToken.type === 'paragraph') {
                    lastToken.raw += '\n' + token.raw;
                    lastToken.text += '\n' + token.text;
                    this.inlineQueue.pop();
                    this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                } else tokens.push(token);
                lastParagraphClipped = cutSrc.length !== src.length;
                src = src.substring(token.raw.length);
                continue;
            }
            // text
            if (token = this.tokenizer.text(src)) {
                src = src.substring(token.raw.length);
                lastToken = tokens[tokens.length - 1];
                if (lastToken && lastToken.type === 'text') {
                    lastToken.raw += '\n' + token.raw;
                    lastToken.text += '\n' + token.text;
                    this.inlineQueue.pop();
                    this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                } else tokens.push(token);
                continue;
            }
            if (src) {
                const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                } else throw new Error(errMsg);
            }
        }
        this.state.top = true;
        return tokens;
    }
    inline(src, tokens = []) {
        this.inlineQueue.push({
            src: src,
            tokens: tokens
        });
        return tokens;
    }
    /**
     * Lexing/Compiling
     */ inlineTokens(src, tokens = []) {
        let token, lastToken, cutSrc;
        // String with links masked to avoid interference with em and strong
        let maskedSrc = src;
        let match;
        let keepPrevChar, prevChar;
        // Mask out reflinks
        if (this.tokens.links) {
            const links = Object.keys(this.tokens.links);
            if (links.length > 0) {
                while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
            }
        }
        // Mask out other blocks
        while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
        // Mask out escaped characters
        while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
        while(src){
            if (!keepPrevChar) prevChar = '';
            keepPrevChar = false;
            // extensions
            if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((extTokenizer)=>{
                if (token = extTokenizer.call({
                    lexer: this
                }, src, tokens)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    return true;
                }
                return false;
            })) continue;
            // escape
            if (token = this.tokenizer.escape(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // tag
            if (token = this.tokenizer.tag(src)) {
                src = src.substring(token.raw.length);
                lastToken = tokens[tokens.length - 1];
                if (lastToken && token.type === 'text' && lastToken.type === 'text') {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                } else tokens.push(token);
                continue;
            }
            // link
            if (token = this.tokenizer.link(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // reflink, nolink
            if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                src = src.substring(token.raw.length);
                lastToken = tokens[tokens.length - 1];
                if (lastToken && token.type === 'text' && lastToken.type === 'text') {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                } else tokens.push(token);
                continue;
            }
            // em & strong
            if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // code
            if (token = this.tokenizer.codespan(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // br
            if (token = this.tokenizer.br(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // del (gfm)
            if (token = this.tokenizer.del(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // autolink
            if (token = this.tokenizer.autolink(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // url (gfm)
            if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            // text
            // prevent inlineText consuming extensions by clipping 'src' to extension start
            cutSrc = src;
            if (this.options.extensions && this.options.extensions.startInline) {
                let startIndex = Infinity;
                const tempSrc = src.slice(1);
                let tempStart;
                this.options.extensions.startInline.forEach((getStartIndex)=>{
                    tempStart = getStartIndex.call({
                        lexer: this
                    }, tempSrc);
                    if (typeof tempStart === 'number' && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                });
                if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
            }
            if (token = this.tokenizer.inlineText(cutSrc)) {
                src = src.substring(token.raw.length);
                if (token.raw.slice(-1) !== '_') prevChar = token.raw.slice(-1);
                keepPrevChar = true;
                lastToken = tokens[tokens.length - 1];
                if (lastToken && lastToken.type === 'text') {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                } else tokens.push(token);
                continue;
            }
            if (src) {
                const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                } else throw new Error(errMsg);
            }
        }
        return tokens;
    }
}
/**
 * Renderer
 */ class $c186377a43ac04e5$export$88530751e3977073 {
    options;
    constructor(options){
        this.options = options || $c186377a43ac04e5$export$ebe90cb607ad99e;
    }
    code(code, infostring, escaped) {
        const lang = (infostring || '').match(/^\S*/)?.[0];
        code = code.replace(/\n$/, '') + '\n';
        if (!lang) return '<pre><code>' + (escaped ? code : $c186377a43ac04e5$var$escape$1(code, true)) + '</code></pre>\n';
        return '<pre><code class="language-' + $c186377a43ac04e5$var$escape$1(lang) + '">' + (escaped ? code : $c186377a43ac04e5$var$escape$1(code, true)) + '</code></pre>\n';
    }
    blockquote(quote) {
        return `<blockquote>\n${quote}</blockquote>\n`;
    }
    html(html, block) {
        return html;
    }
    heading(text, level, raw) {
        // ignore IDs
        return `<h${level}>${text}</h${level}>\n`;
    }
    hr() {
        return '<hr>\n';
    }
    list(body, ordered, start) {
        const type = ordered ? 'ol' : 'ul';
        const startatt = ordered && start !== 1 ? ' start="' + start + '"' : '';
        return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
    }
    listitem(text, task, checked) {
        return `<li>${text}</li>\n`;
    }
    checkbox(checked) {
        return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox">';
    }
    paragraph(text) {
        return `<p>${text}</p>\n`;
    }
    table(header, body) {
        if (body) body = `<tbody>${body}</tbody>`;
        return "<table>\n<thead>\n" + header + '</thead>\n' + body + '</table>\n';
    }
    tablerow(content) {
        return `<tr>\n${content}</tr>\n`;
    }
    tablecell(content, flags) {
        const type = flags.header ? 'th' : 'td';
        const tag = flags.align ? `<${type} align="${flags.align}">` : `<${type}>`;
        return tag + content + `</${type}>\n`;
    }
    /**
     * span level renderer
     */ strong(text) {
        return `<strong>${text}</strong>`;
    }
    em(text) {
        return `<em>${text}</em>`;
    }
    codespan(text) {
        return `<code>${text}</code>`;
    }
    br() {
        return '<br>';
    }
    del(text) {
        return `<del>${text}</del>`;
    }
    link(href, title, text) {
        const cleanHref = $c186377a43ac04e5$var$cleanUrl(href);
        if (cleanHref === null) return text;
        href = cleanHref;
        let out = '<a href="' + href + '"';
        if (title) out += ' title="' + title + '"';
        out += '>' + text + '</a>';
        return out;
    }
    image(href, title, text) {
        const cleanHref = $c186377a43ac04e5$var$cleanUrl(href);
        if (cleanHref === null) return text;
        href = cleanHref;
        let out = `<img src="${href}" alt="${text}"`;
        if (title) out += ` title="${title}"`;
        out += '>';
        return out;
    }
    text(text) {
        return text;
    }
}
/**
 * TextRenderer
 * returns only the textual part of the token
 */ class $c186377a43ac04e5$export$75ebcd2c8ed5b901 {
    // no need for block level renderers
    strong(text) {
        return text;
    }
    em(text) {
        return text;
    }
    codespan(text) {
        return text;
    }
    del(text) {
        return text;
    }
    html(text) {
        return text;
    }
    text(text) {
        return text;
    }
    link(href, title, text) {
        return '' + text;
    }
    image(href, title, text) {
        return '' + text;
    }
    br() {
        return '';
    }
}
/**
 * Parsing & Compiling
 */ class $c186377a43ac04e5$export$7acfa6ed01010e37 {
    options;
    renderer;
    textRenderer;
    constructor(options){
        this.options = options || $c186377a43ac04e5$export$ebe90cb607ad99e;
        this.options.renderer = this.options.renderer || new $c186377a43ac04e5$export$88530751e3977073();
        this.renderer = this.options.renderer;
        this.renderer.options = this.options;
        this.textRenderer = new $c186377a43ac04e5$export$75ebcd2c8ed5b901();
    }
    /**
     * Static Parse Method
     */ static parse(tokens, options) {
        const parser = new $c186377a43ac04e5$export$7acfa6ed01010e37(options);
        return parser.parse(tokens);
    }
    /**
     * Static Parse Inline Method
     */ static parseInline(tokens, options) {
        const parser = new $c186377a43ac04e5$export$7acfa6ed01010e37(options);
        return parser.parseInline(tokens);
    }
    /**
     * Parse Loop
     */ parse(tokens, top = true) {
        let out = '';
        for(let i = 0; i < tokens.length; i++){
            const token = tokens[i];
            // Run any renderer extensions
            if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                const genericToken = token;
                const ret = this.options.extensions.renderers[genericToken.type].call({
                    parser: this
                }, genericToken);
                if (ret !== false || ![
                    'space',
                    'hr',
                    'heading',
                    'code',
                    'table',
                    'blockquote',
                    'list',
                    'html',
                    'paragraph',
                    'text'
                ].includes(genericToken.type)) {
                    out += ret || '';
                    continue;
                }
            }
            switch(token.type){
                case 'space':
                    continue;
                case 'hr':
                    out += this.renderer.hr();
                    continue;
                case 'heading':
                    {
                        const headingToken = token;
                        out += this.renderer.heading(this.parseInline(headingToken.tokens), headingToken.depth, $c186377a43ac04e5$var$unescape(this.parseInline(headingToken.tokens, this.textRenderer)));
                        continue;
                    }
                case 'code':
                    {
                        const codeToken = token;
                        out += this.renderer.code(codeToken.text, codeToken.lang, !!codeToken.escaped);
                        continue;
                    }
                case 'table':
                    {
                        const tableToken = token;
                        let header = '';
                        // header
                        let cell = '';
                        for(let j = 0; j < tableToken.header.length; j++)cell += this.renderer.tablecell(this.parseInline(tableToken.header[j].tokens), {
                            header: true,
                            align: tableToken.align[j]
                        });
                        header += this.renderer.tablerow(cell);
                        let body = '';
                        for(let j = 0; j < tableToken.rows.length; j++){
                            const row = tableToken.rows[j];
                            cell = '';
                            for(let k = 0; k < row.length; k++)cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
                                header: false,
                                align: tableToken.align[k]
                            });
                            body += this.renderer.tablerow(cell);
                        }
                        out += this.renderer.table(header, body);
                        continue;
                    }
                case 'blockquote':
                    {
                        const blockquoteToken = token;
                        const body = this.parse(blockquoteToken.tokens);
                        out += this.renderer.blockquote(body);
                        continue;
                    }
                case 'list':
                    {
                        const listToken = token;
                        const ordered = listToken.ordered;
                        const start = listToken.start;
                        const loose = listToken.loose;
                        let body = '';
                        for(let j = 0; j < listToken.items.length; j++){
                            const item = listToken.items[j];
                            const checked = item.checked;
                            const task = item.task;
                            let itemBody = '';
                            if (item.task) {
                                const checkbox = this.renderer.checkbox(!!checked);
                                if (loose) {
                                    if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
                                        item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                                        if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                                    } else item.tokens.unshift({
                                        type: 'text',
                                        text: checkbox + ' '
                                    });
                                } else itemBody += checkbox + ' ';
                            }
                            itemBody += this.parse(item.tokens, loose);
                            body += this.renderer.listitem(itemBody, task, !!checked);
                        }
                        out += this.renderer.list(body, ordered, start);
                        continue;
                    }
                case 'html':
                    {
                        const htmlToken = token;
                        out += this.renderer.html(htmlToken.text, htmlToken.block);
                        continue;
                    }
                case 'paragraph':
                    {
                        const paragraphToken = token;
                        out += this.renderer.paragraph(this.parseInline(paragraphToken.tokens));
                        continue;
                    }
                case 'text':
                    {
                        let textToken = token;
                        let body = textToken.tokens ? this.parseInline(textToken.tokens) : textToken.text;
                        while(i + 1 < tokens.length && tokens[i + 1].type === 'text'){
                            textToken = tokens[++i];
                            body += '\n' + (textToken.tokens ? this.parseInline(textToken.tokens) : textToken.text);
                        }
                        out += top ? this.renderer.paragraph(body) : body;
                        continue;
                    }
                default:
                    {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return '';
                        } else throw new Error(errMsg);
                    }
            }
        }
        return out;
    }
    /**
     * Parse Inline Tokens
     */ parseInline(tokens, renderer) {
        renderer = renderer || this.renderer;
        let out = '';
        for(let i = 0; i < tokens.length; i++){
            const token = tokens[i];
            // Run any renderer extensions
            if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                const ret = this.options.extensions.renderers[token.type].call({
                    parser: this
                }, token);
                if (ret !== false || ![
                    'escape',
                    'html',
                    'link',
                    'image',
                    'strong',
                    'em',
                    'codespan',
                    'br',
                    'del',
                    'text'
                ].includes(token.type)) {
                    out += ret || '';
                    continue;
                }
            }
            switch(token.type){
                case 'escape':
                    {
                        const escapeToken = token;
                        out += renderer.text(escapeToken.text);
                        break;
                    }
                case 'html':
                    {
                        const tagToken = token;
                        out += renderer.html(tagToken.text);
                        break;
                    }
                case 'link':
                    {
                        const linkToken = token;
                        out += renderer.link(linkToken.href, linkToken.title, this.parseInline(linkToken.tokens, renderer));
                        break;
                    }
                case 'image':
                    {
                        const imageToken = token;
                        out += renderer.image(imageToken.href, imageToken.title, imageToken.text);
                        break;
                    }
                case 'strong':
                    {
                        const strongToken = token;
                        out += renderer.strong(this.parseInline(strongToken.tokens, renderer));
                        break;
                    }
                case 'em':
                    {
                        const emToken = token;
                        out += renderer.em(this.parseInline(emToken.tokens, renderer));
                        break;
                    }
                case 'codespan':
                    {
                        const codespanToken = token;
                        out += renderer.codespan(codespanToken.text);
                        break;
                    }
                case 'br':
                    out += renderer.br();
                    break;
                case 'del':
                    {
                        const delToken = token;
                        out += renderer.del(this.parseInline(delToken.tokens, renderer));
                        break;
                    }
                case 'text':
                    {
                        const textToken = token;
                        out += renderer.text(textToken.text);
                        break;
                    }
                default:
                    {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return '';
                        } else throw new Error(errMsg);
                    }
            }
        }
        return out;
    }
}
class $c186377a43ac04e5$export$5fbefe39e79899a6 {
    options;
    constructor(options){
        this.options = options || $c186377a43ac04e5$export$ebe90cb607ad99e;
    }
    static passThroughHooks = new Set([
        'preprocess',
        'postprocess',
        'processAllTokens'
    ]);
    /**
     * Process markdown before marked
     */ preprocess(markdown) {
        return markdown;
    }
    /**
     * Process HTML after marked is finished
     */ postprocess(html) {
        return html;
    }
    /**
     * Process all tokens before walk tokens
     */ processAllTokens(tokens) {
        return tokens;
    }
}
class $c186377a43ac04e5$export$164128c95a350e30 {
    defaults = $c186377a43ac04e5$export$212bb2fc580a90a8();
    options = this.setOptions;
    parse = this.#parseMarkdown($c186377a43ac04e5$export$6168dc8908a6c652.lex, $c186377a43ac04e5$export$7acfa6ed01010e37.parse);
    parseInline = this.#parseMarkdown($c186377a43ac04e5$export$6168dc8908a6c652.lexInline, $c186377a43ac04e5$export$7acfa6ed01010e37.parseInline);
    Parser = $c186377a43ac04e5$export$7acfa6ed01010e37;
    Renderer = $c186377a43ac04e5$export$88530751e3977073;
    TextRenderer = $c186377a43ac04e5$export$75ebcd2c8ed5b901;
    Lexer = $c186377a43ac04e5$export$6168dc8908a6c652;
    Tokenizer = $c186377a43ac04e5$export$55e8b082af4aa63e;
    Hooks = $c186377a43ac04e5$export$5fbefe39e79899a6;
    constructor(...args){
        this.use(...args);
    }
    /**
     * Run callback for every token
     */ walkTokens(tokens, callback) {
        let values = [];
        for (const token of tokens){
            values = values.concat(callback.call(this, token));
            switch(token.type){
                case 'table':
                    {
                        const tableToken = token;
                        for (const cell of tableToken.header)values = values.concat(this.walkTokens(cell.tokens, callback));
                        for (const row of tableToken.rows)for (const cell of row)values = values.concat(this.walkTokens(cell.tokens, callback));
                        break;
                    }
                case 'list':
                    {
                        const listToken = token;
                        values = values.concat(this.walkTokens(listToken.items, callback));
                        break;
                    }
                default:
                    {
                        const genericToken = token;
                        if (this.defaults.extensions?.childTokens?.[genericToken.type]) this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens)=>{
                            const tokens = genericToken[childTokens].flat(Infinity);
                            values = values.concat(this.walkTokens(tokens, callback));
                        });
                        else if (genericToken.tokens) values = values.concat(this.walkTokens(genericToken.tokens, callback));
                    }
            }
        }
        return values;
    }
    use(...args) {
        const extensions = this.defaults.extensions || {
            renderers: {},
            childTokens: {}
        };
        args.forEach((pack)=>{
            // copy options to new object
            const opts = {
                ...pack
            };
            // set async to true if it was set to true before
            opts.async = this.defaults.async || opts.async || false;
            // ==-- Parse "addon" extensions --== //
            if (pack.extensions) {
                pack.extensions.forEach((ext)=>{
                    if (!ext.name) throw new Error('extension name required');
                    if ('renderer' in ext) {
                        const prevRenderer = extensions.renderers[ext.name];
                        if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                        extensions.renderers[ext.name] = function(...args) {
                            let ret = ext.renderer.apply(this, args);
                            if (ret === false) ret = prevRenderer.apply(this, args);
                            return ret;
                        };
                        else extensions.renderers[ext.name] = ext.renderer;
                    }
                    if ('tokenizer' in ext) {
                        if (!ext.level || ext.level !== 'block' && ext.level !== 'inline') throw new Error("extension level must be 'block' or 'inline'");
                        const extLevel = extensions[ext.level];
                        if (extLevel) extLevel.unshift(ext.tokenizer);
                        else extensions[ext.level] = [
                            ext.tokenizer
                        ];
                        if (ext.start) {
                            if (ext.level === 'block') {
                                if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                else extensions.startBlock = [
                                    ext.start
                                ];
                            } else if (ext.level === 'inline') {
                                if (extensions.startInline) extensions.startInline.push(ext.start);
                                else extensions.startInline = [
                                    ext.start
                                ];
                            }
                        }
                    }
                    if ('childTokens' in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                });
                opts.extensions = extensions;
            }
            // ==-- Parse "overwrite" extensions --== //
            if (pack.renderer) {
                const renderer = this.defaults.renderer || new $c186377a43ac04e5$export$88530751e3977073(this.defaults);
                for(const prop in pack.renderer){
                    if (!(prop in renderer)) throw new Error(`renderer '${prop}' does not exist`);
                    if (prop === 'options') continue;
                    const rendererProp = prop;
                    const rendererFunc = pack.renderer[rendererProp];
                    const prevRenderer = renderer[rendererProp];
                    // Replace renderer with func to run extension, but fall back if false
                    renderer[rendererProp] = (...args)=>{
                        let ret = rendererFunc.apply(renderer, args);
                        if (ret === false) ret = prevRenderer.apply(renderer, args);
                        return ret || '';
                    };
                }
                opts.renderer = renderer;
            }
            if (pack.tokenizer) {
                const tokenizer = this.defaults.tokenizer || new $c186377a43ac04e5$export$55e8b082af4aa63e(this.defaults);
                for(const prop in pack.tokenizer){
                    if (!(prop in tokenizer)) throw new Error(`tokenizer '${prop}' does not exist`);
                    if ([
                        'options',
                        'rules',
                        'lexer'
                    ].includes(prop)) continue;
                    const tokenizerProp = prop;
                    const tokenizerFunc = pack.tokenizer[tokenizerProp];
                    const prevTokenizer = tokenizer[tokenizerProp];
                    // Replace tokenizer with func to run extension, but fall back if false
                    // @ts-expect-error cannot type tokenizer function dynamically
                    tokenizer[tokenizerProp] = (...args)=>{
                        let ret = tokenizerFunc.apply(tokenizer, args);
                        if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                        return ret;
                    };
                }
                opts.tokenizer = tokenizer;
            }
            // ==-- Parse Hooks extensions --== //
            if (pack.hooks) {
                const hooks = this.defaults.hooks || new $c186377a43ac04e5$export$5fbefe39e79899a6();
                for(const prop in pack.hooks){
                    if (!(prop in hooks)) throw new Error(`hook '${prop}' does not exist`);
                    if (prop === 'options') continue;
                    const hooksProp = prop;
                    const hooksFunc = pack.hooks[hooksProp];
                    const prevHook = hooks[hooksProp];
                    if ($c186377a43ac04e5$export$5fbefe39e79899a6.passThroughHooks.has(prop)) // @ts-expect-error cannot type hook function dynamically
                    hooks[hooksProp] = (arg)=>{
                        if (this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret)=>{
                            return prevHook.call(hooks, ret);
                        });
                        const ret = hooksFunc.call(hooks, arg);
                        return prevHook.call(hooks, ret);
                    };
                    else // @ts-expect-error cannot type hook function dynamically
                    hooks[hooksProp] = (...args)=>{
                        let ret = hooksFunc.apply(hooks, args);
                        if (ret === false) ret = prevHook.apply(hooks, args);
                        return ret;
                    };
                }
                opts.hooks = hooks;
            }
            // ==-- Parse WalkTokens extensions --== //
            if (pack.walkTokens) {
                const walkTokens = this.defaults.walkTokens;
                const packWalktokens = pack.walkTokens;
                opts.walkTokens = function(token) {
                    let values = [];
                    values.push(packWalktokens.call(this, token));
                    if (walkTokens) values = values.concat(walkTokens.call(this, token));
                    return values;
                };
            }
            this.defaults = {
                ...this.defaults,
                ...opts
            };
        });
        return this;
    }
    setOptions(opt) {
        this.defaults = {
            ...this.defaults,
            ...opt
        };
        return this;
    }
    lexer(src, options) {
        return $c186377a43ac04e5$export$6168dc8908a6c652.lex(src, options ?? this.defaults);
    }
    parser(tokens, options) {
        return $c186377a43ac04e5$export$7acfa6ed01010e37.parse(tokens, options ?? this.defaults);
    }
    #parseMarkdown(lexer, parser) {
        return (src, options)=>{
            const origOpt = {
                ...options
            };
            const opt = {
                ...this.defaults,
                ...origOpt
            };
            // Show warning if an extension set async to true but the parse was called with async: false
            if (this.defaults.async === true && origOpt.async === false) {
                if (!opt.silent) console.warn('marked(): The async option was set to true by an extension. The async: false option sent to parse will be ignored.');
                opt.async = true;
            }
            const throwError = this.#onError(!!opt.silent, !!opt.async);
            // throw error in case of non string input
            if (typeof src === 'undefined' || src === null) return throwError(new Error('marked(): input parameter is undefined or null'));
            if (typeof src !== 'string') return throwError(new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected'));
            if (opt.hooks) opt.hooks.options = opt;
            if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src)=>lexer(src, opt)).then((tokens)=>opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens).then((tokens)=>opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(()=>tokens) : tokens).then((tokens)=>parser(tokens, opt)).then((html)=>opt.hooks ? opt.hooks.postprocess(html) : html).catch(throwError);
            try {
                if (opt.hooks) src = opt.hooks.preprocess(src);
                let tokens = lexer(src, opt);
                if (opt.hooks) tokens = opt.hooks.processAllTokens(tokens);
                if (opt.walkTokens) this.walkTokens(tokens, opt.walkTokens);
                let html = parser(tokens, opt);
                if (opt.hooks) html = opt.hooks.postprocess(html);
                return html;
            } catch (e) {
                return throwError(e);
            }
        };
    }
    #onError(silent, async) {
        return (e)=>{
            e.message += '\nPlease report this to https://github.com/markedjs/marked.';
            if (silent) {
                const msg = '<p>An error occurred:</p><pre>' + $c186377a43ac04e5$var$escape$1(e.message + '', true) + '</pre>';
                if (async) return Promise.resolve(msg);
                return msg;
            }
            if (async) return Promise.reject(e);
            throw e;
        };
    }
}
const $c186377a43ac04e5$var$markedInstance = new $c186377a43ac04e5$export$164128c95a350e30();
function $c186377a43ac04e5$export$db8f131360c543a5(src, opt) {
    return $c186377a43ac04e5$var$markedInstance.parse(src, opt);
}
/**
 * Sets the default options.
 *
 * @param options Hash of options
 */ $c186377a43ac04e5$export$db8f131360c543a5.options = $c186377a43ac04e5$export$db8f131360c543a5.setOptions = function(options) {
    $c186377a43ac04e5$var$markedInstance.setOptions(options);
    $c186377a43ac04e5$export$db8f131360c543a5.defaults = $c186377a43ac04e5$var$markedInstance.defaults;
    $c186377a43ac04e5$var$changeDefaults($c186377a43ac04e5$export$db8f131360c543a5.defaults);
    return $c186377a43ac04e5$export$db8f131360c543a5;
};
/**
 * Gets the original marked default options.
 */ $c186377a43ac04e5$export$db8f131360c543a5.getDefaults = $c186377a43ac04e5$export$212bb2fc580a90a8;
$c186377a43ac04e5$export$db8f131360c543a5.defaults = $c186377a43ac04e5$export$ebe90cb607ad99e;
/**
 * Use Extension
 */ $c186377a43ac04e5$export$db8f131360c543a5.use = function(...args) {
    $c186377a43ac04e5$var$markedInstance.use(...args);
    $c186377a43ac04e5$export$db8f131360c543a5.defaults = $c186377a43ac04e5$var$markedInstance.defaults;
    $c186377a43ac04e5$var$changeDefaults($c186377a43ac04e5$export$db8f131360c543a5.defaults);
    return $c186377a43ac04e5$export$db8f131360c543a5;
};
/**
 * Run callback for every token
 */ $c186377a43ac04e5$export$db8f131360c543a5.walkTokens = function(tokens, callback) {
    return $c186377a43ac04e5$var$markedInstance.walkTokens(tokens, callback);
};
/**
 * Compiles markdown to HTML without enclosing `p` tag.
 *
 * @param src String of markdown source to be compiled
 * @param options Hash of options
 * @return String of compiled HTML
 */ $c186377a43ac04e5$export$db8f131360c543a5.parseInline = $c186377a43ac04e5$var$markedInstance.parseInline;
/**
 * Expose
 */ $c186377a43ac04e5$export$db8f131360c543a5.Parser = $c186377a43ac04e5$export$7acfa6ed01010e37;
$c186377a43ac04e5$export$db8f131360c543a5.parser = $c186377a43ac04e5$export$7acfa6ed01010e37.parse;
$c186377a43ac04e5$export$db8f131360c543a5.Renderer = $c186377a43ac04e5$export$88530751e3977073;
$c186377a43ac04e5$export$db8f131360c543a5.TextRenderer = $c186377a43ac04e5$export$75ebcd2c8ed5b901;
$c186377a43ac04e5$export$db8f131360c543a5.Lexer = $c186377a43ac04e5$export$6168dc8908a6c652;
$c186377a43ac04e5$export$db8f131360c543a5.lexer = $c186377a43ac04e5$export$6168dc8908a6c652.lex;
$c186377a43ac04e5$export$db8f131360c543a5.Tokenizer = $c186377a43ac04e5$export$55e8b082af4aa63e;
$c186377a43ac04e5$export$db8f131360c543a5.Hooks = $c186377a43ac04e5$export$5fbefe39e79899a6;
$c186377a43ac04e5$export$db8f131360c543a5.parse = $c186377a43ac04e5$export$db8f131360c543a5;
const $c186377a43ac04e5$export$41c562ebe57d11e2 = $c186377a43ac04e5$export$db8f131360c543a5.options;
const $c186377a43ac04e5$export$add91eafeaeab287 = $c186377a43ac04e5$export$db8f131360c543a5.setOptions;
const $c186377a43ac04e5$export$1f96ae73734a86cc = $c186377a43ac04e5$export$db8f131360c543a5.use;
const $c186377a43ac04e5$export$3eedd5437d43cb76 = $c186377a43ac04e5$export$db8f131360c543a5.walkTokens;
const $c186377a43ac04e5$export$c7679c2b5e355e6f = $c186377a43ac04e5$export$db8f131360c543a5.parseInline;
const $c186377a43ac04e5$export$98e6a39c04603d36 = $c186377a43ac04e5$export$db8f131360c543a5;
const $c186377a43ac04e5$export$8f49e4af10703ce3 = $c186377a43ac04e5$export$7acfa6ed01010e37.parse;
const $c186377a43ac04e5$export$43feed32102720d2 = $c186377a43ac04e5$export$6168dc8908a6c652.lex;



var $entK4 = parcelRequire("entK4");
const $af6746371a9d639a$var$API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
const $af6746371a9d639a$var$STORAGE_KEY = 'tria-ai-chats';
const $af6746371a9d639a$var$LEGACY_KEY = 'tria-ai-chat';
const $af6746371a9d639a$var$MAX_CHATS = 100;
const $af6746371a9d639a$var$state = {
    chats: [],
    activeChatId: null,
    modelId: null,
    availableModels: [],
    defaultModel: 'deepseek/deepseek-v4-flash',
    abortController: null,
    streaming: false,
    initialised: false,
    historySearch: ''
};
let $af6746371a9d639a$var$el = {};
function $af6746371a9d639a$var$$(id) {
    return document.getElementById(id);
}
function $af6746371a9d639a$var$showError(msg) {
    if (!$af6746371a9d639a$var$el.error) return;
    $af6746371a9d639a$var$el.error.textContent = msg || '';
    $af6746371a9d639a$var$el.error.classList.toggle('hidden', !msg);
}
function $af6746371a9d639a$var$scrollToBottom() {
    if ($af6746371a9d639a$var$el.messages) $af6746371a9d639a$var$el.messages.scrollTop = $af6746371a9d639a$var$el.messages.scrollHeight;
}
function $af6746371a9d639a$var$renderMarkdown(text) {
    try {
        return (0, $c186377a43ac04e5$export$db8f131360c543a5).parse(text || '', {
            breaks: true,
            gfm: true
        });
    } catch  {
        return (text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
}
function $af6746371a9d639a$var$escapeHtml(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
/** Vytvoří prázdnou bublinu asistenta a vrátí {root, tools, content, setText, addTool, updateTool, appendReasoning}. */ function $af6746371a9d639a$var$createAssistantBubble() {
    const root = document.createElement('div');
    root.className = 'flex flex-col gap-2 max-w-[85%]';
    root.innerHTML = `
    <div class="ai-tools flex flex-wrap gap-1.5"></div>
    <details class="ai-reasoning hidden text-xs text-ink-muted border border-gray-200 rounded-md bg-gray-50 px-2.5 py-1.5">
      <summary class="cursor-pointer select-none font-medium text-ink-muted">P\u{159}em\xfd\u{161}len\xed</summary>
      <div class="ai-reasoning-content mt-1.5 whitespace-pre-wrap leading-relaxed"></div>
    </details>
    <div class="bg-gray-50 border border-gray-200 rounded-2xl rounded-tl-sm p-3 text-sm text-ink leading-relaxed ai-content prose prose-sm max-w-none">
      <div class="ai-thinking inline-flex items-center gap-1.5 text-ink-muted">
        <span class="inline-flex gap-1 items-center">
          <span class="w-1.5 h-1.5 rounded-full bg-gray-400 animate-bounce" style="animation-delay:0ms"></span>
          <span class="w-1.5 h-1.5 rounded-full bg-gray-400 animate-bounce" style="animation-delay:150ms"></span>
          <span class="w-1.5 h-1.5 rounded-full bg-gray-400 animate-bounce" style="animation-delay:300ms"></span>
        </span>
        <span>Asistent p\u{159}em\xfd\u{161}l\xed\u{2026}</span>
      </div>
    </div>
    <div class="ai-offers flex flex-col gap-2"></div>
  `;
    $af6746371a9d639a$var$el.messages.appendChild(root);
    const toolsEl = root.querySelector('.ai-tools');
    const contentEl = root.querySelector('.ai-content');
    const offersEl = root.querySelector('.ai-offers');
    const thinkingEl = root.querySelector('.ai-thinking');
    const reasoningEl = root.querySelector('.ai-reasoning');
    const reasoningContentEl = root.querySelector('.ai-reasoning-content');
    const toolChips = new Map();
    let hasContent = false;
    function hideThinking() {
        if (thinkingEl && thinkingEl.parentNode) thinkingEl.remove();
    }
    return {
        root: root,
        setText (text) {
            if (text && text.trim()) {
                hasContent = true;
                hideThinking();
                contentEl.innerHTML = $af6746371a9d639a$var$renderMarkdown(text);
            } else hasContent;
        },
        addTool (toolCallId, toolName) {
            hideThinking();
            // Stream může pro stejné toolCallId poslat tool-input-start opakovaně
            // (např. při paralelních voláních v jednom kroku). Vytvoř chip jen jednou.
            const existing = toolChips.get(toolCallId);
            if (existing) return existing;
            const chip = document.createElement('span');
            chip.className = 'inline-flex items-center gap-1 text-xs px-2 py-1 rounded-full bg-purple-50 text-purple-700 border border-purple-200';
            chip.dataset.toolName = toolName || '';
            chip.innerHTML = `
        <svg class="w-3.5 h-3.5 animate-spin" data-icon="spinner"></svg>
        <span>Pou\u{17E}\xedv\xe1m n\xe1stroj: <strong>${$af6746371a9d639a$var$escapeHtml(toolName)}</strong></span>
      `;
            (0, $entK4.hydrateIcons)(chip);
            toolsEl.appendChild(chip);
            toolChips.set(toolCallId, chip);
            return chip;
        },
        finishTool (toolCallId, output) {
            const chip = toolChips.get(toolCallId);
            if (!chip) return;
            const toolName = chip.dataset.toolName || '';
            const isError = output && typeof output === 'object' && output.error;
            chip.className = `inline-flex items-center gap-1 text-xs px-2 py-1 rounded-full border ${isError ? 'bg-red-50 text-red-700 border-red-200' : 'bg-green-50 text-green-700 border-green-200'}`;
            chip.innerHTML = `
        <svg class="w-3.5 h-3.5" data-icon="${isError ? 'exclamation-circle' : 'check-circle'}"></svg>
        <span>${isError ? 'Chyba: ' + $af6746371a9d639a$var$escapeHtml(String(output.error).slice(0, 80)) : $af6746371a9d639a$var$escapeHtml($af6746371a9d639a$var$toolLabel(toolName, output))}</span>
      `;
            (0, $entK4.hydrateIcons)(chip);
        },
        appendReasoning (delta) {
            if (!delta) return;
            hideThinking();
            reasoningEl.classList.remove('hidden');
            reasoningContentEl.textContent += delta;
        },
        addOfferCard (offer) {
            if (!offer || !offer.id) return;
            hideThinking();
            const card = document.createElement('div');
            card.className = 'border border-gray-200 bg-white rounded-xl px-3 py-2.5 shadow-sm flex items-start gap-3';
            const status = String(offer.status || 'draft');
            const stavLabel = $af6746371a9d639a$var$STATUS_LABELS[status] || status;
            const stavClass = $af6746371a9d639a$var$STATUS_BADGE[status] || 'bg-gray-100 text-gray-700 border-gray-200';
            const polozkyPocet = offer.polozkyPocet != null ? offer.polozkyPocet : Array.isArray(offer.polozky) ? offer.polozky.length : null;
            const cena = Number(offer.cenaCelkem != null ? offer.cenaCelkem : offer.totalPrice) || 0;
            const zakaznik = offer.zakaznik || offer.customerName || "\u2014";
            const created = offer.createdAt ? new Date(offer.createdAt).toLocaleDateString('cs-CZ') : '';
            card.innerHTML = `
        <div class="shrink-0 w-9 h-9 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center">
          <svg class="w-5 h-5" data-icon="document"></svg>
        </div>
        <div class="min-w-0 flex-1">
          <div class="flex items-center gap-2 flex-wrap">
            <span class="font-semibold text-ink text-sm">${$af6746371a9d639a$var$escapeHtml(offer.id)}</span>
            <span class="text-[11px] px-1.5 py-0.5 rounded-full border ${stavClass}">${$af6746371a9d639a$var$escapeHtml(stavLabel)}</span>
          </div>
          <div class="mt-0.5 text-xs text-ink-muted leading-relaxed">
            <div><span class="text-gray-500">Z\xe1kazn\xedk:</span> <span class="text-ink">${$af6746371a9d639a$var$escapeHtml(zakaznik)}</span></div>
            <div class="flex gap-3 flex-wrap">
              ${polozkyPocet != null ? `<span><span class="text-gray-500">Polo\u{17E}ek:</span> <span class="text-ink">${polozkyPocet}</span></span>` : ''}
              <span><span class="text-gray-500">Celkem:</span> <span class="text-ink font-medium">${cena.toLocaleString('cs-CZ')} K\u{10D}</span></span>
              ${created ? `<span><span class="text-gray-500">Vytvo\u{159}eno:</span> <span class="text-ink">${created}</span></span>` : ''}
            </div>
          </div>
        </div>
        <button type="button" class="offer-open-btn shrink-0 inline-flex items-center gap-1 text-xs font-medium text-blue-700 hover:text-blue-800 hover:bg-blue-50 px-2 py-1.5 rounded-md border border-blue-200">
          Otev\u{159}\xedt
          <svg class="w-3.5 h-3.5" data-icon="arrow-right"></svg>
        </button>
      `;
            card.querySelector('.offer-open-btn').addEventListener('click', ()=>{
                if (window.offersListManager && typeof window.offersListManager.openOfferEditor === 'function') window.offersListManager.openOfferEditor(offer.id);
                else if (window.sectionManager) window.sectionManager.showSection('nabidky');
            });
            offersEl.appendChild(card);
            (0, $entK4.hydrateIcons)(card);
        },
        addCalcButton (input) {
            if (!input || typeof input !== 'object') return;
            hideThinking();
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'self-start inline-flex items-center gap-1.5 text-xs font-medium text-blue-700 hover:text-blue-800 bg-blue-50 hover:bg-blue-100 px-2.5 py-1.5 rounded-md border border-blue-200';
            // U vícepoložkových poptávek (letáky + vizitky…) musí být z tlačítka
            // poznat, ke které kalkulaci patří – popisek z nazev/rozměru + počtu ks.
            const parts = [];
            if (input.nazev) parts.push(String(input.nazev));
            else if (input.sirka && input.vyska) parts.push(`${input.sirka}\xd7${input.vyska} mm`);
            if (input.pocetKusu) parts.push(`${Number(input.pocetKusu).toLocaleString('cs-CZ')} ks`);
            const label = parts.join(', ');
            btn.innerHTML = `
        <svg class="w-3.5 h-3.5 shrink-0" data-icon="calculator"></svg>
        Otev\u{159}\xedt v kalkul\xe1toru${label ? `:&nbsp;<span class="font-semibold truncate max-w-[16rem]">${$af6746371a9d639a$var$escapeHtml(label)}</span>` : ''}
      `;
            btn.addEventListener('click', ()=>$af6746371a9d639a$var$loadCalcIntoForm(input));
            offersEl.appendChild(btn);
            (0, $entK4.hydrateIcons)(btn);
        },
        clearThinking () {
            hideThinking();
        }
    };
}
const $af6746371a9d639a$var$STATUS_LABELS = {
    draft: 'Draft',
    sent: "Odesl\xe1no",
    negotiation: "Jedn\xe1n\xed",
    approved: "Schv\xe1leno",
    rejected: "Odm\xedtnuto",
    converted: "P\u0159evedeno"
};
const $af6746371a9d639a$var$STATUS_BADGE = {
    draft: 'bg-gray-100 text-gray-700 border-gray-200',
    sent: 'bg-blue-50 text-blue-700 border-blue-200',
    negotiation: 'bg-amber-50 text-amber-700 border-amber-200',
    approved: 'bg-green-50 text-green-700 border-green-200',
    rejected: 'bg-red-50 text-red-700 border-red-200',
    converted: 'bg-purple-50 text-purple-700 border-purple-200'
};
/** Z tool outputu vytáhne seznam nabídek k zobrazení jako vizitka (max 3). */ function $af6746371a9d639a$var$extractOffers(toolName, output) {
    if (!output || typeof output !== 'object' || output.error) return [];
    if (toolName === 'create_offer') {
        if (output.id) return [
            {
                id: output.id,
                status: output.status,
                zakaznik: output.customerName,
                cenaCelkem: output.totalPrice,
                createdAt: output.createdAt
            }
        ];
        return [];
    }
    if (toolName === 'get_offer') {
        const s = output.summary || output.offer && $af6746371a9d639a$var$summarizeOfferLocally(output.offer);
        return s ? [
            s
        ] : [];
    }
    if (toolName === 'get_offers') {
        const list = Array.isArray(output.offers) ? output.offers : [];
        return list.slice(0, 3);
    }
    return [];
}
function $af6746371a9d639a$var$summarizeOfferLocally(offer) {
    if (!offer) return null;
    const items = offer.items || offer.polozky || [];
    const total = items.reduce((s, it)=>s + (Number(it.cena) || Number(it.price) || 0), 0);
    return {
        id: offer.id,
        status: offer.status,
        zakaznik: offer.customerName || offer.nazevZakaznika || offer.zakaznik || '',
        polozkyPocet: items.length,
        cenaCelkem: offer.totalPrice != null ? offer.totalPrice : total,
        createdAt: offer.createdAt
    };
}
// Mapování názvu laminace z calculate_price (tool) na value ve formuláři <select id="laminace">.
const $af6746371a9d639a$var$LAMINACE_MAP = {
    '0': '0',
    'lesk-jednostranna': 'lesk10',
    'lesk-oboustranna': 'lesk11',
    'mat-jednostranna': 'mat10',
    'mat-oboustranna': 'mat11',
    'struktura-jednostranna': 'struktura10',
    'struktura-oboustranna': 'struktura11',
    'samet-jednostranna': 'samet10',
    'samet-oboustranna': 'samet11'
};
// Totéž pro lakování → <select id="lakovani">.
const $af6746371a9d639a$var$LAKOVANI_MAP = {
    '0': '0',
    'parcialni-jednostranne': 'parcial10',
    'parcialni-oboustranne': 'parcial11',
    'plocha-jednostranne': 'plocha10',
    'plocha-oboustranne': 'plocha11',
    'stroj-jednostranne': 'stroj10',
    'stroj-oboustranne': 'stroj11'
};
/**
 * Převede vstupní argumenty nástroje calculate_price na objekt formData,
 * který lze předat offerItemsManager.restoreFormState() – formulář kalkulátoru
 * se tím naplní stejnými hodnotami, jaké zadal AI agent.
 */ function $af6746371a9d639a$var$calcInputToFormData(args) {
    const fd = {};
    if (args.nazev != null) fd.nazev = String(args.nazev);
    if (args.pocetKusu != null) fd.pocetKusu = String(args.pocetKusu);
    if (args.sirka != null && args.vyska != null) {
        fd.produktRozmerFormat = 'vlastni';
        fd.produktRozmerSirka = String(args.sirka);
        fd.produktRozmerVyska = String(args.vyska);
    }
    if (args.barevnost != null) fd.pocetBarev = String(args.barevnost);
    if (args.primeBarvy != null) fd.primeBarvy = String(args.primeBarvy);
    if (args.material != null) fd.materialName = String(args.material);
    if (args.laminace != null) fd.laminace = $af6746371a9d639a$var$LAMINACE_MAP[String(args.laminace)] || '0';
    if (args.lakovani != null) fd.lakovani = $af6746371a9d639a$var$LAKOVANI_MAP[String(args.lakovani)] || '0';
    if (args.falcovani != null) fd.falcovani = String(args.falcovani).replace(/_/g, '-');
    if (args.bigovani != null) fd.bigovani = String(args.bigovani).replace(/_/g, '-');
    if (args.vrtani != null) fd.vrtani = String(args.vrtani);
    if (args.perforace != null) fd.perforace = String(args.perforace);
    if (args.dtp != null) fd.dtp = String(args.dtp);
    if (args.vysek != null) {
        const n = Number(args.vysek) || 0;
        if (n > 0) {
            fd.vysek = 'nove';
            fd.pozicNaVysek = String(n);
        } else fd.vysek = '0';
    }
    if (args.vazba != null) fd.vazba = String(args.vazba);
    if (args.vazbaPocetStran != null) fd.vazbaPocetStran = String(args.vazbaPocetStran);
    if (args.vazbaJinaObalka != null) fd.vazbaJinaObalka = Boolean(args.vazbaJinaObalka);
    if (args.vnitrniMaterial != null) fd.vnitrniMaterialName = String(args.vnitrniMaterial);
    if (args.vnitrniBarevnost != null) fd.vnitrniBarevnost = String(args.vnitrniBarevnost);
    if (args.vnitrniLaminace != null) fd.vnitrniLaminace = $af6746371a9d639a$var$LAMINACE_MAP[String(args.vnitrniLaminace)] || '0';
    return fd;
}
/**
 * Načte vstupní argumenty calculate_price do formuláře kalkulátoru a přepne
 * do sekce Kalkulátor. Přidá novou prázdnou položku (jako by uživatel klikl
 * „Přidat položku"), aby se hodnoty nepřepsaly nad existující rozpracovanou
 * položku nabídky.
 */ function $af6746371a9d639a$var$loadCalcIntoForm(args) {
    const mgr = window.offerItemsManager;
    if (!mgr || typeof mgr.restoreFormState !== 'function') {
        if (window.showNotification) window.showNotification("Kalkul\xe1tor nen\xed k dispozici.", 'error');
        return;
    }
    if (window.sectionManager) window.sectionManager.showSection('kalkulator');
    mgr.addItem();
    const formData = $af6746371a9d639a$var$calcInputToFormData(args);
    mgr.restoreFormState(formData);
    if (window.showNotification) window.showNotification("V\xfdpo\u010Det na\u010Dten do kalkul\xe1toru", 'success');
}
function $af6746371a9d639a$var$toolLabel(toolName, output) {
    if (!output) return 'OK';
    if (typeof output === 'string') return output.slice(0, 60);
    if (typeof output === 'object') {
        // Nejprve konkrétní výsledky podle toolu
        if (toolName === 'calculate_price' && output.cenaCelkem != null) return `Spo\u{10D}\xedt\xe1no: ${output.cenaCelkem} K\u{10D}`;
        if (toolName === 'create_offer') return `Nab\xeddka ${output.id || ''} vytvo\u{159}ena`;
        if (toolName === 'get_offer') return `Nab\xeddka ${output.summary?.id || output.id || ''}`;
        if (toolName === 'update_offer_status') return `Nab\xeddka ${output.id || ''} \u{2192} ${output.status || ''}`;
        if (toolName === 'reprint_order') return `Objedn\xe1vka ${output.id || ''} vytvo\u{159}ena`;
        if (toolName === 'get_order') return `Zak\xe1zka ${output.summary?.id || output.id || ''}`;
        if (toolName === 'list_materials') return `${output.count != null ? output.count : Array.isArray(output.materials) ? output.materials.length : '?'} materi\xe1l\u{16F}`;
        if (toolName === 'get_offers') return `${output.count != null ? output.count : Array.isArray(output.offers) ? output.offers.length : 0} nab\xeddek`;
        if (toolName === 'search_orders') return `${output.count != null ? output.count : Array.isArray(output.orders) ? output.orders.length : 0} zak\xe1zek`;
        if (toolName === 'find_customer') {
            const n = output.count != null ? output.count : Array.isArray(output.customers) ? output.customers.length : 0;
            return `${n} ${n === 1 ? "z\xe1kazn\xedk" : n >= 2 && n <= 4 ? "z\xe1kazn\xedci" : "z\xe1kazn\xedk\u016F"}`;
        }
        if (toolName === 'get_settings') return "Nastaven\xed na\u010Dteno";
        if (toolName === 'search_products') {
            const n = output.count != null ? output.count : Array.isArray(output.products) ? output.products.length : 0;
            return `${n} produkt\u{16F} v katalogu`;
        }
        if (toolName === 'get_product') return output.product?.name ? `Produkt: ${output.product.name}` : 'Detail produktu';
        // Fallback podle tvaru výstupu
        if (output.cenaCelkem != null) return `Spo\u{10D}\xedt\xe1no: ${output.cenaCelkem} K\u{10D}`;
        if (output.id) return String(output.id);
        if (output.count != null) return `${output.count} v\xfdsledk\u{16F}`;
        return JSON.stringify(output).slice(0, 60);
    }
    return String(output).slice(0, 60);
}
function $af6746371a9d639a$var$appendUserBubble(text) {
    const div = document.createElement('div');
    div.className = 'self-end max-w-[85%] bg-blue-600 text-white rounded-2xl rounded-br-sm px-3.5 py-2.5 text-sm font-medium whitespace-pre-wrap';
    div.textContent = text;
    $af6746371a9d639a$var$el.messages.appendChild(div);
}
function $af6746371a9d639a$var$activeChat() {
    return $af6746371a9d639a$var$state.chats.find((c)=>c.id === $af6746371a9d639a$var$state.activeChatId) || null;
}
function $af6746371a9d639a$var$nowIso() {
    return new Date().toISOString();
}
function $af6746371a9d639a$var$genId() {
    return `chat-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}
/** Lidsky čitelný "stáří" chatu pro sidebar. */ function $af6746371a9d639a$var$relativeAge(iso) {
    if (!iso) return '';
    const then = new Date(iso).getTime();
    const diff = Date.now() - then;
    const min = Math.floor(diff / 60000);
    if (min < 1) return "pr\xe1v\u011B te\u010F";
    if (min < 60) return `p\u{159}ed ${min} min`;
    const h = Math.floor(min / 60);
    if (h < 24) return `p\u{159}ed ${h} h`;
    const d = Math.floor(h / 24);
    if (d < 7) return `p\u{159}ed ${d} d`;
    const w = Math.floor(d / 7);
    if (w < 5) return `p\u{159}ed ${w} t\xfdd.`;
    const mo = Math.floor(d / 30);
    return `p\u{159}ed ${mo} m\u{11B}s.`;
}
function $af6746371a9d639a$var$saveChats() {
    try {
        localStorage.setItem($af6746371a9d639a$var$STORAGE_KEY, JSON.stringify({
            chats: $af6746371a9d639a$var$state.chats,
            activeChatId: $af6746371a9d639a$var$state.activeChatId
        }));
    } catch  {}
}
/** Migrace starého jednochatového uložiště (tria-ai-chat) na nový formát. */ function $af6746371a9d639a$var$migrateLegacyChat() {
    try {
        const raw = localStorage.getItem($af6746371a9d639a$var$LEGACY_KEY);
        if (!raw) return;
        const data = JSON.parse(raw);
        if (!Array.isArray(data.messages) || data.messages.length === 0) return;
        // Stejná očista osiřelých/duplicitních uživatelských zpráv jako dřív.
        const cleaned = [];
        for (const m of data.messages){
            if (m.role === 'user' && cleaned.length > 0 && cleaned[cleaned.length - 1].role === 'user' && cleaned[cleaned.length - 1].content === m.content) continue;
            cleaned.push(m);
        }
        while(cleaned.length > 0 && cleaned[cleaned.length - 1].role === 'user')cleaned.pop();
        if (cleaned.length === 0) return;
        const firstUser = cleaned.find((m)=>m.role === 'user');
        const title = $af6746371a9d639a$var$deriveLocalTitle(firstUser ? firstUser.content : "Nov\xfd chat");
        const chat = {
            id: $af6746371a9d639a$var$genId(),
            title: title,
            createdAt: $af6746371a9d639a$var$nowIso(),
            updatedAt: $af6746371a9d639a$var$nowIso(),
            modelId: data.modelId || null,
            messages: cleaned
        };
        $af6746371a9d639a$var$state.chats.unshift(chat);
        $af6746371a9d639a$var$state.activeChatId = chat.id;
        $af6746371a9d639a$var$saveChats();
        localStorage.removeItem($af6746371a9d639a$var$LEGACY_KEY);
    } catch  {}
}
/** Lokální fallback titulek (před AI generováním / když gateway nejede). */ function $af6746371a9d639a$var$deriveLocalTitle(text) {
    const t = String(text || '').replace(/\s+/g, ' ').trim();
    if (!t) return "Nov\xfd chat";
    return t.length > 48 ? t.slice(0, 48) + "\u2026" : t;
}
function $af6746371a9d639a$var$loadChats() {
    try {
        const raw = localStorage.getItem($af6746371a9d639a$var$STORAGE_KEY);
        if (raw) {
            const data = JSON.parse(raw);
            if (Array.isArray(data.chats)) $af6746371a9d639a$var$state.chats = data.chats;
        }
    } catch  {}
    $af6746371a9d639a$var$migrateLegacyChat();
    // Asistent se vždy otevírá na NOVÉM chatu (chat vznikne až první zprávou).
    // Dlouhé chaty mají zaplněný kontext a horší přesnost odpovědí – návrat ke
    // starší konverzaci je vědomá volba přes sidebar, ne default.
    $af6746371a9d639a$var$state.activeChatId = null;
}
function $af6746371a9d639a$var$newChat() {
    // Nevytvářet prázdný chat hned – vytvoří se až při prvním odeslání, aby
    // sidebar nebyl plný "Nový chat" položek. Jen resetujme aktivní stav.
    $af6746371a9d639a$var$state.activeChatId = null;
    if ($af6746371a9d639a$var$el.messages) $af6746371a9d639a$var$el.messages.innerHTML = '';
    $af6746371a9d639a$var$renderEmptyHint();
    $af6746371a9d639a$var$renderHistorySidebar();
    $af6746371a9d639a$var$saveChats();
    if ($af6746371a9d639a$var$el.input) $af6746371a9d639a$var$el.input.focus();
}
/** Vytvoří (a otevře) nový chat s první uživatelskou zprávou. Vrací chat. */ function $af6746371a9d639a$var$createChatForFirstMessage(text) {
    const chat = {
        id: $af6746371a9d639a$var$genId(),
        title: $af6746371a9d639a$var$deriveLocalTitle(text),
        createdAt: $af6746371a9d639a$var$nowIso(),
        updatedAt: $af6746371a9d639a$var$nowIso(),
        modelId: $af6746371a9d639a$var$state.modelId,
        messages: [
            {
                role: 'user',
                content: text
            }
        ]
    };
    $af6746371a9d639a$var$state.chats.unshift(chat);
    $af6746371a9d639a$var$state.activeChatId = chat.id;
    // Omez počet uložených chatů (nejstarší přes limit se zahodí).
    if ($af6746371a9d639a$var$state.chats.length > $af6746371a9d639a$var$MAX_CHATS) $af6746371a9d639a$var$state.chats = $af6746371a9d639a$var$state.chats.slice(0, $af6746371a9d639a$var$MAX_CHATS);
    return chat;
}
function $af6746371a9d639a$var$openChat(id) {
    if ($af6746371a9d639a$var$state.streaming) $af6746371a9d639a$var$state.abortController?.abort();
    const chat = $af6746371a9d639a$var$state.chats.find((c)=>c.id === id);
    if (!chat) return;
    $af6746371a9d639a$var$state.activeChatId = id;
    if (chat.modelId && $af6746371a9d639a$var$state.availableModels.includes(chat.modelId)) {
        $af6746371a9d639a$var$state.modelId = chat.modelId;
        if ($af6746371a9d639a$var$el.modelSelect) $af6746371a9d639a$var$el.modelSelect.value = $af6746371a9d639a$var$state.modelId;
    }
    $af6746371a9d639a$var$renderHistory();
    $af6746371a9d639a$var$renderHistorySidebar();
    $af6746371a9d639a$var$saveChats();
    $af6746371a9d639a$var$closeHistoryDrawer();
}
function $af6746371a9d639a$var$deleteChat(id, ev) {
    ev?.stopPropagation();
    const idx = $af6746371a9d639a$var$state.chats.findIndex((c)=>c.id === id);
    if (idx === -1) return;
    $af6746371a9d639a$var$state.chats.splice(idx, 1);
    if ($af6746371a9d639a$var$state.activeChatId === id) {
        $af6746371a9d639a$var$state.activeChatId = $af6746371a9d639a$var$state.chats[0] ? $af6746371a9d639a$var$state.chats[0].id : null;
        $af6746371a9d639a$var$renderHistory();
    }
    $af6746371a9d639a$var$renderHistorySidebar();
    $af6746371a9d639a$var$saveChats();
}
/** Filtrování+řazení chatů pro sidebar (nejnovější nahoře, dle vyhledávání). */ function $af6746371a9d639a$var$visibleChats() {
    const q = $af6746371a9d639a$var$state.historySearch.trim().toLowerCase();
    let list = $af6746371a9d639a$var$state.chats.slice();
    if (q) list = list.filter((c)=>{
        const hay = (c.title + ' ' + (c.messages || []).map((m)=>m.content || '').join(' ')).toLowerCase();
        return hay.includes(q);
    });
    list.sort((a, b)=>new Date(b.updatedAt || b.createdAt || 0) - new Date(a.updatedAt || a.createdAt || 0));
    return list;
}
function $af6746371a9d639a$var$renderHistorySidebar() {
    if (!$af6746371a9d639a$var$el.historyList) return;
    const list = $af6746371a9d639a$var$visibleChats();
    if (list.length === 0) {
        $af6746371a9d639a$var$el.historyList.innerHTML = `<div class="text-center text-ink-muted text-xs py-8">${$af6746371a9d639a$var$state.historySearch ? 'Nic nenalezeno.' : "Zat\xedm \u017E\xe1dn\xe9 chaty. Zeptej se asistenta a chat se ulo\u017E\xed."}</div>`;
        return;
    }
    $af6746371a9d639a$var$el.historyList.innerHTML = list.map((c)=>{
        const active = c.id === $af6746371a9d639a$var$state.activeChatId;
        const age = $af6746371a9d639a$var$relativeAge(c.updatedAt || c.createdAt);
        return `
      <div data-chat-id="${$af6746371a9d639a$var$escapeHtml(c.id)}" class="group chat-history-item cursor-pointer rounded-md px-2.5 py-2 border ${active ? 'border-blue-300 bg-blue-50' : 'border-transparent hover:bg-gray-50'}">
        <div class="flex items-start justify-between gap-2">
          <div class="min-w-0 flex-1">
            <div class="text-sm font-medium text-ink truncate">${$af6746371a9d639a$var$escapeHtml(c.title)}</div>
            <div class="text-[11px] text-ink-muted mt-0.5">${$af6746371a9d639a$var$escapeHtml(age)} \xb7 ${c.messages.length} msg</div>
          </div>
          <button data-delete-id="${$af6746371a9d639a$var$escapeHtml(c.id)}" title="Smazat chat" class="opacity-0 group-hover:opacity-100 text-gray-400 hover:text-red-600 transition-opacity shrink-0">
            <svg class="w-4 h-4" data-icon="trash"></svg>
          </button>
        </div>
      </div>`;
    }).join('');
    (0, $entK4.hydrateIcons)($af6746371a9d639a$var$el.historyList);
}
function $af6746371a9d639a$var$renderEmptyHint() {
    if (!$af6746371a9d639a$var$el.messages) return;
    const c = $af6746371a9d639a$var$activeChat();
    if ((!c || c.messages.length === 0) && !$af6746371a9d639a$var$state.streaming) {
        const hint = document.createElement('div');
        hint.className = 'text-center text-ink-muted text-sm py-10';
        hint.innerHTML = `
      <div class="flex justify-center mb-3 text-blue-500"><svg class="w-8 h-8" data-icon="sparkles"></svg></div>
      <p>Ahoj! Zeptej se na cenu tisku nebo napi\u{161}, co pot\u{159}ebuje\u{161} spo\u{10D}\xedtat.</p>
      <p class="mt-1 text-xs">Nap\u{159}.: <em>Spo\u{10D}\xedtej 1000 ks vizitek 90\xd754 mm 4/4 na matnou kr\xeddu 135 g</em></p>
    `;
        (0, $entK4.hydrateIcons)(hint);
        $af6746371a9d639a$var$el.messages.appendChild(hint);
    }
}
function $af6746371a9d639a$var$renderHistory() {
    if (!$af6746371a9d639a$var$el.messages) return;
    $af6746371a9d639a$var$el.messages.innerHTML = '';
    const c = $af6746371a9d639a$var$activeChat();
    if (c) {
        for (const m of c.messages)if (m.role === 'user') $af6746371a9d639a$var$appendUserBubble(m.content);
        else {
            const b = $af6746371a9d639a$var$createAssistantBubble();
            b.setText(m.content);
        }
    }
    if (!c || c.messages.length === 0) $af6746371a9d639a$var$renderEmptyHint();
    $af6746371a9d639a$var$scrollToBottom();
}
function $af6746371a9d639a$var$clearMessages() {
    // Zpětná kompatibilita pro starý button hook – v novém UI znamená „nový chat".
    $af6746371a9d639a$var$newChat();
}
function $af6746371a9d639a$var$saveHistory() {
    // Zpětná kompatibilita – nový kód používá saveChats() + update aktivního chatu.
    $af6746371a9d639a$var$saveChats();
}
// Načtení dostupných modelů z /api/ai/models. S retry – při výpadku gateway/
// sítě se to zkusí znovu (3× po 5s), ať model-selector nezůstane prázdný kvůli
// jednorázovému selhání (inspirace ai-sdk-gateway-demo/use-available-models).
async function $af6746371a9d639a$var$loadModels() {
    const MAX_RETRIES = 3;
    const RETRY_DELAY_MS = 5000;
    for(let attempt = 0; attempt <= MAX_RETRIES; attempt++)try {
        const res = await fetch(`${$af6746371a9d639a$var$API_BASE_URL}/ai/models`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (!data.success) throw new Error("ne\xfasp\u011B\u0161n\xe1 odpov\u011B\u010F");
        const d = data.data;
        $af6746371a9d639a$var$state.availableModels = d.availableModels || [];
        $af6746371a9d639a$var$state.defaultModel = d.defaultModel || $af6746371a9d639a$var$state.defaultModel;
        if (!$af6746371a9d639a$var$state.modelId || !$af6746371a9d639a$var$state.availableModels.includes($af6746371a9d639a$var$state.modelId)) $af6746371a9d639a$var$state.modelId = $af6746371a9d639a$var$state.defaultModel;
        $af6746371a9d639a$var$populateModelSelect();
        return;
    } catch (e) {
        if (attempt < MAX_RETRIES) {
            console.warn(`[ai] loadModels selhalo (pokus ${attempt + 1}/${MAX_RETRIES}), retry za ${RETRY_DELAY_MS}ms:`, e.message);
            await new Promise((r)=>setTimeout(r, RETRY_DELAY_MS));
        } else {
            console.warn('[ai] loadModels failed po retry', e);
            // Fallback: alespoň default model, ať selector není prázdný.
            if (!$af6746371a9d639a$var$state.availableModels.length) {
                $af6746371a9d639a$var$state.availableModels = [
                    $af6746371a9d639a$var$state.defaultModel
                ];
                if (!$af6746371a9d639a$var$state.modelId) $af6746371a9d639a$var$state.modelId = $af6746371a9d639a$var$state.defaultModel;
                $af6746371a9d639a$var$populateModelSelect();
            }
        }
    }
}
function $af6746371a9d639a$var$populateModelSelect() {
    if (!$af6746371a9d639a$var$el.modelSelect) return;
    const models = $af6746371a9d639a$var$state.availableModels.length ? $af6746371a9d639a$var$state.availableModels : [
        $af6746371a9d639a$var$state.defaultModel
    ];
    const short = (m)=>{
        // "openai/gpt-5-nano" → "gpt-5-nano"; ponech plný název, pokud není ve formátu provider/name
        const parts = String(m).split('/');
        return parts.length > 1 ? parts.slice(1).join('/') : m;
    };
    $af6746371a9d639a$var$el.modelSelect.innerHTML = models.map((m)=>`<option value="${$af6746371a9d639a$var$escapeHtml(m)}">${$af6746371a9d639a$var$escapeHtml(short(m))}</option>`).join('');
    $af6746371a9d639a$var$el.modelSelect.value = $af6746371a9d639a$var$state.modelId || $af6746371a9d639a$var$state.defaultModel;
}
async function $af6746371a9d639a$var$sendMessage(text) {
    if (!text.trim() || $af6746371a9d639a$var$state.streaming) return;
    if ($af6746371a9d639a$var$el.messages) {
        const hint = $af6746371a9d639a$var$el.messages.querySelector('.text-center');
        if (hint) hint.remove();
    }
    $af6746371a9d639a$var$showError('');
    // Vytvoř nový chat, pokud žádný není aktivní.
    let chat = $af6746371a9d639a$var$activeChat();
    const wasNewChat = !chat;
    if (!chat) {
        chat = $af6746371a9d639a$var$createChatForFirstMessage(text);
        $af6746371a9d639a$var$renderHistorySidebar();
    } else chat.messages.push({
        role: 'user',
        content: text
    });
    const chatIdForTitle = chat.id;
    const msgCountBeforeReply = chat.messages.length;
    // Kontext pro API: máme-li z dřívější komprese shrnutí, pošli
    // [shrnutí, zprávy od summaryUpto] místo celé historie – requesty tak
    // nerostou donekonečna a server nemusí shrnovat při každé zprávě.
    // UI vždy zobrazuje plnou historii z chat.messages.
    const sentUpto = chat.summary && Number.isInteger(chat.summaryUpto) && chat.summaryUpto > 0 ? Math.min(chat.summaryUpto, chat.messages.length - 1) : 0;
    const contextMessages = sentUpto > 0 ? [
        {
            role: 'system',
            content: `Shrnut\xed star\u{161}\xed \u{10D}\xe1sti konverzace (historie komprimov\xe1na pro pokra\u{10D}ov\xe1n\xed):

${chat.summary}`
        },
        ...chat.messages.slice(sentUpto)
    ] : chat.messages;
    $af6746371a9d639a$var$appendUserBubble(text);
    const bubble = $af6746371a9d639a$var$createAssistantBubble();
    let assistantText = '';
    const toolNames = new Map();
    const toolInputs = new Map();
    const calcButtonsRendered = new Set();
    bubble.setText('');
    $af6746371a9d639a$var$scrollToBottom();
    $af6746371a9d639a$var$state.streaming = true;
    $af6746371a9d639a$var$state.abortController = new AbortController();
    // Pojistka proti stuck streamu (model se zasekne na generování velkého
    // tool inputu apod.) – po 120s abort a umožni uživateli retry.
    const timeoutMs = 120000;
    const timeoutId = setTimeout(()=>{
        if ($af6746371a9d639a$var$state.streaming && $af6746371a9d639a$var$state.abortController) {
            $af6746371a9d639a$var$showError("AI asistent neodpov\xedd\xe1 (timeout). Zkus to znovu.");
            $af6746371a9d639a$var$state.abortController.abort();
        }
    }, timeoutMs);
    $af6746371a9d639a$var$toggleStreamingUI(true);
    try {
        const res = await fetch(`${$af6746371a9d639a$var$API_BASE_URL}/ai/chat`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                messages: contextMessages,
                modelId: $af6746371a9d639a$var$state.modelId
            }),
            signal: $af6746371a9d639a$var$state.abortController.signal
        });
        if (!res.ok) {
            let msg = `HTTP ${res.status}`;
            try {
                const j = await res.json();
                msg = j.error || msg;
            } catch  {}
            throw new Error(msg);
        }
        await $af6746371a9d639a$var$readSSEStream(res.body, (part)=>{
            switch(part.type){
                case 'data-compression':
                    {
                        // Server komprimoval kontext → ulož shrnutí a posuň hranici, od které
                        // se historie posílá doslovně. coveredCount se vztahuje k poslanému
                        // poli (jehož první zprávou mohlo být předchozí shrnutí).
                        const info = part.data || {};
                        if (typeof info.summary === 'string' && info.summary && Number.isInteger(info.coveredCount) && info.coveredCount > 0) {
                            const coveredReal = info.coveredCount - (sentUpto > 0 ? 1 : 0);
                            chat.summary = info.summary;
                            chat.summaryUpto = Math.min(sentUpto + Math.max(coveredReal, 0), Math.max(chat.messages.length - 1, 0));
                        }
                        break;
                    }
                case 'text-start':
                    // Model píše text, zavolá tool a pokračuje dalším textovým blokem –
                    // bez oddělovače by se věty slily („…bíláZde je kalkulace…").
                    if (assistantText && !/\n\s*$/.test(assistantText)) {
                        assistantText += '\n\n';
                        bubble.setText(assistantText);
                    }
                    break;
                case 'text-delta':
                    assistantText += part.delta || part.text || '';
                    bubble.setText(assistantText);
                    $af6746371a9d639a$var$scrollToBottom();
                    break;
                case 'reasoning-delta':
                    bubble.appendReasoning(part.delta || part.text || '');
                    $af6746371a9d639a$var$scrollToBottom();
                    break;
                case 'reasoning':
                    // Některé verze streamu pošlou reasoning najednou (bez -delta).
                    bubble.appendReasoning(part.text || part.reasoning || '');
                    $af6746371a9d639a$var$scrollToBottom();
                    break;
                case 'tool-input-start':
                    toolNames.set(part.toolCallId, part.toolName);
                    bubble.addTool(part.toolCallId, part.toolName);
                    break;
                case 'tool-input-available':
                    if (part.toolName === 'calculate_price' && part.input) toolInputs.set(part.toolCallId, part.input);
                    break;
                case 'tool-output-available':
                    {
                        bubble.finishTool(part.toolCallId, part.output);
                        const toolName = toolNames.get(part.toolCallId);
                        const offers = $af6746371a9d639a$var$extractOffers(toolName, part.output);
                        if (offers.length) {
                            offers.forEach((o)=>bubble.addOfferCard(o));
                            $af6746371a9d639a$var$scrollToBottom();
                        }
                        // K výsledku kalkulace přidat tlačítko pro otevření ve formuláři.
                        // Opakovaná volání se stejnými parametry (retry modelu) → jen jedno tlačítko.
                        if (toolName === 'calculate_price' && part.output && !part.output.error) {
                            const input = toolInputs.get(part.toolCallId);
                            const key = input ? JSON.stringify(input) : null;
                            if (input && !calcButtonsRendered.has(key)) {
                                calcButtonsRendered.add(key);
                                bubble.addCalcButton(input);
                                $af6746371a9d639a$var$scrollToBottom();
                            }
                        }
                        break;
                    }
                case 'error':
                    $af6746371a9d639a$var$showError(part.errorText || "Chyba p\u0159i generov\xe1n\xed odpov\u011Bdi.");
                    break;
            }
        });
        if (assistantText.trim()) chat.messages.push({
            role: 'assistant',
            content: assistantText
        });
        else // Žádný text ani tool – skryj zbylý thinking indikátor, ať nezůstane prázdná bublina.
        bubble.clearThinking();
        chat.updatedAt = $af6746371a9d639a$var$nowIso();
        chat.modelId = $af6746371a9d639a$var$state.modelId;
        $af6746371a9d639a$var$saveChats();
        $af6746371a9d639a$var$renderHistorySidebar();
        // Po první odpovědi v novém chatu vygeneruj AI titulek (nahradí lokální fallback).
        if (wasNewChat && assistantText.trim()) $af6746371a9d639a$var$generateTitleForChat(chatIdForTitle).catch(()=>{});
    } catch (e) {
        if (e.name === 'AbortError') {
            // Ulož částečnou odpověď, pokud něco je
            if (assistantText.trim()) chat.messages.push({
                role: 'assistant',
                content: assistantText
            });
            chat.updatedAt = $af6746371a9d639a$var$nowIso();
            $af6746371a9d639a$var$saveChats();
            $af6746371a9d639a$var$renderHistorySidebar();
        } else {
            $af6746371a9d639a$var$showError(e.message || "Spojen\xed s AI se nezda\u0159ilo.");
            console.error('[ai] sendMessage error', e);
            // Při chybě v novém chatu bez odpovědi zruš prázdný chat, ať nezůstane osiřelý.
            if (wasNewChat && msgCountBeforeReply === chat.messages.length) {
                const idx = $af6746371a9d639a$var$state.chats.findIndex((c)=>c.id === chat.id);
                if (idx !== -1) {
                    $af6746371a9d639a$var$state.chats.splice(idx, 1);
                    $af6746371a9d639a$var$state.activeChatId = null;
                    $af6746371a9d639a$var$saveChats();
                    $af6746371a9d639a$var$renderHistorySidebar();
                }
            }
        }
    } finally{
        clearTimeout(timeoutId);
        $af6746371a9d639a$var$state.streaming = false;
        $af6746371a9d639a$var$state.abortController = null;
        $af6746371a9d639a$var$toggleStreamingUI(false);
        const c = $af6746371a9d639a$var$activeChat();
        if (!c || c.messages.length === 0) $af6746371a9d639a$var$renderEmptyHint();
    }
}
/** Vygeneruje AI titulek pro chat a aktualizuje sidebar. Lokální fallback zůstane, pokud selže. */ async function $af6746371a9d639a$var$generateTitleForChat(chatId) {
    const chat = $af6746371a9d639a$var$state.chats.find((c)=>c.id === chatId);
    if (!chat) return;
    const res = await fetch(`${$af6746371a9d639a$var$API_BASE_URL}/ai/title`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            messages: chat.messages,
            modelId: chat.modelId || $af6746371a9d639a$var$state.modelId
        })
    });
    if (!res.ok) return;
    const r = await res.json();
    if (!r || !r.success || !r.data || !r.data.title) return;
    // Jen pokud je chat stále aktuální (uživatel ho mezitím nesmazal).
    const target = $af6746371a9d639a$var$state.chats.find((c)=>c.id === chatId);
    if (!target) return;
    target.title = String(r.data.title).slice(0, 80);
    $af6746371a9d639a$var$saveChats();
    $af6746371a9d639a$var$renderHistorySidebar();
}
/** Parsuje SSE UI message stream (data: <json>\n\n, končí data: [DONE]). */ async function $af6746371a9d639a$var$readSSEStream(body, onPart) {
    const reader = body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    while(true){
        const { value: value, done: done } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, {
            stream: true
        });
        let idx;
        while((idx = buffer.indexOf('\n\n')) !== -1){
            const block = buffer.slice(0, idx);
            buffer = buffer.slice(idx + 2);
            const lines = block.split('\n');
            const dataLines = lines.filter((l)=>l.startsWith('data:')).map((l)=>l.slice(5).trimStart());
            if (!dataLines.length) continue;
            const payload = dataLines.join('\n');
            if (payload === '[DONE]') return;
            try {
                onPart(JSON.parse(payload));
            } catch  {}
        }
    }
}
function $af6746371a9d639a$var$toggleStreamingUI(on) {
    $af6746371a9d639a$var$el.sendBtn?.classList.toggle('hidden', on);
    $af6746371a9d639a$var$el.stopBtn?.classList.toggle('hidden', !on);
    if ($af6746371a9d639a$var$el.input) {
        if (on) $af6746371a9d639a$var$el.input.setAttribute('disabled', 'true');
        else $af6746371a9d639a$var$el.input.removeAttribute('disabled');
    }
}
function $af6746371a9d639a$export$9213dfffdee66e5a() {
    if ($af6746371a9d639a$var$state.initialised) {
        // Již inicializováno – jen dočti modely (např. po změně v Nastavení).
        $af6746371a9d639a$var$loadModels();
        return;
    }
    $af6746371a9d639a$var$el = {
        messages: $af6746371a9d639a$var$$('ai-messages'),
        input: $af6746371a9d639a$var$$('ai-input'),
        form: $af6746371a9d639a$var$$('ai-chat-form'),
        sendBtn: $af6746371a9d639a$var$$('ai-send-btn'),
        stopBtn: $af6746371a9d639a$var$$('ai-stop-btn'),
        newChatBtn: $af6746371a9d639a$var$$('ai-new-chat-btn'),
        modelSelect: $af6746371a9d639a$var$$('ai-model-select'),
        error: $af6746371a9d639a$var$$('ai-error'),
        historyList: $af6746371a9d639a$var$$('ai-history-list'),
        historySearch: $af6746371a9d639a$var$$('ai-history-search'),
        historyToggleBtn: $af6746371a9d639a$var$$('ai-history-toggle-btn'),
        historySidebar: $af6746371a9d639a$var$$('ai-history-sidebar'),
        historyOverlay: $af6746371a9d639a$var$$('ai-history-overlay'),
        attachBtn: $af6746371a9d639a$var$$('ai-attach-btn'),
        attachInput: $af6746371a9d639a$var$$('ai-attach-input'),
        attachChips: $af6746371a9d639a$var$$('ai-attach-chips'),
        attachNote: $af6746371a9d639a$var$$('ai-attach-note')
    };
    if (!$af6746371a9d639a$var$el.messages || !$af6746371a9d639a$var$el.form) return; // sekce není v DOM (veřejné stránky)
    $af6746371a9d639a$var$state.initialised = true;
    $af6746371a9d639a$var$loadChats();
    $af6746371a9d639a$var$loadModels();
    $af6746371a9d639a$var$el.form.addEventListener('submit', (e)=>{
        e.preventDefault();
        const text = $af6746371a9d639a$var$el.input.value.trim();
        if (!text) return;
        $af6746371a9d639a$var$el.input.value = '';
        $af6746371a9d639a$var$sendMessage(text);
    });
    $af6746371a9d639a$var$el.input.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            $af6746371a9d639a$var$el.form.requestSubmit();
        }
    });
    $af6746371a9d639a$var$el.stopBtn?.addEventListener('click', ()=>$af6746371a9d639a$var$state.abortController?.abort());
    $af6746371a9d639a$var$el.newChatBtn?.addEventListener('click', ()=>{
        if ($af6746371a9d639a$var$state.streaming) $af6746371a9d639a$var$state.abortController?.abort();
        $af6746371a9d639a$var$newChat();
    });
    $af6746371a9d639a$var$el.modelSelect?.addEventListener('change', ()=>{
        $af6746371a9d639a$var$state.modelId = $af6746371a9d639a$var$el.modelSelect.value;
        const c = $af6746371a9d639a$var$activeChat();
        if (c) {
            c.modelId = $af6746371a9d639a$var$state.modelId;
            $af6746371a9d639a$var$saveChats();
        }
    });
    // Historie – klik otevře chat, mazací tlačítko smaže.
    $af6746371a9d639a$var$el.historyList?.addEventListener('click', (e)=>{
        const delBtn = e.target.closest('[data-delete-id]');
        if (delBtn) {
            e.preventDefault();
            $af6746371a9d639a$var$deleteChat(delBtn.getAttribute('data-delete-id'), e);
            return;
        }
        const item = e.target.closest('[data-chat-id]');
        if (item) $af6746371a9d639a$var$openChat(item.getAttribute('data-chat-id'));
    });
    $af6746371a9d639a$var$el.historySearch?.addEventListener('input', (e)=>{
        $af6746371a9d639a$var$state.historySearch = e.target.value || '';
        $af6746371a9d639a$var$renderHistorySidebar();
    });
    // Mobilní drawer s historií.
    $af6746371a9d639a$var$el.historyToggleBtn?.addEventListener('click', $af6746371a9d639a$var$openHistoryDrawer);
    $af6746371a9d639a$var$el.historyOverlay?.addEventListener('click', $af6746371a9d639a$var$closeHistoryDrawer);
    // Přílohy – zatím jen vizuální nálepky (soubor se neodešle na server).
    $af6746371a9d639a$var$el.attachBtn?.addEventListener('click', ()=>$af6746371a9d639a$var$el.attachInput?.click());
    $af6746371a9d639a$var$el.attachInput?.addEventListener('change', (e)=>{
        const files = Array.from(e.target.files || []);
        if (files.length === 0) return;
        $af6746371a9d639a$var$renderAttachChips(files);
        $af6746371a9d639a$var$el.attachNote?.classList.remove('hidden');
        e.target.value = '';
    });
    $af6746371a9d639a$var$renderHistory();
    $af6746371a9d639a$var$renderHistorySidebar();
}
function $af6746371a9d639a$var$renderAttachChips(files) {
    if (!$af6746371a9d639a$var$el.attachChips) return;
    for (const f of files){
        const chip = document.createElement('span');
        chip.className = 'inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full bg-gray-100 text-gray-700 border border-gray-200';
        chip.innerHTML = `
      <svg class="w-3 h-3" data-icon="paperclip"></svg>
      <span class="max-w-[160px] truncate">${$af6746371a9d639a$var$escapeHtml(f.name)}</span>
      <button type="button" class="text-gray-400 hover:text-red-600" title="Odebrat">
        <svg class="w-3 h-3" data-icon="x-mark"></svg>
      </button>
    `;
        chip.querySelector('button').addEventListener('click', ()=>{
            chip.remove();
            if ($af6746371a9d639a$var$el.attachChips && $af6746371a9d639a$var$el.attachChips.children.length === 0) $af6746371a9d639a$var$el.attachNote?.classList.add('hidden');
        });
        (0, $entK4.hydrateIcons)(chip);
        $af6746371a9d639a$var$el.attachChips.appendChild(chip);
    }
}
function $af6746371a9d639a$var$openHistoryDrawer() {
    if (!$af6746371a9d639a$var$el.historySidebar) return;
    $af6746371a9d639a$var$el.historySidebar.classList.remove('hidden', 'lg:flex');
    $af6746371a9d639a$var$el.historySidebar.classList.add('fixed', 'inset-y-0', 'left-0', 'z-50', 'flex', 'w-80', 'shadow-xl');
    $af6746371a9d639a$var$el.historyOverlay?.classList.remove('hidden');
}
function $af6746371a9d639a$var$closeHistoryDrawer() {
    if (!$af6746371a9d639a$var$el.historySidebar) return;
    // Na lg zůstává viditelný jako flex sloupec, na menších se skryje.
    $af6746371a9d639a$var$el.historySidebar.classList.remove('fixed', 'inset-y-0', 'left-0', 'z-50', 'flex', 'w-80', 'shadow-xl');
    $af6746371a9d639a$var$el.historySidebar.classList.add('hidden', 'lg:flex');
    $af6746371a9d639a$var$el.historyOverlay?.classList.add('hidden');
}
function $af6746371a9d639a$export$9f06ea0653868b1c() {
    const panel = $af6746371a9d639a$var$$('settings-ai');
    if (!panel) return;
    const apiKeyInput = $af6746371a9d639a$var$$('ai-gatewayApiKey');
    const baseUrlInput = $af6746371a9d639a$var$$('ai-baseUrl');
    const enabledInput = $af6746371a9d639a$var$$('ai-enabled');
    const defaultSelect = $af6746371a9d639a$var$$('ai-defaultModel');
    const reasoningSelect = $af6746371a9d639a$var$$('ai-reasoning');
    const modelsList = $af6746371a9d639a$var$$('ai-models-list');
    const loadBtn = $af6746371a9d639a$var$$('ai-load-models-btn');
    const saveBtn = $af6746371a9d639a$var$$('ai-save-btn');
    const statusEl = $af6746371a9d639a$var$$('ai-models-status');
    const saveStatus = $af6746371a9d639a$var$$('ai-save-status');
    let gatewayModels = [];
    let selectedModels = [];
    // Snapshot celého ai bloku – PUT /settings merguje jen top-level klíče,
    // takže při uložení musíme poslat i klíče, které panel needituje
    // (contextWindows, providerOptions…), jinak by se ztratily.
    let currentAi = {};
    const apiBase = $af6746371a9d639a$var$API_BASE_URL;
    async function loadSettings() {
        try {
            const res = await fetch(`${apiBase}/settings`);
            if (!res.ok) return;
            const r = await res.json();
            const ai = r.data && r.data.settings && r.data.settings.ai || {};
            currentAi = ai;
            apiKeyInput.value = ai.gatewayApiKey || '';
            baseUrlInput.value = ai.baseUrl || '';
            enabledInput.checked = ai.enabled !== false;
            if (reasoningSelect) reasoningSelect.value = ai.reasoning || 'default';
            selectedModels = Array.isArray(ai.availableModels) ? [
                ...ai.availableModels
            ] : [];
            renderModelsList();
            setDefaultSelect(ai.defaultModel || selectedModels[0] || 'deepseek/deepseek-v4-flash');
        } catch (e) {
            console.warn('[ai-settings] load', e);
        }
    }
    function setDefaultSelect(value) {
        const opts = (selectedModels.length ? selectedModels : gatewayModels.map((m)=>m.id)).concat(value && !(selectedModels.includes(value) || gatewayModels.some((m)=>m.id === value)) ? [
            value
        ] : []);
        defaultSelect.innerHTML = opts.map((m)=>`<option value="${$af6746371a9d639a$var$escapeHtml(m)}">${$af6746371a9d639a$var$escapeHtml(m)}</option>`).join('');
        defaultSelect.value = value;
    }
    function renderModelsList() {
        const pool = gatewayModels.length ? gatewayModels : selectedModels.map((id)=>({
                id: id,
                name: id
            }));
        modelsList.innerHTML = pool.map((m)=>{
            const checked = selectedModels.includes(m.id) ? 'checked' : '';
            return `
        <label class="flex items-center gap-2 text-sm px-2.5 py-1.5 border border-gray-200 rounded-md hover:bg-gray-50">
          <input type="checkbox" value="${$af6746371a9d639a$var$escapeHtml(m.id)}" ${checked} class="ai-model-checkbox rounded border-gray-300" />
          <span class="truncate">${$af6746371a9d639a$var$escapeHtml(m.name || m.id)}</span>
        </label>`;
        }).join('');
        modelsList.querySelectorAll('.ai-model-checkbox').forEach((cb)=>{
            cb.addEventListener('change', ()=>{
                selectedModels = Array.from(modelsList.querySelectorAll('.ai-model-checkbox:checked')).map((c)=>c.value);
                setDefaultSelect(defaultSelect.value && selectedModels.includes(defaultSelect.value) ? defaultSelect.value : selectedModels[0]);
            });
        });
    }
    loadBtn?.addEventListener('click', async ()=>{
        statusEl.textContent = "Na\u010D\xedt\xe1m modely z gateway\u2026";
        try {
            const res = await fetch(`${apiBase}/ai/models?source=gateway`);
            if (!res.ok) {
                const j = await res.json().catch(()=>({}));
                throw new Error(j.error || `HTTP ${res.status}`);
            }
            const r = await res.json();
            gatewayModels = r.data && r.data.models || [];
            if (r.data && Array.isArray(r.data.availableModels)) selectedModels = [
                ...r.data.availableModels
            ];
            statusEl.textContent = `Nalezeno ${gatewayModels.length} model\u{16F}.`;
            renderModelsList();
            setDefaultSelect(r.data && r.data.defaultModel || selectedModels[0] || 'deepseek/deepseek-v4-flash');
        } catch (e) {
            statusEl.textContent = `Chyba: ${e.message}`;
        }
    });
    saveBtn?.addEventListener('click', async ()=>{
        saveStatus.textContent = "Ukl\xe1d\xe1m\u2026";
        const payload = {
            ai: {
                ...currentAi,
                enabled: enabledInput.checked,
                gatewayApiKey: apiKeyInput.value.trim(),
                baseUrl: baseUrlInput.value.trim(),
                defaultModel: defaultSelect.value,
                reasoning: reasoningSelect ? reasoningSelect.value : currentAi.reasoning || 'default',
                availableModels: selectedModels.length ? selectedModels : [
                    defaultSelect.value
                ]
            }
        };
        try {
            const res = await fetch(`${apiBase}/settings`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            currentAi = payload.ai;
            saveStatus.textContent = "Ulo\u017Eeno \u2713";
            setTimeout(()=>{
                saveStatus.textContent = '';
            }, 2500);
            // Znovu načti modely do chat selectoru.
            $af6746371a9d639a$var$state.initialised && $af6746371a9d639a$var$loadModels();
        } catch (e) {
            saveStatus.textContent = `Chyba: ${e.message}`;
        }
    });
    // Cron: načti nastavení při prvním zobrazení panelu (lazy, až je sekce viditelná).
    let loaded = false;
    const tryLoad = ()=>{
        if (!loaded) {
            loaded = true;
            loadSettings();
        }
    };
    if (document.getElementById('nastaveni-section')?.classList.contains('active')) tryLoad();
    document.addEventListener('click', (e)=>{
        const link = e.target.closest('[data-section="nastaveni"]');
        if (link) setTimeout(tryLoad, 200);
    }, {
        once: false
    });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $af6746371a9d639a$export$9f06ea0653868b1c);
else $af6746371a9d639a$export$9f06ea0653868b1c();


const $df0e1e63dc461fca$var$DEFAULT_INTERVAL_MS = 45000;
const $df0e1e63dc461fca$var$SECTION_RESOURCE_DEPENDENCIES = {
    dashboard: new Set([
        'dashboard',
        'offers',
        'orders',
        'invoices',
        'materials',
        'warehouse',
        'customers'
    ]),
    nabidky: new Set([
        'offers',
        'customers'
    ]),
    objednavky: new Set([
        'orders',
        'offers',
        'invoices',
        'customers'
    ]),
    vyroba: new Set([
        'orders',
        'customers'
    ]),
    faktury: new Set([
        'invoices',
        'orders',
        'customers'
    ]),
    soubory: new Set([
        'files',
        'customers'
    ])
};
function $df0e1e63dc461fca$var$getSectionRefresher(sectionId) {
    const refreshers = {
        dashboard: ()=>window.dashboardManager?.refresh?.(),
        nabidky: ()=>window.offersListManager?.refresh?.(),
        objednavky: ()=>window.ordersListManager?.refresh?.(),
        vyroba: ()=>window.vyrobaManager?.refresh?.(),
        faktury: ()=>window.invoicesListManager?.refresh?.(),
        soubory: ()=>window.filesManager?.refresh?.()
    };
    return refreshers[sectionId] || null;
}
class $df0e1e63dc461fca$var$AutoRefreshManager {
    constructor({ intervalMs: intervalMs = $df0e1e63dc461fca$var$DEFAULT_INTERVAL_MS } = {}){
        this.intervalMs = intervalMs;
        this.currentSection = null;
        this.lastRefreshAt = new Map();
        this.inFlight = new Set();
        this.timer = null;
    }
    start() {
        if (this.timer) return;
        this.currentSection = window.sectionManager?.currentSection || null;
        this.timer = window.setInterval(()=>{
            this.refreshCurrentSection('interval');
        }, this.intervalMs);
        document.addEventListener('visibilitychange', ()=>{
            if (document.visibilityState === 'visible') this.refreshCurrentSection('tab-visible', {
                force: true
            });
        });
        window.addEventListener('focus', ()=>{
            this.refreshCurrentSection('window-focus', {
                force: true
            });
        });
    }
    setCurrentSection(sectionId) {
        this.currentSection = sectionId || null;
    }
    shouldRefreshSectionForPush(sectionId, eventPayload) {
        if (!sectionId) return false;
        const resource = eventPayload?.resource;
        if (!resource || typeof resource !== 'string') // Bez resource metadata fallback na refresh, aby se změna neztratila.
        return true;
        const dependencies = $df0e1e63dc461fca$var$SECTION_RESOURCE_DEPENDENCIES[sectionId];
        if (!dependencies) return false;
        return dependencies.has(resource);
    }
    handlePushEvent(eventPayload) {
        if (!this.currentSection) return;
        if (!this.shouldRefreshSectionForPush(this.currentSection, eventPayload)) return;
        this.refreshCurrentSection('push', {
            force: true
        });
    }
    refreshCurrentSection(reason, { force: force = false } = {}) {
        if (!window.__appReady) return;
        if (document.visibilityState !== 'visible') return;
        if (!this.currentSection) return;
        const refresher = $df0e1e63dc461fca$var$getSectionRefresher(this.currentSection);
        if (!refresher) return;
        if (this.inFlight.has(this.currentSection)) return;
        const now = Date.now();
        const last = this.lastRefreshAt.get(this.currentSection) || 0;
        if (!force && now - last < this.intervalMs) return;
        this.inFlight.add(this.currentSection);
        this.lastRefreshAt.set(this.currentSection, now);
        Promise.resolve(refresher(reason)).catch((err)=>{
            // Auto-refresh běží na pozadí – chyba nesmí rušit UI.
            console.warn('[auto-refresh] Refresh selhal:', this.currentSection, err);
        }).finally(()=>{
            this.inFlight.delete(this.currentSection);
        });
    }
}
function $df0e1e63dc461fca$export$e07844b9a297550a(options = {}) {
    const manager = new $df0e1e63dc461fca$var$AutoRefreshManager(options);
    manager.start();
    return manager;
}


const $0d24267c683c7c53$var$STREAM_URL = '/api/events/stream';
const $0d24267c683c7c53$var$RECONNECT_DELAYS_MS = [
    1000,
    2000,
    5000,
    10000,
    20000,
    30000
];
function $0d24267c683c7c53$var$canUseEventSource() {
    return typeof window !== 'undefined' && typeof window.EventSource !== 'undefined';
}
function $0d24267c683c7c53$var$isRealtimePushEnabled() {
    if (typeof window === 'undefined') return false;
    // SSE keeps a Vercel Function open for the whole browser session. Keep it
    // available for local development and explicit production opt-in only.
    if (window.TRIA_ENABLE_REALTIME_SSE === true) return true;
    if (window.localStorage?.getItem('tria-enable-realtime-sse') === '1') return true;
    const host = window.location.hostname;
    return host === 'localhost' || host === '127.0.0.1';
}
class $0d24267c683c7c53$var$RealtimePushManager {
    constructor({ onDataChange: onDataChange } = {}){
        this.onDataChange = onDataChange;
        this.eventSource = null;
        this.started = false;
        this.retryTimer = null;
        this.retryIndex = 0;
    }
    start() {
        if (this.started || !$0d24267c683c7c53$var$canUseEventSource() || !$0d24267c683c7c53$var$isRealtimePushEnabled()) return;
        this.started = true;
        this.connect();
    }
    stop() {
        this.started = false;
        if (this.retryTimer) {
            clearTimeout(this.retryTimer);
            this.retryTimer = null;
        }
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
        }
    }
    connect() {
        if (!this.started) return;
        if (!window.__appReady) {
            if (!this.retryTimer) this.retryTimer = setTimeout(()=>{
                this.retryTimer = null;
                this.connect();
            }, 2000);
            return;
        }
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
        }
        const source = new EventSource($0d24267c683c7c53$var$STREAM_URL, {
            withCredentials: true
        });
        this.eventSource = source;
        source.addEventListener('ready', ()=>{
            this.retryIndex = 0;
        });
        source.addEventListener('data-change', (evt)=>{
            try {
                const payload = JSON.parse(evt.data);
                if (typeof this.onDataChange === 'function') this.onDataChange(payload);
            } catch (err) {
                console.warn("[realtime-push] Neplatn\xfd payload data-change:", err);
            }
        });
        source.onerror = ()=>{
            this.scheduleReconnect();
        };
    }
    scheduleReconnect() {
        if (!this.started) return;
        if (this.retryTimer) return;
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
        }
        const delay = $0d24267c683c7c53$var$RECONNECT_DELAYS_MS[Math.min(this.retryIndex, $0d24267c683c7c53$var$RECONNECT_DELAYS_MS.length - 1)];
        this.retryIndex += 1;
        this.retryTimer = setTimeout(()=>{
            this.retryTimer = null;
            this.connect();
        }, delay);
    }
}
function $0d24267c683c7c53$export$4552ecc77aef35b6(options = {}) {
    const manager = new $0d24267c683c7c53$var$RealtimePushManager(options);
    manager.start();
    return manager;
}


// Strážce session: zachytává 401 z API, hlídá heartbeatem expiraci
// a vyvolává event 'auth:session-expired', na který reaguje AuthManager
// vykreslením modálu pro obnovu přihlášení (bez ztráty rozpracované práce).
const $a97c5dcf4b2d6669$var$HEARTBEAT_INTERVAL_MS = 300000; // 5 min
const $a97c5dcf4b2d6669$var$HEARTBEAT_GRACE_MS = 30000; // po obnově nech 30 s bez heartbeatu
// Endpoints, které se nemají vyhodnocovat jako "session expired"
// (login sám o sobě vrací 401 při špatných údajích, check je interní heartbeat).
const $a97c5dcf4b2d6669$var$AUTH_PASSTHROUGH_PATHS = [
    '/api/auth/login',
    '/api/auth/check'
];
let $a97c5dcf4b2d6669$var$installed = false;
let $a97c5dcf4b2d6669$var$lastHeartbeatAt = 0;
let $a97c5dcf4b2d6669$var$heartbeatTimer = null;
function $a97c5dcf4b2d6669$var$isApiUrl(url) {
    if (!url) return false;
    try {
        const u = typeof url === 'string' ? url : url.url || '';
        if (u.startsWith('/api/')) return true;
        const parsed = new URL(u, window.location.href);
        return parsed.pathname.startsWith('/api/');
    } catch  {
        return false;
    }
}
function $a97c5dcf4b2d6669$var$isPassthrough(url) {
    if (!url) return false;
    try {
        const u = typeof url === 'string' ? url : url.url || '';
        return $a97c5dcf4b2d6669$var$AUTH_PASSTHROUGH_PATHS.some((p)=>u.includes(p));
    } catch  {
        return false;
    }
}
function $a97c5dcf4b2d6669$var$userLooksLoggedIn() {
    return Boolean(localStorage.getItem('currentUser'));
}
function $a97c5dcf4b2d6669$var$emitSessionExpired(reason = 'unauthorized') {
    if (!$a97c5dcf4b2d6669$var$userLooksLoggedIn()) return;
    window.dispatchEvent(new CustomEvent('auth:session-expired', {
        detail: {
            reason: reason
        }
    }));
}
async function $a97c5dcf4b2d6669$var$runHeartbeat() {
    if (!$a97c5dcf4b2d6669$var$userLooksLoggedIn()) return;
    if (Date.now() - $a97c5dcf4b2d6669$var$lastHeartbeatAt < $a97c5dcf4b2d6669$var$HEARTBEAT_GRACE_MS) return;
    try {
        const res = await window.fetch('/api/auth/check', {
            method: 'GET',
            credentials: 'include'
        });
        if (res.status === 401) $a97c5dcf4b2d6669$var$emitSessionExpired('heartbeat');
    } catch  {
    // Síťová chyba není důvod uživatele otravovat – jen ignorujeme.
    } finally{
        $a97c5dcf4b2d6669$var$lastHeartbeatAt = Date.now();
    }
}
function $a97c5dcf4b2d6669$export$562fb1313e8722bf() {
    $a97c5dcf4b2d6669$var$lastHeartbeatAt = Date.now();
}
function $a97c5dcf4b2d6669$export$dd849b5e1f1f2680() {
    if ($a97c5dcf4b2d6669$var$installed) return;
    $a97c5dcf4b2d6669$var$installed = true;
    const originalFetch = window.fetch.bind(window);
    window.fetch = async function patchedFetch(input, init) {
        const response = await originalFetch(input, init);
        try {
            if (response.status === 401 && $a97c5dcf4b2d6669$var$isApiUrl(input) && !$a97c5dcf4b2d6669$var$isPassthrough(input) && $a97c5dcf4b2d6669$var$userLooksLoggedIn()) $a97c5dcf4b2d6669$var$emitSessionExpired('api-401');
        } catch  {
        // Žádný interceptor by neměl shodit původní fetch.
        }
        return response;
    };
    // Heartbeat – periodicky a při probuzení tabu
    $a97c5dcf4b2d6669$var$heartbeatTimer = window.setInterval($a97c5dcf4b2d6669$var$runHeartbeat, $a97c5dcf4b2d6669$var$HEARTBEAT_INTERVAL_MS);
    document.addEventListener('visibilitychange', ()=>{
        if (document.visibilityState === 'visible') $a97c5dcf4b2d6669$var$runHeartbeat();
    });
    window.addEventListener('focus', $a97c5dcf4b2d6669$var$runHeartbeat);
}
function $a97c5dcf4b2d6669$export$3c4fbc8f7a0be5f9() {
    if ($a97c5dcf4b2d6669$var$heartbeatTimer) {
        window.clearInterval($a97c5dcf4b2d6669$var$heartbeatTimer);
        $a97c5dcf4b2d6669$var$heartbeatTimer = null;
    }
}




var $entK4 = parcelRequire("entK4");
/**
 * Univerzální graf vývoje ceny podle počtu kusů.
 *
 * Použití:
 *  - Nastavení: tlačítko s ikonou grafu u jednotlivých výpočtů (vazby…) –
 *    křivka se počítá klientsky ze vzorce a aktuálních hodnot formuláře.
 *  - Kalkulátor: tlačítko u pole „Počet kusů" – série cen počítá backend
 *    (POST /api/calculate/curve) z kompletního zadání položky.
 *
 * Graf se vykresluje LÍNĚ – až po kliknutí, v modálu (openPriceChartModal).
 */ const $163b6a16f9b4a0d7$var$SERIES_COLORS = [
    '#2563eb',
    '#059669',
    '#d97706',
    '#7c3aed',
    '#db2777',
    '#0891b2'
];
const $163b6a16f9b4a0d7$var$fmt = (v)=>Math.round(v).toLocaleString('cs-CZ');
/** „Hezký" krok osy (1/2/5 × 10^k) pro daný rozsah a počet kroků. */ function $163b6a16f9b4a0d7$var$niceStep(range, steps) {
    const raw = range / steps;
    const mag = Math.pow(10, Math.floor(Math.log10(raw)));
    for (const m of [
        1,
        2,
        5,
        10
    ]){
        if (raw <= m * mag) return m * mag;
    }
    return 10 * mag;
}
function $163b6a16f9b4a0d7$export$107d1e069b7efcf6(mountEl, cfg) {
    const series = (cfg.series || []).filter((s)=>s.points && s.points.length);
    if (!series.length) {
        mountEl.innerHTML = '<p class="text-sm text-gray-500 py-6 text-center">\u017D\xe1dn\xe1 data k zobrazen\xed.</p>';
        return;
    }
    const W = 680, H = 260, L = 64, R = 16, T = 14, B = 32;
    const allPts = series.flatMap((s)=>s.points);
    const maxX = Math.max(...allPts.map((p)=>p.x));
    const maxY = Math.max(...allPts.map((p)=>p.y), 1) * 1.05;
    const x = (n)=>L + n / maxX * (W - L - R);
    const y = (c)=>T + (1 - c / maxY) * (H - T - B);
    // Mřížka Y (3 kroky) + osa X (hezké kroky)
    let grid = '';
    for(let i = 1; i <= 3; i++){
        const val = maxY / 1.05 * (i / 3);
        grid += `<line x1="${L}" y1="${y(val)}" x2="${W - R}" y2="${y(val)}" stroke="#e5e7eb" stroke-width="1"/>` + `<text x="${L - 6}" y="${y(val) + 3}" text-anchor="end" font-size="10" fill="#9ca3af">${$163b6a16f9b4a0d7$var$fmt(val)}</text>`;
    }
    const stepX = $163b6a16f9b4a0d7$var$niceStep(maxX, 5);
    let xTicks = '';
    for(let n = stepX; n <= maxX; n += stepX)xTicks += `<text x="${x(n)}" y="${H - B + 14}" text-anchor="middle" font-size="10" fill="#9ca3af">${$163b6a16f9b4a0d7$var$fmt(n)}</text>`;
    // Pomocné přímky (asymptoty)
    let extra = '';
    for (const l of cfg.extraLines || [])extra += `<line x1="${x(l.x1)}" y1="${y(l.y1)}" x2="${x(l.x2)}" y2="${y(l.y2)}" stroke="#9ca3af" stroke-width="1" stroke-dasharray="5 4"/>`;
    // Svislé markery (práh, aktuální náklad)
    let markers = '';
    for (const m of cfg.markers || []){
        if (m.x <= 0 || m.x > maxX) continue;
        markers += `<line x1="${x(m.x)}" y1="${T}" x2="${x(m.x)}" y2="${y(0)}" stroke="#f59e0b" stroke-width="1" stroke-dasharray="4 3"/>` + `<text x="${x(m.x) + 4}" y="${T + 10}" font-size="10" fill="#b45309">${$163b6a16f9b4a0d7$var$escapeHtml(m.label || '')}</text>`;
    }
    // Křivky sérií + tečky s nativním tooltipem na hlavní sérii
    let paths = '';
    series.forEach((s, i)=>{
        const color = s.color || $163b6a16f9b4a0d7$var$SERIES_COLORS[i % $163b6a16f9b4a0d7$var$SERIES_COLORS.length];
        const d = s.points.map((p, j)=>`${j ? 'L' : 'M'}${x(p.x).toFixed(1)},${y(p.y).toFixed(1)}`).join('');
        paths += `<path d="${d}" fill="none" stroke="${color}" stroke-width="2.5" stroke-linejoin="round"${s.dash ? ` stroke-dasharray="${s.dash}"` : ''}/>`;
    });
    const main = series[0];
    const mainColor = main.color || $163b6a16f9b4a0d7$var$SERIES_COLORS[0];
    const step = Math.max(1, Math.floor(main.points.length / 24));
    let dots = '';
    main.points.forEach((p, j)=>{
        if (j % step !== 0 && j !== main.points.length - 1) return;
        const tech = p.meta && p.meta.technologie ? ` [${p.meta.technologie}]` : '';
        dots += `<circle cx="${x(p.x)}" cy="${y(p.y)}" r="3.5" fill="${mainColor}" stroke="#ffffff" stroke-width="1.5">` + `<title>${$163b6a16f9b4a0d7$var$fmt(p.x)} ks \u{2192} ${$163b6a16f9b4a0d7$var$fmt(p.y)} K\u{10D} (${(p.y / p.x).toFixed(2)} K\u{10D}/ks)${tech}</title></circle>`;
    });
    // Legenda jen při více sériích
    const legend = series.length > 1 ? `<div class="flex flex-wrap gap-x-4 gap-y-1 mb-2 text-xs text-gray-600">${series.map((s, i)=>`
        <span class="inline-flex items-center gap-1.5">
          <span class="inline-block w-4 border-t-2" style="border-color:${s.color || $163b6a16f9b4a0d7$var$SERIES_COLORS[i % $163b6a16f9b4a0d7$var$SERIES_COLORS.length]};${s.dash ? 'border-top-style:dashed;' : ''}"></span>
          ${$163b6a16f9b4a0d7$var$escapeHtml(s.label || `S\xe9rie ${i + 1}`)}
        </span>`).join('')}</div>` : '';
    const chips = (cfg.chips || []).map((c)=>`
    <span class="inline-flex items-center gap-1 px-2 py-1 ${c.highlight ? 'bg-blue-50 border-blue-200 text-blue-800' : 'bg-white border-gray-200 text-gray-700'} border rounded-md">
      <strong>${$163b6a16f9b4a0d7$var$escapeHtml(c.label)}</strong> \u{2192} ${$163b6a16f9b4a0d7$var$escapeHtml(c.value)}
      ${c.sub ? `<span class="${c.highlight ? 'text-blue-400' : 'text-gray-400'}">${$163b6a16f9b4a0d7$var$escapeHtml(c.sub)}</span>` : ''}
    </span>`).join('');
    // Hover prvky: svislý crosshair + zvýrazněný bod na každé sérii
    const hoverDots = series.map((s, i)=>`<circle data-hover-dot="${i}" r="4.5" fill="${s.color || $163b6a16f9b4a0d7$var$SERIES_COLORS[i % $163b6a16f9b4a0d7$var$SERIES_COLORS.length]}" stroke="#ffffff" stroke-width="2" style="display:none"/>`).join('');
    mountEl.innerHTML = `
    ${legend}
    <div class="relative">
      <svg viewBox="0 0 ${W} ${H}" class="w-full" role="img" aria-label="Graf v\xfdvoje ceny podle po\u{10D}tu kus\u{16F}">
        ${grid}
        <line x1="${L}" y1="${y(0)}" x2="${W - R}" y2="${y(0)}" stroke="#d1d5db" stroke-width="1"/>
        ${xTicks}
        <text x="${W - R}" y="${H - B + 26}" text-anchor="end" font-size="10" fill="#9ca3af">${$163b6a16f9b4a0d7$var$escapeHtml(cfg.xLabel || "n\xe1klad (ks)")}</text>
        ${extra}
        ${markers}
        ${paths}
        ${dots}
        <line data-hover-line x1="0" y1="${T}" x2="0" y2="${y(0)}" stroke="#6b7280" stroke-width="1" stroke-dasharray="3 3" style="display:none"/>
        ${hoverDots}
      </svg>
      <div data-chart-tooltip class="hidden absolute z-10 pointer-events-none bg-gray-900/90 text-white rounded-md px-2.5 py-1.5 text-xs shadow-lg whitespace-nowrap"></div>
    </div>
    ${chips ? `<div class="flex flex-wrap gap-2 mt-3 text-xs">${chips}</div>` : ''}
  `;
    $163b6a16f9b4a0d7$var$bindHover(mountEl, {
        series: series,
        W: W,
        H: H,
        L: L,
        R: R,
        T: T,
        B: B,
        maxX: maxX,
        x: x,
        y: y
    });
}
/**
 * Hover vrstva: crosshair sleduje myš, tooltip ukazuje pro nejbližší náklad
 * celkovou cenu, cenu za kus (a technologii) každé série.
 */ function $163b6a16f9b4a0d7$var$bindHover(mountEl, ctx) {
    const { series: series, W: W, L: L, R: R, T: T, maxX: maxX, x: x, y: y } = ctx;
    const svg = mountEl.querySelector('svg');
    const wrap = svg.parentElement;
    const tooltip = mountEl.querySelector('[data-chart-tooltip]');
    const hoverLine = svg.querySelector('[data-hover-line]');
    const hoverDots = [
        ...svg.querySelectorAll('[data-hover-dot]')
    ];
    const nearest = (points, n)=>{
        let best = points[0];
        for (const p of points)if (Math.abs(p.x - n) < Math.abs(best.x - n)) best = p;
        return best;
    };
    const hide = ()=>{
        tooltip.classList.add('hidden');
        hoverLine.style.display = 'none';
        hoverDots.forEach((d)=>{
            d.style.display = 'none';
        });
    };
    svg.addEventListener('mouseleave', hide);
    svg.addEventListener('mousemove', (evt)=>{
        const rect = svg.getBoundingClientRect();
        const vx = (evt.clientX - rect.left) * (W / rect.width);
        if (vx < L || vx > W - R) {
            hide();
            return;
        }
        const n = (vx - L) / (W - L - R) * maxX;
        const main = nearest(series[0].points, n);
        const cx = x(main.x);
        hoverLine.setAttribute('x1', cx);
        hoverLine.setAttribute('x2', cx);
        hoverLine.style.display = '';
        const rows = series.map((s, i)=>{
            const p = nearest(s.points, main.x);
            const dot = hoverDots[i];
            if (dot) {
                dot.setAttribute('cx', x(p.x));
                dot.setAttribute('cy', y(p.y));
                dot.style.display = '';
            }
            const tech = p.meta && p.meta.technologie ? ` \xb7 ${p.meta.technologie}` : '';
            const label = series.length > 1 ? `<span class="text-gray-300">${$163b6a16f9b4a0d7$var$escapeHtml(s.label || '')}:</span> ` : '';
            return `<div>${label}<strong>${$163b6a16f9b4a0d7$var$fmt(p.y)} K\u{10D}</strong> <span class="text-gray-300">(${(p.y / p.x).toFixed(2)} K\u{10D}/ks${tech})</span></div>`;
        }).join('');
        tooltip.innerHTML = `<div class="font-semibold mb-0.5">${$163b6a16f9b4a0d7$var$fmt(main.x)} ks</div>${rows}`;
        tooltip.classList.remove('hidden');
        // Pozice tooltip u kurzoru, s překlopením u pravého okraje
        const wrapRect = wrap.getBoundingClientRect();
        const tipW = tooltip.offsetWidth;
        let left = evt.clientX - wrapRect.left + 14;
        if (left + tipW > wrapRect.width - 4) left = evt.clientX - wrapRect.left - tipW - 14;
        let top = evt.clientY - wrapRect.top - tooltip.offsetHeight - 10;
        if (top < 0) top = evt.clientY - wrapRect.top + 14;
        tooltip.style.left = `${Math.max(0, left)}px`;
        tooltip.style.top = `${top}px`;
    });
}
function $163b6a16f9b4a0d7$export$b9a65a2741894972({ title: title, subtitle: subtitle, load: load }) {
    const overlay = document.createElement('div');
    overlay.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4';
    overlay.innerHTML = `
    <div class="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto" role="dialog" aria-modal="true" aria-label="${$163b6a16f9b4a0d7$var$escapeHtml(title)}">
      <div class="flex items-start justify-between px-5 py-4 border-b border-gray-200">
        <div>
          <h3 class="text-lg font-semibold text-gray-900">${$163b6a16f9b4a0d7$var$escapeHtml(title)}</h3>
          ${subtitle ? `<p class="text-sm text-gray-500 mt-0.5">${$163b6a16f9b4a0d7$var$escapeHtml(subtitle)}</p>` : ''}
        </div>
        <button type="button" data-chart-close class="p-1.5 text-gray-400 hover:text-gray-700 rounded-md hover:bg-gray-100" aria-label="Zav\u{159}\xedt">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" class="w-5 h-5"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>
      <div class="px-5 py-4" data-chart-body>
        <div class="flex items-center justify-center py-12 text-gray-400">
          <svg viewBox="0 0 24 24" fill="none" class="w-8 h-8 animate-spin"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path></svg>
        </div>
      </div>
    </div>
  `;
    document.body.appendChild(overlay);
    const close = ()=>{
        overlay.remove();
        document.removeEventListener('keydown', onKey);
    };
    const onKey = (e)=>{
        if (e.key === 'Escape') close();
    };
    document.addEventListener('keydown', onKey);
    overlay.addEventListener('click', (e)=>{
        if (e.target === overlay || e.target.closest('[data-chart-close]')) close();
    });
    const body = overlay.querySelector('[data-chart-body]');
    Promise.resolve().then(()=>load()).then((cfg)=>$163b6a16f9b4a0d7$export$107d1e069b7efcf6(body, cfg)).catch((err)=>{
        console.error("Graf v\xfdvoje ceny:", err);
        body.innerHTML = `<div class="bg-red-50 border border-red-200 rounded-md p-4 text-sm text-red-700">${$163b6a16f9b4a0d7$var$escapeHtml(err.message || "Na\u010Dten\xed grafu se nezda\u0159ilo")}</div>`;
    });
}
function $163b6a16f9b4a0d7$export$3f24e24def8ba421(n, { priprava: priprava, kusStart: kusStart, kusKonec: kusKonec, prah: prah, utlum: utlum }) {
    if (n <= prah) return priprava + kusStart * n;
    const nad = n - prah;
    return priprava + kusStart * prah + kusKonec * nad + (kusStart - kusKonec) * utlum * (1 - Math.exp(-nad / utlum));
}
function $163b6a16f9b4a0d7$export$8aaec4f23b1a26c8(fn, maxN, step = Math.max(1, Math.round(maxN / 200))) {
    const pts = [];
    for(let n = 1; n <= maxN; n += step)pts.push({
        x: n,
        y: fn(n)
    });
    if (pts[pts.length - 1].x !== maxN) pts.push({
        x: maxN,
        y: fn(maxN)
    });
    return pts;
}
function $163b6a16f9b4a0d7$export$e33a53994a07f308(fn, quantities, highlightN = null) {
    return quantities.map((n)=>({
            label: `${$163b6a16f9b4a0d7$var$fmt(n)} ks`,
            value: `${$163b6a16f9b4a0d7$var$fmt(fn(n))} K\u{10D}`,
            sub: `(${(fn(n) / n).toFixed(2)} K\u{10D}/ks)`,
            highlight: highlightN != null && n === highlightN
        }));
}
function $163b6a16f9b4a0d7$var$escapeHtml(str) {
    if (str == null) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}


(0, $a97c5dcf4b2d6669$export$dd849b5e1f1f2680)();
// Hydratace statických ikon (<svg data-icon="...">) v index.html
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ()=>(0, $entK4.hydrateIcons)());
else (0, $entK4.hydrateIcons)();
// SEC-11: Centrální obal pro window.fetch (a XMLHttpRequest) – musí být
// nainstalován co nejdříve, aby platil i pro ostatní moduly (customers.js,
// offer-editor.js, users-admin.js, files-manager.js, ...).
// Zajišťuje:
//  1. credentials: 'include' pro všechna API volání (auth nese httpOnly cookie),
//  2. CSRF hlavičku X-CSRF-Token (double-submit cookie) pro mutační metody,
//  3. detekci expirované session přes 401 (nahrazuje guard z auth-session.js,
//     který se řídil localStorage authToken – ten už neukládáme, viz SEC-7).
(function installApiFetchWrapper() {
    const MUTATING_METHODS = [
        'POST',
        'PUT',
        'PATCH',
        'DELETE'
    ];
    // Login vrací 401 při špatných údajích – to není expirovaná session.
    const AUTH_PASSTHROUGH = [
        '/api/auth/login'
    ];
    // Vrátí pathname, pokud jde o volání našeho API (relativní /api/... nebo
    // absolutní localhost API v dev). Externí URL (např. Vercel Blob upload)
    // vrací null – tam CSRF hlavičku ani credentials přidávat nesmíme.
    const LOCAL_HOSTS = [
        'localhost',
        '127.0.0.1'
    ];
    const getApiPathname = (input)=>{
        try {
            const raw = typeof input === 'string' ? input : input && input.url || '';
            const parsed = new URL(raw, window.location.href);
            if (!parsed.pathname.startsWith('/api/')) return null;
            const isOurHost = parsed.origin === window.location.origin || LOCAL_HOSTS.includes(window.location.hostname) && LOCAL_HOSTS.includes(parsed.hostname);
            return isOurHost ? parsed.pathname : null;
        } catch  {
            return null;
        }
    };
    const readCookie = (name)=>{
        const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    };
    const hasStoredUser = ()=>Boolean(localStorage.getItem('currentUser'));
    const originalFetch = window.fetch.bind(window);
    window.fetch = async function csrfFetch(input, init) {
        const apiPath = getApiPathname(input);
        let options = init;
        if (apiPath) {
            options = {
                ...init || {}
            };
            if (options.credentials === undefined) options.credentials = 'include';
            const method = String(options.method || typeof input !== 'string' && input && input.method || 'GET').toUpperCase();
            if (MUTATING_METHODS.includes(method)) {
                const token = readCookie('csrfToken');
                if (token) {
                    const headers = new Headers(options.headers || typeof input !== 'string' && input && input.headers || undefined);
                    if (!headers.has('X-CSRF-Token')) headers.set('X-CSRF-Token', token);
                    options.headers = headers;
                }
            }
        }
        const response = await originalFetch(input, options);
        try {
            if (response.status === 401 && apiPath && !AUTH_PASSTHROUGH.some((p)=>apiPath.startsWith(p)) && hasStoredUser()) window.dispatchEvent(new CustomEvent('auth:session-expired', {
                detail: {
                    reason: 'api-401'
                }
            }));
        } catch  {
        // Interceptor nikdy nesmí shodit původní fetch.
        }
        return response;
    };
    // files-manager.js používá XMLHttpRequest pro upload s progress barem –
    // i ten musí posílat CSRF hlavičku, jinak by mutace dostala 403.
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url, ...rest) {
        this.__csrfMethod = String(method || 'GET').toUpperCase();
        this.__csrfApiPath = getApiPathname(url);
        return originalOpen.call(this, method, url, ...rest);
    };
    XMLHttpRequest.prototype.send = function(...args) {
        if (this.__csrfApiPath && MUTATING_METHODS.includes(this.__csrfMethod)) {
            const token = readCookie('csrfToken');
            if (token) try {
                this.setRequestHeader('X-CSRF-Token', token);
            } catch  {
            // hlavičku nelze nastavit (špatný stav XHR) – necháme request projít
            }
        }
        return originalSend.apply(this, args);
    };
})();
// Debug logging only in development (MUSÍ být na začátku!)
const $b3f0fcd8809f5ac4$var$isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const $b3f0fcd8809f5ac4$var$debugLog = (...args)=>{
    if ($b3f0fcd8809f5ac4$var$isDev) console.log(...args);
};
// Globální flag pro detekci veřejné nabídky
window.isPublicOfferView = false;
window.publicOfferToken = null;
// Globální flag pro detekci veřejných souborů
window.isPublicFilesView = false;
window.publicFilesToken = null;
/** Skryje sidebar, mobilní menu a další admin chrome na veřejných odkazech. */ function $b3f0fcd8809f5ac4$var$setupPublicViewChrome() {
    document.body.classList.add('public-view');
    document.getElementById('auth-gate')?.remove();
    const sidebar = document.getElementById('app-sidebar');
    if (sidebar) {
        sidebar.classList.add('hidden');
        sidebar.classList.remove('lg:flex');
    }
    [
        'mobile-menu',
        'mobile-menu-backdrop'
    ].forEach((id)=>{
        document.getElementById(id)?.classList.add('hidden');
    });
    const header = document.querySelector('header.app-bar-mobile');
    const footer = document.querySelector('footer.main-footer');
    const main = document.querySelector('main');
    if (header) header.style.display = 'none';
    if (footer) footer.style.display = 'none';
    if (main) {
        main.classList.remove('hidden');
        main.style.minHeight = '100vh';
        if (window.isPublicOfferView) {
            main.style.display = 'block';
            main.style.padding = '1.5rem 1rem';
        } else {
            main.style.display = 'block';
            main.style.padding = '0';
        }
    }
}
// Zkontrolovat URL routing ještě před DOMContentLoaded
const $b3f0fcd8809f5ac4$var$currentPath = window.location.pathname;
const $b3f0fcd8809f5ac4$var$publicOfferMatch = $b3f0fcd8809f5ac4$var$currentPath.match(/^\/public-offer\/([a-zA-Z0-9]+)$/);
if ($b3f0fcd8809f5ac4$var$publicOfferMatch) {
    window.isPublicOfferView = true;
    window.publicOfferToken = $b3f0fcd8809f5ac4$var$publicOfferMatch[1];
    $b3f0fcd8809f5ac4$var$debugLog("Detekov\xe1na ve\u0159ejn\xe1 nab\xeddka s tokenem:", window.publicOfferToken);
}
// Liberální regex – token validuje až backend, frontend jen rozezná routu
const $b3f0fcd8809f5ac4$var$publicFilesMatch = $b3f0fcd8809f5ac4$var$currentPath.match(/^\/public-files\/([^/]+)\/?$/);
if ($b3f0fcd8809f5ac4$var$publicFilesMatch) {
    window.isPublicFilesView = true;
    window.publicFilesToken = $b3f0fcd8809f5ac4$var$publicFilesMatch[1];
    $b3f0fcd8809f5ac4$var$debugLog("Detekov\xe1na ve\u0159ejn\xe1 str\xe1nka soubor\u016F s tokenem:", window.publicFilesToken);
}
// Společný flag – jakýkoliv veřejný read-only pohled bez auth
window.isPublicView = ()=>window.isPublicOfferView || window.isPublicFilesView;
// Flag: aplikace je "odemčená" (session ověřena / login úspěšný) a data načtena.
// Dokud je false, přeskakují se API-závislé akce (pocitej apod.), aby
// nepřihlášený klient nestřílel 401 do chráněných endpointů.
window.__appReady = false;
// Inicializace layoutu po načtení DOM
document.addEventListener('DOMContentLoaded', async ()=>{
    // Veřejné stránky (/public-offer/*, /public-files/*) – jen obsah nabídky/souborů, bez admin UI
    if (window.isPublicOfferView || window.isPublicFilesView) {
        $b3f0fcd8809f5ac4$var$setupPublicViewChrome();
        return;
    }
    // Normální inicializace pro přihlášené uživatele
    // Nastavit fallback texty do info-boxů před načtením z API
    const materialsLastSavedElement = document.getElementById('materials-last-saved-info');
    const settingsLastSavedElement = document.getElementById('settings-last-saved-info');
    if (materialsLastSavedElement && !materialsLastSavedElement.textContent.trim()) materialsLastSavedElement.textContent = "(na\u010D\xedt\xe1m z API...)";
    if (settingsLastSavedElement && !settingsLastSavedElement.textContent.trim()) settingsLastSavedElement.textContent = "(na\u010D\xedt\xe1m z API...)";
    // POZOR: MaterialsAdmin + loadMaterialsToForm() + loadSettings() se spouští
    // až po ověření session / úspěšném loginu (viz bootAuthenticatedApp),
    // protože GET /api/materials i GET /api/settings vyžadují přihlášení.
    // Inicializovat podmíněné skrývání inputů
    $b3f0fcd8809f5ac4$var$setupConditionalInputs();
});
// Konfigurace API
const $b3f0fcd8809f5ac4$var$API_BASE_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:1234/api' : '/api';
// Globální pojistka: zachyť 403 PASSWORD_CHANGE_REQUIRED z jakéhokoli /api/* volání
// a vyvolej event, na který reaguje AuthManager (forced password change modal).
// Řešíme to ve vrstvě app.js (nedotýkáme se auth-session.js). Response klonujeme,
// abychom nezkonzumovali tělo volajícímu.
(function installPasswordChangeGuard() {
    const isApi = (input)=>{
        try {
            const u = typeof input === 'string' ? input : input && input.url || '';
            if (u.startsWith('/api/')) return true;
            return new URL(u, window.location.href).pathname.startsWith('/api/');
        } catch  {
            return false;
        }
    };
    const originalFetch = window.fetch.bind(window);
    window.fetch = async function passwordGuardFetch(input, init) {
        const response = await originalFetch(input, init);
        try {
            if (response.status === 403 && isApi(input)) {
                const clone = response.clone();
                clone.json().then((data)=>{
                    if (data && data.code === 'PASSWORD_CHANGE_REQUIRED') window.dispatchEvent(new CustomEvent('auth:password-change-required'));
                }).catch(()=>{});
            }
        } catch  {
        // Interceptor nikdy nesmí shodit původní fetch.
        }
        return response;
    };
})();
// Authentication System
class $b3f0fcd8809f5ac4$var$AuthManager {
    constructor(){
        this.currentUser = null;
        this.init();
    }
    init() {
        // Veřejné stránky (/public-offer/*, /public-files/*) nemají auth gate
        // ani auth API volání – gate odstraňuje DOMContentLoaded handler výše.
        if (window.isPublicView()) return;
        // Migrace ze starého auth režimu: legacy Bearer token nesmí přebíjet
        // cookie-based session na některých API voláních.
        localStorage.removeItem('authToken');
        // Přidej event listenery
        this.setupEventListeners();
        // Auth gate bootstrap: setup wizard / ověření session / login formulář
        this.bootstrapGate();
        // Heartbeat: periodické ověření session přes cookie. Původní heartbeat
        // v auth-session.js se řídil localStorage authToken, který už neukládáme
        // (SEC-7), proto expiraci session hlídáme zde. Při 401 vyvolá centrální
        // fetch wrapper event 'auth:session-expired'.
        setInterval(()=>{
            if (this.isLoggedIn()) this.verifySession();
        }, 300000);
        document.addEventListener('visibilitychange', ()=>{
            if (document.visibilityState === 'visible' && this.isLoggedIn()) this.verifySession();
        });
    }
    // Bootstrap auth gate: rozhodne mezi setup wizardem, přihlášenou aplikací
    // a login formulářem. Gate (#auth-gate) je v HTML viditelný od prvního
    // renderu, obsah aplikace (header/main/footer) je skrytý třídou 'hidden'.
    async bootstrapGate() {
        // 1) First-run setup: pokud aplikace nemá žádný účet, zobraz wizard
        try {
            const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/auth/setup-status`);
            const data = await response.json();
            if (response.ok && data?.data?.setupRequired === true) {
                this.showGateLogin();
                this.showSetupModal();
                return;
            }
        } catch (error) {
            $b3f0fcd8809f5ac4$var$debugLog("Nepoda\u0159ilo se ov\u011B\u0159it setup-status:", error);
        // Pokračujeme na ověření session – při výpadku backendu skončí na loginu
        }
        // 2) Ověření session přes httpOnly cookie
        const sessionUser = await this.fetchSessionUser();
        if (sessionUser) {
            // Session platí – obnov UI data (localStorage má víc detailů než /auth/check)
            let storedUser = null;
            try {
                storedUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
            } catch  {
                storedUser = null;
            }
            this.currentUser = storedUser || sessionUser;
            localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
            this.unlockApp();
            if (this.currentUser.mustChangePassword === true) this.showForcePasswordModal();
        } else {
            // Session neplatí – ukliď zbytky a nech uživatele na login gate
            this.currentUser = null;
            localStorage.removeItem('currentUser');
            this.showGateLogin();
        }
    }
    // GET /auth/check – vrátí objekt uživatele při platné session, jinak null.
    // Vedlejší efekt: requireAuth na backendu nastaví/obnoví csrf cookie.
    async fetchSessionUser() {
        try {
            const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/auth/check`, {
                method: 'GET',
                credentials: 'include'
            });
            if (!response.ok) return null;
            const data = await response.json().catch(()=>null);
            return data?.data?.user || null;
        } catch  {
            // Síťová chyba – chovej se jako nepřihlášený (uživatel se může přihlásit)
            return null;
        }
    }
    // Skryje gate, zobrazí aplikaci a spustí načtení dat závislých na API
    // (materials, settings vyžadují přihlášení). Spouští se jen jednou.
    unlockApp() {
        if (window.__appReady) return;
        window.__appReady = true;
        document.querySelector('header')?.classList.remove('hidden');
        document.querySelector('main')?.classList.remove('hidden');
        document.querySelector('footer')?.classList.remove('hidden');
        document.getElementById('app-sidebar')?.classList.remove('hidden');
        document.getElementById('auth-gate')?.remove();
        this.updateUI();
        // Kalkulátor je výchozí landing sekce po přihlášení / obnově session.
        if (typeof $b3f0fcd8809f5ac4$var$sectionManager !== 'undefined' && $b3f0fcd8809f5ac4$var$sectionManager) $b3f0fcd8809f5ac4$var$sectionManager.switchToSection('kalkulator');
        // Teprve teď volej chráněné API – materiály, nastavení, první kalkulace
        try {
            if (!window.materialsAdmin) window.materialsAdmin = new (0, $167d902a780ac256$export$bd69549a0ec80b2c)();
        } catch (error) {
            console.error("Chyba p\u0159i inicializaci MaterialsAdmin:", error);
        }
        Promise.allSettled([
            $b3f0fcd8809f5ac4$var$loadMaterialsToForm(),
            $b3f0fcd8809f5ac4$var$loadSettings()
        ]).then(()=>{
            if (typeof $b3f0fcd8809f5ac4$var$sectionManager !== 'undefined' && $b3f0fcd8809f5ac4$var$sectionManager?.currentSection === 'kalkulator') $b3f0fcd8809f5ac4$var$pocitej();
        });
        // AI asistent – inicializace chatu až po přihlášení (endpointy vyžadují auth).
        try {
            (0, $af6746371a9d639a$export$9213dfffdee66e5a)();
        } catch (e) {
            console.error('AI asistent init:', e);
        }
    }
    // Přepne gate ze stavu "ověřuji" na login formulář
    showGateLogin() {
        const gate = document.getElementById('auth-gate');
        if (!gate) return;
        document.getElementById('gate-loading')?.classList.add('hidden');
        document.getElementById('gate-login-card')?.classList.remove('hidden');
        setTimeout(()=>document.getElementById('gate-username')?.focus(), 50);
    }
    showSetupModal() {
        const modal = document.getElementById('setupModal');
        if (!modal) return;
        modal.classList.remove('hidden');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden');
        setTimeout(()=>document.getElementById('setupUsername')?.focus(), 50);
    }
    hideSetupModal() {
        const modal = document.getElementById('setupModal');
        if (!modal) return;
        modal.classList.add('hidden');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');
    }
    async handleSetup(e) {
        e.preventDefault();
        const errorBox = document.getElementById('setupError');
        const submitBtn = document.getElementById('setupSubmitBtn');
        const showSetupError = (msg)=>{
            if (errorBox) {
                errorBox.textContent = msg;
                errorBox.classList.remove('hidden');
            }
        };
        if (errorBox) errorBox.classList.add('hidden');
        const username = document.getElementById('setupUsername').value.trim();
        const name = document.getElementById('setupName').value.trim();
        const email = document.getElementById('setupEmail').value.trim();
        const phone = document.getElementById('setupPhone').value.trim();
        const password = document.getElementById('setupPassword').value;
        const passwordConfirm = document.getElementById('setupPasswordConfirm').value;
        const pwdError = $b3f0fcd8809f5ac4$var$validatePasswordStrength(password);
        if (pwdError) {
            showSetupError(pwdError);
            return;
        }
        if (password !== passwordConfirm) {
            showSetupError("Hesla se neshoduj\xed.");
            return;
        }
        submitBtn?.setAttribute('disabled', 'true');
        try {
            const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/auth/setup`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    username: username,
                    name: name,
                    password: password,
                    email: email,
                    phone: phone
                })
            });
            const data = await response.json();
            if (response.ok) {
                this.hideSetupModal();
                const form = document.getElementById('setupForm');
                if (form) form.reset();
                $b3f0fcd8809f5ac4$var$showNotification("Administr\xe1tor vytvo\u0159en, p\u0159ihlaste se", 'success');
                // Po setupu zůstává viditelný auth gate s login formulářem
                this.showGateLogin();
                const gateUsername = document.getElementById('gate-username');
                if (gateUsername) gateUsername.value = username;
                setTimeout(()=>document.getElementById('gate-password')?.focus(), 50);
            } else showSetupError(data.message || "Nepoda\u0159ilo se vytvo\u0159it administr\xe1tora");
        } catch (error) {
            console.error('Setup error:', error);
            showSetupError("Chyba spojen\xed se serverem");
        } finally{
            submitBtn?.removeAttribute('disabled');
        }
    }
    // Vynucená změna hesla (mustChangePassword nebo 403 PASSWORD_CHANGE_REQUIRED)
    showForcePasswordModal() {
        const modal = document.getElementById('forcePasswordModal');
        if (!modal) return;
        if (!modal.classList.contains('hidden')) return; // už je vidět
        const errorBox = document.getElementById('forcePasswordError');
        if (errorBox) errorBox.classList.add('hidden');
        const form = document.getElementById('forcePasswordForm');
        if (form) form.reset();
        modal.classList.remove('hidden');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden');
        setTimeout(()=>document.getElementById('forceOldPassword')?.focus(), 50);
    }
    hideForcePasswordModal() {
        const modal = document.getElementById('forcePasswordModal');
        if (!modal) return;
        modal.classList.add('hidden');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');
    }
    async handleForcePasswordChange(e) {
        e.preventDefault();
        const errorBox = document.getElementById('forcePasswordError');
        const submitBtn = document.getElementById('forcePasswordSubmitBtn');
        const showError = (msg)=>{
            if (errorBox) {
                errorBox.textContent = msg;
                errorBox.classList.remove('hidden');
            }
        };
        if (errorBox) errorBox.classList.add('hidden');
        const oldPassword = document.getElementById('forceOldPassword').value;
        const newPassword = document.getElementById('forceNewPassword').value;
        const confirmPassword = document.getElementById('forceConfirmPassword').value;
        if (!oldPassword) {
            showError("Zadejte sv\xe9 do\u010Dasn\xe9 heslo.");
            return;
        }
        const pwdError = $b3f0fcd8809f5ac4$var$validatePasswordStrength(newPassword);
        if (pwdError) {
            showError(pwdError);
            return;
        }
        if (newPassword !== confirmPassword) {
            showError("Nov\xe1 hesla se neshoduj\xed.");
            return;
        }
        submitBtn?.setAttribute('disabled', 'true');
        try {
            const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/user/password`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    ...this.getAuthHeaders()
                },
                credentials: 'include',
                body: JSON.stringify({
                    oldPassword: oldPassword,
                    newPassword: newPassword
                })
            });
            const data = await response.json();
            if (response.ok) {
                // Aktualizuj příznak na uživateli
                if (this.currentUser) {
                    this.currentUser.mustChangePassword = false;
                    localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
                }
                this.hideForcePasswordModal();
                $b3f0fcd8809f5ac4$var$showNotification("Heslo bylo \xfasp\u011B\u0161n\u011B zm\u011Bn\u011Bno", 'success');
            } else showError(data.message || "Chyba p\u0159i zm\u011Bn\u011B hesla");
        } catch (error) {
            console.error('Force password change error:', error);
            showError("Chyba spojen\xed se serverem");
        } finally{
            submitBtn?.removeAttribute('disabled');
        }
    }
    setupEventListeners() {
        // Login form submit (full-screen auth gate)
        const gateLoginForm = document.getElementById('gate-login-form');
        if (gateLoginForm) gateLoginForm.addEventListener('submit', (e)=>this.handleLogin(e));
        // Logout event listeners - desktop, mobile and dropdown
        document.addEventListener('click', (e)=>{
            if (!e.target || typeof e.target.closest !== 'function') return;
            if (e.target.closest('#logout-btn, #logout-btn-mobile')) {
                $b3f0fcd8809f5ac4$var$debugLog("Logout tla\u010D\xedtko kliknuto");
                this.handleLogout();
                return;
            }
            // Profile settings button listeners
            if (e.target.closest('#profile-settings-btn, #profile-settings-btn-mobile')) {
                $b3f0fcd8809f5ac4$var$debugLog("Nastaven\xed profilu tla\u010D\xedtko kliknuto");
                this.showProfileSettings();
            }
        });
        // Session expired – posloucháme event ze SessionGuard.
        // Během bootstrapu gate (aplikace ještě není odemčená) event ignorujeme:
        // 401 z /auth/check při neplatné session řeší bootstrapGate zobrazením loginu.
        window.addEventListener('auth:session-expired', ()=>{
            if (!window.__appReady) return;
            this.showSessionExpiredModal();
        });
        // Session expired modal: form submit + logout button
        const sessionForm = document.getElementById('sessionExpiredForm');
        if (sessionForm) sessionForm.addEventListener('submit', (e)=>this.handleSessionRelogin(e));
        const sessionLogoutBtn = document.getElementById('sessionExpiredLogoutBtn');
        if (sessionLogoutBtn) sessionLogoutBtn.addEventListener('click', ()=>{
            this.hideSessionExpiredModal();
            this.handleLogout();
        });
        // First-run setup wizard
        const setupForm = document.getElementById('setupForm');
        if (setupForm) setupForm.addEventListener('submit', (e)=>this.handleSetup(e));
        // Vynucená změna hesla
        const forcePasswordForm = document.getElementById('forcePasswordForm');
        if (forcePasswordForm) forcePasswordForm.addEventListener('submit', (e)=>this.handleForcePasswordChange(e));
        // Globální pojistka: pokud API vrátí 403 PASSWORD_CHANGE_REQUIRED, vyvolej modal
        window.addEventListener('auth:password-change-required', ()=>this.showForcePasswordModal());
    }
    async handleLogin(e) {
        e.preventDefault();
        const submitBtn = document.getElementById('gate-login-submit');
        const errorDiv = document.getElementById('gate-login-error');
        if (errorDiv) errorDiv.classList.add('hidden');
        const formData = new FormData(e.target);
        const credentials = {
            username: formData.get('username'),
            password: formData.get('password')
        };
        submitBtn?.setAttribute('disabled', 'true');
        try {
            const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify(credentials)
            });
            const data = await response.json().catch(()=>({}));
            if (response.ok) {
                // SEC-7: session token nese httpOnly cookie, do localStorage ukládáme
                // jen currentUser (UI data pro obnovu po reloadu, není to credential).
                localStorage.removeItem('authToken');
                localStorage.setItem('currentUser', JSON.stringify(data.data.user));
                this.currentUser = data.data.user;
                e.target.reset();
                // Ověř session přes cookie – zároveň tím backend nastaví csrf cookie
                // (nutné pro CSRF hlavičku u mutací, viz SEC-11).
                this.verifySession();
                // Skryj gate, zobraz aplikaci a spusť načtení dat (materials, settings)
                this.unlockApp();
                $b3f0fcd8809f5ac4$var$showNotification("\xdasp\u011B\u0161n\u011B p\u0159ihl\xe1\u0161en", 'success');
                // Vynucená změna hesla po prvním přihlášení (dočasné heslo)
                if (this.currentUser.mustChangePassword === true) this.showForcePasswordModal();
            } else {
                const fallback = response.status === 429 ? "P\u0159\xedli\u0161 mnoho pokus\u016F o p\u0159ihl\xe1\u0161en\xed, zkuste to pozd\u011Bji" : "Chyba p\u0159i p\u0159ihla\u0161ov\xe1n\xed";
                this.showLoginError(data.message || fallback);
            }
        } catch (error) {
            console.error('Login error:', error);
            this.showLoginError("Chyba spojen\xed se serverem");
        } finally{
            submitBtn?.removeAttribute('disabled');
        }
    }
    async handleLogout() {
        // Nejdřív vyčistíme stav, aby případné 401 z paralelních volání už SessionGuard nedetekoval
        this.currentUser = null;
        localStorage.removeItem('authToken');
        localStorage.removeItem('currentUser');
        try {
            await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/auth/logout`, {
                method: 'POST',
                credentials: 'include'
            });
        } catch (error) {
            console.error("Chyba p\u0159i odhla\u0161ov\xe1n\xed:", error);
        }
        // Reload spolehlivě vrátí auth gate: obsah aplikace je v HTML defaultně
        // skrytý a bootstrapGate po neplatné session zobrazí login formulář.
        window.location.reload();
    }
    showProfileSettings() {
        // Zavři dropdown menu
        this.closeUserDropdown();
        // Přepni na sekci profilu
        if ($b3f0fcd8809f5ac4$var$sectionManager) $b3f0fcd8809f5ac4$var$sectionManager.switchToSection('profil');
        // Načti a zobraz data profilu
        this.loadProfileData();
    }
    async loadProfileData() {
        try {
            const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/user/profile`, {
                method: 'GET',
                credentials: 'include'
            });
            const data = await response.json();
            if (response.ok) {
                // Naplň formulář daty
                document.getElementById('profile-username').value = data.data.username || '';
                document.getElementById('profile-role').value = data.data.role === 'admin' ? "Administr\xe1tor" : 'Sales';
                document.getElementById('profile-name').value = data.data.name || '';
                document.getElementById('profile-email').value = data.data.email || '';
                document.getElementById('profile-phone').value = data.data.phone || '';
                // Načti preference
                const showHourlyCalcCheckbox = document.getElementById('profile-show-hourly-calc');
                if (showHourlyCalcCheckbox) showHourlyCalcCheckbox.checked = data.data.showHourlyCalc || false;
            } else $b3f0fcd8809f5ac4$var$showNotification(data.message || "Chyba p\u0159i na\u010D\xedt\xe1n\xed profilu", 'error');
        } catch (error) {
            console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed profilu:", error);
            $b3f0fcd8809f5ac4$var$showNotification("Chyba spojen\xed se serverem", 'error');
        }
    }
    closeUserDropdown() {
        const dropdown = document.getElementById('user-dropdown-menu');
        if (dropdown) dropdown.classList.add('opacity-0', 'invisible', 'scale-95');
    }
    // Lehké ověření platnosti session přes httpOnly cookie.
    // Vedlejší efekt: requireAuth na backendu nastaví/obnoví csrf cookie,
    // takže následné mutace mohou poslat hlavičku X-CSRF-Token.
    async verifySession() {
        try {
            const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/auth/check`, {
                method: 'GET',
                credentials: 'include'
            });
            return response.ok;
        } catch  {
            // Síťová chyba není důvod uživatele odhlašovat
            return true;
        }
    }
    updateUI() {
        const userDropdown = document.getElementById('user-dropdown');
        const userInfoMobile = document.getElementById('user-info-mobile');
        const usernameDisplay = document.getElementById('username-display');
        const usernameDisplayMobile = document.getElementById('username-display-mobile');
        // Desktop menu items
        const nastaveniMenuItem = document.getElementById('nastaveni-menu-item');
        const nabidkyMenuItem = document.getElementById('nabidky-menu-item');
        const objednavkyMenuItem = document.getElementById('objednavky-menu-item');
        const vyrobaMenuItem = document.getElementById('vyroba-menu-item');
        const fakturyMenuItem = document.getElementById('faktury-menu-item');
        const zakazniciMenuItem = document.getElementById('zakaznici-menu-item');
        const souboryMenuItem = document.getElementById('soubory-menu-item');
        const papiryMenuItem = document.getElementById('papiry-menu-item');
        const uzivateleMenuItem = document.getElementById('uzivatele-menu-item');
        const aiMenuItem = document.getElementById('ai-asistent-menu-item');
        // Mobile menu items
        const nastaveniMenuItemMobile = document.getElementById('nastaveni-menu-item-mobile');
        const nabidkyMenuItemMobile = document.getElementById('nabidky-menu-item-mobile');
        const objednavkyMenuItemMobile = document.getElementById('objednavky-menu-item-mobile');
        const vyrobaMenuItemMobile = document.getElementById('vyroba-menu-item-mobile');
        const fakturyMenuItemMobile = document.getElementById('faktury-menu-item-mobile');
        const zakazniciMenuItemMobile = document.getElementById('zakaznici-menu-item-mobile');
        const souboryMenuItemMobile = document.getElementById('soubory-menu-item-mobile');
        const papiryMenuItemMobile = document.getElementById('papiry-menu-item-mobile');
        const uzivateleMenuItemMobile = document.getElementById('uzivatele-menu-item-mobile');
        const aiMenuItemMobile = document.getElementById('ai-asistent-menu-item-mobile');
        if (this.isLoggedIn()) {
            // Desktop UI
            userDropdown?.classList.remove('hidden');
            if (usernameDisplay) usernameDisplay.textContent = this.currentUser.username;
            // Mobile UI
            userInfoMobile?.classList.remove('hidden');
            if (usernameDisplayMobile) usernameDisplayMobile.textContent = this.currentUser.username;
            // Nastav vlastní dropdown funkcionalitu
            this.setupCustomDropdown();
            // Zobraz chráněné menu položky podle role - Desktop
            nabidkyMenuItem?.classList.remove('hidden');
            objednavkyMenuItem?.classList.remove('hidden');
            vyrobaMenuItem?.classList.remove('hidden');
            fakturyMenuItem?.classList.remove('hidden');
            zakazniciMenuItem?.classList.remove('hidden');
            souboryMenuItem?.classList.remove('hidden');
            papiryMenuItem?.classList.remove('hidden');
            aiMenuItem?.classList.remove('hidden');
            // Zobraz Nastavení pouze pro Administratory
            if (this.currentUser.role === 'admin') {
                nastaveniMenuItem?.classList.remove('hidden');
                uzivateleMenuItem?.classList.remove('hidden');
            } else {
                nastaveniMenuItem?.classList.add('hidden');
                uzivateleMenuItem?.classList.add('hidden');
            }
            // Zobraz chráněné menu položky podle role - Mobile
            nabidkyMenuItemMobile?.classList.remove('hidden');
            objednavkyMenuItemMobile?.classList.remove('hidden');
            vyrobaMenuItemMobile?.classList.remove('hidden');
            fakturyMenuItemMobile?.classList.remove('hidden');
            zakazniciMenuItemMobile?.classList.remove('hidden');
            souboryMenuItemMobile?.classList.remove('hidden');
            papiryMenuItemMobile?.classList.remove('hidden');
            aiMenuItemMobile?.classList.remove('hidden');
            // Zobraz Nastavení pouze pro Administratory (mobile)
            if (this.currentUser.role === 'admin') {
                nastaveniMenuItemMobile?.classList.remove('hidden');
                uzivateleMenuItemMobile?.classList.remove('hidden');
            } else {
                nastaveniMenuItemMobile?.classList.add('hidden');
                uzivateleMenuItemMobile?.classList.add('hidden');
            }
            // Přidat event listenery pro dropdown menu po přihlášení
            setTimeout(()=>{
                const settingsDropdownBtn = document.getElementById('settings-dropdown-btn');
                const materialsDropdownBtn = document.getElementById('materials-dropdown-btn');
                if (settingsDropdownBtn) settingsDropdownBtn.addEventListener('click', $b3f0fcd8809f5ac4$var$toggleSettingsDropdown);
                if (materialsDropdownBtn) materialsDropdownBtn.addEventListener('click', $b3f0fcd8809f5ac4$var$toggleMaterialsDropdown);
            }, 100);
        } else {
            // Desktop UI
            userDropdown?.classList.add('hidden');
            // Mobile UI
            userInfoMobile?.classList.add('hidden');
            // Skryj chráněné menu položky - Desktop
            nastaveniMenuItem?.classList.add('hidden');
            uzivateleMenuItem?.classList.add('hidden');
            nabidkyMenuItem?.classList.add('hidden');
            objednavkyMenuItem?.classList.add('hidden');
            vyrobaMenuItem?.classList.add('hidden');
            fakturyMenuItem?.classList.add('hidden');
            zakazniciMenuItem?.classList.add('hidden');
            souboryMenuItem?.classList.add('hidden');
            papiryMenuItem?.classList.add('hidden');
            aiMenuItem?.classList.add('hidden');
            // Skryj chráněné menu položky - Mobile
            nastaveniMenuItemMobile?.classList.add('hidden');
            uzivateleMenuItemMobile?.classList.add('hidden');
            nabidkyMenuItemMobile?.classList.add('hidden');
            objednavkyMenuItemMobile?.classList.add('hidden');
            vyrobaMenuItemMobile?.classList.add('hidden');
            fakturyMenuItemMobile?.classList.add('hidden');
            zakazniciMenuItemMobile?.classList.add('hidden');
            souboryMenuItemMobile?.classList.add('hidden');
            papiryMenuItemMobile?.classList.add('hidden');
            aiMenuItemMobile?.classList.add('hidden');
        }
    }
    setupCustomDropdown() {
        const dropdownBtn = document.getElementById('user-dropdown-btn');
        const dropdownMenu = document.getElementById('user-dropdown-menu');
        const userDropdown = document.getElementById('user-dropdown');
        const dropdownArrow = document.getElementById('user-dropdown-arrow');
        if (dropdownBtn && dropdownMenu && userDropdown) {
            // Odstran existující event listenery
            dropdownBtn.removeEventListener('click', this.toggleDropdown);
            // Přidej nový event listener
            this.toggleDropdown = (e)=>{
                e.stopPropagation();
                const isVisible = dropdownMenu.classList.contains('opacity-100');
                if (isVisible) {
                    // Zavři dropdown
                    dropdownMenu.classList.remove('opacity-100', 'visible', 'scale-100');
                    dropdownMenu.classList.add('opacity-0', 'invisible', 'scale-95');
                    if (dropdownArrow) dropdownArrow.classList.remove('rotate-180');
                } else {
                    // Otevři dropdown
                    dropdownMenu.classList.remove('opacity-0', 'invisible', 'scale-95');
                    dropdownMenu.classList.add('opacity-100', 'visible', 'scale-100');
                    if (dropdownArrow) dropdownArrow.classList.add('rotate-180');
                }
                $b3f0fcd8809f5ac4$var$debugLog('Dropdown toggle:', !isVisible);
            };
            dropdownBtn.addEventListener('click', this.toggleDropdown);
            // Zavři dropdown při kliknutí mimo
            document.addEventListener('click', (e)=>{
                if (!userDropdown.contains(e.target)) {
                    dropdownMenu.classList.remove('opacity-100', 'visible', 'scale-100');
                    dropdownMenu.classList.add('opacity-0', 'invisible', 'scale-95');
                    if (dropdownArrow) dropdownArrow.classList.remove('rotate-180');
                }
            });
            $b3f0fcd8809f5ac4$var$debugLog("Vlastn\xed dropdown nastaven");
        }
    }
    showLoginError(message) {
        const errorDiv = document.getElementById('gate-login-error');
        if (errorDiv) {
            errorDiv.textContent = message;
            errorDiv.classList.remove('hidden');
        }
    }
    showSessionExpiredModal() {
        const modal = document.getElementById('sessionExpiredModal');
        if (!modal) return;
        if (!modal.classList.contains('hidden')) return; // už je vidět
        // Předvyplň jméno z aktuálního uživatele (pokud máme)
        const usernameInput = document.getElementById('sessionExpiredUsername');
        const passwordInput = document.getElementById('sessionExpiredPassword');
        const errorBox = document.getElementById('sessionExpiredError');
        const username = this.currentUser?.username || (()=>{
            try {
                return JSON.parse(localStorage.getItem('currentUser') || '{}').username || '';
            } catch  {
                return '';
            }
        })();
        if (usernameInput) usernameInput.value = username;
        if (passwordInput) passwordInput.value = '';
        if (errorBox) {
            errorBox.classList.add('hidden');
            errorBox.textContent = '';
        }
        modal.classList.remove('hidden');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden');
        // Focus na heslo, aby šlo rovnou psát
        setTimeout(()=>passwordInput?.focus(), 50);
    }
    hideSessionExpiredModal() {
        const modal = document.getElementById('sessionExpiredModal');
        if (!modal) return;
        modal.classList.add('hidden');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');
    }
    async handleSessionRelogin(e) {
        e.preventDefault();
        const usernameInput = document.getElementById('sessionExpiredUsername');
        const passwordInput = document.getElementById('sessionExpiredPassword');
        const errorBox = document.getElementById('sessionExpiredError');
        const submitBtn = document.getElementById('sessionExpiredSubmitBtn');
        const spinner = document.getElementById('sessionExpiredSpinner');
        const username = usernameInput?.value?.trim();
        const password = passwordInput?.value || '';
        if (!username || !password) {
            if (errorBox) {
                errorBox.textContent = 'Zadejte heslo.';
                errorBox.classList.remove('hidden');
            }
            return;
        }
        submitBtn?.setAttribute('disabled', 'true');
        spinner?.classList.remove('hidden');
        if (errorBox) {
            errorBox.classList.add('hidden');
            errorBox.textContent = '';
        }
        try {
            const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    username: username,
                    password: password
                })
            });
            const data = await response.json();
            if (response.ok && data?.success && data?.data?.user) {
                // SEC-7: token neukládáme, auth nese httpOnly cookie
                localStorage.removeItem('authToken');
                localStorage.setItem('currentUser', JSON.stringify(data.data.user));
                this.currentUser = data.data.user;
                (0, $a97c5dcf4b2d6669$export$562fb1313e8722bf)();
                // Obnov csrf cookie pro mutační requesty (SEC-11)
                this.verifySession();
                this.hideSessionExpiredModal();
                this.updateUI();
                $b3f0fcd8809f5ac4$var$showNotification("P\u0159ihl\xe1\u0161en\xed obnoveno", 'success');
                if (this.currentUser && this.currentUser.mustChangePassword === true) this.showForcePasswordModal();
            } else {
                const msg = data?.message || "Nepoda\u0159ilo se p\u0159ihl\xe1sit";
                if (errorBox) {
                    errorBox.textContent = msg;
                    errorBox.classList.remove('hidden');
                }
                passwordInput?.focus();
                passwordInput?.select?.();
            }
        } catch (err) {
            console.error('Session relogin error:', err);
            if (errorBox) {
                errorBox.textContent = "Chyba spojen\xed se serverem";
                errorBox.classList.remove('hidden');
            }
        } finally{
            submitBtn?.removeAttribute('disabled');
            spinner?.classList.add('hidden');
        }
    }
    isLoggedIn() {
        return this.currentUser !== null;
    }
    getAuthHeaders() {
        // SEC-7: autentizaci nese httpOnly cookie (credentials: 'include' zajišťuje
        // centrální fetch wrapper), Bearer token z localStorage se už nepoužívá.
        return {};
    }
}
// Validace síly hesla – vrací chybovou hlášku (string) nebo null, pokud je heslo OK.
// Stejná pravidla jako v profilu: min 8 znaků, malé i velké písmeno, číslo, speciální znak.
function $b3f0fcd8809f5ac4$var$validatePasswordStrength(password) {
    if (!password || password.length < 8) return "Heslo mus\xed m\xedt alespo\u0148 8 znak\u016F";
    if (!/[a-z]/.test(password)) return "Heslo mus\xed obsahovat alespo\u0148 jedno mal\xe9 p\xedsmeno";
    if (!/[A-Z]/.test(password)) return "Heslo mus\xed obsahovat alespo\u0148 jedno velk\xe9 p\xedsmeno";
    if (!/[0-9]/.test(password)) return "Heslo mus\xed obsahovat alespo\u0148 jedno \u010D\xedslo";
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) return "Heslo mus\xed obsahovat alespo\u0148 jeden speci\xe1ln\xed znak (!@#$%^&* atd.)";
    return null;
}
// Funkce pro načítání materiálů z API do formuláře
async function $b3f0fcd8809f5ac4$var$loadMaterialsToForm() {
    try {
        const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/materials`);
        const result = await response.json();
        if (result.success) {
            // Nový formát dat s metadata wrapper
            const materials = result.data.materials;
            $b3f0fcd8809f5ac4$var$renderMaterialsToSelect(materials);
        } else console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed materi\xe1l\u016F:", result.error);
    } catch (error) {
        console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed materi\xe1l\u016F:", error);
    }
}
// Exportuji funkci globálně
window.loadMaterialsToForm = $b3f0fcd8809f5ac4$var$loadMaterialsToForm;
// Funkce pro zobrazení notifikace
function $b3f0fcd8809f5ac4$var$showNotification(message, type = 'success') {
    // Mapování typů na Tailwind třídy
    const typeClasses = {
        success: 'bg-green-50 text-green-800 border-green-200',
        error: 'bg-red-50 text-red-800 border-red-200',
        warning: 'bg-yellow-50 text-yellow-800 border-yellow-200',
        info: 'bg-blue-50 text-blue-800 border-blue-200'
    };
    // Vytvořím notifikaci
    const notification = document.createElement('div');
    notification.className = `fixed top-4 right-4 z-50 max-w-sm w-full ${typeClasses[type] || typeClasses.info} border rounded-lg shadow-lg p-4 transition-all duration-300 transform translate-x-0`;
    notification.innerHTML = `
    <div class="flex items-start">
      <div class="flex-1">
        <p class="text-sm font-medium">${message}</p>
      </div>
      <button type="button" onclick="this.parentElement.parentElement.remove()" class="ml-4 inline-flex text-gray-400 hover:text-gray-500 focus:outline-none">
        ${(0, $entK4.icon)('x-mark', 'h-5 w-5')}
      </button>
    </div>
  `;
    document.body.appendChild(notification);
    // Animace při zobrazení
    setTimeout(()=>{
        notification.classList.add('opacity-100');
    }, 10);
    // Automaticky odstraň po 3 sekundách
    setTimeout(()=>{
        notification.classList.add('opacity-0', 'translate-x-full');
        setTimeout(()=>{
            if (notification.parentNode) notification.parentNode.removeChild(notification);
        }, 300);
    }, 3000);
}
// Globální export
window.showNotification = $b3f0fcd8809f5ac4$var$showNotification;
// Funkce pro ukládání nastavení do API
async function $b3f0fcd8809f5ac4$var$saveSettings() {
    const settings = {
        // ============================================================
        // Firemní údaje (dodavatel) – sekce Nastavení → Firma.
        // Id inputů odpovídají klíčům, které čte isdocx-builder.js
        // (normalizeSupplier) a backend/pdf/renderer.js (buildSupplierFromSettings).
        // ============================================================
        companyName: $b3f0fcd8809f5ac4$var$getValue('#companyName', ''),
        ico: $b3f0fcd8809f5ac4$var$getValue('#ico', ''),
        dic: $b3f0fcd8809f5ac4$var$getValue('#dic', ''),
        street: $b3f0fcd8809f5ac4$var$getValue('#street', ''),
        buildingNumber: $b3f0fcd8809f5ac4$var$getValue('#buildingNumber', ''),
        city: $b3f0fcd8809f5ac4$var$getValue('#city', ''),
        postalZone: $b3f0fcd8809f5ac4$var$getValue('#postalZone', ''),
        countryCode: $b3f0fcd8809f5ac4$var$getValue('#countryCode', 'CZ'),
        bankAccount: $b3f0fcd8809f5ac4$var$getValue('#bankAccount', ''),
        bankCode: $b3f0fcd8809f5ac4$var$getValue('#bankCode', ''),
        iban: $b3f0fcd8809f5ac4$var$getValue('#iban', ''),
        swift: $b3f0fcd8809f5ac4$var$getValue('#swift', ''),
        bankName: $b3f0fcd8809f5ac4$var$getValue('#bankName', ''),
        registerRegister: $b3f0fcd8809f5ac4$var$getValue('#registerRegister', ''),
        registerNumber: $b3f0fcd8809f5ac4$var$getValue('#registerNumber', ''),
        companyPhone: $b3f0fcd8809f5ac4$var$getValue('#companyPhone', ''),
        companyEmail: $b3f0fcd8809f5ac4$var$getValue('#companyEmail', ''),
        companyWeb: $b3f0fcd8809f5ac4$var$getValue('#companyWeb', ''),
        // Základní nastavení
        koeficientCena: +$b3f0fcd8809f5ac4$var$getValue('#koeficientCena', 1.2),
        dph: +$b3f0fcd8809f5ac4$var$getValue('#dph', 1.21),
        // technologie - NEUKLÁDÁ SE DO CENTRÁLNÍHO NASTAVENÍ (je lokální v localStorage)
        obratka: $b3f0fcd8809f5ac4$var$getChecked('#obratka', true),
        // Okraje a rozměry
        okrajKolemProduktu: +$b3f0fcd8809f5ac4$var$getValue('#okrajKolemProduktu', 3),
        okrajKolemArchu: +$b3f0fcd8809f5ac4$var$getValue('#okrajKolemArchu', 7),
        horniOkraj: +$b3f0fcd8809f5ac4$var$getValue('#horniOkraj', 17),
        dolniOkraj: +$b3f0fcd8809f5ac4$var$getValue('#dolniOkraj', 15),
        pravyOkraj: +$b3f0fcd8809f5ac4$var$getValue('#pravyOkraj', 10),
        levyOkraj: +$b3f0fcd8809f5ac4$var$getValue('#levyOkraj', 10),
        okrajKolemArchuDigital: +$b3f0fcd8809f5ac4$var$getValue('#okrajKolemArchuDigital', 7),
        horniOkrajDigital: +$b3f0fcd8809f5ac4$var$getValue('#horniOkrajDigital', 0),
        dolniOkrajDigital: +$b3f0fcd8809f5ac4$var$getValue('#dolniOkrajDigital', 0),
        pravyOkrajDigital: +$b3f0fcd8809f5ac4$var$getValue('#pravyOkrajDigital', 0),
        levyOkrajDigital: +$b3f0fcd8809f5ac4$var$getValue('#levyOkrajDigital', 0),
        // Rozměry archů strojů (standardizované rozměry používaných papírů)
        ofsetRozmerSirka: +$b3f0fcd8809f5ac4$var$getValue('#ofsetRozmerSirka', 650),
        ofsetRozmerVyska: +$b3f0fcd8809f5ac4$var$getValue('#ofsetRozmerVyska', 480),
        digitalRozmerSirka: +$b3f0fcd8809f5ac4$var$getValue('#digitalRozmerSirka', 320),
        digitalRozmerVyska: +$b3f0fcd8809f5ac4$var$getValue('#digitalRozmerVyska', 450),
        // Ofset nastavení
        barvaCena: +$b3f0fcd8809f5ac4$var$getValue('#barvaCena', 500),
        mytiCena: +$b3f0fcd8809f5ac4$var$getValue('#mytiCena', 250),
        prujezdOfsetCena: +$b3f0fcd8809f5ac4$var$getValue('#prujezdOfsetCena', 0.25),
        obratkaCena: +$b3f0fcd8809f5ac4$var$getValue('#obratkaCena', 350),
        ofsetSoubehSleva: +$b3f0fcd8809f5ac4$var$getValue('#ofsetSoubehSleva', 0.8),
        // Digitál nastavení
        pripravaCernobile: +$b3f0fcd8809f5ac4$var$getValue('#pripravaCernobile', 200),
        pripravaBarva: +$b3f0fcd8809f5ac4$var$getValue('#pripravaBarva', 200),
        pripravaBarvaSpecial: +$b3f0fcd8809f5ac4$var$getValue('#pripravaBarvaSpecial', 0),
        prujezdDigiCenaDo750_44: +$b3f0fcd8809f5ac4$var$getValue('#prujezdDigiCenaDo750_44', 5.74),
        prujezdDigiCenaNad750_44: +$b3f0fcd8809f5ac4$var$getValue('#prujezdDigiCenaNad750_44', 3.3),
        prujezdDigiCenaDo750_40: +$b3f0fcd8809f5ac4$var$getValue('#prujezdDigiCenaDo750_40', 4.74),
        prujezdDigiCenaNad750_40: +$b3f0fcd8809f5ac4$var$getValue('#prujezdDigiCenaNad750_40', 2.3),
        prujezdDigiCenaDo750_11: +$b3f0fcd8809f5ac4$var$getValue('#prujezdDigiCenaDo750_11', 2.28),
        prujezdDigiCenaNad750_11: +$b3f0fcd8809f5ac4$var$getValue('#prujezdDigiCenaNad750_11', 1.28),
        prujezdDigiCenaDo750_10: +$b3f0fcd8809f5ac4$var$getValue('#prujezdDigiCenaDo750_10', 1.96),
        prujezdDigiCenaNad750_10: +$b3f0fcd8809f5ac4$var$getValue('#prujezdDigiCenaNad750_10', 0.96),
        barvySpecialLak50: +$b3f0fcd8809f5ac4$var$getValue('#barvySpecialLak50', 4),
        barvySpecialLak100: +$b3f0fcd8809f5ac4$var$getValue('#barvySpecialLak100', 8),
        barvySpecialBila50: +$b3f0fcd8809f5ac4$var$getValue('#barvySpecialBila50', 6),
        barvySpecialBila100: +$b3f0fcd8809f5ac4$var$getValue('#barvySpecialBila100', 12),
        barvySpecialZlata50: +$b3f0fcd8809f5ac4$var$getValue('#barvySpecialZlata50', 6),
        barvySpecialZlata100: +$b3f0fcd8809f5ac4$var$getValue('#barvySpecialZlata100', 12),
        // Laminace
        laminaceCenaMinimum: +$b3f0fcd8809f5ac4$var$getValue('#laminaceCenaMinimum', 200),
        laminaceLeskPrujezd10: +$b3f0fcd8809f5ac4$var$getValue('#laminaceLeskPrujezd10', 2.5),
        laminaceLeskPrujezd11: +$b3f0fcd8809f5ac4$var$getValue('#laminaceLeskPrujezd11', 5),
        laminaceMatPrujezd10: +$b3f0fcd8809f5ac4$var$getValue('#laminaceMatPrujezd10', 3.5),
        laminaceMatPrujezd11: +$b3f0fcd8809f5ac4$var$getValue('#laminaceMatPrujezd11', 7),
        laminaceStrukturaPrujezd10: +$b3f0fcd8809f5ac4$var$getValue('#laminaceStrukturaPrujezd10', 7.5),
        laminaceStrukturaPrujezd11: +$b3f0fcd8809f5ac4$var$getValue('#laminaceStrukturaPrujezd11', 15),
        laminaceSametPrujezd10: +$b3f0fcd8809f5ac4$var$getValue('#laminaceSametPrujezd10', 7.5),
        laminaceSametPrujezd11: +$b3f0fcd8809f5ac4$var$getValue('#laminaceSametPrujezd11', 15),
        laminaceLeskPrujezd10Digital: +$b3f0fcd8809f5ac4$var$getValue('#laminaceLeskPrujezd10Digital', 1.25),
        laminaceLeskPrujezd11Digital: +$b3f0fcd8809f5ac4$var$getValue('#laminaceLeskPrujezd11Digital', 2.5),
        laminaceMatPrujezd10Digital: +$b3f0fcd8809f5ac4$var$getValue('#laminaceMatPrujezd10Digital', 1.75),
        laminaceMatPrujezd11Digital: +$b3f0fcd8809f5ac4$var$getValue('#laminaceMatPrujezd11Digital', 3.5),
        laminaceStrukturaPrujezd10Digital: +$b3f0fcd8809f5ac4$var$getValue('#laminaceStrukturaPrujezd10Digital', 3.75),
        laminaceStrukturaPrujezd11Digital: +$b3f0fcd8809f5ac4$var$getValue('#laminaceStrukturaPrujezd11Digital', 7.5),
        laminaceSametPrujezd10Digital: +$b3f0fcd8809f5ac4$var$getValue('#laminaceSametPrujezd10Digital', 3.75),
        laminaceSametPrujezd11Digital: +$b3f0fcd8809f5ac4$var$getValue('#laminaceSametPrujezd11Digital', 7.5),
        laminaceKapsovaPriprava: +$b3f0fcd8809f5ac4$var$getValue('#laminaceKapsovaPriprava', 100),
        laminaceKapsovaA5: +$b3f0fcd8809f5ac4$var$getValue('#laminaceKapsovaA5', 12),
        laminaceKapsovaA4: +$b3f0fcd8809f5ac4$var$getValue('#laminaceKapsovaA4', 23),
        laminaceKapsovaA3: +$b3f0fcd8809f5ac4$var$getValue('#laminaceKapsovaA3', 33),
        // Lakování
        lakParcialPriprava10: +$b3f0fcd8809f5ac4$var$getValue('#lakParcialPriprava10', 1700),
        lakParcialPriprava11: +$b3f0fcd8809f5ac4$var$getValue('#lakParcialPriprava11', 3400),
        lakParcialPrujezd10: +$b3f0fcd8809f5ac4$var$getValue('#lakParcialPrujezd10', 2.5),
        lakParcialPrujezd11: +$b3f0fcd8809f5ac4$var$getValue('#lakParcialPrujezd11', 5),
        lakPlochaPriprava10: +$b3f0fcd8809f5ac4$var$getValue('#lakPlochaPriprava10', 1300),
        lakPlochaPriprava11: +$b3f0fcd8809f5ac4$var$getValue('#lakPlochaPriprava11', 1300),
        lakPlochaPrujezd10: +$b3f0fcd8809f5ac4$var$getValue('#lakPlochaPrujezd10', 2.5),
        lakPlochaPrujezd11: +$b3f0fcd8809f5ac4$var$getValue('#lakPlochaPrujezd11', 5),
        lakStrojPriprava10: +$b3f0fcd8809f5ac4$var$getValue('#lakStrojPriprava10', 250),
        lakStrojPriprava11: +$b3f0fcd8809f5ac4$var$getValue('#lakStrojPriprava11', 250),
        lakStrojPrujezd10: +$b3f0fcd8809f5ac4$var$getValue('#lakStrojPrujezd10', 0.2),
        lakStrojPrujezd11: +$b3f0fcd8809f5ac4$var$getValue('#lakStrojPrujezd11', 0.4),
        // Výsek / předsek / ražba / perforace / lepení
        vysekPriprava: +$b3f0fcd8809f5ac4$var$getValue('#vysekPriprava', 700),
        vysekCena: +$b3f0fcd8809f5ac4$var$getValue('#vysekCena', 500),
        vysekRozmeryMinX: +$b3f0fcd8809f5ac4$var$getValue('#vysekRozmeryMinX', 0),
        vysekRozmeryMinY: +$b3f0fcd8809f5ac4$var$getValue('#vysekRozmeryMinY', 0),
        vysekRozmeryMaxX: +$b3f0fcd8809f5ac4$var$getValue('#vysekRozmeryMaxX', 500),
        vysekRozmeryMaxY: +$b3f0fcd8809f5ac4$var$getValue('#vysekRozmeryMaxY', 700),
        predsekPriprava: +$b3f0fcd8809f5ac4$var$getValue('#predsekPriprava', 700),
        predsekCena: +$b3f0fcd8809f5ac4$var$getValue('#predsekCena', 500),
        predsekRozmeryMinX: +$b3f0fcd8809f5ac4$var$getValue('#predsekRozmeryMinX', 0),
        predsekRozmeryMinY: +$b3f0fcd8809f5ac4$var$getValue('#predsekRozmeryMinY', 0),
        predsekRozmeryMaxX: +$b3f0fcd8809f5ac4$var$getValue('#predsekRozmeryMaxX', 500),
        predsekRozmeryMaxY: +$b3f0fcd8809f5ac4$var$getValue('#predsekRozmeryMaxY', 700),
        razbaPriprava: +$b3f0fcd8809f5ac4$var$getValue('#razbaPriprava', 1000),
        razbaCena: +$b3f0fcd8809f5ac4$var$getValue('#razbaCena', 800),
        razbaRozmeryMinX: +$b3f0fcd8809f5ac4$var$getValue('#razbaRozmeryMinX', 0),
        razbaRozmeryMinY: +$b3f0fcd8809f5ac4$var$getValue('#razbaRozmeryMinY', 0),
        razbaRozmeryMaxX: +$b3f0fcd8809f5ac4$var$getValue('#razbaRozmeryMaxX', 350),
        razbaRozmeryMaxY: +$b3f0fcd8809f5ac4$var$getValue('#razbaRozmeryMaxY', 500),
        perforacePriprava: +$b3f0fcd8809f5ac4$var$getValue('#perforacePriprava', 100),
        perforaceCenaZaKus: +$b3f0fcd8809f5ac4$var$getValue('#perforaceCenaZaKus', 0.1),
        cenaZaLepeniKrabicka: +$b3f0fcd8809f5ac4$var$getValue('#cenaZaLepeniKrabicka', 2),
        lepeniKrabickaPriprava: +$b3f0fcd8809f5ac4$var$getValue('#lepeniKrabickaPriprava', 200),
        // Rozměrové limity falcování / bigování
        falcovaniRozmeryMinX: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniRozmeryMinX', 148),
        falcovaniRozmeryMinY: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniRozmeryMinY', 40),
        falcovaniRozmeryMaxZ: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniRozmeryMaxZ', 353),
        falcovaniRozmeryMaxY: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniRozmeryMaxY', 500),
        bigovaniRozmeryMinX: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniRozmeryMinX', 148),
        bigovaniRozmeryMinY: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniRozmeryMinY', 40),
        bigovaniRozmeryMaxX: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniRozmeryMaxX', 353),
        bigovaniRozmeryMaxY: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniRozmeryMaxY', 500),
        // Doprava
        dopravaOsobni: +$b3f0fcd8809f5ac4$var$getValue('#dopravaOsobni', 0),
        dopravaDpd: +$b3f0fcd8809f5ac4$var$getValue('#dopravaDpd', 100),
        dopravaDpdDo1Kg: +$b3f0fcd8809f5ac4$var$getValue('#dopravaDpdDo1Kg', 133),
        dopravaDpdDo2Kg: +$b3f0fcd8809f5ac4$var$getValue('#dopravaDpdDo2Kg', 155),
        dopravaDpdDo3Kg: +$b3f0fcd8809f5ac4$var$getValue('#dopravaDpdDo3Kg', 157),
        dopravaDpdDo4Kg: +$b3f0fcd8809f5ac4$var$getValue('#dopravaDpdDo4Kg', 161),
        dopravaDpdDo5Kg: +$b3f0fcd8809f5ac4$var$getValue('#dopravaDpdDo5Kg', 163),
        dopravaDpdDo6Kg: +$b3f0fcd8809f5ac4$var$getValue('#dopravaDpdDo6Kg', 170),
        dopravaDpdDo7Kg: +$b3f0fcd8809f5ac4$var$getValue('#dopravaDpdDo7Kg', 178),
        dopravaTria: +$b3f0fcd8809f5ac4$var$getValue('#dopravaTria', 0),
        dopravaZdarmaOd: +$b3f0fcd8809f5ac4$var$getValue('#dopravaZdarmaOd', 3000),
        // Lepené bloky – geometrie přebalu
        blokPresahMin: +$b3f0fcd8809f5ac4$var$getValue('#blokPresahMin', 20),
        blokPresahMax: +$b3f0fcd8809f5ac4$var$getValue('#blokPresahMax', 40),
        blokTloustkaKoeficient: +$b3f0fcd8809f5ac4$var$getValue('#blokTloustkaKoeficient', 1.2),
        // Falcování – ceny podle typu lomu
        falcovaniHalfFoldPriprava: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniHalfFoldPriprava', 100),
        falcovaniHalfFoldCena: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniHalfFoldCena', 0.1),
        falcovaniCrossFoldPriprava: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniCrossFoldPriprava', 200),
        falcovaniCrossFoldCena: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniCrossFoldCena', 0.2),
        falcovaniUFoldPriprava: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniUFoldPriprava', 100),
        falcovaniUFoldCena: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniUFoldCena', 0.2),
        falcovaniZFoldPriprava: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniZFoldPriprava', 100),
        falcovaniZFoldCena: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniZFoldCena', 0.2),
        falcovaniDoubleHalfFoldPriprava: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniDoubleHalfFoldPriprava', 100),
        falcovaniDoubleHalfFoldCena: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniDoubleHalfFoldCena', 0.2),
        falcovaniRollFoldPriprava: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniRollFoldPriprava', 100),
        falcovaniRollFoldCena: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniRollFoldCena', 0.7),
        falcovaniHarmoniumFold3Priprava: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniHarmoniumFold3Priprava', 100),
        falcovaniHarmoniumFold3Cena: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniHarmoniumFold3Cena', 0.3),
        falcovaniHarmoniumFold4Priprava: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniHarmoniumFold4Priprava', 100),
        falcovaniHarmoniumFold4Cena: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniHarmoniumFold4Cena', 0.4),
        falcovaniHarmoniumFold5Priprava: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniHarmoniumFold5Priprava', 100),
        falcovaniHarmoniumFold5Cena: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniHarmoniumFold5Cena', 1),
        falcovaniGateFoldPriprava: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniGateFoldPriprava', 100),
        falcovaniGateFoldCena: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniGateFoldCena', 0.6),
        falcovaniDoubleGateFoldPriprava: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniDoubleGateFoldPriprava', 100),
        falcovaniDoubleGateFoldCena: +$b3f0fcd8809f5ac4$var$getValue('#falcovaniDoubleGateFoldCena', 0.7),
        // Bigování – ceny podle typu bigu
        bigovaniHalfFoldPriprava: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniHalfFoldPriprava', 100),
        bigovaniHalfFoldCena: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniHalfFoldCena', 0.4),
        bigovaniCrossFoldPriprava: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniCrossFoldPriprava', 100),
        bigovaniCrossFoldCena: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniCrossFoldCena', 0.8),
        bigovaniUFoldPriprava: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniUFoldPriprava', 100),
        bigovaniUFoldCena: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniUFoldCena', 0.8),
        bigovaniZFoldPriprava: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniZFoldPriprava', 100),
        bigovaniZFoldCena: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniZFoldCena', 0.8),
        bigovaniDoubleHalfFoldPriprava: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniDoubleHalfFoldPriprava', 100),
        bigovaniDoubleHalfFoldCena: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniDoubleHalfFoldCena', 1.2),
        bigovaniRollFoldPriprava: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniRollFoldPriprava', 100),
        bigovaniRollFoldCena: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniRollFoldCena', 1.2),
        bigovaniHarmoniumFold3Priprava: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniHarmoniumFold3Priprava', 100),
        bigovaniHarmoniumFold3Cena: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniHarmoniumFold3Cena', 1.2),
        bigovaniHarmoniumFold4Priprava: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniHarmoniumFold4Priprava', 100),
        bigovaniHarmoniumFold4Cena: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniHarmoniumFold4Cena', 1.6),
        bigovaniHarmoniumFold5Priprava: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniHarmoniumFold5Priprava', 100),
        bigovaniHarmoniumFold5Cena: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniHarmoniumFold5Cena', 1.6),
        bigovaniGateFoldPriprava: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniGateFoldPriprava', 100),
        bigovaniGateFoldCena: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniGateFoldCena', 0.8),
        bigovaniDoubleGateFoldPriprava: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniDoubleGateFoldPriprava', 100),
        bigovaniDoubleGateFoldCena: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniDoubleGateFoldCena', 1.2),
        bigovaniSpine4Priprava: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniSpine4Priprava', 100),
        bigovaniSpine4Cena: +$b3f0fcd8809f5ac4$var$getValue('#bigovaniSpine4Cena', 1.6),
        // Vazba - V1 šitá skobou
        vazbaV1StrojniPriprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV1StrojniPriprava', 200),
        vazbaV1StrojniCenaZaKus: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV1StrojniCenaZaKus', 0.6),
        vazbaV1RucniPriprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV1RucniPriprava', 100),
        vazbaV1RucniCenaZaKus: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV1RucniCenaZaKus', 1.6),
        vazbaV1RucniCenaZaStranu: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV1RucniCenaZaStranu', 0.3),
        // Vazba - Kroužková twin wire (cenové stupně podle rozměru)
        vazbaKrouzekBlokA7Priprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA7Priprava', 200),
        vazbaKrouzekBlokA7CenaZaKus: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA7CenaZaKus', 10.80),
        vazbaKrouzekBlokA6Priprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA6Priprava', 200),
        vazbaKrouzekBlokA6CenaZaKus: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA6CenaZaKus', 11.80),
        vazbaKrouzekBlokA5Priprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA5Priprava', 200),
        vazbaKrouzekBlokA5CenaZaKus: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA5CenaZaKus', 12.30),
        vazbaKrouzekBlokA4Priprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA4Priprava', 200),
        vazbaKrouzekBlokA4CenaZaKus: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA4CenaZaKus', 12.80),
        vazbaKrouzekBlokA3Priprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA3Priprava', 200),
        vazbaKrouzekBlokA3CenaZaKus: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA3CenaZaKus', 14.00),
        // Vazba - Kroužková s háčkem na pověšení
        vazbaKrouzekKalendarPriprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekKalendarPriprava', 200),
        vazbaKrouzekKalendarCenaZaKus: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekKalendarCenaZaKus', 14.00),
        // Vazba - V2 PUR (marginální ceník: sazba klesá kusStart → kusKonec)
        vazbaV2PurPriprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV2PurPriprava', 400),
        vazbaV2PurKusStart: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV2PurKusStart', 14),
        vazbaV2PurKusKonec: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV2PurKusKonec', 8),
        vazbaV2PurPrah: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV2PurPrah', 200),
        vazbaV2PurUtlum: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV2PurUtlum', 300),
        // ============================================================
        // HODINOVÁ KALKULACE (interní debug)
        // Poznámka: hourlyEnabled se UŽ NEUKLÁDÁ do globálních nastavení
        // Je to user-specific nastavení v session (viz profil uživatele)
        // ============================================================
        // Tiskové stroje
        hourlyOfsetCost: +$b3f0fcd8809f5ac4$var$getValue('#hourlyOfsetCost', 2500),
        hourlyOfsetSetup: +$b3f0fcd8809f5ac4$var$getValue('#hourlyOfsetSetup', 0.5),
        hourlyOfsetSpeed: +$b3f0fcd8809f5ac4$var$getValue('#hourlyOfsetSpeed', 8000),
        hourlyOfsetColorChange: +$b3f0fcd8809f5ac4$var$getValue('#hourlyOfsetColorChange', 0.15),
        hourlyDigitalCost: +$b3f0fcd8809f5ac4$var$getValue('#hourlyDigitalCost', 1500),
        hourlyDigitalSetup: +$b3f0fcd8809f5ac4$var$getValue('#hourlyDigitalSetup', 0.1),
        hourlyDigitalSpeed: +$b3f0fcd8809f5ac4$var$getValue('#hourlyDigitalSpeed', 3000),
        // Dokončovací operace
        hourlyLaminaceCost: +$b3f0fcd8809f5ac4$var$getValue('#hourlyLaminaceCost', 800),
        hourlyLaminaceSetup: +$b3f0fcd8809f5ac4$var$getValue('#hourlyLaminaceSetup', 0.25),
        hourlyLaminaceSpeed: +$b3f0fcd8809f5ac4$var$getValue('#hourlyLaminaceSpeed', 2000),
        hourlyLakovaniCost: +$b3f0fcd8809f5ac4$var$getValue('#hourlyLakovaniCost', 1200),
        hourlyLakovaniSetup: +$b3f0fcd8809f5ac4$var$getValue('#hourlyLakovaniSetup', 0.33),
        hourlyLakovaniSpeed: +$b3f0fcd8809f5ac4$var$getValue('#hourlyLakovaniSpeed', 1500),
        hourlyFalcovaniCost: +$b3f0fcd8809f5ac4$var$getValue('#hourlyFalcovaniCost', 600),
        hourlyFalcovaniSetup: +$b3f0fcd8809f5ac4$var$getValue('#hourlyFalcovaniSetup', 0.17),
        hourlyFalcovaniSpeed: +$b3f0fcd8809f5ac4$var$getValue('#hourlyFalcovaniSpeed', 10000),
        hourlyBigovaniCost: +$b3f0fcd8809f5ac4$var$getValue('#hourlyBigovaniCost', 500),
        hourlyBigovaniSetup: +$b3f0fcd8809f5ac4$var$getValue('#hourlyBigovaniSetup', 0.17),
        hourlyBigovaniSpeed: +$b3f0fcd8809f5ac4$var$getValue('#hourlyBigovaniSpeed', 5000),
        hourlyVysekCost: +$b3f0fcd8809f5ac4$var$getValue('#hourlyVysekCost', 1000),
        hourlyVysekSetup: +$b3f0fcd8809f5ac4$var$getValue('#hourlyVysekSetup', 0.5),
        hourlyVysekSpeed: +$b3f0fcd8809f5ac4$var$getValue('#hourlyVysekSpeed', 3000),
        hourlyRazbaCost: +$b3f0fcd8809f5ac4$var$getValue('#hourlyRazbaCost', 1200),
        hourlyRazbaSetup: +$b3f0fcd8809f5ac4$var$getValue('#hourlyRazbaSetup', 0.5),
        hourlyRazbaSpeed: +$b3f0fcd8809f5ac4$var$getValue('#hourlyRazbaSpeed', 2000),
        vrtaniPriprava: +$b3f0fcd8809f5ac4$var$getValue('#vrtaniPriprava', 160),
        vrtaniEuroBlokPriprava: +$b3f0fcd8809f5ac4$var$getValue('#vrtaniEuroBlokPriprava', 100),
        hourlyVrtaniCost: +$b3f0fcd8809f5ac4$var$getValue('#hourlyVrtaniCost', 400),
        hourlyVrtaniSetup: +$b3f0fcd8809f5ac4$var$getValue('#hourlyVrtaniSetup', 0.17),
        hourlyVrtaniSpeed: +$b3f0fcd8809f5ac4$var$getValue('#hourlyVrtaniSpeed', 8000),
        hourlyVazbaCost: +$b3f0fcd8809f5ac4$var$getValue('#hourlyVazbaCost', 800),
        hourlyVazbaSetup: +$b3f0fcd8809f5ac4$var$getValue('#hourlyVazbaSetup', 0.33),
        hourlyVazbaSpeed: +$b3f0fcd8809f5ac4$var$getValue('#hourlyVazbaSpeed', 500),
        hourlyLepeniCost: +$b3f0fcd8809f5ac4$var$getValue('#hourlyLepeniCost', 300),
        hourlyLepeniSetup: +$b3f0fcd8809f5ac4$var$getValue('#hourlyLepeniSetup', 0.17),
        hourlyLepeniSpeed: +$b3f0fcd8809f5ac4$var$getValue('#hourlyLepeniSpeed', 1000),
        // Režijní náklady
        hourlyOverheadCoefficient: +$b3f0fcd8809f5ac4$var$getValue('#hourlyOverheadCoefficient', 1.15),
        hourlyMinimumTime: +$b3f0fcd8809f5ac4$var$getValue('#hourlyMinimumTime', 0.25)
    };
    try {
        const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/settings`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(settings)
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const result = await response.json();
        if (result.success) {
            $b3f0fcd8809f5ac4$var$debugLog("Nastaven\xed ulo\u017Eena:", result.data);
            // Aktualizovat informace o posledním uložení
            const settingsLastSavedElement = document.getElementById('settings-last-saved-info');
            if (settingsLastSavedElement && result.data.lastUpdatedBy) {
                const lastUpdated = new Date(result.data.lastUpdated);
                const userName = result.data.lastUpdatedBy;
                const storageType = result.data.storageType;
                const storageText = storageType === 'redis' ? "cloud datab\xe1ze" : "lok\xe1ln\xed soubor";
                settingsLastSavedElement.textContent = `Posledn\xed \xfapravu provedl u\u{17E}ivatel ${userName} ${lastUpdated.toLocaleString('cs-CZ')} (${storageText})`;
            }
            // Zobrazit notifikaci pouze pokud je aktivní sekce nastavení
            if (typeof $b3f0fcd8809f5ac4$var$sectionManager !== 'undefined' && $b3f0fcd8809f5ac4$var$sectionManager.currentSection === 'nastaveni') $b3f0fcd8809f5ac4$var$showNotification("Nastaven\xed ulo\u017Eena", 'success');
        } else throw new Error(result.error || "Nezn\xe1m\xe1 chyba");
    } catch (error) {
        console.error("Chyba p\u0159i ukl\xe1d\xe1n\xed nastaven\xed:", error);
        if (typeof $b3f0fcd8809f5ac4$var$sectionManager !== 'undefined' && $b3f0fcd8809f5ac4$var$sectionManager.currentSection === 'nastaveni') $b3f0fcd8809f5ac4$var$showNotification("Chyba p\u0159i ukl\xe1d\xe1n\xed nastaven\xed: " + error.message, 'danger');
    }
}
// Funkce pro načtení nastavení z API
async function $b3f0fcd8809f5ac4$var$loadSettings() {
    try {
        // GET /api/settings vyžaduje přihlášení (cookie) – volá se až po unlockApp()
        const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/settings`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const result = await response.json();
        if (result.success) {
            const settings = result.data.settings;
            $b3f0fcd8809f5ac4$var$debugLog("Na\u010D\xedt\xe1m nastaven\xed z API:", settings);
            // Aplikuj nastavení do formuláře
            let appliedCount = 0;
            Object.keys(settings).forEach((key)=>{
                // Přeskoč 'technologie' - to je lokální nastavení v localStorage
                if (key === 'technologie') return;
                const element = document.getElementById(key);
                if (element) {
                    if (element.type === 'checkbox') element.checked = settings[key];
                    else element.value = settings[key];
                    appliedCount++;
                }
            // Tiché ignorování chybějících elementů - normální stav
            });
            $b3f0fcd8809f5ac4$var$debugLog(`Na\u{10D}teno ${appliedCount} nastaven\xed do formul\xe1\u{159}e`);
            // Přegenerovat možnosti dopravy podle načtených cen
            $b3f0fcd8809f5ac4$var$updateDopravaOptions();
            // Aktualizovat informace o posledním uložení při načtení
            const settingsLastSavedElement = document.getElementById('settings-last-saved-info');
            if (settingsLastSavedElement && result.data.lastUpdated) {
                const lastUpdated = new Date(result.data.lastUpdated);
                const userName = result.data.lastUpdatedBy || "nezn\xe1m\xfd";
                const storageType = result.data.storageType || 'file';
                const storageText = storageType === 'redis' ? "cloud datab\xe1ze" : "lok\xe1ln\xed soubor";
                settingsLastSavedElement.textContent = `Posledn\xed \xfapravu provedl u\u{17E}ivatel ${userName} ${lastUpdated.toLocaleString('cs-CZ')} (${storageText})`;
            }
        } else throw new Error(result.error || "Nezn\xe1m\xe1 chyba");
    } catch (error) {
        console.error("Chyba p\u0159i na\u010D\xedt\xe1n\xed nastaven\xed:", error);
        // Tiché ignorování chyby pro nepřihlášené uživatele - použijí se výchozí hodnoty
        $b3f0fcd8809f5ac4$var$debugLog("Nastaven\xed nebyla na\u010Dtena, pou\u017E\xedvaj\xed se v\xfdchoz\xed hodnoty");
        // Fallback informace do infoboxu pro případ, že API selže
        const settingsLastSavedElement = document.getElementById('settings-last-saved-info');
        if (settingsLastSavedElement) {
            // Zachováme původní text pokud existuje, jinak nastavíme chybovou zprávu
            const currentText = settingsLastSavedElement.textContent.trim();
            if (!currentText || currentText === "(na\u010D\xedt\xe1m z API...)" || currentText.includes('chyba')) settingsLastSavedElement.textContent = "(chyba na\u010Dten\xed z API)";
        // Jinak ponecháme původní text - neztratíme informaci o centrálním nastavení
        }
    }
}
// Funkce pro reset nastavení na výchozí hodnoty
async function $b3f0fcd8809f5ac4$var$resetSettings() {
    if (confirm("Opravdu chcete resetovat v\u0161echna nastaven\xed na v\xfdchoz\xed hodnoty?")) try {
        const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/settings/reset`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...$b3f0fcd8809f5ac4$var$authManager.getAuthHeaders()
            }
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const result = await response.json();
        if (result.success) {
            $b3f0fcd8809f5ac4$var$debugLog("Nastaven\xed resetov\xe1na:", result.data);
            // Resetovat lokální technologii tisku na 'auto'
            $b3f0fcd8809f5ac4$var$saveLocalTechnologie('auto');
            const technologieSelect = document.getElementById('technologie');
            if (technologieSelect) technologieSelect.value = 'auto';
            // Znovu načíst nastavení do formuláře
            await $b3f0fcd8809f5ac4$var$loadSettings();
            // Spustit přepočet
            $b3f0fcd8809f5ac4$var$pocitej();
            $b3f0fcd8809f5ac4$var$showNotification("Nastaven\xed resetov\xe1na na v\xfdchoz\xed hodnoty", 'info');
        } else throw new Error(result.error || "Nezn\xe1m\xe1 chyba");
    } catch (error) {
        console.error("Chyba p\u0159i resetov\xe1n\xed nastaven\xed:", error);
        $b3f0fcd8809f5ac4$var$showNotification("Chyba p\u0159i resetov\xe1n\xed nastaven\xed: " + error.message, 'danger');
    }
}
// Funkce pro export nastavení
async function $b3f0fcd8809f5ac4$var$exportSettings() {
    try {
        const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/settings/export`, {
            headers: {
                ...$b3f0fcd8809f5ac4$var$authManager.getAuthHeaders()
            }
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const settings = await response.json();
        const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(settings, null, 2));
        const downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute("href", dataStr);
        downloadAnchorNode.setAttribute("download", "tria-calculator-settings.json");
        document.body.appendChild(downloadAnchorNode);
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
        $b3f0fcd8809f5ac4$var$showNotification("Nastaven\xed exportov\xe1na", 'success');
    } catch (error) {
        console.error("Chyba p\u0159i exportu nastaven\xed:", error);
        $b3f0fcd8809f5ac4$var$showNotification("Chyba p\u0159i exportu nastaven\xed: " + error.message, 'danger');
    }
}
// Funkce pro import nastavení
function $b3f0fcd8809f5ac4$var$importSettings() {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json';
    input.onchange = function(e) {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = async function(e) {
            try {
                const settings = JSON.parse(e.target.result);
                // Poslat na API
                const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/settings/import`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include',
                    body: JSON.stringify(settings)
                });
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const result = await response.json();
                if (result.success) {
                    // Znovu načíst nastavení do formuláře
                    await $b3f0fcd8809f5ac4$var$loadSettings();
                    // Spustit přepočet
                    $b3f0fcd8809f5ac4$var$pocitej();
                    $b3f0fcd8809f5ac4$var$showNotification("Nastaven\xed byla \xfasp\u011B\u0161n\u011B importov\xe1na", 'success');
                } else throw new Error(result.error || "Nezn\xe1m\xe1 chyba");
            } catch (error) {
                console.error("Chyba p\u0159i importu nastaven\xed:", error);
                $b3f0fcd8809f5ac4$var$showNotification("Chyba p\u0159i importu nastaven\xed: " + error.message, 'danger');
            }
        };
        reader.readAsText(file);
    };
    input.click();
}
// ============================================================================
// LOKÁLNÍ NASTAVENÍ TECHNOLOGIE TISKU (user-specific, sessionStorage)
// Nastavení platí pouze pro aktuální session (do zavření prohlížeče).
// Pro nepřihlášené uživatele je výchozí hodnota 'auto'.
// ============================================================================
// Funkce pro načtení technologie z sessionStorage
function $b3f0fcd8809f5ac4$var$loadLocalTechnologie() {
    const saved = sessionStorage.getItem('technologie');
    return saved || 'auto'; // Výchozí hodnota je 'auto'
}
// Funkce pro uložení technologie do sessionStorage
function $b3f0fcd8809f5ac4$var$saveLocalTechnologie(value) {
    sessionStorage.setItem('technologie', value);
}
// Inicializace event listeneru pro technologii při změně
function $b3f0fcd8809f5ac4$var$initTechnologieListener() {
    const technologieSelect = document.getElementById('technologie');
    if (technologieSelect) {
        // Načíst uloženou hodnotu při načtení stránky
        const savedValue = $b3f0fcd8809f5ac4$var$loadLocalTechnologie();
        technologieSelect.value = savedValue;
        // Event listener pro ukládání při změně
        technologieSelect.addEventListener('change', (e)=>{
            $b3f0fcd8809f5ac4$var$saveLocalTechnologie(e.target.value);
            // Přepočítat kalkulaci
            $b3f0fcd8809f5ac4$var$pocitej();
        });
    }
}
// Exportuji funkce globálně
window.resetSettings = $b3f0fcd8809f5ac4$var$resetSettings;
window.saveSettings = $b3f0fcd8809f5ac4$var$saveSettings;
window.loadSettings = $b3f0fcd8809f5ac4$var$loadSettings;
window.exportSettings = $b3f0fcd8809f5ac4$var$exportSettings;
window.importSettings = $b3f0fcd8809f5ac4$var$importSettings;
window.showNotification = $b3f0fcd8809f5ac4$var$showNotification;
window.loadLocalTechnologie = $b3f0fcd8809f5ac4$var$loadLocalTechnologie;
window.saveLocalTechnologie = $b3f0fcd8809f5ac4$var$saveLocalTechnologie;
// Funkce pro renderování materiálů do select elementu
function $b3f0fcd8809f5ac4$var$renderMaterialsToSelect(materials) {
    const select = document.getElementById('material');
    if (!select) return;
    // Zjistím aktuálně vybranou hodnotu
    const selectedValue = select.value;
    // Vyčistím select
    select.innerHTML = '';
    // Kategorie a jejich názvy
    const categoryNames = {
        'ofset': "Ofsetov\xfd pap\xedr",
        'laserova': "Do laserov\xe9 tisk\xe1rny",
        'krida-leskla': "Leskl\xe1 k\u0159\xedda",
        'krida-matna': "Matn\xe1 k\u0159\xedda",
        'recyklovane': "Recyklovan\xe9 a ekologick\xe9 pap\xedry",
        'lepenky': 'Lepenky',
        'samolepici': "Samolep\xedc\xed pap\xedry",
        'kartony': "Kart\xf3ny",
        'specialni': "Speci\xe1ln\xed grafick\xe9 pap\xedry"
    };
    // Pořadí kategorií
    const categoryOrder = [
        'ofset',
        'laserova',
        'krida-leskla',
        'krida-matna',
        'recyklovane',
        'lepenky',
        'samolepici',
        'kartony',
        'specialni'
    ];
    // Vytvořím optgroup pro každou kategorii
    categoryOrder.forEach((categoryId)=>{
        const categoryMaterials = materials[categoryId];
        if (!categoryMaterials || categoryMaterials.length === 0) return;
        const optgroup = document.createElement('optgroup');
        optgroup.label = categoryNames[categoryId];
        categoryMaterials.forEach((material)=>{
            const option = document.createElement('option');
            option.value = material.price;
            option.textContent = material.name;
            option.setAttribute('data-obratka', material.canFlip ? '1' : '0');
            option.setAttribute('data-gramaz', material.weight);
            option.setAttribute('data-vyska', material.width); // Pozor: width je výška archu
            option.setAttribute('data-sirka', material.height); // Pozor: height je šířka archu
            // Pokud je to stejná hodnota jako předchozí selected, označím jako selected
            if (selectedValue && selectedValue === material.price.toString()) option.selected = true;
            optgroup.appendChild(option);
        });
        select.appendChild(optgroup);
    });
    // Přidám možnost "Vlastní materiál" na konec
    const customOption = document.createElement('option');
    customOption.value = 'vlastni';
    customOption.textContent = "Vlastn\xed materi\xe1l";
    customOption.setAttribute('data-obratka', '1');
    customOption.setAttribute('data-gramaz', '200');
    customOption.setAttribute('data-vyska', '650');
    customOption.setAttribute('data-sirka', '480');
    select.appendChild(customOption);
    // Pokud nebyla žádná hodnota vybrána, vyberu výchozí (Ofset 80 g/m²)
    if (!selectedValue) {
        const defaultOption = select.querySelector('option[value="1.43"]');
        if (defaultOption) defaultOption.selected = true;
    }
    // Synchronizovat materiály do vnitřního bloku selectu (pokud existuje)
    $b3f0fcd8809f5ac4$var$syncVnitrniMaterialSelect();
    // Synchronizovat materiály do podložky selectu (pokud existuje)
    $b3f0fcd8809f5ac4$var$syncPodlozkaMaterialSelect();
}
// Základní objekty pro zadání
var $b3f0fcd8809f5ac4$var$produkt = {
    nazev: '',
    technologieTisku: 'auto',
    dtp: 0,
    pocetKusu: 0,
    barevnost: '4/4',
    primeBarvy: 0,
    okrajKolemProduktu: 3,
    okrajKolemArchu: 7,
    okrajKolemArchuDigital: 7,
    rozmer: {
        format: 'A4',
        sirka: 210,
        vyska: 297
    },
    material: {
        nazev: "Matn\xe1 k\u0159\xedda",
        cena: 0,
        gramaz: 115,
        // false = jednostranně natíraný papír → nelze tisknout na obrátku
        canFlip: true,
        rozmer: {
            sirka: 500,
            vyska: 707
        }
    },
    laminace: {
        typ: '0'
    },
    lak: {
        typ: '0'
    },
    falcovani: {
        typ: '0'
    },
    bigovani: {
        typ: '0'
    },
    vysek: {
        option: 0,
        pozicNaVysek: 0,
        cenaRazniceVyseku: 0
    },
    predsek: {
        option: 0,
        pozicNaPredsek: 0,
        cenaRaznicePredseku: 0
    },
    razba: {
        option: 0,
        pozicNaRazbu: 0,
        cenaStockuRazby: 0
    },
    vrtani: {
        pocetVrtu: 0
    },
    perforace: {
        pocetPerforaci: 0
    },
    lepeni: {
        typ: '0',
        pocetLepeni: 0
    },
    vazba: {
        typ: '0',
        nazev: '',
        cena: 0,
        text: '',
        orientace: 'vysku',
        orientaceText: "Na del\u0161\xed stran\u011B",
        pocetStran: 0,
        jinaObalka: false,
        vnitrniBlok: null,
        podlozka: null
    },
    barvyDigital: {
        typ: 0
    }
};
var $b3f0fcd8809f5ac4$var$objednavka = {
    doprava: {
        cena: 0,
        text: ''
    }
};
var $b3f0fcd8809f5ac4$var$zakaznik = {
    kategorie: 'velko'
};
var $b3f0fcd8809f5ac4$var$nastaveni = {
    koeficientCena: 1.2,
    dph: 1.21,
    stroje: {
        ofset: {
            horniOkraj: 17,
            dolniOkraj: 15,
            pravyOkraj: 10,
            levyOkraj: 10,
            barvaCena: 500,
            mytiCena: 250,
            prujezdCena: 0.25,
            obratkaCena: 350,
            obratka: true
        },
        digital: {
            horniOkraj: 0,
            dolniOkraj: 0,
            pravyOkraj: 0,
            levyOkraj: 0,
            pripravaCernobile: 200,
            pripravaBarva: 200,
            pripravaBarvaSpecial: 0,
            prujezdDigiCenaDo750_44: 5.74,
            prujezdDigiCenaNad750_44: 3.3,
            prujezdDigiCenaDo750_40: 4.74,
            prujezdDigiCenaNad750_40: 2.3,
            prujezdDigiCenaDo750_11: 2.28,
            prujezdDigiCenaNad750_11: 1.28,
            prujezdDigiCenaDo750_10: 1.96,
            prujezdDigiCenaNad750_10: 0.96,
            barvySpecialLak50: 4,
            barvySpecialLak100: 8,
            barvySpecialBila50: 6,
            barvySpecialBila100: 12,
            barvySpecialZlata50: 6,
            barvySpecialZlata100: 12
        }
    },
    vrtani: {
        priprava: 160,
        euroBlokPriprava: 100
    }
};
// Funkce pro získání hodnot z formuláře
function $b3f0fcd8809f5ac4$var$getN(e) {
    const element = document.querySelector(e);
    return element;
}
// Bezpečná funkce pro získání hodnoty
function $b3f0fcd8809f5ac4$var$getValue(selector, defaultValue = 0) {
    const element = $b3f0fcd8809f5ac4$var$getN(selector);
    if (!element) {
        $b3f0fcd8809f5ac4$var$debugLog(`Element ${selector} not found, using default value: ${defaultValue}`);
        return defaultValue;
    }
    return element.value;
}
// Bezpečná funkce pro získání checked stavu
function $b3f0fcd8809f5ac4$var$getChecked(selector, defaultValue = false) {
    const element = $b3f0fcd8809f5ac4$var$getN(selector);
    if (!element) {
        $b3f0fcd8809f5ac4$var$debugLog(`Element ${selector} not found, using default value: ${defaultValue}`);
        return defaultValue;
    }
    return element.checked;
}
// Bezpečná funkce pro získání hodnoty vybraného option
function $b3f0fcd8809f5ac4$var$getSelectedValue(selector, defaultValue = '') {
    const element = $b3f0fcd8809f5ac4$var$getN(selector + ' option:checked');
    if (!element) {
        $b3f0fcd8809f5ac4$var$debugLog(`Selected option in ${selector} not found, using default value: ${defaultValue}`);
        return defaultValue;
    }
    return element.value;
}
// Bezpečná funkce pro získání textu vybraného option
function $b3f0fcd8809f5ac4$var$getSelectedText(selector, defaultValue = '') {
    const element = $b3f0fcd8809f5ac4$var$getN(selector + ' option:checked');
    if (!element) {
        $b3f0fcd8809f5ac4$var$debugLog(`Selected option in ${selector} not found, using default value: ${defaultValue}`);
        return defaultValue;
    }
    return element.text;
}
// Bezpečná funkce pro získání atributu vybraného option
function $b3f0fcd8809f5ac4$var$getSelectedAttribute(selector, attr, defaultValue = '') {
    const element = $b3f0fcd8809f5ac4$var$getN(selector + ' option:checked');
    if (!element) {
        $b3f0fcd8809f5ac4$var$debugLog(`Selected option in ${selector} not found, using default value: ${defaultValue}`);
        return defaultValue;
    }
    return element.getAttribute(attr) || defaultValue;
}
function $b3f0fcd8809f5ac4$var$gatherForm() {
    // Načtení nastavení
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.ofset.barvaCena = +$b3f0fcd8809f5ac4$var$getValue('#barvaCena', 500);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.ofset.mytiCena = +$b3f0fcd8809f5ac4$var$getValue('#mytiCena', 250);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.ofset.prujezdCena = +$b3f0fcd8809f5ac4$var$getValue('#prujezdOfsetCena', 0.25);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.ofset.obratkaCena = +$b3f0fcd8809f5ac4$var$getValue('#obratkaCena', 350);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.ofset.soubehSleva = +$b3f0fcd8809f5ac4$var$getValue('#ofsetSoubehSleva', 0.8);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.ofset.horniOkraj = +$b3f0fcd8809f5ac4$var$getValue('#horniOkraj', 17);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.ofset.dolniOkraj = +$b3f0fcd8809f5ac4$var$getValue('#dolniOkraj', 15);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.ofset.pravyOkraj = +$b3f0fcd8809f5ac4$var$getValue('#pravyOkraj', 10);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.ofset.levyOkraj = +$b3f0fcd8809f5ac4$var$getValue('#levyOkraj', 10);
    $b3f0fcd8809f5ac4$var$nastaveni.koeficientCena = +$b3f0fcd8809f5ac4$var$getValue('#koeficientCena', 1.2);
    $b3f0fcd8809f5ac4$var$nastaveni.dph = +$b3f0fcd8809f5ac4$var$getValue('#dph', 1.21);
    // Načtení digitálních nastavení
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.horniOkraj = +$b3f0fcd8809f5ac4$var$getValue('#horniOkrajDigital', 0);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.dolniOkraj = +$b3f0fcd8809f5ac4$var$getValue('#dolniOkrajDigital', 0);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.pravyOkraj = +$b3f0fcd8809f5ac4$var$getValue('#pravyOkrajDigital', 0);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.levyOkraj = +$b3f0fcd8809f5ac4$var$getValue('#levyOkrajDigital', 0);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.pripravaCernobile = +$b3f0fcd8809f5ac4$var$getValue('#pripravaCernobile', 200);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.pripravaBarva = +$b3f0fcd8809f5ac4$var$getValue('#pripravaBarva', 200);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.pripravaBarvaSpecial = +$b3f0fcd8809f5ac4$var$getValue('#pripravaBarvaSpecial', 0);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.prujezdDigiCenaDo750_44 = +$b3f0fcd8809f5ac4$var$getValue('#prujezdDigiCenaDo750_44', 5.74);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.prujezdDigiCenaNad750_44 = +$b3f0fcd8809f5ac4$var$getValue('#prujezdDigiCenaNad750_44', 3.3);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.prujezdDigiCenaDo750_40 = +$b3f0fcd8809f5ac4$var$getValue('#prujezdDigiCenaDo750_40', 4.74);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.prujezdDigiCenaNad750_40 = +$b3f0fcd8809f5ac4$var$getValue('#prujezdDigiCenaNad750_40', 2.3);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.prujezdDigiCenaDo750_11 = +$b3f0fcd8809f5ac4$var$getValue('#prujezdDigiCenaDo750_11', 2.28);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.prujezdDigiCenaNad750_11 = +$b3f0fcd8809f5ac4$var$getValue('#prujezdDigiCenaNad750_11', 1.28);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.prujezdDigiCenaDo750_10 = +$b3f0fcd8809f5ac4$var$getValue('#prujezdDigiCenaDo750_10', 1.96);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.prujezdDigiCenaNad750_10 = +$b3f0fcd8809f5ac4$var$getValue('#prujezdDigiCenaNad750_10', 0.96);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.barvySpecialLak50 = +$b3f0fcd8809f5ac4$var$getValue('#barvySpecialLak50', 4);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.barvySpecialLak100 = +$b3f0fcd8809f5ac4$var$getValue('#barvySpecialLak100', 8);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.barvySpecialBila50 = +$b3f0fcd8809f5ac4$var$getValue('#barvySpecialBila50', 6);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.barvySpecialBila100 = +$b3f0fcd8809f5ac4$var$getValue('#barvySpecialBila100', 12);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.barvySpecialZlata50 = +$b3f0fcd8809f5ac4$var$getValue('#barvySpecialZlata50', 6);
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.digital.barvySpecialZlata100 = +$b3f0fcd8809f5ac4$var$getValue('#barvySpecialZlata100', 12);
    // Načtení nastavení vrtání
    $b3f0fcd8809f5ac4$var$nastaveni.vrtani.priprava = +$b3f0fcd8809f5ac4$var$getValue('#vrtaniPriprava', 160);
    $b3f0fcd8809f5ac4$var$nastaveni.vrtani.euroBlokPriprava = +$b3f0fcd8809f5ac4$var$getValue('#vrtaniEuroBlokPriprava', 100);
    // Načtení nastavení vazby
    $b3f0fcd8809f5ac4$var$nastaveni.vazba = $b3f0fcd8809f5ac4$var$nastaveni.vazba || {};
    $b3f0fcd8809f5ac4$var$nastaveni.vazba['V1-strojni'] = {
        priprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV1StrojniPriprava', 200),
        cenaZaKus: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV1StrojniCenaZaKus', 0.6)
    };
    $b3f0fcd8809f5ac4$var$nastaveni.vazba['V1-rucni'] = {
        priprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV1RucniPriprava', 100),
        cenaZaKus: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV1RucniCenaZaKus', 1.6),
        cenaZaStranu: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV1RucniCenaZaStranu', 0.3)
    };
    // Kroužková twin wire - cenové stupně
    $b3f0fcd8809f5ac4$var$nastaveni.vazba['krouzek-blok-A7'] = {
        priprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA7Priprava', 200),
        cenaZaKus: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA7CenaZaKus', 10.80)
    };
    $b3f0fcd8809f5ac4$var$nastaveni.vazba['krouzek-blok-A6'] = {
        priprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA6Priprava', 200),
        cenaZaKus: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA6CenaZaKus', 11.80)
    };
    $b3f0fcd8809f5ac4$var$nastaveni.vazba['krouzek-blok-A5'] = {
        priprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA5Priprava', 200),
        cenaZaKus: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA5CenaZaKus', 12.30)
    };
    $b3f0fcd8809f5ac4$var$nastaveni.vazba['krouzek-blok-A4'] = {
        priprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA4Priprava', 200),
        cenaZaKus: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA4CenaZaKus', 12.80)
    };
    $b3f0fcd8809f5ac4$var$nastaveni.vazba['krouzek-blok-A3'] = {
        priprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA3Priprava', 200),
        cenaZaKus: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekBlokA3CenaZaKus', 14.00)
    };
    // Kroužková s háčkem na pověšení
    $b3f0fcd8809f5ac4$var$nastaveni.vazba['krouzek-kalendar'] = {
        priprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekKalendarPriprava', 200),
        cenaZaKus: +$b3f0fcd8809f5ac4$var$getValue('#vazbaKrouzekKalendarCenaZaKus', 14.00)
    };
    // V2 PUR – marginální ceník (sazba plynule klesá kusStart → kusKonec)
    $b3f0fcd8809f5ac4$var$nastaveni.vazba['V2-PUR'] = {
        priprava: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV2PurPriprava', 400),
        kusStart: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV2PurKusStart', 14),
        kusKonec: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV2PurKusKonec', 8),
        prah: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV2PurPrah', 200),
        utlum: +$b3f0fcd8809f5ac4$var$getValue('#vazbaV2PurUtlum', 300)
    };
    // Načtení produktových nastavení
    $b3f0fcd8809f5ac4$var$produkt.nazev = $b3f0fcd8809f5ac4$var$getValue('#nazev', '');
    $b3f0fcd8809f5ac4$var$produkt.dtp = +$b3f0fcd8809f5ac4$var$getValue('#dtp', 0);
    $b3f0fcd8809f5ac4$var$produkt.pocetKusu = +$b3f0fcd8809f5ac4$var$getValue('#pocetKusu', 1000);
    $b3f0fcd8809f5ac4$var$produkt.pocetDruhu = +$b3f0fcd8809f5ac4$var$getValue('#pocetDruhu', 1);
    // Motivy s vlastními náklady – při druzích >= 2 jsou zdrojem pravdy řádky panelu
    $b3f0fcd8809f5ac4$var$produkt.motivy = $b3f0fcd8809f5ac4$var$produkt.pocetDruhu > 1 ? $b3f0fcd8809f5ac4$var$getMotivyRows().filter((m)=>m.pocetKusu > 0) : null;
    // Načíst technologii z lokálního úložiště (sessionStorage), nikoliv z centrálního nastavení
    $b3f0fcd8809f5ac4$var$produkt.technologieTisku = $b3f0fcd8809f5ac4$var$loadLocalTechnologie();
    $b3f0fcd8809f5ac4$var$nastaveni.stroje.ofset.obratka = $b3f0fcd8809f5ac4$var$getChecked('#obratka', true);
    $b3f0fcd8809f5ac4$var$zakaznik.kategorie = $b3f0fcd8809f5ac4$var$getSelectedValue('#typCeny', 'velko');
    $b3f0fcd8809f5ac4$var$produkt.barevnost = $b3f0fcd8809f5ac4$var$getSelectedValue('#pocetBarev', '4/4');
    $b3f0fcd8809f5ac4$var$produkt.primeBarvy = +$b3f0fcd8809f5ac4$var$getValue('#primeBarvy', 0);
    $b3f0fcd8809f5ac4$var$produkt.barvyDigital.typ = $b3f0fcd8809f5ac4$var$getSelectedValue('#barvyDigital', 0);
    $b3f0fcd8809f5ac4$var$produkt.okrajKolemProduktu = +$b3f0fcd8809f5ac4$var$getValue('#okrajKolemProduktu', 3);
    $b3f0fcd8809f5ac4$var$produkt.okrajKolemArchu = +$b3f0fcd8809f5ac4$var$getValue('#okrajKolemArchu', 7);
    $b3f0fcd8809f5ac4$var$produkt.okrajKolemArchuDigital = +$b3f0fcd8809f5ac4$var$getValue('#okrajKolemArchuDigital', 7);
    // Načtení rozměrů
    $b3f0fcd8809f5ac4$var$produkt.rozmer.format = $b3f0fcd8809f5ac4$var$getSelectedText('#produktRozmerFormat', 'A4');
    if ($b3f0fcd8809f5ac4$var$produkt.rozmer.format === "Vlastn\xed rozm\u011Br") {
        $b3f0fcd8809f5ac4$var$produkt.rozmer.sirka = +$b3f0fcd8809f5ac4$var$getValue('#produktRozmerSirka', 210);
        $b3f0fcd8809f5ac4$var$produkt.rozmer.vyska = +$b3f0fcd8809f5ac4$var$getValue('#produktRozmerVyska', 297);
        $b3f0fcd8809f5ac4$var$produkt.rozmer.format = $b3f0fcd8809f5ac4$var$produkt.rozmer.sirka + "\xd7" + $b3f0fcd8809f5ac4$var$produkt.rozmer.vyska + ' mm';
    } else {
        $b3f0fcd8809f5ac4$var$produkt.rozmer.sirka = +$b3f0fcd8809f5ac4$var$getSelectedAttribute('#produktRozmerFormat', 'data-sirka', '210');
        $b3f0fcd8809f5ac4$var$produkt.rozmer.vyska = +$b3f0fcd8809f5ac4$var$getSelectedAttribute('#produktRozmerFormat', 'data-vyska', '297');
        const sirkaEl = $b3f0fcd8809f5ac4$var$getN('#produktRozmerSirka');
        const vyskaEl = $b3f0fcd8809f5ac4$var$getN('#produktRozmerVyska');
        if (sirkaEl) sirkaEl.value = $b3f0fcd8809f5ac4$var$produkt.rozmer.sirka;
        if (vyskaEl) vyskaEl.value = $b3f0fcd8809f5ac4$var$produkt.rozmer.vyska;
    }
    // Načtení materiálu
    if ($b3f0fcd8809f5ac4$var$getSelectedValue('#material', '0') === 'vlastni') {
        $b3f0fcd8809f5ac4$var$produkt.material.nazev = $b3f0fcd8809f5ac4$var$getSelectedText('#material', "Matn\xe1 k\u0159\xedda");
        $b3f0fcd8809f5ac4$var$produkt.material.cena = +$b3f0fcd8809f5ac4$var$getValue('#materialCena', 0);
        $b3f0fcd8809f5ac4$var$produkt.material.gramaz = +$b3f0fcd8809f5ac4$var$getValue('#materialGramaz', 115);
        $b3f0fcd8809f5ac4$var$produkt.material.canFlip = true;
        // Poznámka: Rozměry materiálu se ve výpočtu nepoužívají - používají se rozměry strojů z nastavení
        $b3f0fcd8809f5ac4$var$produkt.material.rozmer.sirka = 500; // Výchozí hodnota
        $b3f0fcd8809f5ac4$var$produkt.material.rozmer.vyska = 707; // Výchozí hodnota
    } else {
        $b3f0fcd8809f5ac4$var$produkt.material.nazev = $b3f0fcd8809f5ac4$var$getSelectedText('#material', "Matn\xe1 k\u0159\xedda");
        $b3f0fcd8809f5ac4$var$produkt.material.cena = +$b3f0fcd8809f5ac4$var$getSelectedValue('#material', '0');
        $b3f0fcd8809f5ac4$var$produkt.material.gramaz = +$b3f0fcd8809f5ac4$var$getSelectedAttribute('#material', 'data-gramaz', '115');
        // data-obratka = canFlip materiálu; '0' u jednostranně natíraných kartonů,
        // kde tisk na obrátku není možný (engine to řeší v safeCalcSheetsWithComp)
        $b3f0fcd8809f5ac4$var$produkt.material.canFlip = $b3f0fcd8809f5ac4$var$getSelectedAttribute('#material', 'data-obratka', '1') !== '0';
        // Opraveno: data-sirka pro sirka, data-vyska pro vyska (byl zde bug)
        $b3f0fcd8809f5ac4$var$produkt.material.rozmer.sirka = +$b3f0fcd8809f5ac4$var$getSelectedAttribute('#material', 'data-sirka', '500');
        $b3f0fcd8809f5ac4$var$produkt.material.rozmer.vyska = +$b3f0fcd8809f5ac4$var$getSelectedAttribute('#material', 'data-vyska', '707');
        const cenaEl = $b3f0fcd8809f5ac4$var$getN('#materialCena');
        const gramazEl = $b3f0fcd8809f5ac4$var$getN('#materialGramaz');
        if (cenaEl) cenaEl.value = $b3f0fcd8809f5ac4$var$produkt.material.cena;
        if (gramazEl) gramazEl.value = $b3f0fcd8809f5ac4$var$produkt.material.gramaz;
    // Odebrány: inputy pro rozměry materiálu již neexistují
    }
    // Načtení služeb
    $b3f0fcd8809f5ac4$var$produkt.laminace.typ = $b3f0fcd8809f5ac4$var$getSelectedValue('#laminace', '0');
    $b3f0fcd8809f5ac4$var$produkt.lak.typ = $b3f0fcd8809f5ac4$var$getSelectedValue('#lakovani', '0');
    $b3f0fcd8809f5ac4$var$produkt.falcovani.typ = $b3f0fcd8809f5ac4$var$getSelectedValue('#falcovani', '0');
    $b3f0fcd8809f5ac4$var$produkt.bigovani.typ = $b3f0fcd8809f5ac4$var$getSelectedValue('#bigovani', '0');
    $b3f0fcd8809f5ac4$var$produkt.vysek.option = $b3f0fcd8809f5ac4$var$getSelectedValue('#vysek', '0');
    $b3f0fcd8809f5ac4$var$produkt.vysek.pozicNaVysek = +$b3f0fcd8809f5ac4$var$getValue('#pozicNaVysek', 0);
    $b3f0fcd8809f5ac4$var$produkt.vysek.cenaRazniceVyseku = +$b3f0fcd8809f5ac4$var$getValue('#cenaRazniceVyseku', 0);
    $b3f0fcd8809f5ac4$var$produkt.predsek.option = +$b3f0fcd8809f5ac4$var$getSelectedValue('#predsek', '0');
    $b3f0fcd8809f5ac4$var$produkt.predsek.pozicNaPredsek = +$b3f0fcd8809f5ac4$var$getValue('#pozicNaPredsek', 0);
    $b3f0fcd8809f5ac4$var$produkt.predsek.cenaRaznicePredseku = +$b3f0fcd8809f5ac4$var$getValue('#cenaRaznicePredseku', 0);
    $b3f0fcd8809f5ac4$var$produkt.razba.option = +$b3f0fcd8809f5ac4$var$getSelectedValue('#razba', '0');
    $b3f0fcd8809f5ac4$var$produkt.razba.pozicNaRazbu = +$b3f0fcd8809f5ac4$var$getValue('#pozicNaRazbu', 0);
    $b3f0fcd8809f5ac4$var$produkt.razba.cenaStockuRazby = +$b3f0fcd8809f5ac4$var$getValue('#cenaStockuRazby', 0);
    $b3f0fcd8809f5ac4$var$produkt.vrtani.typ = $b3f0fcd8809f5ac4$var$getSelectedValue('#vrtani', '0');
    $b3f0fcd8809f5ac4$var$produkt.perforace.pocetPerforaci = +$b3f0fcd8809f5ac4$var$getSelectedValue('#perforace', '0');
    $b3f0fcd8809f5ac4$var$produkt.lepeni.typ = $b3f0fcd8809f5ac4$var$getSelectedValue('#lepeni', '0');
    $b3f0fcd8809f5ac4$var$produkt.lepeni.pocetLepeni = +$b3f0fcd8809f5ac4$var$getValue('#lepeniPocet', 0);
    // Načtení vazby
    $b3f0fcd8809f5ac4$var$produkt.vazba.typ = $b3f0fcd8809f5ac4$var$getSelectedValue('#vazba', '0');
    $b3f0fcd8809f5ac4$var$produkt.vazba.nazev = $b3f0fcd8809f5ac4$var$getSelectedText('#vazba', 'Bez vazby');
    $b3f0fcd8809f5ac4$var$produkt.vazba.orientace = $b3f0fcd8809f5ac4$var$getSelectedValue('#vazbaNa', 'vysku');
    $b3f0fcd8809f5ac4$var$produkt.vazba.orientaceText = $b3f0fcd8809f5ac4$var$getSelectedText('#vazbaNa', "Na del\u0161\xed stran\u011B");
    $b3f0fcd8809f5ac4$var$produkt.vazba.pocetStran = +$b3f0fcd8809f5ac4$var$getValue('#vazbaPocetStran', 0);
    $b3f0fcd8809f5ac4$var$produkt.vazba.jinaObalka = $b3f0fcd8809f5ac4$var$getChecked('#vazbaJinaObalka', false);
    $b3f0fcd8809f5ac4$var$produkt.vazba.vnitrniTisk = $b3f0fcd8809f5ac4$var$getSelectedValue('#vazbaVnitrniTisk', 'jina');
    // Kroužková vazba: barva spirály + rozsah obálky (předek i záda / jen přední)
    const isKrouzekVazba = typeof $b3f0fcd8809f5ac4$var$produkt.vazba.typ === 'string' && $b3f0fcd8809f5ac4$var$produkt.vazba.typ.startsWith('krouzek');
    $b3f0fcd8809f5ac4$var$produkt.vazba.barvaSpiraly = isKrouzekVazba ? $b3f0fcd8809f5ac4$var$getSelectedValue('#vazbaBarvaSpiraly', 'bila') : null;
    $b3f0fcd8809f5ac4$var$produkt.vazba.obalkaZada = isKrouzekVazba && $b3f0fcd8809f5ac4$var$produkt.vazba.jinaObalka ? $b3f0fcd8809f5ac4$var$getSelectedValue('#vazbaObalkaZada', 'ano') === 'ano' : true;
    // Rozsah motivů u vazby: 'obalka' (vnitřek společný) | 'obalka-vnitrek'
    $b3f0fcd8809f5ac4$var$produkt.vazba.motivRozsah = $b3f0fcd8809f5ac4$var$getSelectedValue('#vazbaMotivRozsah', 'obalka');
    // Načtení vnitřního bloku (pokud je jiná obálka než vnitřní blok)
    if ($b3f0fcd8809f5ac4$var$produkt.vazba.typ !== '0' && $b3f0fcd8809f5ac4$var$produkt.vazba.jinaObalka) {
        const vnitrniMaterialVal = $b3f0fcd8809f5ac4$var$getSelectedValue('#vnitrniMaterial', '0');
        $b3f0fcd8809f5ac4$var$produkt.vazba.vnitrniBlok = {
            material: {
                nazev: $b3f0fcd8809f5ac4$var$getSelectedText('#vnitrniMaterial', ''),
                cena: vnitrniMaterialVal === 'vlastni' ? +$b3f0fcd8809f5ac4$var$getValue('#vnitrniMaterialCena', 0) : +vnitrniMaterialVal,
                gramaz: vnitrniMaterialVal === 'vlastni' ? +$b3f0fcd8809f5ac4$var$getValue('#vnitrniMaterialGramaz', 0) : +$b3f0fcd8809f5ac4$var$getSelectedAttribute('#vnitrniMaterial', 'data-gramaz', '0'),
                canFlip: vnitrniMaterialVal === 'vlastni' ? true : $b3f0fcd8809f5ac4$var$getSelectedAttribute('#vnitrniMaterial', 'data-obratka', '1') !== '0',
                rozmer: {
                    sirka: +$b3f0fcd8809f5ac4$var$getSelectedAttribute('#vnitrniMaterial', 'data-sirka', '500'),
                    vyska: +$b3f0fcd8809f5ac4$var$getSelectedAttribute('#vnitrniMaterial', 'data-vyska', '707')
                }
            },
            barevnost: $b3f0fcd8809f5ac4$var$getSelectedValue('#vnitrniBarevnost', '4/4'),
            laminace: $b3f0fcd8809f5ac4$var$getSelectedValue('#vnitrniLaminace', '0')
        };
    } else $b3f0fcd8809f5ac4$var$produkt.vazba.vnitrniBlok = null;
    // Načtení podložky (šedá lepenka) – pro lepené bloky a kroužkové vazby
    const isBlokVazba = $b3f0fcd8809f5ac4$var$produkt.vazba.typ === 'blok' || $b3f0fcd8809f5ac4$var$produkt.vazba.typ === 'blokPrebal';
    if ((isBlokVazba || isKrouzekVazba) && $b3f0fcd8809f5ac4$var$getChecked('#vazbaPodlozka', false)) {
        const podlozkaMaterialVal = $b3f0fcd8809f5ac4$var$getSelectedValue('#podlozkaMaterial', '0');
        $b3f0fcd8809f5ac4$var$produkt.vazba.podlozka = {
            enabled: true,
            material: {
                nazev: $b3f0fcd8809f5ac4$var$getSelectedText('#podlozkaMaterial', ''),
                cena: podlozkaMaterialVal === 'vlastni' ? +$b3f0fcd8809f5ac4$var$getValue('#podlozkaMaterialCena', 0) : +podlozkaMaterialVal,
                gramaz: podlozkaMaterialVal === 'vlastni' ? +$b3f0fcd8809f5ac4$var$getValue('#podlozkaMaterialGramaz', 0) : +$b3f0fcd8809f5ac4$var$getSelectedAttribute('#podlozkaMaterial', 'data-gramaz', '0'),
                canFlip: podlozkaMaterialVal === 'vlastni' ? true : $b3f0fcd8809f5ac4$var$getSelectedAttribute('#podlozkaMaterial', 'data-obratka', '1') !== '0',
                rozmer: {
                    sirka: +$b3f0fcd8809f5ac4$var$getSelectedAttribute('#podlozkaMaterial', 'data-sirka', '500'),
                    vyska: +$b3f0fcd8809f5ac4$var$getSelectedAttribute('#podlozkaMaterial', 'data-vyska', '707')
                }
            }
        };
    } else $b3f0fcd8809f5ac4$var$produkt.vazba.podlozka = null;
    // Načtení objednávky
    $b3f0fcd8809f5ac4$var$objednavka.doprava.cena = +$b3f0fcd8809f5ac4$var$getSelectedValue('#doprava', '0');
    $b3f0fcd8809f5ac4$var$objednavka.doprava.text = $b3f0fcd8809f5ac4$var$getSelectedText('#doprava', 'Bez dopravy');
    if ($b3f0fcd8809f5ac4$var$objednavka.doprava.text == 'Bez dopravy') $b3f0fcd8809f5ac4$var$objednavka.doprava.text = "";
    else $b3f0fcd8809f5ac4$var$objednavka.doprava.text = 'Doprava: ' + $b3f0fcd8809f5ac4$var$objednavka.doprava.text + '<br>';
    return {
        produkt: $b3f0fcd8809f5ac4$var$produkt,
        nastaveni: $b3f0fcd8809f5ac4$var$nastaveni,
        zakaznik: $b3f0fcd8809f5ac4$var$zakaznik,
        objednavka: $b3f0fcd8809f5ac4$var$objednavka
    };
}
// Funkce pro komunikaci s backend API
async function $b3f0fcd8809f5ac4$var$calculatePriceAPI(data) {
    try {
        const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/calculate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const result = await response.json();
        return result;
    } catch (error) {
        console.error("Chyba p\u0159i komunikaci s backend API:", error);
        throw error;
    }
}
// Hlavní funkce pro výpočet
async function $b3f0fcd8809f5ac4$var$pocitej() {
    $b3f0fcd8809f5ac4$var$validateDokoncovaciLimity();
    // Dokud není auth ověřený (gate), nevolej kalkulační API – nepřihlášený
    // klient by dostával 401. Po odemčení aplikace se výpočet spustí znovu.
    if (!window.__appReady) return;
    try {
        // Sezbíráme form data
        const formData = $b3f0fcd8809f5ac4$var$gatherForm();
        // Označit výsledky jako "počítám" – obsah NEmažeme (zabrání skoku velikosti),
        // jen ho ztlumíme. Pokud je kostka ještě prázdná (první výpočet), ukážeme spinner.
        $b3f0fcd8809f5ac4$var$setResultUpdating(document.getElementById('mail'), true);
        $b3f0fcd8809f5ac4$var$setResultUpdating(document.getElementById('technicke'), true);
        // Pošleme data na backend
        const result = await $b3f0fcd8809f5ac4$var$calculatePriceAPI(formData);
        if (result.success) {
            // Validace dat z API - ochrana proti null/undefined hodnotám (např. Infinity v JSON)
            const r = result.result;
            if (r.cenaCelkem == null || r.cenaSDphZaKus == null || !isFinite(r.cenaCelkem)) throw new Error("Kalkulace vr\xe1tila neplatn\xe9 hodnoty. Zkontrolujte rozm\u011Bry produktu a zvolenou technologii tisku.");
            // Zobrazíme výsledky s ikonkou copy
            const copyButton = `
        <button type="button" onclick="copyCalculationResult()" class="absolute bottom-2 right-2 p-1 text-gray-400 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 rounded transition-colors">
          ${(0, $entK4.icon)('document-duplicate', 'w-4 h-4')}
        </button>
      `;
            $b3f0fcd8809f5ac4$var$swapResultContent(document.getElementById('mail'), r.textOutput + copyButton);
            $b3f0fcd8809f5ac4$var$swapResultContent(document.getElementById('technicke'), '<p><strong>Info: </strong>' + $b3f0fcd8809f5ac4$var$pripravRozkresHtml(r.debugInfo) + '</p>');
            $b3f0fcd8809f5ac4$var$setResultUpdating(document.getElementById('mail'), false);
            $b3f0fcd8809f5ac4$var$setResultUpdating(document.getElementById('technicke'), false);
            // Mobil výsledek
            const mobilResult = r.cenaCelkem.toLocaleString('cs-CZ') + " K\u010D (<strong>" + r.cenaSDphZaKus.toFixed(2) + " K\u010D/ks</strong>)";
            const mobilCenaEl = document.getElementById('vysledekMobilCena');
            if (mobilCenaEl) mobilCenaEl.innerHTML = mobilResult;
            // Aktualizovat cenu v položkách nabídky
            if (window.offerItemsManager) window.offerItemsManager.updateItemPrice(r.cenaCelkem, r.cenaSDphZaKus, r.debugInfo, r);
        } else throw new Error(result.error || "Nezn\xe1m\xe1 chyba");
    } catch (error) {
        console.error("Chyba p\u0159i v\xfdpo\u010Dtu:", error);
        // Hezké zobrazení chyby s ikonkou varování
        const errorHtml = `
      <div class="bg-red-50 border border-red-200 rounded-lg p-4">
        <div class="flex items-start">
          ${(0, $entK4.icon)('exclamation-triangle', 'w-5 h-5 text-red-500 mt-0.5 mr-3 flex-shrink-0')}
          <div>
            <h3 class="text-sm font-medium text-red-800">Chyba p\u{159}i v\xfdpo\u{10D}tu</h3>
            <p class="text-sm text-red-700 mt-1">${error.message}</p>
          </div>
        </div>
      </div>
    `;
        $b3f0fcd8809f5ac4$var$swapResultContent(document.getElementById('mail'), errorHtml);
        $b3f0fcd8809f5ac4$var$swapResultContent(document.getElementById('technicke'), '');
        $b3f0fcd8809f5ac4$var$setResultUpdating(document.getElementById('mail'), false);
        $b3f0fcd8809f5ac4$var$setResultUpdating(document.getElementById('technicke'), false);
        const mobilCenaErr = document.getElementById('vysledekMobilCena');
        if (mobilCenaErr) mobilCenaErr.innerHTML = '<span class="text-red-500">Chyba</span>';
    }
}
// -- Plynulý překreslení výsledku kalkulace ------------------------------
// Místo toho, abychom při každém přepočtu přepsali #mail/#technicke na
// spinner (obsah zmizí, kostka se zmenší a po odpovědi zas zvětší -> UI skáče),
// necháme starý obsah na místě, jen ho ztlumíme (.is-updating). Nový obsah
// pak vložíme atomicky a pokud se změnila výška, plynule ji animujeme.
// Označí kostku výsledku jako "počítám" (ztlumí obsah). Při prvním výpočtu,
// když je kostka prázdná, vložíme naivní spinner, ať uživatel něco vidí.
function $b3f0fcd8809f5ac4$var$setResultUpdating(el, updating) {
    if (!el) return;
    if (updating && !el.innerHTML.trim()) el.innerHTML = '<div class="calc-spinner" role="status" aria-label="Na\u010D\xedt\xe1m"></div>';
    el.classList.toggle('is-updating', updating);
}
// Atomická výměna obsahu s krátkou animací výšky (height: auto -> px -> auto).
// Pokud se výška nemění, pouze vyměníme obsah bez animace.
function $b3f0fcd8809f5ac4$var$swapResultContent(el, newHtml) {
    if (!el) return;
    // Zrušit případný probíhající přechod z předchozí výměny.
    if (el._swapCleanup) {
        el._swapCleanup();
        el._swapCleanup = null;
    }
    const startHeight = el.offsetHeight;
    // První vyplnění (dosud prázdná / nulová výška) – bez animace.
    if (!el.innerHTML.trim() || startHeight === 0) {
        el.innerHTML = newHtml;
        return;
    }
    // Zafixovat startovní výšku, vyměnit obsah a změřit cílovou výšku.
    el.style.overflow = 'hidden';
    el.style.height = startHeight + 'px';
    el.innerHTML = newHtml;
    const endHeight = el.scrollHeight;
    if (Math.abs(endHeight - startHeight) < 2) {
        el.style.height = '';
        el.style.overflow = '';
        return;
    }
    // Force reflow na startovní výšce, pak přejdeme na cílovou -> animace.
    el.offsetHeight;
    el.style.height = endHeight + 'px';
    const finish = ()=>{
        el.style.height = '';
        el.style.overflow = '';
        el.removeEventListener('transitionend', onTransitionEnd);
        el._swapCleanup = null;
        if (fallbackTimer) {
            clearTimeout(fallbackTimer);
            fallbackTimer = null;
        }
    };
    const onTransitionEnd = (ev)=>{
        if (ev && ev.propertyName !== 'height') return;
        finish();
    };
    el.addEventListener('transitionend', onTransitionEnd);
    // Fallback pro případ, že transitionend nevystřelí (např. zrušená animace).
    let fallbackTimer = setTimeout(finish, 450);
    el._swapCleanup = ()=>{
        el.removeEventListener('transitionend', onTransitionEnd);
        if (fallbackTimer) {
            clearTimeout(fallbackTimer);
            fallbackTimer = null;
        }
    };
}
// Event listenery pro formulář
// Flag: během aplikace rychlé předvolby (applyPreset) tyto "reset na vlastní"
// listenery vypneme, aby nepřepsaly Formát/Materiál nastavený presetem.
window._applyingPreset = false;
document.querySelectorAll('#materialCena, #materialGramaz').forEach(function(item) {
    const resetMaterial = function() {
        if (window._applyingPreset) return;
        document.querySelector('#material').value = 'vlastni';
    };
    item.addEventListener('keyup', resetMaterial);
    item.addEventListener('change', resetMaterial);
});
document.querySelectorAll('#produktRozmerSirka, #produktRozmerVyska').forEach(function(item) {
    const resetFormat = function() {
        if (window._applyingPreset) return;
        document.querySelector('#produktRozmerFormat').value = 'vlastni';
    };
    item.addEventListener('keyup', resetFormat);
    item.addEventListener('change', resetFormat);
});
// Inicializace dropdownu pro rychlý výběr počtu kusů
function $b3f0fcd8809f5ac4$var$setupPocetKusuDropdown() {
    const dropdown = document.getElementById('pocetKusuDropdown');
    const dropdownBtn = document.getElementById('pocetKusuDropdownBtn');
    const input = document.getElementById('pocetKusu');
    const presetButtons = document.querySelectorAll('.pocet-preset');
    if (!dropdown || !dropdownBtn || !input) return;
    // Toggle dropdown při kliknutí na tlačítko
    dropdownBtn.addEventListener('click', (e)=>{
        e.stopPropagation();
        dropdown.classList.toggle('hidden');
    });
    // Nastavení hodnoty při kliknutí na preset
    presetButtons.forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            const value = btn.getAttribute('data-value');
            input.value = value;
            dropdown.classList.add('hidden');
            // Trigger změnu pro přepočítání
            input.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        });
    });
    // Zavření dropdownu při kliknutí mimo
    document.addEventListener('click', (e)=>{
        if (!dropdown.contains(e.target) && e.target !== dropdownBtn) dropdown.classList.add('hidden');
    });
    // Zavření dropdownu při ESC
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && !dropdown.classList.contains('hidden')) dropdown.classList.add('hidden');
    });
}
// Inicializace dropdownu pro rychlý výběr počtu stran vazby
function $b3f0fcd8809f5ac4$var$setupPocetStranDropdown() {
    const dropdown = document.getElementById('pocetStranDropdown');
    const dropdownBtn = document.getElementById('pocetStranDropdownBtn');
    const input = document.getElementById('vazbaPocetStran');
    const presetButtons = document.querySelectorAll('.stran-preset');
    if (!dropdown || !dropdownBtn || !input) return;
    // Toggle dropdown při kliknutí na tlačítko
    dropdownBtn.addEventListener('click', (e)=>{
        e.stopPropagation();
        dropdown.classList.toggle('hidden');
    });
    // Nastavení hodnoty při kliknutí na preset
    presetButtons.forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            const value = btn.getAttribute('data-value');
            input.value = value;
            dropdown.classList.add('hidden');
            // Trigger změnu pro přepočítání a validaci
            input.dispatchEvent(new Event('input', {
                bubbles: true
            }));
            input.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        });
    });
    // Zavření dropdownu při kliknutí mimo
    document.addEventListener('click', (e)=>{
        if (!dropdown.contains(e.target) && e.target !== dropdownBtn) dropdown.classList.add('hidden');
    });
    // Zavření dropdownu při ESC
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && !dropdown.classList.contains('hidden')) dropdown.classList.add('hidden');
    });
}
// Inicializace event listenerů po načtení DOM
document.addEventListener('DOMContentLoaded', ()=>{
    // Změna ve formuláři, počítej znovu
    const vypocetForm = document.querySelector('#vypocet');
    const cenyForm = document.querySelector('#ceny');
    // Debounce – při psaní (keyup) přepočítáme až po 250 ms klidu,
    // aby jsme nezahlcovali backend při rychlém ťukání do číselných polí.
    // Při change (select / blur) přepočítáme okamžitě – uživatel dokončil akci.
    let pocitejTimer = null;
    function debouncedPocitej(delay = 250) {
        if (pocitejTimer) clearTimeout(pocitejTimer);
        pocitejTimer = setTimeout(()=>{
            pocitejTimer = null;
            $b3f0fcd8809f5ac4$var$pocitej();
        }, delay);
    }
    if (vypocetForm) {
        vypocetForm.addEventListener('keyup', function() {
            if (!window._applyingPreset) debouncedPocitej();
        });
        vypocetForm.addEventListener('change', function() {
            if (!window._applyingPreset) $b3f0fcd8809f5ac4$var$pocitej();
        });
    }
    if (cenyForm) {
        cenyForm.addEventListener('keyup', function() {
            if (!window._applyingPreset) debouncedPocitej();
        });
        cenyForm.addEventListener('change', function() {
            if (!window._applyingPreset) $b3f0fcd8809f5ac4$var$pocitej();
        });
    }
    // Pokud je název položky mimo formulář #vypocet, přidej přepočet i na něj
    const nazevInput = document.getElementById('nazev');
    if (nazevInput && !nazevInput.closest('#vypocet')) {
        nazevInput.addEventListener('keyup', function() {
            debouncedPocitej();
        });
        nazevInput.addEventListener('change', function() {
            $b3f0fcd8809f5ac4$var$pocitej();
        });
    }
    // Quick presets – kliknutím na chip nastavíme klíčová pole a přepočítáme
    $b3f0fcd8809f5ac4$var$setupQuickPresets();
    // Progressive disclosure – sbalení sekce "Dokončování"
    $b3f0fcd8809f5ac4$var$setupCollapsibleSections();
    // Inicializace lokálního nastavení technologie tisku
    $b3f0fcd8809f5ac4$var$initTechnologieListener();
    // Počáteční výpočet po načtení stránky
    setTimeout(()=>$b3f0fcd8809f5ac4$var$pocitej(), 500);
    // Event listenery pro profil formulář
    $b3f0fcd8809f5ac4$var$setupProfileFormListeners();
    // Inicializace podmíněných inputů (skrývání/zobrazování)
    $b3f0fcd8809f5ac4$var$setupConditionalInputs();
    // Inicializace dropdownu pro počet kusů
    $b3f0fcd8809f5ac4$var$setupPocetKusuDropdown();
    // Inicializace dropdownu pro počet stran vazby
    $b3f0fcd8809f5ac4$var$setupPocetStranDropdown();
});
// Profile form event listeners
function $b3f0fcd8809f5ac4$var$setupProfileFormListeners() {
    const profileForm = document.getElementById('profile-form');
    const profileCancelBtn = document.getElementById('profile-cancel-btn');
    if (profileForm) profileForm.addEventListener('submit', async (e)=>{
        e.preventDefault();
        const formData = new FormData(profileForm);
        const profileData = {
            name: formData.get('name'),
            email: formData.get('email'),
            phone: formData.get('phone')
        };
        try {
            // Uložit profil (jméno, email, telefon)
            const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/user/profile`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify(profileData)
            });
            const data = await response.json();
            if (response.ok) {
                // Aktualizuj data v localStorage
                const currentUser = JSON.parse(localStorage.getItem('currentUser'));
                currentUser.name = data.data.name;
                currentUser.email = data.data.email;
                currentUser.phone = data.data.phone;
                localStorage.setItem('currentUser', JSON.stringify(currentUser));
                // Aktualizuj currentUser v authManager
                if ($b3f0fcd8809f5ac4$var$authManager) {
                    $b3f0fcd8809f5ac4$var$authManager.currentUser = currentUser;
                    $b3f0fcd8809f5ac4$var$authManager.updateUI();
                }
                // Uložit preference (showHourlyCalc) - oddělený API call
                const showHourlyCalcCheckbox = document.getElementById('profile-show-hourly-calc');
                const showHourlyCalc = showHourlyCalcCheckbox ? showHourlyCalcCheckbox.checked : false;
                const prefsResponse = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/user/preferences`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include',
                    body: JSON.stringify({
                        showHourlyCalc: showHourlyCalc
                    })
                });
                if (prefsResponse.ok) $b3f0fcd8809f5ac4$var$showNotification("Profil a preference byly \xfasp\u011B\u0161n\u011B ulo\u017Eeny", 'success');
                else $b3f0fcd8809f5ac4$var$showNotification(data.message || "Profil ulo\u017Een, ale chyba p\u0159i ukl\xe1d\xe1n\xed preferenc\xed", 'warning');
            } else $b3f0fcd8809f5ac4$var$showNotification(data.message || "Chyba p\u0159i ukl\xe1d\xe1n\xed profilu", 'error');
        } catch (error) {
            console.error("Chyba p\u0159i ukl\xe1d\xe1n\xed profilu:", error);
            $b3f0fcd8809f5ac4$var$showNotification("Chyba spojen\xed se serverem", 'error');
        }
    });
    if (profileCancelBtn) profileCancelBtn.addEventListener('click', ()=>{
        // Znovu načti původní data
        if ($b3f0fcd8809f5ac4$var$authManager && $b3f0fcd8809f5ac4$var$authManager.isLoggedIn()) $b3f0fcd8809f5ac4$var$authManager.loadProfileData();
    });
    // Inicializuj listener pro změnu hesla
    $b3f0fcd8809f5ac4$var$setupPasswordChangeListener();
}
// Nová funkce pro změnu hesla s validací silného hesla
function $b3f0fcd8809f5ac4$var$setupPasswordChangeListener() {
    const changePasswordBtn = document.getElementById('change-password-btn');
    if (changePasswordBtn) changePasswordBtn.addEventListener('click', async ()=>{
        const oldPassword = document.getElementById('profile-old-password').value;
        const newPassword = document.getElementById('profile-new-password').value;
        const confirmPassword = document.getElementById('profile-confirm-password').value;
        // Validace na frontendu
        if (!oldPassword || !newPassword || !confirmPassword) {
            $b3f0fcd8809f5ac4$var$showNotification("Vypl\u0148te v\u0161echna pole", 'warning');
            return;
        }
        // Validace minimální délky
        if (newPassword.length < 8) {
            $b3f0fcd8809f5ac4$var$showNotification("Nov\xe9 heslo mus\xed m\xedt alespo\u0148 8 znak\u016F", 'warning');
            return;
        }
        // Validace malého písmena
        if (!/[a-z]/.test(newPassword)) {
            $b3f0fcd8809f5ac4$var$showNotification("Heslo mus\xed obsahovat alespo\u0148 jedno mal\xe9 p\xedsmeno", 'warning');
            return;
        }
        // Validace velkého písmena
        if (!/[A-Z]/.test(newPassword)) {
            $b3f0fcd8809f5ac4$var$showNotification("Heslo mus\xed obsahovat alespo\u0148 jedno velk\xe9 p\xedsmeno", 'warning');
            return;
        }
        // Validace čísla
        if (!/[0-9]/.test(newPassword)) {
            $b3f0fcd8809f5ac4$var$showNotification("Heslo mus\xed obsahovat alespo\u0148 jedno \u010D\xedslo", 'warning');
            return;
        }
        // Validace speciálního znaku
        if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(newPassword)) {
            $b3f0fcd8809f5ac4$var$showNotification("Heslo mus\xed obsahovat alespo\u0148 jeden speci\xe1ln\xed znak (!@#$%^&* atd.)", 'warning');
            return;
        }
        // Validace shody hesel
        if (newPassword !== confirmPassword) {
            $b3f0fcd8809f5ac4$var$showNotification("Nov\xe1 hesla se neshoduj\xed", 'warning');
            return;
        }
        try {
            const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/user/password`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    oldPassword: oldPassword,
                    newPassword: newPassword
                })
            });
            const data = await response.json();
            if (response.ok) {
                $b3f0fcd8809f5ac4$var$showNotification("Heslo bylo \xfasp\u011B\u0161n\u011B zm\u011Bn\u011Bno", 'success');
                // Vyčisti formulář
                document.getElementById('profile-old-password').value = '';
                document.getElementById('profile-new-password').value = '';
                document.getElementById('profile-confirm-password').value = '';
            } else $b3f0fcd8809f5ac4$var$showNotification(data.message || "Chyba p\u0159i zm\u011Bn\u011B hesla", 'error');
        } catch (error) {
            console.error("Chyba p\u0159i zm\u011Bn\u011B hesla:", error);
            $b3f0fcd8809f5ac4$var$showNotification("Chyba spojen\xed se serverem", 'error');
        }
    });
}
// Správa sekcí hlavního menu
class $b3f0fcd8809f5ac4$var$SectionManager {
    constructor(){
        this.currentSection = 'dashboard';
        this.sections = {
            'dashboard': document.getElementById('dashboard-section'),
            'kalkulator': document.getElementById('kalkulator-section'),
            'nabidky': document.getElementById('nabidky-section'),
            'nabidka-editor': document.getElementById('nabidka-editor-section'),
            'objednavky': document.getElementById('objednavky-section'),
            'vyroba': document.getElementById('vyroba-section'),
            'faktury': document.getElementById('faktury-section'),
            'zakaznici': document.getElementById('zakaznici-section'),
            'zakaznik-detail': document.getElementById('zakaznik-detail-section'),
            'soubory': document.getElementById('soubory-section'),
            'papiry': document.getElementById('papiry-section'),
            'stroje': document.getElementById('stroje-section'),
            'nastaveni': document.getElementById('nastaveni-section'),
            'uzivatele': document.getElementById('uzivatele-section'),
            'ai-asistent': document.getElementById('ai-asistent-section'),
            'profil': document.getElementById('profil-section'),
            'public-offer': document.getElementById('public-offer-section'),
            'public-files': document.getElementById('public-files-section')
        };
        this.menuItems = {
            'dashboard': document.querySelector('[data-section="dashboard"]'),
            'kalkulator': document.querySelector('[data-section="kalkulator"]'),
            'nabidky': document.querySelector('[data-section="nabidky"]'),
            'objednavky': document.querySelector('[data-section="objednavky"]'),
            'vyroba': document.querySelector('[data-section="vyroba"]'),
            'faktury': document.querySelector('[data-section="faktury"]'),
            'zakaznici': document.querySelector('[data-section="zakaznici"]'),
            'soubory': document.querySelector('[data-section="soubory"]'),
            'papiry': document.querySelector('[data-section="papiry"]'),
            'stroje': document.querySelector('[data-section="stroje"]'),
            'nastaveni': document.querySelector('[data-section="nastaveni"]'),
            'uzivatele': document.querySelector('[data-section="uzivatele"]'),
            'ai-asistent': document.querySelector('[data-section="ai-asistent"]')
        };
        // Debug: Zkontroluj jestli jsou všechny sekce a menu položky nalezeny
        console.log('SectionManager - sections:', this.sections);
        console.log('SectionManager - menuItems:', this.menuItems);
        this.init();
    }
    init() {
        // Pokud je to veřejná nabídka, zobraz ji a neinicializuj menu
        if (window.isPublicOfferView) {
            this.switchToSection('public-offer');
            // Inicializovat PublicOfferManager a načíst nabídku
            if (!window.publicOfferManager) window.publicOfferManager = new (0, $48e6b8dca9234cdb$export$75c187d5a2c30495)();
            if (window.publicOfferToken) window.publicOfferManager.loadOfferByToken(window.publicOfferToken);
            return;
        }
        // Pokud je to veřejná stránka souborů, zobraz ji a neinicializuj menu
        if (window.isPublicFilesView) {
            this.switchToSection('public-files');
            if (!window.publicFilesManager) window.publicFilesManager = new (0, $8f203edbe7e377df$export$6bdc5e81a59d859)();
            if (window.publicFilesToken) window.publicFilesManager.loadFilesByToken(window.publicFilesToken);
            return;
        }
        // Přidej event listenery na VŠECHNY menu položky (desktop i mobile)
        Object.keys(this.sections).forEach((sectionId)=>{
            // Přeskoč veřejné sekce (nemají menu)
            if (sectionId === 'public-offer' || sectionId === 'public-files') return;
            // Najdi VŠECHNY elementy s daným data-section atributem
            const menuItems = document.querySelectorAll(`[data-section="${sectionId}"]`);
            // Přidej event listener na každý nalezený element
            menuItems.forEach((menuItem)=>{
                if (menuItem) menuItem.addEventListener('click', (e)=>{
                    e.preventDefault();
                    this.switchToSection(sectionId);
                });
            });
        });
        // Zobraz počáteční sekci
        this.switchToSection('kalkulator');
    }
    switchToSection(sectionId, options = {}) {
        const skipLoad = Boolean(options.skipLoad);
        console.log(`SectionManager.switchToSection called with: ${sectionId}`);
        // Pro veřejné read-only stránky přeskoč kontrolu přihlášení a menu styling
        if (sectionId === 'public-offer' || sectionId === 'public-files') {
            // Skryj všechny sekce pomocí stejné logiky jako pro normální sekce
            Object.values(this.sections).forEach((section)=>{
                if (section) {
                    section.classList.remove('active', 'hidden');
                    section.style.display = '';
                }
            });
            // Zobraz cílovou veřejnou sekci přidáním 'active' třídy
            if (this.sections[sectionId]) this.sections[sectionId].classList.add('active');
            this.currentSection = sectionId;
            window.autoRefreshManager?.setCurrentSection(sectionId);
            return;
        }
        // Kontrola přihlášení pro chráněné sekce
        const protectedSections = [
            'dashboard',
            'nastaveni',
            'uzivatele',
            'nabidky',
            'nabidka-editor',
            'objednavky',
            'vyroba',
            'faktury',
            'zakaznici',
            'zakaznik-detail',
            'soubory',
            'papiry',
            'profil',
            'ai-asistent'
        ];
        if (protectedSections.includes(sectionId) && $b3f0fcd8809f5ac4$var$authManager && !$b3f0fcd8809f5ac4$var$authManager.isLoggedIn()) {
            const sectionNames = {
                'dashboard': 'dashboardu',
                'nastaveni': "nastaven\xed",
                'uzivatele': "spr\xe1v\u011B u\u017Eivatel\u016F",
                'nabidky': "nab\xeddk\xe1m",
                'nabidka-editor': "editoru nab\xeddky",
                'objednavky': "objedn\xe1vk\xe1m",
                'vyroba': "technologick\xfdm list\u016Fm",
                'faktury': "faktur\xe1m",
                'zakaznici': "z\xe1kazn\xedk\u016Fm",
                'zakaznik-detail': "detailu z\xe1kazn\xedka",
                'soubory': "soubor\u016Fm",
                'profil': "nastaven\xed profilu",
                'papiry': "pap\xedr\u016Fm",
                'ai-asistent': 'AI asistentovi'
            };
            console.log(`User not logged in for protected section: ${sectionId}`);
            // Druhá vrstva obrany – nepřihlášený uživatel vidí jen auth gate,
            // sem by se neměl dostat. Jen upozorni a nepřepínej sekci.
            $b3f0fcd8809f5ac4$var$showNotification(`Pro p\u{159}\xedstup k ${sectionNames[sectionId]} se mus\xedte p\u{159}ihl\xe1sit`, 'warning');
            return;
        }
        // Skryj mobilní drawer po kliknutí na menu položku
        if (window.mobileMenu && window.mobileMenu.isVisible()) window.mobileMenu.hide();
        // Skryj všechny sekce pomocí custom CSS tříd
        Object.values(this.sections).forEach((section)=>{
            if (section) {
                section.classList.remove('active', 'hidden');
                // Odstraň inline styles pokud existují
                section.style.display = '';
            }
        });
        // Odstraň aktivní stav ze všech menu položek (Tailwind třídy) - desktop i mobile
        Object.keys(this.sections).forEach((key)=>{
            const allMenuItems = document.querySelectorAll(`[data-section="${key}"]`);
            allMenuItems.forEach((menuItem)=>{
                if (menuItem) {
                    // Odstraň aktivní Tailwind třídy
                    menuItem.classList.remove('text-white', 'bg-blue-600', 'shadow-sm');
                    // Přidej neaktivní Tailwind třídy
                    menuItem.classList.add('text-gray-600', 'hover:text-blue-600', 'hover:bg-blue-50');
                }
            });
        });
        // Resetuj aktivní stav user dropdown tlačítka
        const userDropdownBtn = document.getElementById('user-dropdown-btn');
        if (userDropdownBtn) {
            userDropdownBtn.classList.remove('text-white', 'bg-blue-600', 'shadow-sm');
            userDropdownBtn.classList.add('text-gray-600', 'hover:text-blue-600', 'hover:bg-blue-50');
        }
        // Zobraz aktivní sekci pomocí custom CSS tříd
        const activeSection = this.sections[sectionId];
        console.log(`Active section for ${sectionId}:`, activeSection);
        if (activeSection) {
            activeSection.classList.add('active');
            console.log(`Section ${sectionId} shown - classes:`, activeSection.className);
        } else console.error(`Section ${sectionId} not found!`);
        // Označ aktivní menu položku (Tailwind třídy) - desktop i mobile
        const activeMenuItems = document.querySelectorAll(`[data-section="${sectionId}"]`);
        activeMenuItems.forEach((activeMenuItem)=>{
            if (activeMenuItem) {
                // Odstraň neaktivní Tailwind třídy
                activeMenuItem.classList.remove('text-gray-600', 'hover:text-blue-600', 'hover:bg-blue-50');
                // Přidej aktivní Tailwind třídy
                activeMenuItem.classList.add('text-white', 'bg-blue-600', 'shadow-sm');
            }
        });
        // Pokud je aktivní sekce profil, označ user dropdown jako aktivní
        if (sectionId === 'profil' && userDropdownBtn) {
            userDropdownBtn.classList.remove('text-gray-600', 'hover:text-blue-600', 'hover:bg-blue-50');
            userDropdownBtn.classList.add('text-white', 'bg-blue-600', 'shadow-sm');
        }
        this.currentSection = sectionId;
        window.autoRefreshManager?.setCurrentSection(sectionId);
        // Pokud je aktivní kalkulátor, znovu spustí výpočet
        if (sectionId === 'kalkulator') setTimeout(()=>$b3f0fcd8809f5ac4$var$pocitej(), 100);
        if (!skipLoad) {
            // Pokud je aktivní sekce nabídek, obnovit seznam
            if (sectionId === 'nabidky' && window.offersListManager) window.offersListManager.refresh();
            // Pokud je aktivní sekce zákazníků, načíst a vykreslit
            if (sectionId === 'zakaznici' && window.customersManager) window.customersManager.showSection();
            // Pokud je aktivní sekce objednávek, načíst a vykreslit
            if (sectionId === 'objednavky' && window.ordersListManager) window.ordersListManager.showSection();
            // Pokud je aktivní sekce výroby (technologické listy), načíst a vykreslit
            if (sectionId === 'vyroba' && window.vyrobaManager) window.vyrobaManager.showSection();
            // Pokud je aktivní sekce faktur, načíst a vykreslit
            if (sectionId === 'faktury' && window.invoicesListManager) window.invoicesListManager.showSection();
            // Pokud je aktivní sekce dashboardu, načíst a vykreslit KPI
            if (sectionId === 'dashboard' && window.dashboardManager) window.dashboardManager.showSection();
            // Pokud je aktivní sekce souborů, načíst a vykreslit
            if (sectionId === 'soubory' && window.filesManager) window.filesManager.showSection();
            // Pokud je aktivní sekce nastavení a uživatel je admin, načti API klíče
            // a OAuth klienty (obě sekce + nav skupina jsou data-admin-only).
            if (sectionId === 'nastaveni') {
                const role = window.authManager?.currentUser?.role;
                const isAdmin = role === 'admin';
                document.querySelectorAll('[data-admin-only]').forEach((el)=>{
                    el.classList.toggle('hidden', !isAdmin);
                });
                if (isAdmin) {
                    if (window.apiKeysAdmin) window.apiKeysAdmin.load();
                    if (window.oauthClientsAdmin) window.oauthClientsAdmin.load();
                }
            }
            // Pokud je aktivní sekce uživatelů, načíst a vykreslit
            if (sectionId === 'uzivatele' && window.usersAdmin) window.usersAdmin.showSection();
        }
    }
    // Alias pro switchToSection pro kompatibilitu
    showSection(sectionId, options) {
        this.switchToSection(sectionId, options);
    }
}
// Inicializace správce sekcí (pro všechny stránky včetně veřejné nabídky)
const $b3f0fcd8809f5ac4$var$sectionManager = new $b3f0fcd8809f5ac4$var$SectionManager();
window.sectionManager = $b3f0fcd8809f5ac4$var$sectionManager;
function $b3f0fcd8809f5ac4$var$initSettingsNav() {
    const nav = document.getElementById('settings-nav');
    if (!nav) return;
    const links = Array.from(nav.querySelectorAll('.settings-nav__link'));
    if (!links.length) return;
    const targets = links.map((link)=>{
        const id = link.getAttribute('href')?.replace('#', '');
        const el = id ? document.getElementById(id) : null;
        return el ? {
            link: link,
            el: el
        } : null;
    }).filter(Boolean);
    if (!targets.length) return;
    const setActive = (activeLink)=>{
        links.forEach((l)=>l.classList.remove('is-active'));
        if (activeLink) activeLink.classList.add('is-active');
    };
    // Výchozí aktivní = první dostupný odkaz (typicky "Obecné")
    setActive(targets[0].link);
    links.forEach((link)=>{
        link.addEventListener('click', (e)=>{
            const id = link.getAttribute('href')?.replace('#', '');
            const el = id ? document.getElementById(id) : null;
            if (!el) return;
            e.preventDefault();
            setActive(link);
            el.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
            history.replaceState(null, '', `#${id}`);
        });
    });
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries)=>{
            // Vyber nejvrchnější viditelný cíl
            const visible = entries.filter((en)=>en.isIntersecting).sort((a, b)=>a.boundingClientRect.top - b.boundingClientRect.top);
            if (!visible.length) return;
            const topId = visible[0].target.id;
            const match = targets.find((t)=>t.el.id === topId);
            if (match) setActive(match.link);
        }, {
            rootMargin: '-96px 0px -60% 0px',
            threshold: 0
        });
        targets.forEach((t)=>observer.observe(t.el));
    }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $b3f0fcd8809f5ac4$var$initSettingsNav);
else $b3f0fcd8809f5ac4$var$initSettingsNav();
// Inicializace auth manageru (s error handling) - pouze pokud to není veřejná nabídka
let $b3f0fcd8809f5ac4$var$authManager;
if (!window.isPublicOfferView) try {
    $b3f0fcd8809f5ac4$var$authManager = new $b3f0fcd8809f5ac4$var$AuthManager();
} catch (error) {
    console.error("Chyba p\u0159i inicializaci AuthManager:", error);
    // Vytvoř dummy objekt aby nedošlo k dalším chybám
    $b3f0fcd8809f5ac4$var$authManager = {
        isLoggedIn: ()=>false,
        updateUI: ()=>{},
        getAuthHeaders: ()=>({}),
        showSessionExpiredModal: ()=>{},
        hideSessionExpiredModal: ()=>{}
    };
}
else // Pro veřejnou nabídku vytvoř dummy authManager
$b3f0fcd8809f5ac4$var$authManager = {
    isLoggedIn: ()=>false,
    updateUI: ()=>{},
    getAuthHeaders: ()=>({}),
    showSessionExpiredModal: ()=>{},
    hideSessionExpiredModal: ()=>{}
};
window.authManager = $b3f0fcd8809f5ac4$var$authManager;
// Inicializace správce položek nabídky (pouze pokud to není veřejná nabídka)
let $b3f0fcd8809f5ac4$var$offerItemsManager;
if (!window.isPublicOfferView) try {
    $b3f0fcd8809f5ac4$var$offerItemsManager = new (0, $978543261cadeb8d$export$e516135c113cb170)();
    window.offerItemsManager = $b3f0fcd8809f5ac4$var$offerItemsManager;
} catch (error) {
    console.error("Chyba p\u0159i inicializaci OfferItemsManager:", error);
}
// Inicializace správce seznamu nabídek (pouze pokud to není veřejná nabídka)
let $b3f0fcd8809f5ac4$var$offersListManager;
if (!window.isPublicOfferView) try {
    $b3f0fcd8809f5ac4$var$offersListManager = new (0, $7c4048e26ce185a4$export$66ddce14385f3c96)();
    window.offersListManager = $b3f0fcd8809f5ac4$var$offersListManager;
} catch (error) {
    console.error("Chyba p\u0159i inicializaci OffersListManager:", error);
}
// Inicializace správce editoru nabídky (pouze pokud to není veřejná nabídka)
let $b3f0fcd8809f5ac4$var$offerEditorManager;
if (!window.isPublicOfferView) try {
    $b3f0fcd8809f5ac4$var$offerEditorManager = new (0, $89d32ed16e1177d1$export$9669364b582e5a9e)();
    window.offerEditorManager = $b3f0fcd8809f5ac4$var$offerEditorManager;
} catch (error) {
    console.error("Chyba p\u0159i inicializaci OfferEditorManager:", error);
}
// Inicializace správce zákazníků (pouze pokud to není veřejná nabídka)
let $b3f0fcd8809f5ac4$var$customersManager;
if (!window.isPublicOfferView) try {
    $b3f0fcd8809f5ac4$var$customersManager = new (0, $b9955ebca66af344$export$2bd0f762d756ec28)();
    window.customersManager = $b3f0fcd8809f5ac4$var$customersManager;
} catch (error) {
    console.error("Chyba p\u0159i inicializaci CustomersManager:", error);
}
// Inicializace správce objednávek (pouze pokud to není veřejná nabídka)
let $b3f0fcd8809f5ac4$var$ordersListManager;
if (!window.isPublicOfferView) try {
    $b3f0fcd8809f5ac4$var$ordersListManager = new (0, $c2f7131301a6236c$export$972696b81c05d4f3)();
    window.ordersListManager = $b3f0fcd8809f5ac4$var$ordersListManager;
} catch (error) {
    console.error("Chyba p\u0159i inicializaci OrdersListManager:", error);
}
// Inicializace správce výroby (pouze pokud to není veřejná nabídka)
let $b3f0fcd8809f5ac4$var$vyrobaManager;
if (!window.isPublicOfferView) try {
    $b3f0fcd8809f5ac4$var$vyrobaManager = new (0, $48533a8b43f55ecf$export$ddd6263a5ec85a3d)();
    window.vyrobaManager = $b3f0fcd8809f5ac4$var$vyrobaManager;
} catch (error) {
    console.error("Chyba p\u0159i inicializaci VyrobaManager:", error);
}
// Inicializace správce dashboardu (pouze pokud to není veřejná nabídka)
let $b3f0fcd8809f5ac4$var$dashboardManager;
if (!window.isPublicOfferView && !window.isPublicFilesView) try {
    $b3f0fcd8809f5ac4$var$dashboardManager = new (0, $d61c106ff4296524$export$25a4e4714246e488)();
    window.dashboardManager = $b3f0fcd8809f5ac4$var$dashboardManager;
} catch (error) {
    console.error("Chyba p\u0159i inicializaci DashboardManager:", error);
}
// Inicializace správce faktur (pouze pokud to není veřejná nabídka)
let $b3f0fcd8809f5ac4$var$invoicesListManager;
if (!window.isPublicOfferView) try {
    $b3f0fcd8809f5ac4$var$invoicesListManager = new (0, $948c3369c316bbed$export$3c55d5630281258f)();
    window.invoicesListManager = $b3f0fcd8809f5ac4$var$invoicesListManager;
    // Pro snadný přístup ze customers.js (status meta)
    window.InvoicesListManager = (0, $948c3369c316bbed$export$3c55d5630281258f);
} catch (error) {
    console.error("Chyba p\u0159i inicializaci InvoicesListManager:", error);
}
// Inicializace správce souborů (pouze pokud to není veřejný read-only pohled)
let $b3f0fcd8809f5ac4$var$filesManager;
if (!window.isPublicOfferView && !window.isPublicFilesView) try {
    $b3f0fcd8809f5ac4$var$filesManager = new (0, $02538f383e87444e$export$7d691179cffa4ac0)();
    window.filesManager = $b3f0fcd8809f5ac4$var$filesManager;
} catch (error) {
    console.error("Chyba p\u0159i inicializaci FilesManager:", error);
}
// Inicializace správce API klíčů (admin-only, aktivuje se po prvním otevření
// sekce Nastavení – aby se zbytečně nestahoval seznam před přihlášením).
let $b3f0fcd8809f5ac4$var$apiKeysAdmin;
let $b3f0fcd8809f5ac4$var$oauthClientsAdmin;
if (!window.isPublicOfferView && !window.isPublicFilesView) {
    try {
        $b3f0fcd8809f5ac4$var$apiKeysAdmin = new (0, $e2a4d9e9dccae108$export$be712e1a94688726)();
        window.apiKeysAdmin = $b3f0fcd8809f5ac4$var$apiKeysAdmin;
    } catch (error) {
        console.error("Chyba p\u0159i inicializaci ApiKeysAdmin:", error);
    }
    try {
        $b3f0fcd8809f5ac4$var$oauthClientsAdmin = new (0, $f4a03d91423655c0$export$ba48fe53c6dc330)();
        window.oauthClientsAdmin = $b3f0fcd8809f5ac4$var$oauthClientsAdmin;
    } catch (error) {
        console.error("Chyba p\u0159i inicializaci OAuthClientsAdmin:", error);
    }
}
// Inicializace správce uživatelů (admin only, pouze pokud to není veřejný read-only pohled)
let $b3f0fcd8809f5ac4$var$usersAdmin;
if (!window.isPublicOfferView && !window.isPublicFilesView) try {
    $b3f0fcd8809f5ac4$var$usersAdmin = new (0, $6d164d6d27cb07b0$export$d6f738b7ad05096e)();
    window.usersAdmin = $b3f0fcd8809f5ac4$var$usersAdmin;
} catch (error) {
    console.error("Chyba p\u0159i inicializaci UsersAdmin:", error);
}
// Automatická obnova aktivní sekce (poll + návrat do tabu/focus).
let $b3f0fcd8809f5ac4$var$autoRefreshManager;
if (!window.isPublicOfferView && !window.isPublicFilesView) try {
    $b3f0fcd8809f5ac4$var$autoRefreshManager = (0, $df0e1e63dc461fca$export$e07844b9a297550a)({
        intervalMs: 600000
    });
    window.autoRefreshManager = $b3f0fcd8809f5ac4$var$autoRefreshManager;
    $b3f0fcd8809f5ac4$var$autoRefreshManager.setCurrentSection($b3f0fcd8809f5ac4$var$sectionManager.currentSection);
} catch (error) {
    console.error("Chyba p\u0159i inicializaci AutoRefreshManager:", error);
}
// True push: SSE notifikace změn ze serveru → okamžitý refresh aktivní sekce.
let $b3f0fcd8809f5ac4$var$realtimePushManager;
if (!window.isPublicOfferView && !window.isPublicFilesView) try {
    $b3f0fcd8809f5ac4$var$realtimePushManager = (0, $0d24267c683c7c53$export$4552ecc77aef35b6)({
        onDataChange: (eventPayload)=>{
            window.autoRefreshManager?.handlePushEvent(eventPayload);
        }
    });
    window.realtimePushManager = $b3f0fcd8809f5ac4$var$realtimePushManager;
} catch (error) {
    console.error("Chyba p\u0159i inicializaci RealtimePushManager:", error);
}
// ============================================================================
// MOTIVY – vlastní počty kusů pro jednotlivé druhy/motivy
// Panel se zobrazí při Počet druhů >= 2. Počet kusů se přepne na dopočítanou
// sumu (jeden zdroj pravdy = řádky motivů). Názvy motivů putují do nabídky,
// objednávky i technických listů.
// ============================================================================
function $b3f0fcd8809f5ac4$var$getMotivyRows() {
    const rows = [];
    document.querySelectorAll('#motivy-rows [data-motiv-row]').forEach((row)=>{
        const nazev = row.querySelector('[data-motiv-nazev]')?.value?.trim() || '';
        const pocetKusu = Math.max(0, Math.round(+(row.querySelector('[data-motiv-kusu]')?.value || 0)));
        rows.push({
            nazev: nazev,
            pocetKusu: pocetKusu
        });
    });
    return rows;
}
function $b3f0fcd8809f5ac4$var$updateMotivySum() {
    const rows = $b3f0fcd8809f5ac4$var$getMotivyRows();
    const sum = rows.reduce((a, m)=>a + m.pocetKusu, 0);
    const sumEl = document.getElementById('motivy-celkem');
    if (sumEl) sumEl.textContent = sum;
    const pocetKusuInput = document.getElementById('pocetKusu');
    if (pocetKusuInput && rows.length > 1) pocetKusuInput.value = sum;
    return sum;
}
function $b3f0fcd8809f5ac4$var$renderMotivyPanel(presetMotivy = null) {
    const panel = document.getElementById('motivy-panel');
    const rowsBox = document.getElementById('motivy-rows');
    const pocetDruhuInput = document.getElementById('pocetDruhu');
    const pocetKusuInput = document.getElementById('pocetKusu');
    const pocetKusuDropdownBtn = document.getElementById('pocetKusuDropdownBtn');
    if (!panel || !rowsBox || !pocetDruhuInput || !pocetKusuInput) return;
    const n = Math.max(1, Math.round(+pocetDruhuInput.value || 1));
    if (n < 2) {
        // Zpět na jeden druh: Počet kusů = dosavadní celkový náklad.
        if (!panel.classList.contains('hidden')) {
            const sum = $b3f0fcd8809f5ac4$var$updateMotivySum();
            if (sum > 0) pocetKusuInput.value = sum;
        }
        panel.classList.add('hidden');
        rowsBox.innerHTML = '';
        pocetKusuInput.disabled = false;
        pocetKusuDropdownBtn?.classList.remove('hidden');
        return;
    }
    // Zachovat stávající hodnoty řádků; nové řádky předvyplnit.
    const existing = $b3f0fcd8809f5ac4$var$getMotivyRows();
    const fallbackKusu = existing.length ? existing[existing.length - 1].pocetKusu || 0 : Math.max(0, Math.round(+pocetKusuInput.value || 0));
    const values = [];
    for(let i = 0; i < n; i++){
        if (presetMotivy && presetMotivy[i]) values.push({
            nazev: String(presetMotivy[i].nazev || ''),
            pocetKusu: +presetMotivy[i].pocetKusu || 0
        });
        else if (existing[i]) values.push(existing[i]);
        else values.push({
            nazev: '',
            pocetKusu: fallbackKusu
        });
    }
    rowsBox.innerHTML = values.map((m, i)=>`
    <div data-motiv-row class="grid grid-cols-[24px_minmax(0,1fr)_110px_28px] gap-2 items-center mb-2">
      <span class="text-xs text-blue-700 text-center">${i + 1}</span>
      <input type="text" data-motiv-nazev maxlength="80" placeholder="Motiv ${i + 1} (nap\u{159}. jm\xe9no)" value="${$b3f0fcd8809f5ac4$var$escapeHtml(m.nazev)}"
        class="block w-full px-3 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-white" />
      <input type="number" data-motiv-kusu min="0" value="${m.pocetKusu}"
        class="block w-full px-3 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-white text-right" />
      <button type="button" data-motiv-remove="${i}" aria-label="Odebrat motiv ${i + 1}" class="p-1.5 text-gray-400 hover:text-red-600">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
      </button>
    </div>
  `).join('');
    panel.classList.remove('hidden');
    pocetKusuInput.disabled = true;
    pocetKusuDropdownBtn?.classList.add('hidden');
    $b3f0fcd8809f5ac4$var$updateMotivyRozsahVisibility();
    $b3f0fcd8809f5ac4$var$updateMotivySum();
}
// „Motivy se liší" (jen obálka × obálka i vnitřek) má smysl jen u vazby s jinou
// obálkou/přebalem – u volných listů a vazeb bez oddělené obálky se skrývá.
function $b3f0fcd8809f5ac4$var$updateMotivyRozsahVisibility() {
    const wrapper = document.getElementById('motivy-rozsah-wrapper');
    if (!wrapper) return;
    const typ = document.getElementById('vazba')?.value || '0';
    const druhu = +(document.getElementById('pocetDruhu')?.value || 1);
    const jinaObalka = document.getElementById('vazbaJinaObalka')?.checked || typ === 'blokPrebal';
    wrapper.classList.toggle('hidden', !(typ !== '0' && druhu > 1 && jinaObalka));
}
function $b3f0fcd8809f5ac4$var$setupMotivyPanel() {
    const pocetDruhuInput = document.getElementById('pocetDruhu');
    const rowsBox = document.getElementById('motivy-rows');
    if (!pocetDruhuInput || !rowsBox) return;
    pocetDruhuInput.addEventListener('input', ()=>$b3f0fcd8809f5ac4$var$renderMotivyPanel());
    document.getElementById('vazba')?.addEventListener('change', $b3f0fcd8809f5ac4$var$updateMotivyRozsahVisibility);
    document.getElementById('vazbaJinaObalka')?.addEventListener('change', $b3f0fcd8809f5ac4$var$updateMotivyRozsahVisibility);
    // Suma průběžně při psaní (přepočet zajistí delegace change/keyup na formuláři)
    rowsBox.addEventListener('input', (e)=>{
        if (e.target.matches('[data-motiv-kusu]')) $b3f0fcd8809f5ac4$var$updateMotivySum();
    });
    // Odebrání řádku
    rowsBox.addEventListener('click', (e)=>{
        const btn = e.target.closest('[data-motiv-remove]');
        if (!btn) return;
        const idx = +btn.getAttribute('data-motiv-remove');
        const values = $b3f0fcd8809f5ac4$var$getMotivyRows();
        values.splice(idx, 1);
        pocetDruhuInput.value = Math.max(1, values.length);
        $b3f0fcd8809f5ac4$var$renderMotivyPanel(values.length > 1 ? values : null);
        $b3f0fcd8809f5ac4$var$pocitej();
    });
    document.getElementById('motivy-add')?.addEventListener('click', ()=>{
        pocetDruhuInput.value = Math.max(2, (+pocetDruhuInput.value || 1) + 1);
        $b3f0fcd8809f5ac4$var$renderMotivyPanel();
        $b3f0fcd8809f5ac4$var$pocitej();
    });
    document.getElementById('motivy-rovnomerne')?.addEventListener('click', ()=>{
        const values = $b3f0fcd8809f5ac4$var$getMotivyRows();
        if (values.length < 2) return;
        const sum = values.reduce((a, m)=>a + m.pocetKusu, 0);
        const base = Math.floor(sum / values.length);
        let zbytek = sum - base * values.length;
        const rozdelene = values.map((m)=>({
                ...m,
                pocetKusu: base + (zbytek-- > 0 ? 1 : 0)
            }));
        $b3f0fcd8809f5ac4$var$renderMotivyPanel(rozdelene);
        $b3f0fcd8809f5ac4$var$pocitej();
    });
}
$b3f0fcd8809f5ac4$var$setupMotivyPanel();
window.getMotivyRows = $b3f0fcd8809f5ac4$var$getMotivyRows;
window.renderMotivyPanel = $b3f0fcd8809f5ac4$var$renderMotivyPanel;
// ============================================================================
// SKRÝVÁNÍ ROZKRESU DESEK
// Někoho zajímají jen textová data kalkulace – rozkres vyřazení na desky lze
// skrýt tlačítkem. Volba se pamatuje v sessionStorage a aplikuje se už při
// vykreslení (kvůli animaci výšky výsledku). Do technických listů pro výrobu
// se tlačítko nepropisuje – tam rozkres patří vždy.
// ============================================================================
const $b3f0fcd8809f5ac4$var$ROZKRES_STORAGE_KEY = 'tria-rozkres-desek-skryty';
function $b3f0fcd8809f5ac4$var$jeRozkresSkryty() {
    try {
        return sessionStorage.getItem($b3f0fcd8809f5ac4$var$ROZKRES_STORAGE_KEY) === '1';
    } catch  {
        return false;
    }
}
function $b3f0fcd8809f5ac4$var$nastavRozkresSkryti(rozkresBoxEl, btnEl, skryt) {
    if (!rozkresBoxEl || !btnEl) return;
    rozkresBoxEl.style.display = skryt ? 'none' : '';
    btnEl.textContent = skryt ? "Zobrazit rozkres vy\u0159azen\xed" : "Skr\xfdt rozkres vy\u0159azen\xed";
    btnEl.setAttribute('aria-expanded', skryt ? 'false' : 'true');
}
// Doplní do HTML z kalkulace tlačítko Skrýt/Zobrazit a případně rovnou skryje obsah.
function $b3f0fcd8809f5ac4$var$pripravRozkresHtml(html) {
    const str = String(html || '');
    if (!str.includes('data-rozkres-desek')) return str;
    const wrapper = document.createElement('div');
    wrapper.innerHTML = str;
    const rozkresBox = wrapper.querySelector('[data-rozkres-desek]');
    if (!rozkresBox) return str;
    const controls = document.createElement('div');
    controls.className = 'mt-3 mb-2';
    controls.innerHTML = '<button type="button" data-rozkres-toggle class="inline-flex items-center rounded-md border border-indigo-200 bg-indigo-50 px-2.5 py-1 text-[11px] font-semibold text-indigo-700 hover:bg-indigo-100 transition-colors">Skr\xfdt rozkres vy\u0159azen\xed</button>';
    rozkresBox.parentNode?.insertBefore(controls, rozkresBox);
    const toggleBtn = controls.querySelector('[data-rozkres-toggle]');
    $b3f0fcd8809f5ac4$var$nastavRozkresSkryti(rozkresBox, toggleBtn, $b3f0fcd8809f5ac4$var$jeRozkresSkryty());
    return wrapper.innerHTML;
}
// Delegovaný klik – přežije každou výměnu obsahu #technicke při přepočtu.
document.getElementById('technicke')?.addEventListener('click', (e)=>{
    const btn = e.target.closest('[data-rozkres-toggle]');
    if (!btn) return;
    const rozkresBox = btn.closest('#technicke')?.querySelector('[data-rozkres-desek]');
    if (!rozkresBox) return;
    const maBytSkryty = rozkresBox.style.display !== 'none';
    $b3f0fcd8809f5ac4$var$nastavRozkresSkryti(rozkresBox, btn, maBytSkryty);
    try {
        sessionStorage.setItem($b3f0fcd8809f5ac4$var$ROZKRES_STORAGE_KEY, maBytSkryty ? '1' : '0');
    } catch  {}
});
// Doprava v "Dodání a fakturace" – možnosti a ceny se generují z Nastavení → Doprava.
function $b3f0fcd8809f5ac4$var$updateDopravaOptions() {
    const select = document.getElementById('doprava');
    if (!select) return;
    const g = (id, d)=>{
        const el = document.getElementById(id);
        const v = el ? +el.value : NaN;
        return Number.isFinite(v) ? v : d;
    };
    const osobni = g('dopravaOsobni', 0);
    const zdarmaOd = g('dopravaZdarmaOd', 3000);
    const dpd = g('dopravaDpd', 100);
    const tria = g('dopravaTria', 0);
    const fmt = (c)=>c > 0 ? c + " K\u010D" : 'zdarma';
    const prevIndex = select.selectedIndex;
    const options = [
        '<option value="0">Bez dopravy</option>',
        `<option value="${osobni}">Osobn\xed vyzvednut\xed (${fmt(osobni)})</option>`,
        `<option value="0">DPD (zdarma nad ${zdarmaOd} K\u{10D})</option>`,
        `<option value="${dpd}">DPD z\xe1kladn\xed (${dpd} K\u{10D})</option>`
    ];
    for(let kg = 1; kg <= 7; kg++){
        const cena = g(`dopravaDpdDo${kg}Kg`, 0);
        options.push(`<option value="${cena}">DPD do ${kg} kg (${cena} K\u{10D})</option>`);
    }
    options.push(`<option value="${tria}">Doprava Tria (${fmt(tria)})</option>`);
    select.innerHTML = options.join('');
    if (prevIndex >= 0 && prevIndex < select.options.length) select.selectedIndex = prevIndex;
}
// Validace rozměrových limitů dokončovacích operací (falcování, bigování,
// výsek, předsek, ražba) podle Nastavení. Produkt smí být otočen o 90°.
function $b3f0fcd8809f5ac4$var$validateDokoncovaciLimity() {
    const box = document.getElementById('dokoncovaci-limity-error');
    if (!box) return;
    const sirka = +$b3f0fcd8809f5ac4$var$getValue('#produktRozmerSirka', 0);
    const vyska = +$b3f0fcd8809f5ac4$var$getValue('#produktRozmerVyska', 0);
    if (!sirka || !vyska) {
        box.classList.add('hidden');
        return;
    }
    const g = (id, d)=>{
        const el = document.getElementById(id);
        const v = el ? +el.value : NaN;
        return Number.isFinite(v) ? v : d;
    };
    // [label, aktivní?, minX, minY, maxX, maxY]
    const operace = [
        [
            "Falcov\xe1n\xed",
            $b3f0fcd8809f5ac4$var$getSelectedValue('#falcovani', '0') !== '0',
            g('falcovaniRozmeryMinX', 148),
            g('falcovaniRozmeryMinY', 40),
            g('falcovaniRozmeryMaxZ', 353),
            g('falcovaniRozmeryMaxY', 500)
        ],
        [
            "Bigov\xe1n\xed",
            $b3f0fcd8809f5ac4$var$getSelectedValue('#bigovani', '0') !== '0',
            g('bigovaniRozmeryMinX', 148),
            g('bigovaniRozmeryMinY', 40),
            g('bigovaniRozmeryMaxX', 353),
            g('bigovaniRozmeryMaxY', 500)
        ],
        [
            "V\xfdsek",
            $b3f0fcd8809f5ac4$var$getSelectedValue('#vysek', '0') !== '0',
            g('vysekRozmeryMinX', 0),
            g('vysekRozmeryMinY', 0),
            g('vysekRozmeryMaxX', 500),
            g('vysekRozmeryMaxY', 700)
        ],
        [
            "P\u0159edsek",
            $b3f0fcd8809f5ac4$var$getSelectedValue('#predsek', '0') !== '0',
            g('predsekRozmeryMinX', 0),
            g('predsekRozmeryMinY', 0),
            g('predsekRozmeryMaxX', 500),
            g('predsekRozmeryMaxY', 700)
        ],
        [
            "Ra\u017Eba",
            $b3f0fcd8809f5ac4$var$getSelectedValue('#razba', '0') !== '0',
            g('razbaRozmeryMinX', 0),
            g('razbaRozmeryMinY', 0),
            g('razbaRozmeryMaxX', 350),
            g('razbaRozmeryMaxY', 500)
        ]
    ];
    const fits = (a, b, minX, minY, maxX, maxY)=>a >= minX && b >= minY && a <= maxX && b <= maxY;
    const chyby = [];
    for (const [label, aktivni, minX, minY, maxX, maxY] of operace){
        if (!aktivni) continue;
        // Produkt lze do stroje vložit na šířku i na výšku
        if (!fits(sirka, vyska, minX, minY, maxX, maxY) && !fits(vyska, sirka, minX, minY, maxX, maxY)) chyby.push(`${label}: rozm\u{11B}r ${sirka}\xd7${vyska} mm je mimo povolen\xfd rozsah ${minX}\xd7${minY} a\u{17E} ${maxX}\xd7${maxY} mm.`);
    }
    if (chyby.length) {
        box.innerHTML = "<strong>P\u0159ekro\u010Den\xe9 limity dokon\u010Dovac\xedch operac\xed:</strong><br>" + chyby.join('<br>');
        box.classList.remove('hidden');
    } else box.classList.add('hidden');
}
// Změna cen dopravy v Nastavení se hned promítne do selectu Doprava
document.querySelectorAll('#dopravaOsobni, #dopravaDpd, #dopravaDpdDo1Kg, #dopravaDpdDo2Kg, #dopravaDpdDo3Kg, #dopravaDpdDo4Kg, #dopravaDpdDo5Kg, #dopravaDpdDo6Kg, #dopravaDpdDo7Kg, #dopravaTria, #dopravaZdarmaOd').forEach((el)=>{
    el.addEventListener('change', $b3f0fcd8809f5ac4$var$updateDopravaOptions);
});
// Synchronizace nastavení s kalkulátorem
function $b3f0fcd8809f5ac4$var$synchronizeSettings() {
    const nastaveniForm = document.getElementById('nastaveni-form');
    if (nastaveniForm) {
        // Přidej event listener na všechny input prvky v formuláři nastavení
        // (kromě #technologie, které se ukládá lokálně do sessionStorage)
        const inputs = nastaveniForm.querySelectorAll('input, select');
        inputs.forEach((input)=>{
            if (input.id === 'technologie') return; // Technologie se neukládá na server
            input.addEventListener('change', async ()=>{
                // Uložit nastavení do API
                await $b3f0fcd8809f5ac4$var$saveSettings();
                // Při změně nastavení spusť znovu výpočet
                if ($b3f0fcd8809f5ac4$var$sectionManager.currentSection === 'kalkulator') setTimeout(()=>$b3f0fcd8809f5ac4$var$pocitej(), 100);
            });
        });
    }
}
// Inicializace synchronizace nastavení
$b3f0fcd8809f5ac4$var$synchronizeSettings();
// Konečná inicializace po vytvoření všech objektů
document.addEventListener('DOMContentLoaded', async ()=>{
    // Počkej chvilku než se vytvoří všechny objekty
    await new Promise((resolve)=>setTimeout(resolve, 100));
    // loadSettings() se volá až po ověření session / loginu (unlockApp),
    // protože GET /api/settings vyžaduje přihlášení.
    // Přidat event listenery pro dropdown menu
    const settingsDropdownBtn = document.getElementById('settings-dropdown-btn');
    const materialsDropdownBtn = document.getElementById('materials-dropdown-btn');
    if (settingsDropdownBtn) settingsDropdownBtn.addEventListener('click', $b3f0fcd8809f5ac4$var$toggleSettingsDropdown);
    if (materialsDropdownBtn) materialsDropdownBtn.addEventListener('click', $b3f0fcd8809f5ac4$var$toggleMaterialsDropdown);
});
// Funkce pro ovládání dropdown menu
function $b3f0fcd8809f5ac4$var$toggleSettingsDropdown() {
    const dropdown = document.getElementById('settings-dropdown');
    const button = document.getElementById('settings-dropdown-btn');
    if (dropdown && button) dropdown.classList.toggle('hidden');
}
function $b3f0fcd8809f5ac4$var$toggleMaterialsDropdown() {
    const dropdown = document.getElementById('materials-dropdown');
    const button = document.getElementById('materials-dropdown-btn');
    if (dropdown && button) dropdown.classList.toggle('hidden');
}
// Zavřít dropdown menu při kliknutí mimo
document.addEventListener('click', function(event) {
    const settingsDropdown = document.getElementById('settings-dropdown');
    const materialsDropdown = document.getElementById('materials-dropdown');
    const settingsButton = document.getElementById('settings-dropdown-btn');
    const materialsButton = document.getElementById('materials-dropdown-btn');
    // Zavřít settings dropdown
    if (settingsDropdown && !event.target.closest('#settings-dropdown') && !event.target.closest('#settings-dropdown-btn')) settingsDropdown.classList.add('hidden');
    // Zavřít materials dropdown
    if (materialsDropdown && !event.target.closest('#materials-dropdown') && !event.target.closest('#materials-dropdown-btn')) materialsDropdown.classList.add('hidden');
});
// Funkce pro kopírování výsledku kalkulace
function $b3f0fcd8809f5ac4$var$copyCalculationResult() {
    const resultElement = document.getElementById('mail');
    if (!resultElement) return;
    // Získat textový obsah výsledku (bez HTML tagů)
    const textToCopy = resultElement.innerText || resultElement.textContent;
    if (!textToCopy || textToCopy.trim() === '') {
        $b3f0fcd8809f5ac4$var$showNotification("\u017D\xe1dn\xfd v\xfdsledek kalkulace ke kop\xedrov\xe1n\xed", 'warning');
        return;
    }
    // Zkusit použít moderní Clipboard API
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(textToCopy).then(()=>{
        $b3f0fcd8809f5ac4$var$showNotification("V\xfdsledek kalkulace zkop\xedrov\xe1n do schr\xe1nky", 'success');
    }).catch((err)=>{
        console.error("Chyba p\u0159i kop\xedrov\xe1n\xed:", err);
        $b3f0fcd8809f5ac4$var$fallbackCopyTextToClipboard(textToCopy);
    });
    else // Fallback pro starší prohlížeče
    $b3f0fcd8809f5ac4$var$fallbackCopyTextToClipboard(textToCopy);
}
// Fallback funkce pro kopírování (pro starší prohlížeče)
function $b3f0fcd8809f5ac4$var$fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        const successful = document.execCommand('copy');
        if (successful) $b3f0fcd8809f5ac4$var$showNotification("V\xfdsledek kalkulace zkop\xedrov\xe1n do schr\xe1nky", 'success');
        else $b3f0fcd8809f5ac4$var$showNotification("Nepoda\u0159ilo se zkop\xedrovat v\xfdsledek", 'error');
    } catch (err) {
        console.error("Chyba p\u0159i kop\xedrov\xe1n\xed:", err);
        $b3f0fcd8809f5ac4$var$showNotification("Nepoda\u0159ilo se zkop\xedrovat v\xfdsledek", 'error');
    }
    document.body.removeChild(textArea);
}
// Funkce pro skrývání/zobrazování doplňkových inputů
function $b3f0fcd8809f5ac4$var$setupConditionalInputs() {
    // Výsek - skryj/zobraz "Pozic na raznici" a "Cena raznice"
    const vysekSelect = document.getElementById('vysek');
    const vysekInputsContainer = document.querySelector('.vysek-extra');
    // Předsek - skryj/zobraz "Pozic na raznici" a "Cena raznice"  
    const predsekSelect = document.getElementById('predsek');
    const predsekInputsContainer = document.querySelector('.predsek-extra');
    // Ražba - skryj/zobraz "Pozic na štočku" a "Cena štočku"
    const razbaSelect = document.getElementById('razba');
    const razbaInputsContainer = document.querySelector('.razba-extra');
    // Vazba - skryj/zobraz všechny vazebné inputy
    const vazbaSelect = document.getElementById('vazba');
    const vazbaInputsContainers = document.querySelectorAll('.vazba-inputs');
    // Lepení - skryj/zobraz "Počet lepení/kus"
    const lepeniSelect = document.getElementById('lepeni');
    const lepeniPocetContainer = document.getElementById('lepeniPocet')?.parentElement;
    function toggleInputsVisibility(selectElement, inputsContainer, defaultValue) {
        if (!selectElement || !inputsContainer) {
            console.warn('Element not found for conditional inputs:', selectElement, inputsContainer);
            return;
        }
        const isDefaultSelected = selectElement.value === defaultValue;
        if (isDefaultSelected) inputsContainer.classList.add('hidden');
        else inputsContainer.classList.remove('hidden');
    }
    function toggleMultipleInputsVisibility(selectElement, inputsContainers, defaultValue) {
        if (!selectElement || !inputsContainers || inputsContainers.length === 0) {
            console.warn('Element not found for conditional inputs:', selectElement, inputsContainers);
            return;
        }
        const isDefaultSelected = selectElement.value === defaultValue;
        inputsContainers.forEach((container)=>{
            if (isDefaultSelected) container.classList.add('hidden');
            else container.classList.remove('hidden');
        });
    }
    // Nastavit počáteční stav a event listenery
    if (vysekSelect && vysekInputsContainer) {
        toggleInputsVisibility(vysekSelect, vysekInputsContainer, '0');
        vysekSelect.addEventListener('change', ()=>{
            toggleInputsVisibility(vysekSelect, vysekInputsContainer, '0');
        });
    }
    if (predsekSelect && predsekInputsContainer) {
        toggleInputsVisibility(predsekSelect, predsekInputsContainer, '0');
        predsekSelect.addEventListener('change', ()=>{
            toggleInputsVisibility(predsekSelect, predsekInputsContainer, '0');
        });
    }
    if (razbaSelect && razbaInputsContainer) {
        toggleInputsVisibility(razbaSelect, razbaInputsContainer, '0');
        razbaSelect.addEventListener('change', ()=>{
            toggleInputsVisibility(razbaSelect, razbaInputsContainer, '0');
        });
    }
    if (lepeniSelect && lepeniPocetContainer) {
        toggleInputsVisibility(lepeniSelect, lepeniPocetContainer, '0');
        lepeniSelect.addEventListener('change', ()=>{
            toggleInputsVisibility(lepeniSelect, lepeniPocetContainer, '0');
        });
    }
    // Vazba - skrývání inputů při volbě "Bez vazby"
    if (vazbaSelect && vazbaInputsContainers.length > 0) {
        toggleMultipleInputsVisibility(vazbaSelect, vazbaInputsContainers, '0');
        vazbaSelect.addEventListener('change', ()=>{
            toggleMultipleInputsVisibility(vazbaSelect, vazbaInputsContainers, '0');
        });
    }
    // Vazba UI - info box, validace, toggle
    $b3f0fcd8809f5ac4$var$setupVazbaUI();
    $b3f0fcd8809f5ac4$var$setupVnitrniMaterialSync();
    $b3f0fcd8809f5ac4$var$setupPodlozkaMaterialSync();
    $b3f0fcd8809f5ac4$var$setupPriceCharts();
}
// ============================================================================
// Vývoj ceny podle počtu kusů – univerzální grafy (shared/price-chart.js)
// ============================================================================
// Grafy se načítají líně – až po kliknutí na tlačítko s ikonou grafu:
//  - kalkulátor (#pocetKusuChartBtn): kompletní kalkulace položky přes
//    POST /api/calculate/curve (vazba, dokončování, volba ofset/digitál)
//  - Nastavení ([data-price-chart]): křivky ceníků vazby počítané klientsky
//    ze vzorce a aktuálních hodnot formuláře
function $b3f0fcd8809f5ac4$var$setupPriceCharts() {
    document.getElementById('pocetKusuChartBtn')?.addEventListener('click', $b3f0fcd8809f5ac4$var$openCalculatorPriceChart);
    document.querySelectorAll('[data-price-chart]').forEach((btn)=>{
        btn.addEventListener('click', ()=>$b3f0fcd8809f5ac4$var$openSettingsPriceChart(btn.dataset.priceChart));
    });
}
const $b3f0fcd8809f5ac4$var$CHART_SAMPLES = [
    100,
    250,
    500,
    1000,
    2000
];
/** Graf ceníku v Nastavení – vzorce odpovídají backend/calc/calc-vazba.js. */ function $b3f0fcd8809f5ac4$var$openSettingsPriceChart(kind) {
    const v = (id, d)=>+$b3f0fcd8809f5ac4$var$getValue('#' + id, d);
    if (kind === 'v1') {
        const stran = 32;
        const fnStrojni = (n)=>v('vazbaV1StrojniPriprava', 200) + v('vazbaV1StrojniCenaZaKus', 0.6) * n;
        const fnRucni = (n)=>v('vazbaV1RucniPriprava', 100) + v('vazbaV1RucniCenaZaKus', 1.6) * n + n * stran * v('vazbaV1RucniCenaZaStranu', 0.3) / 4;
        (0, $163b6a16f9b4a0d7$export$b9a65a2741894972)({
            title: "V1 (\u0161it\xe1 skobou) \u2013 v\xfdvoj ceny",
            subtitle: `Podle aktu\xe1ln\xedch hodnot v Nastaven\xed \xb7 ru\u{10D}n\xed \u{161}it\xed po\u{10D}\xedt\xe1no p\u{159}i ${stran} stran\xe1ch`,
            load: ()=>({
                    series: [
                        {
                            label: "V1 strojn\xed",
                            points: (0, $163b6a16f9b4a0d7$export$8aaec4f23b1a26c8)(fnStrojni, 2000)
                        },
                        {
                            label: `V1 ru\u{10D}n\u{11B} (${stran} stran)`,
                            points: (0, $163b6a16f9b4a0d7$export$8aaec4f23b1a26c8)(fnRucni, 2000)
                        }
                    ]
                })
        });
        return;
    }
    if (kind === 'krouzek') {
        const stupne = [
            [
                'A7',
                "do 105\xd774 mm"
            ],
            [
                'A6',
                "do 105\xd7148 mm"
            ],
            [
                'A5',
                "do 210\xd7148 mm"
            ],
            [
                'A4',
                "do 210\xd7297 mm"
            ],
            [
                'A3',
                "do 420\xd7594 mm"
            ]
        ];
        (0, $163b6a16f9b4a0d7$export$b9a65a2741894972)({
            title: "Krou\u017Ekov\xe1 twin wire \u2013 v\xfdvoj ceny",
            subtitle: "Podle aktu\xe1ln\xedch hodnot v Nastaven\xed \xb7 jedna k\u0159ivka na rozm\u011Brov\xfd stupe\u0148",
            load: ()=>({
                    series: stupne.map(([kod, label])=>({
                            label: `${kod} (${label})`,
                            points: (0, $163b6a16f9b4a0d7$export$8aaec4f23b1a26c8)((n)=>v(`vazbaKrouzekBlok${kod}Priprava`, 200) + v(`vazbaKrouzekBlok${kod}CenaZaKus`, 12) * n, 1000)
                        }))
                })
        });
        return;
    }
    if (kind === 'kalendar') {
        const fn = (n)=>v('vazbaKrouzekKalendarPriprava', 200) + v('vazbaKrouzekKalendarCenaZaKus', 14) * n;
        (0, $163b6a16f9b4a0d7$export$b9a65a2741894972)({
            title: "Krou\u017Ekov\xe1 s h\xe1\u010Dkem \u2013 v\xfdvoj ceny",
            subtitle: "Podle aktu\xe1ln\xedch hodnot v Nastaven\xed",
            load: ()=>({
                    series: [
                        {
                            label: "Krou\u017Ekov\xe1 s h\xe1\u010Dkem",
                            points: (0, $163b6a16f9b4a0d7$export$8aaec4f23b1a26c8)(fn, 1000)
                        }
                    ],
                    chips: (0, $163b6a16f9b4a0d7$export$e33a53994a07f308)(fn, [
                        50,
                        100,
                        250,
                        500,
                        1000
                    ])
                })
        });
        return;
    }
    if (kind === 'v2pur') {
        const cenik = {
            priprava: v('vazbaV2PurPriprava', 400),
            kusStart: v('vazbaV2PurKusStart', 14),
            kusKonec: v('vazbaV2PurKusKonec', 8),
            prah: Math.max(v('vazbaV2PurPrah', 200), 1),
            utlum: Math.max(v('vazbaV2PurUtlum', 300), 1)
        };
        const fn = (n)=>(0, $163b6a16f9b4a0d7$export$3f24e24def8ba421)(n, cenik);
        const maxN = 2500;
        const asymptota = (n)=>cenik.priprava + (cenik.kusStart - cenik.kusKonec) * (cenik.prah + cenik.utlum) + cenik.kusKonec * n;
        (0, $163b6a16f9b4a0d7$export$b9a65a2741894972)({
            title: "V2 lepen\xe1 (PUR) \u2013 v\xfdvoj ceny",
            subtitle: "Podle aktu\xe1ln\xedch hodnot v Nastaven\xed \xb7 p\u0159eru\u0161ovan\u011B: pr\xe1h a asymptota koncov\xe9 sazby",
            load: ()=>({
                    series: [
                        {
                            label: 'V2 PUR',
                            points: (0, $163b6a16f9b4a0d7$export$8aaec4f23b1a26c8)(fn, maxN)
                        }
                    ],
                    markers: [
                        {
                            x: cenik.prah,
                            label: `pr\xe1h ${cenik.prah.toLocaleString('cs-CZ')} ks`
                        }
                    ],
                    extraLines: [
                        {
                            x1: cenik.prah,
                            y1: asymptota(cenik.prah),
                            x2: maxN,
                            y2: asymptota(maxN)
                        }
                    ],
                    chips: (0, $163b6a16f9b4a0d7$export$e33a53994a07f308)(fn, $b3f0fcd8809f5ac4$var$CHART_SAMPLES)
                })
        });
    }
}
/** Graf vývoje celkové ceny aktuální položky v kalkulátoru (počítá backend). */ function $b3f0fcd8809f5ac4$var$openCalculatorPriceChart() {
    const formData = $b3f0fcd8809f5ac4$var$gatherForm();
    const n0 = Math.max(1, Math.round(+formData.produkt.pocetKusu || 1));
    const mults = [
        0.1,
        0.2,
        0.35,
        0.5,
        0.65,
        0.8,
        0.9,
        1,
        1.15,
        1.35,
        1.6,
        2,
        2.5,
        3,
        4,
        5
    ];
    const serie = [
        ...new Set(mults.map((m)=>Math.max(1, Math.round(n0 * m))))
    ].sort((a, b)=>a - b);
    const fmt = (val)=>Math.round(val).toLocaleString('cs-CZ');
    (0, $163b6a16f9b4a0d7$export$b9a65a2741894972)({
        title: "V\xfdvoj ceny podle po\u010Dtu kus\u016F",
        subtitle: (formData.produkt.nazev ? `${formData.produkt.nazev} \xb7 ` : '') + "kompletn\xed kalkulace polo\u017Eky v\u010D. dokon\u010Dov\xe1n\xed a volby technologie",
        load: async ()=>{
            const response = await fetch(`${$b3f0fcd8809f5ac4$var$API_BASE_URL}/calculate/curve`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ...formData,
                    pocetKusuSerie: serie
                })
            });
            const json = await response.json();
            if (!json.success) throw new Error(json.error || "V\xfdpo\u010Det cenov\xe9 k\u0159ivky selhal");
            const pts = json.data.filter((p)=>!p.error);
            if (!pts.length) throw new Error((json.data.find((p)=>p.error) || {}).error || "\u017D\xe1dn\xfd platn\xfd bod k\u0159ivky");
            // Markery: aktuální náklad + místa, kde se mění technologie tisku
            const markers = [
                {
                    x: n0,
                    label: `aktu\xe1ln\u{11B} ${fmt(n0)} ks`
                }
            ];
            for(let i = 1; i < pts.length; i++)if (pts[i].technologie && pts[i - 1].technologie && pts[i].technologie !== pts[i - 1].technologie) markers.push({
                x: pts[i].pocetKusu,
                label: `\u{2192} ${pts[i].technologie}`
            });
            // Čipy: rovnoměrný výběr max 6 bodů, aktuální náklad zvýrazněný
            const idx = new Set([
                0,
                pts.length - 1
            ]);
            for(let k = 1; k <= 4; k++)idx.add(Math.round(k * (pts.length - 1) / 5));
            const chips = [
                ...idx
            ].sort((a, b)=>a - b).map((i)=>({
                    label: `${fmt(pts[i].pocetKusu)} ks`,
                    value: `${fmt(pts[i].cenaCelkem)} K\u{10D}`,
                    sub: `(${(pts[i].cenaCelkem / pts[i].pocetKusu).toFixed(2)} K\u{10D}/ks${pts[i].technologie ? ` \xb7 ${pts[i].technologie}` : ''})`,
                    highlight: pts[i].pocetKusu === n0
                }));
            return {
                series: [
                    {
                        label: 'Cena celkem (bez DPH)',
                        points: pts.map((p)=>({
                                x: p.pocetKusu,
                                y: p.cenaCelkem,
                                meta: {
                                    technologie: p.technologie
                                }
                            }))
                    }
                ],
                markers: markers,
                chips: chips
            };
        }
    });
}
// ============================================================================
// VAZBA UI - Info box, validace, toggle obálka/vnitřní blok
// ============================================================================
const $b3f0fcd8809f5ac4$var$VAZBA_CONFIG = {
    'V1-strojni': {
        nazev: "V1 (2 skoby) strojn\xed",
        minSirka: 99,
        minVyska: 148,
        maxSirka: 300,
        maxVyska: 300,
        maxStran: 72,
        orientace: "del\u0161\xed i krat\u0161\xed strana",
        tisk: null,
        popis: null
    },
    'V1-rucni': {
        nazev: "V1 (2 skoby) ru\u010Dn\u011B",
        minSirka: 50,
        minVyska: 110,
        maxSirka: 220,
        maxVyska: 307,
        maxStran: 110,
        orientace: "del\u0161\xed i krat\u0161\xed strana",
        tisk: null,
        popis: null
    },
    'blok': {
        nazev: "Lepen\xfd blok",
        minSirka: 74,
        minVyska: 105,
        maxSirka: 210,
        maxVyska: 297,
        maxStran: null,
        orientace: null,
        tisk: null,
        popis: null
    },
    'blokPrebal': {
        nazev: "Lepen\xfd blok s p\u0159ebalem",
        minSirka: 74,
        minVyska: 105,
        maxSirka: 210,
        maxVyska: 297,
        maxStran: null,
        orientace: null,
        tisk: null,
        popis: null
    },
    'V2-PUR': {
        nazev: "V2 lepen\xe1 (PUR)",
        minSirka: 105,
        minVyska: 148,
        maxSirka: 210,
        maxVyska: 297,
        maxStran: null,
        orientace: null,
        tisk: null,
        popis: "H\u0159bet: 4\u201330 mm"
    },
    'krouzek-blok': {
        nazev: "Krou\u017Ekov\xe1 twin wire",
        minSirka: 74,
        minVyska: 105,
        maxSirka: 420,
        maxVyska: 594,
        maxStran: null,
        orientace: null,
        tisk: "jednotliv\xe9 listy (ne p\u0159elo\u017Een\xe9)",
        popis: "Cena vazby podle rozm\u011Bru: do A7, A6, A5, A4, A3. Min. rozm\u011Br A7 (105\xd774 mm)."
    },
    'krouzek-kalendar': {
        nazev: "Krou\u017Ekov\xe1 s h\xe1\u010Dkem na pov\u011B\u0161en\xed",
        minSirka: 74,
        minVyska: 105,
        maxSirka: 420,
        maxVyska: 594,
        maxStran: null,
        orientace: null,
        tisk: "jednotliv\xe9 listy (ne p\u0159elo\u017Een\xe9)",
        popis: "V\u010Detn\u011B h\xe1\u010Dku na pov\u011B\u0161en\xed. Min. rozm\u011Br A7 (105\xd774 mm)."
    }
};
function $b3f0fcd8809f5ac4$var$setupVazbaUI() {
    const vazbaSelect = document.getElementById('vazba');
    const infoBox = document.getElementById('vazba-info-box');
    const maxStranHint = document.getElementById('vazba-max-stran-hint');
    const stranError = document.getElementById('vazba-stran-error');
    const rozmeryError = document.getElementById('vazba-rozmery-error');
    const pocetStranInput = document.getElementById('vazbaPocetStran');
    const pocetStranLabel = document.getElementById('vazba-pocet-stran-label');
    const pocetStranHelp = document.getElementById('vazba-pocet-stran-help');
    const vnitrniTiskSelect = document.getElementById('vazbaVnitrniTisk');
    const vnitrniTiskJinaOption = vnitrniTiskSelect?.querySelector('option[value="jina"]');
    const vnitrniTiskStejnaOption = vnitrniTiskSelect?.querySelector('option[value="stejna"]');
    const toggle = document.getElementById('vazbaJinaObalka');
    const obalkaZadaSelect = document.getElementById('vazbaObalkaZada');
    const jinaObalkaWrapper = document.getElementById('vazba-jina-obalka-wrapper');
    const vnitrniBlokSection = document.getElementById('vazba-vnitrni-blok-section');
    const obalkaTitle = document.getElementById('vazba-obalka-title');
    const podlozkaSection = document.getElementById('vazba-podlozka-section');
    if (!vazbaSelect || !infoBox) return;
    // Aktualizace info boxu podle zvoleného typu vazby
    function updateInfoBox() {
        const typ = vazbaSelect.value;
        if (typ === '0') {
            infoBox.classList.add('hidden');
            return;
        }
        const config = $b3f0fcd8809f5ac4$var$VAZBA_CONFIG[typ];
        if (!config) {
            infoBox.classList.add('hidden');
            return;
        }
        let html = '<div class="flex items-start">' + (0, $entK4.icon)('information-circle', 'w-5 h-5 mr-2 mt-0.5 flex-shrink-0 text-amber-600') + '<div>';
        html += '<p class="font-semibold text-amber-800 mb-1">' + config.nazev + '</p>';
        html += '<p class="text-amber-700">Rozm\u011Bry: ' + config.minSirka + "\xd7" + config.minVyska + " mm a\u017E " + config.maxSirka + "\xd7" + config.maxVyska + ' mm</p>';
        if (config.maxStran) {
            const jednotkyInfo = (0, $464a82d0a054b7a0$export$4b295968f122e918)(typ);
            const vcetne = jednotkyInfo.unit === 'listy' ? "(v\u010Detn\u011B ob\xe1lkov\xfdch list\u016F)" : "(v\u010Detn\u011B ob\xe1lky)";
            html += '<p class="text-amber-700">Max. po\u010Det ' + jednotkyInfo.slovo + ': ' + config.maxStran + ' ' + vcetne + '</p>';
        }
        if (config.orientace) html += '<p class="text-amber-700">Orientace: ' + config.orientace + '</p>';
        if (config.tisk) html += '<p class="text-amber-700">Tisk: ' + config.tisk + '</p>';
        if (config.popis) html += '<p class="text-amber-700">' + config.popis + '</p>';
        html += '</div></div>';
        infoBox.innerHTML = html;
        infoBox.classList.remove('hidden');
    }
    // Validace rozměrů produktu vůči omezením vazby
    function validateDimensions() {
        const typ = vazbaSelect.value;
        if (typ === '0' || !rozmeryError) return;
        const config = $b3f0fcd8809f5ac4$var$VAZBA_CONFIG[typ];
        if (!config) {
            rozmeryError.classList.add('hidden');
            return;
        }
        const sirka = +(document.getElementById('produktRozmerSirka')?.value || 0);
        const vyska = +(document.getElementById('produktRozmerVyska')?.value || 0);
        if (sirka === 0 && vyska === 0) {
            rozmeryError.classList.add('hidden');
            return;
        }
        // Kontrola s flexibilní orientací (kratší strana = šířka, delší = výška)
        const prodMin = Math.min(sirka, vyska);
        const prodMax = Math.max(sirka, vyska);
        const vazbaMin = Math.min(config.minSirka, config.minVyska);
        const vazbaMax = Math.max(config.minSirka, config.minVyska);
        const vazbaMaxMin = Math.min(config.maxSirka, config.maxVyska);
        const vazbaMaxMax = Math.max(config.maxSirka, config.maxVyska);
        const tooSmall = prodMin < vazbaMin || prodMax < vazbaMax;
        const tooBig = prodMin > vazbaMaxMin || prodMax > vazbaMaxMax;
        if (tooSmall || tooBig) {
            rozmeryError.textContent = "Rozm\u011Bry " + sirka + "\xd7" + vyska + ' mm jsou mimo rozsah pro ' + config.nazev + ' (' + config.minSirka + "\xd7" + config.minVyska + " a\u017E " + config.maxSirka + "\xd7" + config.maxVyska + ' mm)';
            rozmeryError.classList.remove('hidden');
        } else rozmeryError.classList.add('hidden');
    }
    // Validace počtu stran
    function validatePages() {
        const typ = vazbaSelect.value;
        if (typ === '0') {
            if (maxStranHint) maxStranHint.textContent = '';
            if (stranError) stranError.classList.add('hidden');
            return;
        }
        const config = $b3f0fcd8809f5ac4$var$VAZBA_CONFIG[typ];
        if (!config) return;
        const pocetStran = +(pocetStranInput?.value || 0);
        if (config.maxStran && maxStranHint) maxStranHint.textContent = '(max. ' + config.maxStran + ')';
        else if (maxStranHint) maxStranHint.textContent = '';
        const slovo = (0, $464a82d0a054b7a0$export$4b295968f122e918)(typ).slovo;
        const nasobekChyba = (0, $464a82d0a054b7a0$export$9993a9b4228961d8)(typ, pocetStran);
        if (config.maxStran && pocetStran > config.maxStran && stranError) {
            stranError.textContent = "Maxim\xe1ln\xed po\u010Det " + slovo + ' pro ' + config.nazev + ' je ' + config.maxStran;
            stranError.classList.remove('hidden');
        } else if (nasobekChyba && stranError) {
            stranError.textContent = nasobekChyba;
            stranError.classList.remove('hidden');
        } else if (stranError) stranError.classList.add('hidden');
        updatePocetStranHelp(typ);
    }
    // Toggle: Jiná obálka než vnitřní blok
    function handleObalkaToggle() {
        if (!toggle || !vnitrniBlokSection || !obalkaTitle) return;
        const typ = vazbaSelect.value;
        const isBlok = typ === 'blok' || typ === 'blokPrebal';
        const isKrouzek = typ.startsWith('krouzek');
        if (toggle.checked) {
            vnitrniBlokSection.classList.remove('hidden');
            obalkaTitle.textContent = "Ob\xe1lka";
            // Naplnit cenu a gramáž z aktuálně vybrané option
            $b3f0fcd8809f5ac4$var$syncVnitrniMaterialInputs();
        } else {
            vnitrniBlokSection.classList.add('hidden');
            obalkaTitle.textContent = "Ob\xe1lka a vnit\u0159n\xed blok";
        }
        // Rozsah obálky (předek i záda / jen přední) – jen kroužková s jinou obálkou
        const obalkaZadaWrapper = document.getElementById('vazba-obalka-zada-wrapper');
        if (obalkaZadaWrapper) {
            const isKrouzekType = vazbaSelect.value.startsWith('krouzek');
            obalkaZadaWrapper.classList.toggle('hidden', !(isKrouzekType && toggle.checked));
        }
        updatePocetStranHelp(typ, isBlok, isKrouzek);
    }
    // Aktualizace UI pro vazbu:
    // - u lepených bloků ('blok', 'blokPrebal') je "Počet stran" ve skutečnosti počet listů
    // - přepínač "Jiná obálka" je dostupný pro všechny typy vazby kromě "Bez vazby"
    // - podložka (šedá lepenka) je dostupná pouze pro lepené bloky
    function updatePocetStranHelp(typ) {
        if (!pocetStranHelp) return;
        if (!typ || typ === '0') {
            pocetStranHelp.textContent = '';
            return;
        }
        const hasJinaObalka = !!toggle?.checked;
        const maObalkaZada = (obalkaZadaSelect?.value || 'ano') === 'ano';
        const hodnota = +(pocetStranInput?.value || 0);
        // Primárně živý přepočet zadaného čísla (strany ↔ listy/složky).
        // Zákazník i obchodník hned vidí, jestli aplikace chápe totéž co on.
        const prepocet = (0, $464a82d0a054b7a0$export$b435a2b6fffcb71b)(typ, hodnota, {
            jinaObalka: hasJinaObalka,
            obalkaZada: maObalkaZada
        });
        if (prepocet) {
            pocetStranHelp.textContent = prepocet;
            return;
        }
        // Fallback (prázdné pole / neplatný násobek): obecné vysvětlení jednotky
        const meta = (0, $464a82d0a054b7a0$export$4b295968f122e918)(typ);
        if (meta.unit === 'listy') pocetStranHelp.textContent = typ === 'blok' || typ === 'blokPrebal' ? "Zadejte po\u010Det list\u016F vnit\u0159n\xedho bloku (1 list = 2 strany, l\xedc a rub)." : "Zadejte po\u010Det list\u016F v\u010Detn\u011B ob\xe1lkov\xfdch (1 list = 2 strany, l\xedc a rub).";
        else if (meta.nasobek === 4) pocetStranHelp.textContent = "Zadejte po\u010Det stran v\u010Detn\u011B ob\xe1lky \u2013 n\xe1sobek 4 (1 p\u0159elo\u017Een\xfd list / slo\u017Eka = 4 strany).";
        else pocetStranHelp.textContent = "Zadejte po\u010Det stran v\u010Detn\u011B ob\xe1lky \u2013 n\xe1sobek 2 (1 list = 2 strany).";
    }
    function updateBlokUI() {
        const typ = vazbaSelect.value;
        const hasVazba = typ !== '0';
        const isBlok = typ === 'blok' || typ === 'blokPrebal';
        const isKrouzek = typ.startsWith('krouzek');
        // Popisek + step pole počtu stran/listů – jednotky dle oborového standardu
        // (stránkované publikace = strany, bloky/kroužkové = listy), viz jednotky.js
        const jednotky = (0, $464a82d0a054b7a0$export$4b295968f122e918)(typ);
        if (pocetStranLabel) pocetStranLabel.textContent = jednotky.label;
        if (pocetStranInput) {
            pocetStranInput.setAttribute('min', String(jednotky.min));
            pocetStranInput.setAttribute('step', String(jednotky.step));
        }
        // Dropdown předvoleb mluví stejnou jednotkou jako label (stran/listů)
        document.querySelectorAll('#pocetStranDropdown .stran-preset').forEach((btn)=>{
            btn.textContent = btn.getAttribute('data-value') + ' ' + jednotky.slovo;
        });
        if (vnitrniTiskJinaOption && vnitrniTiskStejnaOption) {
            if (isBlok || isKrouzek) {
                vnitrniTiskJinaOption.textContent = "Ka\u017Ed\xfd list jin\xfd (kalend\xe1\u0159, blok)";
                vnitrniTiskStejnaOption.textContent = "Ka\u017Ed\xfd list stejn\xfd (opakuj\xedc\xed se motiv)";
            } else {
                vnitrniTiskJinaOption.textContent = "Ka\u017Ed\xe1 strana jin\xe1 (bro\u017Eura, katalog)";
                vnitrniTiskStejnaOption.textContent = "Ka\u017Ed\xe1 strana stejn\xe1 (blok, se\u0161it)";
            }
        }
        updatePocetStranHelp(typ, isBlok, isKrouzek);
        // Barva spirály – jen pro kroužkové vazby
        const barvaSpiralyWrapper = document.getElementById('vazba-barva-spiraly-wrapper');
        if (barvaSpiralyWrapper) barvaSpiralyWrapper.classList.toggle('hidden', !isKrouzek);
        // „Jiná obálka" je dostupná pro všechny typy vazby (mimo "Bez vazby").
        if (jinaObalkaWrapper) {
            if (hasVazba) jinaObalkaWrapper.classList.remove('hidden');
            else {
                jinaObalkaWrapper.classList.add('hidden');
                if (toggle) toggle.checked = false;
            }
        }
        // Bez vazby vždy schovat sekci vnitřního bloku.
        if (!hasVazba && vnitrniBlokSection) vnitrniBlokSection.classList.add('hidden');
        // Podložka – pro lepené bloky a kroužkové vazby.
        if (podlozkaSection) {
            if (isBlok || isKrouzek) podlozkaSection.classList.remove('hidden');
            else {
                podlozkaSection.classList.add('hidden');
                const podlozkaToggle = document.getElementById('vazbaPodlozka');
                if (podlozkaToggle) podlozkaToggle.checked = false;
                const materialSection = document.getElementById('vazba-podlozka-material-section');
                if (materialSection) materialSection.classList.add('hidden');
            }
        }
        handleObalkaToggle();
    }
    // Event listenery
    vazbaSelect.addEventListener('change', ()=>{
        updateInfoBox();
        updateBlokUI();
        validateDimensions();
        validatePages();
    });
    if (pocetStranInput) {
        pocetStranInput.addEventListener('input', validatePages);
        pocetStranInput.addEventListener('change', validatePages);
    }
    // Validace rozměrů při změně šířky/výšky
    const sirkaInput = document.getElementById('produktRozmerSirka');
    const vyskaInput = document.getElementById('produktRozmerVyska');
    if (sirkaInput) {
        sirkaInput.addEventListener('input', validateDimensions);
        sirkaInput.addEventListener('change', validateDimensions);
    }
    if (vyskaInput) {
        vyskaInput.addEventListener('input', validateDimensions);
        vyskaInput.addEventListener('change', validateDimensions);
    }
    // Validace rozměrů při změně formátu
    const formatSelect = document.getElementById('produktRozmerFormat');
    if (formatSelect) formatSelect.addEventListener('change', ()=>{
        // Počkej chvíli než se aktualizují rozměry
        setTimeout(validateDimensions, 50);
    });
    if (toggle) toggle.addEventListener('change', handleObalkaToggle);
    // Glosář jednotek (strana / list / složka / arch) pod ikonou ⓘ u labelu
    const glosarBtn = document.getElementById('vazba-jednotky-info-btn');
    const glosar = document.getElementById('vazba-jednotky-glosar');
    if (glosarBtn && glosar) {
        glosarBtn.addEventListener('click', (e)=>{
            e.stopPropagation();
            glosar.classList.toggle('hidden');
        });
        document.getElementById('vazba-jednotky-glosar-zavrit')?.addEventListener('click', ()=>glosar.classList.add('hidden'));
        document.addEventListener('click', (e)=>{
            if (!glosar.classList.contains('hidden') && !glosar.contains(e.target) && !glosarBtn.contains(e.target)) glosar.classList.add('hidden');
        });
    }
    if (obalkaZadaSelect) obalkaZadaSelect.addEventListener('change', ()=>{
        const typ = vazbaSelect.value;
        const isBlok = typ === 'blok' || typ === 'blokPrebal';
        const isKrouzek = typ.startsWith('krouzek');
        updatePocetStranHelp(typ, isBlok, isKrouzek);
    });
    // Inicializace stavu
    updateInfoBox();
    updateBlokUI();
    validateDimensions();
    validatePages();
    handleObalkaToggle();
}
// Synchronizace materiálů do vnitřního bloku selectu
function $b3f0fcd8809f5ac4$var$syncVnitrniMaterialSelect() {
    const mainSelect = document.getElementById('material');
    const vnitrniSelect = document.getElementById('vnitrniMaterial');
    if (!mainSelect || !vnitrniSelect) return;
    // Uložit aktuální výběr
    const currentValue = vnitrniSelect.value;
    // Zkopírovat obsah z hlavního selectu
    vnitrniSelect.innerHTML = mainSelect.innerHTML;
    // Obnovit výběr pokud možno
    if (currentValue) {
        const option = vnitrniSelect.querySelector('option[value="' + currentValue + '"]');
        if (option) option.selected = true;
    }
    // Synchronizovat cenu a gramáž z aktuálně vybrané option do inputů
    $b3f0fcd8809f5ac4$var$syncVnitrniMaterialInputs();
}
// Přetáhne cenu a gramáž z vybrané option vnitřního materiálu do inputů
function $b3f0fcd8809f5ac4$var$syncVnitrniMaterialInputs() {
    const vnitrniSelect = document.getElementById('vnitrniMaterial');
    const vnitrniCena = document.getElementById('vnitrniMaterialCena');
    const vnitrniGramaz = document.getElementById('vnitrniMaterialGramaz');
    if (!vnitrniSelect || !vnitrniCena || !vnitrniGramaz) return;
    if (vnitrniSelect.value === 'vlastni') return;
    const selectedOption = vnitrniSelect.options[vnitrniSelect.selectedIndex];
    if (selectedOption && selectedOption.value) {
        vnitrniCena.value = selectedOption.value;
        vnitrniGramaz.value = selectedOption.getAttribute('data-gramaz') || '0';
    }
}
// Event listener pro synchronizaci ceny/gramáže při změně vnitřního materiálu
function $b3f0fcd8809f5ac4$var$setupVnitrniMaterialSync() {
    const vnitrniSelect = document.getElementById('vnitrniMaterial');
    const vnitrniCena = document.getElementById('vnitrniMaterialCena');
    const vnitrniGramaz = document.getElementById('vnitrniMaterialGramaz');
    if (!vnitrniSelect || !vnitrniCena || !vnitrniGramaz) return;
    vnitrniSelect.addEventListener('change', ()=>{
        if (vnitrniSelect.value === 'vlastni') return;
        const selectedOption = vnitrniSelect.options[vnitrniSelect.selectedIndex];
        if (selectedOption) {
            vnitrniCena.value = selectedOption.value;
            vnitrniGramaz.value = selectedOption.getAttribute('data-gramaz') || '0';
        }
    });
    // Při ručním zadání ceny/gramáže přepnout na "Vlastní materiál"
    [
        vnitrniCena,
        vnitrniGramaz
    ].forEach((input)=>{
        input.addEventListener('keyup', ()=>{
            vnitrniSelect.value = 'vlastni';
        });
        input.addEventListener('change', ()=>{
            vnitrniSelect.value = 'vlastni';
        });
    });
}
// Synchronizace materiálů do selectu podložky (kopie z hlavního selectu)
function $b3f0fcd8809f5ac4$var$syncPodlozkaMaterialSelect() {
    const mainSelect = document.getElementById('material');
    const podlozkaSelect = document.getElementById('podlozkaMaterial');
    if (!mainSelect || !podlozkaSelect) return;
    const currentValue = podlozkaSelect.value;
    podlozkaSelect.innerHTML = mainSelect.innerHTML;
    if (currentValue) {
        const option = podlozkaSelect.querySelector('option[value="' + currentValue + '"]');
        if (option) option.selected = true;
    }
    $b3f0fcd8809f5ac4$var$syncPodlozkaMaterialInputs();
}
// Přetáhne cenu a gramáž z vybrané option podložky do inputů
function $b3f0fcd8809f5ac4$var$syncPodlozkaMaterialInputs() {
    const podlozkaSelect = document.getElementById('podlozkaMaterial');
    const podlozkaCena = document.getElementById('podlozkaMaterialCena');
    const podlozkaGramaz = document.getElementById('podlozkaMaterialGramaz');
    if (!podlozkaSelect || !podlozkaCena || !podlozkaGramaz) return;
    if (podlozkaSelect.value === 'vlastni') return;
    const selectedOption = podlozkaSelect.options[podlozkaSelect.selectedIndex];
    if (selectedOption && selectedOption.value) {
        podlozkaCena.value = selectedOption.value;
        podlozkaGramaz.value = selectedOption.getAttribute('data-gramaz') || '0';
    }
}
// Event listener pro synchronizaci ceny/gramáže podložky
function $b3f0fcd8809f5ac4$var$setupPodlozkaMaterialSync() {
    const podlozkaSelect = document.getElementById('podlozkaMaterial');
    const podlozkaCena = document.getElementById('podlozkaMaterialCena');
    const podlozkaGramaz = document.getElementById('podlozkaMaterialGramaz');
    if (!podlozkaSelect || !podlozkaCena || !podlozkaGramaz) return;
    podlozkaSelect.addEventListener('change', ()=>{
        if (podlozkaSelect.value === 'vlastni') return;
        const selectedOption = podlozkaSelect.options[podlozkaSelect.selectedIndex];
        if (selectedOption) {
            podlozkaCena.value = selectedOption.value;
            podlozkaGramaz.value = selectedOption.getAttribute('data-gramaz') || '0';
        }
    });
    [
        podlozkaCena,
        podlozkaGramaz
    ].forEach((input)=>{
        input.addEventListener('keyup', ()=>{
            podlozkaSelect.value = 'vlastni';
        });
        input.addEventListener('change', ()=>{
            podlozkaSelect.value = 'vlastni';
        });
    });
    // Toggle podložky – zobrazit/skrýt materiál (přepočet řeší delegovaný listener na #vypocet)
    const toggle = document.getElementById('vazbaPodlozka');
    const materialSection = document.getElementById('vazba-podlozka-material-section');
    if (toggle && materialSection) toggle.addEventListener('change', ()=>{
        if (toggle.checked) {
            materialSection.classList.remove('hidden');
            $b3f0fcd8809f5ac4$var$syncPodlozkaMaterialInputs();
        } else materialSection.classList.add('hidden');
    });
}
// Přidat funkce do window objektu pro dostupnost z HTML onclick
window.toggleSettingsDropdown = $b3f0fcd8809f5ac4$var$toggleSettingsDropdown;
window.toggleMaterialsDropdown = $b3f0fcd8809f5ac4$var$toggleMaterialsDropdown;
window.copyCalculationResult = $b3f0fcd8809f5ac4$var$copyCalculationResult;
// ──────────────────────────────────────────────
// Quick presets – rychlé výchozí konfigurace pro běžné typy zakázek
// ──────────────────────────────────────────────
// Pozn. k `materialName` / `vnitrniMaterialName`:
// Preset vybere konkrétní materiál podle přesného názvu v selectu (option.textContent).
// Po výběru materiálu pocitej() automaticky doplní Kč/arch a g/m² z data atributů option.
const $b3f0fcd8809f5ac4$var$QUICK_PRESETS = [
    {
        id: 'vizitky',
        label: 'Vizitky',
        sub: "100 ks \xb7 90\xd750 \xb7 4/4 \xb7 Leskl\xe1 k\u0159\xedda 350 g/m\xb2",
        fields: {
            pocetKusu: 100,
            produktRozmerFormat: 'Vizitka',
            produktRozmerSirka: 90,
            produktRozmerVyska: 50,
            pocetBarev: '4/4',
            materialName: "Leskl\xe1 k\u0159\xedda 350 g/m\xb2",
            vazba: '0'
        }
    },
    {
        id: 'letakA5',
        label: "Let\xe1ky A5",
        sub: "500 ks \xb7 4/4 \xb7 Leskl\xe1 k\u0159\xedda 135 g/m\xb2",
        fields: {
            pocetKusu: 500,
            produktRozmerFormat: 'A5',
            produktRozmerSirka: 148,
            produktRozmerVyska: 210,
            pocetBarev: '4/4',
            materialName: "Leskl\xe1 k\u0159\xedda 135 g/m\xb2",
            vazba: '0'
        }
    },
    {
        id: 'lepenyBlokObalka',
        label: "Lep. blok + ob\xe1lka",
        sub: "200 ks \xb7 A5 \xb7 60 list\u016F \xb7 4/0 + 1/1",
        // Pořadí matters: vazba před vazbaJinaObalka (toggle se objeví až po nastavení vazby)
        fields: {
            pocetKusu: 200,
            produktRozmerFormat: 'A5',
            produktRozmerSirka: 148,
            produktRozmerVyska: 210,
            vazba: 'blokPrebal',
            vazbaPocetStran: 60,
            vazbaJinaObalka: true,
            // Vnitřní blok – obyčejný papír, oboustranně černobíle
            vnitrniMaterialName: "Ofset 80 g/m\xb2",
            vnitrniBarevnost: '1/1',
            // Obálka (přebal) – silnější křída, plnobarevně z jedné strany
            materialName: "Matn\xe1 k\u0159\xedda 250 g/m\xb2",
            pocetBarev: '4/0',
            // Podložka (šedá lepenka) pod blok
            vazbaPodlozka: true,
            podlozkaMaterialName: "\u0160ed\xe1 lepenka 300 g/m\xb2"
        }
    },
    {
        id: 'plakatA3',
        label: "Plak\xe1ty A3",
        sub: "100 ks \xb7 4/0 \xb7 Matn\xe1 k\u0159\xedda 170 g/m\xb2",
        fields: {
            pocetKusu: 100,
            produktRozmerFormat: 'A3',
            produktRozmerSirka: 297,
            produktRozmerVyska: 420,
            pocetBarev: '4/0',
            materialName: "Matn\xe1 k\u0159\xedda 170 g/m\xb2",
            vazba: '0'
        }
    },
    {
        id: 'brozuraA5',
        label: "Bro\u017Eura A5",
        sub: "60 stran \xb7 V1 \xb7 4/4 \xb7 Matn\xe1 k\u0159\xedda 115 g/m\xb2",
        fields: {
            pocetKusu: 100,
            produktRozmerFormat: 'A5',
            produktRozmerSirka: 148,
            produktRozmerVyska: 210,
            pocetBarev: '4/4',
            materialName: "Matn\xe1 k\u0159\xedda 115 g/m\xb2",
            vazba: 'V1-strojni',
            vazbaPocetStran: 60
        }
    },
    {
        id: 'obalkaDL',
        label: "Ob\xe1lka DL",
        sub: "500 ks \xb7 1/0 \xb7 Ofset 90 g/m\xb2",
        fields: {
            pocetKusu: 500,
            produktRozmerFormat: 'DL',
            produktRozmerSirka: 110,
            produktRozmerVyska: 220,
            pocetBarev: '1/0',
            materialName: "Ofset 90 g/m\xb2",
            vazba: '0'
        }
    }
];
// ──────────────────────────────────────────────
// Uživatelské předvolby – storage a helpers
// ──────────────────────────────────────────────
const $b3f0fcd8809f5ac4$var$PRESETS_STORAGE_KEY = 'tria:custom-presets';
function $b3f0fcd8809f5ac4$var$escapeHtml(str) {
    return String(str == null ? '' : str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
/** Načte pracovní sadu předvoleb z localStorage, nebo ji nasází z defaultů. */ function $b3f0fcd8809f5ac4$var$loadPresets() {
    try {
        const stored = localStorage.getItem($b3f0fcd8809f5ac4$var$PRESETS_STORAGE_KEY);
        if (stored) {
            const parsed = JSON.parse(stored);
            if (Array.isArray(parsed)) return parsed;
        }
    } catch (_) {}
    const seeded = $b3f0fcd8809f5ac4$var$QUICK_PRESETS.map((p)=>({
            ...p,
            fields: {
                ...p.fields
            }
        }));
    $b3f0fcd8809f5ac4$var$savePresets(seeded);
    return seeded;
}
/** Uloží pracovní sadu předvoleb do localStorage. */ function $b3f0fcd8809f5ac4$var$savePresets(presets) {
    try {
        localStorage.setItem($b3f0fcd8809f5ac4$var$PRESETS_STORAGE_KEY, JSON.stringify(presets));
    } catch (_) {}
}
/** Pracovní sada předvoleb (defaultní + uživatelské, bez vizuálního rozlišení). */ let $b3f0fcd8809f5ac4$var$userPresets = $b3f0fcd8809f5ac4$var$loadPresets();
/** Vygeneruje popisek chipu z polí předvolby: [ks/stran] · [barevnost] · [papír]. */ function $b3f0fcd8809f5ac4$var$generatePresetSub(fields) {
    const parts = [];
    const hasVazba = fields.vazba && fields.vazba !== '0';
    if (Array.isArray(fields.motivy) && fields.motivy.length > 1) {
        const sum = fields.motivy.reduce((a, m)=>a + (+m.pocetKusu || 0), 0);
        parts.push(`${sum} ks (${fields.motivy.length} motiv\u{16F})`);
    } else if (hasVazba && fields.vazbaPocetStran) {
        // Lepené bloky a kroužkové vazby počítají listy, ostatní vazby strany.
        const jsouListy = fields.vazba === 'blok' || fields.vazba === 'blokPrebal' || fields.vazba.startsWith('krouzek');
        parts.push(`${fields.vazbaPocetStran} ${jsouListy ? "list\u016F" : 'stran'}`);
    } else if (fields.pocetKusu) parts.push(`${fields.pocetKusu} ks`);
    if (fields.pocetBarev) parts.push(fields.pocetBarev);
    if (fields.materialName && fields.materialName !== 'vlastni') parts.push(fields.materialName);
    return parts.join(" \xb7 ");
}
/** Načte aktuální stav formuláře do objektu fields pro uložení předvolby. */ function $b3f0fcd8809f5ac4$var$captureFormFields() {
    const fields = {};
    const form = document.getElementById('vypocet');
    if (!form) return fields;
    // Materiály uložíme podle názvu (aby applyPreset našel správnou option i při
    // duplicitních cenách). Pro "vlastni" uložíme i cenu/gramáž.
    const materialSelect = document.getElementById('material');
    if (materialSelect) {
        const opt = materialSelect.options[materialSelect.selectedIndex];
        if (opt && opt.value && opt.value !== 'vlastni') fields.materialName = opt.textContent.trim();
        else {
            fields.materialName = 'vlastni';
            const cena = document.getElementById('materialCena');
            const gramaz = document.getElementById('materialGramaz');
            if (cena && cena.value) fields.materialCena = cena.value;
            if (gramaz && gramaz.value) fields.materialGramaz = gramaz.value;
        }
    }
    const vnitrniSelect = document.getElementById('vnitrniMaterial');
    if (vnitrniSelect) {
        const opt = vnitrniSelect.options[vnitrniSelect.selectedIndex];
        if (opt && opt.value && opt.value !== 'vlastni') fields.vnitrniMaterialName = opt.textContent.trim();
    }
    const podlozkaSelect = document.getElementById('podlozkaMaterial');
    if (podlozkaSelect) {
        const opt = podlozkaSelect.options[podlozkaSelect.selectedIndex];
        if (opt && opt.value && opt.value !== 'vlastni') fields.podlozkaMaterialName = opt.textContent.trim();
    }
    // Všechna ostatní pole s id (vynecháme materiály zpracované výše).
    const skipIds = new Set([
        'material',
        'vnitrniMaterial',
        'podlozkaMaterial',
        'materialCena',
        'materialGramaz'
    ]);
    form.querySelectorAll('input, select, textarea').forEach((el)=>{
        if (!el.id || skipIds.has(el.id)) return;
        if (el.type === 'checkbox' || el.type === 'radio') // Ukládáme i false – applyPreset pak checkbox spolehlivě vypne
        // (jinak by v něm zůstal stav z předchozí kalkulace).
        fields[el.id] = el.checked;
        else if (el.value !== '' && el.value !== undefined) fields[el.id] = el.value;
    });
    // Motivy s vlastními náklady (dynamické řádky nemají id – serializují se zvlášť)
    if (+(fields.pocetDruhu || 1) > 1) {
        const rows = $b3f0fcd8809f5ac4$var$getMotivyRows().filter((m)=>m.pocetKusu > 0);
        if (rows.length > 1) fields.motivy = rows;
    }
    // Bez vazby ("Volné listy") nemají vazbová pole význam – skryté inputy si
    // ale drží poslední hodnoty (např. počet stran z předchozí kalkulace),
    // takže by se do předvolby uložil zavádějící stav.
    if (!fields.vazba || fields.vazba === '0') for (const id of Object.keys(fields)){
        // 'vazba' samotnou zachováme, aby applyPreset vrátil select na "Volné listy".
        if (id === 'vazba') continue;
        if (id.startsWith('vazba') || id.startsWith('vnitrni') || id.startsWith('podlozka')) delete fields[id];
    }
    return fields;
}
function $b3f0fcd8809f5ac4$var$setupQuickPresets() {
    const container = document.getElementById('quick-presets');
    if (!container) return;
    const render = ()=>{
        container.innerHTML = $b3f0fcd8809f5ac4$var$userPresets.map((p)=>`
      <button type="button" class="preset-chip group" data-preset-id="${p.id}">
        <span class="preset-chip-label">${$b3f0fcd8809f5ac4$var$escapeHtml(p.label)}</span>
        <span class="preset-chip-sub">${$b3f0fcd8809f5ac4$var$escapeHtml(p.sub)}</span>
      </button>
    `).join('');
    };
    render();
    container.addEventListener('click', (e)=>{
        const btn = e.target.closest('[data-preset-id]');
        if (!btn) return;
        const preset = $b3f0fcd8809f5ac4$var$userPresets.find((p)=>p.id === btn.dataset.presetId);
        if (!preset) return;
        $b3f0fcd8809f5ac4$var$applyPreset(preset);
        container.querySelectorAll('.preset-chip').forEach((c)=>c.classList.remove('is-active'));
        btn.classList.add('is-active');
    });
    $b3f0fcd8809f5ac4$var$setupPresetSaveModal(render);
    $b3f0fcd8809f5ac4$var$setupPresetManageModal(render);
}
// ──────────────────────────────────────────────
// Modal: Uložit aktuální jako předvolbu
// ──────────────────────────────────────────────
function $b3f0fcd8809f5ac4$var$setupPresetSaveModal(renderChips) {
    const modal = document.getElementById('presetSaveModal');
    const openBtn = document.getElementById('presetSaveBtn');
    const nameInput = document.getElementById('presetSaveName');
    const confirmBtn = document.getElementById('presetSaveConfirmBtn');
    const errorEl = document.getElementById('presetSaveError');
    if (!modal || !openBtn || !nameInput || !confirmBtn) return;
    const close = ()=>{
        modal.classList.add('hidden');
        modal.setAttribute('aria-hidden', 'true');
        nameInput.value = '';
        if (errorEl) {
            errorEl.textContent = '';
            errorEl.classList.add('hidden');
        }
    };
    const open = ()=>{
        // Předvyplnit název odvozeným popiskem z aktuálních polí.
        const fields = $b3f0fcd8809f5ac4$var$captureFormFields();
        nameInput.value = $b3f0fcd8809f5ac4$var$generatePresetSub(fields);
        modal.classList.remove('hidden');
        modal.setAttribute('aria-hidden', 'false');
        setTimeout(()=>nameInput.focus(), 0);
    };
    openBtn.addEventListener('click', open);
    modal.querySelectorAll('[data-preset-save-close]').forEach((el)=>{
        el.addEventListener('click', close);
    });
    nameInput.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            confirmBtn.click();
        }
        if (e.key === 'Escape') close();
    });
    confirmBtn.addEventListener('click', ()=>{
        const label = nameInput.value.trim();
        if (!label) {
            if (errorEl) {
                errorEl.textContent = "Zadejte n\xe1zev p\u0159edvolby.";
                errorEl.classList.remove('hidden');
            }
            nameInput.focus();
            return;
        }
        const fields = $b3f0fcd8809f5ac4$var$captureFormFields();
        const preset = {
            id: `user-${Date.now()}`,
            label: label,
            sub: $b3f0fcd8809f5ac4$var$generatePresetSub(fields),
            fields: fields
        };
        $b3f0fcd8809f5ac4$var$userPresets.push(preset);
        $b3f0fcd8809f5ac4$var$savePresets($b3f0fcd8809f5ac4$var$userPresets);
        renderChips();
        close();
        if (typeof $b3f0fcd8809f5ac4$var$showNotification === 'function') $b3f0fcd8809f5ac4$var$showNotification(`P\u{159}edvolba \u{201E}${label}" ulo\u{17E}ena.`, 'success');
    });
}
// ──────────────────────────────────────────────
// Modal: Spravovat předvolby
// ──────────────────────────────────────────────
function $b3f0fcd8809f5ac4$var$setupPresetManageModal(renderChips) {
    const modal = document.getElementById('presetManageModal');
    const openBtn = document.getElementById('presetManageBtn');
    const listEl = document.getElementById('presetManageList');
    const emptyEl = document.getElementById('presetManageEmpty');
    const restoreBtn = document.getElementById('presetRestoreDefaultsBtn');
    if (!modal || !openBtn || !listEl) return;
    const close = ()=>{
        modal.classList.add('hidden');
        modal.setAttribute('aria-hidden', 'true');
    };
    const open = ()=>{
        renderList();
        modal.classList.remove('hidden');
        modal.setAttribute('aria-hidden', 'false');
    };
    function renderItemHtml(p) {
        return `
      <li class="flex items-center gap-3 py-2.5" data-preset-id="${p.id}">
        <div class="flex-1 min-w-0">
          <div class="text-sm font-medium text-ink truncate">${$b3f0fcd8809f5ac4$var$escapeHtml(p.label)}</div>
          <div class="text-xs text-ink-500 truncate">${$b3f0fcd8809f5ac4$var$escapeHtml(p.sub)}</div>
        </div>
        <button type="button" class="p-1 text-gray-400 hover:text-gray-600 focus:outline-none" data-preset-action="rename" title="P\u{159}ejmenovat">
          ${typeof (0, $entK4.icon) === 'function' ? (0, $entK4.icon)('pencil-square', 'w-5 h-5') : ''}
        </button>
        <button type="button" class="p-1 text-gray-400 hover:text-red-600 focus:outline-none" data-preset-action="delete" title="Smazat">
          ${typeof (0, $entK4.icon) === 'function' ? (0, $entK4.icon)('trash', 'w-5 h-5') : ''}
        </button>
      </li>
    `;
    }
    function renderList() {
        if (!$b3f0fcd8809f5ac4$var$userPresets.length) {
            listEl.innerHTML = '';
            if (emptyEl) emptyEl.classList.remove('hidden');
            return;
        }
        if (emptyEl) emptyEl.classList.add('hidden');
        listEl.innerHTML = $b3f0fcd8809f5ac4$var$userPresets.map(renderItemHtml).join('');
    }
    /** Překreslí jen jeden řádek zpět do display módu (ostatní řádky neruší). */ function renderRowDisplay(idx) {
        const p = $b3f0fcd8809f5ac4$var$userPresets[idx];
        if (!p) return;
        const li = listEl.querySelector(`li[data-preset-id="${CSS.escape(p.id)}"]`);
        if (!li) {
            renderList();
            return;
        }
        li.outerHTML = renderItemHtml(p);
    }
    openBtn.addEventListener('click', open);
    modal.querySelectorAll('[data-preset-manage-close]').forEach((el)=>{
        el.addEventListener('click', close);
    });
    function startRename(li, idx) {
        const current = $b3f0fcd8809f5ac4$var$userPresets[idx].label;
        li.innerHTML = `
      <div class="flex-1 min-w-0">
        <input type="text" class="block w-full px-2 py-1 sm:text-sm border border-blue-500 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-200" value="${$b3f0fcd8809f5ac4$var$escapeHtml(current)}" maxlength="40" data-preset-rename-input />
      </div>
      <button type="button" class="p-1 text-green-600 hover:text-green-800 focus:outline-none" data-preset-rename-save title="Ulo\u{17E}it">
        ${(0, $entK4.icon)('check', 'w-5 h-5')}
      </button>
      <button type="button" class="p-1 text-gray-400 hover:text-gray-600 focus:outline-none" data-preset-rename-cancel title="Zru\u{161}it">
        ${(0, $entK4.icon)('x-mark', 'w-5 h-5')}
      </button>
    `;
        const input = li.querySelector('[data-preset-rename-input]');
        input.focus();
        input.select();
        const commit = ()=>{
            const trimmed = input.value.trim();
            if (trimmed && trimmed !== current) {
                $b3f0fcd8809f5ac4$var$userPresets[idx].label = trimmed;
                $b3f0fcd8809f5ac4$var$savePresets($b3f0fcd8809f5ac4$var$userPresets);
                renderChips();
            }
            renderRowDisplay(idx);
        };
        input.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                commit();
            }
            if (e.key === 'Escape') {
                e.preventDefault();
                renderRowDisplay(idx);
            }
        });
        li.querySelector('[data-preset-rename-save]').addEventListener('click', commit);
        li.querySelector('[data-preset-rename-cancel]').addEventListener('click', ()=>renderRowDisplay(idx));
    }
    listEl.addEventListener('click', (e)=>{
        const actionBtn = e.target.closest('[data-preset-action]');
        if (!actionBtn) return;
        const li = actionBtn.closest('[data-preset-id]');
        if (!li) return;
        const id = li.dataset.presetId;
        const idx = $b3f0fcd8809f5ac4$var$userPresets.findIndex((p)=>p.id === id);
        if (idx < 0) return;
        const action = actionBtn.dataset.presetAction;
        if (action === 'delete') {
            const label = $b3f0fcd8809f5ac4$var$userPresets[idx].label;
            $b3f0fcd8809f5ac4$var$userPresets.splice(idx, 1);
            $b3f0fcd8809f5ac4$var$savePresets($b3f0fcd8809f5ac4$var$userPresets);
            renderChips();
            renderList();
            if (typeof $b3f0fcd8809f5ac4$var$showNotification === 'function') $b3f0fcd8809f5ac4$var$showNotification(`P\u{159}edvolba \u{201E}${label}" smaz\xe1na.`, 'info');
        } else if (action === 'rename') startRename(li, idx);
    });
    restoreBtn.addEventListener('click', ()=>{
        if (!window.confirm("Obnovit v\xfdchoz\xed p\u0159edvolby? St\xe1vaj\xedc\xed seznam bude nahrazen defaultn\xed sadou.")) return;
        $b3f0fcd8809f5ac4$var$userPresets = $b3f0fcd8809f5ac4$var$QUICK_PRESETS.map((p)=>({
                ...p,
                fields: {
                    ...p.fields
                }
            }));
        $b3f0fcd8809f5ac4$var$savePresets($b3f0fcd8809f5ac4$var$userPresets);
        renderChips();
        renderList();
        if (typeof $b3f0fcd8809f5ac4$var$showNotification === 'function') $b3f0fcd8809f5ac4$var$showNotification("V\xfdchoz\xed p\u0159edvolby obnoveny.", 'success');
    });
}
function $b3f0fcd8809f5ac4$var$applyPreset(preset) {
    // Vypnout "reset-na-vlastní" listenery, aby změna šířky/výšky nepřepsala
    // Formát na "vlastni" a změna gramáže/ceny nepřepsala Materiál na "vlastni".
    window._applyingPreset = true;
    try {
        Object.entries(preset.fields).forEach(([id, value])=>{
            // Speciální klíče pro výběr materiálu podle názvu – zpracují se níže
            // až po nastavení ostatních polí (aby je nepřepsalo "reset-na-vlastní").
            if (id === 'materialName' || id === 'vnitrniMaterialName' || id === 'podlozkaMaterialName') return;
            const el = document.getElementById(id);
            if (!el) return;
            if (el.type === 'checkbox' || el.type === 'radio') el.checked = Boolean(value);
            else el.value = value;
            // Trigger change event aby se spustily i conditional inputs / dependentní logika
            el.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        });
        // Obnova motivů (dynamické řádky) – až po nastavení pocetDruhu generickou smyčkou.
        if (Array.isArray(preset.fields.motivy) && preset.fields.motivy.length > 1) {
            const druhuInput = document.getElementById('pocetDruhu');
            if (druhuInput) druhuInput.value = preset.fields.motivy.length;
            $b3f0fcd8809f5ac4$var$renderMotivyPanel(preset.fields.motivy);
        } else $b3f0fcd8809f5ac4$var$renderMotivyPanel();
        // Nastavení materiálu podle názvu (až po ostatních polích).
        // Po výběru option v selectu následný pocitej() doplní #materialCena a #materialGramaz
        // z data-atributů vybrané option.
        if (preset.fields.materialName) {
            if (preset.fields.materialName === 'vlastni') {
                const select = document.getElementById('material');
                if (select) {
                    select.value = 'vlastni';
                    select.dispatchEvent(new Event('change', {
                        bubbles: true
                    }));
                }
            } else $b3f0fcd8809f5ac4$var$selectMaterialByName('material', preset.fields.materialName);
        }
        if (preset.fields.vnitrniMaterialName) {
            if (preset.fields.vnitrniMaterialName === 'vlastni') {
                const select = document.getElementById('vnitrniMaterial');
                if (select) {
                    select.value = 'vlastni';
                    select.dispatchEvent(new Event('change', {
                        bubbles: true
                    }));
                }
            } else $b3f0fcd8809f5ac4$var$selectMaterialByName('vnitrniMaterial', preset.fields.vnitrniMaterialName);
        }
        if (preset.fields.podlozkaMaterialName) {
            if (preset.fields.podlozkaMaterialName === 'vlastni') {
                const select = document.getElementById('podlozkaMaterial');
                if (select) {
                    select.value = 'vlastni';
                    select.dispatchEvent(new Event('change', {
                        bubbles: true
                    }));
                }
            } else $b3f0fcd8809f5ac4$var$selectMaterialByName('podlozkaMaterial', preset.fields.podlozkaMaterialName);
        }
    } finally{
        window._applyingPreset = false;
    }
    // Načíst název předvolby do pole "Název položky" – propíše se do názvu položky
    // nabídky (OfferItemsManager.generateItemName ho používá jako prefix). Umožní
    // skládat nabídku z předvoleb jen klikáním a mít v ní názvy produktů.
    if (preset.label) {
        const nazevInput = document.getElementById('nazev');
        if (nazevInput) {
            nazevInput.value = preset.label;
            nazevInput.dispatchEvent(new Event('input', {
                bubbles: true
            }));
        }
    }
    // Po nastavení polí proveď okamžitý přepočet – vyplní Kč/arch a g/m² z vybrané option.
    if (typeof $b3f0fcd8809f5ac4$var$pocitej === 'function') $b3f0fcd8809f5ac4$var$pocitej();
}
// Najde v daném <select> element <option>, jehož textContent odpovídá zadanému názvu,
// a nastaví ho jako vybraný. Používá se pro rychlé předvolby (quick presets).
function $b3f0fcd8809f5ac4$var$selectMaterialByName(selectId, name) {
    const select = document.getElementById(selectId);
    if (!select) return false;
    const trimmedName = String(name).trim();
    const option = Array.from(select.querySelectorAll('option')).find((o)=>o.textContent.trim() === trimmedName);
    if (!option) {
        console.warn(`[preset] Materi\xe1l "${trimmedName}" nebyl nalezen v selectu #${selectId}.`);
        return false;
    }
    // Pozn.: option.value je cena materiálu a v datech se ceny mohou opakovat
    // (různé papíry se stejnou cenou). Nastavení `select.value` by vybralo první
    // option s danou cenou, proto označíme přímo nalezenou option.
    select.querySelectorAll('option').forEach((o)=>{
        o.selected = false;
    });
    option.selected = true;
    select.dispatchEvent(new Event('change', {
        bubbles: true
    }));
    return true;
}
// Vystaveno na window pro offer-items.js (restore stavu formuláře při přepnutí položky).
window.selectMaterialByName = $b3f0fcd8809f5ac4$var$selectMaterialByName;
window.pocitej = $b3f0fcd8809f5ac4$var$pocitej;
// ──────────────────────────────────────────────
// Progressive disclosure – sbalitelné sekce (např. Dokončování)
// Použití: <div class="collapsible-section" data-collapsed="true|false">
//   <button class="collapsible-toggle">…</button>
//   <div class="collapsible-content">…</div>
// </div>
// ──────────────────────────────────────────────
const $b3f0fcd8809f5ac4$var$COLLAPSIBLE_STORAGE_PREFIX = 'tria:collapsible:';
function $b3f0fcd8809f5ac4$var$getCollapsibleStorageKey(section, index) {
    const id = section.id || section.dataset.collapsibleKey;
    if (id) return `${$b3f0fcd8809f5ac4$var$COLLAPSIBLE_STORAGE_PREFIX}${id}`;
    return `${$b3f0fcd8809f5ac4$var$COLLAPSIBLE_STORAGE_PREFIX}section-${index}`;
}
function $b3f0fcd8809f5ac4$var$setupCollapsibleSections() {
    document.querySelectorAll('.collapsible-section').forEach((section, index)=>{
        const toggle = section.querySelector('.collapsible-toggle');
        const content = section.querySelector('.collapsible-content');
        if (!toggle || !content) return;
        const storageKey = $b3f0fcd8809f5ac4$var$getCollapsibleStorageKey(section, index);
        const stored = localStorage.getItem(storageKey);
        const setExpanded = (expanded, { persist: persist = true } = {})=>{
            section.dataset.collapsed = expanded ? 'false' : 'true';
            toggle.setAttribute('aria-expanded', String(expanded));
            content.hidden = !expanded;
            if (persist) try {
                localStorage.setItem(storageKey, String(expanded));
            } catch (_) {}
        };
        // Defaultní stav: preferujeme uloženou hodnotu, jinak podle data-collapsed
        const initialExpanded = stored !== null ? stored === 'true' : section.dataset.collapsed === 'false';
        setExpanded(initialExpanded, {
            persist: false
        });
        toggle.addEventListener('click', ()=>{
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            setExpanded(!isExpanded);
        // Při sbalení/rozbalení nemusíme přepočítávat, jen měníme viditelnost
        });
    });
    // Pomocné: aktualizuj počet "aktivních" voleb v summary značce u "Dokončování"
    $b3f0fcd8809f5ac4$var$updateFinishingCount();
    document.addEventListener('change', (e)=>{
        if (e.target.closest('#finishing-collapsible')) $b3f0fcd8809f5ac4$var$updateFinishingCount();
    });
}
function $b3f0fcd8809f5ac4$var$updateFinishingCount() {
    const counter = document.getElementById('finishing-count');
    if (!counter) return;
    const ids = [
        'lakovani',
        'laminace',
        'falcovani',
        'bigovani',
        'vrtani',
        'perforace',
        'lepeni',
        'vysek',
        'predsek',
        'razba'
    ];
    let active = 0;
    ids.forEach((id)=>{
        const el = document.getElementById(id);
        if (el && el.value && el.value !== '0' && el.value !== '') active += 1;
    });
    counter.textContent = active > 0 ? String(active) : '';
    counter.classList.toggle('hidden', active === 0);
}
// ──────────────────────────────────────────────
// Sidebar – collapsible (ikonky / rozbalený) s persistencí do localStorage.
// Není vázáno na přihlášení – inicializuje se hned po DOM ready, ale sidebar
// je skrytý (hidden) dokud ho unlockApp() neodemkne. Tlačítko funguje až pak.
// ──────────────────────────────────────────────
const $b3f0fcd8809f5ac4$var$SIDEBAR_COLLAPSED_KEY = 'tria:sidebar:collapsed';
function $b3f0fcd8809f5ac4$var$setupSidebarCollapse() {
    const sidebar = document.getElementById('app-sidebar');
    const btn = document.getElementById('sidebar-collapse-btn');
    if (!sidebar || !btn) return;
    let collapsed = false;
    try {
        collapsed = localStorage.getItem($b3f0fcd8809f5ac4$var$SIDEBAR_COLLAPSED_KEY) === 'true';
    } catch (_) {}
    sidebar.classList.toggle('sidebar-collapsed', collapsed);
    btn.setAttribute('aria-expanded', String(!collapsed));
    btn.addEventListener('click', ()=>{
        collapsed = !sidebar.classList.contains('sidebar-collapsed');
        sidebar.classList.toggle('sidebar-collapsed', collapsed);
        btn.setAttribute('aria-expanded', String(!collapsed));
        try {
            localStorage.setItem($b3f0fcd8809f5ac4$var$SIDEBAR_COLLAPSED_KEY, String(collapsed));
        } catch (_) {}
    });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $b3f0fcd8809f5ac4$var$setupSidebarCollapse);
else $b3f0fcd8809f5ac4$var$setupSidebarCollapse();
// ──────────────────────────────────────────────
// Mobilní stavový bar – tlačítko „K výsledku" odscrolluje k sekci Výsledek kalkulace.
// ──────────────────────────────────────────────
function $b3f0fcd8809f5ac4$var$setupMobileResultScroll() {
    const btn = document.getElementById('vysledekMobilScroll');
    if (!btn) return;
    btn.addEventListener('click', ()=>{
        const target = document.getElementById('vysledek-kalkulace');
        if (!target) return;
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $b3f0fcd8809f5ac4$var$setupMobileResultScroll);
else $b3f0fcd8809f5ac4$var$setupMobileResultScroll();


//# sourceMappingURL=path1.b083d853.js.map
